import { jsx as g, jsxs as F, Fragment as Vt } from "react/jsx-runtime";
import { c as B, a as ne, b as ae } from "./utils-B9z9WPG8.js";
import * as x from "react";
import Be, { useId as At, useState as qe, useEffect as Rt, createContext as ho, use as dn, useRef as nt, createElement as O1, useLayoutEffect as po, Children as Ql, isValidElement as Jl, useContext as xg, cloneElement as Yc, useCallback as Tn, useMemo as vl, Fragment as t4 } from "react";
import * as cn from "react-dom";
import { createPortal as n4 } from "react-dom";
function o4({ defaultTagName: t, props: e, render: n, state: o = {}, stateAttributesMapping: r }) {
  let i = jc(r4(o, r), e);
  if (!n) return x.createElement(t, i);
  if (typeof n == "function") return n(i, o);
  if (!x.isValidElement(n)) return null;
  let s = n.props, l = { ...jc(i, s), ref: rs(i.ref, s.ref) };
  return x.cloneElement(n, l);
}
function jc(...t) {
  let e = {};
  for (let n of t) {
    if (!n) continue;
    let o = n;
    for (let r of Object.keys(o)) {
      let i = o[r];
      if (i === void 0) continue;
      let s = e[r];
      r === "className" ? e[r] = [s, i].filter(Boolean).join(" ") : r === "style" ? e[r] = { ...s, ...i } : r === "ref" ? e[r] = rs(s, i) : s4(r) && typeof s == "function" && typeof i == "function" ? e[r] = i4(i, s) : e[r] = i;
    }
  }
  return e;
}
function r4(t, e) {
  let n = {};
  for (let o of Object.keys(t)) {
    let r = t[o], i = e?.[o]?.(r);
    if (i) {
      Object.assign(n, i);
      continue;
    }
    if (o === "slot") {
      n["data-slot"] = r;
      continue;
    }
    let s = `data-${String(o).replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`)}`;
    typeof r == "boolean" ? n[s] = r ? "" : void 0 : r != null && (n[s] = String(r));
  }
  return n;
}
function i4(t, e) {
  return function(n) {
    t(n), n.defaultPrevented || e(n);
  };
}
function s4(t) {
  return /^on[A-Z]/.test(t);
}
function rs(...t) {
  let e = t.filter(Boolean);
  if (e.length !== 0) return (n) => {
    for (let o of e) typeof o == "function" ? o(n) : o && (o.current = n);
  };
}
var l4 = 8, a4 = 64, c4 = 0, Il = 0.5, u4 = 180, d4 = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "End", "Home", "PageDown", "PageUp", " "]), Cg = { start: !1, end: !1 }, f4 = [], Pl = { currentAnchorId: null, visibleMessageIds: f4 };
function p4({ content: t, scrollEdgeThreshold: e, spacer: n, viewport: o }) {
  if (!o || !t) return Cg;
  let r = ku({ content: t, spacer: n, viewport: o });
  return { start: o.scrollTop > e, end: r - o.scrollTop - o.clientHeight > e };
}
function m4({ content: t, scrollMargin: e, scrollPreviousItemPeek: n, spacer: o, viewport: r, visibleMessageIds: i }) {
  if (!t || !r) return Pl;
  let s = r.getBoundingClientRect(), l = s.top + e + n, a = typeof IntersectionObserver > "u", c = [], u = null;
  for (let d of Ui(t, o)) {
    let f = d.dataset.messageId;
    if (!f) continue;
    let p = d.dataset.scrollAnchor === "true", m = p || a ? d.getBoundingClientRect() : null;
    (a && m ? m.bottom > l && m.top < s.bottom : i.has(f)) && c.push(f), p && m && m.top <= l + Il && (u = f);
  }
  return c.length === 0 && u === null ? Pl : { currentAnchorId: u, visibleMessageIds: c };
}
function Ui(t, e) {
  return Array.from(t.children).filter((n) => n instanceof HTMLElement && n !== e);
}
function g4(t, e) {
  for (let n = e; n < t.length; n++) {
    let o = t[n];
    if (o?.dataset.scrollAnchor === "true") return o;
  }
  return null;
}
function h4(t, e) {
  for (let n of t) if (n.dataset.scrollAnchor === "true" && !e.has(n)) return n;
  return null;
}
function b4(t, e) {
  let n = 0;
  for (let o = e; o < t.length; o++) if (t[o]?.dataset.scrollAnchor === "true" && (n += 1, n > 1)) return !0;
  return !1;
}
function v4(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    let n = t[e];
    if (n?.dataset.scrollAnchor === "true") return n;
  }
  return null;
}
function y4({ content: t, spacer: e, viewport: n }) {
  let o = n.getBoundingClientRect();
  for (let r of Ui(t, e)) {
    if (!r.dataset.messageId) continue;
    let i = r.getBoundingClientRect();
    if (i.bottom > o.top && i.top < o.bottom) return r;
  }
  return null;
}
function x4({ align: t, element: e, scrollMargin: n, spacer: o, viewport: r }) {
  let i = wg(e, r), s = e.getBoundingClientRect().height, l = S4(o);
  if (t === "center") {
    let a = Math.max(0, r.clientHeight - l.start - l.end);
    return i - l.start - (a - s) / 2 - n;
  }
  if (t === "end") return i - r.clientHeight + s + l.end + n;
  if (t === "nearest") {
    let a = i + s, c = r.scrollTop + l.start, u = r.scrollTop + r.clientHeight - l.end;
    return i >= c && a <= u ? r.scrollTop : i < c ? i - l.start - n : a - r.clientHeight + l.end + n;
  }
  return i - l.start - n;
}
function wg(t, e) {
  let n = t.getBoundingClientRect(), o = e.getBoundingClientRect();
  return n.top - o.top + e.scrollTop;
}
function yl(t, e) {
  return t.getBoundingClientRect().top - e.getBoundingClientRect().top;
}
function C4({ content: t, scrollTop: e, spacer: n, viewport: o }) {
  let r = ku({ content: t, spacer: n, viewport: o });
  return e + o.clientHeight - r;
}
function ku({ content: t, spacer: e, viewport: n }) {
  let o = Ui(t, e), r = Sg(t), i = n.getBoundingClientRect(), s = n.scrollTop, l = r.start + r.end;
  for (let a of o) {
    let c = a.getBoundingClientRect();
    l = Math.max(l, c.bottom - i.top + s + r.end);
  }
  return l;
}
function w4(t) {
  return Math.max(0, t.scrollHeight - t.clientHeight);
}
function Sg(t) {
  let e = window.getComputedStyle(t);
  return { end: Kc(e.paddingBlockEnd || e.paddingBottom), start: Kc(e.paddingBlockStart || e.paddingTop) };
}
function S4(t) {
  let e = t?.parentElement;
  return e ? Sg(e) : { end: 0, start: 0 };
}
function R4(t) {
  if (!t) return 0;
  let e = window.getComputedStyle(t), n = e.rowGap === "normal" ? e.gap : e.rowGap;
  return Kc(n);
}
function Kc(t) {
  if (!t) return 0;
  let e = Number.parseFloat(t);
  return Number.isFinite(e) ? e : 0;
}
function E4({ refs: t, commitScrollState: e, scheduleStateCommit: n, scheduleVisibilitySync: o }) {
  let { streamingTurnRef: r, autoScrollRef: i, autoscrollingRef: s, autoscrollingTimeoutRef: l, contentRef: a, defaultScrollPositionAppliedRef: c, itemCountRef: u, messageElementsRef: d, modeRef: f, pendingScrollToMessageRef: p, prependRestoreRef: m, scrollMarginRef: h, scrollPreviousItemPeekRef: b, spacerGapRef: v, spacerHeightRef: C, spacerRef: y, viewportRef: w } = t, R = x.useCallback((I) => {
    l.current !== null && (window.clearTimeout(l.current), l.current = null), s.current !== I && (s.current = I, e()), I && (l.current = window.setTimeout(() => {
      l.current = null, s.current = !1, e();
    }, u4));
  }, [e]), S = x.useCallback((I) => {
    let D = y.current;
    if (!D) return;
    let O = Math.max(0, Math.ceil(I));
    C.current !== O && (C.current = O, D.hidden = O === 0, D.style.height = `${O}px`, D.style.marginTop = O > 0 ? `${-v.current}px` : "");
  }, []), E = x.useCallback((I, { behavior: D = "auto", autoscrolling: O = !1 } = {}) => {
    let V = w.current;
    if (!V) return;
    let _ = Math.max(0, I);
    if (Math.abs(V.scrollTop - _) <= Il) {
      V.scrollTop = _, e();
      return;
    }
    O && R(!0), V.scrollTo({ top: _, behavior: D }), n();
  }, [e, n, R]), N = x.useCallback(({ behavior: I = "auto" } = {}) => w.current ? (S(0), r.current = null, f.current = "free-scrolling", E(0, { behavior: I }), o(), !0) : !1, [o, E, S]), M = x.useCallback(({ behavior: I = "auto" } = {}) => {
    let D = w.current;
    return D ? (S(0), r.current = null, f.current = i.current ? "following-bottom" : "free-scrolling", E(w4(D), { autoscrolling: !0, behavior: I }), o(), !0) : !1;
  }, [o, E, S]), T = x.useCallback((I, { align: D = "start", behavior: O = "auto", scrollMargin: V = h.current } = {}, { keepPreviousPeek: _ = !1 } = {}) => {
    let L = a.current, A = w.current;
    if (!L || !A || !L.contains(I)) return !1;
    let $ = x4({ align: D, element: I, scrollMargin: _ ? V + b.current : V, spacer: y.current, viewport: A }), Y = C4({ content: L, scrollTop: $, spacer: y.current, viewport: A });
    return S(Y), m.current = { element: I, viewportTop: yl(I, A) }, f.current = _ ? "anchored-to-message" : "settling-jump", r.current = _ ? I : null, E($, { behavior: O }), o(), !0;
  }, [o, E, S]), P = x.useCallback(() => {
    let I = r.current;
    return !I || !I.isConnected || f.current !== "anchored-to-message" ? !1 : T(I, { align: "start" }, { keepPreviousPeek: !0 });
  }, [T]), k = x.useCallback((I, D) => {
    let O = d.current.get(I);
    return O ? (c.current = !0, T(O, D) ? (p.current = null, !0) : (p.current = { messageId: I, options: D }, !0)) : u.current === 0 ? (p.current = { messageId: I, options: D }, c.current = !0, !0) : !1;
  }, [T]);
  return { flushPendingScrollToMessage: x.useCallback(() => {
    let I = p.current;
    if (!I) return !1;
    let D = d.current.get(I.messageId);
    return !D || !T(D, I.options) ? !1 : (p.current = null, c.current = !0, !0);
  }, [T]), reanchorToAnchoredMessage: P, scrollToElement: T, scrollToEnd: M, scrollToMessage: k, scrollToStart: N };
}
function Rg(t, e) {
  let n = t, o = /* @__PURE__ */ new Set();
  return { getSnapshot: () => n, hasListeners: () => o.size > 0, setSnapshot: (r) => {
    e(n, r) || (n = r, o.forEach((i) => i()));
  }, subscribe: (r, i, s) => {
    let l = o.size === 0;
    return o.add(r), l && i?.(), () => {
      o.delete(r), o.size === 0 && s?.();
    };
  } };
}
function N4(t, e) {
  return Rg(t, e);
}
function k4() {
  return Rg(Pl, P4);
}
function I4(t, e) {
  return t.start === e.start && t.end === e.end;
}
function P4(t, e) {
  return t.currentAnchorId !== e.currentAnchorId || t.visibleMessageIds.length !== e.visibleMessageIds.length ? !1 : t.visibleMessageIds.every((n, o) => n === e.visibleMessageIds[o]);
}
function M4({ autoScroll: t, scrollEdgeThreshold: e, scrollMargin: n, scrollPreviousItemPeek: o }) {
  let r = x.useRef(t), i = x.useRef(!1), s = x.useRef(null), l = x.useRef(!1), a = x.useRef(e), c = x.useRef(0), u = x.useRef(null), d = x.useRef(0), f = x.useRef(t ? "following-bottom" : "free-scrolling"), p = x.useRef(/* @__PURE__ */ new Map()), m = x.useRef(null), h = x.useRef(null), b = x.useRef(null), v = x.useRef(o), C = x.useRef(!0), y = x.useRef(null), w = x.useRef(n), R = x.useRef(null), S = x.useRef(0), E = x.useRef(0), N = x.useRef(null), M = x.useRef(null), T = x.useRef(null), P = x.useRef(null), k = x.useRef(null), I = x.useRef(null), D = x.useRef(null), O = x.useRef(null), V = x.useRef(/* @__PURE__ */ new Set()), _ = x.useRef(/* @__PURE__ */ new WeakSet());
  return T.current === null && (T.current = N4(Cg, I4)), O.current === null && (O.current = k4()), r.current = t, a.current = e, w.current = n, v.current = o, { autoScrollRef: r, autoscrollingRef: i, autoscrollingTimeoutRef: P, streamingTurnRef: b, contentRef: s, defaultScrollPositionAppliedRef: l, firstItemRef: u, itemCountRef: c, lastScrollTopRef: d, messageElementsRef: p, modeRef: f, pendingScrollFrameRef: R, pendingScrollToMessageRef: m, prependRestoreRef: h, preserveScrollOnPrependRef: C, rootRef: y, scrollEdgeThresholdRef: a, scrollMarginRef: w, scrollPreviousItemPeekRef: v, spacerGapRef: S, spacerHeightRef: E, spacerRef: N, stateFrameRef: M, stateStore: T.current, viewportRef: k, visibilityFrameRef: I, visibilityObserverRef: D, visibilityStore: O.current, visibleMessageIdsRef: V, handledScrollAnchorsRef: _ };
}
function D1(t, e) {
  return x.useCallback((n) => {
    t.current = n, n && e();
  }, [t, e]);
}
function T4({ autoScroll: t = !1, defaultScrollPosition: e = "end", scrollEdgeThreshold: n = l4, scrollPreviousItemPeek: o = a4, scrollMargin: r = c4 }) {
  let i = M4({ autoScroll: t, scrollEdgeThreshold: n, scrollMargin: r, scrollPreviousItemPeek: o }), { streamingTurnRef: s, autoScrollRef: l, autoscrollingRef: a, autoscrollingTimeoutRef: c, contentRef: u, defaultScrollPositionAppliedRef: d, firstItemRef: f, itemCountRef: p, lastScrollTopRef: m, messageElementsRef: h, modeRef: b, pendingScrollFrameRef: v, pendingScrollToMessageRef: C, prependRestoreRef: y, preserveScrollOnPrependRef: w, rootRef: R, scrollEdgeThresholdRef: S, scrollMarginRef: E, scrollPreviousItemPeekRef: N, spacerGapRef: M, spacerHeightRef: T, spacerRef: P, stateFrameRef: k, stateStore: I, viewportRef: D, visibilityFrameRef: O, visibilityObserverRef: V, visibilityStore: _, visibleMessageIdsRef: L, handledScrollAnchorsRef: A } = i, $ = x.useRef(e);
  $.current !== e && ($.current = e, d.current = !1);
  let Y = x.useCallback((ye) => {
    let xe = R.current, de = D.current, we = [ye.start && "start", ye.end && "end"].filter(Boolean).join(" "), Me = a.current;
    for (let Re of [xe, de]) Re && (we ? Re.setAttribute("data-scrollable", we) : Re.removeAttribute("data-scrollable"), Re.toggleAttribute("data-autoscrolling", Me));
  }, []), z = x.useCallback((ye) => {
    let xe = D.current?.scrollTop ?? 0, de = xe < m.current - Il;
    m.current = xe, l.current && !ye.end && b.current !== "settling-jump" && b.current !== "anchored-to-message" ? b.current = "following-bottom" : b.current === "following-bottom" && ye.end && de && !a.current && (b.current = "free-scrolling");
  }, []), H = x.useCallback(() => {
    let ye = p4({ content: u.current, scrollEdgeThreshold: S.current, spacer: P.current, viewport: D.current });
    z(ye);
    let xe = b.current === "following-bottom" ? { ...ye, end: !1 } : ye;
    Y(xe), I.setSnapshot(xe);
  }, [z, I, Y]), K = x.useCallback(() => {
    k.current === null && (k.current = window.requestAnimationFrame(() => {
      k.current = null, H();
    }));
  }, [H]), G = x.useCallback(() => {
    _.hasListeners() && O.current === null && (O.current = window.requestAnimationFrame(() => {
      O.current = null, _.hasListeners() && _.setSnapshot(m4({ content: u.current, scrollMargin: E.current, scrollPreviousItemPeek: N.current, spacer: P.current, viewport: D.current, visibleMessageIds: L.current }));
    }));
  }, [_]), { flushPendingScrollToMessage: q, reanchorToAnchoredMessage: ee, scrollToElement: W, scrollToEnd: X, scrollToMessage: J, scrollToStart: re } = E4({ refs: i, commitScrollState: H, scheduleStateCommit: K, scheduleVisibilitySync: G }), Q = x.useCallback(() => {
    let ye = y.current, xe = D.current;
    if (!ye || !xe || !ye.element.isConnected) return !1;
    let de = yl(ye.element, xe) - ye.viewportTop;
    return Math.abs(de) <= Il ? !1 : (xe.scrollTop += de, ye.viewportTop = yl(ye.element, xe), K(), G(), !0);
  }, [K, G]), ie = x.useCallback(() => {
    let ye = u.current, xe = D.current;
    if (!ye || !xe) {
      y.current = null;
      return;
    }
    let de = y4({ content: ye, spacer: P.current, viewport: xe });
    y.current = de ? { element: de, viewportTop: yl(de, xe) } : null;
  }, []), ce = x.useCallback(() => {
    v.current === null && (v.current = window.requestAnimationFrame(() => {
      v.current = null, q() && ie();
    }));
  }, [ie, q]), oe = x.useCallback(() => {
    if (!e || d.current || p.current === 0) return !1;
    let ye = !1;
    if (e === "last-anchor") {
      let xe = u.current, de = D.current, we = xe && de ? v4(Ui(xe, P.current)) : null;
      if (!xe || !de || !we) ye = X({ behavior: "auto" });
      else {
        let Me = wg(we, de);
        ye = ku({ content: xe, spacer: P.current, viewport: de }) - Me <= de.clientHeight ? X({ behavior: "auto" }) : W(we, { align: "start" }, { keepPreviousPeek: !0 });
      }
    } else ye = e === "end" ? X({ behavior: "auto" }) : re({ behavior: "auto" });
    return ye ? (d.current = !0, !0) : !1;
  }, [e, W, X, re]), se = x.useCallback(() => {
    let ye = u.current;
    if (!ye) return;
    let xe = Ui(ye, P.current), de = p.current, we = f.current;
    p.current = xe.length, f.current = xe[0] ?? null, (() => {
      if (q()) return;
      if (de === 0) {
        if (oe() || xe.length > 0 && l.current && X({ behavior: "auto" })) return;
        H(), G();
        return;
      }
      let Me = we ? xe.indexOf(we) : -1;
      if (w.current && Me > 0) {
        Q();
        return;
      }
      if (xe.length > de) {
        let Re = g4(xe, de);
        if (Re) {
          if (l.current && b.current === "following-bottom" && b4(xe, de)) {
            X({ behavior: "auto" });
            return;
          }
          W(Re, { align: "start" }, { keepPreviousPeek: !0 }), A.current.add(Re);
          return;
        }
      }
      if (xe.length === de) {
        let Re = h4(xe, A.current);
        if (Re) {
          W(Re, { align: "start" }, { keepPreviousPeek: !0 }), A.current.add(Re);
          return;
        }
      }
      b.current === "following-bottom" && l.current ? X({ behavior: "auto" }) : (H(), G());
    })(), ie();
  }, [oe, ie, H, q, Q, G, W, X]), fe = x.useCallback(() => {
    if (b.current === "following-bottom" && l.current) {
      X({ behavior: "auto" });
      return;
    }
    let ye = T.current;
    if (ee()) {
      l.current && ye > 0 && T.current === 0 && X({ behavior: "auto" });
      return;
    }
    K(), G();
  }, [ee, K, G, X]), be = x.useCallback(() => {
    let ye = D.current;
    if (!(!ye || !_.hasListeners())) {
      if (typeof IntersectionObserver > "u") {
        G();
        return;
      }
      V.current || (V.current = new IntersectionObserver((xe) => {
        for (let de of xe) {
          let we = de.target.dataset.messageId;
          we && (de.isIntersecting ? L.current.add(we) : L.current.delete(we));
        }
        G();
      }, { root: ye, rootMargin: `${-(E.current + N.current)}px 0px 0px 0px`, threshold: [0, 0.01, 0.5, 1] })), h.current.forEach((xe) => {
        V.current?.observe(xe);
      }), G();
    }
  }, [G, _]), le = x.useCallback(() => {
    O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), V.current?.disconnect(), V.current = null, L.current.clear(), _.setSnapshot(Pl);
  }, [_]), me = x.useCallback((ye, xe, de) => {
    if (xe) {
      h.current.set(ye, xe), V.current?.observe(xe), G(), C.current?.messageId === ye && ce();
      return;
    }
    de && h.current.get(ye) === de && (h.current.delete(ye), L.current.delete(ye), V.current?.unobserve(de), G());
  }, [ce, G]), j = x.useCallback(() => {
    (b.current === "following-bottom" || b.current === "anchored-to-message" || b.current === "settling-jump") && (s.current = null, b.current = "free-scrolling");
  }, []), te = x.useCallback(() => Y(I.getSnapshot()), [I, Y]), U = D1(R, te), Z = D1(D, te), ue = x.useCallback((ye) => {
    u.current = ye;
  }, []), pe = x.useCallback((ye) => {
    P.current = ye, M.current = R4(ye?.parentElement ?? null);
  }, []), he = x.useCallback(() => {
    H(), G(), ie();
  }, [ie, H, G]), Ie = x.useMemo(() => ({ handleContentChange: se, handleResize: fe, observeVisibility: be, preserveScrollOnPrependRef: w, scrollToEnd: X, scrollToMessage: J, scrollToStart: re, setContentElement: ue, setRootElement: U, setSpacerElement: pe, setViewportElement: Z, stateStore: I, syncAfterScroll: he, unobserveVisibility: le, userScrollIntent: j, viewportRef: D, visibilityStore: _ }), [se, fe, be, X, J, re, ue, U, pe, Z, I, he, le, j, _]);
  return x.useLayoutEffect(() => {
    oe();
  }, [oe]), x.useEffect(() => () => {
    k.current !== null && (window.cancelAnimationFrame(k.current), k.current = null), O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), c.current !== null && (window.clearTimeout(c.current), c.current = null), v.current !== null && (window.cancelAnimationFrame(v.current), v.current = null), V.current?.disconnect(), V.current = null;
  }, []), x.useLayoutEffect(() => {
    if (t && b.current === "following-bottom" && p.current > 0) {
      X({ behavior: "auto" });
      return;
    }
    H();
  }, [t, H, X]), { context: Ie, registerMessage: me };
}
function O4(t) {
  let e = x.useRef(t);
  return e.current = t, e;
}
var Eg = x.createContext(null), Ng = x.createContext(null);
function is() {
  let t = x.useContext(Eg);
  if (!t) throw new Error("useMessageScroller must be used within a MessageScroller.");
  return t;
}
function D4() {
  let t = x.useContext(Ng);
  if (!t) throw new Error("MessageScrollerItem must be used within a MessageScroller.");
  return t;
}
function Iu() {
  let { scrollToEnd: t, scrollToMessage: e, scrollToStart: n } = is();
  return x.useMemo(() => ({ scrollToEnd: t, scrollToMessage: e, scrollToStart: n }), [t, e, n]);
}
function _4({ autoScroll: t = !1, children: e, defaultScrollPosition: n = "end", scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i }) {
  let { context: s, registerMessage: l } = T4({ autoScroll: t, defaultScrollPosition: n, scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i });
  return g(Eg.Provider, { value: s, children: g(Ng.Provider, { value: l, children: e }) });
}
function V4({ children: t, ...e }) {
  let { setRootElement: n } = is();
  return g("div", { ref: n, ...e, children: t });
}
function A4({ "aria-label": t, children: e, onKeyDown: n, onScroll: o, onTouchMove: r, onWheel: i, preserveScrollOnPrepend: s = !0, ref: l, role: a, tabIndex: c, ...u }) {
  let { handleResize: d, preserveScrollOnPrependRef: f, setViewportElement: p, syncAfterScroll: m, userScrollIntent: h, viewportRef: b } = is();
  f.current = s;
  let v = x.useCallback((S) => {
    p(S), rs(l)?.(S);
  }, [l, p]);
  function C(S) {
    m(), o?.(S);
  }
  function y(S) {
    h(), i?.(S);
  }
  function w(S) {
    h(), r?.(S);
  }
  function R(S) {
    d4.has(S.key) && h(), n?.(S);
  }
  return x.useEffect(() => {
    let S = b.current;
    if (!S || typeof ResizeObserver > "u") return;
    let E = 0, N = new ResizeObserver(() => {
      window.cancelAnimationFrame(E), E = window.requestAnimationFrame(d);
    });
    return N.observe(S), () => {
      window.cancelAnimationFrame(E), N.disconnect();
    };
  }, [d, b]), g("div", { ref: v, role: a ?? "region", "aria-label": t ?? "Messages", tabIndex: c ?? 0, onKeyDown: R, onScroll: C, onTouchMove: w, onWheel: y, ...u, children: e });
}
function L4({ "aria-relevant": t, children: e, ref: n, role: o, spacerClassName: r, ...i }) {
  let { handleContentChange: s, handleResize: l, setContentElement: a, setSpacerElement: c } = is(), u = x.useRef(null), d = x.useCallback((f) => {
    u.current = f, a(f), rs(n)?.(f);
  }, [n, a]);
  return x.useLayoutEffect(() => {
    let f = u.current;
    if (!f || (s(), typeof MutationObserver > "u")) return;
    let p = new MutationObserver(() => {
      s();
    });
    return p.observe(f, { childList: !0 }), () => p.disconnect();
  }, [s]), x.useEffect(() => {
    let f = u.current;
    if (!f || typeof ResizeObserver > "u") return;
    let p = 0, m = new ResizeObserver(() => {
      window.cancelAnimationFrame(p), p = window.requestAnimationFrame(l);
    });
    return m.observe(f), () => {
      window.cancelAnimationFrame(p), m.disconnect();
    };
  }, [l]), F("div", { ref: d, role: o ?? "log", "aria-relevant": t ?? "additions", ...i, children: [e, g("div", { ref: c, "aria-hidden": "true", "data-message-scroller-spacer": "", hidden: !0, className: r })] });
}
function F4({ messageId: t, ref: e, scrollAnchor: n = !1, ...o }) {
  let r = D4(), i = x.useRef(null), s = x.useCallback((l) => {
    let a = i.current;
    i.current = l, t && r(t, l, a), rs(e)?.(l);
  }, [t, e, r]);
  return g("div", { ref: s, "data-message-id": t, "data-scroll-anchor": n ? "true" : "false", ...o });
}
function $4({ behavior: t = "smooth", children: e, direction: n = "end", onClick: o, render: r, tabIndex: i, type: s = "button", ...l }) {
  let { scrollToEnd: a, scrollToStart: c, stateStore: u } = is(), d = O4(o), f = x.useCallback((b) => u.subscribe(b), [u]), p = x.useCallback(() => {
    let b = u.getSnapshot();
    return n === "start" ? b.start : b.end;
  }, [n, u]), m = x.useSyncExternalStore(f, p, p), h = x.useCallback((b) => {
    m && (d.current?.(b), b.defaultPrevented || (b.currentTarget.blur(), n === "start" ? c({ behavior: t }) : a({ behavior: t })));
  }, [t, n, m, d, a, c]);
  return o4({ defaultTagName: "button", props: jc({ type: s, inert: !m, tabIndex: m ? i : -1, children: e ?? F("span", { children: ["Scroll to ", n] }), onClick: h }, l), render: r, state: { active: m, direction: n }, stateAttributesMapping: { active: (b) => ({ "data-active": b ? "true" : "false" }) } });
}
var Yr = { Provider: _4, Root: V4, Viewport: A4, Content: L4, Item: F4, Button: $4 };
const kg = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)"
};
function Pu(t) {
  const e = B.c(18);
  let n, o;
  e[0] !== t ? ({
    size: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "md" : o, i = At();
  let s;
  if (e[3] !== i) {
    let v;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /:/g, e[5] = v) : v = e[5], s = i.replace(v, ""), e[3] = i, e[4] = s;
  } else
    s = e[4];
  const a = `ai-sparkles-gradient-${s}`, c = kg[r];
  let u, d, f;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), d = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), f = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), e[6] = u, e[7] = d, e[8] = f) : (u = e[6], d = e[7], f = e[8]);
  let p;
  e[9] !== a ? (p = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ F("linearGradient", { id: a, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
    u,
    d,
    f
  ] }) }), e[9] = a, e[10] = p) : p = e[10];
  const m = `url(#${a})`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  return e[13] !== c || e[14] !== n || e[15] !== p || e[16] !== h ? (b = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", width: c, height: c, "aria-hidden": "true", focusable: "false", ...n, children: [
    p,
    h
  ] }), e[13] = c, e[14] = n, e[15] = p, e[16] = h, e[17] = b) : b = e[17], b;
}
function H4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 12.52 7 12.938 7.418 12.938 7.9375 V 12.3125 C 12.938 12.832 12.52 13.25 12 13.25 C 11.48 13.25 11.062 12.832 11.062 12.3125 V 7.9375 C 11.062 7.418 11.48 7 12 7 Z M 10.75 15.75 C 10.75 15.4185 10.882 15.1005 11.116 14.8661 C 11.351 14.6317 11.668 14.5 12 14.5 C 12.332 14.5 12.649 14.6317 12.884 14.8661 C 13.118 15.1005 13.25 15.4185 13.25 15.75 C 13.25 16.0815 13.118 16.3995 12.884 16.6339 C 12.649 16.8683 12.332 17 12 17 C 11.668 17 11.351 16.8683 11.116 16.6339 C 10.882 16.3995 10.75 16.0815 10.75 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function z4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 6.96 C 4.32 6.561 4.641 6.24 5.04 6.24 C 5.439 6.24 5.76 6.561 5.76 6.96 V 17.04 C 5.76 17.439 5.439 17.76 5.04 17.76 C 4.641 17.76 4.32 17.439 4.32 17.04 V 6.96 Z M 8.37 12.51 C 8.088 12.228 8.088 11.772 8.37 11.493 L 12.45 7.41 C 12.732 7.128 13.188 7.128 13.467 7.41 C 13.746 7.692 13.749 8.148 13.467 8.427 L 10.617 11.277 H 18.96 C 19.359 11.277 19.68 11.598 19.68 11.997 C 19.68 12.396 19.359 12.717 18.96 12.717 H 10.617 L 13.467 15.567 C 13.749 15.849 13.749 16.305 13.467 16.584 C 13.185 16.863 12.729 16.866 12.45 16.584 L 8.37 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function B4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2.275 10.8332 C 1.908 11.2004 1.908 11.7942 2.275 12.1575 L 8.837 18.7246 C 9.204 19.0918 9.798 19.0918 10.161 18.7246 C 10.525 18.3574 10.528 17.7636 10.161 17.4002 L 5.201 12.4349 H 21.063 C 21.582 12.4349 22 12.0169 22 11.4973 C 22 10.9777 21.582 10.5597 21.063 10.5597 H 5.201 L 10.165 5.5983 C 10.532 5.2311 10.532 4.6373 10.165 4.274 C 9.798 3.9106 9.204 3.9067 8.841 4.274 L 2.275 10.8332 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function W4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.76 6.96 C 5.76 6.561 5.439 6.24 5.04 6.24 C 4.641 6.24 4.32 6.561 4.32 6.96 V 17.04 C 4.32 17.439 4.641 17.76 5.04 17.76 C 5.439 17.76 5.76 17.439 5.76 17.04 V 6.96 Z M 19.47 12.51 C 19.752 12.228 19.752 11.772 19.47 11.493 L 15.39 7.41 C 15.108 7.128 14.652 7.128 14.373 7.41 C 14.094 7.692 14.091 8.148 14.373 8.427 L 17.223 11.277 H 8.88 C 8.481 11.277 8.16 11.598 8.16 11.997 C 8.16 12.396 8.481 12.717 8.88 12.717 H 17.223 L 14.373 15.567 C 14.091 15.849 14.091 16.305 14.373 16.584 C 14.655 16.863 15.111 16.866 15.39 16.584 L 19.47 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function U4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19 4 C 19.554 4 20 4.4459 20 5.0001 V 15.0014 C 20 15.5557 19.554 16.0016 19 16.0016 C 18.446 16.0016 18 15.5557 18 15.0014 V 7.4129 L 5.706 19.7062 C 5.314 20.0979 4.68 20.0979 4.293 19.7062 C 3.905 19.3145 3.901 18.6852 4.289 18.2935 L 16.583 6.0003 H 8.994 C 8.439 6.0003 7.993 5.5544 7.993 5.0001 C 7.993 4.4459 8.439 4 8.994 4 H 18.996 H 19 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function G4(t) {
  const e = B.c(13), n = At();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 11.414 4.0871 C 11.582 3.9894 11.784 3.9894 11.953 4.0871 L 17.339 7.1983 L 11.683 10.4646 L 6.027 7.1983 L 11.414 4.0871 Z M 5.218 8.6006 L 10.874 11.8669 V 18.3995 L 5.488 15.2882 C 5.319 15.1905 5.218 15.0152 5.218 14.8197 V 8.5972 V 8.6006 Z M 12.492 18.3995 V 11.8669 L 18.148 8.6006 V 14.8231 C 18.148 15.0152 18.047 15.1938 17.879 15.2916 L 12.492 18.3995 Z M 12.762 2.6882 C 12.094 2.304 11.272 2.304 10.605 2.6882 L 4.679 6.1062 C 4.011 6.4905 3.6 7.2051 3.6 7.9736 V 14.8163 C 3.6 15.5882 4.011 16.2995 4.679 16.6837 L 10.605 20.1118 C 11.272 20.4961 12.094 20.4961 12.762 20.1118 L 18.691 16.6905 C 19.359 16.3062 19.77 15.5916 19.77 14.8231 V 7.9804 C 19.77 7.2085 19.359 6.4972 18.691 6.1129 L 12.762 2.6849 V 2.6882 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function Y4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6 4.8 C 6 4.1362 6.536 3.6 7.2 3.6 H 8.4 C 9.064 3.6 9.6 4.1362 9.6 4.8 V 5.4 H 6 V 4.8 Z M 4.635 8.325 C 4.815 7.3275 5.685 6.6 6.701 6.6 H 9.9 C 10.399 6.6 10.8 7.0012 10.8 7.5 V 8.4 H 13.2 V 7.5 C 13.2 7.0012 13.601 6.6 14.1 6.6 H 17.299 C 18.315 6.6 19.185 7.3275 19.365 8.325 L 19.552 9.3487 C 19.687 10.095 19.957 10.8112 20.347 11.4637 L 20.445 11.6287 C 21.199 12.8887 21.6 14.3287 21.6 15.795 V 18.3 C 21.6 19.4587 20.659 20.4 19.5 20.4 H 15.3 C 14.141 20.4 13.2 19.4587 13.2 18.3 V 13.2 H 10.8 V 18.3 C 10.8 19.4587 9.859 20.4 8.7 20.4 H 4.5 C 3.341 20.4 2.4 19.4587 2.4 18.3 V 15.795 C 2.4 14.325 2.797 12.885 3.555 11.625 L 3.652 11.46 C 4.042 10.8075 4.312 10.0912 4.447 9.345 L 4.635 8.3212 V 8.325 Z M 6.701 8.4 C 6.555 8.4 6.431 8.505 6.405 8.6475 L 6.217 9.6712 C 6.045 10.6312 5.7 11.55 5.197 12.39 L 5.1 12.555 C 4.511 13.5337 4.2 14.6512 4.2 15.795 V 18.3 C 4.2 18.465 4.335 18.6 4.5 18.6 H 8.7 C 8.865 18.6 9 18.465 9 18.3 V 8.4 H 6.701 Z M 17.299 8.4 H 15 V 18.3 C 15 18.465 15.135 18.6 15.3 18.6 H 19.5 C 19.665 18.6 19.8 18.465 19.8 18.3 V 15.795 C 19.8 14.655 19.489 13.5337 18.904 12.555 L 18.806 12.39 C 18.304 11.5537 17.959 10.6312 17.782 9.6712 L 17.595 8.6475 C 17.569 8.505 17.445 8.4 17.299 8.4 Z M 15.6 3.6 H 16.8 C 17.464 3.6 18 4.1362 18 4.8 V 5.4 H 14.4 V 4.8 C 14.4 4.1362 14.936 3.6 15.6 3.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function j4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 20.66 17 C 21.512 15.5312 22 13.8203 22 12 C 22 6.4766 17.523 2 12 2 V 3.875 C 16.488 3.875 20.125 7.5117 20.125 12 C 20.125 13.4805 19.73 14.8672 19.039 16.0625 L 20.664 17 H 20.66 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function K4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.357 2 C 7.951 2 8.429 2.4681 8.429 3.05 V 4.8 H 15.571 V 3.05 C 15.571 2.4681 16.049 2 16.643 2 C 17.237 2 17.714 2.4681 17.714 3.05 V 4.8 H 19.143 C 20.719 4.8 22 6.0556 22 7.6 V 20.2 C 22 21.7444 20.719 23 19.143 23 H 4.857 C 3.281 23 2 21.7444 2 20.2 V 7.6 C 2 6.0556 3.281 4.8 4.857 4.8 H 6.286 V 3.05 C 6.286 2.4681 6.763 2 7.357 2 Z M 7.357 6.9 H 4.857 C 4.464 6.9 4.143 7.215 4.143 7.6 V 9.7 H 19.857 V 7.6 C 19.857 7.215 19.536 6.9 19.143 6.9 H 7.357 Z M 4.143 11.8 V 20.2 C 4.143 20.585 4.464 20.9 4.857 20.9 H 19.143 C 19.536 20.9 19.857 20.585 19.857 20.2 V 11.8 H 4.143 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function q4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M1.82142 0.910712V0H0V16.9999H19.4285V15.1785H1.82142V0.910712ZM17.9486 5.19865L18.5937 4.55356L17.3073 3.26718L16.6622 3.91227L12.1466 8.42788C9.756 6.03726 8.54172 4.82298 8.50377 4.78503L7.85868 5.43012L3.91227 9.37653L3.26718 10.0216L4.55356 11.308L5.19865 10.6629L8.49998 7.36159L11.4977 10.3593L12.1428 11.0044L12.7879 10.3593L17.9486 5.19865Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Z4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 8.17 16.6234 L 3.194 11.648 L 1.5 13.3303 L 8.17 20 L 22.487 5.6823 L 20.805 4 L 8.17 16.6234 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function X4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.45739 5.45213C7.75425 5.03285 7.6527 4.4597 7.22692 4.16736C6.80115 3.87502 6.21914 3.97503 5.92227 4.39431L4.37153 6.56764L3.60201 5.80601C3.23484 5.44828 2.6411 5.44828 2.27392 5.80601C1.90674 6.16375 1.91065 6.75228 2.27392 7.11386L3.83638 8.6525C4.03169 8.84483 4.30512 8.94485 4.58246 8.91792C4.8598 8.89099 5.10979 8.75252 5.26994 8.52941L7.45739 5.45213ZM7.45739 11.6067C7.75425 11.1874 7.6527 10.6143 7.22692 10.3219C6.80115 10.0296 6.21914 10.1296 5.92227 10.5489L4.37153 12.7222L3.60201 11.9606C3.23484 11.599 2.6411 11.599 2.27783 11.9606C1.91455 12.3222 1.91065 12.9069 2.27392 13.2684L3.83638 14.8071C4.03169 14.9994 4.30512 15.0994 4.58246 15.0725C4.8598 15.0456 5.10979 14.9071 5.26994 14.684L7.45739 11.6067ZM9.50031 6.45994C9.50031 6.97154 9.91826 7.38312 10.4378 7.38312H21.0625C21.582 7.38312 22 6.97154 22 6.45994C22 5.94834 21.582 5.53675 21.0625 5.53675H10.4378C9.91826 5.53675 9.50031 5.94834 9.50031 6.45994ZM9.50031 12.6145C9.50031 13.1261 9.91826 13.5377 10.4378 13.5377H21.0625C21.582 13.5377 22 13.1261 22 12.6145C22 12.1029 21.582 11.6913 21.0625 11.6913H10.4378C9.91826 11.6913 9.50031 12.1029 9.50031 12.6145ZM8.25034 18.7691C8.25034 19.2807 8.6683 19.6923 9.18781 19.6923H21.0625C21.582 19.6923 22 19.2807 22 18.7691C22 18.2575 21.582 17.8459 21.0625 17.8459H9.18781C8.6683 17.8459 8.25034 18.2575 8.25034 18.7691ZM5.7504 18.7691C5.7504 18.4426 5.61871 18.1295 5.38429 17.8987C5.14988 17.6679 4.83194 17.5382 4.50043 17.5382C4.16892 17.5382 3.85098 17.6679 3.61657 17.8987C3.38215 18.1295 3.25046 18.4426 3.25046 18.7691C3.25046 19.0955 3.38215 19.4086 3.61657 19.6395C3.85098 19.8703 4.16892 20 4.50043 20C4.83194 20 5.14988 19.8703 5.38429 19.6395C5.61871 19.4086 5.7504 19.0955 5.7504 18.7691Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Q4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function J4(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ev(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 17.687 11.778 C 18.104 12.1768 18.104 12.8216 17.687 13.2162 L 8.816 21.7009 C 8.399 22.0997 7.725 22.0997 7.313 21.7009 C 6.9 21.3021 6.896 20.6573 7.313 20.2627 L 15.43 12.4992 L 7.313 4.7357 C 6.896 4.3369 6.896 3.692 7.313 3.2975 C 7.73 2.903 8.404 2.8987 8.816 3.2975 L 17.687 11.7822 V 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function tv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 7.41 C 11.787 7.128 12.243 7.128 12.522 7.41 L 18.522 13.41 C 18.804 13.692 18.804 14.148 18.522 14.427 C 18.24 14.706 17.784 14.709 17.505 14.427 L 12.015 8.937 L 6.525 14.427 C 6.243 14.709 5.787 14.709 5.508 14.427 C 5.229 14.145 5.226 13.689 5.508 13.41 L 11.508 7.41 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function nv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 21.6 C 6.697 21.6 2.4 17.3025 2.4 12 C 2.4 6.6975 6.697 2.4 12 2.4 C 17.302 2.4 21.6 6.6975 21.6 12 C 21.6 17.3025 17.302 21.6 12 21.6 Z M 12 4.2 C 7.691 4.2 4.2 7.6913 4.2 12 C 4.2 16.3088 7.691 19.8 12 19.8 C 16.309 19.8 19.8 16.3088 19.8 12 C 19.8 7.6913 16.309 4.2 12 4.2 Z M 14.651 8.7713 C 14.944 8.37 15.506 8.28 15.907 8.5725 C 16.309 8.865 16.399 9.4275 16.106 9.8288 L 11.527 16.1288 C 11.374 16.3425 11.134 16.4775 10.871 16.4963 C 10.609 16.515 10.35 16.4213 10.166 16.2375 L 8.07 14.1413 C 7.717 13.7888 7.717 13.2188 8.07 12.87 C 8.422 12.5213 8.992 12.5175 9.341 12.87 L 10.691 14.22 L 14.651 8.775 V 8.7713 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ov(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 11.48 7 11.062 7.418 11.062 7.9375 V 12.3125 C 11.062 12.832 11.48 13.25 12 13.25 C 12.52 13.25 12.938 12.832 12.938 12.3125 V 7.9375 C 12.938 7.418 12.52 7 12 7 Z M 13.25 15.75 C 13.25 15.4185 13.118 15.1005 12.884 14.8661 C 12.649 14.6317 12.332 14.5 12 14.5 C 11.668 14.5 11.351 14.6317 11.116 14.8661 C 10.882 15.1005 10.75 15.4185 10.75 15.75 C 10.75 16.0815 10.882 16.3995 11.116 16.6339 C 11.351 16.8683 11.668 17 12 17 C 12.332 17 12.649 16.8683 12.884 16.6339 C 13.118 16.3995 13.25 16.0815 13.25 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function rv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function iv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.672 11.75 C 19.672 13.851 18.837 15.866 17.352 17.3516 C 15.866 18.8373 13.851 19.6719 11.75 19.6719 C 9.649 19.6719 7.634 18.8373 6.148 17.3516 C 4.663 15.866 3.828 13.851 3.828 11.75 C 3.828 9.649 4.663 7.634 6.148 6.1484 C 7.634 4.6627 9.649 3.8281 11.75 3.8281 C 13.851 3.8281 15.866 4.6627 17.352 6.1484 C 18.837 7.634 19.672 9.649 19.672 11.75 Z M 2 11.75 C 2 14.3359 3.027 16.8158 4.856 18.6443 C 6.684 20.4728 9.164 21.5 11.75 21.5 C 14.336 21.5 16.816 20.4728 18.644 18.6443 C 20.473 16.8158 21.5 14.3359 21.5 11.75 C 21.5 9.1641 20.473 6.6842 18.644 4.8557 C 16.816 3.0272 14.336 2 11.75 2 C 9.164 2 6.684 3.0272 4.856 4.8557 C 3.027 6.6842 2 9.1641 2 11.75 Z M 10.836 6.5703 V 8.7298 L 10.074 7.5872 C 9.792 7.1683 9.225 7.054 8.806 7.332 C 8.387 7.6101 8.273 8.1813 8.551 8.6003 L 10.988 12.2565 C 11.213 12.5917 11.628 12.7402 12.013 12.626 C 12.397 12.5117 12.66 12.1537 12.66 11.75 V 6.5703 C 12.66 6.0638 12.253 5.6562 11.746 5.6562 C 11.24 5.6562 10.832 6.0638 10.832 6.5703 H 10.836 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function sv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M9 5.31034C9.47739 5.31034 9.93523 5.1069 10.2728 4.74476C10.6104 4.38262 10.8 3.89145 10.8 3.37931C10.8 2.86717 10.6104 2.376 10.2728 2.01386C9.93523 1.65172 9.47739 1.44828 9 1.44828C8.52261 1.44828 8.06477 1.65172 7.72721 2.01386C7.38964 2.376 7.2 2.86717 7.2 3.37931C7.2 3.89145 7.38964 4.38262 7.72721 4.74476C8.06477 5.1069 8.52261 5.31034 9 5.31034ZM9 0C9.83543 0 10.6366 0.356033 11.2274 0.989777C11.8181 1.62352 12.15 2.48306 12.15 3.37931C12.15 4.27556 11.8181 5.1351 11.2274 5.76884C10.6366 6.40259 9.83543 6.75862 9 6.75862C8.16457 6.75862 7.36335 6.40259 6.77261 5.76884C6.18187 5.1351 5.85 4.27556 5.85 3.37931C5.85 2.48306 6.18187 1.62352 6.77261 0.989777C7.36335 0.356033 8.16457 0 9 0ZM8.325 9.65517C6.71062 9.65517 5.4 11.0612 5.4 12.7931V13.2759C5.4 13.6772 5.09906 14 4.725 14C4.35094 14 4.05 13.6772 4.05 13.2759V12.7931C4.05 10.2616 5.96531 8.2069 8.325 8.2069H9.675C12.0347 8.2069 13.95 10.2616 13.95 12.7931V13.2759C13.95 13.6772 13.6491 14 13.275 14C12.9009 14 12.6 13.6772 12.6 13.2759V12.7931C12.6 11.0612 11.2894 9.65517 9.675 9.65517H8.325ZM12.1331 6.8431C12.4622 6.50216 12.7406 6.1069 12.96 5.67241C13.1259 5.75086 13.3087 5.7931 13.5 5.7931C14.2453 5.7931 14.85 5.1444 14.85 4.34483C14.85 3.54526 14.2453 2.89655 13.5 2.89655H13.4775C13.4325 2.39569 13.3144 1.91897 13.1372 1.47543C13.2553 1.45733 13.3791 1.44828 13.5 1.44828C14.9906 1.44828 16.2 2.74569 16.2 4.34483C16.2 5.94397 14.9906 7.24138 13.5 7.24138C13.0022 7.24138 12.5353 7.09655 12.1331 6.8431ZM4.5 1.44828C4.62375 1.44828 4.74469 1.45733 4.86281 1.47543C4.68562 1.91897 4.5675 2.39871 4.5225 2.89655H4.5C3.75469 2.89655 3.15 3.54526 3.15 4.34483C3.15 5.1444 3.75469 5.7931 4.5 5.7931C4.69125 5.7931 4.87406 5.75086 5.04 5.67241C5.25937 6.1069 5.53781 6.50216 5.86688 6.8431C5.4675 7.09655 5.00062 7.24138 4.5 7.24138C3.00937 7.24138 1.8 5.94397 1.8 4.34483C1.8 2.74569 3.00937 1.44828 4.5 1.44828ZM4.19906 8.68966C3.77437 9.18147 3.42563 9.74569 3.1725 10.3672C2.10375 10.8349 1.35 11.9603 1.35 13.2759C1.35 13.6772 1.04906 14 0.675 14C0.300937 14 0 13.6772 0 13.2759C0 10.7685 1.87313 8.7319 4.19906 8.68966ZM14.8275 10.3672C14.5744 9.74569 14.2228 9.17845 13.8009 8.68966C16.1269 8.7319 18 10.7685 18 13.2759C18 13.6772 17.6991 14 17.325 14C16.9509 14 16.65 13.6772 16.65 13.2759C16.65 11.9603 15.8962 10.8349 14.8275 10.3672Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function lv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M11.875 3.875H7.5C7.15625 3.875 6.875 4.15625 6.875 4.5V19.5C6.875 19.8438 7.15625 20.125 7.5 20.125H17.5C17.8438 20.125 18.125 19.8438 18.125 19.5V10.125H14.6875C13.1328 10.125 11.875 8.86719 11.875 7.3125V3.875ZM17.3477 8.25L13.75 4.65234V7.3125C13.75 7.83203 14.168 8.25 14.6875 8.25H17.3477ZM5 4.5C5 3.12109 6.12109 2 7.5 2H12.7148C13.3789 2 14.0156 2.26172 14.4844 2.73047L19.2695 7.51953C19.7383 7.98828 20 8.625 20 9.28906V19.5C20 20.8789 18.8789 22 17.5 22H7.5C6.12109 22 5 20.8789 5 19.5V4.5Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function av(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.366 12.0832C16.2569 12.0832 15.3571 11.15 15.3571 9.99987C15.3571 8.84971 16.2569 7.91656 17.366 7.91656C18.4751 7.91656 19.3749 8.84971 19.3749 9.99987C19.3749 11.15 18.4751 12.0832 17.366 12.0832ZM10 7.91656C11.1091 7.91656 12.0089 8.84971 12.0089 9.99987C12.0089 11.15 11.1091 12.0832 10 12.0832C8.89092 12.0832 7.99109 11.15 7.99109 9.99987C7.99109 8.84971 8.89092 7.91656 10 7.91656ZM2.634 12.0832C1.52492 12.0832 0.625095 11.15 0.625095 9.99987C0.625095 8.84971 1.52492 7.91656 2.634 7.91656C3.74309 7.91656 4.64291 8.84971 4.64291 9.99987C4.64291 11.15 3.74309 12.0832 2.634 12.0832Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function cv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M12.0833 2.634C12.0833 3.74309 11.1502 4.64291 10 4.64291C8.84984 4.64291 7.91669 3.74309 7.91669 2.634C7.91669 1.52492 8.84984 0.625095 10 0.625095C11.1502 0.625095 12.0833 1.52492 12.0833 2.634ZM7.91669 10C7.91669 8.89092 8.84984 7.99109 10 7.99109C11.1502 7.99109 12.0833 8.89092 12.0833 10C12.0833 11.1091 11.1502 12.0089 10 12.0089C8.84984 12.0089 7.91669 11.1091 7.91669 10ZM12.0833 17.366C12.0833 18.4751 11.1502 19.3749 10 19.3749C8.84984 19.3749 7.91669 18.4751 7.91669 17.366C7.91669 16.2569 8.84984 15.3571 10 15.3571C11.1502 15.3571 12.0833 16.2569 12.0833 17.366Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function uv(t) {
  const e = B.c(13), n = At();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 14.3999 C 11.682 14.3999 11.376 14.5263 11.151 14.7514 C 10.926 14.9764 10.8 15.2816 10.8 15.5999 C 10.8 15.9182 10.926 16.2234 11.151 16.4484 C 11.376 16.6735 11.682 16.7999 12 16.7999 C 12.318 16.7999 12.623 16.6735 12.848 16.4484 C 13.073 16.2234 13.2 15.9182 13.2 15.5999 C 13.2 15.2816 13.073 14.9764 12.848 14.7514 C 12.623 14.5263 12.318 14.3999 12 14.3999 Z M 12 7.1999 C 11.317 7.1999 10.774 7.7812 10.822 8.4637 L 11.1 12.3637 C 11.134 12.8362 11.527 13.1999 11.996 13.1999 C 12.469 13.1999 12.859 12.8362 12.892 12.3637 L 13.17 8.4637 C 13.219 7.7812 12.679 7.1999 11.992 7.1999 H 12 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function dv(t) {
  const e = B.c(13), n = At();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 4.1999 C 9.931 4.1999 7.947 5.0217 6.484 6.4845 C 5.022 7.9473 4.2 9.9312 4.2 11.9999 C 4.2 14.0686 5.022 16.0526 6.484 17.5153 C 7.947 18.9781 9.931 19.7999 12 19.7999 C 14.069 19.7999 16.053 18.9781 17.515 17.5153 C 18.978 16.0526 19.8 14.0686 19.8 11.9999 C 19.8 9.9312 18.978 7.9473 17.515 6.4845 C 16.053 5.0217 14.069 4.1999 12 4.1999 Z M 12 16.7999 C 11.682 16.7999 11.376 16.6735 11.151 16.4484 C 10.926 16.2234 10.8 15.9182 10.8 15.5999 C 10.8 15.2816 10.926 14.9764 11.151 14.7514 C 11.376 14.5263 11.682 14.3999 12 14.3999 C 12.318 14.3999 12.623 14.5263 12.848 14.7514 C 13.073 14.9764 13.2 15.2816 13.2 15.5999 C 13.2 15.9182 13.073 16.2234 12.848 16.4484 C 12.623 16.6735 12.318 16.7999 12 16.7999 Z M 12 7.1999 C 12.682 7.1999 13.226 7.7812 13.177 8.4637 L 12.9 12.3637 C 12.866 12.8362 12.472 13.1999 12.004 13.1999 C 11.531 13.1999 11.141 12.8362 11.107 12.3637 L 10.83 8.4637 C 10.774 7.7812 11.317 7.1999 12 7.1999 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function fv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.998 5.3214 C 9.508 5.3214 7.461 6.4446 5.891 7.8904 C 4.421 9.2489 3.405 10.8616 2.886 12 C 3.405 13.1384 4.421 14.7511 5.888 16.1096 C 7.461 17.5554 9.508 18.6786 11.998 18.6786 C 14.488 18.6786 16.535 17.5554 18.105 16.1096 C 19.575 14.7511 20.591 13.1384 21.11 12 C 20.591 10.8616 19.575 9.2489 18.109 7.8904 C 16.535 6.4446 14.488 5.3214 11.998 5.3214 Z M 4.642 6.5585 C 6.441 4.8964 8.912 3.5 11.998 3.5 C 15.084 3.5 17.555 4.8964 19.354 6.5585 C 21.141 8.2092 22.336 10.1786 22.905 11.5333 C 23.032 11.833 23.032 12.167 22.905 12.4667 C 22.336 13.8214 21.141 15.7946 19.354 17.4415 C 17.555 19.1036 15.084 20.5 11.998 20.5 C 8.912 20.5 6.441 19.1036 4.642 17.4415 C 2.855 15.7946 1.66 13.8214 1.095 12.4667 C 0.968 12.167 0.968 11.833 1.095 11.5333 C 1.66 10.1786 2.855 8.2054 4.642 6.5585 Z M 11.998 15.0357 C 13.686 15.0357 15.053 13.6772 15.053 12 C 15.053 10.3228 13.686 8.9643 11.998 8.9643 C 11.971 8.9643 11.948 8.9643 11.922 8.9643 C 11.971 9.1578 11.998 9.3627 11.998 9.5714 C 11.998 10.9109 10.902 12 9.554 12 C 9.344 12 9.138 11.9734 8.943 11.9241 C 8.943 11.9507 8.943 11.9734 8.943 12 C 8.943 13.6772 10.31 15.0357 11.998 15.0357 Z M 11.998 7.1429 C 13.295 7.1429 14.538 7.6546 15.455 8.5655 C 16.372 9.4764 16.887 10.7118 16.887 12 C 16.887 13.2882 16.372 14.5236 15.455 15.4345 C 14.538 16.3454 13.295 16.8571 11.998 16.8571 C 10.702 16.8571 9.458 16.3454 8.541 15.4345 C 7.625 14.5236 7.11 13.2882 7.11 12 C 7.11 10.7118 7.625 9.4764 8.541 8.5655 C 9.458 7.6546 10.702 7.1429 11.998 7.1429 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function pv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M3.88889 2.25C3.88889 1.00898 4.88542 0 6.11111 0H13.8889C15.1146 0 16.1111 1.00898 16.1111 2.25V6.75H17.7778C19.0035 6.75 20 7.75898 20 9V15.75C20 16.991 19.0035 18 17.7778 18H2.22222C0.996528 18 0 16.991 0 15.75V5.625C0 4.38398 0.996528 3.375 2.22222 3.375H3.88889V2.25ZM6.11111 1.6875C5.80556 1.6875 5.55556 1.94062 5.55556 2.25V4.21875C5.55556 4.68633 5.18403 5.0625 4.72222 5.0625H2.22222C1.91667 5.0625 1.66667 5.31563 1.66667 5.625V15.75C1.66667 16.0594 1.91667 16.3125 2.22222 16.3125H8.33333V13.5C8.33333 12.8777 8.82986 12.375 9.44444 12.375H10.5556C11.1701 12.375 11.6667 12.8777 11.6667 13.5V16.3125H17.7778C18.0833 16.3125 18.3333 16.0594 18.3333 15.75V9C18.3333 8.69063 18.0833 8.4375 17.7778 8.4375H15.2778C14.816 8.4375 14.4444 8.06133 14.4444 7.59375V2.25C14.4444 1.94062 14.1944 1.6875 13.8889 1.6875H6.11111ZM10.5556 3.9375C10.5556 3.62812 10.8056 3.375 11.1111 3.375H12.2222C12.5278 3.375 12.7778 3.62812 12.7778 3.9375V5.0625C12.7778 5.37187 12.5278 5.625 12.2222 5.625H11.1111C10.8056 5.625 10.5556 5.37187 10.5556 5.0625V3.9375ZM7.77778 3.375H8.88889C9.19444 3.375 9.44444 3.62812 9.44444 3.9375V5.0625C9.44444 5.37187 9.19444 5.625 8.88889 5.625H7.77778C7.47222 5.625 7.22222 5.37187 7.22222 5.0625V3.9375C7.22222 3.62812 7.47222 3.375 7.77778 3.375ZM10.5556 7.3125C10.5556 7.00313 10.8056 6.75 11.1111 6.75H12.2222C12.5278 6.75 12.7778 7.00313 12.7778 7.3125V8.4375C12.7778 8.74687 12.5278 9 12.2222 9H11.1111C10.8056 9 10.5556 8.74687 10.5556 8.4375V7.3125ZM7.77778 6.75H8.88889C9.19444 6.75 9.44444 7.00313 9.44444 7.3125V8.4375C9.44444 8.74687 9.19444 9 8.88889 9H7.77778C7.47222 9 7.22222 8.74687 7.22222 8.4375V7.3125C7.22222 7.00313 7.47222 6.75 7.77778 6.75ZM3.33333 7.3125C3.33333 7.00313 3.58333 6.75 3.88889 6.75H5C5.30556 6.75 5.55556 7.00313 5.55556 7.3125V8.4375C5.55556 8.74687 5.30556 9 5 9H3.88889C3.58333 9 3.33333 8.74687 3.33333 8.4375V7.3125ZM3.88889 10.125H5C5.30556 10.125 5.55556 10.3781 5.55556 10.6875V11.8125C5.55556 12.1219 5.30556 12.375 5 12.375H3.88889C3.58333 12.375 3.33333 12.1219 3.33333 11.8125V10.6875C3.33333 10.3781 3.58333 10.125 3.88889 10.125ZM15 10.125H16.1111C16.4167 10.125 16.6667 10.3781 16.6667 10.6875V11.8125C16.6667 12.1219 16.4167 12.375 16.1111 12.375H15C14.6944 12.375 14.4444 12.1219 14.4444 11.8125V10.6875C14.4444 10.3781 14.6944 10.125 15 10.125Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function mv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 7.131 C 4.32 6.639 4.719 6.24 5.211 6.24 H 18.792 C 19.284 6.24 19.683 6.639 19.683 7.131 C 19.683 7.368 19.59 7.593 19.422 7.761 L 14.4 12.777 V 18.789 C 14.4 19.281 14.001 19.68 13.509 19.68 C 13.272 19.68 13.047 19.587 12.879 19.419 L 9.81 16.35 C 9.675 16.215 9.6 16.032 9.6 15.84 V 12.777 L 4.581 7.758 C 4.413 7.593 4.32 7.365 4.32 7.131 Z M 6.537 7.68 L 10.83 11.97 C 10.965 12.105 11.04 12.288 11.04 12.48 V 15.543 L 12.96 17.463 V 12.48 C 12.96 12.288 13.035 12.105 13.17 11.97 L 17.46 7.68 H 6.537 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function gv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M6.87493 0.937491C6.87493 0.417965 6.45697 0 5.93744 0C5.41791 0 4.99995 0.417965 4.99995 0.937491V2.49997C3.62106 2.49997 2.49997 3.62106 2.49997 4.99995H0.937491C0.417965 4.99995 0 5.41791 0 5.93744C0 6.45697 0.417965 6.87493 0.937491 6.87493H2.49997V9.06241H0.937491C0.417965 9.06241 0 9.48037 0 9.9999C0 10.5194 0.417965 10.9374 0.937491 10.9374H2.49997V13.1249H0.937491C0.417965 13.1249 0 13.5428 0 14.0624C0 14.5819 0.417965 14.9998 0.937491 14.9998H2.49997C2.49997 16.3787 3.62106 17.4998 4.99995 17.4998V19.0623C4.99995 19.5818 5.41791 19.9998 5.93744 19.9998C6.45697 19.9998 6.87493 19.5818 6.87493 19.0623V17.4998H9.06241V19.0623C9.06241 19.5818 9.48037 19.9998 9.9999 19.9998C10.5194 19.9998 10.9374 19.5818 10.9374 19.0623V17.4998H13.1249V19.0623C13.1249 19.5818 13.5428 19.9998 14.0624 19.9998C14.5819 19.9998 14.9998 19.5818 14.9998 19.0623V17.4998C16.3787 17.4998 17.4998 16.3787 17.4998 14.9998H19.0623C19.5818 14.9998 19.9998 14.5819 19.9998 14.0624C19.9998 13.5428 19.5818 13.1249 19.0623 13.1249H17.4998V10.9374H19.0623C19.5818 10.9374 19.9998 10.5194 19.9998 9.9999C19.9998 9.48037 19.5818 9.06241 19.0623 9.06241H17.4998V6.87493H19.0623C19.5818 6.87493 19.9998 6.45697 19.9998 5.93744C19.9998 5.41791 19.5818 4.99995 19.0623 4.99995H17.4998C17.4998 3.62106 16.3787 2.49997 14.9998 2.49997V0.937491C14.9998 0.417965 14.5819 0 14.0624 0C13.5428 0 13.1249 0.417965 13.1249 0.937491V2.49997H10.9374V0.937491C10.9374 0.417965 10.5194 0 9.9999 0C9.48037 0 9.06241 0.417965 9.06241 0.937491V2.49997H6.87493V0.937491ZM15.6248 4.99995V14.9998C15.6248 15.3436 15.3436 15.6248 14.9998 15.6248H4.99995C4.6562 15.6248 4.37496 15.3436 4.37496 14.9998V4.99995C4.37496 4.6562 4.6562 4.37496 4.99995 4.37496H14.9998C15.3436 4.37496 15.6248 4.6562 15.6248 4.99995ZM7.49992 6.24994C6.80852 6.24994 6.24994 6.80852 6.24994 7.49992V12.4999C6.24994 13.1913 6.80852 13.7499 7.49992 13.7499H12.4999C13.1913 13.7499 13.7499 13.1913 13.7499 12.4999V7.49992C13.7499 6.80852 13.1913 6.24994 12.4999 6.24994H7.49992ZM8.12492 8.12492H11.8749V11.8749H8.12492V8.12492Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function hv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.378 2.2403 C 11.734 1.9199 12.273 1.9199 12.628 2.2403 L 21.688 10.3661 C 22.075 10.7098 22.106 11.3036 21.759 11.6904 C 21.411 12.0772 20.821 12.1084 20.435 11.7607 L 20.122 11.4794 V 19.4998 C 20.122 20.8788 19.001 22 17.623 22 H 6.376 C 4.997 22 3.876 20.8788 3.876 19.4998 V 11.4794 L 3.564 11.7607 C 3.177 12.1045 2.588 12.0732 2.24 11.6904 C 1.893 11.3075 1.928 10.7137 2.31 10.3661 L 11.378 2.2403 Z M 12.003 4.1975 L 5.755 9.8035 V 19.5037 C 5.755 19.8474 6.036 20.1287 6.38 20.1287 H 8.254 V 16.0658 C 8.254 14.511 9.512 13.2531 11.066 13.2531 H 12.94 C 14.495 13.2531 15.752 14.511 15.752 16.0658 V 20.1287 H 17.627 C 17.97 20.1287 18.252 19.8474 18.252 19.5037 V 9.8035 L 12.003 4.2014 V 4.1975 Z M 10.129 20.1287 H 13.878 V 16.0658 C 13.878 15.5462 13.46 15.1282 12.94 15.1282 H 11.066 C 10.547 15.1282 10.129 15.5462 10.129 16.0658 V 20.1287 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function bv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.5 5.375 C 19.844 5.375 20.125 5.6562 20.125 6 V 18.4922 L 19.93 18.2383 L 14.617 11.3633 C 14.441 11.1328 14.164 11 13.875 11 C 13.586 11 13.312 11.1328 13.133 11.3633 L 9.891 15.5586 L 8.699 13.8906 C 8.523 13.6445 8.242 13.5 7.938 13.5 C 7.633 13.5 7.352 13.6445 7.176 13.8945 L 4.051 18.2695 L 3.875 18.5117 V 18.5 V 6 C 3.875 5.6562 4.156 5.375 4.5 5.375 H 19.5 Z M 4.5 3.5 C 3.121 3.5 2 4.6211 2 6 V 18.5 C 2 19.8789 3.121 21 4.5 21 H 19.5 C 20.879 21 22 19.8789 22 18.5 V 6 C 22 4.6211 20.879 3.5 19.5 3.5 H 4.5 Z M 7.625 11 C 7.871 11 8.115 10.9515 8.343 10.8573 C 8.57 10.763 8.777 10.6249 8.951 10.4508 C 9.125 10.2767 9.263 10.07 9.357 9.8425 C 9.452 9.615 9.5 9.3712 9.5 9.125 C 9.5 8.8788 9.452 8.635 9.357 8.4075 C 9.263 8.18 9.125 7.9733 8.951 7.7992 C 8.777 7.6251 8.57 7.487 8.343 7.3927 C 8.115 7.2985 7.871 7.25 7.625 7.25 C 7.379 7.25 7.135 7.2985 6.907 7.3927 C 6.68 7.487 6.473 7.6251 6.299 7.7992 C 6.125 7.9733 5.987 8.18 5.893 8.4075 C 5.798 8.635 5.75 8.8788 5.75 9.125 C 5.75 9.3712 5.798 9.615 5.893 9.8425 C 5.987 10.07 6.125 10.2767 6.299 10.4508 C 6.473 10.6249 6.68 10.763 6.907 10.8573 C 7.135 10.9515 7.379 11 7.625 11 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function vv(t) {
  const e = B.c(13), n = At();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 9.12 5.5198 C 9.519 5.5198 9.84 5.8408 9.84 6.2398 C 9.84 6.6388 9.519 6.9598 9.12 6.9598 C 8.721 6.9598 8.4 6.6388 8.4 6.2398 C 8.4 5.8408 8.721 5.5198 9.12 5.5198 Z M 9.12 8.1598 C 9.153 8.1598 9.186 8.1598 9.219 8.1568 L 10.026 9.8848 C 9.087 10.5358 8.415 11.5468 8.22 12.7198 H 6.102 C 5.817 12.0148 5.127 11.5198 4.323 11.5198 C 3.264 11.5198 2.403 12.3808 2.403 13.4398 C 2.403 14.4988 3.264 15.3598 4.323 15.3598 C 5.13 15.3598 5.82 14.8648 6.102 14.1598 H 8.22 C 8.562 16.2028 10.341 17.7598 12.48 17.7598 C 13.794 17.7598 14.97 17.1748 15.762 16.2478 L 17.784 17.4598 C 17.769 17.5558 17.76 17.6578 17.76 17.7568 C 17.76 18.8158 18.621 19.6768 19.68 19.6768 C 20.739 19.6768 21.6 18.8158 21.6 17.7568 C 21.6 16.6978 20.739 15.8368 19.68 15.8368 C 19.245 15.8368 18.846 15.9808 18.525 16.2238 L 16.506 15.0118 C 16.698 14.5228 16.803 13.9918 16.803 13.4368 C 16.803 12.7408 16.638 12.0808 16.344 11.4988 L 18.672 9.7918 C 18.966 9.9748 19.311 10.0798 19.683 10.0798 C 20.742 10.0798 21.603 9.2188 21.603 8.1598 C 21.603 7.1008 20.742 6.2398 19.683 6.2398 C 18.624 6.2398 17.763 7.1008 17.763 8.1598 C 17.763 8.3218 17.784 8.4808 17.82 8.6308 L 15.492 10.3378 C 14.715 9.5818 13.653 9.1168 12.483 9.1168 C 12.084 9.1168 11.7 9.1708 11.334 9.2728 L 10.527 7.5478 C 10.845 7.2058 11.04 6.7468 11.04 6.2398 C 11.04 5.1808 10.179 4.3198 9.12 4.3198 C 8.061 4.3198 7.2 5.1808 7.2 6.2398 C 7.2 7.2988 8.061 8.1598 9.12 8.1598 Z M 19.68 7.4398 C 20.079 7.4398 20.4 7.7608 20.4 8.1598 C 20.4 8.5588 20.079 8.8798 19.68 8.8798 C 19.281 8.8798 18.96 8.5588 18.96 8.1598 C 18.96 7.7608 19.281 7.4398 19.68 7.4398 Z M 18.96 17.7598 C 18.96 17.3608 19.281 17.0398 19.68 17.0398 C 20.079 17.0398 20.4 17.3608 20.4 17.7598 C 20.4 18.1588 20.079 18.4798 19.68 18.4798 C 19.281 18.4798 18.96 18.1588 18.96 17.7598 Z M 4.32 12.7198 C 4.719 12.7198 5.04 13.0408 5.04 13.4398 C 5.04 13.8388 4.719 14.1598 4.32 14.1598 C 3.921 14.1598 3.6 13.8388 3.6 13.4398 C 3.6 13.0408 3.921 12.7198 4.32 12.7198 Z M 12.48 10.5598 C 14.07 10.5598 15.36 11.8498 15.36 13.4398 C 15.36 15.0298 14.07 16.3198 12.48 16.3198 C 10.89 16.3198 9.6 15.0298 9.6 13.4398 C 9.6 11.8498 10.89 10.5598 12.48 10.5598 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function yv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M0.91935 0C0.409877 0 0 0.409877 0 0.91935V2.75805C0 3.26752 0.409877 3.6774 0.91935 3.6774H2.75805C3.26752 3.6774 3.6774 3.26752 3.6774 2.75805V0.91935C3.6774 0.409877 3.26752 0 2.75805 0H0.91935ZM6.43545 0.91935C5.92598 0.91935 5.5161 1.32923 5.5161 1.8387C5.5161 2.34817 5.92598 2.75805 6.43545 2.75805H18.0806C18.59 2.75805 18.9999 2.34817 18.9999 1.8387C18.9999 1.32923 18.59 0.91935 18.0806 0.91935H6.43545ZM6.43545 7.04835C5.92598 7.04835 5.5161 7.45823 5.5161 7.9677C5.5161 8.47717 5.92598 8.88705 6.43545 8.88705H18.0806C18.59 8.88705 18.9999 8.47717 18.9999 7.9677C18.9999 7.45823 18.59 7.04835 18.0806 7.04835H6.43545ZM6.43545 13.1774C5.92598 13.1774 5.5161 13.5872 5.5161 14.0967C5.5161 14.6062 5.92598 15.0161 6.43545 15.0161H18.0806C18.59 15.0161 18.9999 14.6062 18.9999 14.0967C18.9999 13.5872 18.59 13.1774 18.0806 13.1774H6.43545ZM0 7.04835V8.88705C0 9.39652 0.409877 9.8064 0.91935 9.8064H2.75805C3.26752 9.8064 3.6774 9.39652 3.6774 8.88705V7.04835C3.6774 6.53888 3.26752 6.129 2.75805 6.129H0.91935C0.409877 6.129 0 6.53888 0 7.04835ZM0.91935 12.258C0.409877 12.258 0 12.6679 0 13.1774V15.0161C0 15.5255 0.409877 15.9354 0.91935 15.9354H2.75805C3.26752 15.9354 3.6774 15.5255 3.6774 15.0161V13.1774C3.6774 12.6679 3.26752 12.258 2.75805 12.258H0.91935Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function xv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.6 9.4725 C 6.6 10.5263 6.941 11.76 7.56 13.0913 C 8.171 14.4075 9 15.72 9.859 16.8975 C 10.62 17.9475 11.389 18.8663 12.004 19.5638 C 12.619 18.8663 13.384 17.9475 14.149 16.8975 C 15.007 15.72 15.836 14.4075 16.447 13.0913 C 17.062 11.76 17.407 10.5263 17.407 9.4725 C 17.407 6.5925 15.019 4.2 12.007 4.2 C 8.996 4.2 6.6 6.5888 6.6 9.4725 Z M 19.2 9.4725 C 19.2 13.6425 15.289 18.5775 13.234 20.8875 C 12.851 21.3188 12.532 21.6563 12.315 21.8813 C 12.116 22.0875 12 22.2 12 22.2 C 12 22.2 11.887 22.0875 11.685 21.8813 C 11.467 21.6563 11.149 21.315 10.766 20.8875 C 8.711 18.5775 4.8 13.6425 4.8 9.4725 C 4.8 5.565 8.025 2.4 12 2.4 C 15.975 2.4 19.2 5.565 19.2 9.4725 Z M 13.2 9.6 C 13.2 9.2818 13.073 8.9765 12.848 8.7515 C 12.623 8.5265 12.318 8.4 12 8.4 C 11.682 8.4 11.376 8.5265 11.151 8.7515 C 10.926 8.9765 10.8 9.2818 10.8 9.6 C 10.8 9.9183 10.926 10.2235 11.151 10.4486 C 11.376 10.6736 11.682 10.8 12 10.8 C 12.318 10.8 12.623 10.6736 12.848 10.4486 C 13.073 10.2235 13.2 9.9183 13.2 9.6 Z M 9 9.6 C 9 8.8044 9.316 8.0413 9.878 7.4787 C 10.441 6.9161 11.204 6.6 12 6.6 C 12.795 6.6 13.559 6.9161 14.121 7.4787 C 14.684 8.0413 15 8.8044 15 9.6 C 15 10.3957 14.684 11.1587 14.121 11.7213 C 13.559 12.284 12.795 12.6 12 12.6 C 11.204 12.6 10.441 12.284 9.878 11.7213 C 9.316 11.1587 9 10.3957 9 9.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Cv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.378 8.5091 C 9.378 5.1346 12.113 2.4 15.487 2.4 C 16.473 2.4 17.407 2.6328 18.233 3.0509 C 18.484 3.1782 18.658 3.4146 18.702 3.6909 C 18.745 3.9673 18.654 4.2473 18.458 4.4473 L 15.778 7.1273 V 8.2218 H 16.873 L 19.553 5.5418 C 19.749 5.3455 20.033 5.2546 20.309 5.2982 C 20.585 5.3418 20.825 5.5164 20.949 5.7673 C 21.364 6.5928 21.6 7.5273 21.6 8.5128 C 21.6 11.8873 18.865 14.6218 15.491 14.6218 C 14.887 14.6218 14.302 14.5346 13.749 14.3709 L 7.364 20.7491 C 6.229 21.8837 4.385 21.8837 3.251 20.7491 C 2.116 19.6146 2.116 17.7709 3.251 16.6364 L 9.629 10.2509 C 9.465 9.6982 9.378 9.1128 9.378 8.5091 Z M 15.487 4.1455 C 13.076 4.1455 11.124 6.0982 11.124 8.5091 C 11.124 9.0909 11.236 9.6473 11.444 10.1528 C 11.574 10.4764 11.502 10.8509 11.251 11.0982 L 4.48 17.8691 C 4.025 18.3237 4.025 19.0618 4.48 19.5164 C 4.934 19.9709 5.673 19.9709 6.127 19.5164 L 12.898 12.7455 C 13.145 12.4982 13.52 12.4218 13.844 12.5528 C 14.349 12.76 14.905 12.8728 15.487 12.8728 C 17.898 12.8728 19.851 10.92 19.851 8.5091 C 19.851 8.2582 19.829 8.0109 19.789 7.7709 L 17.851 9.7091 C 17.687 9.8728 17.465 9.9637 17.233 9.9637 H 14.905 C 14.422 9.9637 14.033 9.5746 14.033 9.0909 V 6.7637 C 14.033 6.5309 14.124 6.3091 14.287 6.1455 L 16.225 4.2073 C 15.985 4.1673 15.738 4.1455 15.487 4.1455 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function wv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Sv(t) {
  const e = B.c(13), n = At();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 15.12 5.76 C 15.12 6.024 14.904 6.24 14.64 6.24 H 12.48 V 8.16 H 15.84 C 16.899 8.16 17.76 9.021 17.76 10.08 V 10.581 C 17.445 10.554 17.115 10.554 16.8 10.581 V 10.08 C 16.8 9.549 16.371 9.12 15.84 9.12 H 8.16 C 7.629 9.12 7.2 9.549 7.2 10.08 V 13.92 C 7.2 14.451 7.629 14.88 8.16 14.88 H 9.12 C 9.27 14.88 9.414 14.952 9.504 15.072 L 10.512 16.416 C 10.692 16.659 10.977 16.8 11.28 16.8 H 11.541 C 11.568 17.13 11.622 17.448 11.703 17.76 H 11.283 C 10.68 17.76 10.11 17.475 9.747 16.992 L 8.88 15.84 H 8.16 C 7.101 15.84 6.24 14.979 6.24 13.92 V 12.48 H 5.28 V 14.88 C 5.28 15.144 5.064 15.36 4.8 15.36 C 4.536 15.36 4.32 15.144 4.32 14.88 V 9.12 C 4.32 8.856 4.536 8.64 4.8 8.64 C 5.064 8.64 5.28 8.856 5.28 9.12 V 11.52 H 6.24 V 10.08 C 6.24 9.021 7.101 8.16 8.16 8.16 H 11.52 V 6.24 H 9.36 C 9.096 6.24 8.88 6.024 8.88 5.76 C 8.88 5.496 9.096 5.28 9.36 5.28 H 14.64 C 14.904 5.28 15.12 5.496 15.12 5.76 Z M 18.72 10.74 V 9.6 C 18.72 9.336 18.936 9.12 19.2 9.12 C 19.464 9.12 19.68 9.336 19.68 9.6 V 11.082 C 19.374 10.941 19.053 10.827 18.72 10.74 Z M 14.4 11.04 C 14.523 11.04 14.634 11.085 14.718 11.16 C 14.265 11.385 13.845 11.67 13.47 12 H 9.6 C 9.336 12 9.12 11.784 9.12 11.52 C 9.12 11.256 9.336 11.04 9.6 11.04 H 14.4 Z M 20.64 16.32 C 20.64 14.463 19.137 12.96 17.28 12.96 C 15.423 12.96 13.92 14.463 13.92 16.32 C 13.92 18.177 15.423 19.68 17.28 19.68 C 19.137 19.68 20.64 18.177 20.64 16.32 Z M 12.96 16.32 C 12.96 13.935 14.895 12 17.28 12 C 19.665 12 21.6 13.935 21.6 16.32 C 21.6 18.705 19.665 20.64 17.28 20.64 C 14.895 20.64 12.96 18.705 12.96 16.32 Z M 17.28 17.64 C 17.61 17.64 17.88 17.91 17.88 18.24 C 17.88 18.57 17.61 18.84 17.28 18.84 C 16.95 18.84 16.68 18.57 16.68 18.24 C 16.68 17.91 16.95 17.64 17.28 17.64 Z M 17.28 13.92 C 17.544 13.92 17.76 14.136 17.76 14.4 V 16.32 C 17.76 16.584 17.544 16.8 17.28 16.8 C 17.016 16.8 16.8 16.584 16.8 16.32 V 14.4 C 16.8 14.136 17.016 13.92 17.28 13.92 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function Rv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 4.3199 C 11.601 4.3199 11.28 4.6409 11.28 5.0399 V 5.3309 C 8.838 5.6789 6.96 7.7819 6.96 10.3199 V 10.7549 C 6.96 11.8859 6.66 12.9959 6.09 13.9739 L 5.433 15.0959 C 5.334 15.2699 5.28 15.4649 5.28 15.6659 C 5.28 16.2929 5.787 16.7999 6.414 16.7999 H 17.586 C 18.213 16.7999 18.72 16.2929 18.72 15.6659 C 18.72 15.4649 18.666 15.2669 18.567 15.0959 L 17.91 13.9709 C 17.34 12.9929 17.04 11.8829 17.04 10.7519 V 10.3169 C 17.04 7.7789 15.162 5.6759 12.72 5.3279 V 5.0369 C 12.72 4.6379 12.399 4.3169 12 4.3169 V 4.3199 Z M 17.052 15.3599 H 6.945 L 7.332 14.6969 C 8.031 13.4999 8.4 12.1379 8.4 10.7549 V 10.3199 C 8.4 8.3309 10.011 6.7199 12 6.7199 C 13.989 6.7199 15.6 8.3309 15.6 10.3199 V 10.7549 C 15.6 12.1409 15.969 13.4999 16.665 14.6969 L 17.052 15.3599 Z M 9.963 18.2399 C 10.26 19.0799 11.061 19.6799 12 19.6799 C 12.939 19.6799 13.74 19.0799 14.037 18.2399 H 9.963 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Ev(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.6 1 C 8.936 1 8.4 1.5462 8.4 2.2222 C 8.4 2.6729 8.64 3.0701 9 3.2802 V 7.9285 C 7.208 8.9865 6 10.9573 6 13.2222 V 19.6389 C 6 21.4951 7.478 23 9.3 23 H 14.7 C 16.523 23 18 21.4951 18 19.6389 V 13.2222 C 18 10.9573 16.793 8.9865 15 7.9285 V 3.2802 C 15.36 3.0701 15.6 2.6729 15.6 2.2222 C 15.6 1.5462 15.064 1 14.4 1 H 9.6 Z M 10.8 3.4444 H 13.2 V 8.4861 C 13.2 8.8451 13.406 9.1736 13.729 9.3226 C 15.188 9.9948 16.2 11.4882 16.2 13.2222 V 19.6389 C 16.2 20.483 15.529 21.1667 14.7 21.1667 H 9.3 C 8.471 21.1667 7.8 20.483 7.8 19.6389 V 13.2222 C 7.8 11.4882 8.812 9.9948 10.271 9.3226 C 10.594 9.1736 10.8 8.849 10.8 8.4861 V 3.4444 Z M 14.4 15.6667 C 14.4 14.8569 13.316 13.2031 12.604 12.2062 C 12.3 11.7823 11.696 11.7823 11.393 12.2062 C 10.68 13.2031 9.596 14.8569 9.596 15.6667 C 9.596 16.8736 10.673 18.1111 11.996 18.1111 C 13.32 18.1111 14.396 16.8736 14.396 15.6667 H 14.4 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Nv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.212 2.7115 C 13.212 2.0401 12.671 1.5 12 1.5 C 11.329 1.5 10.788 2.0401 10.788 2.7115 V 10.7885 H 2.712 C 2.04 10.7885 1.5 11.3286 1.5 12 C 1.5 12.6714 2.04 13.2115 2.712 13.2115 H 10.788 V 21.2885 C 10.788 21.9599 11.329 22.5 12 22.5 C 12.671 22.5 13.212 21.9599 13.212 21.2885 V 13.2115 H 21.288 C 21.96 13.2115 22.5 12.6714 22.5 12 C 22.5 11.3286 21.96 10.7885 21.288 10.7885 H 13.212 V 2.7115 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function kv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.19979 5.27982V4.31982H5.27979V19.6798H7.19979V15.0718L9.08079 14.5078C10.3378 14.1298 11.6938 14.2468 12.8668 14.8348C14.1478 15.4768 15.6418 15.5548 16.9828 15.0508L18.7198 14.3998V4.79982L17.0218 5.64882C15.6748 6.32382 14.0878 6.32382 12.7378 5.64882C11.6458 5.10282 10.3888 4.99482 9.22178 5.34582L7.19979 5.95182V5.27982Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Iv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.199 10.2018 C 16.199 6.8871 13.514 4.2024 10.199 4.2024 C 6.884 4.2024 4.2 6.8871 4.2 10.2018 C 4.2 13.5165 6.884 16.2012 10.199 16.2012 C 13.514 16.2012 16.199 13.5165 16.199 10.2018 Z M 15.04 16.3175 C 13.713 17.3711 12.029 18.0011 10.199 18.0011 C 5.891 18.0011 2.4 14.5102 2.4 10.2018 C 2.4 5.8935 5.891 2.4026 10.199 2.4026 C 14.507 2.4026 17.998 5.8935 17.998 10.2018 C 17.998 12.0316 17.368 13.7152 16.315 15.0426 L 21.336 20.0634 C 21.688 20.4158 21.688 20.9858 21.336 21.3345 C 20.983 21.6832 20.413 21.687 20.064 21.3345 L 15.04 16.3175 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Pv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.485 7.1008 L 10.896 5.2798 H 13.104 L 13.515 7.1008 C 13.566 7.3228 13.719 7.5088 13.929 7.6018 C 14.253 7.7458 14.559 7.9228 14.841 8.1298 C 15.024 8.2648 15.264 8.3068 15.483 8.2378 L 17.268 7.6828 L 18.372 9.5968 L 16.998 10.8658 C 16.83 11.0218 16.746 11.2468 16.77 11.4718 C 16.809 11.8168 16.809 12.1828 16.77 12.5278 C 16.746 12.7558 16.83 12.9808 16.998 13.1338 L 18.372 14.4028 L 17.268 16.3168 L 15.483 15.7618 C 15.264 15.6928 15.027 15.7348 14.841 15.8698 C 14.559 16.0768 14.253 16.2568 13.929 16.3978 C 13.719 16.4908 13.566 16.6768 13.515 16.8988 L 13.104 18.7198 H 10.896 L 10.485 16.8988 C 10.434 16.6768 10.281 16.4908 10.071 16.3978 C 9.747 16.2538 9.441 16.0768 9.159 15.8698 C 8.976 15.7348 8.736 15.6928 8.517 15.7618 L 6.732 16.3168 L 5.628 14.4028 L 7.002 13.1338 C 7.17 12.9778 7.254 12.7528 7.23 12.5278 C 7.191 12.1828 7.191 11.8168 7.23 11.4718 C 7.254 11.2438 7.17 11.0188 7.002 10.8658 L 5.628 9.5968 L 6.732 7.6828 L 8.517 8.2378 C 8.736 8.3068 8.973 8.2648 9.159 8.1298 C 9.441 7.9228 9.747 7.7428 10.071 7.6018 C 10.281 7.5088 10.434 7.3228 10.485 7.1008 Z M 10.704 3.8398 C 10.143 3.8398 9.657 4.2298 9.534 4.7758 L 9.156 6.4438 C 8.967 6.5398 8.787 6.6448 8.61 6.7588 L 6.978 6.2518 C 6.441 6.0838 5.862 6.3118 5.583 6.7978 L 4.287 9.0418 C 4.008 9.5278 4.101 10.1428 4.512 10.5238 L 5.769 11.6848 C 5.76 11.8918 5.76 12.1048 5.769 12.3148 L 4.512 13.4758 C 4.101 13.8568 4.005 14.4718 4.287 14.9578 L 5.583 17.2018 C 5.862 17.6878 6.444 17.9128 6.978 17.7478 L 8.613 17.2408 C 8.79 17.3548 8.97 17.4598 9.159 17.5558 L 9.537 19.2238 C 9.66 19.7698 10.146 20.1598 10.707 20.1598 H 13.299 C 13.86 20.1598 14.346 19.7698 14.469 19.2238 L 14.847 17.5558 C 15.036 17.4598 15.216 17.3548 15.393 17.2408 L 17.028 17.7478 C 17.565 17.9158 18.144 17.6878 18.423 17.2018 L 19.719 14.9578 C 19.998 14.4718 19.905 13.8568 19.494 13.4758 L 18.237 12.3148 C 18.246 12.1078 18.246 11.8948 18.237 11.6848 L 19.494 10.5238 C 19.905 10.1428 19.998 9.5278 19.719 9.0418 L 18.42 6.7978 C 18.138 6.3118 17.559 6.0868 17.025 6.2518 L 15.39 6.7588 C 15.213 6.6448 15.033 6.5398 14.844 6.4438 L 14.469 4.7758 C 14.343 4.2298 13.857 3.8398 13.296 3.8398 H 10.704 Z M 13.44 11.9998 C 13.44 12.7948 12.795 13.4398 12 13.4398 C 11.205 13.4398 10.56 12.7948 10.56 11.9998 C 10.56 11.2048 11.205 10.5598 12 10.5598 C 12.795 10.5598 13.44 11.2048 13.44 11.9998 Z M 12 9.1198 C 10.41 9.1198 9.12 10.4098 9.12 11.9998 C 9.12 13.5898 10.41 14.8798 12 14.8798 C 13.59 14.8798 14.88 13.5898 14.88 11.9998 C 14.88 10.4098 13.59 9.1198 12 9.1198 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Mv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.539 7.8393 C 13.187 8.1918 12.617 8.1918 12.268 7.8393 C 11.919 7.4868 11.916 6.9168 12.268 6.5681 L 16.164 2.6643 C 16.517 2.3118 17.087 2.3118 17.436 2.6643 L 21.336 6.5643 C 21.688 6.9168 21.688 7.4868 21.336 7.8356 C 20.983 8.1843 20.413 8.1881 20.064 7.8356 L 17.702 5.4731 V 20.7018 C 17.702 21.2006 17.301 21.6018 16.802 21.6018 C 16.303 21.6018 15.902 21.2006 15.902 20.7018 V 5.4731 L 13.539 7.8356 V 7.8393 Z M 3.939 16.1643 L 6.302 18.5268 V 3.2981 C 6.302 2.7993 6.703 2.3981 7.202 2.3981 C 7.701 2.3981 8.102 2.7993 8.102 3.2981 V 18.5268 L 10.464 16.1643 C 10.817 15.8118 11.387 15.8118 11.736 16.1643 C 12.084 16.5168 12.088 17.0868 11.736 17.4356 L 7.836 21.3356 C 7.483 21.6881 6.913 21.6881 6.564 21.3356 L 2.664 17.4393 C 2.312 17.0868 2.312 16.5168 2.664 16.1681 C 3.017 15.8193 3.587 15.8156 3.936 16.1681 L 3.939 16.1643 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Tv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Ov(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.781 3.4736 C 12.632 3.1844 12.33 3 12.003 3 C 11.676 3 11.374 3.1844 11.225 3.4736 L 8.55 8.6862 L 2.737 9.6044 C 2.414 9.655 2.145 9.8828 2.043 10.1936 C 1.941 10.5045 2.025 10.8443 2.254 11.0757 L 6.412 15.2147 L 5.496 20.9949 C 5.445 21.3167 5.58 21.642 5.845 21.8336 C 6.111 22.0252 6.46 22.0541 6.754 21.9059 L 12.003 19.2526 L 17.249 21.9059 C 17.54 22.0541 17.892 22.0252 18.158 21.8336 C 18.423 21.642 18.558 21.3203 18.507 20.9949 L 17.587 15.2147 L 21.746 11.0757 C 21.978 10.8443 22.058 10.5045 21.957 10.1936 C 21.855 9.8828 21.589 9.655 21.262 9.6044 L 15.453 8.6862 L 12.781 3.4736 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Dv(t) {
  const e = B.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.199 11.3999 C 19.531 11.3998 19.799 11.6684 19.799 11.9997 L 19.8 15.9268 C 19.8 16.0859 19.737 16.2385 19.624 16.3511 C 19.512 16.4637 19.359 16.5269 19.2 16.5269 L 15.272 16.5268 C 14.941 16.5268 14.672 16.2581 14.672 15.9268 C 14.672 15.5954 14.941 15.3268 15.272 15.3268 L 18.6 15.3269 L 18.599 12 C 18.599 11.6686 18.868 11.4 19.199 11.3999 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 4.375 7.6474 C 4.61 7.4131 4.99 7.4131 5.224 7.6474 L 9.709 12.1324 L 12.557 9.2843 C 12.791 9.05 13.171 9.05 13.405 9.2843 L 19.624 15.502 C 19.858 15.7363 19.858 16.1162 19.624 16.3505 C 19.39 16.5848 19.01 16.5849 18.775 16.3506 L 12.981 10.5571 L 10.133 13.4052 C 9.899 13.6395 9.519 13.6395 9.285 13.4052 L 4.375 8.4959 C 4.141 8.2616 4.141 7.8817 4.375 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function _v(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M19.1454 10.5575C19.4514 10.2514 19.4514 9.75637 19.1454 9.45351L14.7188 5.02131C14.4128 4.71519 13.9181 4.71519 13.6154 5.02131C13.3127 5.32743 13.3094 5.82243 13.6154 6.12529L16.7075 9.21903H1.40627C0.973369 9.21903 0.625095 9.56749 0.625095 10.0006C0.625095 10.4337 0.973369 10.7822 1.40627 10.7822H16.7075L13.6154 13.8759C13.3094 14.1821 13.3094 14.677 13.6154 14.9799C13.9213 15.2828 14.4161 15.286 14.7188 14.9799L19.1454 10.5575Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Vv(t) {
  const e = B.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 14.673 8.0727 C 14.673 7.7413 14.941 7.4727 15.273 7.4727 H 19.2 C 19.531 7.4727 19.8 7.7413 19.8 8.0726 V 11.9996 C 19.8 12.3309 19.531 12.5996 19.2 12.5996 C 18.868 12.5996 18.6 12.3309 18.6 11.9996 V 8.6727 H 15.273 C 14.941 8.6727 14.673 8.404 14.673 8.0727 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.624 7.6474 C 19.858 7.8817 19.858 8.2616 19.624 8.4959 L 13.405 14.7144 C 13.293 14.8269 13.14 14.8901 12.981 14.8901 C 12.822 14.8901 12.669 14.8268 12.557 14.7144 L 9.709 11.8656 L 5.224 16.3505 C 4.99 16.5848 4.61 16.5848 4.375 16.3505 C 4.141 16.1162 4.141 15.7363 4.375 15.502 L 9.285 10.5928 C 9.397 10.4803 9.55 10.417 9.709 10.4171 C 9.868 10.4171 10.021 10.4803 10.133 10.5928 L 12.981 13.4416 L 18.775 7.6474 C 19.01 7.4131 19.39 7.4131 19.624 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function Av(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.72 14.1599 C 12.72 14.5589 12.399 14.8799 12 14.8799 C 11.601 14.8799 11.28 14.5589 11.28 14.1599 V 6.7769 L 9.39 8.6669 C 9.108 8.9489 8.652 8.9489 8.373 8.6669 C 8.094 8.3849 8.091 7.9289 8.373 7.6499 L 11.49 4.5299 C 11.772 4.2479 12.228 4.2479 12.507 4.5299 L 15.63 7.6499 C 15.912 7.9319 15.912 8.3879 15.63 8.6669 C 15.348 8.9459 14.892 8.9489 14.613 8.6669 L 12.723 6.7769 V 14.1599 H 12.72 Z M 9.84 13.9199 H 7.2 C 6.936 13.9199 6.72 14.1359 6.72 14.3999 V 16.7999 C 6.72 17.0639 6.936 17.2799 7.2 17.2799 H 16.8 C 17.064 17.2799 17.28 17.0639 17.28 16.7999 V 14.3999 C 17.28 14.1359 17.064 13.9199 16.8 13.9199 H 14.16 V 12.4799 H 16.8 C 17.859 12.4799 18.72 13.3409 18.72 14.3999 V 16.7999 C 18.72 17.8589 17.859 18.7199 16.8 18.7199 H 7.2 C 6.141 18.7199 5.28 17.8589 5.28 16.7999 V 14.3999 C 5.28 13.3409 6.141 12.4799 7.2 12.4799 H 9.84 V 13.9199 Z M 14.88 15.5999 C 14.88 15.2009 15.201 14.8799 15.6 14.8799 C 15.999 14.8799 16.32 15.2009 16.32 15.5999 C 16.32 15.9989 15.999 16.3199 15.6 16.3199 C 15.201 16.3199 14.88 15.9989 14.88 15.5999 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Lv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M5.78571 5C5.78571 4.1712 6.12436 3.37634 6.72716 2.79029C7.32995 2.20424 8.14752 1.875 9 1.875C9.85248 1.875 10.67 2.20424 11.2728 2.79029C11.8756 3.37634 12.2143 4.1712 12.2143 5C12.2143 5.8288 11.8756 6.62366 11.2728 7.20971C10.67 7.79576 9.85248 8.125 9 8.125C8.14752 8.125 7.32995 7.79576 6.72716 7.20971C6.12436 6.62366 5.78571 5.8288 5.78571 5ZM14.1429 5C14.1429 3.67392 13.601 2.40215 12.6365 1.46447C11.6721 0.526784 10.364 0 9 0C7.63603 0 6.32792 0.526784 5.36345 1.46447C4.39898 2.40215 3.85714 3.67392 3.85714 5C3.85714 6.32608 4.39898 7.59785 5.36345 8.53553C6.32792 9.47322 7.63603 10 9 10C10.364 10 11.6721 9.47322 12.6365 8.53553C13.601 7.59785 14.1429 6.32608 14.1429 5ZM1.92857 18.75C1.92857 15.9883 4.2308 13.75 7.07143 13.75H10.9286C13.7692 13.75 16.0714 15.9883 16.0714 18.75V19.0625C16.0714 19.582 16.5013 20 17.0357 20C17.5701 20 18 19.582 18 19.0625V18.75C18 14.9531 14.8339 11.875 10.9286 11.875H7.07143C3.16607 11.875 0 14.9531 0 18.75V19.0625C0 19.582 0.429911 20 0.964286 20C1.49866 20 1.92857 19.582 1.92857 19.0625V18.75Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Fv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.103 3.2971 C 15.44 3.2971 19.037 6.4723 19.697 10.6231 C 19.353 10.7931 19.047 11.0446 18.806 11.3778 L 18.167 12.2515 C 18.17 12.1665 18.174 12.0849 18.174 11.9999 C 18.174 8.0938 15.009 4.9289 11.103 4.9289 C 7.197 4.9289 4.032 8.0938 4.032 11.9999 C 4.032 15.9059 7.197 19.0709 11.103 19.0709 C 12.33 19.0709 13.482 18.7581 14.485 18.2108 L 15.542 19.3055 C 15.58 19.3428 15.621 19.3802 15.661 19.4142 C 14.336 20.2301 12.775 20.7027 11.103 20.7027 C 6.296 20.7027 2.4 16.8068 2.4 11.9999 C 2.4 7.193 6.296 3.2971 11.103 3.2971 Z M 20.125 12.3364 C 20.39 11.9727 20.9 11.8911 21.264 12.1563 C 21.628 12.4214 21.709 12.9314 21.444 13.2951 L 17.963 18.0816 C 17.82 18.2754 17.599 18.4012 17.361 18.4148 C 17.123 18.4284 16.885 18.34 16.719 18.1666 L 15.141 16.5348 C 14.829 16.2119 14.835 15.6952 15.162 15.3824 C 15.488 15.0697 16.001 15.0799 16.314 15.4028 L 17.215 16.3343 L 20.125 12.333 V 12.3364 Z M 11.103 16.3513 C 10.501 16.3513 10.015 15.8651 10.015 15.2634 C 10.015 14.6617 10.501 14.1756 11.103 14.1756 C 11.704 14.1756 12.191 14.6617 12.191 15.2634 C 12.191 15.8651 11.704 16.3513 11.103 16.3513 Z M 11.103 7.6485 C 11.721 7.6485 12.214 8.1754 12.17 8.7941 L 11.919 12.3296 C 11.888 12.758 11.531 13.0877 11.106 13.0877 C 10.678 13.0877 10.324 12.758 10.294 12.3296 L 10.042 8.7941 C 9.998 8.1754 10.487 7.6485 11.109 7.6485 H 11.103 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function $v(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2 5.2222 C 2 3.9965 2.997 3 4.222 3 H 13.111 C 14.337 3 15.333 3.9965 15.333 5.2222 V 9.8958 C 12.767 10.6215 10.889 12.9792 10.889 15.7778 C 10.889 17.8299 11.899 19.6424 13.448 20.7535 C 13.337 20.7708 13.226 20.7778 13.111 20.7778 H 4.222 C 2.997 20.7778 2 19.7812 2 18.5556 V 5.2222 Z M 4.222 8 C 4.222 8.3056 4.472 8.5556 4.778 8.5556 H 12.556 C 12.861 8.5556 13.111 8.3056 13.111 8 C 13.111 7.6944 12.861 7.4444 12.556 7.4444 H 4.778 C 4.472 7.4444 4.222 7.6944 4.222 8 Z M 4.778 10.7778 C 4.472 10.7778 4.222 11.0278 4.222 11.3333 C 4.222 11.6389 4.472 11.8889 4.778 11.8889 H 10.333 C 10.639 11.8889 10.889 11.6389 10.889 11.3333 C 10.889 11.0278 10.639 10.7778 10.333 10.7778 H 4.778 Z M 4.778 14.1111 C 4.472 14.1111 4.222 14.3611 4.222 14.6667 C 4.222 14.9722 4.472 15.2222 4.778 15.2222 H 8.111 C 8.417 15.2222 8.667 14.9722 8.667 14.6667 C 8.667 14.3611 8.417 14.1111 8.111 14.1111 H 4.778 Z M 17 10.7778 C 18.326 10.7778 19.598 11.3046 20.536 12.2422 C 21.473 13.1799 22 14.4517 22 15.7778 C 22 17.1039 21.473 18.3756 20.536 19.3133 C 19.598 20.251 18.326 20.7778 17 20.7778 C 15.674 20.7778 14.402 20.251 13.464 19.3133 C 12.527 18.3756 12 17.1039 12 15.7778 C 12 14.4517 12.527 13.1799 13.464 12.2422 C 14.402 11.3046 15.674 10.7778 17 10.7778 Z M 17 14.1111 C 17.221 14.1111 17.433 14.0233 17.589 13.867 C 17.746 13.7108 17.833 13.4988 17.833 13.2778 C 17.833 13.0568 17.746 12.8448 17.589 12.6885 C 17.433 12.5322 17.221 12.4444 17 12.4444 C 16.779 12.4444 16.567 12.5322 16.411 12.6885 C 16.254 12.8448 16.167 13.0568 16.167 13.2778 C 16.167 13.4988 16.254 13.7108 16.411 13.867 C 16.567 14.0233 16.779 14.1111 17 14.1111 Z M 15.889 15.7778 C 15.889 16.0833 16.139 16.3333 16.444 16.3333 V 18 C 16.139 18 15.889 18.25 15.889 18.5556 C 15.889 18.8611 16.139 19.1111 16.444 19.1111 H 17 H 17.556 C 17.861 19.1111 18.111 18.8611 18.111 18.5556 C 18.111 18.25 17.861 18 17.556 18 V 15.7778 C 17.556 15.4722 17.306 15.2222 17 15.2222 H 16.444 C 16.139 15.2222 15.889 15.4722 15.889 15.7778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Hv(t) {
  const e = B.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.465 7.47 C 6.183 7.188 6.183 6.732 6.465 6.453 C 6.747 6.174 7.203 6.171 7.482 6.453 L 12.012 10.983 L 16.542 6.453 C 16.824 6.171 17.28 6.171 17.559 6.453 C 17.838 6.735 17.841 7.191 17.559 7.47 L 13.029 12 L 17.559 16.53 C 17.841 16.812 17.841 17.268 17.559 17.547 C 17.277 17.826 16.821 17.829 16.542 17.547 L 12.012 13.017 L 7.482 17.547 C 7.2 17.829 6.744 17.829 6.465 17.547 C 6.186 17.265 6.183 16.809 6.465 16.53 L 10.995 12 L 6.465 7.47 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
const Ig = {
  alerts: H4,
  "arrow-left-shrink-sidebar": z4,
  "arrow-left": B4,
  "arrow-right-expand-sidebar": W4,
  "arrow-up-right": U4,
  asset: G4,
  binoculars: Y4,
  "button-load-spinner": j4,
  calendar: K4,
  "chart-line": q4,
  "check-mark": Z4,
  checklist: X4,
  "chevron-down": Q4,
  "chevron-left": J4,
  "chevron-right": ev,
  "chevron-up": tv,
  "circle-check": nv,
  "circle-exclamation": ov,
  "circle-info": rv,
  "clock-seven": iv,
  customers: sv,
  document: lv,
  "ellipsis-dots-horiz": av,
  "ellipsis-dots": cv,
  "error-solid": uv,
  error: dv,
  "eye-watching": fv,
  facilities: pv,
  filter: mv,
  hardware: gv,
  home: hv,
  "image-regular": bv,
  integrations: vv,
  list: yv,
  "location-pin-solid": xv,
  maintenance: Cv,
  "menu-hamburger": wv,
  "monitoring-point": Sv,
  "notification-bell": Rv,
  "oil-analysis-bottle": Ev,
  "plus-regular": Nv,
  priority: kv,
  search: Iv,
  "settings-cog": Pv,
  sort: Mv,
  sparkles: Tv,
  "star-recommended": Ov,
  "trend-down": Dv,
  "trend-no-change": _v,
  "trend-up": Vv,
  upload: Av,
  user: Lv,
  warning: Fv,
  workorder: $v,
  "x-close": Hv
}, zv = {
  "add-photo": () => import("./add-photo-UE3i3aw7.js"),
  "add-plus": () => import("./add-plus-oFj-MK_p.js"),
  "advanced-readings": () => import("./advanced-readings-DE7-Y7MC.js"),
  "ai-filled": () => import("./ai-filled-1J1gMDKF.js"),
  ai: () => import("./ai-CruGGRMf.js"),
  "alert-exclamation": () => import("./alert-exclamation-C9YLD8Y5.js"),
  "alerts-outline": () => import("./alerts-outline-u0BE6BKG.js"),
  "angles-up-down-solid": () => import("./angles-up-down-solid-abyxkTyM.js"),
  api: () => import("./api-Cq21Vyn5.js"),
  "arrow-drop-down": () => import("./arrow-drop-down-CvUuwgsF.js"),
  "arrow-right-regular": () => import("./arrow-right-regular-ClIL3B0L.js"),
  "arrow-right": () => import("./arrow-right-BB9ZosBM.js"),
  "art-service": () => import("./art-service-D9k-QhdX.js"),
  "assign-link": () => import("./assign-link-Cz8DBNIP.js"),
  "barcode-scan-regular": () => import("./barcode-scan-regular-CRMPw43a.js"),
  "bars-filter-regular": () => import("./bars-filter-regular-rA10KAwS.js"),
  "bookmark-regular": () => import("./bookmark-regular-ErqXaTnq.js"),
  "bookmark-solid": () => import("./bookmark-solid-XxMmOSH8.js"),
  "calendar-solid": () => import("./calendar-solid-BKuAZoMG.js"),
  "camera-regular": () => import("./camera-regular-DCn5NMis.js"),
  "check-circle": () => import("./check-circle-pcTXVe3m.js"),
  "circle-check-regular": () => import("./circle-check-regular-D1RKE1A3.js"),
  "circle-minus-solid": () => import("./circle-minus-solid-DKh4s7Vy.js"),
  "circle-navigation": () => import("./circle-navigation-BggCTKte.js"),
  "circle-play-solid": () => import("./circle-play-solid-5RxV5EWv.js"),
  "circle-plus-regular": () => import("./circle-plus-regular-zl6C5_zW.js"),
  "circle-question": () => import("./circle-question-BInzI22Q.js"),
  "circle-stop-regular": () => import("./circle-stop-regular-C_JIeCcl.js"),
  "circle-xmark-solid": () => import("./circle-xmark-solid--KBWCnKI.js"),
  "cloud-slash-regular": () => import("./cloud-slash-regular-DoTIr8Oz.js"),
  collect: () => import("./collect-Co2HYlGr.js"),
  "collection-taken": () => import("./collection-taken-eCVooTdW.js"),
  "command-search": () => import("./command-search-C2xsNRgD.js"),
  component: () => import("./component-BbcQUwAb.js"),
  "configure-slider": () => import("./configure-slider-bFpbIHj4.js"),
  "copy-regular": () => import("./copy-regular-BuvekPFc.js"),
  "cost-savings-dollar": () => import("./cost-savings-dollar-WugkrpTl.js"),
  "developing-stage": () => import("./developing-stage-CBpNw3F8.js"),
  "document-upload": () => import("./document-upload-BGJdqBn4.js"),
  "dollar-sign": () => import("./dollar-sign-DrSDp3MT.js"),
  dot: () => import("./dot-Bsti8OLe.js"),
  download: () => import("./download-CnMNSBLT.js"),
  drag: () => import("./drag-BZplXPTC.js"),
  "early-stage": () => import("./early-stage-DN8bJpyi.js"),
  "edit-pen": () => import("./edit-pen-CxBiIwxm.js"),
  "email-envelope": () => import("./email-envelope-DiLoHzY9.js"),
  "expand-regular": () => import("./expand-regular-C05q6RBY.js"),
  expand: () => import("./expand-Ar2qxbi8.js"),
  "eye-slash-regular": () => import("./eye-slash-regular-BL-pt4ts.js"),
  "flash-auto": () => import("./flash-auto-COJnXXcG.js"),
  "flash-off": () => import("./flash-off-DxAJx4CC.js"),
  "flash-on": () => import("./flash-on-D41TNyqb.js"),
  "gauge-max-solid-full": () => import("./gauge-max-solid-full-DVsU73t4.js"),
  grid: () => import("./grid-BnvfXTkX.js"),
  "grip-drag": () => import("./grip-drag-T3n9XLV-.js"),
  hazardous: () => import("./hazardous-DMmCTvnj.js"),
  "hwe-sensor-triangle": () => import("./hwe-sensor-triangle-DoamELQq.js"),
  "invoke-reading-bolt-regular": () => import("./invoke-reading-bolt-regular-Cp5QGlzd.js"),
  "invoke-reading-bolt-solid": () => import("./invoke-reading-bolt-solid-B9yq2sii.js"),
  line: () => import("./line-bZnGeTu-.js"),
  "logout-exit": () => import("./logout-exit-CJdNt9zY.js"),
  marketplace: () => import("./marketplace-DjGN6iKj.js"),
  "mature-stage": () => import("./mature-stage-Dvx2oWNp.js"),
  message: () => import("./message-CnKMpyxz.js"),
  "microphone-solid": () => import("./microphone-solid-BN1BAqyC.js"),
  minus: () => import("./minus-Ck_rUujj.js"),
  "new-message": () => import("./new-message-COl6FN29.js"),
  "new-nxt-step": () => import("./new-nxt-step-DdKIQhHf.js"),
  "note-regular": () => import("./note-regular-DtG3iBud.js"),
  "paper-plane-top": () => import("./paper-plane-top-UvtbOAeS.js"),
  partners: () => import("./partners-qveXf0qH.js"),
  phone: () => import("./phone-bdISCoGZ.js"),
  "qr-code-scan": () => import("./qr-code-scan-0YI-iWcO.js"),
  "quarterly-collection": () => import("./quarterly-collection-CxUmYmn_.js"),
  "report-error-square-regular": () => import("./report-error-square-regular-BVmNOQPD.js"),
  rotate: () => import("./rotate-BZY99ywR.js"),
  save: () => import("./save-BMS6Tjxq.js"),
  send: () => import("./send-iYh4V9VL.js"),
  service: () => import("./service-D19lNwJd.js"),
  "settings-cog-solid": () => import("./settings-cog-solid-DzBAvMJm.js"),
  share: () => import("./share-DR74k9ao.js"),
  "signal-connection": () => import("./signal-connection-D2TXKNXS.js"),
  signal: () => import("./signal-ClsGNY50.js"),
  "sort-lines": () => import("./sort-lines-BqsmDERv.js"),
  "stacked-images-regular": () => import("./stacked-images-regular-C7r2AhI2.js"),
  sync: () => import("./sync-DCq2I0rc.js"),
  tag: () => import("./tag-C-1U0rZc.js"),
  "temperature-high-regular-full": () => import("./temperature-high-regular-full-CGdfPnlm.js"),
  "thumbs-down": () => import("./thumbs-down-CFpQbdTQ.js"),
  "thumbs-up": () => import("./thumbs-up-BA7gZye6.js"),
  "trash-delete-bin": () => import("./trash-delete-bin-BRaP7obb.js"),
  "triangle-exclamation-solid": () => import("./triangle-exclamation-solid-BlUal_cM.js"),
  ultrasound: () => import("./ultrasound-CVhj4j7D.js"),
  "up-down": () => import("./up-down-BgbgwQHo.js"),
  vero: () => import("./vero-BgxkNmbD.js"),
  vibration: () => import("./vibration-B66xjocq.js"),
  watching: () => import("./watching-C6VbFi_c.js"),
  "wifi-exclamation-sharp-solid": () => import("./wifi-exclamation-sharp-solid-B2lRByzu.js"),
  wifi: () => import("./wifi-8GgIkdeE.js"),
  "zoom-in": () => import("./zoom-in-B26X0B3W.js"),
  "zoom-out": () => import("./zoom-out-5iqiIT_e.js")
}, Bv = {
  neutral: "text-icon-main",
  secondary: "text-icon-secondary",
  brand: "text-primary",
  warning: "text-accessibility-warning",
  negative: "text-negative",
  positive: "text-positive",
  informative: "text-informative",
  inherit: "text-current"
}, Ml = /* @__PURE__ */ new Map(), Bs = /* @__PURE__ */ new Map();
function Ka(t) {
  return t in Ig;
}
function Wv(t) {
  const e = Ml.get(t);
  if (e)
    return Promise.resolve(e);
  const n = Bs.get(t);
  if (n)
    return n;
  const o = zv[t], r = o().then((i) => (Ml.set(t, i.default), Bs.delete(t), i.default)).catch((i) => {
    throw Bs.delete(t), i;
  });
  return Bs.set(t, r), r;
}
function We(t) {
  const e = B.c(31);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    name: r,
    size: l,
    tone: a,
    style: s,
    "aria-label": o,
    "aria-hidden": n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "md" : l, u = a === void 0 ? "neutral" : a, d = !o, f = kg[c];
  let p;
  e[8] !== r ? (p = () => {
    if (Ka(r))
      return;
    const M = Ml.get(r);
    return M ? {
      name: r,
      Component: M
    } : void 0;
  }, e[8] = r, e[9] = p) : p = e[9];
  const [m, h] = qe(p), b = Bv[u];
  let v;
  e[10] !== f || e[11] !== s ? (v = {
    width: f,
    height: f,
    flexShrink: 0,
    ...s
  }, e[10] = f, e[11] = s, e[12] = v) : v = e[12];
  const C = n ?? (d ? !0 : void 0), y = d ? void 0 : "img";
  let w;
  e[13] !== o || e[14] !== i || e[15] !== b || e[16] !== v || e[17] !== C || e[18] !== y ? (w = {
    className: b,
    style: v,
    "aria-hidden": C,
    "aria-label": o,
    role: y,
    ...i
  }, e[13] = o, e[14] = i, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19];
  const R = w;
  let S, E;
  if (e[20] !== r ? (E = () => {
    if (Ka(r)) {
      h(void 0);
      return;
    }
    let M = !0;
    const T = r, P = Ml.get(T);
    if (P) {
      h({
        name: T,
        Component: P
      });
      return;
    }
    return h(void 0), Wv(T).then((k) => {
      M && h({
        name: T,
        Component: k
      });
    }).catch(() => {
      M && h(void 0);
    }), () => {
      M = !1;
    };
  }, S = [r], e[20] = r, e[21] = S, e[22] = E) : (S = e[21], E = e[22]), Rt(E, S), Ka(r)) {
    const M = Ig[r];
    let T;
    return e[23] !== M || e[24] !== R ? (T = /* @__PURE__ */ g(M, { ...R }), e[23] = M, e[24] = R, e[25] = T) : T = e[25], T;
  }
  if (m?.name === r) {
    const M = m.Component;
    let T;
    return e[26] !== M || e[27] !== R ? (T = /* @__PURE__ */ g(M, { ...R }), e[26] = M, e[27] = R, e[28] = T) : T = e[28], T;
  }
  let N;
  return e[29] !== R ? (N = /* @__PURE__ */ g("svg", { ...R }), e[29] = R, e[30] = N) : N = e[30], N;
}
const Uv = ae(["inline-flex", "items-center", "justify-center", "max-w-full", "gap-(--spacing-4)", "h-(--spacing-24)", "rounded-(--radius-sm)", "overflow-hidden", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(--font-weight-medium)", "whitespace-nowrap"], {
  variants: {
    tone: {
      positive: ["bg-chip-positive-container", "text-chip-positive-label"],
      neutral: ["bg-chip-neutral-container", "text-chip-neutral-label"],
      negative: ["bg-chip-negative-container", "text-chip-negative-label"],
      warning: ["bg-chip-warning-container", "text-chip-warning-label"],
      informative: ["bg-chip-informative-container", "text-chip-informative-label"],
      brand: ["bg-chip-brand-container", "text-chip-brand-label"]
    },
    iconOnly: {
      true: ["px-(--spacing-4)", "py-(--spacing-4)"],
      false: ["px-(--spacing-6)", "py-(--spacing-4)"]
    }
  },
  defaultVariants: {
    tone: "neutral",
    iconOnly: !1
  }
}), Gv = {
  informative: "text-chip-informative-label-icon",
  positive: "text-chip-positive-label-icon",
  warning: "text-chip-warning-label-icon",
  negative: "text-chip-negative-label-icon"
};
function Pg(t) {
  const e = B.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: l,
    icon: o,
    label: r,
    children: n,
    truncate: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !0 : s, c = o !== void 0 && r === void 0;
  let u;
  e[7] !== c || e[8] !== l ? (u = Uv({
    tone: l,
    iconOnly: c
  }), e[7] = c, e[8] = l, e[9] = u) : u = e[9];
  let d;
  e[10] !== o || e[11] !== l ? (d = o && /* @__PURE__ */ g("span", { className: ne("inline-flex shrink-0 items-center", Gv[l]), children: /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit" }) }), e[10] = o, e[11] = l, e[12] = d) : d = e[12];
  let f;
  e[13] !== r || e[14] !== a ? (f = r !== void 0 && /* @__PURE__ */ g("span", { className: a ? "min-w-0 flex-1 truncate" : void 0, children: String(r) }), e[13] = r, e[14] = a, e[15] = f) : f = e[15];
  let p;
  return e[16] !== n || e[17] !== i || e[18] !== u || e[19] !== d || e[20] !== f ? (p = /* @__PURE__ */ F("span", { className: u, ...i, children: [
    d,
    f,
    n
  ] }), e[16] = n, e[17] = i, e[18] = u, e[19] = d, e[20] = f, e[21] = p) : p = e[21], p;
}
function Ln(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Pg, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Yv(t) {
  const e = B.c(15);
  let n, o, r, i;
  e[0] !== t ? ({
    label: n,
    onClose: o,
    removeAriaLabel: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = i ?? `Remove ${n}`;
  let l;
  e[5] !== o ? (l = (d) => {
    d.stopPropagation(), o();
  }, e[5] = o, e[6] = l) : l = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }), e[7] = a) : a = e[7];
  let c;
  e[8] !== s || e[9] !== l ? (c = /* @__PURE__ */ g("button", { type: "button", "aria-label": s, className: "inline-flex shrink-0 cursor-pointer items-center text-icon-main rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: l, children: a }), e[8] = s, e[9] = l, e[10] = c) : c = e[10];
  let u;
  return e[11] !== n || e[12] !== r || e[13] !== c ? (u = /* @__PURE__ */ g(Pg, { tone: "neutral", label: n, ...r, children: c }), e[11] = n, e[12] = r, e[13] = c, e[14] = u) : u = e[14], u;
}
const Mg = ho({
  activeId: void 0,
  orientation: "vertical",
  onActiveChange: void 0,
  startScrollLock: void 0,
  scrollRef: void 0
}), _1 = ae([
  // Layout
  "relative",
  "inline-flex",
  "items-center",
  "gap-(--spacing-4)",
  "px-(--spacing-6)",
  "rounded-(--radius-sm)",
  // Typography
  "font-(family-name:--font-family-label)",
  "text-(length:--font-size-label-large)",
  "leading-(--font-line-height-16)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "select-none",
  "outline-none",
  "cursor-pointer",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Default text color
  "text-informative",
  // Hover
  "hover:bg-surface-hover",
  // Pressed
  "active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring"
], {
  variants: {
    orientation: {
      // Vertical: fixed 26px height, no extra vertical padding
      vertical: ["h-[26px]"],
      // Horizontal: fixed 26px height, no extra vertical padding
      horizontal: ["h-[26px]"]
    },
    selected: {
      true: [],
      false: []
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none", "cursor-default"]
    }
  },
  compoundVariants: [{
    orientation: "horizontal",
    selected: !0,
    className: "font-semibold"
  }]
}), jv = ["flex", "items-center", "gap-(--spacing-16)", "h-[26px]", "w-full"].join(" "), V1 = ae(["shrink-0", "transition-colors", "duration-200", "ease-in-out"], {
  variants: {
    orientation: {
      vertical: ["shrink-0", "w-(--spacing-2)", "h-(--spacing-24)", "rounded-tr-(--radius-sm)", "rounded-br-(--radius-sm)"],
      horizontal: ["absolute", "bottom-0", "left-[14px]", "right-[14px]", "h-(--spacing-2)", "rounded-tl-(--radius-sm)", "rounded-tr-(--radius-sm)"]
    },
    selected: {
      true: "bg-informative",
      false: "bg-surface-container-highest"
    }
  }
});
function Kv(t) {
  const e = B.c(59), {
    targetId: n,
    icon: o,
    chip: r,
    disabled: i,
    children: s
  } = t, l = i === void 0 ? !1 : i, {
    activeId: a,
    orientation: c,
    onActiveChange: u,
    startScrollLock: d,
    scrollRef: f
  } = dn(Mg), p = a === n, m = !l && p;
  let h;
  e[0] !== l || e[1] !== u || e[2] !== f || e[3] !== d || e[4] !== n ? (h = function(P) {
    if (l) {
      P.preventDefault();
      return;
    }
    if (P.button !== 0 || P.metaKey || P.ctrlKey || P.shiftKey || P.altKey)
      return;
    P.preventDefault();
    const k = document.getElementById(n);
    if (k) {
      const I = window.matchMedia("(prefers-reduced-motion: reduce)").matches, D = I ? "instant" : "smooth", O = f?.current;
      I || d?.(), O ? O.scrollTo({
        top: k.offsetTop - O.offsetTop,
        behavior: D
      }) : k.scrollIntoView({
        behavior: D
      });
    }
    window.history.pushState(null, "", `#${n}`), u?.(n);
  }, e[0] = l, e[1] = u, e[2] = f, e[3] = d, e[4] = n, e[5] = h) : h = e[5];
  const b = h;
  if (c === "vertical") {
    const T = m || l && p;
    let P;
    e[6] !== c || e[7] !== T ? (P = V1({
      orientation: c,
      selected: T
    }), e[6] = c, e[7] = T, e[8] = P) : P = e[8];
    const k = l && p ? "opacity-50" : "";
    let I;
    e[9] !== P || e[10] !== k ? (I = [P, k].filter(Boolean), e[9] = P, e[10] = k, e[11] = I) : I = e[11];
    const D = I.join(" ");
    let O;
    e[12] !== D ? (O = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: D }), e[12] = D, e[13] = O) : O = e[13];
    const V = `#${n}`, _ = m ? "true" : void 0, L = l ? "true" : void 0, A = l ? -1 : void 0;
    let $;
    e[14] !== l || e[15] !== m || e[16] !== c ? ($ = _1({
      selected: m,
      disabled: l,
      orientation: c
    }), e[14] = l, e[15] = m, e[16] = c, e[17] = $) : $ = e[17];
    let Y;
    e[18] !== o ? (Y = o && /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[18] = o, e[19] = Y) : Y = e[19];
    let z;
    e[20] !== r ? (z = r && /* @__PURE__ */ g(Ln, { ...r }), e[20] = r, e[21] = z) : z = e[21];
    let H;
    e[22] !== s || e[23] !== b || e[24] !== _ || e[25] !== L || e[26] !== A || e[27] !== $ || e[28] !== Y || e[29] !== z || e[30] !== V ? (H = /* @__PURE__ */ F("a", { href: V, onClick: b, "aria-current": _, "aria-disabled": L, tabIndex: A, className: $, children: [
      Y,
      s,
      z
    ] }), e[22] = s, e[23] = b, e[24] = _, e[25] = L, e[26] = A, e[27] = $, e[28] = Y, e[29] = z, e[30] = V, e[31] = H) : H = e[31];
    let K;
    return e[32] !== H || e[33] !== O ? (K = /* @__PURE__ */ F("div", { className: jv, children: [
      O,
      H
    ] }), e[32] = H, e[33] = O, e[34] = K) : K = e[34], K;
  }
  const v = `#${n}`, C = m ? "true" : void 0, y = l ? "true" : void 0, w = l ? -1 : void 0;
  let R;
  e[35] !== l || e[36] !== m || e[37] !== c ? (R = _1({
    selected: m,
    disabled: l,
    orientation: c
  }), e[35] = l, e[36] = m, e[37] = c, e[38] = R) : R = e[38];
  let S;
  e[39] !== o ? (S = o && /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[39] = o, e[40] = S) : S = e[40];
  let E;
  e[41] !== r ? (E = r && /* @__PURE__ */ g(Ln, { ...r }), e[41] = r, e[42] = E) : E = e[42];
  let N;
  e[43] !== l || e[44] !== p || e[45] !== m || e[46] !== c ? (N = (m || l && p) && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: [V1({
    orientation: c,
    selected: !0
  }), l && p ? "opacity-50" : ""].filter(Boolean).join(" ") }), e[43] = l, e[44] = p, e[45] = m, e[46] = c, e[47] = N) : N = e[47];
  let M;
  return e[48] !== s || e[49] !== b || e[50] !== N || e[51] !== v || e[52] !== C || e[53] !== y || e[54] !== w || e[55] !== R || e[56] !== S || e[57] !== E ? (M = /* @__PURE__ */ F("a", { href: v, onClick: b, "aria-current": C, "aria-disabled": y, tabIndex: w, className: R, children: [
    S,
    s,
    E,
    N
  ] }), e[48] = s, e[49] = b, e[50] = N, e[51] = v, e[52] = C, e[53] = y, e[54] = w, e[55] = R, e[56] = S, e[57] = E, e[58] = M) : M = e[58], M;
}
function qv(t) {
  const e = B.c(12), {
    orientation: n,
    activeId: o,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s,
    children: l
  } = t, a = n === void 0 ? "vertical" : n;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== a || e[3] !== s || e[4] !== i ? (c = {
    activeId: o,
    orientation: a,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s
  }, e[0] = o, e[1] = r, e[2] = a, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const u = a === "vertical" ? "flex flex-col items-start gap-(--spacing-8)" : "flex flex-row flex-wrap gap-(--spacing-8)";
  let d;
  e[6] !== l || e[7] !== u ? (d = /* @__PURE__ */ g("nav", { "aria-label": "On this page", className: u, children: l }), e[6] = l, e[7] = u, e[8] = d) : d = e[8];
  let f;
  return e[9] !== c || e[10] !== d ? (f = /* @__PURE__ */ g(Mg, { value: c, children: d }), e[9] = c, e[10] = d, e[11] = f) : f = e[11], f;
}
const Zv = 800;
function Xv(t) {
  const e = nt(null), n = nt(!1), o = nt(null), r = nt(null), [i, s] = qe(t[0]), l = t.join(","), a = nt(() => {
  });
  Rt(() => {
    const d = e.current, f = l ? l.split(",") : [], p = f.flatMap((w) => {
      const R = document.getElementById(w);
      return R ? [R] : [];
    });
    function m() {
      n.current = !1, r.current !== null && (clearTimeout(r.current), r.current = null);
    }
    a.current = m;
    function h() {
      if (n.current || o.current !== null) return;
      const R = (d ? d.getBoundingClientRect().top + d.clientTop : 0) + 1;
      let S = p[0], E = Number.NEGATIVE_INFINITY;
      for (const N of p) {
        const M = N.getBoundingClientRect().top;
        M <= R && M >= E && (S = N, E = M);
      }
      S && s(S.id);
    }
    function b() {
      o.current = null, m();
    }
    function v(w) {
      if (!(w instanceof KeyboardEvent)) return;
      const R = w.target;
      R instanceof HTMLElement && (R.isContentEditable || R.closest("input, textarea, select")) || ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(w.key) && b();
    }
    const C = new IntersectionObserver(h, {
      root: d,
      threshold: 0
    });
    for (const w of p) C.observe(w);
    const y = d ?? document;
    return y.addEventListener("scroll", h, {
      passive: !0
    }), y.addEventListener("scrollend", m), y.addEventListener("wheel", b, {
      passive: !0
    }), y.addEventListener("touchstart", b, {
      passive: !0
    }), y.addEventListener("pointerdown", b), y.addEventListener("keydown", v), window.addEventListener("resize", h), o.current && !f.includes(o.current) && (o.current = null, m()), () => {
      C.disconnect(), y.removeEventListener("scroll", h), y.removeEventListener("scrollend", m), y.removeEventListener("wheel", b), y.removeEventListener("touchstart", b), y.removeEventListener("pointerdown", b), y.removeEventListener("keydown", v), window.removeEventListener("resize", h), r.current !== null && clearTimeout(r.current);
    };
  }, [l]);
  const c = nt(() => {
    n.current = !0, r.current !== null && clearTimeout(r.current), r.current = setTimeout(() => a.current(), Zv);
  }).current;
  function u(d) {
    o.current = d, s(d);
  }
  return {
    scrollRef: e,
    activeId: i,
    onActiveChange: u,
    startScrollLock: c
  };
}
function Qv(t, e) {
  return function(o, ...r) {
    const i = new URL(t);
    return i.searchParams.set("code", o.toString()), r.forEach((s) => i.searchParams.append("args[]", s)), `${e} error #${o}; visit ${i} for the full message.`;
  };
}
const tt = Qv("https://base-ui.com/production-error", "Base UI"), A1 = {};
function Tt(t, e) {
  const n = x.useRef(A1);
  return n.current === A1 && (n.current = t(e)), n;
}
function mn(t, e, n, o) {
  const r = Tt(Tg).current;
  return e5(r, t, e, n, o) && Og(r, [t, e, n, o]), r.callback;
}
function Jv(t) {
  const e = Tt(Tg).current;
  return t5(e, t) && Og(e, t), e.callback;
}
function Tg() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function e5(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function t5(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function Og(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const i = e[r];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (o[r] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const i = e[r];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = o[r];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const n5 = parseInt(x.version, 10);
function Mu(t) {
  return n5 >= t;
}
function L1(t) {
  if (!/* @__PURE__ */ x.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (Mu(19) ? n?.ref : e.ref) ?? null;
}
function qc(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
let Zc;
process.env.NODE_ENV !== "production" && (Zc = /* @__PURE__ */ new Set());
function ea(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Zc.has(e) || (Zc.add(e), console.warn(`Base UI: ${e}`));
  }
}
function xt() {
}
const _n = Object.freeze([]), St = Object.freeze({});
function o5(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const i = e[o](r);
      i != null && Object.assign(n, i);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function r5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function i5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
const Tu = {};
function Jt(t, e, n, o, r) {
  if (!n && !o && !r && !t)
    return Tl(e);
  let i = Tl(t);
  return e && (i = _i(i, e)), n && (i = _i(i, n)), o && (i = _i(i, o)), r && (i = _i(i, r)), i;
}
function s5(t) {
  if (t.length === 0)
    return Tu;
  if (t.length === 1)
    return Tl(t[0]);
  let e = Tl(t[0]);
  for (let n = 1; n < t.length; n += 1)
    e = _i(e, t[n]);
  return e;
}
function Tl(t) {
  return Ou(t) ? {
    ..._g(t, Tu)
  } : l5(t);
}
function _i(t, e) {
  return Ou(e) ? _g(e, t) : a5(t, e);
}
function l5(t) {
  const e = {
    ...t
  };
  for (const n in e) {
    const o = e[n];
    Dg(n, o) && (e[n] = Vg(o));
  }
  return e;
}
function a5(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = qc(t.style, o);
        break;
      }
      case "className": {
        t[n] = Ag(t.className, o);
        break;
      }
      default:
        Dg(n, o) ? t[n] = c5(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function Dg(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function Ou(t) {
  return typeof t == "function";
}
function _g(t, e) {
  return Ou(t) ? t(e) : t ?? Tu;
}
function c5(t, e) {
  return e ? t ? (...n) => {
    const o = n[0];
    if (Lg(o)) {
      const i = o;
      Ol(i);
      const s = e(...n);
      return i.baseUIHandlerPrevented || t?.(...n), s;
    }
    const r = e(...n);
    return t?.(...n), r;
  } : Vg(e) : t;
}
function Vg(t) {
  return t && ((...e) => {
    const n = e[0];
    return Lg(n) && Ol(n), t(...e);
  });
}
function Ol(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function Ag(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function Lg(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function Le(t, e, n = {}) {
  const o = e.render, r = u5(e, n);
  if (n.enabled === !1)
    return null;
  const i = n.state ?? St;
  return g5(t, o, r, i);
}
function u5(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: i = St,
    ref: s,
    props: l,
    stateAttributesMapping: a,
    enabled: c = !0
  } = e, u = c ? r5(n, i) : void 0, d = c ? i5(o, i) : void 0, f = c ? o5(i, a) : St, p = c && l ? d5(l) : void 0, m = c ? qc(f, p) ?? {} : St;
  return typeof document < "u" && (c ? Array.isArray(s) ? m.ref = Jv([m.ref, L1(r), ...s]) : m.ref = mn(m.ref, L1(r), s) : mn(null, null)), c ? (u !== void 0 && (m.className = Ag(m.className, u)), d !== void 0 && (m.style = qc(m.style, d)), m) : St;
}
function d5(t) {
  return Array.isArray(t) ? s5(t) : Jt(void 0, t);
}
const f5 = /* @__PURE__ */ Symbol.for("react.lazy"), p5 = /^[A-Z][A-Za-z0-9$]*$/, m5 = /[a-z]/;
function g5(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return process.env.NODE_ENV !== "production" && h5(e), e(n, o);
    const r = Jt(n, e.props);
    r.ref = n.ref;
    let i = e;
    if (i?.$$typeof === f5 && (i = x.Children.toArray(e)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ x.isValidElement(i))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ x.cloneElement(i, r);
  }
  if (t && typeof t == "string")
    return b5(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : tt(8));
}
function h5(t) {
  const e = t.name;
  e.length !== 0 && p5.test(e) && m5.test(e) && ea(`The \`render\` prop received a function named \`${e}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function b5(t, e) {
  return t === "button" ? /* @__PURE__ */ O1("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ O1("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ x.createElement(t, e);
}
const Du = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Du.displayName = "AvatarRootContext");
function Fg() {
  const t = x.useContext(Du);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : tt(13));
  return t;
}
const _u = {
  imageLoadingStatus: () => null
}, Xc = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, [l, a] = x.useState("idle"), c = {
    imageLoadingStatus: l
  }, u = x.useMemo(() => ({
    imageLoadingStatus: l,
    setImageLoadingStatus: a
  }), [l, a]), d = Le("span", e, {
    state: c,
    ref: n,
    props: s,
    stateAttributesMapping: _u
  });
  return /* @__PURE__ */ g(Du.Provider, {
    value: u,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (Xc.displayName = "AvatarRoot");
const qa = x[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], v5 = (
  // React 17 doesn't have useInsertionEffect.
  qa && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  qa !== x.useLayoutEffect ? qa : (t) => t()
);
function Ce(t) {
  const e = Tt(y5).current;
  return e.next = t, v5(e.effect), e.trampoline;
}
function y5() {
  const t = {
    next: void 0,
    callback: x5,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function x5() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const C5 = () => {
}, Ne = typeof document < "u" ? x.useLayoutEffect : C5, w5 = [];
function ei(t) {
  x.useEffect(t, w5);
}
const Ws = null;
let F1 = globalThis.requestAnimationFrame;
class S5 {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (e) => {
    this.isScheduled = !1;
    const n = this.callbacks, o = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
      for (let r = 0; r < n.length; r += 1)
        n[r]?.(e);
  };
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV !== "production" && F1 !== requestAnimationFrame && (F1 = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const Us = new S5();
class Lt {
  static create() {
    return new Lt();
  }
  static request(e) {
    return Us.request(e);
  }
  static cancel(e) {
    return Us.cancel(e);
  }
  currentId = Ws;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = Us.request(() => {
      this.currentId = Ws, e();
    });
  }
  cancel = () => {
    this.currentId !== Ws && (Us.cancel(this.currentId), this.currentId = Ws);
  };
  disposeEffect = () => this.cancel;
}
function ti() {
  const t = Tt(Lt.create).current;
  return ei(t.disposeEffect), t;
}
function xo(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
let qn = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const R5 = {
  [qn.startingStyle]: ""
}, E5 = {
  [qn.endingStyle]: ""
}, Bt = {
  transitionStatus(t) {
    return t === "starting" ? R5 : t === "ending" ? E5 : null;
  }
};
function ta(t, e = !1, n = !0) {
  const o = ti();
  return Ce((r, i = null) => {
    o.cancel();
    const s = xo(t);
    if (s == null)
      return;
    const l = s, a = () => {
      cn.flushSync(r);
    };
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function c() {
      Promise.all(l.getAnimations().map((u) => u.finished)).then(() => {
        i?.aborted || a();
      }).catch(() => {
        if (n) {
          i?.aborted || a();
          return;
        }
        const u = l.getAnimations();
        !i?.aborted && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && c();
      });
    }
    if (e) {
      const u = qn.startingStyle;
      if (!l.hasAttribute(u)) {
        o.request(c);
        return;
      }
      const d = new MutationObserver(() => {
        l.hasAttribute(u) || (d.disconnect(), c());
      });
      d.observe(l, {
        attributes: !0,
        attributeFilter: [u]
      }), i?.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    o.request(c);
  });
}
function jt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, i = Ce(r), s = ta(o, n, !1);
  x.useEffect(() => {
    if (!e)
      return;
    const l = new AbortController();
    return s(i, l.signal), () => {
      l.abort();
    };
  }, [e, n, i, s]);
}
function Xn(t, e = !1, n = !1) {
  const [o, r] = x.useState(t && e ? "idle" : void 0), [i, s] = x.useState(t);
  return t && !i && (s(!0), r("starting")), !t && i && o !== "ending" && !n && r("ending"), !t && !i && o === "ending" && r(void 0), Ne(() => {
    if (!t && i && o !== "ending" && n) {
      const l = Lt.request(() => {
        r("ending");
      });
      return () => {
        Lt.cancel(l);
      };
    }
  }, [t, i, o, n]), Ne(() => {
    if (!t || e)
      return;
    const l = Lt.request(() => {
      r(void 0);
    });
    return () => {
      Lt.cancel(l);
    };
  }, [e, t]), Ne(() => {
    if (!t || !e)
      return;
    t && i && o !== "idle" && r("starting");
    const l = Lt.request(() => {
      r("idle");
    });
    return () => {
      Lt.cancel(l);
    };
  }, [e, t, i, o]), {
    mounted: i,
    setMounted: s,
    transitionStatus: o
  };
}
function N5(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = x.useState("idle");
  return Ne(() => {
    if (!t)
      return r("error"), xt;
    let i = !0;
    const s = new window.Image(), l = (a) => () => {
      i && r(a);
    };
    return r("loading"), s.onload = l("loaded"), s.onerror = l("error"), e && (s.referrerPolicy = e), s.crossOrigin = n ?? null, s.src = t, s.complete && r(s.naturalWidth > 0 ? "loaded" : "error"), () => {
      i = !1;
    };
  }, [t, n, e]), o;
}
const k5 = {
  ..._u,
  ...Bt
}, $g = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: i,
    referrerPolicy: s,
    crossOrigin: l,
    style: a,
    ...c
  } = e, u = Fg(), d = N5(e.src, {
    referrerPolicy: s,
    crossOrigin: l
  }), f = d === "loaded", {
    mounted: p,
    transitionStatus: m,
    setMounted: h
  } = Xn(f), b = x.useRef(null), v = Ce((w) => {
    i?.(w), u.setImageLoadingStatus(w);
  });
  Ne(() => {
    d !== "idle" && v(d);
  }, [d, v]);
  const C = {
    imageLoadingStatus: d,
    transitionStatus: m
  };
  jt({
    open: f,
    ref: b,
    onComplete() {
      f || h(!1);
    }
  });
  const y = Le("img", e, {
    state: C,
    ref: [n, b],
    props: c,
    stateAttributesMapping: k5,
    enabled: p
  });
  return p ? y : null;
});
process.env.NODE_ENV !== "production" && ($g.displayName = "AvatarImage");
const Ei = 0;
class Cn {
  static create() {
    return new Cn();
  }
  currentId = Ei;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Ei, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== Ei;
  }
  clear = () => {
    this.currentId !== Ei && (clearTimeout(this.currentId), this.currentId = Ei);
  };
  disposeEffect = () => this.clear;
}
function _t() {
  const t = Tt(Cn.create).current;
  return ei(t.disposeEffect), t;
}
const Hg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: i,
    style: s,
    ...l
  } = e, {
    imageLoadingStatus: a
  } = Fg(), [c, u] = x.useState(i === void 0), d = _t();
  return x.useEffect(() => (i !== void 0 && d.start(i, () => u(!0)), d.clear), [d, i]), Le("span", e, {
    state: {
      imageLoadingStatus: a
    },
    ref: n,
    props: l,
    stateAttributesMapping: _u,
    enabled: a !== "loaded" && c
  });
});
process.env.NODE_ENV !== "production" && (Hg.displayName = "AvatarFallback");
const $1 = ae(["inline-flex", "shrink-0", "items-center", "justify-center", "overflow-hidden", "rounded-full", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "select-none"], {
  variants: {
    size: {
      md: ["size-(--spacing-40)", "text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"],
      xs: ["size-(--spacing-20)", "text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)"]
    },
    variant: {
      internal: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      external: ["bg-surface-container-highest", "text-surface-on-surface"],
      ai: ["bg-ai-avatar-background"]
    }
  }
});
function jr(t) {
  const e = B.c(44);
  let n, o, r, i;
  e[0] !== t ? ({
    size: r,
    variant: i,
    "aria-label": n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "md" : r;
  if (i === "ai") {
    const S = s === "xs", E = S ? void 0 : "img", N = S ? void 0 : n ?? "AI", M = S || void 0;
    let T;
    e[5] !== s || e[6] !== i ? (T = $1({
      size: s,
      variant: i
    }), e[5] = s, e[6] = i, e[7] = T) : T = e[7];
    const P = s === "xs" ? "xs" : "sm", k = s === "xs" ? "size-[12px]" : void 0;
    let I;
    e[8] !== P || e[9] !== k ? (I = /* @__PURE__ */ g(Pu, { size: P, className: k }), e[8] = P, e[9] = k, e[10] = I) : I = e[10];
    let D;
    return e[11] !== o || e[12] !== E || e[13] !== N || e[14] !== M || e[15] !== T || e[16] !== I ? (D = /* @__PURE__ */ g(Xc, { ...o, "data-slot": "avatar", "data-variant": "ai", role: E, "aria-label": N, "aria-hidden": M, className: T, children: I }), e[11] = o, e[12] = E, e[13] = N, e[14] = M, e[15] = T, e[16] = I, e[17] = D) : D = e[17], D;
  }
  const l = o;
  let a, c, u;
  e[18] !== l ? ({
    initials: a,
    src: u,
    ...c
  } = l, e[18] = l, e[19] = a, e[20] = c, e[21] = u) : (a = e[19], c = e[20], u = e[21]);
  const d = s === "xs", f = !u && !d ? n : void 0, p = u && !d ? n : void 0, m = f ? "img" : void 0, h = d || void 0;
  let b;
  e[22] !== s || e[23] !== i ? (b = $1({
    size: s,
    variant: i
  }), e[22] = s, e[23] = i, e[24] = b) : b = e[24];
  let v;
  e[25] !== n || e[26] !== d || e[27] !== u ? (v = u ? /* @__PURE__ */ g($g, { "data-slot": "avatar-image", src: u, alt: d ? "" : n ?? "", className: "h-full w-full object-cover" }) : null, e[25] = n, e[26] = d, e[27] = u, e[28] = v) : v = e[28];
  const C = p ? "img" : void 0;
  let y;
  e[29] !== a ? (y = /* @__PURE__ */ g("span", { "aria-hidden": "true", children: a }), e[29] = a, e[30] = y) : y = e[30];
  let w;
  e[31] !== p || e[32] !== C || e[33] !== y ? (w = /* @__PURE__ */ g(Hg, { "data-slot": "avatar-fallback", role: C, "aria-label": p, children: y }), e[31] = p, e[32] = C, e[33] = y, e[34] = w) : w = e[34];
  let R;
  return e[35] !== f || e[36] !== c || e[37] !== m || e[38] !== h || e[39] !== b || e[40] !== v || e[41] !== w || e[42] !== i ? (R = /* @__PURE__ */ F(Xc, { ...c, "data-slot": "avatar", "data-variant": i, role: m, "aria-label": f, "aria-hidden": h, className: b, children: [
    v,
    w
  ] }), e[35] = f, e[36] = c, e[37] = m, e[38] = h, e[39] = b, e[40] = v, e[41] = w, e[42] = i, e[43] = R) : R = e[43], R;
}
function na() {
  return typeof window < "u";
}
function un(t) {
  return Vu(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function wt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function bo(t) {
  var e;
  return (e = (Vu(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Vu(t) {
  return na() ? t instanceof Node || t instanceof wt(t).Node : !1;
}
function pt(t) {
  return na() ? t instanceof Element || t instanceof wt(t).Element : !1;
}
function Ct(t) {
  return na() ? t instanceof HTMLElement || t instanceof wt(t).HTMLElement : !1;
}
function Kr(t) {
  return !na() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof wt(t).ShadowRoot;
}
function Jo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = gn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function I5(t) {
  return /^(table|td|th)$/.test(un(t));
}
function oa(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const P5 = /transform|translate|scale|rotate|perspective|filter/, M5 = /paint|layout|strict|content/, rr = (t) => !!t && t !== "none";
let Za;
function Au(t) {
  const e = pt(t) ? gn(t) : t;
  return rr(e.transform) || rr(e.translate) || rr(e.scale) || rr(e.rotate) || rr(e.perspective) || !ra() && (rr(e.backdropFilter) || rr(e.filter)) || P5.test(e.willChange || "") || M5.test(e.contain || "");
}
function T5(t) {
  let e = mo(t);
  for (; Ct(e) && !ao(e); ) {
    if (Au(e))
      return e;
    if (oa(e))
      return null;
    e = mo(e);
  }
  return null;
}
function ra() {
  return Za == null && (Za = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Za;
}
function ao(t) {
  return /^(html|body|#document)$/.test(un(t));
}
function gn(t) {
  return wt(t).getComputedStyle(t);
}
function ia(t) {
  return pt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function mo(t) {
  if (un(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Kr(t) && t.host || // Fallback.
    bo(t)
  );
  return Kr(e) ? e.host : e;
}
function zg(t) {
  const e = mo(t);
  return ao(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Ct(e) && Jo(e) ? e : zg(e);
}
function Gi(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = zg(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = wt(r);
  if (i) {
    const l = Qc(s);
    return e.concat(s, s.visualViewport || [], Jo(r) ? r : [], l && n ? Gi(l) : []);
  } else
    return e.concat(r, Gi(r, [], n));
}
function Qc(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
let Jc;
process.env.NODE_ENV !== "production" && (Jc = /* @__PURE__ */ new Set());
function Ko(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Jc.has(e) || (Jc.add(e), console.error(`Base UI: ${e}`));
  }
}
const mr = {
  ...x
}, Lu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lu.displayName = "CompositeRootContext");
function Fu(t = !1) {
  const e = x.useContext(Lu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : tt(16));
  return e;
}
function O5(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: i
  } = t, s = o && e !== !1, l = o && e === !1;
  return {
    props: x.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !i && n && (c.tabIndex = e ? r : -1)), (i && (e || s) || !i && n) && (c["aria-disabled"] = n), i && (!e || l) && (c.disabled = n), c;
    }, [o, n, e, s, l, i, r])
  };
}
function Wt(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0,
    composite: i
  } = t, s = x.useRef(null), l = Fu(!0), a = i ?? l !== void 0, {
    props: c
  } = O5({
    focusableWhenDisabled: n,
    disabled: e,
    composite: a,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!s.current)
      return;
    const p = Gs(s.current);
    if (r) {
      if (!p) {
        const m = mr.captureOwnerStack?.() || "";
        Ko(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${m}`);
      }
    } else if (p) {
      const m = mr.captureOwnerStack?.() || "";
      Ko(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${m}`);
    }
  }, [r]);
  const u = x.useCallback(() => {
    const p = s.current;
    Gs(p) && a && e && c.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, c.disabled, a]);
  Ne(u, [u]);
  const d = x.useCallback((p = {}) => {
    const {
      onClick: m,
      onMouseDown: h,
      onKeyUp: b,
      onKeyDown: v,
      onPointerDown: C,
      ...y
    } = p;
    return Jt({
      type: r ? "button" : void 0,
      onClick(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        m?.(R);
      },
      onMouseDown(R) {
        e || h?.(R);
      },
      onKeyDown(R) {
        if (e || (Ol(R), v?.(R), R.baseUIHandlerPrevented))
          return;
        const S = R.target === R.currentTarget, E = R.currentTarget, N = Gs(E), M = !r && D5(E), T = S && (r ? N : !M), P = R.key === "Enter", k = R.key === " ", I = E.getAttribute("role"), D = I?.startsWith("menuitem") || I === "option" || I === "gridcell";
        if (S && a && k) {
          if (R.defaultPrevented && D)
            return;
          R.preventDefault(), M || r && N ? (E.click(), R.preventBaseUIHandler()) : T && (m?.(R), R.preventBaseUIHandler());
          return;
        }
        T && (!r && (k || P) && R.preventDefault(), !r && P && m?.(R));
      },
      onKeyUp(R) {
        if (!e) {
          if (Ol(R), b?.(R), R.target === R.currentTarget && r && a && Gs(R.currentTarget) && R.key === " ") {
            R.preventDefault();
            return;
          }
          R.baseUIHandlerPrevented || R.target === R.currentTarget && !r && !a && R.key === " " && m?.(R);
        }
      },
      onPointerDown(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        C?.(R);
      }
    }, r ? void 0 : {
      role: "button"
    }, c, y);
  }, [e, c, a, r]), f = Ce((p) => {
    s.current = p, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function Gs(t) {
  return Ct(t) && t.tagName === "BUTTON";
}
function D5(t) {
  return !!(t?.tagName === "A" && t?.href);
}
const Qn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    focusableWhenDisabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    getButtonProps: u,
    buttonRef: d
  } = Wt({
    disabled: i,
    focusableWhenDisabled: s,
    native: l
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, d],
    props: [c, u]
  });
});
process.env.NODE_ENV !== "production" && (Qn.displayName = "Button");
function $u(t) {
  const e = B.c(2), {
    size: n
  } = t, o = n === void 0 ? "sm" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "aw-spinner inline-flex", "aria-hidden": "true", children: /* @__PURE__ */ g(We, { name: "button-load-spinner", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
const _5 = ae(["inline-flex", "items-center", "justify-center", "whitespace-nowrap", "shrink-0", "rounded-(--radius-sm)", "px-(--spacing-12)", "border", "border-solid", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-[background,color,box-shadow]", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "conversation-ui": ["bg-button-primary-conversation-ui-background", "text-button-primary-conversation-ui-text", "border-button-primary-conversation-ui-background", "hover:bg-button-primary-conversation-ui-background", "hover:border-button-primary-conversation-ui-background", "active:bg-button-primary-conversation-ui-background", "active:border-button-primary-conversation-ui-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-outline": ["aw-ai-button--outline", "bg-surface", "border-transparent", "text-text-default", "hover:bg-button-outline-hover-background", "active:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-ghost": ["border-transparent", "bg-transparent", "text-text-default", "hover:bg-surface-hover", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["h-(--spacing-32)", "gap-(--spacing-8)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"],
      md: ["h-(--spacing-40)", "gap-(--spacing-8)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"],
      lg: ["h-[44px]", "gap-(--spacing-8)", "px-(--spacing-16)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "sm",
    class: ["text-(length:--font-size-body-large)", "leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "md",
    class: ["leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "lg",
    class: ["px-(--spacing-12)", "leading-(--font-line-height-20)"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function V5() {
  const t = B.c(44), e = At();
  let n;
  if (t[0] !== e) {
    let Y;
    t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = /:/g, t[2] = Y) : Y = t[2], n = e.replace(Y, ""), t[0] = e, t[1] = n;
  } else
    n = t[1];
  const o = n, r = `ai-button-gradient-${o}`, i = `ai-button-shimmer-${o}`, s = `ai-button-glow-${o}`;
  let l, a, c;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), a = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), c = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), t[3] = l, t[4] = a, t[5] = c) : (l = t[3], a = t[4], c = t[5]);
  let u;
  t[6] !== r ? (u = /* @__PURE__ */ F("linearGradient", { id: r, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    l,
    a,
    c
  ] }), t[6] = r, t[7] = u) : u = t[7];
  let d, f, p, m, h, b;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("stop", { offset: "0%", stopColor: "hsl(var(--primary-primary))", stopOpacity: "0" }), m = /* @__PURE__ */ g("stop", { offset: "30%", stopColor: "hsl(var(--primary-primary-container))", stopOpacity: "0" }), h = /* @__PURE__ */ g("stop", { offset: "46%", stopColor: "hsl(var(--gradients-ai-gradient-01))", stopOpacity: "0.9" }), b = /* @__PURE__ */ g("stop", { offset: "70%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), d = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), f = /* @__PURE__ */ g("animateTransform", { attributeName: "gradientTransform", type: "rotate", from: "-12 .5 .5", to: "348 .5 .5", dur: "3.25s", repeatCount: "indefinite" }), t[8] = d, t[9] = f, t[10] = p, t[11] = m, t[12] = h, t[13] = b) : (d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], b = t[13]);
  let v;
  t[14] !== i ? (v = /* @__PURE__ */ F("linearGradient", { id: i, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    p,
    m,
    h,
    b,
    d,
    f
  ] }), t[14] = i, t[15] = v) : v = t[15];
  let C, y, w, R;
  t[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "0.8", result: "haloBlur" }), y = /* @__PURE__ */ g("feFlood", { floodColor: "hsl(var(--gradients-ai-gradient-01))", floodOpacity: "0.4", result: "haloColor" }), w = /* @__PURE__ */ g("feComposite", { in: "haloColor", in2: "haloBlur", operator: "in", result: "halo" }), R = /* @__PURE__ */ g("feMerge", { children: /* @__PURE__ */ g("feMergeNode", { in: "halo" }) }), t[16] = C, t[17] = y, t[18] = w, t[19] = R) : (C = t[16], y = t[17], w = t[18], R = t[19]);
  let S;
  t[20] !== s ? (S = /* @__PURE__ */ F("filter", { id: s, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", filterUnits: "userSpaceOnUse", children: [
    C,
    y,
    w,
    R
  ] }), t[20] = s, t[21] = S) : S = t[21];
  const E = `${s}-outside`;
  let N, M;
  t[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g("rect", { x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", fill: "white" }), M = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "black" }), t[22] = N, t[23] = M) : (N = t[22], M = t[23]);
  let T;
  t[24] !== E ? (T = /* @__PURE__ */ F("mask", { id: E, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", maskUnits: "userSpaceOnUse", children: [
    N,
    M
  ] }), t[24] = E, t[25] = T) : T = t[25];
  let P;
  t[26] !== v || t[27] !== S || t[28] !== T || t[29] !== u ? (P = /* @__PURE__ */ F("defs", { children: [
    u,
    v,
    S,
    T
  ] }), t[26] = v, t[27] = S, t[28] = T, t[29] = u, t[30] = P) : P = t[30];
  const k = `url(#${s}-outside)`, I = `url(#${s})`;
  let D;
  t[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: "hsl(var(--gradients-ai-gradient-01))", strokeWidth: "4" }), t[31] = D) : D = t[31];
  let O;
  t[32] !== k || t[33] !== I ? (O = /* @__PURE__ */ g("g", { mask: k, filter: I, children: D }), t[32] = k, t[33] = I, t[34] = O) : O = t[34];
  const V = `url(#${r})`;
  let _;
  t[35] !== V ? (_ = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: V, strokeWidth: "1" }), t[35] = V, t[36] = _) : _ = t[36];
  const L = `url(#${i})`;
  let A;
  t[37] !== L ? (A = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border aw-ai-button__highlight", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: L, strokeWidth: "1.5" }), t[37] = L, t[38] = A) : A = t[38];
  let $;
  return t[39] !== P || t[40] !== O || t[41] !== _ || t[42] !== A ? ($ = /* @__PURE__ */ F("svg", { className: "pointer-events-none absolute inset-0 z-0 size-full overflow-visible", "aria-hidden": "true", focusable: "false", children: [
    P,
    O,
    _,
    A
  ] }), t[39] = P, t[40] = O, t[41] = _, t[42] = A, t[43] = $) : $ = t[43], $;
}
function Hu(t) {
  const e = B.c(42);
  let n, o, r, i, s, l, a, c, u, d;
  e[0] !== t ? ({
    children: n,
    variant: d,
    intent: r,
    size: l,
    icon: o,
    loading: a,
    loadingText: i,
    fullWidth: c,
    disabled: u,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10]);
  const f = a === void 0 ? !1 : a, p = c === void 0 ? !1 : c, m = u === void 0 ? !1 : u, h = m || f, b = d === "ai-outline" || d === "ai-ghost", v = d === "ai-outline", y = f ? `${i ?? (b ? "Thinking" : "Loading")}...` : n;
  let w;
  e[11] !== o || e[12] !== b || e[13] !== f ? (w = f ? /* @__PURE__ */ g($u, { size: "sm" }) : b ? /* @__PURE__ */ g("span", { className: "inline-flex size-(--icon-sm) shrink-0 overflow-hidden", "aria-hidden": "true", children: /* @__PURE__ */ g(Pu, { className: "block size-(--icon-sm) shrink-0", size: "sm" }) }) : o ? /* @__PURE__ */ g(We, { name: o, size: "sm", tone: "inherit" }) : null, e[11] = o, e[12] = b, e[13] = f, e[14] = w) : w = e[14];
  let R;
  e[15] !== y || e[16] !== w ? (R = /* @__PURE__ */ F(Vt, { children: [
    y,
    w
  ] }), e[15] = y, e[16] = w, e[17] = R) : R = e[17];
  const S = R;
  let E;
  e[18] !== m || e[19] !== p || e[20] !== r || e[21] !== h || e[22] !== f || e[23] !== l || e[24] !== d ? (E = ne(_5({
    variant: d,
    intent: r,
    size: l
  }), p && "w-full", h && "opacity-40 pointer-events-none", m && "cursor-not-allowed", f && !m && "cursor-default"), e[18] = m, e[19] = p, e[20] = r, e[21] = h, e[22] = f, e[23] = l, e[24] = d, e[25] = E) : E = e[25];
  const N = h || void 0, M = f || void 0, T = h ? -1 : void 0;
  let P;
  e[26] !== v ? (P = v ? /* @__PURE__ */ g(V5, {}) : null, e[26] = v, e[27] = P) : P = e[27];
  let k;
  e[28] !== S || e[29] !== b ? (k = b ? /* @__PURE__ */ g("span", { className: "relative z-10 inline-flex items-center gap-(--spacing-8)", children: S }) : S, e[28] = S, e[29] = b, e[30] = k) : k = e[30];
  let I;
  return e[31] !== h || e[32] !== s || e[33] !== l || e[34] !== T || e[35] !== P || e[36] !== k || e[37] !== E || e[38] !== N || e[39] !== M || e[40] !== d ? (I = /* @__PURE__ */ F(Qn, { "data-slot": "button", "data-variant": d, "data-size": l, className: E, disabled: h, "aria-disabled": N, "aria-busy": M, tabIndex: T, ...s, children: [
    P,
    k
  ] }), e[31] = h, e[32] = s, e[33] = l, e[34] = T, e[35] = P, e[36] = k, e[37] = E, e[38] = N, e[39] = M, e[40] = d, e[41] = I) : I = e[41], I;
}
function tn(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Hu, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function H1(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Hu, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function A5(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Hu, { ...t, variant: "conversation-ui" }), e[0] = t, e[1] = n) : n = e[1], n;
}
const sa = ho({
  align: "start"
}), L5 = ae(["flex", "w-full", "min-w-0", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "justify-start",
      end: "justify-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), F5 = ae(["flex", "min-w-0", "w-full", "max-w-[520px]", "flex-col", "gap-(--spacing-4)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), $5 = ae(["flex", "items-center", "gap-(--spacing-6)", "px-(--spacing-2)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default"]), H5 = ae(["flex", "items-center", "min-w-0", "w-full", "gap-(--spacing-8)"]), z5 = ae(["flex", "w-full", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), B5 = ae(["max-w-full", "break-words", "whitespace-pre-wrap", "rounded-(--radius-sm)", "p-(--spacing-16)", "shadow-elevation-1", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      inbound: ["w-fit", "bg-surface-container", "text-text-default"],
      outbound: ["w-fit", "bg-surface-container", "text-text-default"],
      system: ["w-full", "bg-surface-container", "text-text-default"],
      informative: ["w-full", "bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "inbound"
  }
}), W5 = ae(["flex", "w-full", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "px-(--spacing-16)", "py-(--spacing-8)", "text-center", "font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      default: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      informative: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      positive: ["border-positive-on-container", "bg-positive-container", "text-positive-on-container"],
      warning: ["border-warning-on-container", "bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["border-negative-on-container", "bg-negative-container", "text-negative-on-container"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function eu(t) {
  const e = B.c(18);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    direction: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = o === "outbound" ? "end" : "start";
  let s;
  e[4] !== o || e[5] !== i ? (s = {
    align: i,
    direction: o
  }, e[4] = o, e[5] = i, e[6] = s) : s = e[6];
  let l;
  e[7] !== i ? (l = ne(L5({
    align: i
  })), e[7] = i, e[8] = l) : l = e[8];
  let a;
  e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== i || e[13] !== l ? (a = /* @__PURE__ */ g("article", { "data-slot": "chat-message", "data-align": i, "data-direction": o, className: l, ...r, children: n }), e[9] = n, e[10] = o, e[11] = r, e[12] = i, e[13] = l, e[14] = a) : a = e[14];
  let c;
  return e[15] !== s || e[16] !== a ? (c = /* @__PURE__ */ g(sa, { value: s, children: a }), e[15] = s, e[16] = a, e[17] = c) : c = e[17], c;
}
function Bg(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g("div", { "data-slot": "chat-message-avatar", className: "shrink-0", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function tu(t) {
  const e = B.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = dn(sa);
  let i;
  e[3] !== r ? (i = ne(F5({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { "data-slot": "chat-message-content", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function Wg(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne($5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-message-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function z1(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(H5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-message-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function U5(t) {
  const e = B.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = dn(sa);
  let i;
  e[3] !== r ? (i = ne(z5({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { "data-slot": "chat-message-group", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function nu(t) {
  const e = B.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tone: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const {
    direction: i
  } = dn(sa), s = r ?? i ?? "inbound";
  let l;
  e[4] !== s ? (l = ne(B5({
    tone: s
  })), e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== n || e[7] !== o || e[8] !== s || e[9] !== l ? (a = /* @__PURE__ */ g("div", { "data-slot": "chat-bubble", "data-tone": s, className: l, ...o, children: n }), e[6] = n, e[7] = o, e[8] = s, e[9] = l, e[10] = a) : a = e[10], a;
}
function G5(t) {
  const e = B.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    live: r,
    tone: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "polite" : r, l = i === void 0 ? "default" : i;
  let a;
  e[5] !== l ? (a = ne(W5({
    tone: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== s || e[9] !== o || e[10] !== a || e[11] !== l ? (c = /* @__PURE__ */ g("output", { "data-slot": "chat-status", "data-tone": l, "aria-live": s, className: a, ...o, children: n }), e[7] = n, e[8] = s, e[9] = o, e[10] = a, e[11] = l, e[12] = c) : c = e[12], c;
}
const Y5 = ae(["inline-flex", "items-center", "justify-center", "shrink-0", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["size-(--spacing-32)"],
      md: ["size-(--spacing-40)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function gt(t) {
  const e = B.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: n,
    variant: a,
    intent: o,
    size: i,
    loading: s,
    disabled: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? !1 : s, u = l === void 0 ? !1 : l, d = u || c;
  let f;
  e[8] !== u || e[9] !== o || e[10] !== d || e[11] !== c || e[12] !== i || e[13] !== a ? (f = ne(Y5({
    variant: a,
    intent: o,
    size: i
  }), d && "opacity-40 pointer-events-none", u && "cursor-not-allowed", c && !u && "cursor-default"), e[8] = u, e[9] = o, e[10] = d, e[11] = c, e[12] = i, e[13] = a, e[14] = f) : f = e[14];
  const p = d || void 0, m = c || void 0, h = d ? -1 : void 0;
  let b;
  e[15] !== n || e[16] !== c ? (b = c ? /* @__PURE__ */ g($u, { size: "sm" }) : /* @__PURE__ */ g(We, { name: n, size: "sm", tone: "inherit" }), e[15] = n, e[16] = c, e[17] = b) : b = e[17];
  let v;
  return e[18] !== d || e[19] !== r || e[20] !== i || e[21] !== f || e[22] !== p || e[23] !== m || e[24] !== h || e[25] !== b || e[26] !== a ? (v = /* @__PURE__ */ g(Qn, { "data-slot": "icon-button", "data-variant": a, "data-size": i, className: f, disabled: d, "aria-disabled": p, "aria-busy": m, tabIndex: h, ...r, children: b }), e[18] = d, e[19] = r, e[20] = i, e[21] = f, e[22] = p, e[23] = m, e[24] = h, e[25] = b, e[26] = a, e[27] = v) : v = e[27], v;
}
const j5 = ae(["aw-chat-scroller", "group", "relative", "flex", "h-full", "min-h-0", "min-w-0", "flex-1", "flex-col"]), K5 = ae(["min-h-0", "min-w-0", "flex-1", "overflow-x-hidden", "overflow-y-auto", "px-(--spacing-12)", "py-(--spacing-12)", "outline-none", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-button-focus-ring"]), q5 = ae(["flex", "flex-col", "min-w-0", "gap-(--spacing-20)"]), Z5 = ae(["min-w-0"]), X5 = ae(["absolute", "bottom-(--spacing-16)", "left-1/2", "z-10", "-translate-x-1/2", "hidden", "group-data-[scrollable~='end']:block"]);
function Ug(t) {
  const e = B.c(19);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    children: n,
    autoScroll: l,
    defaultScrollPosition: a,
    scrollEdgeThreshold: r,
    scrollPreviousItemPeek: s,
    scrollMargin: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !0 : l, u = a === void 0 ? "end" : a;
  let d;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(j5()), e[8] = d) : d = e[8];
  let f;
  e[9] !== n || e[10] !== o ? (f = /* @__PURE__ */ g(Yr.Root, { "data-slot": "chat-scroller", className: d, ...o, children: n }), e[9] = n, e[10] = o, e[11] = f) : f = e[11];
  let p;
  return e[12] !== c || e[13] !== u || e[14] !== r || e[15] !== i || e[16] !== s || e[17] !== f ? (p = /* @__PURE__ */ g(Yr.Provider, { autoScroll: c, defaultScrollPosition: u, scrollEdgeThreshold: r, scrollPreviousItemPeek: s, scrollMargin: i, children: f }), e[12] = c, e[13] = u, e[14] = r, e[15] = i, e[16] = s, e[17] = f, e[18] = p) : p = e[18], p;
}
function Gg(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(K5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Yr.Viewport, { "data-slot": "chat-scroller-viewport", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Yg(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(q5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Yr.Content, { "data-slot": "chat-scroller-content", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Hi(t) {
  const e = B.c(9);
  let n, o, r;
  e[0] !== t ? ({
    messageId: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(Z5()), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = /* @__PURE__ */ g(Yr.Item, { "data-slot": "chat-scroller-item", messageId: o, className: i, ...r, children: n }), e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], s;
}
function jg(t) {
  const e = B.c(9);
  let n, o;
  e[0] !== t ? ({
    "aria-label": o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "Jump to latest message" : o;
  let i;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(X5()), e[3] = i) : i = e[3];
  let s;
  e[4] !== r ? (s = /* @__PURE__ */ g(gt, { icon: "chevron-down", "aria-label": r, variant: "outline", size: "sm" }), e[4] = r, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== s ? (l = /* @__PURE__ */ g("div", { "data-slot": "chat-scroller-jump-to-latest", className: i, children: /* @__PURE__ */ g(Yr.Button, { direction: "end", render: s, ...n }) }), e[6] = n, e[7] = s, e[8] = l) : l = e[8], l;
}
const Q5 = {
  default: "border-outline-subtle",
  high: "border-outline opacity-60"
}, J5 = {
  horizontal: {
    "full-width": "",
    inset: "pl-(--spacing-16)",
    "middle-inset": "px-(--spacing-16)"
  },
  vertical: {
    "full-width": "",
    inset: "pt-(--spacing-16)",
    "middle-inset": "py-(--spacing-16)"
  }
}, B1 = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap"]);
function gr(t) {
  const e = B.c(52);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    orientation: i,
    variant: s,
    subheader: r,
    centeredText: n,
    emphasis: l,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "horizontal" : i, c = s === void 0 ? "full-width" : s, u = l === void 0 ? "default" : l, d = a === "vertical", f = Q5[u], p = d ? "border-l" : "border-t", m = J5[a][c];
  if (!d && n) {
    let w;
    e[7] !== f || e[8] !== p ? (w = ne("grow", p, f), e[7] = f, e[8] = p, e[9] = w) : w = e[9];
    let R;
    e[10] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[10] = w, e[11] = R) : R = e[11];
    let S;
    e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(B1(), "shrink-0", "text-(length:--font-size-body-small)"), e[12] = S) : S = e[12];
    let E;
    e[13] !== n || e[14] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: n }), e[13] = n, e[14] = S, e[15] = E) : E = e[15];
    let N;
    e[16] !== f || e[17] !== p ? (N = ne("grow", p, f), e[16] = f, e[17] = p, e[18] = N) : N = e[18];
    let M;
    e[19] !== N ? (M = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: N }), e[19] = N, e[20] = M) : M = e[20];
    let T;
    return e[21] !== o || e[22] !== R || e[23] !== E || e[24] !== M ? (T = /* @__PURE__ */ F("div", { ...o, className: "flex items-center gap-(--spacing-6)", children: [
      R,
      E,
      M
    ] }), e[21] = o, e[22] = R, e[23] = E, e[24] = M, e[25] = T) : T = e[25], T;
  }
  if (!d && r) {
    let w;
    e[26] !== f || e[27] !== p ? (w = ne("w-full", p, f), e[26] = f, e[27] = p, e[28] = w) : w = e[28];
    let R;
    e[29] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[29] = w, e[30] = R) : R = e[30];
    let S;
    e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(B1(), "shrink-0", "text-(length:--font-size-body-medium)"), e[31] = S) : S = e[31];
    let E;
    e[32] !== r || e[33] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: r }), e[32] = r, e[33] = S, e[34] = E) : E = e[34];
    let N;
    return e[35] !== o || e[36] !== R || e[37] !== E ? (N = /* @__PURE__ */ F("div", { ...o, className: "flex flex-col gap-(--spacing-4) px-(--spacing-16)", children: [
      R,
      E
    ] }), e[35] = o, e[36] = R, e[37] = E, e[38] = N) : N = e[38], N;
  }
  const h = d ? "flex-col" : "flex-row";
  let b;
  e[39] !== m || e[40] !== h ? (b = ne("flex", h, m), e[39] = m, e[40] = h, e[41] = b) : b = e[41];
  let v;
  e[42] !== f || e[43] !== p ? (v = ne("grow", p, f), e[42] = f, e[43] = p, e[44] = v) : v = e[44];
  let C;
  e[45] !== a || e[46] !== v ? (C = /* @__PURE__ */ g("hr", { "aria-orientation": a, className: v }), e[45] = a, e[46] = v, e[47] = C) : C = e[47];
  let y;
  return e[48] !== o || e[49] !== b || e[50] !== C ? (y = /* @__PURE__ */ g("div", { ...o, className: b, children: C }), e[48] = o, e[49] = b, e[50] = C, e[51] = y) : y = e[51], y;
}
function e8(t) {
  const e = B.c(7);
  let n, o, r, i, s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.3918 80.2045L20.2608 86.5396H24.3507L14.0566 64.5386H10.2275L0 86.5396H3.86238L6.73141 80.2045H17.3918ZM16.1043 77.3364H7.98557L12.0089 68.333L16.0988 77.3364H16.1043ZM41.9423 75.356C41.5483 71.5949 39.0733 69.8474 34.2564 69.8474C29.4395 69.8474 26.5982 71.728 26.5982 74.8623C26.5982 76.5764 27.586 78.0299 29.1731 78.6567C30.2608 79.0839 31.0877 79.2836 34.2231 79.7773C36.4872 80.1286 37.8283 80.3931 38.2464 80.5706C38.8735 80.8369 39.2342 81.3971 39.2342 82.0573C39.2342 83.5773 37.5194 84.4316 34.4173 84.4316C31.3152 84.4316 29.434 83.3443 29.2009 81.264H25.8657C26.4928 85.2249 29.101 86.9723 34.3785 86.9723C39.6559 86.9723 42.5305 85.125 42.5305 81.7244C42.5305 80.271 41.97 79.1172 40.9489 78.3627C39.9945 77.6693 39.4007 77.5362 34.9778 76.8427C32.2697 76.4156 31.6759 76.3157 31.0155 76.0494C30.2886 75.7832 29.7947 75.1896 29.7947 74.5627C29.7947 73.2425 31.5094 72.3882 34.0844 72.3882C37.02 72.3882 38.4406 73.309 38.7014 75.356H41.9367H41.9423ZM61.5039 75.356C61.1099 71.5949 58.6349 69.8474 53.8124 69.8474C48.99 69.8474 46.1543 71.728 46.1543 74.8623C46.1543 76.5764 47.1421 78.0299 48.7292 78.6567C49.8169 79.0839 50.6437 79.2836 53.7791 79.7773C56.0433 80.1286 57.3844 80.3931 57.8024 80.5706C58.4295 80.8369 58.7902 81.3971 58.7902 82.0573C58.7902 83.5773 57.0755 84.4316 53.9734 84.4316C50.8713 84.4316 48.99 83.3443 48.7569 81.264H45.4218C46.0488 85.2249 48.6571 86.9723 53.9345 86.9723C59.212 86.9723 62.0866 85.125 62.0866 81.7244C62.0866 80.271 61.5261 79.1172 60.505 78.3627C59.5505 77.6693 58.9567 77.5362 54.5339 76.8427C51.8257 76.4156 51.232 76.3157 50.5716 76.0494C49.8446 75.7832 49.3507 75.1896 49.3507 74.5627C49.3507 73.2425 51.0655 72.3882 53.6404 72.3882C56.576 72.3882 57.9967 73.309 58.2575 75.356H61.4928H61.5039ZM83.1521 79.3502C83.1521 77.3364 82.919 76.0827 82.3585 74.7014C81.1043 71.667 77.9689 69.853 74.0732 69.853C68.6959 69.853 64.9667 73.3811 64.9667 78.4959C64.9667 83.6106 68.596 86.9723 74.0067 86.9723C78.3296 86.9723 81.232 85.1583 82.8524 81.4637H79.3896C78.5627 83.4441 76.8479 84.4316 74.3063 84.4316C70.7769 84.4316 68.4018 82.4844 68.0688 79.3502H83.1465H83.1521ZM68.1687 76.8427C68.929 73.9747 71.0377 72.3549 74.0455 72.3549C77.0533 72.3549 79.162 73.9692 79.8835 76.8427H68.1687ZM90.9822 65.759H87.7802V70.2801H85.6659V72.9207H87.7802V82.3901C87.7802 84.4704 87.9467 85.1916 88.6071 85.8184C89.3008 86.5119 90.5549 86.8724 92.1698 86.8724C92.9634 86.8724 93.5572 86.8059 94.778 86.6394V83.9656C94.0178 84.0987 93.6903 84.132 93.03 84.132C91.3818 84.132 90.9822 83.7714 90.9822 82.2847V72.9152H94.778V70.2746H90.9822V65.7535V65.759ZM123.069 86.5396L130.494 64.5386H127.031L121.226 82.6841L115.022 64.5386H111.193L105.022 82.6841L99.3785 64.5386H95.5494L102.941 86.5396H106.87L113.041 68.2664L119.345 86.5396H123.074H123.069ZM135.305 75.6556C135.538 73.248 136.92 72.3549 140.422 72.3549C143.391 72.3549 144.811 73.1482 144.811 74.8956C144.811 75.7221 144.417 76.2159 143.524 76.5099C142.697 76.7762 142.203 76.8427 139.301 77.1367C135.905 77.4973 135.178 77.6637 133.99 78.1907C132.469 78.8842 131.515 80.3986 131.515 82.1516C131.515 85.1527 133.923 87 137.852 87C140.788 87 142.836 86.2067 144.817 84.3262C145.444 86.1402 146.371 86.767 148.38 86.767C149.073 86.767 149.467 86.7005 150.061 86.5008V84.3262C149.795 84.3595 149.534 84.3928 149.334 84.3928C148.246 84.426 147.847 83.8657 147.847 82.2792V75.0565C147.847 73.076 147.386 71.9555 146.265 71.1955C144.911 70.269 142.963 69.8419 140.294 69.8419C136.926 69.8419 134.551 70.7017 133.23 72.3826C132.569 73.2092 132.275 74.0635 132.109 75.65H135.311L135.305 75.6556ZM144.806 79.744C144.806 81.2917 144.573 81.9186 143.651 82.8117C142.497 83.899 140.877 84.4593 138.735 84.4593C136.127 84.4593 134.806 83.5995 134.806 81.9519C134.806 80.4652 135.699 79.9049 138.568 79.6109C141.143 79.3446 143.024 78.984 144.806 78.4237V79.744ZM156.748 65.759H153.546V70.2801H151.432V72.9207H153.546V82.3901C153.546 84.4704 153.713 85.1916 154.373 85.8184C155.067 86.5119 156.321 86.8724 157.936 86.8724C158.729 86.8724 159.323 86.8059 160.544 86.6394V83.9656C159.784 84.0987 159.456 84.132 158.796 84.132C157.148 84.132 156.748 83.7714 156.748 82.2847V72.9152H160.544V70.2746H156.748V65.7535V65.759ZM176.759 80.6372C175.999 83.1779 174.351 84.4316 171.709 84.4316C168.08 84.4316 165.871 82.1571 165.871 78.3627C165.871 74.5683 168.019 72.3604 171.681 72.3604C174.223 72.3604 175.938 73.481 176.665 75.6278H179.767C178.94 71.9998 175.938 69.853 171.615 69.853C166.104 69.853 162.669 73.1537 162.669 78.4959C162.669 83.838 166.038 86.9723 171.615 86.9723C176.038 86.9723 179.04 84.6979 179.895 80.6372H176.759ZM183.862 86.5396H187.064V77.0702C187.064 74.596 189.639 72.549 192.775 72.549C193.962 72.549 194.95 72.8486 195.677 73.4422C196.537 74.1356 196.798 74.7957 196.798 76.41V86.5396H200V76.1826C200 73.775 199.573 72.5213 198.452 71.5339C197.231 70.4466 195.45 69.853 193.402 69.853C190.76 69.853 189.145 70.5464 187.064 72.5879V64.5386H183.862V86.5396Z" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.5202 30.3223L58.0352 45.2171H69.2338C71.0429 45.2171 72.8243 44.7344 74.3892 43.8247C75.9541 42.9149 77.2527 41.6001 78.1406 40.0247L83.6345 30.3223H66.5091H66.5202Z" }), r = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78.0688 20.1038L89.3841 40.0356C90.2775 41.6111 91.5705 42.9203 93.1354 43.8301C94.7004 44.7398 96.4762 45.2225 98.2908 45.2169H109.501L83.757 0L78.0744 9.97979C77.1976 11.522 76.7314 13.2639 76.7314 15.039C76.7314 16.8142 77.192 18.5561 78.0688 20.0983V20.1038Z" }), i = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M109.5 0L103.818 9.97979C102.941 11.522 102.48 13.2639 102.48 15.039C102.48 16.8142 102.941 18.5561 103.818 20.0983L115.139 40.0301C116.032 41.6056 117.325 42.9092 118.89 43.8245C120.455 44.7343 122.231 45.2169 124.04 45.2169H135.25L109.5 0Z" }), s = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.245 0L129.562 9.97979C128.685 11.522 128.225 13.2694 128.225 15.039C128.225 16.8086 128.685 18.5561 129.562 20.0983L135.245 30.078L143.807 15.0335L135.245 0Z" }), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s) : (n = e[0], o = e[1], r = e[2], i = e[3], s = e[4]);
  let l;
  return e[5] !== t ? (l = /* @__PURE__ */ F("svg", { width: "200", height: "87", viewBox: "0 0 200 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    n,
    o,
    r,
    i,
    s
  ] }), e[5] = t, e[6] = l) : l = e[6], l;
}
const W1 = {
  default: "fill-surface-inverse-surface",
  primary: "fill-primary"
}, t8 = {
  default: {
    width: 44,
    height: 23.21
  },
  compact: {
    width: 24.16,
    height: 12.74
  },
  display: {
    width: 90,
    height: 47.47
  },
  stacked: {
    width: 200,
    height: 87
  }
};
function n8(t) {
  const e = B.c(29);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    size: s,
    style: i,
    tone: l,
    "aria-label": o,
    "aria-hidden": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "default" : s, c = !o, u = t8[a], d = l ?? "primary";
  if (a === "stacked") {
    const C = W1[d], y = n ?? (c ? !0 : void 0), w = c ? void 0 : "img";
    let R;
    e[7] !== i ? (R = {
      flexShrink: 0,
      ...i
    }, e[7] = i, e[8] = R) : R = e[8];
    let S;
    return e[9] !== o || e[10] !== r || e[11] !== C || e[12] !== y || e[13] !== w || e[14] !== R ? (S = /* @__PURE__ */ g(e8, { ...r, className: C, "aria-hidden": y, "aria-label": o, role: w, style: R }), e[9] = o, e[10] = r, e[11] = C, e[12] = y, e[13] = w, e[14] = R, e[15] = S) : S = e[15], S;
  }
  const f = n ?? (c ? !0 : void 0), p = c ? void 0 : "img";
  let m;
  e[16] !== i ? (m = {
    flexShrink: 0,
    ...i
  }, e[16] = i, e[17] = m) : m = e[17];
  const h = W1[d];
  let b;
  e[18] !== h ? (b = /* @__PURE__ */ g("path", { d: "M10.3174 20.54C9.85932 21.349 9.19472 22.0221 8.3916 22.4902C7.58855 22.9583 6.67561 23.2051 5.74609 23.2051H0L4.35254 15.5615H13.1367L10.3174 20.54ZM26.4014 23.2051H20.6514C19.7228 23.2052 18.8103 22.9593 18.0078 22.4922C17.2054 22.0251 16.5415 21.3532 16.083 20.5459L10.2764 10.3164C9.8266 9.52465 9.59036 8.62933 9.59082 7.71875C9.59128 6.80816 9.82872 5.91337 10.2793 5.12207L13.1934 0L26.4014 23.2051ZM39.6104 23.2021H33.8613C32.9331 23.2021 32.021 22.9562 31.2188 22.4893C30.4164 22.0221 29.7514 21.3504 29.293 20.543L23.4863 10.3135C23.0366 9.52227 22.7998 8.62785 22.7998 7.71777C22.7998 6.8077 23.0366 5.91328 23.4863 5.12207L26.4014 0L39.6104 23.2021ZM44 7.71973L39.6084 15.4395L36.6934 10.3174C36.243 9.52576 36.0068 8.63047 36.0068 7.71973C36.0068 6.80898 36.243 5.91369 36.6934 5.12207L39.6084 0L44 7.71973Z", className: h }), e[18] = h, e[19] = b) : b = e[19];
  let v;
  return e[20] !== o || e[21] !== u.height || e[22] !== u.width || e[23] !== r || e[24] !== f || e[25] !== p || e[26] !== m || e[27] !== b ? (v = /* @__PURE__ */ g("svg", { ...r, width: u.width, height: u.height, viewBox: "0 0 44 23.21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": f, "aria-label": o, role: p, style: m, children: b }), e[20] = o, e[21] = u.height, e[22] = u.width, e[23] = r, e[24] = f, e[25] = p, e[26] = m, e[27] = b, e[28] = v) : v = e[28], v;
}
const zu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zu.displayName = "MenuPositionerContext");
function ss(t) {
  const e = x.useContext(zu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : tt(33));
  return e;
}
const Bu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bu.displayName = "MenuRootContext");
function Jn(t) {
  const e = x.useContext(Bu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : tt(36));
  return e;
}
let fn = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t.side = "data-side", t.align = "data-align", t;
})({}), Dl = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const o8 = {
  [Dl.popupOpen]: ""
}, r8 = {
  [Dl.popupOpen]: "",
  [Dl.pressed]: ""
}, i8 = {
  [fn.open]: ""
}, s8 = {
  [fn.closed]: ""
}, l8 = {
  [fn.anchorHidden]: ""
}, yr = {
  open(t) {
    return t ? o8 : null;
  }
}, Yi = {
  open(t) {
    return t ? r8 : null;
  }
}, In = {
  open(t) {
    return t ? i8 : s8;
  },
  anchorHidden(t) {
    return t ? l8 : null;
  }
}, Kg = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Kg.displayName = "ContextMenuRootContext");
function la(t = !0) {
  const e = x.useContext(Kg);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : tt(25));
  return e;
}
const Mt = "none", Zn = "trigger-press", Ft = "trigger-hover", fr = "trigger-focus", ls = "outside-press", Uo = "item-press", qg = "close-press", U1 = "clear-press", a8 = "chip-remove-press", Lr = "input-change", zo = "input-clear", Zg = "input-press", Mo = "focus-out", xr = "escape-key", c8 = "close-watcher", zr = "list-navigation", u8 = "pointer", Xg = "cancel-open", Vi = "sibling-open", d8 = "disabled", as = "imperative-action", Ys = "swipe", f8 = "window-resize";
function pn({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = x.useRef(t !== void 0), [i, s] = x.useState(e), l = r ? t : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      r !== (t !== void 0) && Ko([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = x.useRef(e);
    x.useEffect(() => {
      !r && G1(c) !== G1(e) && Ko([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [e]);
  }
  const a = x.useCallback((c) => {
    r || s(c);
  }, []);
  return [l, a];
}
function G1(t) {
  let e = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(t, function(i, s) {
      if (!(i === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof s == "bigint")
          return `__bigint__:${s}`;
        if (s !== null && typeof s == "object") {
          const l = n.get(s);
          if (l !== void 0)
            return `__object__:${l}`;
          n.set(s, e), e += 1;
        }
        return s;
      }
    }) ?? `__top__:${typeof t}`;
  } catch {
    return "__unserializable__";
  }
}
const Qg = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qg.displayName = "MenuCheckboxItemContext");
const Cr = typeof navigator < "u", Xa = p8(), Jg = g8(), Wu = m8(), Uu = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), Gu = (
  // iPads can claim to be MacIntel
  Xa.platform === "MacIntel" && Xa.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Xa.platform)
), Y1 = Cr && /firefox/i.test(Wu), eh = Cr && /apple/i.test(navigator.vendor), ji = Cr && /android/i.test(Jg) || /android/i.test(Wu), th = Cr && Jg.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, nh = Wu.includes("jsdom/");
function p8() {
  if (!Cr)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function m8() {
  if (!Cr)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function g8() {
  if (!Cr)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
function h8(t) {
  const {
    closeOnClick: e,
    highlighted: n,
    id: o,
    nodeId: r,
    store: i,
    typingRef: s,
    itemRef: l,
    itemMetadata: a
  } = t, {
    events: c
  } = i.useState("floatingTreeRoot"), u = la(!0), d = u !== void 0;
  return x.useMemo(() => ({
    id: o,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && s?.current && f.preventDefault();
    },
    onMouseMove(f) {
      r && c.emit("itemhover", {
        nodeId: r,
        target: f.currentTarget
      });
    },
    onClick(f) {
      e && c.emit("close", {
        domEvent: f,
        reason: Uo
      });
    },
    onMouseUp(f) {
      if (u) {
        const p = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && p && Math.abs(f.clientX - p.x) <= 1 && Math.abs(f.clientY - p.y) <= 1 || d && !th && f.button === 2)
          return;
      }
      l.current && i.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!a || a.type === "regular-item") && l.current.click();
    }
  }), [e, n, o, c, r, i, s, l, u, d, a]);
}
const Yu = {
  type: "regular-item"
};
function aa(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: i,
    typingRef: s = i.context.typingRef,
    nativeButton: l,
    itemMetadata: a,
    nodeId: c
  } = t, u = x.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Wt({
    disabled: n,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  }), p = h8({
    closeOnClick: e,
    highlighted: o,
    id: r,
    nodeId: c,
    store: i,
    typingRef: s,
    itemRef: u,
    itemMetadata: a
  }), m = x.useCallback((b) => Jt(p, {
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    }
  }, b, d), [p, d, a]), h = mn(u, f);
  return x.useMemo(() => ({
    getItemProps: m,
    itemRef: h
  }), [m, h]);
}
const ju = /* @__PURE__ */ x.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (ju.displayName = "CompositeListContext");
function b8() {
  return x.useContext(ju);
}
let Ku = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Do(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: i
  } = t, {
    register: s,
    unregister: l,
    subscribeMapChange: a,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = b8(), f = x.useRef(-1), [p, m] = x.useState(i ?? (r === Ku.GuessFromOrder ? () => {
    if (f.current === -1) {
      const v = d.current;
      d.current += 1, f.current = v;
    }
    return f.current;
  } : -1)), h = x.useRef(null), b = x.useCallback((v) => {
    if (h.current = v, p !== -1 && v !== null && (c.current[p] = v, u)) {
      const C = e !== void 0;
      u.current[p] = C ? e : o?.current?.textContent ?? v.textContent;
    }
  }, [p, c, u, e, o]);
  return Ne(() => {
    if (i != null)
      return;
    const v = h.current;
    if (v)
      return s(v, n), () => {
        l(v);
      };
  }, [i, s, l, n]), Ne(() => {
    if (i == null)
      return a((v) => {
        const C = h.current ? v.get(h.current)?.index : null;
        C != null && m(C);
      });
  }, [i, a, m]), x.useMemo(() => ({
    ref: b,
    index: p
  }), [p, b]);
}
let j1 = 0;
function v8(t, e = "mui") {
  const [n, o] = x.useState(t), r = t || n;
  return x.useEffect(() => {
    n == null && (j1 += 1, o(`${e}-${j1}`));
  }, [n, e]), r;
}
const K1 = mr.useId;
function _o(t, e) {
  if (K1 !== void 0) {
    const n = K1();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return v8(t, e);
}
function It(t) {
  return _o(t, "base-ui");
}
let q1 = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const qu = {
  checked(t) {
    return t ? {
      [q1.checked]: ""
    } : {
      [q1.unchecked]: ""
    };
  },
  ...Bt
};
function _e(t, e, n, o) {
  let r = !1, i = !1;
  const s = o ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      i = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return i;
    },
    trigger: n,
    ...s
  };
}
function Ni(t, e, n) {
  const o = n ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const oh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: p,
    ...m
  } = e, h = Do({
    label: s
  }), b = ss(!0), v = It(i), {
    store: C
  } = Jn(), y = C.useState("isActive", h.index), w = C.useState("itemProps"), [R, S] = pn({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: N
  } = aa({
    closeOnClick: c,
    disabled: a,
    highlighted: y,
    id: v,
    store: C,
    nativeButton: l,
    nodeId: b?.context.nodeId,
    itemMetadata: Yu
  }), M = x.useMemo(() => ({
    disabled: a,
    highlighted: y,
    checked: R
  }), [a, y, R]), T = Ce((k) => {
    const I = {
      ..._e(Uo, k.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f?.(!R, I), !I.isCanceled && S((D) => !D);
  }), P = Le("div", e, {
    state: M,
    stateAttributesMapping: qu,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": R,
      onClick: T
    }, m, E],
    ref: [N, n, h.ref]
  });
  return /* @__PURE__ */ g(Qg.Provider, {
    value: M,
    children: P
  });
});
process.env.NODE_ENV !== "production" && (oh.displayName = "MenuCheckboxItem");
const rh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = e, f = Do({
    label: s
  }), p = ss(!0), m = It(i), {
    store: h
  } = Jn(), b = h.useState("isActive", f.index), v = h.useState("itemProps"), {
    getItemProps: C,
    itemRef: y
  } = aa({
    closeOnClick: c,
    disabled: a,
    highlighted: b,
    id: m,
    store: h,
    nativeButton: l,
    nodeId: p?.context.nodeId,
    itemMetadata: Yu
  });
  return Le("div", e, {
    state: {
      disabled: a,
      highlighted: b
    },
    props: [v, d, C],
    ref: [y, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (rh.displayName = "MenuItem");
function $t(t) {
  t.preventDefault(), t.stopPropagation();
}
function y8(t) {
  return "nativeEvent" in t;
}
function ih(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : ji && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function sh(t) {
  return nh ? !1 : !ji && t.width === 0 && t.height === 0 || ji && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function qr(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function lh(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
function x8(t, e) {
  return e != null && !qr(e) ? 0 : typeof t == "function" ? t() : t;
}
function _l(t, e, n) {
  const o = x8(t, n);
  return typeof o == "number" ? o : o?.[e];
}
function Z1(t) {
  return typeof t == "function" ? t() : t;
}
function ah(t, e) {
  return e || t === "click" || t === "mousedown";
}
const Zu = /* @__PURE__ */ x.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new Cn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Zu.displayName = "FloatingDelayGroupContext");
function C8(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = x.useRef(n), i = x.useRef(n), s = x.useRef(null), l = x.useRef(null), a = _t();
  return /* @__PURE__ */ g(Zu.Provider, {
    value: x.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: i,
      currentIdRef: s,
      timeoutMs: o,
      currentContextRef: l,
      timeout: a
    }), [o, a]),
    children: e
  });
}
function w8(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    open: r
  } = e, i = x.useContext(Zu), {
    currentIdRef: s,
    delayRef: l,
    timeoutMs: a,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = i, [p, m] = x.useState(!1);
  return Ne(() => {
    function h() {
      m(!1), u.current?.setIsInstantPhase(!1), s.current = null, u.current = null, l.current = c.current;
    }
    if (s.current && !r && s.current === o) {
      if (m(!1), a) {
        const b = o;
        return f.start(a, () => {
          n.select("open") || s.current && s.current !== b || h();
        }), () => {
          f.clear();
        };
      }
      h();
    }
  }, [r, o, s, l, a, c, u, f, n]), Ne(() => {
    if (!r)
      return;
    const h = u.current, b = s.current;
    f.clear(), u.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: m
    }, s.current = o, l.current = {
      open: 0,
      close: _l(c.current, "close")
    }, b !== null && b !== o ? (m(!0), h?.setIsInstantPhase(!0), h?.onOpenChange(!1, _e(Mt))) : (m(!1), h?.setIsInstantPhase(!1));
  }, [r, o, n, s, l, a, c, u, f]), Ne(() => () => {
    u.current = null;
  }, [u]), x.useMemo(() => ({
    hasProvider: d,
    delayRef: l,
    isInstantPhase: p
  }), [d, l, p]);
}
function dt(t, e, n, o) {
  return t.addEventListener(e, n, o), () => {
    t.removeEventListener(e, n, o);
  };
}
function jn(...t) {
  return () => {
    for (let e = 0; e < t.length; e += 1) {
      const n = t[e];
      n && n();
    }
  };
}
function Ht(t) {
  const e = Tt(S8, t).current;
  return e.next = t, Ne(e.effect), e;
}
function S8(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
function et(t) {
  return t?.ownerDocument || document;
}
const ch = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, er = {
  ...ch,
  position: "fixed",
  top: 0,
  left: 0
}, ni = {
  ...ch,
  position: "absolute"
}, An = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const [o, r] = x.useState();
  return Ne(() => {
    eh && r("button");
  }, []), /* @__PURE__ */ g("span", {
    ...e,
    ref: n,
    style: er,
    "aria-hidden": o ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (An.displayName = "FocusGuard");
const ou = "data-base-ui-focusable", uh = "active", dh = "selected", fh = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Go = "ArrowLeft", Yo = "ArrowRight", Xu = "ArrowUp", cs = "ArrowDown";
function Gt(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function He(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && Kr(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function bt(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function Vl(t, e) {
  if (!pt(t))
    return !1;
  const n = t;
  if (e.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, o] of e.entries())
    if (He(o, n))
      return !o.hasAttribute("data-trigger-disabled");
  return !1;
}
function Bn(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function R8(t) {
  return t.matches("html,body");
}
function ca(t) {
  return Ct(t) && t.matches(fh);
}
function ph(t) {
  return t?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${fh}`) != null;
}
function ru(t) {
  return t ? t.getAttribute("role") === "combobox" && ca(t) : !1;
}
function Al(t) {
  if (!t || nh)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Ki(t) {
  return t ? t.hasAttribute(ou) ? t : t.querySelector(`[${ou}]`) || t : null;
}
const E8 = ["top", "right", "bottom", "left"], Zr = Math.min, En = Math.max, Ll = Math.round, cr = Math.floor, co = (t) => ({
  x: t,
  y: t
}), N8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function iu(t, e, n) {
  return En(t, Zr(e, n));
}
function To(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function xn(t) {
  return t.split("-")[0];
}
function tr(t) {
  return t.split("-")[1];
}
function Qu(t) {
  return t === "x" ? "y" : "x";
}
function Ju(t) {
  return t === "y" ? "height" : "width";
}
function Vn(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function ed(t) {
  return Qu(Vn(t));
}
function k8(t, e, n) {
  n === void 0 && (n = !1);
  const o = tr(t), r = ed(t), i = Ju(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Fl(s)), [s, Fl(s)];
}
function I8(t) {
  const e = Fl(t);
  return [su(t), e, su(e)];
}
function su(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const X1 = ["left", "right"], Q1 = ["right", "left"], P8 = ["top", "bottom"], M8 = ["bottom", "top"];
function T8(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Q1 : X1 : e ? X1 : Q1;
    case "left":
    case "right":
      return e ? P8 : M8;
    default:
      return [];
  }
}
function O8(t, e, n, o) {
  const r = tr(t);
  let i = T8(xn(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(su)))), i;
}
function Fl(t) {
  const e = xn(t);
  return N8[e] + t.slice(e.length);
}
function D8(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function mh(t) {
  return typeof t != "number" ? D8(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function qi(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function js(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Zi(t, e) {
  return e < 0 || e >= t.length;
}
function xl(t, e) {
  return ln(t.current, {
    disabledIndices: e
  });
}
function lu(t, e) {
  return ln(t.current, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function ln(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let i = e;
  do
    i += n ? -r : r;
  while (i >= 0 && i <= t.length - 1 && ko(t, i, o));
  return i;
}
function gh(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  onLoop: r,
  rtl: i,
  cols: s,
  disabledIndices: l,
  minIndex: a,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, p;
  if (e.key === Xu ? p = "up" : e.key === cs && (p = "down"), p) {
    const m = [], h = [];
    let b = !1, v = 0;
    {
      let M = null, T = -1;
      t.forEach((P, k) => {
        if (P == null)
          return;
        v += 1;
        const I = P.closest('[role="row"]');
        I && (b = !0), (I !== M || T === -1) && (M = I, T += 1, m[T] = []), m[T].push(k), h[k] = T;
      });
    }
    let C = !1, y = 0;
    if (b)
      for (const M of m) {
        const T = M.length;
        T > y && (y = T), T !== s && (C = !0);
      }
    const w = C && v < t.length, R = y || s, S = (M) => {
      if (!C || u === -1)
        return;
      const T = h[u];
      if (T == null)
        return;
      const P = m[T].indexOf(u), k = M === "up" ? -1 : 1;
      for (let I = T + k, D = 0; D < m.length; D += 1, I += k) {
        if (I < 0 || I >= m.length) {
          if (!o || w)
            return;
          if (I = I < 0 ? m.length - 1 : 0, r) {
            const V = Math.min(P, m[I].length - 1), _ = m[I][V] ?? m[I][0], L = r(e, u, _);
            I = h[L] ?? I;
          }
        }
        const O = m[I];
        for (let V = Math.min(P, O.length - 1); V >= 0; V -= 1) {
          const _ = O[V];
          if (!ko(t, _, l))
            return _;
        }
      }
    }, E = (M) => {
      if (!w || u === -1)
        return;
      const T = u % R, P = M === "up" ? -R : R, k = c - c % R, I = cr(c / R) + 1;
      for (let D = u - T + P, O = 0; O < I; O += 1, D += P) {
        if (D < 0 || D > c) {
          if (!o)
            return;
          D = D < 0 ? k : 0;
        }
        const V = Math.min(D + R - 1, c);
        for (let _ = Math.min(D + T, V); _ >= D; _ -= 1)
          if (!ko(t, _, l))
            return _;
      }
    };
    d && $t(e);
    const N = S(p) ?? E(p);
    if (N !== void 0)
      f = N;
    else if (u === -1)
      f = p === "up" ? c : a;
    else if (f = ln(t, {
      startingIndex: u,
      amount: R,
      decrement: p === "up",
      disabledIndices: l
    }), o) {
      if (p === "up" && (u - R < a || f < 0)) {
        const M = u % R, T = c % R, P = c - (T - M);
        T === M ? f = c : f = T > M ? P : P - R, r && (f = r(e, u, f));
      }
      p === "down" && u + R > c && (f = ln(t, {
        startingIndex: u % R - R,
        amount: R,
        disabledIndices: l
      }), r && (f = r(e, u, f)));
    }
    Zi(t, f) && (f = u);
  }
  if (n === "both") {
    const m = cr(u / s);
    e.key === (i ? Go : Yo) && (d && $t(e), u % s !== s - 1 ? (f = ln(t, {
      startingIndex: u,
      disabledIndices: l
    }), o && js(f, s, m) && (f = ln(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = ln(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))), js(f, s, m) && (f = u)), e.key === (i ? Yo : Go) && (d && $t(e), u % s !== 0 ? (f = ln(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: l
    }), o && js(f, s, m) && (f = ln(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = ln(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f))), js(f, s, m) && (f = u));
    const h = cr(c / s) === m;
    Zi(t, f) && (o && h ? (f = e.key === (i ? Yo : Go) ? c : ln(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))) : f = u);
  }
  return f;
}
function hh(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: i,
    height: s
  }, l) => {
    if (i > e && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${l} is greater than grid columns`);
    let a = !1;
    for (n && (r = 0); !a; ) {
      const c = [];
      for (let u = 0; u < i; u += 1)
        for (let d = 0; d < s; d += 1)
          c.push(r + u + d * e);
      r % e + i <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = l;
      }), a = !0) : r += 1;
    }
  }), [...o];
}
function bh(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const i = n.indexOf(t), s = e[t];
  switch (r) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * o : i;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function vh(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function ko(t, e, n) {
  if (typeof n == "function" ? n(e) : n?.includes(e) ?? !1)
    return !0;
  const r = t[e];
  return r ? ua(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function _8(t) {
  return t.visibility === "hidden" || t.visibility === "collapse";
}
function ua(t, e = t ? gn(t) : null) {
  return !t || !t.isConnected || !e || _8(e) ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : e.display !== "none" && e.display !== "contents";
}
const V8 = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function A8(t) {
  const e = t.assignedSlot;
  if (e)
    return e;
  if (t.parentElement)
    return t.parentElement;
  const n = t.getRootNode();
  return Kr(n) ? n.host : null;
}
function au(t) {
  for (const e of Array.from(t.children))
    if (un(e) === "summary")
      return e;
  return null;
}
function L8(t, e) {
  const n = au(e);
  return !!n && (t === n || He(n, t));
}
function yh(t) {
  const e = t ? un(t) : "";
  return t != null && t.matches(V8) && (e !== "summary" || t.parentElement != null && un(t.parentElement) === "details" && au(t.parentElement) === t) && (e !== "details" || au(t) == null) && (e !== "input" || t.type !== "hidden");
}
function xh(t) {
  if (!yh(t) || !t.isConnected || t.matches(":disabled"))
    return !1;
  for (let e = t; e; e = A8(e)) {
    const n = e !== t, o = un(e) === "slot";
    if (e.hasAttribute("inert") || n && un(e) === "details" && !e.open && !L8(t, e) || e.hasAttribute("hidden") || !o && !F8(e, n))
      return !1;
  }
  return !0;
}
function F8(t, e) {
  const n = gn(t);
  return e ? n.display !== "none" : ua(t, n);
}
function Ch(t) {
  const e = t.tabIndex;
  if (e < 0) {
    const n = un(t);
    if (n === "details" || n === "audio" || n === "video" || Ct(t) && t.isContentEditable)
      return 0;
  }
  return e;
}
function Qa(t) {
  if (un(t) !== "input")
    return null;
  const e = t;
  return e.type === "radio" && e.name !== "" ? e : null;
}
function $8(t, e) {
  const n = Qa(t);
  if (!n)
    return !0;
  const o = e.find((r) => {
    const i = Qa(r);
    return i?.name === n.name && i.form === n.form && i.checked;
  });
  return o ? o === n : e.find((r) => {
    const i = Qa(r);
    return i?.name === n.name && i.form === n.form;
  }) === n;
}
function wh(t) {
  if (Ct(t) && un(t) === "slot") {
    const e = t.assignedElements({
      flatten: !0
    });
    if (e.length > 0)
      return e;
  }
  return Ct(t) && t.shadowRoot ? Array.from(t.shadowRoot.children) : Array.from(t.children);
}
function Sh(t, e) {
  wh(t).forEach((n) => {
    yh(n) && e.push(n), Sh(n, e);
  });
}
function Rh(t, e, n) {
  wh(t).forEach((o) => {
    Ct(o) && o.matches(e) && n.push(o), Rh(o, e, n);
  });
}
function td(t) {
  return xh(t) && Ch(t) >= 0;
}
function Eh(t) {
  const e = [];
  return Sh(t, e), e.filter(xh);
}
function us(t) {
  const e = Eh(t);
  return e.filter((n) => Ch(n) >= 0 && $8(n, e));
}
function Nh(t, e) {
  const n = us(t), o = n.length;
  if (o === 0)
    return;
  const r = Gt(et(t)), i = n.indexOf(r), s = i === -1 ? e === 1 ? 0 : o - 1 : i + e;
  return n[s];
}
function nd(t) {
  return Nh(et(t).body, 1) || t;
}
function kh(t) {
  return Nh(et(t).body, -1) || t;
}
function Ih(t, e) {
  if (!t)
    return null;
  const n = us(et(t).body), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const i = (r + e + o) % o;
  return n[i];
}
function H8(t) {
  return Ih(t, 1);
}
function z8(t) {
  return Ih(t, -1);
}
function Br(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !He(n, o);
}
function B8(t) {
  us(t).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function J1(t) {
  const e = [];
  Rh(t, "[data-tabindex]", e), e.forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function uo(t, e, n = !0) {
  return t.filter((r) => r.parentId === e).flatMap((r) => [...!n || r.context?.open ? [r] : [], ...uo(t, r.id, n)]);
}
function ep(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((i) => i.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function Xi(t) {
  return `data-base-ui-${t}`;
}
let Ks = 0;
function Cl(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Ks);
  const i = () => t?.focus({
    preventScroll: n
  });
  if (r)
    return i(), xt;
  const s = requestAnimationFrame(i);
  return Ks = s, () => {
    Ks === s && (cancelAnimationFrame(s), Ks = 0);
  };
}
const Ja = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, tp = "data-base-ui-inert", cu = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let ki = /* @__PURE__ */ new WeakMap(), ec = 0;
function W8(t) {
  return cu[t];
}
function Ph(t) {
  return t ? Kr(t) ? t.host : Ph(t.parentNode) : null;
}
const tc = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = Ph(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null), np = (t) => {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    let o = n;
    for (; o && !e.has(o); )
      e.add(o), o = o.parentNode;
  }), e;
}, op = (t, e, n) => {
  const o = [], r = (i) => {
    !i || n.has(i) || Array.from(i.children).forEach((s) => {
      un(s) !== "script" && (e.has(s) ? r(s) : o.push(s));
    });
  };
  return r(t), o;
};
function U8(t, e, n, o, {
  mark: r = !0,
  markerIgnoreElements: i = []
}) {
  const s = o ? "inert" : n ? "aria-hidden" : null;
  let l = null, a = null;
  const c = tc(e, t), u = r ? tc(e, i) : [], d = new Set(u), f = r ? op(e, np(c), new Set(c)).filter((h) => !d.has(h)) : [], p = [], m = [];
  if (s) {
    const h = Ja[s], b = W8(s);
    a = b, l = h;
    const v = tc(e, Array.from(e.querySelectorAll("[aria-live]"))), C = c.concat(v);
    op(e, np(C), new Set(C)).forEach((w) => {
      const R = w.getAttribute(s), S = R !== null && R !== "false", E = (h.get(w) || 0) + 1;
      h.set(w, E), p.push(w), E === 1 && S && b.add(w), S || w.setAttribute(s, s === "inert" ? "" : "true");
    });
  }
  return r && f.forEach((h) => {
    const b = (ki.get(h) || 0) + 1;
    ki.set(h, b), m.push(h), b === 1 && h.setAttribute(tp, "");
  }), ec += 1, () => {
    l && p.forEach((h) => {
      const v = (l.get(h) || 0) - 1;
      l.set(h, v), v || (!a?.has(h) && s && h.removeAttribute(s), a?.delete(h));
    }), r && m.forEach((h) => {
      const b = (ki.get(h) || 0) - 1;
      ki.set(h, b), b || h.removeAttribute(tp);
    }), ec -= 1, ec || (Ja.inert = /* @__PURE__ */ new WeakMap(), Ja["aria-hidden"] = /* @__PURE__ */ new WeakMap(), cu.inert = /* @__PURE__ */ new WeakSet(), cu["aria-hidden"] = /* @__PURE__ */ new WeakSet(), ki = /* @__PURE__ */ new WeakMap());
  };
}
function rp(t, e = {}) {
  const {
    ariaHidden: n = !1,
    inert: o = !1,
    mark: r = !0,
    markerIgnoreElements: i = []
  } = e, s = et(t[0]).body;
  return U8(t, s, n, o, {
    mark: r,
    markerIgnoreElements: i
  });
}
const G8 = 500, Mh = 500, Y8 = {
  style: {
    transition: "none"
  }
}, od = "data-base-ui-click-trigger", j8 = "data-base-ui-swipe-ignore", K8 = "data-swipe-ignore", Th = `[${j8}]`, q8 = `[${K8}]`, rd = {
  fallbackAxisSide: "none"
}, da = {
  fallbackAxisSide: "end"
}, Z8 = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, id = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (id.displayName = "PortalContext");
const Oh = () => x.useContext(id), X8 = Xi("portal");
function Dh(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = St,
    elementProps: r
  } = t, i = _o(), l = Oh()?.portalNode, [a, c] = x.useState(null), [u, d] = x.useState(null), f = Ce((b) => {
    b !== null && d(b);
  }), p = x.useRef(null);
  Ne(() => {
    if (n === null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    if (i == null)
      return;
    const b = (n && (Vu(n) ? n : n.current)) ?? l ?? document.body;
    if (b == null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    p.current !== b && (p.current = b, d(null), c(b));
  }, [n, l, i]);
  const m = Le("div", o, {
    ref: [e, f],
    props: [{
      id: i,
      [X8]: ""
    }, r]
  });
  return {
    portalNode: u,
    portalSubtree: a && m ? /* @__PURE__ */ cn.createPortal(m, a) : null
  };
}
const oi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    renderGuards: l,
    style: a,
    ...c
  } = e, {
    portalNode: u,
    portalSubtree: d
  } = Dh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: c
  }), f = x.useRef(null), p = x.useRef(null), m = x.useRef(null), h = x.useRef(null), [b, v] = x.useState(null), C = x.useRef(!1), y = b?.modal, w = b?.open, R = typeof l == "boolean" ? l : !!b && !b.modal && b.open && !!u;
  x.useEffect(() => {
    if (!u || y)
      return;
    function E(N) {
      u && N.relatedTarget && Br(N) && (N.type === "focusin" ? C.current && (J1(u), C.current = !1) : (B8(u), C.current = !0));
    }
    return jn(dt(u, "focusin", E, !0), dt(u, "focusout", E, !0));
  }, [u, y]), x.useEffect(() => {
    !u || w !== !1 || (J1(u), C.current = !1);
  }, [w, u]);
  const S = x.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: p,
    beforeInsideRef: m,
    afterInsideRef: h,
    portalNode: u,
    setFocusManagerState: v
  }), [u]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [d, /* @__PURE__ */ F(id.Provider, {
      value: S,
      children: [R && u && /* @__PURE__ */ g(An, {
        "data-type": "outside",
        ref: f,
        onFocus: (E) => {
          if (Br(E, u))
            m.current?.focus();
          else {
            const N = b ? b.domReference : null;
            kh(N)?.focus();
          }
        }
      }), R && u && /* @__PURE__ */ g("span", {
        "aria-owns": u.id,
        style: Z8
      }), u && /* @__PURE__ */ cn.createPortal(o, u), R && u && /* @__PURE__ */ g(An, {
        "data-type": "outside",
        ref: p,
        onFocus: (E) => {
          if (Br(E, u))
            h.current?.focus();
          else {
            const N = b ? b.domReference : null;
            nd(N)?.focus(), b?.closeOnFocusOut && b?.onOpenChange(!1, _e(Mo, E.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (oi.displayName = "FloatingPortal");
function _h() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class sd {
  nodesRef = {
    current: []
  };
  events = _h();
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const ld = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (ld.displayName = "FloatingNodeContext");
const ad = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (ad.displayName = "FloatingTreeContext");
const vo = () => x.useContext(ld)?.id || null, nr = (t) => {
  const e = x.useContext(ad);
  return t ?? e;
};
function fa(t) {
  const e = _o(), n = nr(t), o = vo();
  return Ne(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function cd(t) {
  const {
    children: e,
    id: n
  } = t, o = vo();
  return /* @__PURE__ */ g(ld.Provider, {
    value: x.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function ud(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = Tt(() => n ?? new sd()).current;
  return /* @__PURE__ */ g(ad.Provider, {
    value: o,
    children: e
  });
}
function Q8(t, e) {
  const n = wt(bt(t));
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const ip = 20;
let Bo = [];
function dd() {
  Bo = Bo.filter((t) => t.deref()?.isConnected);
}
function J8(t) {
  dd(), t && un(t) !== "body" && (Bo.push(new WeakRef(t)), Bo.length > ip && (Bo = Bo.slice(-ip)));
}
function nc() {
  return dd(), Bo[Bo.length - 1]?.deref();
}
function e6(t) {
  return t ? td(t) ? t : us(t)[0] || t : null;
}
function sp(t, e) {
  if (t.hasAttribute("tabindex") && !t.hasAttribute("data-tabindex") || !e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const o = Eh(t).filter((i) => {
    const s = i.getAttribute("data-tabindex") || "";
    return td(i) || i.hasAttribute("data-tabindex") && !s.startsWith("-");
  }), r = t.getAttribute("tabindex");
  e.current.includes("floating") || o.length === 0 ? r !== "0" && t.setAttribute("tabindex", "0") : (r !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function ri(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    initialFocus: r = !0,
    returnFocus: i = !0,
    restoreFocus: s = !1,
    modal: l = !0,
    closeOnFocusOut: a = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: p,
    getInsideElements: m
  } = t, h = "rootStore" in e ? e.rootStore : e, b = h.useState("open"), v = h.useState("domReferenceElement"), C = h.useState("floatingElement"), {
    events: y,
    dataRef: w
  } = h.context, R = Ce(() => w.current.floatingContext?.nodeId), S = r === !1, E = ru(v) && S, N = x.useRef(["content"]), M = Ht(r), T = Ht(i), P = Ht(c), k = nr(p), I = Oh(), D = x.useRef(!1), O = x.useRef(!1), V = x.useRef(!1), _ = x.useRef(null), L = x.useRef(""), A = x.useRef(""), $ = x.useRef(null), Y = x.useRef(null), z = mn($, f, I?.beforeInsideRef), H = mn(Y, I?.afterInsideRef), K = _t(), G = _t(), q = ti(), ee = I != null, W = Ki(C), X = Ce((Q = W) => Q ? us(Q) : []), J = Ce(() => m?.().filter((Q) => Q != null) ?? []);
  x.useEffect(() => {
    if (o || !l)
      return;
    function Q(ce) {
      ce.key === "Tab" && He(W, Gt(et(W))) && X().length === 0 && !E && $t(ce);
    }
    const ie = et(W);
    return dt(ie, "keydown", Q);
  }, [o, v, W, l, N, E, X]), x.useEffect(() => {
    if (o || !b)
      return;
    const Q = et(W);
    function ie() {
      V.current = !1;
    }
    function ce(se) {
      const fe = bt(se), be = J(), le = He(C, fe) || He(v, fe) || He(I?.portalNode, fe) || be.some((me) => me === fe || He(me, fe));
      V.current = !le, A.current = se.pointerType || "keyboard", fe?.closest(`[${od}]`) && (O.current = !0);
    }
    function oe() {
      A.current = "keyboard";
    }
    return jn(dt(Q, "pointerdown", ce, !0), dt(Q, "pointerup", ie, !0), dt(Q, "pointercancel", ie, !0), dt(Q, "keydown", oe, !0));
  }, [o, C, v, W, b, I, J]), x.useEffect(() => {
    if (o || !a)
      return;
    const Q = et(W);
    function ie() {
      O.current = !0, G.start(0, () => {
        O.current = !1;
      });
    }
    function ce(be) {
      const le = bt(be);
      td(le) && (_.current = le);
    }
    function oe(be) {
      const le = be.relatedTarget, me = be.currentTarget, j = bt(be);
      queueMicrotask(() => {
        const te = R(), U = h.context.triggerElements, Z = J(), ue = le?.hasAttribute(Xi("focus-guard")) && [$.current, Y.current, I?.beforeInsideRef.current, I?.afterInsideRef.current, I?.beforeOutsideRef.current, I?.afterOutsideRef.current, xo(d), xo(u)].includes(le), pe = !(He(v, le) || He(C, le) || He(le, C) || He(I?.portalNode, le) || Z.some((he) => he === le || He(he, le)) || le != null && U.hasElement(le) || U.hasMatchingElement((he) => He(he, le)) || ue || k && (uo(k.nodesRef.current, te).find((he) => He(he.context?.elements.floating, le) || He(he.context?.elements.domReference, le)) || ep(k.nodesRef.current, te).find((he) => [he.context?.elements.floating, Ki(he.context?.elements.floating)].includes(le) || he.context?.elements.domReference === le)));
        if (me === v && W && sp(W, N), s && me !== v && !ua(j) && Gt(Q) === Q.body) {
          if (Ct(W) && (W.focus(), s === "popup")) {
            q.request(() => {
              W.focus();
            });
            return;
          }
          const he = X(), Ie = _.current, ye = (Ie && he.includes(Ie) ? Ie : null) || he[he.length - 1] || W;
          Ct(ye) && ye.focus();
        }
        if (w.current.insideReactTree) {
          w.current.insideReactTree = !1;
          return;
        }
        (E || !l) && le && pe && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (E || le !== nc()) && (D.current = !0, h.setOpen(!1, _e(Mo, be)));
      });
    }
    function se() {
      V.current || (w.current.insideReactTree = !0, K.start(0, () => {
        w.current.insideReactTree = !1;
      }));
    }
    const fe = Ct(v) ? v : null;
    if (!(!C && !fe))
      return jn(fe && dt(fe, "focusout", oe), fe && dt(fe, "pointerdown", ie), C && dt(C, "focusin", ce), C && dt(C, "focusout", oe), C && I && dt(C, "focusout", se, !0));
  }, [o, v, C, W, l, k, I, h, a, s, X, E, R, N, w, K, G, q, u, d, J]), x.useEffect(() => {
    if (o || !C || !b)
      return;
    const Q = Array.from(I?.portalNode?.querySelectorAll(`[${Xi("portal")}]`) || []), ce = (k ? ep(k.nodesRef.current, R()) : []).find((me) => ru(me.context?.elements.domReference || null))?.context?.elements.domReference, se = [...[C, ...Q, $.current, Y.current, I?.beforeOutsideRef.current, I?.afterOutsideRef.current, ...J()], ce, xo(d), xo(u), E ? v : null].filter((me) => me != null), fe = rp(se, {
      ariaHidden: l || E,
      mark: !1
    }), be = [C, ...Q].filter((me) => me != null), le = rp(be);
    return () => {
      le(), fe();
    };
  }, [b, o, v, C, l, N, I, E, k, R, u, d, J]), Ne(() => {
    if (!b || o || !Ct(W))
      return;
    const Q = et(W), ie = Gt(Q);
    queueMicrotask(() => {
      const ce = M.current, oe = typeof ce == "function" ? ce(P.current || "") : ce;
      if (oe === void 0 || oe === !1 || He(W, ie))
        return;
      let fe = null;
      const be = () => (fe == null && (fe = X(W)), fe[0] || W);
      let le;
      oe === !0 || oe === null ? le = be() : le = xo(oe), le = le || be(), Cl(le, {
        preventScroll: le === W
      });
    });
  }, [o, b, W, S, X, M, P]), Ne(() => {
    if (o || !W)
      return;
    const Q = et(W), ie = Gt(Q);
    J8(ie);
    function ce(se) {
      if (se.open || (L.current = Q8(se.nativeEvent, A.current)), se.reason === Ft && se.nativeEvent.type === "mouseleave" && (D.current = !0), se.reason === ls)
        if (se.nested)
          D.current = !1;
        else if (ih(se.nativeEvent) || sh(se.nativeEvent))
          D.current = !1;
        else {
          let fe = !1;
          et(W).createElement("div").focus({
            get preventScroll() {
              return fe = !0, !1;
            }
          }), fe ? D.current = !1 : D.current = !0;
        }
    }
    y.on("openchange", ce);
    function oe() {
      const se = T.current;
      let fe = typeof se == "function" ? se(L.current) : se;
      if (fe === void 0 || fe === !1)
        return null;
      if (fe === null && (fe = !0), typeof fe == "boolean") {
        const le = v || nc();
        return le && le.isConnected ? le : null;
      }
      const be = v || nc();
      return xo(fe) || be || null;
    }
    return () => {
      y.off("openchange", ce);
      const se = Gt(Q), fe = J(), be = He(C, se) || fe.some((j) => j === se || He(j, se)) || k && uo(k.nodesRef.current, R(), !1).some((j) => He(j.context?.elements.floating, se)), le = T.current, me = oe();
      queueMicrotask(() => {
        const j = e6(me), te = typeof le != "boolean";
        le && !D.current && Ct(j) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!te && j !== se && se !== Q.body) || be) && j.focus({
          preventScroll: !0
        }), D.current = !1;
      });
    };
  }, [o, C, W, T, w, y, k, v, R, J]), Ne(() => {
    if (!Uu || b || !C)
      return;
    const Q = Gt(et(C));
    !Ct(Q) || !ca(Q) || He(C, Q) && Q.blur();
  }, [b, C]), Ne(() => {
    if (!(o || !I))
      return I.setFocusManagerState({
        modal: l,
        closeOnFocusOut: a,
        open: b,
        onOpenChange: h.setOpen,
        domReference: v
      }), () => {
        I.setFocusManagerState(null);
      };
  }, [o, I, l, b, h, a, v]), Ne(() => {
    if (!(o || !W))
      return sp(W, N), () => {
        queueMicrotask(dd);
      };
  }, [o, W, N]);
  const re = !o && (l ? !E : !0) && (ee || l);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [re && /* @__PURE__ */ g(An, {
      "data-type": "inside",
      ref: z,
      onFocus: (Q) => {
        if (l) {
          const ie = X();
          Cl(ie[ie.length - 1]);
        } else I?.portalNode && (D.current = !1, Br(Q, I.portalNode) ? nd(v)?.focus() : xo(d ?? I.beforeOutsideRef)?.focus());
      }
    }), n, re && /* @__PURE__ */ g(An, {
      "data-type": "inside",
      ref: H,
      onFocus: (Q) => {
        l ? Cl(X()[0]) : I?.portalNode && (a && (D.current = !0), Br(Q, I.portalNode) ? kh(v)?.focus() : xo(u ?? I.afterOutsideRef)?.focus());
      }
    })]
  });
}
function wr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: i = "click",
    toggle: s = !0,
    ignoreMouse: l = !1,
    stickIfOpen: a = !0,
    touchOpenDelay: c = 0,
    reason: u = Zn
  } = e, d = x.useRef(void 0), f = ti(), p = _t(), m = x.useMemo(() => ({
    onPointerDown(h) {
      d.current = h.pointerType;
    },
    onMouseDown(h) {
      const b = d.current, v = h.nativeEvent, C = n.select("open");
      if (h.button !== 0 || i === "click" || qr(b, !0) && l)
        return;
      const y = o.current.openEvent, w = y?.type, R = n.select("domReferenceElement") !== h.currentTarget, S = C && R || !(C && s && (!(y && a) || w === "click" || w === "mousedown")), E = bt(v);
      if (ca(E)) {
        const M = _e(u, v, E);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, M);
        }) : n.setOpen(S, M);
        return;
      }
      const N = h.currentTarget;
      f.request(() => {
        const M = _e(u, v, N);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, M);
        }) : n.setOpen(S, M);
      });
    },
    onClick(h) {
      if (i === "mousedown-only")
        return;
      const b = d.current;
      if (i === "mousedown" && b) {
        d.current = void 0;
        return;
      }
      if (qr(b, !0) && l)
        return;
      const v = n.select("open"), C = o.current.openEvent, y = n.select("domReferenceElement") !== h.currentTarget, w = v && y || !(v && s && (!(C && a) || lh(C))), R = _e(u, h.nativeEvent, h.currentTarget);
      w && b === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, R);
      }) : n.setOpen(w, R);
    },
    onKeyDown() {
      d.current = void 0;
    }
  }), [o, i, l, n, a, s, f, p, c, u]);
  return x.useMemo(() => r ? {
    reference: m
  } : St, [r, m]);
}
function t6(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const i = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, s = e.axis === "x" || e.axis === "both", l = e.axis === "y" || e.axis === "both", a = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = i.width, u = i.height, d = i.x, f = i.y;
      return n == null && e.x && s && (n = i.x - e.x), o == null && e.y && l && (o = i.y - e.y), d -= n || 0, f -= o || 0, c = 0, u = 0, !r || a ? (c = e.axis === "y" ? i.width : 0, u = e.axis === "x" ? i.height : 0, d = s && e.x != null ? e.x : d, f = l && e.y != null ? e.y : f) : r && !a && (u = e.axis === "x" ? i.height : u, c = e.axis === "y" ? i.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function lp(t) {
  return t != null && t.clientX != null;
}
function n6(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    enabled: l = !0,
    axis: a = "both"
  } = e, c = x.useRef(!1), u = x.useRef(null), [d, f] = x.useState(), [p, m] = x.useState([]), h = Ce((w, R, S) => {
    c.current || s.current.openEvent && !lp(s.current.openEvent) || n.set("positionReference", t6(S ?? i, {
      x: w,
      y: R,
      axis: a,
      dataRef: s,
      pointerType: d
    }));
  }), b = Ce((w) => {
    o ? u.current || m([]) : h(w.clientX, w.clientY, w.currentTarget);
  }), v = qr(d) ? r : o, C = x.useCallback(() => {
    if (!v || !l)
      return;
    const w = wt(r);
    function R(S) {
      const E = bt(S);
      He(r, E) ? (u.current?.(), u.current = null) : h(S.clientX, S.clientY);
    }
    if (!s.current.openEvent || lp(s.current.openEvent)) {
      const S = () => {
        u.current?.(), u.current = null;
      };
      return u.current = dt(w, "mousemove", R), S;
    }
    n.set("positionReference", i);
  }, [v, l, r, s, i, n, h]);
  x.useEffect(() => C(), [C, p]), x.useEffect(() => {
    l && !r && (c.current = !1);
  }, [l, r]), x.useEffect(() => {
    !l && o && (c.current = !0);
  }, [l, o]);
  const y = x.useMemo(() => {
    function w(R) {
      f(R.pointerType);
    }
    return {
      onPointerDown: w,
      onPointerEnter: w,
      onMouseMove: b,
      onMouseEnter: b
    };
  }, [b]);
  return x.useMemo(() => l ? {
    reference: y,
    trigger: y
  } : {}, [l, y]);
}
const o6 = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function r6() {
  return !1;
}
function i6(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function Sr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), {
    dataRef: i
  } = n.context, {
    enabled: s = !0,
    escapeKey: l = !0,
    outsidePress: a = !0,
    outsidePressEvent: c = "sloppy",
    referencePress: u = r6,
    referencePressEvent: d = "sloppy",
    bubbles: f,
    externalTree: p
  } = e, m = nr(p), h = Ce(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? h : a, v = b !== !1, C = Ce(() => c), y = x.useRef(!1), w = x.useRef(!1), R = x.useRef(!1), {
    escapeKey: S,
    outsidePress: E
  } = i6(f), N = x.useRef(null), M = _t(), T = _t(), P = Ce(() => {
    T.clear(), i.current.insideReactTree = !1;
  }), k = x.useRef(!1), I = x.useRef(""), D = Ce(u), O = Ce((Y) => {
    if (!o || !s || !l || Y.key !== "Escape" || k.current)
      return;
    const z = i.current.floatingContext?.nodeId, H = m ? uo(m.nodesRef.current, z) : [];
    if (!S && H.length > 0) {
      let q = !0;
      if (H.forEach((ee) => {
        ee.context?.open && !ee.context.dataRef.current.__escapeKeyBubbles && (q = !1);
      }), !q)
        return;
    }
    const K = y8(Y) ? Y.nativeEvent : Y, G = _e(xr, K);
    n.setOpen(!1, G), !S && !G.isPropagationAllowed && Y.stopPropagation();
  }), V = Ce(() => {
    i.current.insideReactTree = !0, T.start(0, P);
  });
  x.useEffect(() => {
    if (!o || !s)
      return;
    i.current.__escapeKeyBubbles = S, i.current.__outsidePressBubbles = E;
    const Y = new Cn(), z = new Cn();
    function H() {
      Y.clear(), k.current = !0;
    }
    function K() {
      Y.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ra() ? 5 : 0,
        () => {
          k.current = !1;
        }
      );
    }
    function G() {
      R.current = !0, z.start(0, () => {
        R.current = !1;
      });
    }
    function q() {
      y.current = !1, w.current = !1;
    }
    function ee() {
      const U = I.current, Z = U === "pen" || !U ? "mouse" : U, ue = C(), pe = typeof ue == "function" ? ue() : ue;
      return typeof pe == "string" ? pe : pe[Z];
    }
    function W(U) {
      const Z = ee();
      return Z === "intentional" && U.type !== "click" || Z === "sloppy" && U.type === "click";
    }
    function X(U) {
      const Z = i.current.floatingContext?.nodeId, ue = m && uo(m.nodesRef.current, Z).some((pe) => Bn(U, pe.context?.elements.floating));
      return Bn(U, n.select("floatingElement")) || Bn(U, n.select("domReferenceElement")) || ue;
    }
    function J(U) {
      if (W(U)) {
        P();
        return;
      }
      if (i.current.insideReactTree) {
        P();
        return;
      }
      const Z = bt(U), ue = `[${Xi("inert")}]`, pe = pt(Z) ? Z.getRootNode() : null, he = Array.from((Kr(pe) ? pe : et(n.select("floatingElement"))).querySelectorAll(ue)), Ie = n.context.triggerElements;
      if (Z && (Ie.hasElement(Z) || Ie.hasMatchingElement((we) => He(we, Z))))
        return;
      let ye = pt(Z) ? Z : null;
      for (; ye && !ao(ye); ) {
        const we = mo(ye);
        if (ao(we) || !pt(we))
          break;
        ye = we;
      }
      if (he.length && pt(Z) && !R8(Z) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !He(Z, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      he.every((we) => !He(ye, we)))
        return;
      if (Ct(Z) && !("touches" in U)) {
        const we = ao(Z), Me = gn(Z), Re = /auto|scroll/, Ve = we || Re.test(Me.overflowX), je = we || Re.test(Me.overflowY), Ze = Ve && Z.clientWidth > 0 && Z.scrollWidth > Z.clientWidth, ze = je && Z.clientHeight > 0 && Z.scrollHeight > Z.clientHeight, Ee = Me.direction === "rtl", Ae = ze && (Ee ? U.offsetX <= Z.offsetWidth - Z.clientWidth : U.offsetX > Z.clientWidth), Pe = Ze && U.offsetY > Z.clientHeight;
        if (Ae || Pe)
          return;
      }
      if (X(U))
        return;
      if (ee() === "intentional" && R.current) {
        z.clear(), R.current = !1;
        return;
      }
      if (typeof b == "function" && !b(U))
        return;
      const xe = i.current.floatingContext?.nodeId, de = m ? uo(m.nodesRef.current, xe) : [];
      if (de.length > 0) {
        let we = !0;
        if (de.forEach((Me) => {
          Me.context?.open && !Me.context.dataRef.current.__outsidePressBubbles && (we = !1);
        }), !we)
          return;
      }
      n.setOpen(!1, _e(ls, U)), P();
    }
    function re(U) {
      ee() !== "sloppy" || U.pointerType === "touch" || !n.select("open") || !s || Bn(U, n.select("floatingElement")) || Bn(U, n.select("domReferenceElement")) || J(U);
    }
    function Q(U) {
      if (ee() !== "sloppy" || !n.select("open") || !s || Bn(U, n.select("floatingElement")) || Bn(U, n.select("domReferenceElement")))
        return;
      const Z = U.touches[0];
      Z && (N.current = {
        startTime: Date.now(),
        startX: Z.clientX,
        startY: Z.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, M.start(1e3, () => {
        N.current && (N.current.dismissOnTouchEnd = !1, N.current.dismissOnMouseDown = !1);
      }));
    }
    function ie(U, Z) {
      const ue = bt(U);
      if (!ue)
        return;
      const pe = dt(ue, U.type, () => {
        Z(U), pe();
      });
    }
    function ce(U) {
      I.current = "touch", ie(U, Q);
    }
    function oe(U) {
      M.clear(), U.type === "pointerdown" && (I.current = U.pointerType), !(U.type === "mousedown" && N.current && !N.current.dismissOnMouseDown) && ie(U, (Z) => {
        Z.type === "pointerdown" ? re(Z) : J(Z);
      });
    }
    function se(U) {
      if (!y.current)
        return;
      const Z = w.current;
      if (q(), ee() === "intentional") {
        if (U.type === "pointercancel") {
          Z && G();
          return;
        }
        if (!X(U)) {
          if (Z) {
            G();
            return;
          }
          typeof b == "function" && !b(U) || (z.clear(), R.current = !0, P());
        }
      }
    }
    function fe(U) {
      if (ee() !== "sloppy" || !N.current || Bn(U, n.select("floatingElement")) || Bn(U, n.select("domReferenceElement")))
        return;
      const Z = U.touches[0];
      if (!Z)
        return;
      const ue = Math.abs(Z.clientX - N.current.startX), pe = Math.abs(Z.clientY - N.current.startY), he = Math.sqrt(ue * ue + pe * pe);
      he > 5 && (N.current.dismissOnTouchEnd = !0), he > 10 && (J(U), M.clear(), N.current = null);
    }
    function be(U) {
      ie(U, fe);
    }
    function le(U) {
      ee() !== "sloppy" || !N.current || Bn(U, n.select("floatingElement")) || Bn(U, n.select("domReferenceElement")) || (N.current.dismissOnTouchEnd && J(U), M.clear(), N.current = null);
    }
    function me(U) {
      ie(U, le);
    }
    const j = et(r), te = jn(l && jn(dt(j, "keydown", O), dt(j, "compositionstart", H), dt(j, "compositionend", K)), v && jn(dt(j, "click", oe, !0), dt(j, "pointerdown", oe, !0), dt(j, "pointerup", se, !0), dt(j, "pointercancel", se, !0), dt(j, "mousedown", oe, !0), dt(j, "mouseup", se, !0), dt(j, "touchstart", ce, !0), dt(j, "touchmove", be, !0), dt(j, "touchend", me, !0)));
    return () => {
      te(), Y.clear(), z.clear(), q(), R.current = !1;
    };
  }, [i, r, l, v, b, o, s, S, E, O, P, C, m, n, M]), x.useEffect(P, [b, P]);
  const _ = x.useMemo(() => ({
    onKeyDown: O,
    [o6[d]]: (Y) => {
      D() && n.setOpen(!1, _e(Zn, Y.nativeEvent));
    },
    ...d !== "intentional" && {
      onClick(Y) {
        D() && n.setOpen(!1, _e(Zn, Y.nativeEvent));
      }
    }
  }), [O, n, d, D]), L = Ce((Y) => {
    if (!o || !s || Y.button !== 0)
      return;
    const z = bt(Y.nativeEvent);
    He(n.select("floatingElement"), z) && (y.current || (y.current = !0, w.current = !1));
  }), A = Ce((Y) => {
    !o || !s || (Y.defaultPrevented || Y.nativeEvent.defaultPrevented) && y.current && (w.current = !0);
  }), $ = x.useMemo(() => ({
    onKeyDown: O,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: A,
    onMouseDown: A,
    onClickCapture: V,
    onMouseDownCapture(Y) {
      V(), L(Y);
    },
    onPointerDownCapture(Y) {
      V(), L(Y);
    },
    onMouseUpCapture: V,
    onTouchEndCapture: V,
    onTouchMoveCapture: V
  }), [O, V, L, A]);
  return x.useMemo(() => s ? {
    reference: _,
    floating: $,
    trigger: _
  } : {}, [s, _, $]);
}
function ap(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = Vn(e), s = ed(e), l = Ju(s), a = xn(e), c = i === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, f = o[l] / 2 - r[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (tr(e)) {
    case "start":
      p[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function s6(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = To(e, t), m = mh(p), b = l[f ? d === "floating" ? "reference" : "floating" : d], v = qi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: a
  })), C = d === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = qi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: a
  }) : C);
  return {
    top: (v.top - R.top + m.top) / w.y,
    bottom: (R.bottom - v.bottom + m.bottom) / w.y,
    left: (v.left - R.left + m.left) / w.x,
    right: (R.right - v.right + m.right) / w.x
  };
}
const l6 = 50, a6 = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = s.detectOverflow ? s : {
    ...s,
    detectOverflow: s6
  }, a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = ap(c, o, a), f = o, p = 0;
  const m = {};
  for (let h = 0; h < i.length; h++) {
    const b = i[h];
    if (!b)
      continue;
    const {
      name: v,
      fn: C
    } = b, {
      x: y,
      y: w,
      data: R,
      reset: S
    } = await C({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = y ?? u, d = w ?? d, m[v] = {
      ...m[v],
      ...R
    }, S && p < l6 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = ap(c, f, a)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: m
  };
}, c6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...b
      } = To(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = xn(r), C = Vn(l), y = xn(l) === l, w = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), R = f || (y || !h ? [Fl(l)] : I8(l)), S = m !== "none";
      !f && S && R.push(...O8(l, h, m, w));
      const E = [l, ...R], N = await a.detectOverflow(e, b), M = [];
      let T = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (u && M.push(N[v]), d) {
        const D = k8(r, s, w);
        M.push(N[D[0]], N[D[1]]);
      }
      if (T = [...T, {
        placement: r,
        overflows: M
      }], !M.every((D) => D <= 0)) {
        var P, k;
        const D = (((P = i.flip) == null ? void 0 : P.index) || 0) + 1, O = E[D];
        if (O && (!(d === "alignment" ? C !== Vn(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((L) => Vn(L.placement) === C ? L.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: T
            },
            reset: {
              placement: O
            }
          };
        let V = (k = T.filter((_) => _.overflows[0] <= 0).sort((_, L) => _.overflows[1] - L.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var I;
              const _ = (I = T.filter((L) => {
                if (S) {
                  const A = Vn(L.placement);
                  return A === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  A === "y";
                }
                return !0;
              }).map((L) => [L.placement, L.overflows.filter((A) => A > 0).reduce((A, $) => A + $, 0)]).sort((L, A) => L[1] - A[1])[0]) == null ? void 0 : I[0];
              _ && (V = _);
              break;
            }
            case "initialPlacement":
              V = l;
              break;
          }
        if (r !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function cp(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function up(t) {
  return E8.some((e) => t[e] >= 0);
}
const u6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = To(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(e, {
            ...i,
            elementContext: "reference"
          }), l = cp(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: up(l)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(e, {
            ...i,
            altBoundary: !0
          }), l = cp(s, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: up(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Vh = /* @__PURE__ */ new Set(["left", "top"]);
async function d6(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = xn(n), l = tr(n), a = Vn(n) === "y", c = Vh.has(s) ? -1 : 1, u = i && a ? -1 : 1, d = To(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof m == "number" && (p = l === "end" ? m * -1 : m), a ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const f6 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: l
      } = e, a = await d6(e, t);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, p6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: l = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: C,
              y
            } = v;
            return {
              x: C,
              y
            };
          }
        },
        ...c
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = await i.detectOverflow(e, c), f = Vn(xn(r)), p = Qu(f);
      let m = u[p], h = u[f];
      if (s) {
        const v = p === "y" ? "top" : "left", C = p === "y" ? "bottom" : "right", y = m + d[v], w = m - d[C];
        m = iu(y, m, w);
      }
      if (l) {
        const v = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", y = h + d[v], w = h - d[C];
        h = iu(y, h, w);
      }
      const b = a.fn({
        ...e,
        [p]: m,
        [f]: h
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [p]: s,
            [f]: l
          }
        }
      };
    }
  };
}, m6 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = e, {
        offset: l = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = Vn(r), f = Qu(d);
      let p = u[f], m = u[d];
      const h = To(l, e), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (a) {
        const y = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[y] + b.mainAxis, R = i.reference[f] + i.reference[y] - b.mainAxis;
        p < w ? p = w : p > R && (p = R);
      }
      if (c) {
        var v, C;
        const y = f === "y" ? "width" : "height", w = Vh.has(xn(r)), R = i.reference[d] - i.floating[y] + (w && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (w ? 0 : b.crossAxis), S = i.reference[d] + i.reference[y] + (w ? 0 : ((C = s.offset) == null ? void 0 : C[d]) || 0) - (w ? b.crossAxis : 0);
        m < R ? m = R : m > S && (m = S);
      }
      return {
        [f]: p,
        [d]: m
      };
    }
  };
}, g6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: l
      } = e, {
        apply: a = () => {
        },
        ...c
      } = To(t, e), u = await s.detectOverflow(e, c), d = xn(r), f = tr(r), p = Vn(r) === "y", {
        width: m,
        height: h
      } = i.floating;
      let b, v;
      d === "top" || d === "bottom" ? (b = d, v = f === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (v = d, b = f === "end" ? "top" : "bottom");
      const C = h - u.top - u.bottom, y = m - u.left - u.right, w = Zr(h - u[b], C), R = Zr(m - u[v], y), S = !e.middlewareData.shift;
      let E = w, N = R;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (N = y), (o = e.middlewareData.shift) != null && o.enabled.y && (E = C), S && !f) {
        const T = En(u.left, 0), P = En(u.right, 0), k = En(u.top, 0), I = En(u.bottom, 0);
        p ? N = m - 2 * (T !== 0 || P !== 0 ? T + P : En(u.left, u.right)) : E = h - 2 * (k !== 0 || I !== 0 ? k + I : En(u.top, u.bottom));
      }
      await a({
        ...e,
        availableWidth: N,
        availableHeight: E
      });
      const M = await s.getDimensions(l.floating);
      return m !== M.width || h !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ah(t) {
  const e = gn(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = Ct(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, l = Ll(n) !== i || Ll(o) !== s;
  return l && (n = i, o = s), {
    width: n,
    height: o,
    $: l
  };
}
function fd(t) {
  return pt(t) ? t : t.contextElement;
}
function Wr(t) {
  const e = fd(t);
  if (!Ct(e))
    return co(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Ah(e);
  let s = (i ? Ll(n.width) : n.width) / o, l = (i ? Ll(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const h6 = /* @__PURE__ */ co(0);
function Lh(t) {
  const e = wt(t);
  return !ra() || !e.visualViewport ? h6 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function b6(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== wt(t) ? !1 : e;
}
function hr(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = fd(t);
  let s = co(1);
  e && (o ? pt(o) && (s = Wr(o)) : s = Wr(t));
  const l = b6(i, n, o) ? Lh(i) : co(0);
  let a = (r.left + l.x) / s.x, c = (r.top + l.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (i) {
    const f = wt(i), p = o && pt(o) ? wt(o) : o;
    let m = f, h = Qc(m);
    for (; h && o && p !== m; ) {
      const b = Wr(h), v = h.getBoundingClientRect(), C = gn(h), y = v.left + (h.clientLeft + parseFloat(C.paddingLeft)) * b.x, w = v.top + (h.clientTop + parseFloat(C.paddingTop)) * b.y;
      a *= b.x, c *= b.y, u *= b.x, d *= b.y, a += y, c += w, m = wt(h), h = Qc(m);
    }
  }
  return qi({
    width: u,
    height: d,
    x: a,
    y: c
  });
}
function pa(t, e) {
  const n = ia(t).scrollLeft;
  return e ? e.left + n : hr(bo(t)).left + n;
}
function Fh(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - pa(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function v6(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = bo(o), l = e ? oa(e.floating) : !1;
  if (o === s || l && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = co(1);
  const u = co(0), d = Ct(o);
  if ((d || !d && !i) && ((un(o) !== "body" || Jo(s)) && (a = ia(o)), d)) {
    const p = hr(o);
    c = Wr(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const f = s && !d && !i ? Fh(s, a) : co(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - a.scrollTop * c.y + u.y + f.y
  };
}
function y6(t) {
  return Array.from(t.getClientRects());
}
function x6(t) {
  const e = bo(t), n = ia(t), o = t.ownerDocument.body, r = En(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = En(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + pa(t);
  const l = -n.scrollTop;
  return gn(o).direction === "rtl" && (s += En(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
const dp = 25;
function C6(t, e) {
  const n = wt(t), o = bo(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, l = 0, a = 0;
  if (r) {
    i = r.width, s = r.height;
    const u = ra();
    (!u || u && e === "fixed") && (l = r.offsetLeft, a = r.offsetTop);
  }
  const c = pa(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, f = getComputedStyle(d), p = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, m = Math.abs(o.clientWidth - d.clientWidth - p);
    m <= dp && (i -= m);
  } else c <= dp && (i += c);
  return {
    width: i,
    height: s,
    x: l,
    y: a
  };
}
function w6(t, e) {
  const n = hr(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = Ct(t) ? Wr(t) : co(1), s = t.clientWidth * i.x, l = t.clientHeight * i.y, a = r * i.x, c = o * i.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function fp(t, e, n) {
  let o;
  if (e === "viewport")
    o = C6(t, n);
  else if (e === "document")
    o = x6(bo(t));
  else if (pt(e))
    o = w6(e, n);
  else {
    const r = Lh(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return qi(o);
}
function $h(t, e) {
  const n = mo(t);
  return n === e || !pt(n) || ao(n) ? !1 : gn(n).position === "fixed" || $h(n, e);
}
function S6(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = Gi(t, [], !1).filter((l) => pt(l) && un(l) !== "body"), r = null;
  const i = gn(t).position === "fixed";
  let s = i ? mo(t) : t;
  for (; pt(s) && !ao(s); ) {
    const l = gn(s), a = Au(s);
    !a && l.position === "fixed" && (r = null), (i ? !a && !r : !a && l.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Jo(s) && !a && $h(t, s)) ? o = o.filter((u) => u !== s) : r = l, s = mo(s);
  }
  return e.set(t, o), o;
}
function R6(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? oa(e) ? [] : S6(e, this._c) : [].concat(n), o], l = fp(e, s[0], r);
  let a = l.top, c = l.right, u = l.bottom, d = l.left;
  for (let f = 1; f < s.length; f++) {
    const p = fp(e, s[f], r);
    a = En(p.top, a), c = Zr(p.right, c), u = Zr(p.bottom, u), d = En(p.left, d);
  }
  return {
    width: c - d,
    height: u - a,
    x: d,
    y: a
  };
}
function E6(t) {
  const {
    width: e,
    height: n
  } = Ah(t);
  return {
    width: e,
    height: n
  };
}
function N6(t, e, n) {
  const o = Ct(e), r = bo(e), i = n === "fixed", s = hr(t, !0, i, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = co(0);
  function c() {
    a.x = pa(r);
  }
  if (o || !o && !i)
    if ((un(e) !== "body" || Jo(r)) && (l = ia(e)), o) {
      const p = hr(e, !0, i, e);
      a.x = p.x + e.clientLeft, a.y = p.y + e.clientTop;
    } else r && c();
  i && !o && r && c();
  const u = r && !o && !i ? Fh(r, l) : co(0), d = s.left + l.scrollLeft - a.x - u.x, f = s.top + l.scrollTop - a.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function oc(t) {
  return gn(t).position === "static";
}
function pp(t, e) {
  if (!Ct(t) || gn(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return bo(t) === n && (n = n.ownerDocument.body), n;
}
function Hh(t, e) {
  const n = wt(t);
  if (oa(t))
    return n;
  if (!Ct(t)) {
    let r = mo(t);
    for (; r && !ao(r); ) {
      if (pt(r) && !oc(r))
        return r;
      r = mo(r);
    }
    return n;
  }
  let o = pp(t, e);
  for (; o && I5(o) && oc(o); )
    o = pp(o, e);
  return o && ao(o) && oc(o) && !Au(o) ? n : o || T5(t) || n;
}
const k6 = async function(t) {
  const e = this.getOffsetParent || Hh, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: N6(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function I6(t) {
  return gn(t).direction === "rtl";
}
const zh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: v6,
  getDocumentElement: bo,
  getClippingRect: R6,
  getOffsetParent: Hh,
  getElementRects: k6,
  getClientRects: y6,
  getDimensions: E6,
  getScale: Wr,
  isElement: pt,
  isRTL: I6
};
function Bh(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function P6(t, e) {
  let n = null, o;
  const r = bo(t);
  function i() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (l || e(), !f || !p)
      return;
    const m = cr(d), h = cr(r.clientWidth - (u + f)), b = cr(r.clientHeight - (d + p)), v = cr(u), y = {
      rootMargin: -m + "px " + -h + "px " + -b + "px " + -v + "px",
      threshold: En(0, Zr(1, a)) || 1
    };
    let w = !0;
    function R(S) {
      const E = S[0].intersectionRatio;
      if (E !== a) {
        if (!w)
          return s();
        E ? s(!1, E) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Bh(c, t.getBoundingClientRect()) && s(), w = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, y);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function mp(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = fd(t), u = r || i ? [...c ? Gi(c) : [], ...e ? Gi(e) : []] : [];
  u.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && l ? P6(c, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((v) => {
    let [C] = v;
    C && C.target === c && p && e && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), n();
  }), c && !a && p.observe(c), e && p.observe(e));
  let m, h = a ? hr(t) : null;
  a && b();
  function b() {
    const v = hr(t);
    h && !Bh(h, v) && n(), h = v, m = requestAnimationFrame(b);
  }
  return n(), () => {
    var v;
    u.forEach((C) => {
      r && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), d?.(), (v = p) == null || v.disconnect(), p = null, a && cancelAnimationFrame(m);
  };
}
const M6 = f6, T6 = p6, O6 = c6, D6 = g6, _6 = u6, V6 = m6, A6 = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: zh,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return a6(t, e, {
    ...r,
    platform: i
  });
};
var L6 = typeof document < "u", F6 = function() {
}, wl = L6 ? po : F6;
function $l(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!$l(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !$l(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Wh(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function gp(t, e) {
  const n = Wh(t);
  return Math.round(e * n) / n;
}
function rc(t) {
  const e = x.useRef(t);
  return wl(() => {
    e.current = t;
  }), e;
}
function $6(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = t, [u, d] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = x.useState(o);
  $l(f, o) || p(o);
  const [m, h] = x.useState(null), [b, v] = x.useState(null), C = x.useCallback((L) => {
    L !== S.current && (S.current = L, h(L));
  }, []), y = x.useCallback((L) => {
    L !== E.current && (E.current = L, v(L));
  }, []), w = i || m, R = s || b, S = x.useRef(null), E = x.useRef(null), N = x.useRef(u), M = a != null, T = rc(a), P = rc(r), k = rc(c), I = x.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const L = {
      placement: e,
      strategy: n,
      middleware: f
    };
    P.current && (L.platform = P.current), A6(S.current, E.current, L).then((A) => {
      const $ = {
        ...A,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      D.current && !$l(N.current, $) && (N.current = $, cn.flushSync(() => {
        d($);
      }));
    });
  }, [f, e, n, P, k]);
  wl(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((L) => ({
      ...L,
      isPositioned: !1
    })));
  }, [c]);
  const D = x.useRef(!1);
  wl(() => (D.current = !0, () => {
    D.current = !1;
  }), []), wl(() => {
    if (w && (S.current = w), R && (E.current = R), w && R) {
      if (T.current)
        return T.current(w, R, I);
      I();
    }
  }, [w, R, I, T, M]);
  const O = x.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: C,
    setFloating: y
  }), [C, y]), V = x.useMemo(() => ({
    reference: w,
    floating: R
  }), [w, R]), _ = x.useMemo(() => {
    const L = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return L;
    const A = gp(V.floating, u.x), $ = gp(V.floating, u.y);
    return l ? {
      ...L,
      transform: "translate(" + A + "px, " + $ + "px)",
      ...Wh(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: A,
      top: $
    };
  }, [n, l, V.floating, u.x, u.y]);
  return x.useMemo(() => ({
    ...u,
    update: I,
    refs: O,
    elements: V,
    floatingStyles: _
  }), [u, I, O, V, _]);
}
const H6 = (t, e) => {
  const n = M6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, z6 = (t, e) => {
  const n = T6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, B6 = (t, e) => ({
  fn: V6(t).fn,
  options: [t, e]
}), W6 = (t, e) => {
  const n = O6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, U6 = (t, e) => {
  const n = D6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, G6 = (t, e) => {
  const n = _6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, ge = (t, e, n, o, r, i, ...s) => {
  if (s.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : tt(1));
  let l;
  if (t && e)
    l = (a, c, u, d) => {
      const f = t(a, c, u, d);
      return e(f, c, u, d);
    };
  else if (t)
    l = t;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return l;
};
var Y6 = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: r } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, j6 = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: i, inputSelectorResultsCopy: s } = t, l = o(() => ({}), ...r);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, K6 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Hl = /* @__PURE__ */ Symbol("NOT_FOUND");
function q6(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function Z6(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function X6(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var hp = (t) => Array.isArray(t) ? t : [t];
function Q6(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return X6(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function bp(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var J6 = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...K6,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: Y6
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: j6
    }
  };
};
function ey(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : Hl;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function ty(t, e) {
  let n = [];
  function o(l) {
    const a = n.findIndex((c) => e(l, c.key));
    if (a > -1) {
      const c = n[a];
      return a > 0 && (n.splice(a, 1), n.unshift(c)), c.value;
    }
    return Hl;
  }
  function r(l, a) {
    o(l) === Hl && (n.unshift({ key: l, value: a }), n.length > t && n.pop());
  }
  function i() {
    return n;
  }
  function s() {
    n = [];
  }
  return { get: o, put: r, getEntries: i, clear: s };
}
var ny = (t, e) => t === e;
function oy(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let i = 0; i < r; i++)
      if (!t(n[i], o[i]))
        return !1;
    return !0;
  };
}
function ry(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = ny,
    maxSize: r = 1,
    resultEqualityCheck: i
  } = n, s = oy(o);
  let l = 0;
  const a = r <= 1 ? ey(s) : ty(r, s);
  function c() {
    let u = a.get(arguments);
    if (u === Hl) {
      if (u = t.apply(null, arguments), l++, i) {
        const f = a.getEntries().find(
          (p) => i(p.value, u)
        );
        f && (u = f.value, l !== 0 && l--);
      }
      a.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    a.clear(), c.resetResultsCount();
  }, c.resultsCount = () => l, c.resetResultsCount = () => {
    l = 0;
  }, c;
}
var iy = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, sy = typeof WeakRef < "u" ? WeakRef : iy, ly = 0, vp = 1;
function qs() {
  return {
    s: ly,
    v: void 0,
    o: null,
    p: null
  };
}
function Uh(t, e = {}) {
  let n = qs();
  const { resultEqualityCheck: o } = e;
  let r, i = 0;
  function s() {
    let l = n;
    const { length: a } = arguments;
    for (let d = 0, f = a; d < f; d++) {
      const p = arguments[d];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let m = l.o;
        m === null && (l.o = m = /* @__PURE__ */ new WeakMap());
        const h = m.get(p);
        h === void 0 ? (l = qs(), m.set(p, l)) : l = h;
      } else {
        let m = l.p;
        m === null && (l.p = m = /* @__PURE__ */ new Map());
        const h = m.get(p);
        h === void 0 ? (l = qs(), m.set(p, l)) : l = h;
      }
    }
    const c = l;
    let u;
    if (l.s === vp)
      u = l.v;
    else if (u = t.apply(null, arguments), i++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, i !== 0 && i--), r = typeof u == "object" && u !== null || typeof u == "function" ? new sy(u) : u;
    }
    return c.s = vp, c.v = u, u;
  }
  return s.clearCache = () => {
    n = qs(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function Gh(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let i = 0, s = 0, l, a = {}, c = r.pop();
    typeof c == "object" && (a = c, c = r.pop()), q6(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...a
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: p = Uh,
      argsMemoizeOptions: m = [],
      devModeChecks: h = {}
    } = u, b = hp(f), v = hp(m), C = Q6(r), y = d(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...b);
    let w = !0;
    const R = p(function() {
      s++;
      const E = bp(
        C,
        arguments
      );
      if (l = y.apply(null, E), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: N, inputStabilityCheck: M } = J6(w, h);
        if (N.shouldRun && N.run(
          c,
          E,
          l
        ), M.shouldRun) {
          const T = bp(
            C,
            arguments
          );
          M.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: T },
            { memoize: d, memoizeOptions: b },
            arguments
          );
        }
        w && (w = !1);
      }
      return l;
    }, ...v);
    return Object.assign(R, {
      resultFunc: c,
      memoizedResultFunc: y,
      dependencies: C,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: p
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var ay = /* @__PURE__ */ Gh(Uh), cy = Object.assign(
  (t, e = ay) => {
    Z6(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (i) => t[i]
    );
    return e(
      o,
      (...i) => i.reduce((s, l, a) => (s[n[a]] = l, s), {})
    );
  },
  { withTypes: () => cy }
);
const uy = Gh({
  memoize: ry,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), dy = (...t) => {
  const e = /* @__PURE__ */ new WeakMap();
  let n = 1;
  const o = t[t.length - 1], r = t.length - 1 || 1, i = o.length - r;
  if (i > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : tt(2));
  return (l, a, c, u) => {
    let d = l.__cacheKey__;
    d || (d = {
      id: n
    }, l.__cacheKey__ = d, n += 1);
    let f = e.get(d);
    if (!f) {
      let p = t;
      const m = [void 0, void 0, void 0];
      switch (i) {
        case 0:
          break;
        case 1: {
          p = [...t.slice(0, -1), () => m[0], o];
          break;
        }
        case 2: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], o];
          break;
        }
        case 3: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], () => m[2], o];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : tt(2));
      }
      f = uy(...p), f.selectorArgs = m, e.set(d, f);
    }
    switch (f.selectorArgs[0] = a, f.selectorArgs[1] = c, f.selectorArgs[2] = u, i) {
      case 0:
        return f(l);
      case 1:
        return f(l, a);
      case 2:
        return f(l, a, c);
      case 3:
        return f(l, a, c, u);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var Zs = { exports: {} }, ic = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yp;
function fy() {
  if (yp) return ic;
  yp = 1;
  var t = Be;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function l(d, f) {
    var p = f(), m = o({ inst: { value: p, getSnapshot: f } }), h = m[0].inst, b = m[1];
    return i(
      function() {
        h.value = p, h.getSnapshot = f, a(h) && b({ inst: h });
      },
      [d, p, f]
    ), r(
      function() {
        return a(h) && b({ inst: h }), d(function() {
          a(h) && b({ inst: h });
        });
      },
      [d]
    ), s(p), p;
  }
  function a(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return ic.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, ic;
}
var sc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xp;
function py() {
  return xp || (xp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(p, m) {
      return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    function e(p, m) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = m();
      if (!d) {
        var b = m();
        i(h, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      b = s({
        inst: { value: h, getSnapshot: m }
      });
      var v = b[0].inst, C = b[1];
      return a(
        function() {
          v.value = h, v.getSnapshot = m, n(v) && C({ inst: v });
        },
        [p, h, m]
      ), l(
        function() {
          return n(v) && C({ inst: v }), p(function() {
            n(v) && C({ inst: v });
          });
        },
        [p]
      ), c(h), h;
    }
    function n(p) {
      var m = p.getSnapshot;
      p = p.value;
      try {
        var h = m();
        return !i(p, h);
      } catch {
        return !0;
      }
    }
    function o(p, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = Be, i = typeof Object.is == "function" ? Object.is : t, s = r.useState, l = r.useEffect, a = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    sc.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), sc;
}
var Cp;
function pd() {
  return Cp || (Cp = 1, process.env.NODE_ENV === "production" ? Zs.exports = fy() : Zs.exports = py()), Zs.exports;
}
var md = pd(), Xs = { exports: {} }, lc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wp;
function my() {
  if (wp) return lc;
  wp = 1;
  var t = Be, e = pd();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return lc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var m = i(null);
    if (m.current === null) {
      var h = { hasValue: !1, value: null };
      m.current = h;
    } else h = m.current;
    m = l(
      function() {
        function v(S) {
          if (!C) {
            if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
              var E = h.value;
              if (p(E, S))
                return w = E;
            }
            return w = S;
          }
          if (E = w, o(y, S)) return E;
          var N = f(S);
          return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
        }
        var C = !1, y, w, R = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          R === null ? void 0 : function() {
            return v(R());
          }
        ];
      },
      [u, d, f, p]
    );
    var b = r(c, m[0], m[1]);
    return s(
      function() {
        h.hasValue = !0, h.value = b;
      },
      [b]
    ), a(b), b;
  }, lc;
}
var ac = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sp;
function gy() {
  return Sp || (Sp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Be, n = pd(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, i = e.useRef, s = e.useEffect, l = e.useMemo, a = e.useDebugValue;
    ac.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var m = i(null);
      if (m.current === null) {
        var h = { hasValue: !1, value: null };
        m.current = h;
      } else h = m.current;
      m = l(
        function() {
          function v(S) {
            if (!C) {
              if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
                var E = h.value;
                if (p(E, S))
                  return w = E;
              }
              return w = S;
            }
            if (E = w, o(y, S))
              return E;
            var N = f(S);
            return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
          }
          var C = !1, y, w, R = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            R === null ? void 0 : function() {
              return v(R());
            }
          ];
        },
        [u, d, f, p]
      );
      var b = r(c, m[0], m[1]);
      return s(
        function() {
          h.hasValue = !0, h.value = b;
        },
        [b]
      ), a(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), ac;
}
var Rp;
function hy() {
  return Rp || (Rp = 1, process.env.NODE_ENV === "production" ? Xs.exports = my() : Xs.exports = gy()), Xs.exports;
}
var by = hy();
const uu = [];
let du;
function vy() {
  return du;
}
function yy(t) {
  uu.push(t);
}
function gd(t) {
  const e = (n, o) => {
    const r = Tt(xy).current;
    let i;
    try {
      du = r;
      for (const s of uu)
        s.before(r);
      i = t(n, o);
      for (const s of uu)
        s.after(r);
      r.didInitialize = !0;
    } finally {
      du = void 0;
    }
    return i;
  };
  return e.displayName = t.displayName || t.name, e;
}
function Yh(t) {
  return /* @__PURE__ */ x.forwardRef(gd(t));
}
function xy() {
  return {
    didInitialize: !1
  };
}
const Cy = Mu(19), wy = Cy ? Ry : Ey;
function ve(t, e, n, o, r) {
  return wy(t, e, n, o, r);
}
function Sy(t, e, n, o, r) {
  const i = x.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return md.useSyncExternalStore(t.subscribe, i, i);
}
yy({
  before(t) {
    t.syncIndex = 0, t.didInitialize || (t.syncTick = 1, t.syncHooks = [], t.didChangeStore = !0, t.getSnapshot = () => {
      let e = !1;
      for (let n = 0; n < t.syncHooks.length; n += 1) {
        const o = t.syncHooks[n], r = o.selector(o.store.state, o.a1, o.a2, o.a3);
        (o.didChange || !Object.is(o.value, r)) && (e = !0, o.value = r, o.didChange = !1);
      }
      return e && (t.syncTick += 1), t.syncTick;
    });
  },
  after(t) {
    t.syncHooks.length > 0 && (t.didChangeStore && (t.didChangeStore = !1, t.subscribe = (e) => {
      const n = /* @__PURE__ */ new Set();
      for (const r of t.syncHooks)
        n.add(r.store);
      const o = [];
      for (const r of n)
        o.push(r.subscribe(e));
      return () => {
        for (const r of o)
          r();
      };
    }), md.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot));
  }
});
function Ry(t, e, n, o, r) {
  const i = vy();
  if (!i)
    return Sy(t, e, n, o, r);
  const s = i.syncIndex;
  i.syncIndex += 1;
  let l;
  return i.didInitialize ? (l = i.syncHooks[s], (l.store !== t || l.selector !== e || !Object.is(l.a1, n) || !Object.is(l.a2, o) || !Object.is(l.a3, r)) && (l.store !== t && (i.didChangeStore = !0), l.store = t, l.selector = e, l.a1 = n, l.a2 = o, l.a3 = r, l.didChange = !0)) : (l = {
    store: t,
    selector: e,
    a1: n,
    a2: o,
    a3: r,
    value: e(t.getSnapshot(), n, o, r),
    didChange: !1
  }, i.syncHooks.push(l)), l.value;
}
function Ey(t, e, n, o, r) {
  return by.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (i) => e(i, n, o, r));
}
class hd {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (e) => (this.listeners.add(e), () => {
    this.listeners.delete(e);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        this.setState({
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || this.setState({
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    this.setState(e);
  }
  use(e, n, o, r) {
    return ve(this, e, n, o, r);
  }
}
class Rr extends hd {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(e, n = {}, o) {
    super(e), this.context = n, this.selectors = o;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(e, n) {
    x.useDebugValue(e), Ne(() => {
      this.state[e] !== n && this.set(e, n);
    }, [e, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(e, n) {
    const o = this;
    Ne(() => (o.state[e] !== n && o.set(e, n), () => {
      o.set(e, void 0);
    }), [o, e, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(e) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      x.useDebugValue(e, (s) => Object.keys(s));
      const r = x.useRef(Object.keys(e)).current, i = Object.keys(e);
      (r.length !== i.length || r.some((s, l) => s !== i[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(e);
    Ne(() => {
      n.update(e);
    }, [n, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(e, n) {
    x.useDebugValue(e);
    const o = n !== void 0;
    if (Ne(() => {
      o && !Object.is(this.state[e], n) && super.setState({
        ...this.state,
        [e]: n
      });
    }, [e, n, o]), process.env.NODE_ENV !== "production") {
      const r = this.controlledValues ??= /* @__PURE__ */ new Map();
      r.has(e) || r.set(e, o);
      const i = r.get(e);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${e.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(e, n, o, r) {
    const i = this.selectors[e];
    return i(this.state, n, o, r);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(e, n, o, r) {
    return x.useDebugValue(e), ve(this, this.selectors[e], n, o, r);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(e, n) {
    x.useDebugValue(e);
    const o = Ce(n ?? xt);
    this.context[e] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(e) {
    const n = x.useRef(void 0);
    return n.current === void 0 && (n.current = (o) => {
      this.set(e, o);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(e, n) {
    let o;
    typeof e == "function" ? o = e : o = this.selectors[e];
    let r = o(this.state);
    return n(r, r, this), this.subscribe((i) => {
      const s = o(i);
      if (!Object.is(r, s)) {
        const l = r;
        r = s, n(s, l, this);
      }
    });
  }
}
const Ny = {
  open: ge((t) => t.open),
  transitionStatus: ge((t) => t.transitionStatus),
  domReferenceElement: ge((t) => t.domReferenceElement),
  referenceElement: ge((t) => t.positionReference ?? t.referenceElement),
  floatingElement: ge((t) => t.floatingElement),
  floatingId: ge((t) => t.floatingId)
};
class bd extends Rr {
  constructor(e) {
    const {
      syncOnly: n,
      nested: o,
      onOpenChange: r,
      triggerElements: i,
      ...s
    } = e;
    super({
      ...s,
      positionReference: s.referenceElement,
      domReferenceElement: s.referenceElement
    }, {
      onOpenChange: r,
      dataRef: {
        current: {}
      },
      events: _h(),
      nested: o,
      triggerElements: i
    }, Ny), this.syncOnly = n;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (e, n) => {
    (!e || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    n != null && lh(n)) && (this.context.dataRef.current.openEvent = e ? n : void 0);
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (e, n) => {
    this.syncOpenEvent(e, n.event);
    const o = {
      open: e,
      reason: n.reason,
      nativeEvent: n.event,
      nested: this.context.nested,
      triggerElement: n.trigger
    };
    this.context.events.emit("openchange", o);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (e, n) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e, n);
      return;
    }
    this.dispatchOpenChange(e, n), this.context.onOpenChange?.(e, n);
  };
}
function jh(t, e) {
  const n = x.useRef(null), o = x.useRef(null);
  return x.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const i = n.current, s = o.current, l = e.context.triggerElements.getById(i);
        s && l === s && e.context.triggerElements.delete(i), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function ds(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), i = jh(t, n), s = Ce((l) => {
    if (i(l), !l || !n.select("open"))
      return;
    const a = n.select("activeTriggerId");
    if (a === t) {
      n.update({
        activeTriggerElement: l,
        ...o
      });
      return;
    }
    a == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: l,
      ...o
    });
  });
  return Ne(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: s,
    isMountedByThisTrigger: r
  };
}
function fs(t) {
  const e = t.useState("open");
  Ne(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function ps(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: i
  } = Xn(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: i
  });
  const s = Ce(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), l = e.useState("preventUnmountingOnClose");
  return jt({
    enabled: !l,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || s();
    }
  }), {
    forceUnmount: s,
    transitionStatus: i
  };
}
class Er {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elementsSet.delete(o), this.elementsSet.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elementsSet.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elementsSet.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elementsSet)
      if (e(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(e) {
    return this.idMap.get(e);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function ky() {
  return new bd({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new Er(),
    floatingId: "",
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function ms() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: ky(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: St,
    inactiveTriggerProps: St,
    popupProps: St
  };
}
const Qs = ge((t) => t.triggerIdProp ?? t.activeTriggerId), gs = {
  open: ge((t) => t.openProp ?? t.open),
  mounted: ge((t) => t.mounted),
  transitionStatus: ge((t) => t.transitionStatus),
  floatingRootContext: ge((t) => t.floatingRootContext),
  preventUnmountingOnClose: ge((t) => t.preventUnmountingOnClose),
  payload: ge((t) => t.payload),
  activeTriggerId: Qs,
  activeTriggerElement: ge((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: ge((t, e) => e !== void 0 && Qs(t) === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: ge((t, e) => e !== void 0 && Qs(t) === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: ge((t, e) => e !== void 0 && Qs(t) === e && t.mounted),
  triggerProps: ge((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: ge((t) => t.popupProps),
  popupElement: ge((t) => t.popupElement),
  positionerElement: ge((t) => t.positionerElement)
};
function vd(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = _o(), i = vo() != null;
  if (process.env.NODE_ENV !== "production") {
    const l = o.reference;
    l && !pt(l) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const s = Tt(() => new bd({
    open: e,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: new Er(),
    floatingId: r,
    syncOnly: !1,
    nested: i
  })).current;
  return Ne(() => {
    const l = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (l.referenceElement = o.reference, l.domReferenceElement = pt(o.reference) ? o.reference : null), o.floating !== void 0 && (l.floatingElement = o.floating), s.update(l);
  }, [e, r, o.reference, o.floating, s]), s.context.onOpenChange = n, s.context.nested = i, s;
}
function Iy(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = vd(t), r = t.rootContext || o, i = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [s, l] = x.useState(null), a = x.useRef(null), c = nr(n);
  Ne(() => {
    i.domReference && (a.current = i.domReference);
  }, [i.domReference]);
  const u = $6({
    ...t,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), d = x.useCallback((N) => {
    const M = pt(N) ? {
      getBoundingClientRect: () => N.getBoundingClientRect(),
      getClientRects: () => N.getClientRects(),
      contextElement: N
    } : N;
    l(M), u.refs.setReference(M);
  }, [u.refs]), [f, p] = x.useState(void 0), [m, h] = x.useState(null);
  r.useSyncedValue("referenceElement", f ?? null);
  const b = pt(f) ? f : null;
  r.useSyncedValue("domReferenceElement", f === void 0 ? i.domReference : b), r.useSyncedValue("floatingElement", m);
  const v = x.useCallback((N) => {
    (pt(N) || N === null) && (a.current = N, p(N)), (pt(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    N !== null && !pt(N)) && u.refs.setReference(N);
  }, [u.refs, p]), C = x.useCallback((N) => {
    h(N), u.refs.setFloating(N);
  }, [u.refs]), y = x.useMemo(() => ({
    ...u.refs,
    setReference: v,
    setFloating: C,
    setPositionReference: d,
    domReference: a
  }), [u.refs, v, C, d]), w = x.useMemo(() => ({
    ...u.elements,
    domReference: i.domReference
  }), [u.elements, i.domReference]), R = r.useState("open"), S = r.useState("floatingId"), E = x.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: R,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: y,
    elements: w,
    nodeId: e,
    rootStore: r
  }), [u, y, w, e, r, R, S]);
  return Ne(() => {
    r.context.dataRef.current.floatingContext = E;
    const N = c?.nodesRef.current.find((M) => M.id === e);
    N && (N.context = E);
  }), x.useMemo(() => ({
    ...u,
    context: E,
    refs: y,
    elements: w,
    rootStore: r
  }), [u, y, w, E, r]);
}
function hs(t) {
  const {
    popupStore: e,
    treatPopupAsFloatingElement: n = !1,
    onOpenChange: o
  } = t, r = _o(), i = vo() != null, s = e.useState("open"), l = e.useState("activeTriggerElement"), a = e.useState(n ? "popupElement" : "positionerElement"), c = e.context.triggerElements, u = Tt(() => new bd({
    open: s,
    transitionStatus: void 0,
    referenceElement: l,
    floatingElement: a,
    triggerElements: c,
    onOpenChange: o,
    floatingId: r,
    syncOnly: !0,
    nested: i
  })).current;
  return Ne(() => {
    const d = {
      open: s,
      floatingId: r,
      referenceElement: l,
      floatingElement: a
    };
    pt(l) && (d.domReferenceElement = l), u.state.positionReference === u.state.referenceElement && (d.positionReference = l), u.update(d);
  }, [s, r, l, a, u]), u.context.onOpenChange = o, u.context.nested = i, u;
}
const cc = th && eh;
function yd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: i = !0,
    delay: s
  } = e, l = x.useRef(!1), a = x.useRef(null), c = _t(), u = x.useRef(!0);
  x.useEffect(() => {
    const f = n.select("domReferenceElement");
    if (!i)
      return;
    const p = wt(f);
    function m() {
      const v = n.select("domReferenceElement");
      !n.select("open") && Ct(v) && v === Gt(et(v)) && (l.current = !0);
    }
    function h() {
      u.current = !0;
    }
    function b() {
      u.current = !1;
    }
    return jn(dt(p, "blur", m), cc && dt(p, "keydown", h, !0), cc && dt(p, "pointerdown", b, !0));
  }, [n, i]), x.useEffect(() => {
    if (!i)
      return;
    function f(p) {
      if (p.reason === Zn || p.reason === xr) {
        const m = n.select("domReferenceElement");
        pt(m) && (a.current = m, l.current = !0);
      }
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, i, n]);
  const d = x.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, a.current = null;
    },
    onFocus(f) {
      const p = f.currentTarget;
      if (l.current) {
        if (a.current === p)
          return;
        l.current = !1, a.current = null;
      }
      const m = bt(f.nativeEvent);
      if (pt(m)) {
        if (cc && !f.relatedTarget) {
          if (!u.current && !ca(m))
            return;
        } else if (!Al(m))
          return;
      }
      const h = Vl(f.relatedTarget, n.context.triggerElements), {
        nativeEvent: b,
        currentTarget: v
      } = f, C = typeof s == "function" ? s() : s;
      if (n.select("open") && h || C === 0 || C === void 0) {
        n.setOpen(!0, _e(fr, b, v));
        return;
      }
      c.start(C, () => {
        l.current || n.setOpen(!0, _e(fr, b, v));
      });
    },
    onBlur(f) {
      l.current = !1, a.current = null;
      const p = f.relatedTarget, m = f.nativeEvent, h = pt(p) && p.hasAttribute(Xi("focus-guard")) && p.getAttribute("data-type") === "outside";
      c.start(0, () => {
        const b = n.select("domReferenceElement"), v = Gt(et(b));
        !p && v === b || He(r.current.floatingContext?.refs.floating.current, v) || He(b, v) || h || Vl(p ?? v, n.context.triggerElements) || n.setOpen(!1, _e(fr, m));
      });
    }
  }), [r, n, c, s]);
  return x.useMemo(() => i ? {
    reference: d,
    trigger: d
  } : {}, [i, d]);
}
class xd {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new Cn(), this.restTimeout = new Cn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new xd();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
const zl = /* @__PURE__ */ new WeakMap();
function Bl(t) {
  if (!t.performedPointerEventsMutation)
    return;
  const e = t.pointerEventsScopeElement;
  e && zl.get(e) === t && (t.pointerEventsScopeElement?.style.removeProperty("pointer-events"), t.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), t.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), zl.delete(e)), t.performedPointerEventsMutation = !1, t.pointerEventsScopeElement = null, t.pointerEventsReferenceElement = null, t.pointerEventsFloatingElement = null;
}
function Kh(t, e) {
  const {
    scopeElement: n,
    referenceElement: o,
    floatingElement: r
  } = e, i = zl.get(n);
  i && i !== t && Bl(i), Bl(t), t.performedPointerEventsMutation = !0, t.pointerEventsScopeElement = n, t.pointerEventsReferenceElement = o, t.pointerEventsFloatingElement = r, zl.set(n, t), n.style.pointerEvents = "none", o.style.pointerEvents = "auto", r.style.pointerEvents = "auto";
}
function qh(t) {
  const e = Tt(xd.create).current, n = t.context.dataRef.current;
  return n.hoverInteractionState || (n.hoverInteractionState = e), ei(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
function ma(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), {
    dataRef: s
  } = n.context, {
    enabled: l = !0,
    closeDelay: a = 0,
    nodeId: c
  } = e, u = qh(n), d = nr(), f = vo(), p = Ce(() => ah(s.current.openEvent?.type, u.interactedInside)), m = Ce(() => {
    const w = s.current.openEvent?.type;
    return w?.includes("mouse") && w !== "mousedown";
  }), h = Ce((w) => Vl(w, n.context.triggerElements)), b = x.useCallback((w) => {
    const R = _l(a, "close", u.pointerType), S = () => {
      n.setOpen(!1, _e(Ft, w)), d?.events.emit("floating.closed", w);
    };
    R ? u.openChangeTimeout.start(R, S) : (u.openChangeTimeout.clear(), S());
  }, [a, n, u, d]), v = Ce(() => {
    Bl(u);
  }), C = Ce((w) => {
    const R = bt(w);
    if (!ph(R)) {
      u.interactedInside = !1;
      return;
    }
    u.interactedInside = R?.closest("[aria-haspopup]") != null;
  });
  Ne(() => {
    o || (u.pointerType = void 0, u.restTimeoutPending = !1, u.interactedInside = !1, v());
  }, [o, u, v]), x.useEffect(() => v, [v]), Ne(() => {
    if (l && o && u.handleCloseOptions?.blockPointerEvents && m() && pt(i) && r) {
      const w = i, R = r, S = et(r), E = d?.nodesRef.current.find((M) => M.id === f)?.context?.elements.floating;
      E && (E.style.pointerEvents = "");
      const N = u.handleCloseOptions?.getScope?.() ?? u.pointerEventsScopeElement ?? E ?? w.closest("[data-rootownerid]") ?? S.body;
      return Kh(u, {
        scopeElement: N,
        referenceElement: w,
        floatingElement: R
      }), () => {
        v();
      };
    }
  }, [l, o, i, r, u, m, d, f, v]);
  const y = _t();
  x.useEffect(() => {
    if (!l)
      return;
    function w() {
      u.openChangeTimeout.clear(), y.clear(), d?.events.off("floating.closed", S), v();
    }
    function R(N) {
      if (d && f && uo(d.nodesRef.current, f).length > 0) {
        d.events.on("floating.closed", S);
        return;
      }
      if (h(N.relatedTarget))
        return;
      const M = s.current.floatingContext?.nodeId ?? c, T = N.relatedTarget;
      if (!(d && M && pt(T) && uo(d.nodesRef.current, M, !1).some((k) => He(k.context?.elements.floating, T)))) {
        if (u.handler) {
          u.handler(N);
          return;
        }
        v(), p() || b(N);
      }
    }
    function S(N) {
      !d || !f || uo(d.nodesRef.current, f).length > 0 || y.start(0, () => {
        d.events.off("floating.closed", S), n.setOpen(!1, _e(Ft, N)), d.events.emit("floating.closed", N);
      });
    }
    const E = r;
    return jn(E && dt(E, "mouseenter", w), E && dt(E, "mouseleave", R), E && dt(E, "pointerdown", C, !0), () => {
      d?.events.off("floating.closed", S);
    });
  }, [l, r, n, s, c, p, h, b, v, C, u, d, f, y]);
}
const Py = {
  current: null
};
function bs(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: i = !0,
    delay: s = 0,
    handleClose: l = null,
    mouseOnly: a = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = Py,
    externalTree: f,
    isActiveTrigger: p = !0,
    getHandleCloseContext: m,
    isClosing: h
  } = e, b = nr(f), v = qh(n), C = x.useRef(!1), y = Ht(l), w = Ht(s), R = Ht(c), S = Ht(i), E = Ht(h);
  p && (v.handleCloseOptions = y.current?.__options);
  const N = Ce(() => ah(o.current.openEvent?.type, v.interactedInside)), M = Ce((D) => Vl(D, n.context.triggerElements)), T = Ce((D, O, V) => {
    const _ = n.context.triggerElements;
    if (_.hasElement(O))
      return !D || !He(D, O);
    if (!pt(V))
      return !1;
    const L = V;
    return _.hasMatchingElement((A) => He(A, L)) && (!D || !He(D, L));
  }), P = Ce((D, O = !0) => {
    const V = _l(w.current, "close", v.pointerType);
    V ? v.openChangeTimeout.start(V, () => {
      n.setOpen(!1, _e(Ft, D)), b?.events.emit("floating.closed", D);
    }) : O && (v.openChangeTimeout.clear(), n.setOpen(!1, _e(Ft, D)), b?.events.emit("floating.closed", D));
  }), k = Ce(() => {
    if (!v.handler)
      return;
    et(n.select("domReferenceElement")).removeEventListener("mousemove", v.handler), v.handler = void 0;
  }), I = Ce(() => {
    Bl(v);
  });
  return x.useEffect(() => k, [k]), x.useEffect(() => {
    if (!i)
      return;
    function D(O) {
      O.open ? C.current = !1 : (C.current = O.reason === Ft, k(), v.openChangeTimeout.clear(), v.restTimeout.clear(), v.blockMouseMove = !0, v.restTimeoutPending = !1);
    }
    return r.on("openchange", D), () => {
      r.off("openchange", D);
    };
  }, [i, r, v, k]), x.useEffect(() => {
    if (!i)
      return;
    const D = d.current ?? (p ? n.select("domReferenceElement") : null);
    if (!pt(D))
      return;
    function O(_) {
      if (v.openChangeTimeout.clear(), v.blockMouseMove = !1, a && !qr(v.pointerType))
        return;
      const L = Z1(R.current), A = _l(w.current, "open", v.pointerType), $ = bt(_), Y = _.currentTarget ?? null, z = n.select("domReferenceElement");
      let H = Y;
      if (pt($) && !n.context.triggerElements.hasElement($)) {
        for (const Q of n.context.triggerElements.elements())
          if (He(Q, $)) {
            H = Q;
            break;
          }
      }
      pt(Y) && pt(z) && !n.context.triggerElements.hasElement(Y) && He(Y, z) && (H = z);
      const K = H == null ? !1 : T(z, H, $), G = n.select("open"), q = E.current?.() ?? n.select("transitionStatus") === "ending", ee = !G && q && C.current, W = !K && pt(H) && pt(z) && He(z, H) && ee, X = L > 0 && !A, J = K && (G || ee) || W, re = !G || K;
      if (J) {
        n.setOpen(!0, _e(Ft, _, H));
        return;
      }
      X || (A ? v.openChangeTimeout.start(A, () => {
        re && n.setOpen(!0, _e(Ft, _, H));
      }) : re && n.setOpen(!0, _e(Ft, _, H)));
    }
    function V(_) {
      if (N()) {
        I();
        return;
      }
      k();
      const L = n.select("domReferenceElement"), A = et(L);
      v.restTimeout.clear(), v.restTimeoutPending = !1;
      const $ = o.current.floatingContext ?? m?.();
      if (M(_.relatedTarget))
        return;
      if (y.current && $) {
        n.select("open") || v.openChangeTimeout.clear();
        const H = d.current;
        v.handler = y.current({
          ...$,
          tree: b,
          x: _.clientX,
          y: _.clientY,
          onClose() {
            I(), k(), S.current && !N() && H === n.select("domReferenceElement") && P(_, !0);
          }
        }), A.addEventListener("mousemove", v.handler), v.handler(_);
        return;
      }
      (v.pointerType !== "touch" || !He(n.select("floatingElement"), _.relatedTarget)) && P(_);
    }
    return u ? jn(dt(D, "mousemove", O, {
      once: !0
    }), dt(D, "mouseenter", O), dt(D, "mouseleave", V)) : jn(dt(D, "mouseenter", O), dt(D, "mouseleave", V));
  }, [k, I, o, w, P, n, i, y, v, p, T, N, M, a, u, R, d, b, S, m, E]), x.useMemo(() => {
    if (!i)
      return;
    function D(O) {
      v.pointerType = O.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(O) {
        const {
          nativeEvent: V
        } = O, _ = O.currentTarget, L = n.select("domReferenceElement"), A = n.select("open"), $ = T(L, _, O.target);
        if (a && !qr(v.pointerType))
          return;
        if (A && $ && v.handleCloseOptions?.blockPointerEvents) {
          const H = n.select("floatingElement");
          if (H) {
            const K = v.handleCloseOptions?.getScope?.() ?? _.ownerDocument.body;
            Kh(v, {
              scopeElement: K,
              referenceElement: _,
              floatingElement: H
            });
          }
        }
        const Y = Z1(R.current);
        if (A && !$ || Y === 0 || !$ && v.restTimeoutPending && O.movementX ** 2 + O.movementY ** 2 < 2)
          return;
        v.restTimeout.clear();
        function z() {
          if (v.restTimeoutPending = !1, N())
            return;
          const H = n.select("open");
          !v.blockMouseMove && (!H || $) && n.setOpen(!0, _e(Ft, V, _));
        }
        v.pointerType === "touch" ? cn.flushSync(() => {
          z();
        }) : $ && A ? z() : (v.restTimeoutPending = !0, v.restTimeout.start(Y, z));
      }
    };
  }, [i, v, N, T, a, n, R]);
}
function eo(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), i = x.useCallback(
    (c) => Js(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), s = x.useCallback(
    (c) => Js(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = x.useCallback(
    (c) => Js(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), a = x.useCallback(
    (c) => Js(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return x.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: s,
    getItemProps: l,
    getTriggerProps: a
  }), [i, s, l, a]);
}
function Js(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", i = {};
  n === "floating" && (i.tabIndex = -1, i[ou] = "");
  for (const s in t)
    r && t && (s === uh || s === dh) || (i[s] = t[s]);
  for (let s = 0; s < e.length; s += 1) {
    let l;
    const a = e[s]?.[n];
    typeof a == "function" ? l = t ? a(t) : null : l = a, l && Ep(i, l, r, o);
  }
  return Ep(i, t, r, o), i;
}
function Ep(t, e, n, o) {
  for (const r in e) {
    const i = e[r];
    n && (r === uh || r === dh) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof i == "function" && (o.get(r)?.push(i), t[r] = (...s) => o.get(r)?.map((l) => l(...s)).find((l) => l !== void 0))) : t[r] = i);
  }
}
const My = "Escape";
function ga(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function el(t, e) {
  return ga(e, t === Xu || t === cs, t === Go || t === Yo);
}
function uc(t, e, n) {
  return ga(e, t === cs, n ? t === Go : t === Yo) || t === "Enter" || t === " " || t === "";
}
function Ty(t, e, n) {
  return ga(e, n ? t === Go : t === Yo, t === cs);
}
function Oy(t, e, n, o) {
  const r = n ? t === Yo : t === Go, i = t === Xu;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === My : ga(e, r, i);
}
function Cd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    listRef: l,
    activeIndex: a,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: p = !1,
    nested: m = !1,
    rtl: h = !1,
    virtual: b = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: C = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: w = void 0,
    orientation: R = "vertical",
    parentOrientation: S,
    cols: E = 1,
    id: N,
    resetOnPointerLeave: M = !0,
    externalTree: T
  } = e;
  process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), b || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && E > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const P = Ki(r), k = Ht(P), I = vo(), D = nr(T);
  Ne(() => {
    s.current.orientation = R;
  }, [s, R]);
  const O = ru(i), V = x.useRef(v), _ = x.useRef(d ?? -1), L = x.useRef(null), A = x.useRef(!0), $ = Ce((j) => {
    c(_.current === -1 ? null : _.current, j);
  }), Y = x.useRef($), z = x.useRef(!!r), H = x.useRef(o), K = x.useRef(!1), G = x.useRef(!1), q = x.useRef(null), ee = Ht(w), W = Ht(o), X = Ht(d), J = Ht(M), re = Ce(() => {
    function j(ue) {
      b ? D?.events.emit("virtualfocus", ue) : q.current = Cl(ue, {
        sync: K.current,
        preventScroll: !0
      });
    }
    const te = l.current[_.current], U = G.current;
    te && j(te), (K.current ? (ue) => ue() : requestAnimationFrame)(() => {
      const ue = l.current[_.current] || te;
      if (!ue)
        return;
      te || j(ue), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      ce && (U || !A.current) && ue.scrollIntoView?.({
        block: "nearest",
        inline: "nearest"
      });
    });
  });
  Ne(() => {
    u && (o && r ? (_.current = d ?? -1, V.current && d != null && (G.current = !0, $())) : z.current && (_.current = -1, Y.current()));
  }, [u, o, r, d, $]), Ne(() => {
    if (u) {
      if (!o) {
        K.current = !1;
        return;
      }
      if (r)
        if (a == null) {
          if (K.current = !1, X.current != null)
            return;
          if (z.current && (_.current = -1, re()), (!H.current || !z.current) && V.current && (L.current != null || V.current === !0 && L.current == null)) {
            let j = 0;
            const te = () => {
              l.current[0] == null ? (j < 2 && (j ? requestAnimationFrame : queueMicrotask)(te), j += 1) : (_.current = L.current == null || uc(L.current, R, h) || m ? xl(l) : lu(l), L.current = null, $());
            };
            te();
          }
        } else Zi(l.current, a) || (_.current = a, re(), G.current = !1);
    }
  }, [u, o, r, a, X, m, l, R, h, $, re, ee]), Ne(() => {
    if (!u || r || !D || b || !z.current)
      return;
    const j = D.nodesRef.current, te = j.find((ue) => ue.id === I)?.context?.elements.floating, U = Gt(et(r)), Z = j.some((ue) => ue.context && He(ue.context.elements.floating, U));
    te && !Z && A.current && te.focus({
      preventScroll: !0
    });
  }, [u, r, D, I, b]), Ne(() => {
    Y.current = $, H.current = o, z.current = !!r;
  }), Ne(() => {
    o || (L.current = null, V.current = v);
  }, [o, v]);
  const Q = a != null, ie = Ce((j) => {
    if (!W.current)
      return;
    const te = l.current.indexOf(j.currentTarget);
    te !== -1 && (_.current !== te || a !== te) && (_.current = te, $(j));
  }), ce = x.useMemo(() => ({
    onFocus(te) {
      K.current = !0, ie(te);
    },
    onClick: ({
      currentTarget: te
    }) => te.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(te) {
      K.current = !0, G.current = !1, C && ie(te);
    },
    onPointerLeave(te) {
      if (!W.current || !A.current || te.pointerType === "touch")
        return;
      K.current = !0;
      const U = te.relatedTarget;
      if (!(!C || l.current.includes(U)) && J.current && (q.current?.(), q.current = null, _.current = -1, $(te), !b)) {
        const Z = k.current, ue = Gt(et(Z));
        Z && He(Z, ue) && Z.focus({
          preventScroll: !0
        });
      }
    }
  }), [ie, W, k, C, l, $, J, b]), oe = x.useCallback(() => S ?? D?.nodesRef.current.find((j) => j.id === I)?.context?.dataRef?.current.orientation, [I, D, S]), se = Ce((j) => {
    if (A.current = !1, K.current = !0, j.which === 229 || !W.current && j.currentTarget === k.current)
      return;
    if (m && Oy(j.key, R, h, E)) {
      el(j.key, oe()) || $t(j), n.setOpen(!1, _e(zr, j.nativeEvent)), Ct(i) && (b ? D?.events.emit("virtualfocus", i) : i.focus());
      return;
    }
    const te = _.current, U = xl(l, w), Z = lu(l, w);
    if (O || (j.key === "Home" && ($t(j), _.current = U, $(j)), j.key === "End" && ($t(j), _.current = Z, $(j))), E > 1) {
      const ue = Array.from({
        length: l.current.length
      }, () => ({
        width: 1,
        height: 1
      })), pe = hh(ue, E, !1), he = pe.findIndex((xe) => xe != null && !ko(l.current, xe, w)), Ie = pe.reduce((xe, de, we) => de != null && !ko(l.current, de, w) ? we : xe, -1), ye = pe[gh(pe.map((xe) => xe != null ? l.current[xe] : null), {
        event: j,
        orientation: R,
        loopFocus: p,
        rtl: h,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: vh([...(typeof w != "function" ? w : null) || l.current.map((xe, de) => ko(l.current, de, w) ? de : void 0), void 0], pe),
        minIndex: he,
        maxIndex: Ie,
        prevIndex: bh(
          _.current > Z ? U : _.current,
          ue,
          pe,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          j.key === cs ? "bl" : j.key === (h ? Go : Yo) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (ye != null && (_.current = ye, $(j)), R === "both")
        return;
    }
    if (el(j.key, R)) {
      if ($t(j), o && !b && Gt(j.currentTarget.ownerDocument) === j.currentTarget) {
        _.current = uc(j.key, R, h) ? U : Z, $(j);
        return;
      }
      uc(j.key, R, h) ? p ? te >= Z ? f && te !== l.current.length ? _.current = -1 : (K.current = !1, _.current = U) : _.current = ln(l.current, {
        startingIndex: te,
        disabledIndices: w
      }) : _.current = Math.min(Z, ln(l.current, {
        startingIndex: te,
        disabledIndices: w
      })) : p ? te <= U ? f && te !== -1 ? _.current = l.current.length : (K.current = !1, _.current = Z) : _.current = ln(l.current, {
        startingIndex: te,
        decrement: !0,
        disabledIndices: w
      }) : _.current = Math.max(U, ln(l.current, {
        startingIndex: te,
        decrement: !0,
        disabledIndices: w
      })), Zi(l.current, _.current) && (_.current = -1), $(j);
    }
  }), fe = x.useMemo(() => b && o && Q && {
    "aria-activedescendant": `${N}-${a}`
  }, [b, o, Q, N, a]), be = x.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...O ? {} : fe,
    onKeyDown(j) {
      if (j.key === "Tab" && j.shiftKey && o && !b) {
        const te = bt(j.nativeEvent);
        if (te && !He(k.current, te))
          return;
        $t(j), n.setOpen(!1, _e(Mo, j.nativeEvent)), Ct(i) && i.focus();
        return;
      }
      se(j);
    },
    onPointerMove() {
      A.current = !0;
    }
  }), [fe, se, k, R, O, n, o, b, i]), le = x.useMemo(() => {
    function j(U) {
      v === "auto" && ih(U.nativeEvent) && (V.current = !b);
    }
    function te(U) {
      V.current = v, v === "auto" && sh(U.nativeEvent) && (V.current = !0);
    }
    return {
      onKeyDown(U) {
        const Z = n.select("open");
        A.current = !1;
        const ue = U.key.startsWith("Arrow"), pe = Ty(U.key, oe(), h), he = el(U.key, R), Ie = (m ? pe : he) || U.key === "Enter" || U.key.trim() === "";
        if (b && Z)
          return se(U);
        if (!(!Z && !y && ue)) {
          if (Ie) {
            const ye = el(U.key, oe());
            L.current = m && ye ? null : U.key;
          }
          if (m) {
            pe && ($t(U), Z ? (_.current = xl(l, ee.current), $(U)) : n.setOpen(!0, _e(zr, U.nativeEvent, U.currentTarget)));
            return;
          }
          he && (X.current != null && (_.current = X.current), $t(U), !Z && y ? n.setOpen(!0, _e(zr, U.nativeEvent, U.currentTarget)) : se(U), Z && $(U));
        }
      },
      onFocus(U) {
        n.select("open") && !b && (_.current = -1, $(U));
      },
      onPointerDown: te,
      onPointerEnter: te,
      onMouseDown: j,
      onClick: j
    };
  }, [se, ee, v, l, m, $, n, y, R, oe, h, X, b]), me = x.useMemo(() => ({
    ...fe,
    ...le
  }), [fe, le]);
  return x.useMemo(() => u ? {
    reference: me,
    floating: be,
    item: ce,
    trigger: le
  } : {}, [u, me, be, le, ce]);
}
const Dy = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function wd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), i = n.useState("domReferenceElement"), s = n.useState("floatingElement"), {
    role: l = "dialog"
  } = e, a = _o(), c = i?.id || a, u = x.useMemo(() => Ki(s)?.id || r, [s, r]), d = Dy.get(l) ?? l, p = vo() != null, m = x.useMemo(() => d === "tooltip" || l === "label" ? St : {
    "aria-haspopup": d === "alertdialog" ? "dialog" : d,
    "aria-expanded": "false",
    ...d === "listbox" && {
      role: "combobox"
    },
    ...d === "menu" && p && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [d, p, l]), h = x.useMemo(() => d === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: o ? u : void 0
  } : {
    ...m,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? u : void 0,
    ...d === "menu" && {
      id: c
    }
  }, [d, u, o, c, l, m]), b = x.useMemo(() => {
    const C = {
      id: u,
      ...d && {
        role: d
      }
    };
    return d === "tooltip" || l === "label" ? C : {
      ...C,
      ...d === "menu" && {
        "aria-labelledby": c
      }
    };
  }, [d, u, c, l]), v = x.useCallback(({
    active: C,
    selected: y
  }) => {
    const w = {
      role: "option",
      ...C && {
        id: `${u}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...w,
          "aria-selected": y
        };
    }
    return {};
  }, [u, l]);
  return x.useMemo(() => ({
    reference: h,
    floating: b,
    item: v,
    trigger: m
  }), [h, b, m, v]);
}
function Sd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, r = n.useState("open"), {
    listRef: i,
    elementsRef: s,
    activeIndex: l,
    onMatch: a,
    onTypingChange: c,
    enabled: u = !0,
    resetMs: d = 750,
    selectedIndex: f = null
  } = e, p = _t(), m = x.useRef(""), h = x.useRef(f ?? l ?? -1), b = x.useRef(null);
  Ne(() => {
    !r && f !== null || (p.clear(), b.current = null, m.current !== "" && (m.current = ""));
  }, [r, f, p]), Ne(() => {
    r && m.current === "" && (h.current = f ?? l ?? -1);
  }, [r, f, l]);
  const v = Ce((S) => {
    S ? o.current.typing || (o.current.typing = S, c?.(S)) : o.current.typing && (o.current.typing = S, c?.(S));
  }), C = Ce((S) => {
    function E(O) {
      const V = s?.current[O];
      return !V || ua(V);
    }
    function N(O, V, _ = 0) {
      if (O.length === 0)
        return -1;
      const L = (_ % O.length + O.length) % O.length, A = V.toLocaleLowerCase();
      for (let $ = 0; $ < O.length; $ += 1) {
        const Y = (L + $) % O.length;
        if (!(!O[Y]?.toLocaleLowerCase().startsWith(A) || !E(Y)))
          return Y;
      }
      return -1;
    }
    const M = i.current;
    if (m.current.length > 0 && S.key === " " && ($t(S), v(!0)), m.current.length > 0 && m.current[0] !== " " && N(M, m.current) === -1 && S.key !== " " && v(!1), M == null || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && ($t(S), v(!0));
    const T = m.current === "";
    T && (h.current = f ?? l ?? -1), M.every((O) => O ? O[0]?.toLocaleLowerCase() !== O[1]?.toLocaleLowerCase() : !0) && m.current === S.key && (m.current = "", h.current = b.current), m.current += S.key, p.start(d, () => {
      m.current = "", h.current = b.current, v(!1);
    });
    const I = ((T ? f ?? l ?? -1 : h.current) ?? 0) + 1, D = N(M, m.current, I);
    D !== -1 ? (a?.(D), b.current = D) : S.key !== " " && (m.current = "", v(!1));
  }), y = Ce((S) => {
    const E = S.relatedTarget, N = n.select("domReferenceElement"), M = n.select("floatingElement"), T = He(N, E), P = He(M, E);
    T || P || (p.clear(), m.current = "", h.current = b.current, v(!1));
  }), w = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]), R = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]);
  return x.useMemo(() => u ? {
    reference: w,
    floating: R
  } : {}, [u, w, R]);
}
const Np = 0.1, _y = Np * Np, kt = 0.5;
function tl(t, e, n, o, r, i) {
  return o >= e != i >= e && t <= (r - n) * (e - o) / (i - o) + n;
}
function nl(t, e, n, o, r, i, s, l, a, c) {
  let u = !1;
  return tl(t, e, n, o, r, i) && (u = !u), tl(t, e, r, i, s, l) && (u = !u), tl(t, e, s, l, a, c) && (u = !u), tl(t, e, a, c, n, o) && (u = !u), u;
}
function Vy(t, e, n) {
  return t >= n.x && t <= n.x + n.width && e >= n.y && e <= n.y + n.height;
}
function ol(t, e, n, o, r, i) {
  const s = Math.min(n, r), l = Math.max(n, r), a = Math.min(o, i), c = Math.max(o, i);
  return t >= s && t <= l && e >= a && e <= c;
}
function vs(t = {}) {
  const {
    blockPointerEvents: e = !1
  } = t, n = new Cn(), o = ({
    x: r,
    y: i,
    placement: s,
    elements: l,
    onClose: a,
    nodeId: c,
    tree: u
  }) => {
    const d = s?.split("-")[0];
    let f = !1, p = null, m = null, h = typeof performance < "u" ? performance.now() : 0;
    function b(C, y) {
      const w = performance.now(), R = w - h;
      if (p === null || m === null || R === 0)
        return p = C, m = y, h = w, !1;
      const S = C - p, E = y - m, N = S * S + E * E, M = R * R * _y;
      return p = C, m = y, h = w, N < M;
    }
    function v() {
      n.clear(), a();
    }
    return function(y) {
      n.clear();
      const w = l.domReference, R = l.floating;
      if (!w || !R || d == null || r == null || i == null)
        return;
      const {
        clientX: S,
        clientY: E
      } = y, N = bt(y), M = y.type === "mouseleave", T = He(R, N), P = He(w, N);
      if (T && (f = !0, !M))
        return;
      if (P && (f = !1, !M)) {
        f = !0;
        return;
      }
      if (M && pt(y.relatedTarget) && He(R, y.relatedTarget))
        return;
      function k() {
        return !!(u && uo(u.nodesRef.current, c).length > 0);
      }
      function I() {
        k() || v();
      }
      if (k())
        return;
      const D = w.getBoundingClientRect(), O = R.getBoundingClientRect(), V = r > O.right - O.width / 2, _ = i > O.bottom - O.height / 2, L = O.width > D.width, A = O.height > D.height, $ = (L ? D : O).left, Y = (L ? D : O).right, z = (A ? D : O).top, H = (A ? D : O).bottom;
      if (d === "top" && i >= D.bottom - 1 || d === "bottom" && i <= D.top + 1 || d === "left" && r >= D.right - 1 || d === "right" && r <= D.left + 1) {
        I();
        return;
      }
      let K = !1;
      switch (d) {
        case "top":
          K = ol(S, E, $, D.top + 1, Y, O.bottom - 1);
          break;
        case "bottom":
          K = ol(S, E, $, O.top + 1, Y, D.bottom - 1);
          break;
        case "left":
          K = ol(S, E, O.right - 1, H, D.left + 1, z);
          break;
        case "right":
          K = ol(S, E, D.right - 1, H, O.left + 1, z);
          break;
      }
      if (K)
        return;
      if (f && !Vy(S, E, D)) {
        I();
        return;
      }
      if (!M && b(S, E)) {
        I();
        return;
      }
      let G = !1;
      switch (d) {
        case "top": {
          const q = L ? kt / 2 : kt * 4, ee = L || V ? r + q : r - q, W = L ? r - q : V ? r + q : r - q, X = i + kt + 1, J = V || L ? O.bottom - kt : O.top, re = V ? L ? O.bottom - kt : O.top : O.bottom - kt;
          G = nl(S, E, ee, X, W, X, O.left, J, O.right, re);
          break;
        }
        case "bottom": {
          const q = L ? kt / 2 : kt * 4, ee = L || V ? r + q : r - q, W = L ? r - q : V ? r + q : r - q, X = i - kt, J = V || L ? O.top + kt : O.bottom, re = V ? L ? O.top + kt : O.bottom : O.top + kt;
          G = nl(S, E, ee, X, W, X, O.left, J, O.right, re);
          break;
        }
        case "left": {
          const q = A ? kt / 2 : kt * 4, ee = A || _ ? i + q : i - q, W = A ? i - q : _ ? i + q : i - q, X = r + kt + 1, J = _ || A ? O.right - kt : O.left, re = _ ? A ? O.right - kt : O.left : O.right - kt;
          G = nl(S, E, J, O.top, re, O.bottom, X, ee, X, W);
          break;
        }
        case "right": {
          const q = A ? kt / 2 : kt * 4, ee = A || _ ? i + q : i - q, W = A ? i - q : _ ? i + q : i - q, X = r - kt, J = _ || A ? O.left + kt : O.right, re = _ ? A ? O.left + kt : O.right : O.left + kt;
          G = nl(S, E, X, ee, X, W, J, O.top, re, O.bottom);
          break;
        }
      }
      G ? f || n.start(40, I) : I();
    };
  };
  return o.__options = {
    ...t,
    blockPointerEvents: e
  }, o;
}
const Zh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Zh.displayName = "ToolbarRootContext");
function Rd(t) {
  return x.useContext(Zh);
}
const Ur = "ArrowUp", ur = "ArrowDown", Qi = "ArrowLeft", Gr = "ArrowRight", ys = "Home", xs = "End", Xh = /* @__PURE__ */ new Set([Qi, Gr]), Ay = /* @__PURE__ */ new Set([Qi, Gr, ys, xs]), Qh = /* @__PURE__ */ new Set([Ur, ur]), Ly = /* @__PURE__ */ new Set([Ur, ur, ys, xs]), Jh = /* @__PURE__ */ new Set([...Xh, ...Qh]), Fy = /* @__PURE__ */ new Set([...Jh, ys, xs]), Cs = /* @__PURE__ */ new Set([Ur, ur, Qi, Gr, ys, xs]), e2 = "Shift", $y = "Control", Hy = "Alt", zy = "Meta", By = /* @__PURE__ */ new Set([e2, $y, Hy, zy]);
function Wy(t) {
  return Ct(t) && t.tagName === "INPUT";
}
function kp(t) {
  return !!(Wy(t) && t.selectionStart != null || Ct(t) && t.tagName === "TEXTAREA");
}
function Ip(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, i = t.scrollTop;
  const s = t.clientWidth < t.scrollWidth, l = t.clientHeight < t.scrollHeight;
  if (s && o !== "vertical") {
    const a = Pp(t, e, "left"), c = rl(t), u = rl(e);
    n === "ltr" && (a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : a - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = a - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (a - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = a - u.scrollMarginLeft - c.scrollPaddingLeft : a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (l && o !== "horizontal") {
    const a = Pp(t, e, "top"), c = rl(t), u = rl(e);
    a - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? i = a - u.scrollMarginTop - c.scrollPaddingTop : a + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (i = a + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: i,
    behavior: "auto"
  });
}
function Pp(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function rl(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
function Nr(t) {
  return t === "starting" ? Y8 : St;
}
const Uy = {
  ...In,
  ...Bt
}, t2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a
  } = Jn(), {
    side: c,
    align: u
  } = ss(), d = Rd() != null, f = a.useState("open"), p = a.useState("transitionStatus"), m = a.useState("popupProps"), h = a.useState("mounted"), b = a.useState("instantType"), v = a.useState("activeTriggerElement"), C = a.useState("parent"), y = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), R = a.useState("floatingRootContext"), S = a.useState("floatingTreeRoot"), E = a.useState("closeDelay"), N = a.useState("activeTriggerElement"), M = C.type === "context-menu";
  jt({
    open: f,
    ref: a.context.popupRef,
    onComplete() {
      f && a.context.onOpenChangeComplete?.(!0);
    }
  }), x.useEffect(() => {
    function V(_) {
      a.setOpen(!1, _e(_.reason, _.domEvent));
    }
    return S.events.on("close", V), () => {
      S.events.off("close", V);
    };
  }, [S.events, a]);
  const T = a.useState("hoverEnabled"), P = a.useState("disabled");
  ma(R, {
    enabled: T && !P && !M && C.type !== "menubar",
    closeDelay: E
  });
  const k = {
    transitionStatus: p,
    side: c,
    align: u,
    open: f,
    nested: C.type === "menu",
    instant: b
  }, I = x.useCallback((V) => {
    a.set("popupElement", V);
  }, [a]), D = Le("div", e, {
    state: k,
    ref: [n, a.context.popupRef, I],
    stateAttributesMapping: Uy,
    props: [m, {
      onKeyDown(V) {
        d && Cs.has(V.key) && V.stopPropagation();
      }
    }, Nr(p), l, {
      "data-rootownerid": w
    }]
  });
  let O = C.type === void 0 || M;
  return (v || C.type === "menubar" && y !== ls) && (O = !0), /* @__PURE__ */ g(ri, {
    context: R,
    modal: M,
    disabled: !h,
    returnFocus: s === void 0 ? O : s,
    initialFocus: C.type !== "menu",
    restoreFocus: !0,
    externalTree: C.type !== "menubar" ? S : void 0,
    previousFocusableElement: N,
    nextFocusableElement: C.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: C.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (t2.displayName = "MenuPopup");
const Ed = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ed.displayName = "MenuPortalContext");
function Gy() {
  const t = x.useContext(Ed);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : tt(32));
  return t;
}
const n2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Jn();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(Ed.Provider, {
    value: o,
    children: /* @__PURE__ */ g(oi, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (n2.displayName = "MenuPortal");
function kr(t) {
  return Mu(19) ? t : t ? "true" : void 0;
}
const o2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (o2.displayName = "DirectionContext");
function ws() {
  return x.useContext(o2)?.direction ?? "ltr";
}
const Yy = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = To(t, e) || {};
    if (c == null)
      return {};
    const f = mh(u), p = {
      x: n,
      y: o
    }, m = ed(r), h = Ju(m), b = await s.getDimensions(c), v = m === "y", C = v ? "top" : "left", y = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", R = i.reference[h] + i.reference[m] - p[m] - i.floating[h], S = p[m] - i.reference[m], E = d === "real" ? await s.getOffsetParent?.(c) : l.floating;
    let N = l.floating[w] || i.floating[h];
    (!N || !await s.isElement?.(E)) && (N = l.floating[w] || i.floating[h]);
    const M = R / 2 - S / 2, T = N / 2 - b[h] / 2 - 1, P = Math.min(f[C], T), k = Math.min(f[y], T), I = P, D = N - b[h] - k, O = N / 2 - b[h] / 2 + M, V = iu(I, O, D), _ = !a.arrow && tr(r) != null && O !== V && i.reference[h] / 2 - (O < I ? P : k) - b[h] / 2 < 0, L = _ ? O < I ? O - I : O - D : 0;
    return {
      [m]: p[m] + L,
      data: {
        [m]: V,
        centerOffset: O - V - L,
        ..._ && {
          alignmentOffset: L
        }
      },
      reset: _
    };
  }
}), jy = (t, e) => ({
  ...Yy(t),
  options: [t, e]
}), Ky = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, i = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await G6().fn(t)).data?.referenceHidden || i
      }
    };
  }
}, Sl = {
  sideX: "left",
  sideY: "top"
}, ha = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: i,
      strategy: s,
      placement: l
    } = t, a = wt(r), c = a.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: Sl
      };
    const d = await i.getOffsetParent?.(r);
    let f = {
      width: 0,
      height: 0
    };
    if (s === "fixed" && a?.visualViewport)
      f = {
        width: a.visualViewport.width,
        height: a.visualViewport.height
      };
    else if (d === a) {
      const C = et(r);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else await i.isElement?.(d) && (f = await i.getDimensions(d));
    const p = xn(l);
    let m = e, h = n;
    p === "left" && (m = f.width - (e + o.width)), p === "top" && (h = f.height - (n + o.height));
    const b = p === "left" ? "right" : Sl.sideX, v = p === "top" ? "bottom" : Sl.sideY;
    return {
      x: m,
      y: h,
      data: {
        sideX: b,
        sideY: v
      }
    };
  }
};
function r2(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function Mp(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: r2(e, xn(r), n),
    align: tr(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function ii(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: i = "center",
    alignOffset: s = 0,
    collisionBoundary: l,
    collisionPadding: a = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: p,
    mounted: m,
    collisionAvoidance: h,
    shiftCrossAxis: b = !1,
    nodeId: v,
    adaptiveOrigin: C,
    lazyFlip: y = !1,
    externalTree: w
  } = t, [R, S] = x.useState(null);
  !m && R !== null && S(null);
  const E = h.side || "flip", N = h.align || "flip", M = h.fallbackAxisSide || "end", T = typeof e == "function" ? e : void 0, P = Ce(T), k = T ? P : e, I = Ht(e), D = Ht(m), V = ws() === "rtl", _ = R || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": V ? "left" : "right",
    "inline-start": V ? "right" : "left"
  }[o], L = i === "center" ? _ : `${_}-${i}`;
  let A = a;
  const $ = 1, Y = o === "bottom" ? $ : 0, z = o === "top" ? $ : 0, H = o === "right" ? $ : 0, K = o === "left" ? $ : 0;
  typeof A == "number" ? A = {
    top: A + Y,
    right: A + K,
    bottom: A + z,
    left: A + H
  } : A && (A = {
    top: (A.top || 0) + Y,
    right: (A.right || 0) + K,
    bottom: (A.bottom || 0) + z,
    left: (A.left || 0) + H
  });
  const G = {
    boundary: l === "clipping-ancestors" ? "clippingAncestors" : l,
    padding: A
  }, q = x.useRef(null), ee = Ht(r), W = Ht(s), re = [H6((ze) => {
    const Ee = Mp(ze, o, V), Ae = typeof ee.current == "function" ? ee.current(Ee) : ee.current, Pe = typeof W.current == "function" ? W.current(Ee) : W.current;
    return {
      mainAxis: Ae,
      crossAxis: Pe,
      alignmentAxis: Pe
    };
  }, [typeof r != "function" ? r : 0, typeof s != "function" ? s : 0, V, o])], Q = N === "none" && E !== "shift", ie = !Q && (c || b || E === "shift"), ce = E === "none" ? null : W6({
    ...G,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: A.top + $,
      right: A.right + $,
      bottom: A.bottom + $,
      left: A.left + $
    },
    mainAxis: !b && E === "flip",
    crossAxis: N === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: M
  }), oe = Q ? null : z6((ze) => {
    const Ee = et(ze.elements.floating).documentElement;
    return {
      ...G,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: b ? {
        x: 0,
        y: 0,
        width: Ee.clientWidth,
        height: Ee.clientHeight
      } : void 0,
      mainAxis: N !== "none",
      crossAxis: ie,
      limiter: c || b ? void 0 : B6((Ae) => {
        if (!q.current)
          return {};
        const {
          width: Pe,
          height: Oe
        } = q.current.getBoundingClientRect(), $e = Vn(xn(Ae.placement)), Te = $e === "y" ? Pe : Oe, vt = $e === "y" ? A.left + A.right : A.top + A.bottom;
        return {
          offset: Te / 2 + vt / 2
        };
      })
    };
  }, [G, c, b, A, N]);
  E === "shift" || N === "shift" || i === "center" ? re.push(oe, ce) : re.push(ce, oe), re.push(U6({
    ...G,
    apply({
      elements: {
        floating: ze
      },
      availableWidth: Ee,
      availableHeight: Ae,
      rects: Pe
    }) {
      if (!D.current)
        return;
      const Oe = ze.style;
      Oe.setProperty("--available-width", `${Ee}px`), Oe.setProperty("--available-height", `${Ae}px`);
      const $e = wt(ze).devicePixelRatio || 1, {
        x: Te,
        y: vt,
        width: st,
        height: Se
      } = Pe.reference, ke = (Math.round((Te + st) * $e) - Math.round(Te * $e)) / $e, Fe = (Math.round((vt + Se) * $e) - Math.round(vt * $e)) / $e;
      Oe.setProperty("--anchor-width", `${ke}px`), Oe.setProperty("--anchor-height", `${Fe}px`);
    }
  }), jy(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: q.current || et(q.current).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(ze) {
      const {
        elements: Ee,
        middlewareData: Ae,
        placement: Pe,
        rects: Oe,
        y: $e
      } = ze, Te = xn(Pe), vt = Vn(Te), st = q.current, Se = Ae.arrow?.x || 0, ke = Ae.arrow?.y || 0, Fe = st?.clientWidth || 0, Ue = st?.clientHeight || 0, it = Se + Fe / 2, Ke = ke + Ue / 2, ot = Math.abs(Ae.shift?.y || 0), Ye = Oe.reference.height / 2, Xe = typeof r == "function" ? r(Mp(ze, o, V)) : r, rt = ot > Xe, ct = {
        top: `${it}px calc(100% + ${Xe}px)`,
        bottom: `${it}px ${-Xe}px`,
        left: `calc(100% + ${Xe}px) ${Ke}px`,
        right: `${-Xe}px ${Ke}px`
      }[Te], mt = `${it}px ${Oe.reference.y + Ye - $e}px`;
      return Ee.floating.style.setProperty("--transform-origin", ie && vt === "y" && rt ? mt : ct), {};
    }
  }, Ky, C), Ne(() => {
    !m && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [m, p]);
  const se = x.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: fe,
    elements: be,
    x: le,
    y: me,
    middlewareData: j,
    update: te,
    placement: U,
    context: Z,
    isPositioned: ue,
    floatingStyles: pe
  } = Iy({
    rootContext: p,
    open: f ? m : void 0,
    placement: L,
    middleware: re,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...ze) => mp(...ze, se),
    nodeId: v,
    externalTree: w
  }), {
    sideX: he,
    sideY: Ie
  } = j.adaptiveOrigin || Sl, ye = ue ? n : "fixed", xe = x.useMemo(() => {
    const ze = C ? {
      position: ye,
      [he]: le,
      [Ie]: me
    } : {
      position: ye,
      ...pe
    };
    return ue || (ze.opacity = 0), ze;
  }, [C, ye, he, le, Ie, me, pe, ue]), de = x.useRef(null);
  Ne(() => {
    if (!m)
      return;
    const ze = I.current, Ee = typeof ze == "function" ? ze() : ze, Pe = (Tp(Ee) ? Ee.current : Ee) || null || null;
    Pe !== de.current && (fe.setPositionReference(Pe), de.current = Pe);
  }, [m, fe, k, I]), x.useEffect(() => {
    if (!m)
      return;
    const ze = I.current;
    typeof ze != "function" && Tp(ze) && ze.current !== de.current && (fe.setPositionReference(ze.current), de.current = ze.current);
  }, [m, fe, k, I]), x.useEffect(() => {
    if (f && m && be.domReference && be.floating)
      return mp(be.domReference, be.floating, te, se);
  }, [f, m, be, te, se]);
  const we = xn(U), Me = r2(o, we, V), Re = tr(U) || "center", Ve = !!j.hide?.referenceHidden;
  Ne(() => {
    y && m && ue && S(we);
  }, [y, m, ue, we]);
  const je = x.useMemo(() => ({
    position: "absolute",
    top: j.arrow?.y,
    left: j.arrow?.x
  }), [j.arrow]), Ze = j.arrow?.centerOffset !== 0;
  return x.useMemo(() => ({
    positionerStyles: xe,
    arrowStyles: je,
    arrowRef: q,
    arrowUncentered: Ze,
    side: Me,
    align: Re,
    physicalSide: we,
    anchorHidden: Ve,
    refs: fe,
    context: Z,
    isPositioned: ue,
    update: te
  }), [xe, je, q, Ze, Me, Re, we, Ve, fe, Z, ue, te]);
}
function Tp(t) {
  return t != null && "current" in t;
}
function si(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, i = Ce(r), s = x.useRef(0), l = Tt(Zy).current, a = Tt(qy).current, [c, u] = x.useState(0), d = x.useRef(c), f = Ce((v, C) => {
    a.set(v, C ?? null), d.current += 1, u(d.current);
  }), p = Ce((v) => {
    a.delete(v), d.current += 1, u(d.current);
  }), m = x.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return Array.from(a.keys()).filter((y) => y.isConnected).sort(Xy).forEach((y, w) => {
      const R = a.get(y) ?? {};
      v.set(y, {
        ...R,
        index: w
      });
    }), v;
  }, [a, c]);
  Ne(() => {
    if (typeof MutationObserver != "function" || m.size === 0)
      return;
    const v = new MutationObserver((C) => {
      const y = /* @__PURE__ */ new Set(), w = (R) => y.has(R) ? y.delete(R) : y.add(R);
      C.forEach((R) => {
        R.removedNodes.forEach(w), R.addedNodes.forEach(w);
      }), y.size === 0 && (d.current += 1, u(d.current));
    });
    return m.forEach((C, y) => {
      y.parentElement && v.observe(y.parentElement, {
        childList: !0
      });
    }), () => {
      v.disconnect();
    };
  }, [m]), Ne(() => {
    d.current === c && (n.current.length !== m.size && (n.current.length = m.size), o && o.current.length !== m.size && (o.current.length = m.size), s.current = m.size), i(m);
  }, [i, m, n, o, c]), Ne(() => () => {
    n.current = [];
  }, [n]), Ne(() => () => {
    o && (o.current = []);
  }, [o]);
  const h = Ce((v) => (l.add(v), () => {
    l.delete(v);
  }));
  Ne(() => {
    l.forEach((v) => v(m));
  }, [l, m]);
  const b = x.useMemo(() => ({
    register: f,
    unregister: p,
    subscribeMapChange: h,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: s
  }), [f, p, h, n, o, s]);
  return /* @__PURE__ */ g(ju.Provider, {
    value: b,
    children: e
  });
}
function qy() {
  return /* @__PURE__ */ new Map();
}
function Zy() {
  return /* @__PURE__ */ new Set();
}
function Xy(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const li = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let i;
  if (o) {
    const s = o.getBoundingClientRect();
    i = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${s.left}px ${s.top}px,${s.left}px ${s.bottom}px,${s.right}px ${s.bottom}px,${s.right}px ${s.top}px,${s.left}px ${s.top}px)`;
  }
  return /* @__PURE__ */ g("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: i
    }
  });
});
process.env.NODE_ENV !== "production" && (li.displayName = "InternalBackdrop");
function ai(t, e, {
  styles: n,
  transitionStatus: o,
  props: r,
  refs: i,
  hidden: s,
  inert: l = !1
}) {
  const a = {
    ...n
  };
  return l && (a.pointerEvents = "none"), Le("div", t, {
    state: e,
    ref: i,
    props: [{
      role: "presentation",
      hidden: s,
      style: a
    }, Nr(o), r],
    stateAttributesMapping: In
  });
}
let Op = {}, Dp = {}, _p = "";
function Qy(t) {
  if (typeof document > "u")
    return !1;
  const e = et(t);
  return wt(e).innerWidth - e.documentElement.clientWidth > 0;
}
function Jy(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = et(t), o = n.documentElement, r = n.body, i = Jo(o) ? o : r, s = i.style.overflowY, l = o.style.scrollbarGutter;
  o.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
  const a = i.offsetWidth;
  i.style.overflowY = "hidden";
  const c = i.offsetWidth;
  return i.style.overflowY = s, o.style.scrollbarGutter = l, a === c;
}
function e9(t) {
  const e = et(t), n = e.documentElement, o = e.body, r = Jo(n) ? n : o, i = {
    overflowY: r.style.overflowY,
    overflowX: r.style.overflowX
  };
  return Object.assign(r.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(r.style, i);
  };
}
function t9(t) {
  const e = et(t), n = e.documentElement, o = e.body, r = wt(n);
  let i = 0, s = 0, l = !1;
  const a = Lt.create();
  if (Uu && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), m = r.getComputedStyle(o), v = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    i = n.scrollTop, s = n.scrollLeft, Op = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, _p = n.style.scrollBehavior, Dp = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const C = n.scrollHeight > n.clientHeight, y = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || m.overflowY === "scroll", R = p.overflowX === "scroll" || m.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), E = Math.max(0, r.innerHeight - o.clientHeight), N = parseFloat(m.marginTop) + parseFloat(m.marginBottom), M = parseFloat(m.marginLeft) + parseFloat(m.marginRight), T = Jo(n) ? n : o;
    if (l = Jy(t), l) {
      n.style.scrollbarGutter = v, T.style.overflowY = "hidden", T.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: v,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (C || w) && (n.style.overflowY = "scroll"), (y || R) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: N || E ? `calc(100dvh - ${N + E}px)` : "100dvh",
      width: M || S ? `calc(100vw - ${M + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = i, o.scrollLeft = s, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, Op), Object.assign(o.style, Dp), l || (n.scrollTop = i, n.scrollLeft = s, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = _p);
  }
  function d() {
    u(), a.request(c);
  }
  c();
  const f = dt(r, "resize", d);
  return () => {
    a.cancel(), u(), typeof r.removeEventListener == "function" && f();
  };
}
class n9 {
  lockCount = 0;
  restore = null;
  timeoutLock = Cn.create();
  timeoutUnlock = Cn.create();
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = et(e).documentElement, r = wt(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = xt;
      return;
    }
    const i = Gu || !Qy(e);
    this.restore = i ? e9(e) : t9(e);
  }
}
const o9 = new n9();
function i2(t = !0, e = null) {
  Ne(() => {
    if (t)
      return o9.acquire(e);
  }, [t, e]);
}
const r9 = 20;
function ba(t, e, n, o) {
  const [r, i] = x.useState(!1);
  Ne(() => {
    if (!t || !e || n == null) {
      i(!1);
      return;
    }
    const s = et(n).documentElement.clientWidth, l = n.offsetWidth;
    i(s > 0 && l > 0 && l >= s - r9);
  }, [t, e, n]), i2(t && (!e || r), o);
}
const s2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l,
    align: a,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = rd,
    style: v,
    ...C
  } = e, {
    store: y
  } = Jn(), w = Gy(), R = la(!0), S = y.useState("parent"), E = y.useState("floatingRootContext"), N = y.useState("floatingTreeRoot"), M = y.useState("mounted"), T = y.useState("open"), P = y.useState("modal"), k = y.useState("openMethod"), I = y.useState("activeTriggerElement"), D = y.useState("transitionStatus"), O = y.useState("positionerElement"), V = y.useState("instantType"), _ = y.useState("hasViewport"), L = y.useState("lastOpenChangeReason"), A = y.useState("floatingNodeId"), $ = y.useState("floatingParentNodeId"), Y = E.useState("domReferenceElement"), z = x.useRef(null), H = ta(O, !1, !1);
  let K = o, G = c, q = u, ee = a, W = b;
  S.type === "context-menu" && (K = o ?? S.context?.anchor, ee = ee ?? "start", !l && ee !== "center" && (q = e.alignOffset ?? 2, G = e.sideOffset ?? -5));
  let X = l, J = ee;
  S.type === "menu" ? (X = X ?? "inline-end", J = J ?? "start", W = e.collisionAvoidance ?? da) : S.type === "menubar" && (X = X ?? "bottom", J = J ?? "start");
  const re = S.type === "context-menu", Q = ii({
    anchor: K,
    floatingRootContext: E,
    positionMethod: R ? "fixed" : r,
    mounted: M,
    side: X,
    sideOffset: G,
    align: J,
    alignOffset: q,
    arrowPadding: re ? 0 : p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    nodeId: A,
    keepMounted: w,
    disableAnchorTracking: h,
    collisionAvoidance: W,
    shiftCrossAxis: re && !("side" in W && W.side === "flip"),
    externalTree: N,
    adaptiveOrigin: _ ? ha : void 0
  });
  x.useEffect(() => {
    function me(j) {
      j.open && (j.parentNodeId === A && y.set("hoverEnabled", !1), j.nodeId !== A && j.parentNodeId === y.select("floatingParentNodeId") && y.setOpen(!1, _e(Vi)));
    }
    return N.events.on("menuopenchange", me), () => {
      N.events.off("menuopenchange", me);
    };
  }, [y, N.events, A]), x.useEffect(() => {
    if (y.select("floatingParentNodeId") == null)
      return;
    function me(j) {
      if (j.open || j.nodeId !== y.select("floatingParentNodeId"))
        return;
      const te = j.reason ?? Vi;
      y.setOpen(!1, _e(te));
    }
    return N.events.on("menuopenchange", me), () => {
      N.events.off("menuopenchange", me);
    };
  }, [N.events, y]);
  const ie = _t();
  x.useEffect(() => {
    T || ie.clear();
  }, [T, ie]), x.useEffect(() => {
    function me(j) {
      if (!(!T || j.nodeId !== y.select("floatingParentNodeId")))
        if (j.target && I && I !== j.target) {
          const te = y.select("closeDelay");
          te > 0 ? ie.isStarted() || ie.start(te, () => {
            y.setOpen(!1, _e(Vi));
          }) : y.setOpen(!1, _e(Vi));
        } else
          ie.clear();
    }
    return N.events.on("itemhover", me), () => {
      N.events.off("itemhover", me);
    };
  }, [N.events, T, I, y, ie]), x.useEffect(() => {
    const me = {
      open: T,
      nodeId: A,
      parentNodeId: $,
      reason: y.select("lastOpenChangeReason")
    };
    N.events.emit("menuopenchange", me);
  }, [N.events, T, y, A, $]), Ne(() => {
    const me = Y, j = z.current;
    if (me && (z.current = me), j && me && me !== j) {
      y.set("instantType", void 0);
      const te = new AbortController();
      return H(() => {
        y.set("instantType", "trigger-change");
      }, te.signal), () => {
        te.abort();
      };
    }
  }, [Y, H, y]);
  const ce = {
    open: T,
    side: Q.side,
    align: Q.align,
    anchorHidden: Q.anchorHidden,
    nested: S.type === "menu",
    instant: V
  }, oe = S.type === "menubar" && S.context.modal;
  ba(T && (oe || P && L !== Ft), k === "touch", O, I);
  const fe = ai(e, ce, {
    styles: Q.positionerStyles,
    transitionStatus: D,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !M,
    inert: !T
  }), be = M && S.type !== "menu" && (S.type !== "menubar" && P && L !== Ft || S.type === "menubar" && S.context.modal);
  let le = null;
  return S.type === "menubar" ? le = S.context.contentElement : S.type === void 0 && (le = I), /* @__PURE__ */ F(zu.Provider, {
    value: Q,
    children: [be && /* @__PURE__ */ g(li, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: kr(!T),
      cutout: le
    }), /* @__PURE__ */ g(cd, {
      id: A,
      children: /* @__PURE__ */ g(si, {
        elementsRef: y.context.itemDomElements,
        labelsRef: y.context.itemLabels,
        children: fe
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (s2.displayName = "MenuPositioner");
const Nd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Nd.displayName = "MenuRadioGroupContext");
function i9() {
  const t = x.useContext(Nd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : tt(34));
  return t;
}
const l2 = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i,
    defaultValue: s,
    onValueChange: l,
    disabled: a = !1,
    style: c,
    ...u
  } = e, [d, f] = pn({
    controlled: i,
    default: s,
    name: "MenuRadioGroup"
  }), p = Ce(l), m = Ce((C, y) => {
    p?.(C, y), !y.isCanceled && f(C);
  }), b = Le("div", e, {
    state: {
      disabled: a
    },
    ref: n,
    props: {
      role: "group",
      "aria-disabled": a || void 0,
      ...u
    }
  }), v = x.useMemo(() => ({
    value: d,
    setValue: m,
    disabled: a
  }), [d, m, a]);
  return /* @__PURE__ */ g(Nd.Provider, {
    value: v,
    children: b
  });
}));
process.env.NODE_ENV !== "production" && (l2.displayName = "MenuRadioGroup");
const kd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (kd.displayName = "MenuRadioItemContext");
function s9() {
  const t = x.useContext(kd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : tt(35));
  return t;
}
const a2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = e, p = Do({
    label: s
  }), m = ss(!0), h = It(i), {
    store: b
  } = Jn(), v = b.useState("isActive", p.index), C = b.useState("itemProps"), {
    value: y,
    setValue: w,
    disabled: R
  } = i9(), S = R || a, E = y === u, {
    getItemProps: N,
    itemRef: M
  } = aa({
    closeOnClick: c,
    disabled: S,
    highlighted: v,
    id: h,
    store: b,
    nativeButton: l,
    nodeId: m?.context.nodeId,
    itemMetadata: Yu
  }), T = x.useMemo(() => ({
    disabled: S,
    highlighted: v,
    checked: E
  }), [S, v, E]), P = Ce((I) => {
    const D = {
      ..._e(Uo, I.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, D);
  }), k = Le("div", e, {
    state: T,
    stateAttributesMapping: qu,
    props: [C, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: P
    }, f, N],
    ref: [M, n, p.ref]
  });
  return /* @__PURE__ */ g(kd.Provider, {
    value: T,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (a2.displayName = "MenuRadioItem");
const c2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = s9(), c = x.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = Xn(a.checked);
  jt({
    open: a.checked,
    ref: c,
    onComplete() {
      a.checked || d(!1);
    }
  });
  const f = {
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: u
  };
  return Le("span", e, {
    state: f,
    stateAttributesMapping: qu,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...l
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (c2.displayName = "MenuRadioItemIndicator");
function Ir(t) {
  const e = x.useRef(!0);
  e.current && (e.current = !1, t());
}
const u2 = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (u2.displayName = "MenubarContext");
function d2(t) {
  return x.useContext(u2);
}
function l9(t) {
  const e = x.useRef(""), n = x.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: x.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r ? t(r, r.pointerType) : t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function So(t, e) {
  const n = x.useRef(t), o = Ce(e);
  Ne(() => {
    n.current !== t && o(n.current);
  }, [t, o]), Ne(() => {
    n.current = t;
  }, [t]);
}
function Ss(t) {
  const [e, n] = x.useState(null), o = Ce((s, l) => {
    t || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (Gu ? "touch" : ""));
  });
  So(t, (s) => {
    s && !t && n(null);
  });
  const {
    onClick: r,
    onPointerDown: i
  } = l9(o);
  return x.useMemo(() => ({
    openMethod: e,
    triggerProps: {
      onClick: r,
      onPointerDown: i
    }
  }), [e, r, i]);
}
const a9 = {
  ...gs,
  disabled: ge((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: ge((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  openMethod: ge((t) => t.openMethod),
  allowMouseEnter: ge((t) => t.allowMouseEnter),
  stickIfOpen: ge((t) => t.stickIfOpen),
  parent: ge((t) => t.parent),
  rootId: ge((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: ge((t) => t.activeIndex),
  isActive: ge((t, e) => t.activeIndex === e),
  hoverEnabled: ge((t) => t.hoverEnabled),
  instantType: ge((t) => t.instantType),
  lastOpenChangeReason: ge((t) => t.openChangeReason),
  floatingTreeRoot: ge((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: ge((t) => t.floatingNodeId),
  floatingParentNodeId: ge((t) => t.floatingParentNodeId),
  itemProps: ge((t) => t.itemProps),
  closeDelay: ge((t) => t.closeDelay),
  hasViewport: ge((t) => t.hasViewport),
  keyboardEventRelay: ge((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class Id extends Rr {
  constructor(e) {
    super({
      ...c9(),
      ...e
    }, {
      positionerRef: /* @__PURE__ */ x.createRef(),
      popupRef: /* @__PURE__ */ x.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new Er()
    }, a9), this.unsubscribeParentListener = this.observe("parent", (n) => {
      if (this.unsubscribeParentListener?.(), n.type === "menu") {
        let o = n.store.select("rootId"), r = n.store.select("floatingTreeRoot"), i = n.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = n.store.subscribe(() => {
          const s = n.store.select("rootId"), l = n.store.select("floatingTreeRoot"), a = n.store.select("keyboardEventRelay");
          o === s && r === l && i === a || (o = s, r = l, i = a, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = n.store.context.allowMouseUpTriggerRef;
        return;
      }
      n.type !== void 0 && (this.context.allowMouseUpTriggerRef = n.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(e, n) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: e,
      eventDetails: n
    });
  }
  static useStore(e, n) {
    const o = Tt(() => new Id(n)).current;
    return e ?? o;
  }
  unsubscribeParentListener = null;
}
function c9() {
  return {
    ...ms(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new sd(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: St,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Pd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pd.displayName = "MenuSubmenuRootContext");
function f2() {
  return x.useContext(Pd);
}
const ci = gd(function(e) {
  const {
    children: n,
    open: o,
    onOpenChange: r,
    onOpenChangeComplete: i,
    defaultOpen: s = !1,
    disabled: l = !1,
    modal: a,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: p,
    triggerId: m,
    defaultTriggerId: h = null,
    highlightItemOnHover: b = !0
  } = e, v = la(!0), C = Jn(!0), y = d2(!0), w = f2(), R = x.useMemo(() => w && C ? {
    type: "menu",
    store: C.store
  } : y ? {
    type: "menubar",
    context: y
  } : v && !C ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, C, y, w]), S = Id.useStore(p?.store, {
    open: s,
    openProp: o,
    activeTriggerId: h,
    triggerIdProp: m,
    parent: R
  });
  Ir(() => {
    o === void 0 && S.state.open === !1 && s === !0 && S.update({
      open: !0,
      activeTriggerId: h
    });
  }), S.useControlledProp("openProp", o), S.useControlledProp("triggerIdProp", m), S.useContextCallback("onOpenChangeComplete", i);
  const E = S.useState("floatingTreeRoot"), N = fa(E), M = vo();
  Ne(() => {
    v && !C ? S.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: N,
      floatingParentNodeId: M
    }) : C && S.update({
      floatingNodeId: N,
      floatingParentNodeId: M
    });
  }, [v, C, N, M, S]);
  const T = S.useState("open"), P = S.useState("activeTriggerElement"), k = S.useState("positionerElement"), I = S.useState("hoverEnabled"), D = S.useState("disabled"), O = S.useState("lastOpenChangeReason"), V = S.useState("parent"), _ = S.useState("activeIndex"), L = S.useState("payload"), A = S.useState("floatingParentNodeId"), $ = x.useRef(null), Y = A != null;
  process.env.NODE_ENV !== "production" && V.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: z,
    triggerProps: H
  } = Ss(T);
  S.useSyncedValues({
    disabled: l,
    modal: V.type === void 0 ? a : void 0,
    openMethod: z,
    rootId: _o()
  }), fs(S);
  const {
    forceUnmount: K
  } = ps(T, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  }), G = x.useRef(V.type !== "context-menu"), q = _t();
  x.useEffect(() => {
    if (T || ($.current = null), V.type === "context-menu") {
      if (!T) {
        q.clear(), G.current = !1;
        return;
      }
      q.start(500, () => {
        G.current = !0;
      });
    }
  }, [q, T, V.type]), Ne(() => {
    !T && !I && S.set("hoverEnabled", !0);
  }, [T, I, S]);
  const ee = x.useRef(!0), W = _t(), X = Ce((de, we) => {
    const Me = we.reason;
    if (T === de && we.trigger === P && O === Me || (we.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !de && we.trigger == null && (we.trigger = P ?? void 0), r?.(de, we), we.isCanceled))
      return;
    S.state.floatingRootContext.dispatchOpenChange(de, we);
    const Re = we.event;
    if (de === !1 && Re?.type === "click" && Re.pointerType === "touch" && !ee.current)
      return;
    if (!de && _ !== null) {
      const Ee = S.context.itemDomElements.current[_];
      queueMicrotask(() => {
        Ee?.setAttribute("tabindex", "-1");
      });
    }
    de && Me === fr ? (ee.current = !1, W.start(300, () => {
      ee.current = !0;
    })) : (ee.current = !0, W.clear());
    const Ve = (Me === Zn || Me === Uo) && Re.detail === 0 && Re?.isTrusted, je = !de && (Me === xr || Me == null), Ze = {
      open: de,
      openChangeReason: Me
    };
    $.current = we.event ?? null;
    const ze = we.trigger?.id ?? null;
    (ze || de) && (Ze.activeTriggerId = ze, Ze.activeTriggerElement = we.trigger ?? null), S.update(Ze), V.type === "menubar" && (Me === fr || Me === Mo || Me === Ft || Me === zr || Me === Vi) ? S.set("instantType", "group") : Ve || je ? S.set("instantType", Ve ? "click" : "dismiss") : S.set("instantType", void 0);
  }), J = x.useCallback(() => {
    S.setOpen(!1, _e(as));
  }, [S]);
  x.useImperativeHandle(d, () => ({
    unmount: K,
    close: J
  }), [K, J]);
  let re;
  V.type === "context-menu" && (re = V.context), x.useImperativeHandle(re?.positionerRef, () => k, [k]), x.useImperativeHandle(re?.actionsRef, () => ({
    setOpen: X
  }), [X]);
  const Q = hs({
    popupStore: S,
    onOpenChange: X
  }), ie = Q.context.events;
  x.useEffect(() => {
    const de = ({
      open: we,
      eventDetails: Me
    }) => X(we, Me);
    return ie.on("setOpen", de), () => {
      ie?.off("setOpen", de);
    };
  }, [ie, X]);
  const ce = Sr(Q, {
    enabled: !D,
    bubbles: {
      escapeKey: f && V.type === "menu"
    },
    outsidePress() {
      return V.type !== "context-menu" || $.current?.type === "contextmenu" ? !0 : G.current;
    },
    externalTree: Y ? E : void 0
  }), oe = wd(Q, {
    role: "menu"
  }), se = ws(), fe = x.useCallback((de) => {
    S.select("activeIndex") !== de && S.set("activeIndex", de);
  }, [S]), be = Cd(Q, {
    enabled: !D,
    listRef: S.context.itemDomElements,
    activeIndex: _,
    nested: V.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: V.type === "menubar" ? V.context.orientation : void 0,
    rtl: se === "rtl",
    disabledIndices: _n,
    onNavigate: fe,
    openOnArrowKeyDown: V.type !== "context-menu",
    externalTree: Y ? E : void 0,
    focusItemOnHover: b
  }), le = x.useCallback((de) => {
    S.context.typingRef.current = de;
  }, [S]), me = Sd(Q, {
    listRef: S.context.itemLabels,
    elementsRef: S.context.itemDomElements,
    activeIndex: _,
    resetMs: G8,
    onMatch: (de) => {
      T && de !== _ && S.set("activeIndex", de);
    },
    onTypingChange: le
  }), {
    getReferenceProps: j,
    getFloatingProps: te,
    getItemProps: U,
    getTriggerProps: Z
  } = eo([ce, oe, be, me]), ue = x.useMemo(() => {
    const de = Jt(j(), {
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, H);
    return delete de.role, de;
  }, [j, S, H]), pe = x.useMemo(() => {
    const de = Z();
    if (!de)
      return de;
    const we = Jt(de, H);
    return delete we.role, delete we["aria-controls"], we;
  }, [Z, H]), he = x.useMemo(() => te({
    onMouseMove() {
      S.set("allowMouseEnter", !0), V.type === "menu" && S.set("hoverEnabled", !1);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(de) {
      const we = S.select("keyboardEventRelay");
      we && !de.isPropagationStopped() && we(de);
    }
  }), [te, V.type, S]), Ie = x.useMemo(() => U(), [U]);
  S.useSyncedValues({
    floatingRootContext: Q,
    activeTriggerProps: ue,
    inactiveTriggerProps: pe,
    popupProps: he,
    itemProps: Ie
  });
  const ye = x.useMemo(() => ({
    store: S,
    parent: R
  }), [S, R]), xe = /* @__PURE__ */ g(Bu.Provider, {
    value: ye,
    children: typeof n == "function" ? n({
      payload: L
    }) : n
  });
  return V.type === void 0 || V.type === "context-menu" ? /* @__PURE__ */ g(ud, {
    externalTree: E,
    children: xe
  }) : xe;
});
process.env.NODE_ENV !== "production" && (ci.displayName = "MenuRoot");
function u9(t) {
  const e = Jn().store, n = x.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ g(Pd.Provider, {
    value: n,
    children: /* @__PURE__ */ g(ci, {
      ...t
    })
  });
}
function Md(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return e;
  const n = wt(t), o = n.getComputedStyle(t, "::before"), r = n.getComputedStyle(t, "::after");
  if (!(o.content !== "none" || r.content !== "none"))
    return e;
  const s = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, a = parseFloat(r.width) || 0, c = parseFloat(r.height) || 0, u = Math.max(e.width, s, a), d = Math.max(e.height, l, c), f = u - e.width, p = d - e.height;
  return {
    left: e.left - f / 2,
    right: e.right + f / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
function p2(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Fu(), {
    ref: r,
    index: i
  } = Do(t), s = n === i, l = x.useRef(null), a = mn(r, l);
  return {
    compositeProps: x.useMemo(() => ({
      tabIndex: s ? 0 : -1,
      onFocus() {
        o(i);
      },
      onMouseMove() {
        const u = l.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !s && !d && u.focus();
      }
    }), [s, o, i, e]),
    compositeRef: a,
    index: i
  };
}
function Td(t) {
  const {
    render: e,
    className: n,
    style: o,
    state: r = St,
    props: i = _n,
    refs: s = _n,
    metadata: l,
    stateAttributesMapping: a,
    tag: c = "div",
    ...u
  } = t, {
    compositeProps: d,
    compositeRef: f
  } = p2({
    metadata: l
  });
  return Le(c, t, {
    state: r,
    ref: [...s, f],
    props: [d, ...i, u],
    stateAttributesMapping: a
  });
}
function m2(t) {
  if (Ct(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!ao(t))
    return m2(mo(t));
}
function g2(t, e) {
  const n = x.useRef(null), o = Ce((i) => {
    cn.flushSync(() => {
      t.setOpen(!1, _e(Mo, i.nativeEvent, i.currentTarget));
    }), z8(n.current)?.focus();
  }), r = Ce((i) => {
    const s = t.select("positionerElement");
    if (s && Br(i, s))
      t.context.beforeContentFocusGuardRef.current?.focus();
    else {
      cn.flushSync(() => {
        t.setOpen(!1, _e(Mo, i.nativeEvent, i.currentTarget));
      });
      let l = H8(t.context.triggerFocusTargetRef.current || e.current);
      for (; l !== null && He(s, l); ) {
        const a = l;
        if (l = nd(l), l === a)
          break;
      }
      l?.focus();
    }
  });
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: o,
    handleFocusTargetFocus: r
  };
}
function d9(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = x.useRef(!1);
  return x.useMemo(() => e ? {
    onMouseDown: (i) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, et(i.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (i) => {
      r.current && (r.current = !1, i.preventBaseUIHandler());
    }
  } : St, [e, n, o]);
}
const il = 2, h2 = Yh(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    openOnHover: a,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    style: p,
    ...m
  } = e, h = Jn(!0), b = d?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : tt(85));
  const v = It(l), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), S = p9(), E = Fu(!0), N = nr(), M = x.useMemo(() => N ?? new sd(), [N]), T = fa(M), P = vo(), {
    registerTrigger: k,
    isMountedByThisTrigger: I
  } = ds(v, R, b, {
    payload: f,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: M,
    floatingNodeId: T,
    floatingParentNodeId: P,
    keyboardEventRelay: E?.relayKeyboardEvent
  }), D = S.type === "menubar", O = b.useState("disabled"), V = i || O || D && S.context.disabled, {
    getButtonProps: _,
    buttonRef: L
  } = Wt({
    disabled: V,
    native: s
  });
  x.useEffect(() => {
    !w && S.type === void 0 && (b.context.allowMouseUpTriggerRef.current = !1);
  }, [b, w, S.type]);
  const A = x.useRef(null), $ = _t(), Y = Ce((be) => {
    if (!A.current)
      return;
    $.clear(), b.context.allowMouseUpTriggerRef.current = !1;
    const le = be.target;
    if (He(A.current, le) || He(b.select("positionerElement"), le) || le === A.current || le != null && m2(le) === b.select("rootId"))
      return;
    const me = Md(A.current);
    be.clientX >= me.left - il && be.clientX <= me.right + il && be.clientY >= me.top - il && be.clientY <= me.bottom + il || M.events.emit("close", {
      domEvent: be,
      reason: Xg
    });
  });
  x.useEffect(() => {
    w && b.select("lastOpenChangeReason") === Ft && et(A.current).addEventListener("mouseup", Y, {
      once: !0
    });
  }, [w, Y, b]);
  const z = D && S.context.hasSubmenuOpen, K = bs(y, {
    enabled: (a ?? z) && !V && S.type !== "context-menu" && (!D || z && !I),
    handleClose: vs({
      blockPointerEvents: !D
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: R,
    externalTree: M,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), G = f9(w, b.select("lastOpenChangeReason")), q = wr(y, {
    enabled: !V && S.type !== "context-menu",
    event: w && D ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? G : !1
  }), ee = yd(y, {
    enabled: !V && z
  }), W = d9({
    open: w,
    enabled: D,
    mouseDownAction: "open"
  }), X = eo([q, ee]), J = {
    disabled: V,
    open: w
  }, re = b.useState("triggerProps", I), Q = [A, n, L, k, R], ie = [X.getReferenceProps(), K ?? St, re, {
    "aria-haspopup": "menu",
    id: v,
    onMouseDown: (be) => {
      if (b.select("open"))
        return;
      $.start(200, () => {
        b.context.allowMouseUpTriggerRef.current = !0;
      }), et(be.currentTarget).addEventListener("mouseup", Y, {
        once: !0
      });
    }
  }, D ? {
    role: "menuitem"
  } : {}, W, m, _], {
    preFocusGuardRef: ce,
    handlePreFocusGuardFocus: oe,
    handleFocusTargetFocus: se
  } = g2(b, R), fe = Le("button", e, {
    enabled: !D,
    stateAttributesMapping: Yi,
    state: J,
    ref: Q,
    props: ie
  });
  return D ? /* @__PURE__ */ g(Td, {
    tag: "button",
    render: o,
    className: r,
    style: p,
    state: J,
    refs: Q,
    props: ie,
    stateAttributesMapping: Yi
  }) : w ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(An, {
      ref: ce,
      onFocus: oe
    }, `${v}-pre-focus-guard`), /* @__PURE__ */ g(x.Fragment, {
      children: fe
    }, v), /* @__PURE__ */ g(An, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: se
    }, `${v}-post-focus-guard`)]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: fe
  }, v);
});
process.env.NODE_ENV !== "production" && (h2.displayName = "MenuTrigger");
function f9(t, e) {
  const n = _t(), [o, r] = x.useState(!1);
  return Ne(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(Mh, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function p9() {
  const t = la(!0), e = Jn(!0), n = d2();
  return x.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
function m9(t) {
  const [e, n] = x.useState({
    current: t,
    previous: null
  });
  return t !== e.current && n({
    current: t,
    previous: e.current
  }), e.previous;
}
function b2(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
const v2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: i,
    id: s,
    nativeButton: l = !1,
    openOnHover: a = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    style: f,
    ...p
  } = e, m = Do(), h = ss(), {
    store: b
  } = Jn(), v = It(s), C = b.useState("open"), y = b.useState("floatingRootContext"), w = b.useState("floatingTreeRoot"), R = jh(v, b), S = x.useCallback((q) => {
    const ee = R(q);
    return q !== null && b.select("open") && b.select("activeTriggerId") == null && b.update({
      activeTriggerId: v,
      activeTriggerElement: q,
      closeDelay: u
    }), ee;
  }, [R, u, b, v]), E = x.useRef(null), N = x.useCallback((q) => {
    E.current = q, b.set("activeTriggerElement", q);
  }, [b]);
  process.env.NODE_ENV !== "production" && Ne(() => {
    const q = E.current;
    if (q && b2(q) && !d) {
      const ee = mr.captureOwnerStack?.() || "";
      ea(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${ee}`);
    }
  });
  const M = f2();
  if (!M?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : tt(37));
  b.useSyncedValue("closeDelay", u);
  const T = M.parentMenu, P = T.useState("itemProps"), k = T.useState("isActive", m.index), I = x.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      T.set("activeIndex", m.index);
    }
  }), [T, m.index]), D = b.useState("disabled"), O = d || D, {
    getItemProps: V,
    itemRef: _
  } = aa({
    closeOnClick: !1,
    disabled: O,
    highlighted: k,
    id: v,
    store: b,
    typingRef: T.context.typingRef,
    nativeButton: l,
    itemMetadata: I,
    nodeId: h?.context.nodeId
  }), L = b.useState("hoverEnabled"), A = T.useState("allowMouseEnter"), $ = bs(y, {
    enabled: L && a && !O,
    handleClose: vs({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: A ? {
      open: c,
      close: u
    } : 0,
    triggerElementRef: E,
    externalTree: w,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), Y = wr(y, {
    enabled: !O,
    event: "mousedown",
    toggle: !a,
    ignoreMouse: a,
    stickIfOpen: !1
  }), z = eo([Y]), H = b.useState("triggerProps", !0);
  return delete H.id, Le("div", e, {
    state: {
      disabled: O,
      highlighted: k,
      open: C
    },
    stateAttributesMapping: yr,
    props: [z.getReferenceProps(), $, H, P, {
      tabIndex: C || k ? 0 : -1,
      onBlur() {
        k && T.set("activeIndex", null);
      }
    }, p, V],
    ref: [n, m.ref, _, S, N]
  });
});
process.env.NODE_ENV !== "production" && (v2.displayName = "MenuSubmenuTrigger");
const Od = ho({
  blockingLayerHost: null,
  portalHost: null
});
function Kt() {
  return dn(Od).portalHost ?? void 0;
}
function g9() {
  return dn(Od).blockingLayerHost ?? void 0;
}
function h9() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const b9 = ae(["rounded-(--radius-sm)", "border", "border-solid", "border-menu-default-outline", "bg-menu-default-background", "shadow-elevation-3", "p-(--spacing-4)", "flex", "flex-col", "max-h-[min(20rem,calc(100vh-2rem))]", "overflow-y-auto", "overscroll-contain", "outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"], {
  variants: {
    size: {
      sm: "w-[180px]",
      md: "w-[296px]",
      lg: "w-[400px]",
      anchor: "w-[var(--anchor-width)]",
      trigger: "w-[max(180px,var(--anchor-width))] max-w-[calc(100vw-var(--spacing-16))]",
      auto: "w-auto min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), v9 = ae(["flex", "h-[36px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[selected]:bg-menu-item-selected", "data-[checked]:bg-menu-item-selected", "[&[data-highlighted]:active]:bg-menu-item-pressed", "[&[data-selected]:active]:bg-menu-item-pressed", "[&[data-checked]:active]:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "data-[disabled]:hover:bg-transparent"], {
  variants: {
    tone: {
      default: "",
      destructive: ["text-menu-text-destructive", "[&_svg]:text-menu-icon-destructive"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
}), y9 = ne("flex", "h-(--spacing-24)", "w-full", "items-center", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-4)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle", "select-none", "data-[disabled]:text-menu-text-disabled-sub");
function ui({
  size: t,
  className: e
}) {
  return ne(b9({
    size: t
  }), e);
}
function Xr(t) {
  const e = B.c(19), {
    children: n,
    leadingIcon: o,
    endSection: r,
    checked: i,
    checkbox: s,
    submenu: l
  } = t;
  let a;
  e[0] !== s || e[1] !== i ? (a = s && /* @__PURE__ */ g(x9, { checked: i }), e[0] = s, e[1] = i, e[2] = a) : a = e[2];
  let c;
  e[3] !== o ? (c = o && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit" }) }), e[3] = o, e[4] = c) : c = e[4];
  let u;
  e[5] !== n ? (u = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[5] = n, e[6] = u) : u = e[6];
  let d;
  e[7] !== s || e[8] !== i ? (d = i && !s && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(We, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[7] = s, e[8] = i, e[9] = d) : d = e[9];
  let f;
  e[10] !== r || e[11] !== l ? (f = l ? /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(We, { name: "chevron-right", size: "xs", tone: "inherit" }) }) : r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[10] = r, e[11] = l, e[12] = f) : f = e[12];
  let p;
  return e[13] !== a || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F(Vt, { children: [
    a,
    c,
    u,
    d,
    f
  ] }), e[13] = a, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function x9(t) {
  const e = B.c(7), {
    checked: n
  } = t, o = n ? "" : void 0, r = n ? "" : void 0;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "h-(--icon-xs)", "w-(--icon-xs)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-[1.5px]", "border-checkbox-outline-default-border", "bg-surface-container-lowest", "text-transparent", "transition-colors", "duration-200", "ease-in-out", "data-[checked]:border-transparent", "data-[checked]:bg-checkbox-filled-default-background", "data-[checked]:text-surface-container-lowest", "[[data-disabled]_&]:border-transparent", "[[data-disabled]_&]:bg-checkbox-filled-disabled-background", "[[data-disabled]_&]:text-surface-container-lowest"), e[0] = i) : i = e[0];
  let s;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("span", { className: "h-[calc(var(--icon-xs)*0.8)] w-[calc(var(--icon-xs)*0.8)]", children: /* @__PURE__ */ g(h9, {}) }), e[1] = s) : s = e[1];
  let l;
  e[2] !== r ? (l = /* @__PURE__ */ g("span", { "data-checked": r, className: i, children: s }), e[2] = r, e[3] = l) : l = e[3];
  let a;
  return e[4] !== o || e[5] !== l ? (a = /* @__PURE__ */ g("span", { "aria-hidden": "true", "data-checked": o, className: "inline-flex h-(--icon-sm) w-(--icon-sm) shrink-0 items-center justify-center", children: l }), e[4] = o, e[5] = l, e[6] = a) : a = e[6], a;
}
function Oo({
  tone: t,
  className: e
}) {
  return ne(v9({
    tone: t
  }), e);
}
const C9 = 13;
function Dd(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(ci, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function jo(t) {
  const e = B.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g(h2, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function Pr(t) {
  const e = B.c(29);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    side: l,
    align: a,
    sideOffset: c,
    alignOffset: u,
    size: s,
    className: o,
    positionerClassName: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = l === void 0 ? "bottom" : l, f = a === void 0 ? "start" : a, p = c === void 0 ? 4 : c, m = u === void 0 ? 0 : u, h = Kt();
  let b;
  e[10] !== r ? (b = ne("z-[var(--z-layer-popover)]", r), e[10] = r, e[11] = b) : b = e[11];
  let v;
  e[12] !== o || e[13] !== s ? (v = ui({
    size: s,
    className: o
  }), e[12] = o, e[13] = s, e[14] = v) : v = e[14];
  let C;
  e[15] !== n || e[16] !== i || e[17] !== v ? (C = /* @__PURE__ */ g(t2, { className: v, ...i, children: n }), e[15] = n, e[16] = i, e[17] = v, e[18] = C) : C = e[18];
  let y;
  e[19] !== f || e[20] !== m || e[21] !== d || e[22] !== p || e[23] !== b || e[24] !== C ? (y = /* @__PURE__ */ g(s2, { side: d, align: f, sideOffset: p, alignOffset: m, className: b, children: C }), e[19] = f, e[20] = m, e[21] = d, e[22] = p, e[23] = b, e[24] = C, e[25] = y) : y = e[25];
  let w;
  return e[26] !== h || e[27] !== y ? (w = /* @__PURE__ */ g(n2, { container: h, children: y }), e[26] = h, e[27] = y, e[28] = w) : w = e[28], w;
}
function pr(t) {
  const e = B.c(36);
  let n, o, r, i, s, l, a;
  if (e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    submenu: l,
    tone: a,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]), l != null) {
    let f;
    if (e[8] !== s) {
      const {
        closeOnClick: C,
        ...y
      } = s;
      f = y, e[8] = s, e[9] = f;
    } else
      f = e[9];
    let p;
    e[10] !== o || e[11] !== a ? (p = Oo({
      tone: a,
      className: o
    }), e[10] = o, e[11] = a, e[12] = p) : p = e[12];
    let m;
    e[13] !== n || e[14] !== i ? (m = /* @__PURE__ */ g(Xr, { leadingIcon: i, submenu: !0, children: n }), e[13] = n, e[14] = i, e[15] = m) : m = e[15];
    let h;
    e[16] !== p || e[17] !== m || e[18] !== f ? (h = /* @__PURE__ */ g(v2, { className: p, ...f, children: m }), e[16] = p, e[17] = m, e[18] = f, e[19] = h) : h = e[19];
    let b;
    e[20] !== l ? (b = /* @__PURE__ */ g(Pr, { side: "right", align: "start", sideOffset: C9, alignOffset: -4, size: "sm", children: l }), e[20] = l, e[21] = b) : b = e[21];
    let v;
    return e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F(u9, { children: [
      h,
      b
    ] }), e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
  }
  let c;
  e[25] !== o || e[26] !== a ? (c = Oo({
    tone: a,
    className: o
  }), e[25] = o, e[26] = a, e[27] = c) : c = e[27];
  let u;
  e[28] !== n || e[29] !== r || e[30] !== i ? (u = /* @__PURE__ */ g(Xr, { leadingIcon: i, endSection: r, children: n }), e[28] = n, e[29] = r, e[30] = i, e[31] = u) : u = e[31];
  let d;
  return e[32] !== s || e[33] !== c || e[34] !== u ? (d = /* @__PURE__ */ g(rh, { className: c, ...s, children: u }), e[32] = s, e[33] = c, e[34] = u, e[35] = d) : d = e[35], d;
}
function _d(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(l2, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Vd(t) {
  const e = B.c(21);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o ? (l = Oo({
    className: o
  }), e[6] = o, e[7] = l) : l = e[7];
  let a;
  e[8] !== i ? (a = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(We, { name: i, size: "xs", tone: "inherit" }) }), e[8] = i, e[9] = a) : a = e[9];
  let c;
  e[10] !== n ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g(c2, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(We, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[12] = u) : u = e[12];
  let d;
  e[13] !== r ? (d = r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[13] = r, e[14] = d) : d = e[14];
  let f;
  return e[15] !== s || e[16] !== l || e[17] !== a || e[18] !== c || e[19] !== d ? (f = /* @__PURE__ */ F(a2, { className: l, ...s, children: [
    a,
    c,
    u,
    d
  ] }), e[15] = s, e[16] = l, e[17] = a, e[18] = c, e[19] = d, e[20] = f) : f = e[20], f;
}
function w9(t) {
  const e = B.c(19);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: o,
    leadingIcon: s,
    endSection: i,
    checked: n,
    className: r,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== r ? (a = Oo({
    className: r
  }), e[7] = r, e[8] = a) : a = e[8];
  let c;
  e[9] !== n || e[10] !== o || e[11] !== i || e[12] !== s ? (c = /* @__PURE__ */ g(Xr, { leadingIcon: s, endSection: i, checked: n, checkbox: !0, children: o }), e[9] = n, e[10] = o, e[11] = i, e[12] = s, e[13] = c) : c = e[13];
  let u;
  return e[14] !== n || e[15] !== l || e[16] !== a || e[17] !== c ? (u = /* @__PURE__ */ g(oh, { checked: n, className: a, ...l, children: c }), e[14] = n, e[15] = l, e[16] = a, e[17] = c, e[18] = u) : u = e[18], u;
}
function fu(t) {
  const e = B.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    disabled: r,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r ? "" : void 0, l = r || void 0;
  let a;
  e[5] !== o ? (a = ne(y9, o), e[5] = o, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== i || e[9] !== s || e[10] !== l || e[11] !== a ? (c = /* @__PURE__ */ g("div", { role: "presentation", "data-disabled": s, "aria-disabled": l, className: a, ...i, children: n }), e[7] = n, e[8] = i, e[9] = s, e[10] = l, e[11] = a, e[12] = c) : c = e[12], c;
}
const Ad = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ad.displayName = "TooltipRootContext");
function Rs(t) {
  const e = x.useContext(Ad);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : tt(72));
  return e;
}
const S9 = {
  ...gs,
  disabled: ge((t) => t.disabled),
  instantType: ge((t) => t.instantType),
  isInstantPhase: ge((t) => t.isInstantPhase),
  trackCursorAxis: ge((t) => t.trackCursorAxis),
  disableHoverablePopup: ge((t) => t.disableHoverablePopup),
  lastOpenChangeReason: ge((t) => t.openChangeReason),
  closeOnClick: ge((t) => t.closeOnClick),
  closeDelay: ge((t) => t.closeDelay),
  hasViewport: ge((t) => t.hasViewport)
};
class Ld extends Rr {
  constructor(e) {
    super({
      ...R9(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Er()
    }, S9);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Ft, i = e && o === fr, s = !e && (o === Zn || o === xr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e,
        openChangeReason: o
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Ft && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? cn.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Tt(() => new Ld(n)).current, r = e ?? o, i = hs({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function R9() {
  return {
    ...ms(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Fd = gd(function(e) {
  const {
    disabled: n = !1,
    defaultOpen: o = !1,
    open: r,
    disableHoverablePopup: i = !1,
    trackCursorAxis: s = "none",
    actionsRef: l,
    onOpenChange: a,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: p
  } = e, m = Ld.useStore(u?.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d
  });
  Ir(() => {
    r === void 0 && m.state.open === !1 && o === !0 && m.update({
      open: !0,
      activeTriggerId: f
    });
  }), m.useControlledProp("openProp", r), m.useControlledProp("triggerIdProp", d), m.useContextCallback("onOpenChange", a), m.useContextCallback("onOpenChangeComplete", c);
  const h = m.useState("open"), b = !n && h, v = m.useState("activeTriggerId"), C = m.useState("payload");
  m.useSyncedValues({
    trackCursorAxis: s,
    disableHoverablePopup: i
  }), Ne(() => {
    h && n && m.setOpen(!1, _e(d8));
  }, [h, n, m]), m.useSyncedValue("disabled", n), fs(m);
  const {
    forceUnmount: y,
    transitionStatus: w
  } = ps(b, m), R = m.select("floatingRootContext"), S = m.useState("isInstantPhase"), E = m.useState("instantType"), N = m.useState("lastOpenChangeReason"), M = x.useRef(null);
  Ne(() => {
    w === "ending" && N === Mt || w !== "ending" && S ? (E !== "delay" && (M.current = E), m.set("instantType", "delay")) : M.current !== null && (m.set("instantType", M.current), M.current = null);
  }, [w, S, N, E, m]), Ne(() => {
    b && v == null && m.set("payload", void 0);
  }, [m, v, b]);
  const T = x.useCallback(() => {
    m.setOpen(!1, _e(as));
  }, [m]);
  x.useImperativeHandle(l, () => ({
    unmount: y,
    close: T
  }), [y, T]);
  const P = Sr(R, {
    enabled: !n,
    referencePress: () => m.select("closeOnClick")
  }), k = n6(R, {
    enabled: !n && s !== "none",
    axis: s === "none" ? void 0 : s
  }), {
    getReferenceProps: I,
    getFloatingProps: D,
    getTriggerProps: O
  } = eo([P, k]), V = x.useMemo(() => I(), [I]), _ = x.useMemo(() => O(), [O]), L = x.useMemo(() => D(), [D]);
  return m.useSyncedValues({
    activeTriggerProps: V,
    inactiveTriggerProps: _,
    popupProps: L
  }), /* @__PURE__ */ g(Ad.Provider, {
    value: m,
    children: typeof p == "function" ? p({
      payload: C
    }) : p
  });
});
process.env.NODE_ENV !== "production" && (Fd.displayName = "TooltipRoot");
const $d = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && ($d.displayName = "TooltipProviderContext");
function E9() {
  return x.useContext($d);
}
let N9 = (function(t) {
  return t[t.popupOpen = Dl.popupOpen] = "popupOpen", t.triggerDisabled = "data-trigger-disabled", t;
})({});
const k9 = 600, Hd = Yh(function(e, n) {
  const {
    className: o,
    render: r,
    handle: i,
    payload: s,
    disabled: l,
    delay: a,
    closeOnClick: c = !0,
    closeDelay: u,
    id: d,
    style: f,
    ...p
  } = e, m = Rs(!0), h = i?.store ?? m;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : tt(82));
  const b = It(d), v = h.useState("isTriggerActive", b), C = h.useState("isOpenedByTrigger", b), y = h.useState("floatingRootContext"), w = x.useRef(null), R = a ?? k9, S = u ?? 0, {
    registerTrigger: E,
    isMountedByThisTrigger: N
  } = ds(b, w, h, {
    payload: s,
    closeOnClick: c,
    closeDelay: S
  }), M = E9(), {
    delayRef: T,
    isInstantPhase: P,
    hasProvider: k
  } = w8(y, {
    open: C
  });
  h.useSyncedValue("isInstantPhase", P);
  const I = h.useState("disabled"), D = l ?? I, O = h.useState("trackCursorAxis"), V = h.useState("disableHoverablePopup"), _ = bs(y, {
    enabled: !D,
    mouseOnly: !0,
    move: !1,
    handleClose: !V && O !== "both" ? vs() : null,
    restMs() {
      const z = M?.delay, H = typeof T.current == "object" ? T.current.open : void 0;
      let K = R;
      return k && (H !== 0 ? K = a ?? z ?? R : K = 0), K;
    },
    delay() {
      const z = typeof T.current == "object" ? T.current.close : void 0;
      let H = S;
      return u == null && k && (H = z), {
        close: H
      };
    },
    triggerElementRef: w,
    isActiveTrigger: v,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), L = yd(y, {
    enabled: !D
  }).reference, A = {
    open: C
  }, $ = h.useState("triggerProps", N);
  return Le("button", e, {
    state: A,
    ref: [n, E, w],
    props: [_, L, $, {
      onPointerDown() {
        h.set("closeOnClick", c);
      },
      id: b,
      [N9.triggerDisabled]: D ? "" : void 0
    }, p],
    stateAttributesMapping: yr
  });
});
process.env.NODE_ENV !== "production" && (Hd.displayName = "TooltipTrigger");
const zd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zd.displayName = "TooltipPortalContext");
function I9() {
  const t = x.useContext(zd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : tt(70));
  return t;
}
const va = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    style: l,
    ...a
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = Dh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: a
  });
  return !u && !c ? null : /* @__PURE__ */ F(x.Fragment, {
    children: [u, c && /* @__PURE__ */ cn.createPortal(o, c)]
  });
});
process.env.NODE_ENV !== "production" && (va.displayName = "FloatingPortalLite");
const Bd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Rs().useState("mounted") || o ? /* @__PURE__ */ g(zd.Provider, {
    value: o,
    children: /* @__PURE__ */ g(va, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Bd.displayName = "TooltipPortal");
const Wd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Wd.displayName = "TooltipPositionerContext");
function y2() {
  const t = x.useContext(Wd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : tt(71));
  return t;
}
const Ud = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "top",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = da,
    style: v,
    ...C
  } = e, y = Rs(), w = I9(), R = y.useState("open"), S = y.useState("mounted"), E = y.useState("trackCursorAxis"), N = y.useState("disableHoverablePopup"), M = y.useState("floatingRootContext"), T = y.useState("instantType"), P = y.useState("transitionStatus"), k = y.useState("hasViewport"), I = ii({
    anchor: i,
    positionMethod: s,
    floatingRootContext: M,
    mounted: S,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    arrowPadding: p,
    disableAnchorTracking: h,
    keepMounted: w,
    collisionAvoidance: b,
    adaptiveOrigin: k ? ha : void 0
  }), D = x.useMemo(() => ({
    open: R,
    side: I.side,
    align: I.align,
    anchorHidden: I.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : T
  }), [R, I.side, I.align, I.anchorHidden, E, T]), O = ai(e, D, {
    styles: I.positionerStyles,
    transitionStatus: P,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !S,
    inert: !R || E === "both" || N
  });
  return /* @__PURE__ */ g(Wd.Provider, {
    value: I,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (Ud.displayName = "TooltipPositioner");
const P9 = {
  ...In,
  ...Bt
}, Gd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Rs(), {
    side: a,
    align: c
  } = y2(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = l.useState("disabled"), b = l.useState("closeDelay");
  return ma(m, {
    enabled: !h,
    closeDelay: b
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Nr(f), s],
    stateAttributesMapping: P9
  });
});
process.env.NODE_ENV !== "production" && (Gd.displayName = "TooltipPopup");
const Yd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Rs(), a = l.useState("open"), c = l.useState("instantType"), {
    arrowRef: u,
    side: d,
    align: f,
    arrowUncentered: p,
    arrowStyles: m
  } = y2();
  return Le("div", e, {
    state: {
      open: a,
      side: d,
      align: f,
      uncentered: p,
      instant: c
    },
    ref: [n, u],
    props: [{
      style: m,
      "aria-hidden": !0
    }, s],
    stateAttributesMapping: In
  });
});
process.env.NODE_ENV !== "production" && (Yd.displayName = "TooltipArrow");
const x2 = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, i = x.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), s = x.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ g($d.Provider, {
    value: i,
    children: /* @__PURE__ */ g(C8, {
      delay: s,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (x2.displayName = "TooltipProvider");
const C2 = "z-[var(--z-layer-tooltip)]", w2 = 5, S2 = 9, R2 = ne("max-w-[240px]", "rounded-(--radius-sm)", "px-(--spacing-12) py-(--spacing-8)", "bg-surface-inverse-surface", "text-text-inverse", "shadow-elevation-2", "font-(family-name:--font-family-body)", "transition-opacity duration-150 ease-in-out", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0"), E2 = ne("text-(length:--font-size-label-small)", "leading-(--font-line-height-16)"), N2 = ne("text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "mt-(--spacing-4)"), k2 = ne("bg-surface-inverse-surface", "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)", "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)", "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)", "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)", "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]", "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]", "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]", "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]");
function qo(t) {
  const e = B.c(30), {
    children: n,
    label: o,
    description: r,
    endSection: i,
    side: s,
    align: l,
    disabled: a,
    showArrow: c
  } = t, u = s === void 0 ? "top" : s, d = l === void 0 ? "center" : l, f = a === void 0 ? !1 : a, p = c === void 0 ? !0 : c, m = Kt();
  let h;
  e[0] !== n ? (h = /* @__PURE__ */ g(Hd, { render: n }), e[0] = n, e[1] = h) : h = e[1];
  const b = p ? S2 : w2;
  let v;
  e[2] !== p ? (v = p && /* @__PURE__ */ g(Yd, { "data-slot": "tooltip-arrow", className: k2 }), e[2] = p, e[3] = v) : v = e[3];
  const C = r ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let y;
  e[4] !== C ? (y = ne(E2, C), e[4] = C, e[5] = y) : y = e[5];
  let w;
  e[6] !== o || e[7] !== y ? (w = /* @__PURE__ */ g("p", { className: y, children: o }), e[6] = o, e[7] = y, e[8] = w) : w = e[8];
  let R;
  e[9] !== i || e[10] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-8)", children: [
    w,
    i
  ] }), e[9] = i, e[10] = w, e[11] = R) : R = e[11];
  let S;
  e[12] !== r ? (S = r && /* @__PURE__ */ g("p", { className: N2, children: r }), e[12] = r, e[13] = S) : S = e[13];
  let E;
  e[14] !== R || e[15] !== S || e[16] !== v ? (E = /* @__PURE__ */ F(Gd, { className: R2, children: [
    v,
    R,
    S
  ] }), e[14] = R, e[15] = S, e[16] = v, e[17] = E) : E = e[17];
  let N;
  e[18] !== d || e[19] !== u || e[20] !== E || e[21] !== b ? (N = /* @__PURE__ */ g(Ud, { side: u, align: d, sideOffset: b, className: C2, children: E }), e[18] = d, e[19] = u, e[20] = E, e[21] = b, e[22] = N) : N = e[22];
  let M;
  e[23] !== m || e[24] !== N ? (M = /* @__PURE__ */ g(Bd, { container: m, children: N }), e[23] = m, e[24] = N, e[25] = M) : M = e[25];
  let T;
  return e[26] !== f || e[27] !== M || e[28] !== h ? (T = /* @__PURE__ */ F(Fd, { disabled: f, children: [
    h,
    M
  ] }), e[26] = f, e[27] = M, e[28] = h, e[29] = T) : T = e[29], T;
}
function Es() {
  const t = B.c(10), [e, n] = x.useState(!1);
  let o, r;
  t[0] !== e ? (o = () => {
    if (!e)
      return;
    const u = function() {
      n(!1);
    };
    return document.addEventListener("mouseup", u), document.addEventListener("dragend", u), window.addEventListener("blur", u), () => {
      document.removeEventListener("mouseup", u), document.removeEventListener("dragend", u), window.removeEventListener("blur", u);
    };
  }, r = [e], t[0] = e, t[1] = o, t[2] = r) : (o = t[1], r = t[2]), x.useEffect(o, r);
  const i = e ? "" : void 0;
  let s, l;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = (u) => {
    u.defaultPrevented || u.button !== 0 || n(!0);
  }, l = () => n(!1), t[3] = s, t[4] = l) : (s = t[3], l = t[4]);
  let a;
  t[5] !== i ? (a = {
    "data-mouse-down": i,
    onMouseDown: s,
    onMouseUp: l
  }, t[5] = i, t[6] = a) : a = t[6];
  let c;
  return t[7] !== e || t[8] !== a ? (c = {
    mouseDown: e,
    triggerMouseDownProps: a
  }, t[7] = e, t[8] = a, t[9] = c) : c = t[9], c;
}
function M9(t) {
  const e = B.c(17), {
    align: n,
    disabled: o,
    items: r,
    size: i,
    tooltip: s,
    variant: l,
    ...a
  } = t, c = n === void 0 ? "end" : n, u = o === void 0 ? !1 : o, d = i === void 0 ? "md" : i, f = l === void 0 ? "default" : l, [p, m] = x.useState(!1), {
    triggerMouseDownProps: h
  } = Es();
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = function(P) {
    m(P);
  }, e[0] = b) : b = e[0];
  const v = b, C = D9({
    disabled: u,
    isOpen: p,
    props: a,
    size: d,
    tooltip: s,
    triggerMouseDownProps: h,
    variant: f
  }), y = f === "combo" && "gap-(--spacing-4)";
  let w;
  e[1] !== y ? (w = ne("inline-flex items-center", y), e[1] = y, e[2] = w) : w = e[2];
  let R;
  e[3] !== w || e[4] !== C ? (R = /* @__PURE__ */ g("div", { className: w, children: C }), e[3] = w, e[4] = C, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] !== r ? (E = r.map(T9), e[6] = r, e[7] = E) : E = e[7];
  let N;
  e[8] !== c || e[9] !== E ? (N = /* @__PURE__ */ g(Pr, { align: c, sideOffset: 5, size: "trigger", children: E }), e[8] = c, e[9] = E, e[10] = N) : N = e[10];
  let M;
  return e[11] !== u || e[12] !== v || e[13] !== p || e[14] !== N || e[15] !== S ? (M = /* @__PURE__ */ F(Dd, { open: p, onOpenChange: v, disabled: u, modal: !1, children: [
    S,
    N
  ] }), e[11] = u, e[12] = v, e[13] = p, e[14] = N, e[15] = S, e[16] = M) : M = e[16], M;
}
function T9(t) {
  return t.type === "subheader" ? /* @__PURE__ */ g(fu, { disabled: t.disabled, children: t.label }, t.id) : O9(t);
}
function Vp(t) {
  return /* @__PURE__ */ g(pr, { disabled: t.disabled, endSection: t.endSection, leadingIcon: t.leadingIcon, onClick: t.onSelect, tone: t.tone, children: t.label }, t.id);
}
function O9(t) {
  return t.submenuItems ? /* @__PURE__ */ g(pr, { disabled: t.disabled, leadingIcon: t.leadingIcon, tone: t.tone, submenu: t.submenuItems.map(Vp), children: t.label }, t.id) : Vp(t);
}
function D9({
  disabled: t,
  isOpen: e,
  props: n,
  size: o,
  tooltip: r,
  triggerMouseDownProps: i,
  variant: s
}) {
  const l = o === "lg" ? "md" : o, a = o === "lg" ? {
    width: 44,
    height: 44
  } : void 0;
  if (s === "combo") {
    const {
      buttonVariant: p = "outline",
      label: m,
      onPrimaryAction: h
    } = n, b = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(gt, { "aria-label": `${m} menu`, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: l, style: a, variant: p, ...i }) });
    return /* @__PURE__ */ F(Vt, { children: [
      /* @__PURE__ */ g(H1, { disabled: t, onClick: h, size: o, variant: p, children: m }),
      r ? /* @__PURE__ */ g(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: b }) }) : b
    ] });
  }
  if (s === "overflow") {
    const {
      "aria-label": p
    } = n, m = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(gt, { "aria-label": p, disabled: t, icon: "ellipsis-dots", size: l, style: a, variant: "outline", ...i }) });
    return r ? /* @__PURE__ */ g(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: m }) }) : m;
  }
  const {
    "aria-label": c,
    label: u
  } = n, d = {};
  c && (d["aria-label"] = c);
  const f = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(H1, { ...d, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: o, variant: "outline", ...i, children: u }) });
  return r ? _9(f, r) : f;
}
function _9(t, e) {
  return /* @__PURE__ */ g(qo, { label: e, side: "top", align: "end", showArrow: !0, children: t });
}
const V9 = {
  xs: "size-(--spacing-40)",
  sm: "size-[60px]",
  md: "size-(--spacing-80)",
  lg: "size-[104px]",
  xl: "size-[120px]"
}, A9 = {
  xs: 40,
  sm: 60,
  md: 80,
  lg: 104,
  xl: 120
}, L9 = {
  xs: "6 6",
  sm: "8 6",
  md: "8 6",
  lg: "8 6",
  xl: "8 6"
}, F9 = {
  xs: 4,
  sm: 4,
  md: 0,
  lg: 2,
  xl: 0
};
function Wl(t) {
  const e = B.c(21), {
    size: n,
    fullWidth: o,
    src: r,
    alt: i,
    selected: s,
    onClick: l,
    "aria-label": a,
    onImageError: c
  } = t, u = n === void 0 ? "md" : n, f = (o === void 0 ? !1 : o) ? "aspect-square w-full" : V9[u], p = u === "sm" ? "focus-visible:ring-offset-1" : "focus-visible:ring-offset-2", m = !!l, h = s !== void 0, b = s === !1 && "opacity-50", v = s && "outline-solid outline-2 outline-primary outline-offset-2";
  let C;
  e[0] !== p || e[1] !== m || e[2] !== f || e[3] !== b || e[4] !== v ? (C = ne("relative inline-flex items-center justify-center shrink-0 overflow-hidden", f, "rounded-(--radius-sm)", b, v, m && ["cursor-pointer", "focus-visible:outline-none", "focus-visible:ring-2", p, "focus-visible:ring-datavis-blue-30"]), e[0] = p, e[1] = m, e[2] = f, e[3] = b, e[4] = v, e[5] = C) : C = e[5];
  const y = C;
  let w;
  e[6] !== i || e[7] !== c || e[8] !== u || e[9] !== f || e[10] !== r ? (w = r ? /* @__PURE__ */ g("img", { src: r, alt: i, className: ne(f, "object-cover"), onError: c }) : /* @__PURE__ */ F("div", { "data-slot": "thumbnail-frame", className: ne(f, "relative flex items-center justify-center rounded-(--radius-sm) bg-surface-container-lowest text-icon-main"), children: [
    /* @__PURE__ */ g($9, { size: u }),
    /* @__PURE__ */ g(We, { name: "image-regular", size: u, tone: "inherit" })
  ] }), e[6] = i, e[7] = c, e[8] = u, e[9] = f, e[10] = r, e[11] = w) : w = e[11];
  const R = w;
  if (m) {
    const E = h ? s : void 0;
    let N;
    return e[12] !== a || e[13] !== l || e[14] !== y || e[15] !== E || e[16] !== R ? (N = /* @__PURE__ */ g(Qn, { type: "button", className: y, "aria-label": a, "aria-pressed": E, onClick: l, children: R }), e[12] = a, e[13] = l, e[14] = y, e[15] = E, e[16] = R, e[17] = N) : N = e[17], N;
  }
  let S;
  return e[18] !== y || e[19] !== R ? (S = /* @__PURE__ */ g("div", { className: y, children: R }), e[18] = y, e[19] = R, e[20] = S) : S = e[20], S;
}
function $9(t) {
  const e = B.c(12), {
    size: n
  } = t, o = A9[n], r = o - 0.5, i = r - 3.5, s = L9[n], l = F9[n], a = `M 4 ${0.5} H ${i} A ${3.5} ${3.5} 0 0 1 ${r} 4`, c = `M ${r} 4 V ${i} A ${3.5} ${3.5} 0 0 1 ${i} ${r}`, u = `M ${i} ${r} H 4 A ${3.5} ${3.5} 0 0 1 ${0.5} ${i}`, d = `M ${0.5} ${i} V 4 A ${3.5} ${3.5} 0 0 1 4 ${0.5}`;
  let f;
  e[0] !== a || e[1] !== c || e[2] !== u || e[3] !== d ? (f = [a, c, u, d], e[0] = a, e[1] = c, e[2] = u, e[3] = d, e[4] = f) : f = e[4];
  const p = f, m = `0 0 ${o} ${o}`;
  let h;
  e[5] !== s || e[6] !== l || e[7] !== p ? (h = p.map((v) => /* @__PURE__ */ g("path", { "data-slot": "thumbnail-empty-stroke", className: "stroke-outline-subtle", d: v, strokeDasharray: s, strokeDashoffset: l, strokeLinecap: "butt", strokeLinejoin: "miter", strokeWidth: "1" }, v)), e[5] = s, e[6] = l, e[7] = p, e[8] = h) : h = e[8];
  let b;
  return e[9] !== m || e[10] !== h ? (b = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", viewBox: m, children: h }), e[9] = m, e[10] = h, e[11] = b) : b = e[11], b;
}
const di = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative"
}, fi = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
}, H9 = {
  ...fi,
  justify: "text-justify"
}, pi = {
  true: "truncate",
  false: ""
}, Io = {
  regular: "font-(number:--font-weight-regular)",
  medium: "font-(number:--font-weight-medium)",
  semibold: "font-(number:--font-weight-semibold)",
  bold: "font-(number:--font-weight-bold)"
}, I2 = {
  true: "italic",
  false: "not-italic"
}, z9 = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4"
}, B9 = ae(["font-(family-name:--font-family-body)", "text-(length:--font-size-body-small)", "leading-(--line-height-16)", "font-(number:--font-weight-regular)"], {
  variants: {
    tone: di,
    align: fi,
    truncate: pi
  },
  defaultVariants: {
    tone: "default"
  }
});
function BO({
  tone: t,
  align: e,
  truncate: n,
  as: o = "span",
  ...r
}) {
  return x.createElement(o, {
    className: B9({
      tone: t,
      align: e,
      truncate: n
    }),
    ...r
  });
}
const W9 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-lg)", "leading-(--line-height-64)", "tracking-[-0.25px]"],
      md: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-md)", "leading-(--line-height-52)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-sm)", "leading-(--line-height-44)", "tracking-normal"]
    },
    tone: di,
    align: fi,
    truncate: pi,
    weight: Io
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), U9 = {
  lg: "h1",
  md: "h1",
  sm: "h2"
};
function WO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? U9[t] : "h1", a = i || l;
  return x.createElement(a, {
    className: W9({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const G9 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-lg)", "leading-(--line-height-40)", "tracking-normal"],
      md: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-md)", "leading-(--line-height-36)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-sm)", "leading-(--line-height-32)", "tracking-normal"]
    },
    tone: di,
    align: fi,
    truncate: pi,
    weight: {
      medium: Io.medium,
      semibold: Io.semibold,
      bold: Io.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), Y9 = {
  lg: "h2",
  md: "h3",
  sm: "h4"
};
function UO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? Y9[t] : "h3", a = i || l;
  return x.createElement(a, {
    className: G9({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const j9 = ae("font-(family-name:--font-family-label)", {
  variants: {
    size: {
      lg: ["text-(length:--font-size-label-lg)", "leading-(--line-height-20)"],
      md: ["text-(length:--font-size-label-md)", "leading-(--line-height-20)"],
      sm: ["text-(length:--font-size-label-sm)", "leading-(--line-height-16)"],
      xs: ["text-(length:--font-size-label-xs)", "leading-(--line-height-16)"]
    },
    tone: di,
    align: fi,
    truncate: pi,
    weight: Io,
    italic: I2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "semibold",
    italic: !1
  }
});
function fo({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "semibold",
  italic: i = !1,
  as: s = "span",
  ...l
}) {
  return x.createElement(s, {
    className: j9({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r,
      italic: i
    }),
    ...l
  });
}
const K9 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-lg)", "leading-(--line-height-24)", "tracking-[0.5px]"],
      md: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-md)", "leading-(--line-height-20)", "tracking-[0.25px]"],
      sm: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-sm)", "leading-(--line-height-16)", "tracking-[0.4px]"]
    },
    tone: di,
    align: H9,
    truncate: pi,
    lineClamp: z9,
    weight: Io,
    italic: I2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "regular",
    italic: !1
  }
});
function nn({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  lineClamp: r,
  weight: i = "regular",
  italic: s = !1,
  as: l = "p",
  ...a
}) {
  return x.createElement(l, {
    className: K9({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      lineClamp: r,
      weight: i,
      italic: s
    }),
    ...a
  });
}
const q9 = ae("", {
  variants: {
    size: {
      xl: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xl)", "tracking-normal"],
      lg: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "tracking-[0.15px]"],
      md: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "tracking-[0.15px]"],
      sm: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-sm)", "tracking-[0.1px]"],
      xs: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xs)", "leading-(--line-height-16)", "tracking-[0.1px]"]
    },
    tone: di,
    align: fi,
    truncate: pi,
    weight: {
      medium: Io.medium,
      semibold: Io.semibold,
      bold: Io.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), Z9 = {
  xl: "h4",
  lg: "h5",
  md: "h5",
  sm: "h6",
  xs: "h6"
};
function wn({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? Z9[t] : "h5", a = i || l;
  return x.createElement(a, {
    className: q9({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const X9 = ae(["flex", "h-full", "min-h-0", "min-w-0", "w-full", "flex-col", "overflow-hidden", "bg-surface", "pb-(--spacing-20)", "pt-(--spacing-10)"]), Q9 = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-16)", "px-(--spacing-10)"]), J9 = ae(["flex", "shrink-0", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-8)", "py-(--spacing-8)"]), e7 = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-20)"]), t7 = ae(["flex", "shrink-0", "items-start", "gap-(--spacing-20)", "px-(--spacing-10)"]), n7 = ae(["flex", "min-w-0", "flex-1", "flex-col", "items-start", "gap-(--spacing-4)"]), o7 = ae(["flex", "w-full", "flex-wrap", "items-center", "gap-x-(--spacing-6)", "gap-y-(--spacing-2)"]), r7 = ae(["flex", "flex-1", "min-h-0", "min-w-0", "flex-col", "gap-(--spacing-12)", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface-low", "px-(--spacing-4)", "pb-(--spacing-4)"]), i7 = ae(["flex", "w-full", "max-w-[580px]", "min-w-0", "self-center", "flex-col"]), s7 = ae(["flex", "w-full", "flex-col", "gap-(--spacing-20)", "py-(--spacing-10)"]), l7 = ae(["flex", "min-w-0", "flex-col"], {
  variants: {
    informative: {
      true: "gap-(--spacing-12)",
      false: "gap-(--spacing-6)"
    }
  },
  defaultVariants: {
    informative: !1
  }
}), a7 = ae(["flex", "h-full", "min-h-0", "w-(--spacing-40)", "shrink-0", "flex-col", "items-center"]), c7 = ae(["w-(--spacing-2)", "flex-1", "bg-outline-variant"]);
function u7(t) {
  const e = B.c(24), {
    content: n,
    detail: o,
    actions: r
  } = t, i = "title" in n ? n.title : void 0, s = "body" in n ? n.body : void 0, l = n.type === "observation" || n.type === "next-step" || n.type === "recommended-procedure", a = l ? "informative" : void 0;
  let c;
  e[0] !== l ? (c = l7({
    informative: l
  }), e[0] = l, e[1] = c) : c = e[1];
  let u;
  e[2] !== i ? (u = i ? /* @__PURE__ */ g(wn, { size: "md", children: i }) : null, e[2] = i, e[3] = u) : u = e[3];
  let d;
  e[4] !== s || e[5] !== n.steps || e[6] !== n.type ? (d = n.type === "recommended-procedure" ? /* @__PURE__ */ g("ol", { className: "m-0 w-full list-decimal pl-(--spacing-20) text-(length:--font-size-body-medium) leading-(--font-line-height-20)", children: n.steps.map(d7) }) : s ? /* @__PURE__ */ g(nn, { size: "md", children: s }) : null, e[4] = s, e[5] = n.steps, e[6] = n.type, e[7] = d) : d = e[7];
  let f;
  e[8] !== n ? (f = "completion" in n && n.completion ? /* @__PURE__ */ g(nn, { size: "md", weight: "semibold", children: n.completion }) : null, e[8] = n, e[9] = f) : f = e[9];
  let p;
  e[10] !== o ? (p = o ? /* @__PURE__ */ g("div", { children: o }) : null, e[10] = o, e[11] = p) : p = e[11];
  let m;
  e[12] !== r ? (m = r ? /* @__PURE__ */ g("div", { className: "flex w-full items-center", children: r }) : null, e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ F("div", { className: c, children: [
    u,
    d,
    f,
    p,
    m
  ] }), e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  let b;
  return e[21] !== a || e[22] !== h ? (b = /* @__PURE__ */ g(nu, { tone: a, children: h }), e[21] = a, e[22] = h, e[23] = b) : b = e[23], b;
}
function d7(t) {
  return /* @__PURE__ */ g("li", { children: t.content }, t.id);
}
function f7(t) {
  const e = B.c(35), {
    alert: n,
    isCurrentUser: o,
    showConnector: r,
    renderAlertDetail: i,
    renderAlertActions: s
  } = t, l = o ? "outbound" : "inbound";
  let a;
  e[0] !== n.author.initials || e[1] !== n.author.name || e[2] !== n.author.type ? (a = /* @__PURE__ */ g(jr, { variant: n.author.type, initials: n.author.initials, "aria-label": n.author.name }), e[0] = n.author.initials, e[1] = n.author.name, e[2] = n.author.type, e[3] = a) : a = e[3];
  const c = a;
  let u;
  e[4] !== c || e[5] !== o || e[6] !== r ? (u = o ? null : /* @__PURE__ */ g(Bg, { children: r ? /* @__PURE__ */ F("div", { className: a7(), children: [
    /* @__PURE__ */ g("div", { className: "-mb-(--spacing-16) flex w-full items-center pb-(--spacing-24)", children: c }),
    /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "asset-alert-chat-connector-divider", className: c7() })
  ] }) : /* @__PURE__ */ g("div", { className: "pb-(--spacing-24)", children: c }) }), e[4] = c, e[5] = o, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== n.author.name ? (d = /* @__PURE__ */ g(fo, { size: "lg", weight: "medium", children: n.author.name }), e[8] = n.author.name, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.author.type ? (f = n.author.type === "internal" ? /* @__PURE__ */ g(n8, { size: "compact", "aria-hidden": "true", "data-slot": "asset-alert-chat-author-logo" }) : null, e[10] = n.author.type, e[11] = f) : f = e[11];
  let p;
  e[12] !== n.timestamp ? (p = n.timestamp ? /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ g(fo, { size: "xs", tone: "subtle", weight: "semibold", children: "•" }),
    /* @__PURE__ */ g(fo, { size: "lg", tone: "subtle", weight: "medium", children: n.timestamp })
  ] }) : null, e[12] = n.timestamp, e[13] = p) : p = e[13];
  let m;
  e[14] !== d || e[15] !== f || e[16] !== p ? (m = /* @__PURE__ */ F(Wg, { children: [
    d,
    f,
    p
  ] }), e[14] = d, e[15] = f, e[16] = p, e[17] = m) : m = e[17];
  let h;
  e[18] !== n || e[19] !== i ? (h = i?.(n), e[18] = n, e[19] = i, e[20] = h) : h = e[20];
  let b;
  e[21] !== n || e[22] !== s ? (b = s?.(n), e[21] = n, e[22] = s, e[23] = b) : b = e[23];
  let v;
  e[24] !== n.content || e[25] !== h || e[26] !== b ? (v = /* @__PURE__ */ g(U5, { children: /* @__PURE__ */ g(u7, { content: n.content, detail: h, actions: b }) }), e[24] = n.content, e[25] = h, e[26] = b, e[27] = v) : v = e[27];
  let C;
  e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F(tu, { children: [
    m,
    v
  ] }), e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  let y;
  return e[31] !== l || e[32] !== C || e[33] !== u ? (y = /* @__PURE__ */ F(eu, { direction: l, children: [
    u,
    C
  ] }), e[31] = l, e[32] = C, e[33] = u, e[34] = y) : y = e[34], y;
}
function p7(t, e) {
  return t.author.type === "internal" && e?.author.type === "internal" && t.author.id === e.author.id && !e.dateLabel;
}
function m7(t) {
  const e = B.c(4), {
    messageId: n,
    hasAuxiliaryContent: o
  } = t, {
    scrollToEnd: r
  } = Iu(), i = nt(n);
  let s, l;
  return e[0] !== n || e[1] !== r ? (s = () => {
    n && i.current !== n && r(), i.current = n;
  }, l = [n, r], e[0] = n, e[1] = r, e[2] = s, e[3] = l) : (s = e[2], l = e[3]), Rt(s, l), g7(o), null;
}
function g7(t) {
  const e = B.c(4), {
    scrollToMessage: n
  } = Iu();
  let o, r;
  e[0] !== t || e[1] !== n ? (o = () => {
    t && n("asset-alert-chat-auxiliary-content", {
      align: "start"
    });
  }, r = [t, n], e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (o = e[2], r = e[3]), Rt(o, r);
}
function GO({
  title: t,
  titleAccessory: e,
  assetSummary: n,
  sections: o,
  alerts: r,
  currentUserId: i,
  activeSectionId: s,
  onSectionChange: l,
  headerMenuItems: a,
  onClose: c,
  renderAlertDetail: u,
  renderAlertActions: d,
  composer: f,
  auxiliaryContent: p
}) {
  const m = At(), h = `asset-alert-${m}-details`, [b, v] = qe(!1), C = new Set(o.map((k) => k.id)), y = new Map(o.map((k) => [k.id, `asset-alert-${m}-${k.id}`])), w = /* @__PURE__ */ new Set(), R = r.map((k) => {
    const I = k.sectionId, D = I && C.has(I) && !w.has(I) ? y.get(I) : void 0;
    return I && D && w.add(I), {
      alert: k,
      anchorId: D
    };
  }), S = Xv(o.filter((k) => w.has(k.id)).map((k) => y.get(k.id) ?? k.id)), E = nt(S.activeId), N = r.reduce((k, I) => I.author.id === i ? I.id : k, void 0), M = s === void 0 ? S.activeId : w.has(s) ? y.get(s) : void 0;
  function T(k) {
    S.scrollRef.current = k;
  }
  function P(k) {
    E.current = k, S.onActiveChange(k);
    const I = o.find((D) => y.get(D.id) === k);
    I && l?.(I.id);
  }
  return Rt(() => {
    if (E.current === S.activeId)
      return;
    E.current = S.activeId;
    const k = o.find((I) => y.get(I.id) === S.activeId);
    k && l?.(k.id);
  }, [S.activeId, l, y, o]), /* @__PURE__ */ g("section", { "aria-label": typeof t == "string" ? t : "Asset alert chat", className: X9(), "data-slot": "asset-alert-chat", children: /* @__PURE__ */ F("div", { className: Q9(), children: [
    /* @__PURE__ */ F("header", { className: J9(), "data-slot": "asset-alert-chat-header", children: [
      /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 flex-wrap items-center gap-(--spacing-8)", children: [
        /* @__PURE__ */ g(wn, { as: "h2", size: "lg", truncate: !0, children: t }),
        e
      ] }),
      /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-10)", children: [
        a?.length ? /* @__PURE__ */ g(M9, { label: "View", items: a, size: "sm" }) : null,
        c ? /* @__PURE__ */ g(gt, { icon: "x-close", variant: "ghost", size: "md", "aria-label": "Close asset chat", onClick: c }) : null
      ] })
    ] }),
    /* @__PURE__ */ F("div", { className: e7(), children: [
      n ? /* @__PURE__ */ F("div", { className: t7(), "data-slot": "asset-alert-chat-summary", children: [
        /* @__PURE__ */ g(Wl, { ...n.thumbnail, size: b ? "xl" : "sm" }),
        /* @__PURE__ */ F("div", { className: n7(), children: [
          /* @__PURE__ */ g(wn, { as: "h3", size: "sm", truncate: !0, children: n.name }),
          /* @__PURE__ */ g("div", { id: h, hidden: !b, className: "flex w-full flex-col items-start gap-(--spacing-10)", children: b ? /* @__PURE__ */ F(Vt, { children: [
            n.metrics.length > 0 ? /* @__PURE__ */ g("div", { className: o7(), children: n.metrics.map((k, I) => /* @__PURE__ */ F("span", { className: "contents", children: [
              I > 0 ? /* @__PURE__ */ g("span", { className: "inline-flex h-(--spacing-16) w-(--spacing-2) shrink-0 items-stretch self-center", children: /* @__PURE__ */ g(gr, { orientation: "vertical" }) }) : null,
              /* @__PURE__ */ F("span", { className: "inline-flex h-(--spacing-24) min-w-0 items-center gap-(--spacing-4)", children: [
                /* @__PURE__ */ F(nn, { as: "span", size: "md", tone: "subtle", truncate: !0, children: [
                  k.label,
                  ":"
                ] }),
                /* @__PURE__ */ g("span", { children: /* @__PURE__ */ g(nn, { as: "span", size: "md", truncate: !0, children: k.value }) })
              ] })
            ] }, k.id)) }) : null,
            n.status ? /* @__PURE__ */ g(Ln, { ...n.status }) : null
          ] }) : null }),
          /* @__PURE__ */ g(tn, { variant: "ghost", size: "sm", icon: b ? "chevron-up" : "chevron-down", "aria-controls": h, "aria-expanded": b, onClick: () => v((k) => !k), children: b ? "Hide Details" : "View Details" })
        ] })
      ] }) : null,
      o.length > 0 ? /* @__PURE__ */ g(qv, { orientation: "horizontal", activeId: M, onActiveChange: P, scrollRef: S.scrollRef, startScrollLock: S.startScrollLock, children: o.map((k) => /* @__PURE__ */ g(Kv, { targetId: y.get(k.id) ?? k.id, disabled: !w.has(k.id), children: k.label }, k.id)) }) : null,
      /* @__PURE__ */ F("div", { className: r7(), children: [
        /* @__PURE__ */ F(Ug, { defaultScrollPosition: "end", children: [
          /* @__PURE__ */ F(Gg, { ref: T, "aria-label": "Asset alert transcript", children: [
            /* @__PURE__ */ F(Yg, { children: [
              R.length === 0 ? /* @__PURE__ */ g("div", { className: "flex min-h-full items-center justify-center text-center", children: /* @__PURE__ */ g(nn, { tone: "subtle", children: "No alerts to display." }) }) : R.map(({
                alert: k,
                anchorId: I
              }, D) => {
                const O = R[D + 1]?.alert, V = /* @__PURE__ */ g(f7, { alert: k, isCurrentUser: k.author.id === i, showConnector: p7(k, O), renderAlertDetail: u, renderAlertActions: d });
                return /* @__PURE__ */ g(Hi, { id: I, messageId: k.id, children: /* @__PURE__ */ g("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ F("div", { className: i7(), "data-slot": "asset-alert-chat-alerts", children: [
                  k.dateLabel ? /* @__PURE__ */ F("div", { className: s7(), children: [
                    /* @__PURE__ */ g(gr, { centeredText: k.dateLabel }),
                    V
                  ] }) : null,
                  k.dateLabel ? null : V
                ] }) }) }, k.id);
              }),
              p ? /* @__PURE__ */ g(Hi, { messageId: "asset-alert-chat-auxiliary-content", "data-slot": "asset-alert-chat-auxiliary-content", children: p }) : null
            ] }),
            /* @__PURE__ */ g(m7, { messageId: N, hasAuxiliaryContent: !!p })
          ] }),
          /* @__PURE__ */ g(jg, {})
        ] }),
        f ? /* @__PURE__ */ g("div", { className: "px-(--spacing-4)", children: f }) : null
      ] })
    ] })
  ] }) });
}
function Ns(t, e) {
  const n = typeof window < "u" && typeof window.matchMedia < "u";
  t = t.replace(/^@media( ?)/m, "");
  const {
    defaultMatches: o = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: i = null,
    noSsr: s = !1
  } = e, l = x.useCallback(() => o, [o]), a = x.useMemo(() => {
    if (s && r)
      return () => r(t).matches;
    if (i !== null) {
      const {
        matches: f
      } = i(t);
      return () => f;
    }
    return l;
  }, [l, t, i, s, r]), [c, u] = x.useMemo(() => {
    if (r === null)
      return [l, () => () => {
      }];
    const f = r(t);
    return [() => f.matches, (p) => dt(f, "change", p)];
  }, [l, r, t]), d = md.useSyncExternalStore(u, c, a);
  return process.env.NODE_ENV !== "production" && x.useDebugValue({
    query: t,
    match: d
  }), d;
}
const ks = {
  belowSm: "(width < 600px)",
  belowMd: "(width < 905px)"
}, h7 = ae(["inline-flex", "rounded-full"], {
  variants: {
    tone: {
      urgent: "bg-error",
      activity: "bg-primary",
      info: "bg-informative"
    },
    variant: {
      dot: "size-(--spacing-6)",
      pill: "items-center justify-center min-w-(--spacing-16) h-(--spacing-16) px-(--spacing-4) py-[3px]"
    }
  },
  defaultVariants: {
    tone: "urgent",
    variant: "dot"
  }
}), b7 = ae(["font-(family-name:--font-family-body)", "font-normal", "text-(length:--font-size-body-small)", "leading-[11px]", "text-center"], {
  variants: {
    tone: {
      urgent: "text-error-on-error",
      activity: "text-primary-on-primary",
      info: "text-text-inverse"
    }
  },
  defaultVariants: {
    tone: "urgent"
  }
});
function pu(t) {
  const e = B.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    tone: l,
    count: r,
    visible: a,
    "aria-hidden": n,
    "aria-label": o,
    style: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "urgent" : l, u = a === void 0 ? !0 : a, d = r === void 0;
  let f;
  e[8] !== r || e[9] !== d ? (f = d ? void 0 : String(r).slice(0, 3), e[8] = r, e[9] = d, e[10] = f) : f = e[10];
  const p = f, m = !u || !o || n === !0 || n === "true" ? !0 : void 0, h = d ? "dot" : "pill";
  let b;
  e[11] !== h || e[12] !== c ? (b = h7({
    tone: c,
    variant: h
  }), e[11] = h, e[12] = c, e[13] = b) : b = e[13];
  let v;
  e[14] !== s || e[15] !== u ? (v = u ? s : {
    ...s,
    visibility: "hidden"
  }, e[14] = s, e[15] = u, e[16] = v) : v = e[16];
  let C;
  e[17] !== p || e[18] !== d || e[19] !== c ? (C = !d && /* @__PURE__ */ g("span", { className: b7({
    tone: c
  }), children: p }), e[17] = p, e[18] = d, e[19] = c, e[20] = C) : C = e[20];
  let y;
  return e[21] !== o || e[22] !== m || e[23] !== i || e[24] !== b || e[25] !== v || e[26] !== C ? (y = /* @__PURE__ */ g("span", { ...i, role: "img", "aria-hidden": m, "aria-label": o, className: b, style: v, children: C }), e[21] = o, e[22] = m, e[23] = i, e[24] = b, e[25] = v, e[26] = C, e[27] = y) : y = e[27], y;
}
const jd = ho("none"), v7 = ae(["grid", "h-full", "min-h-0", "min-w-0", "w-full", "overflow-hidden", "relative", "rounded-(--radius-md)", "after:pointer-events-none", "after:absolute", "after:inset-0", "after:z-10", "after:rounded-(--radius-md)", "after:border", "after:border-outline-subtle", "after:content-['']", "bg-surface", "shadow-elevation-4", "text-text-default", "max-sm:grid-cols-1"], {
  variants: {
    sidebar: {
      none: "grid-cols-[minmax(0,1fr)]",
      expanded: "grid-cols-[240px_minmax(0,1fr)]",
      collapsed: "grid-cols-[64px_minmax(0,1fr)]"
    }
  },
  defaultVariants: {
    sidebar: "none"
  }
}), y7 = ae(["min-h-0", "min-w-0", "overflow-hidden", "relative", "after:pointer-events-none", "after:absolute", "after:inset-y-0", "after:right-0", "after:border-r", "after:border-outline-subtle", "after:content-['']", "bg-surface", "max-sm:hidden"], {
  variants: {
    sidebar: {
      expanded: "block",
      collapsed: "block",
      none: "hidden"
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), x7 = ae([], {
  variants: {
    sidebar: {
      expanded: ["flex", "items-center", "justify-between"],
      collapsed: ["relative", "flex", "w-(--spacing-48)", "justify-center"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), C7 = ae([], {
  variants: {
    sidebar: {
      expanded: "shrink-0",
      collapsed: ["absolute", "-right-(--spacing-4)", "-top-(--spacing-4)"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), w7 = ae(["flex", "min-w-0", "min-h-0", "flex-col", "bg-surface"]), S7 = ae(["flex", "shrink-0", "items-center", "gap-(--spacing-12)", "border-b", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)"]), R7 = ae(["min-h-0", "flex-1", "overflow-hidden"]), E7 = ae(["shrink-0", "min-w-0", "bg-surface", "p-(--spacing-16)"]);
function Ap(t) {
  const e = B.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    sidebar: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ?? "none";
  let s;
  e[4] !== i ? (s = ne(v7({
    sidebar: i
  })), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== n || e[7] !== o || e[8] !== i || e[9] !== s ? (l = /* @__PURE__ */ g("section", { "data-slot": "chat-panel", "data-sidebar": i, className: s, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s, e[10] = l) : l = e[10];
  let a;
  return e[11] !== i || e[12] !== l ? (a = /* @__PURE__ */ g(jd, { value: i, children: l }), e[11] = i, e[12] = l, e[13] = a) : a = e[13], a;
}
function N7(t) {
  const e = B.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = dn(jd);
  let i;
  e[3] !== r ? (i = ne(y7({
    sidebar: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("aside", { "data-slot": "chat-panel-sidebar", className: i, ...o, children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function Lp(t) {
  const e = B.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    badge: n,
    children: o,
    sidebar: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = dn(jd), l = i ?? (s === "collapsed" ? "collapsed" : "expanded");
  let a;
  e[5] !== l ? (a = ne(x7({
    sidebar: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] !== n || e[8] !== l ? (c = n && /* @__PURE__ */ g("span", { className: ne(C7({
    sidebar: l
  })), "data-slot": "chat-panel-sidebar-badge", children: /* @__PURE__ */ g(pu, { count: n.count, tone: n.tone, "aria-label": n.label }) }), e[7] = n, e[8] = l, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("header", { "data-slot": "chat-panel-sidebar-header", "data-sidebar": l, className: a, ...r, children: [
    o,
    c
  ] }), e[10] = o, e[11] = r, e[12] = l, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
function Fp(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(w7()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-main", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function YO(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(S7()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-panel-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function $p(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(R7()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-body", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function k7(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(E7()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-panel-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function I7() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ F("output", { className: "inline-flex items-center gap-[5px] rounded-(--radius-xl) bg-surface-container px-[14px] py-(--spacing-10)", "aria-label": "AI is typing", children: [
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" })
  ] }), t[0] = e) : e = t[0], e;
}
const P7 = 4;
function Ii(t) {
  if (!t) return 0;
  const e = t.getBoundingClientRect().width;
  return e > 0 ? e : t.offsetWidth;
}
function M7(t) {
  const e = Number.parseFloat(getComputedStyle(t).columnGap);
  return Number.isFinite(e) ? e : P7;
}
function T7(t, e) {
  return t.reduce((o, r) => o + r, 0) + Math.max(0, t.length - 1) * e;
}
function Hp({
  itemWidths: t,
  reservedStartWidth: e,
  reservedEndWidth: n,
  overflowWidth: o
}) {
  return [...e > 0 ? [e] : [], ...t, ...o && o > 0 ? [o] : [], ...n > 0 ? [n] : []];
}
function zp(t, e, n, o) {
  if (t.length === 0) return !0;
  if (o <= 1) return T7(t, n) <= e;
  let r = 1, i = 0;
  for (const s of t) {
    const l = i === 0 ? s : i + n + s;
    if (l <= e || i === 0) {
      i = l;
      continue;
    }
    if (r += 1, i = s, r > o) return !1;
  }
  return !0;
}
function Kd({
  items: t,
  maxRows: e = 1,
  minVisibleItems: n = t.length > 0 ? 1 : 0
}) {
  const o = nt(null), r = nt(null), i = nt(null), s = nt(null), l = nt([]), a = nt({}), c = nt(() => {
  }), [u, d] = qe(Number.POSITIVE_INFINITY), f = t.length === 0 ? 0 : Math.max(n, Math.min(u, t.length)), p = t.slice(0, f), m = t.length - p.length;
  return c.current = () => {
    const h = o.current;
    function b(E) {
      d((N) => N === E ? N : E);
    }
    if (!h || t.length <= n) {
      b(t.length);
      return;
    }
    const v = Ii(h), C = M7(h), y = Ii(i.current), w = Ii(s.current), R = t.map((E, N) => Ii(l.current[N])), S = Hp({
      itemWidths: R,
      reservedStartWidth: y,
      reservedEndWidth: w
    });
    if (zp(S, v, C, e)) {
      b(t.length);
      return;
    }
    for (let E = t.length - 1; E >= n; E -= 1) {
      const N = t.length - E, M = Ii(a.current[N]), T = Hp({
        itemWidths: R.slice(0, E),
        reservedStartWidth: y,
        reservedEndWidth: w,
        overflowWidth: M
      });
      if (zp(T, v, C, e)) {
        b(E);
        return;
      }
    }
    b(n);
  }, po(() => {
    c.current();
  }), po(() => {
    const h = o.current;
    if (typeof ResizeObserver > "u" || !h) return;
    const b = new ResizeObserver(() => {
      c.current();
    });
    return b.observe(h), r.current && b.observe(r.current), () => b.disconnect();
  }, []), {
    containerRef: o,
    measuringContainerRef: r,
    reservedStartRef: i,
    reservedEndRef: s,
    itemRefs: l,
    overflowRefs: a,
    visibleItems: p,
    overflowCount: m
  };
}
function O7(t) {
  const e = B.c(26);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    fileName: n,
    variant: a,
    imageSrc: r,
    imageAlt: o,
    onRemove: i,
    removeAriaLabel: l,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  let c;
  e[8] !== o || e[9] !== r || e[10] !== a ? (c = a === "file" ? /* @__PURE__ */ g("span", { className: "inline-flex size-(--spacing-20) shrink-0 items-center justify-center gap-(--spacing-4) rounded-(--radius-sm) bg-chip-neutral-container px-(--spacing-6) py-(--spacing-4)", children: /* @__PURE__ */ g(We, { name: "document", size: "xs", tone: "inherit" }) }) : /* @__PURE__ */ g("img", { alt: o, src: r, className: "size-(--spacing-20) shrink-0 rounded-(--radius-xs) object-cover" }), e[8] = o, e[9] = r, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== n ? (u = /* @__PURE__ */ g("span", { title: n, className: "max-w-[100px] shrink-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-16) font-(--font-weight-medium) tracking-(--font-letter-spacing-default)", children: n }), e[12] = n, e[13] = u) : u = e[13];
  const d = l ?? `Remove ${n}`;
  let f;
  e[14] !== i ? (f = (b) => {
    b.stopPropagation(), i(b);
  }, e[14] = i, e[15] = f) : f = e[15];
  let p;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }), e[16] = p) : p = e[16];
  let m;
  e[17] !== d || e[18] !== f ? (m = /* @__PURE__ */ g("button", { "data-slot": "chat-attachment-remove", type: "button", "aria-label": d, className: "inline-flex shrink-0 cursor-pointer items-center rounded-(--radius-xs) text-icon-main focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: f, children: p }), e[17] = d, e[18] = f, e[19] = m) : m = e[19];
  let h;
  return e[20] !== s || e[21] !== c || e[22] !== u || e[23] !== m || e[24] !== a ? (h = /* @__PURE__ */ F("span", { "data-slot": "chat-attachment", "data-variant": a, className: "inline-flex h-(--spacing-28) items-center gap-(--spacing-8) rounded-(--radius-sm) bg-chip-neutral-container px-(--spacing-6) py-(--spacing-4) text-chip-neutral-label", ...s, children: [
    c,
    u,
    m
  ] }), e[20] = s, e[21] = c, e[22] = u, e[23] = m, e[24] = a, e[25] = h) : h = e[25], h;
}
const D7 = ae("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});
function jO(t) {
  const e = B.c(10);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== r ? (i = ne(D7({
    size: r
  })), e[4] = r, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
const P2 = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)"
}, M2 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, _7 = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, V7 = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse"
}, A7 = ae("flex flex-row", {
  variants: {
    align: M2,
    justify: _7,
    gap: P2,
    wrap: V7
  },
  defaultVariants: {
    gap: 8,
    align: "center"
  }
});
function br(t) {
  const e = B.c(18);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    gap: r,
    align: n,
    justify: i,
    wrap: a,
    grow: l,
    children: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !1 : l;
  let u;
  e[8] !== n || e[9] !== r || e[10] !== c || e[11] !== i || e[12] !== a ? (u = ne(A7({
    gap: r,
    align: n,
    justify: i,
    wrap: a
  }), c && "[&>*]:flex-1"), e[8] = n, e[9] = r, e[10] = c, e[11] = i, e[12] = a, e[13] = u) : u = e[13];
  let d;
  return e[14] !== o || e[15] !== s || e[16] !== u ? (d = /* @__PURE__ */ g("div", { className: u, ...s, children: o }), e[14] = o, e[15] = s, e[16] = u, e[17] = d) : d = e[17], d;
}
const L7 = ae("flex flex-col", {
  variants: {
    align: M2,
    gap: P2,
    fullWidth: {
      true: "w-full",
      false: null
    }
  },
  defaultVariants: {
    gap: 16,
    fullWidth: !1
  }
});
function Zo(t) {
  const e = B.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    gap: r,
    align: n,
    fullWidth: s,
    children: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s;
  let a;
  e[6] !== n || e[7] !== l || e[8] !== r ? (a = ne(L7({
    gap: r,
    align: n,
    fullWidth: l
  })), e[6] = n, e[7] = l, e[8] = r, e[9] = a) : a = e[9];
  let c;
  return e[10] !== o || e[11] !== i || e[12] !== a ? (c = /* @__PURE__ */ g("div", { className: a, ...i, children: o }), e[10] = o, e[11] = i, e[12] = a, e[13] = c) : c = e[13], c;
}
const qd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (qd.displayName = "PopoverRootContext");
function Is(t) {
  const e = x.useContext(qd);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : tt(47));
  return e;
}
function F7() {
  return {
    ...ms(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const $7 = {
  ...gs,
  disabled: ge((t) => t.disabled),
  instantType: ge((t) => t.instantType),
  openMethod: ge((t) => t.openMethod),
  openChangeReason: ge((t) => t.openChangeReason),
  modal: ge((t) => t.modal),
  focusManagerModal: ge((t) => t.focusManagerModal),
  stickIfOpen: ge((t) => t.stickIfOpen),
  titleElementId: ge((t) => t.titleElementId),
  descriptionElementId: ge((t) => t.descriptionElementId),
  openOnHover: ge((t) => t.openOnHover),
  closeDelay: ge((t) => t.closeDelay),
  hasViewport: ge((t) => t.hasViewport)
};
class Zd extends Rr {
  constructor(e) {
    const n = {
      ...F7(),
      ...e
    };
    n.open && e?.mounted === void 0 && (n.mounted = !0), super(n, {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      stickIfOpenTimeout: new Cn(),
      triggerElements: new Er()
    }, $7);
  }
  setOpen = (e, n) => {
    const o = n.reason === Ft, r = n.reason === Zn && n.event.detail === 0, i = !e && (n.reason === xr || n.reason == null);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const s = () => {
      const l = {
        open: e,
        openChangeReason: n.reason
      }, a = n.trigger?.id ?? null;
      (a || e) && (l.activeTriggerId = a, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(Mh, () => {
      this.set("stickIfOpen", !1);
    }), cn.flushSync(s)) : s(), r || i ? this.set("instantType", r ? "click" : "dismiss") : n.reason === Mo ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(e, n) {
    const o = Tt(() => new Zd(n)).current, r = e ?? o;
    return ei(o.disposeEffect), r;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function Bp({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    modal: s = !1,
    handle: l,
    triggerId: a,
    defaultTriggerId: c = null
  } = t, u = Zd.useStore(l?.store, {
    modal: s,
    open: o,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: a
  });
  Ir(() => {
    n === void 0 && u.state.open === !1 && o === !0 && u.update({
      open: !0,
      activeTriggerId: c
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", a);
  const d = u.useState("open"), f = u.useState("payload");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", i);
  const {
    openMethod: p,
    triggerProps: m
  } = Ss(d);
  fs(u);
  const {
    forceUnmount: h
  } = ps(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  x.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, _e(as));
  }, [u]);
  x.useImperativeHandle(t.actionsRef, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = hs({
    popupStore: u,
    onOpenChange: u.setOpen
  }), C = Sr(v, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: s === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), y = wd(v), {
    getReferenceProps: w,
    getFloatingProps: R,
    getTriggerProps: S
  } = eo([C, y]), E = x.useMemo(() => w(m), [w, m]), N = x.useMemo(() => S(m), [S, m]), M = x.useMemo(() => R(), [R]);
  u.useSyncedValues({
    modal: s,
    openMethod: p,
    activeTriggerProps: E,
    inactiveTriggerProps: N,
    popupProps: M,
    floatingRootContext: v,
    nested: vo() != null
  });
  const T = x.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ g(qd.Provider, {
    value: T,
    children: typeof e == "function" ? e({
      payload: f
    }) : e
  });
}
function Xd(t) {
  return Is(!0) ? /* @__PURE__ */ g(Bp, {
    props: t
  }) : /* @__PURE__ */ g(ud, {
    children: /* @__PURE__ */ g(Bp, {
      props: t
    })
  });
}
const H7 = 300, ya = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    handle: l,
    payload: a,
    openOnHover: c = !1,
    delay: u = H7,
    closeDelay: d = 0,
    id: f,
    style: p,
    ...m
  } = e, h = Is(!0), b = l?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : tt(74));
  const v = It(f), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: E
  } = ds(v, R, b, {
    payload: a,
    disabled: i,
    openOnHover: c,
    closeDelay: d
  }), N = b.useState("openChangeReason"), M = b.useState("stickIfOpen"), T = b.useState("openMethod"), P = b.useState("focusManagerModal"), k = bs(y, {
    enabled: y != null && c && (T !== "touch" || N !== Zn),
    mouseOnly: !0,
    move: !1,
    handleClose: vs(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: R,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), I = wr(y, {
    enabled: y != null,
    stickIfOpen: M
  }), D = eo([I]), O = b.useState("triggerProps", E), V = {
    disabled: i,
    open: w
  }, {
    getButtonProps: _,
    buttonRef: L
  } = Wt({
    disabled: i,
    native: s
  }), A = x.useMemo(() => ({
    open(K) {
      return K && N === Zn ? Yi.open(K) : yr.open(K);
    }
  }), [N]), $ = Le("button", e, {
    state: V,
    ref: [L, n, S, R],
    props: [D.getReferenceProps(), k, O, {
      [od]: "",
      id: v
    }, m, _],
    stateAttributesMapping: A
  }), {
    preFocusGuardRef: Y,
    handlePreFocusGuardFocus: z,
    handleFocusTargetFocus: H
  } = g2(b, R);
  return C && !P ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(An, {
      ref: Y,
      onFocus: z
    }), /* @__PURE__ */ g(x.Fragment, {
      children: $
    }, v), /* @__PURE__ */ g(An, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: H
    })]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: $
  }, v);
});
process.env.NODE_ENV !== "production" && (ya.displayName = "PopoverTrigger");
const Qd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qd.displayName = "PopoverPortalContext");
function z7() {
  const t = x.useContext(Qd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : tt(45));
  return t;
}
const xa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Is();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(Qd.Provider, {
    value: o,
    children: /* @__PURE__ */ g(oi, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (xa.displayName = "PopoverPortal");
const Jd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jd.displayName = "PopoverPositionerContext");
function B7() {
  const t = x.useContext(Jd);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : tt(46));
  return t;
}
const Ca = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = da,
    style: v,
    ...C
  } = e, {
    store: y
  } = Is(), w = z7(), R = fa(), S = y.useState("floatingRootContext"), E = y.useState("mounted"), N = y.useState("open"), M = y.useState("openChangeReason"), T = y.useState("activeTriggerElement"), P = y.useState("modal"), k = y.useState("openMethod"), I = y.useState("positionerElement"), D = y.useState("instantType"), O = y.useState("transitionStatus"), V = y.useState("hasViewport"), _ = x.useRef(null), L = ta(I, !1, !1), A = ii({
    anchor: i,
    floatingRootContext: S,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: V ? ha : void 0
  }), $ = S.useState("domReferenceElement");
  Ne(() => {
    const K = $, G = _.current;
    if (K && (_.current = K), G && K && K !== G) {
      y.set("instantType", void 0);
      const q = new AbortController();
      return L(() => {
        y.set("instantType", "trigger-change");
      }, q.signal), () => {
        q.abort();
      };
    }
  }, [$, L, y]);
  const Y = {
    open: N,
    side: A.side,
    align: A.align,
    anchorHidden: A.anchorHidden,
    instant: D
  };
  ba(N && P === !0 && M !== Ft, k === "touch", I, T);
  const z = x.useCallback((K) => {
    y.set("positionerElement", K);
  }, [y]), H = ai(e, Y, {
    styles: A.positionerStyles,
    transitionStatus: O,
    props: C,
    refs: [n, z],
    hidden: !E,
    inert: !N
  });
  return /* @__PURE__ */ F(Jd.Provider, {
    value: A,
    children: [E && P === !0 && M !== Ft && /* @__PURE__ */ g(li, {
      ref: y.context.internalBackdropRef,
      inert: kr(!N),
      cutout: T
    }), /* @__PURE__ */ g(cd, {
      id: R,
      children: H
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ca.displayName = "PopoverPositioner");
const T2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (T2.displayName = "ClosePartContext");
function W7() {
  const [t, e] = x.useState(0), n = Ce(() => (e((r) => r + 1), () => {
    e((r) => Math.max(0, r - 1));
  }));
  return {
    context: x.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: t > 0
  };
}
function U7(t) {
  const {
    value: e,
    children: n
  } = t;
  return /* @__PURE__ */ g(T2.Provider, {
    value: e,
    children: n
  });
}
const G7 = {
  ...In,
  ...Bt
}, wa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: i,
    finalFocus: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = Is(), u = B7(), d = Rd() != null, {
    context: f,
    hasClosePart: p
  } = W7(), m = c.useState("open"), h = c.useState("openMethod"), b = c.useState("instantType"), v = c.useState("transitionStatus"), C = c.useState("popupProps"), y = c.useState("titleElementId"), w = c.useState("descriptionElementId"), R = c.useState("modal"), S = c.useState("mounted"), E = c.useState("openChangeReason"), N = c.useState("activeTriggerElement"), M = c.useState("floatingRootContext");
  jt({
    open: m,
    ref: c.context.popupRef,
    onComplete() {
      m && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const T = c.useState("disabled"), P = c.useState("openOnHover"), k = c.useState("closeDelay");
  ma(M, {
    enabled: P && !T,
    closeDelay: k
  });
  function I(A) {
    return A === "touch" ? c.context.popupRef.current : !0;
  }
  const D = i === void 0 ? I : i, O = {
    open: m,
    side: u.side,
    align: u.align,
    instant: b,
    transitionStatus: v
  }, V = R !== !1 && p;
  c.useSyncedValue("focusManagerModal", V);
  const _ = x.useCallback((A) => {
    c.set("popupElement", A);
  }, [c]), L = Le("div", e, {
    state: O,
    ref: [n, c.context.popupRef, _],
    props: [C, {
      "aria-labelledby": y,
      "aria-describedby": w,
      onKeyDown(A) {
        d && Cs.has(A.key) && A.stopPropagation();
      }
    }, Nr(v), a],
    stateAttributesMapping: G7
  });
  return /* @__PURE__ */ g(ri, {
    context: M,
    openInteractionType: h,
    modal: V,
    disabled: !S || E === Ft,
    initialFocus: D,
    returnFocus: s,
    restoreFocus: "popup",
    previousFocusableElement: Ct(N) ? N : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ g(U7, {
      value: f,
      children: L
    })
  });
});
process.env.NODE_ENV !== "production" && (wa.displayName = "PopoverPopup");
function Y7(t) {
  const e = B.c(4), {
    open: n,
    onOpenChange: o,
    children: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== o || e[2] !== n ? (i = /* @__PURE__ */ g(Xd, { open: n, onOpenChange: o, modal: !1, children: r }), e[0] = r, e[1] = o, e[2] = n, e[3] = i) : i = e[3], i;
}
function j7(t) {
  const e = B.c(5), {
    render: n,
    openOnHover: o,
    delay: r,
    closeDelay: i
  } = t;
  let s;
  return e[0] !== i || e[1] !== r || e[2] !== o || e[3] !== n ? (s = /* @__PURE__ */ g(ya, { render: n, openOnHover: o, delay: r, closeDelay: i }), e[0] = i, e[1] = r, e[2] = o, e[3] = n, e[4] = s) : s = e[4], s;
}
function K7(t) {
  const e = B.c(13), {
    children: n,
    side: o,
    align: r,
    sideOffset: i,
    className: s,
    positionerClassName: l,
    finalFocus: a
  } = t, c = o === void 0 ? "bottom" : o, u = r === void 0 ? "start" : r, d = i === void 0 ? 4 : i, f = Kt();
  let p;
  e[0] !== n || e[1] !== s || e[2] !== a ? (p = /* @__PURE__ */ g(wa, { className: s, finalFocus: a, children: n }), e[0] = n, e[1] = s, e[2] = a, e[3] = p) : p = e[3];
  let m;
  e[4] !== u || e[5] !== l || e[6] !== c || e[7] !== d || e[8] !== p ? (m = /* @__PURE__ */ g(Ca, { side: c, align: u, sideOffset: d, className: l, children: p }), e[4] = u, e[5] = l, e[6] = c, e[7] = d, e[8] = p, e[9] = m) : m = e[9];
  let h;
  return e[10] !== f || e[11] !== m ? (h = /* @__PURE__ */ g(xa, { container: f, children: m }), e[10] = f, e[11] = m, e[12] = h) : h = e[12], h;
}
const O2 = ne("rounded-(--radius-sm)", "border border-solid border-outline-subtle", "bg-surface-container-lowest", "text-text-default", "shadow-elevation-3", "font-(family-name:--font-family-body)", "origin-(--transform-origin)", "transition-[opacity,transform]", "duration-200", "ease-in-out", "will-change-[opacity,transform]", "[&[data-starting-style]]:scale-95", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:scale-95", "[&[data-ending-style]]:opacity-0"), q7 = ae([
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-(--spacing-4)",
  "h-(--spacing-24)",
  "rounded-(--radius-sm)",
  "px-(--spacing-6)",
  "py-(--spacing-4)",
  "border",
  "border-solid",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "font-(family-name:--font-family-body)",
  "font-(number:--font-weight-medium)",
  "text-(length:--font-size-label-medium)",
  "leading-(--font-line-height-16)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Default state
  "bg-tag-default-background",
  "border-tag-default-outline",
  "text-tag-default-text",
  // Hover state
  "hover:bg-tag-hover-background",
  "hover:border-tag-hover-outline",
  // Pressed state
  "active:bg-tag-pressed-background",
  "active:border-tag-pressed-outline",
  // Focus state
  "focus-visible:ring-2",
  "focus-visible:ring-offset-1",
  "focus-visible:ring-offset-tag-default-background",
  "focus-visible:ring-tag-focus-ring"
]), Z7 = {
  neutral: "text-tag-icon-default",
  brand: "text-tag-icon-brand",
  positive: "text-tag-icon-positive",
  warning: "text-tag-icon-warning",
  negative: "text-tag-icon-negative"
};
function Ji(t) {
  const e = B.c(20);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    icon: o,
    iconTone: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "neutral" : i, a = s === void 0 ? !1 : s, c = o ? l : void 0;
  let u;
  e[6] !== a ? (u = ne(q7(), a && "opacity-50 pointer-events-none cursor-default"), e[6] = a, e[7] = u) : u = e[7];
  const d = a || void 0, f = a ? -1 : void 0;
  let p;
  e[8] !== o || e[9] !== l ? (p = o && /* @__PURE__ */ g("span", { className: ne("inline-flex items-center", Z7[l]), children: /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit" }) }), e[8] = o, e[9] = l, e[10] = p) : p = e[10];
  let m;
  return e[11] !== n || e[12] !== a || e[13] !== r || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F(Qn, { "data-slot": "tag", "data-icon-tone": c, className: u, disabled: a, "aria-disabled": d, tabIndex: f, ...r, children: [
    p,
    n
  ] }), e[11] = n, e[12] = a, e[13] = r, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
const X7 = ae(["flex", "min-w-0", "w-full", "flex-col"]), Q7 = ae(["relative", "flex", "min-w-0", "flex-col", "gap-(--spacing-32)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):focus-within]:border-input-active-outline", "[&_[data-slot=icon-button]]:text-icon-main"], {
  variants: {
    hasAlert: {
      true: ["rounded-t-none"],
      false: []
    },
    disabled: {
      true: ["opacity-50", "cursor-not-allowed", "[&_textarea]:cursor-not-allowed", "[&_[data-slot=button]:disabled]:opacity-100", "[&_[data-slot=icon-button]:disabled]:opacity-100"],
      false: []
    }
  },
  defaultVariants: {
    hasAlert: !1,
    disabled: !1
  }
}), J7 = ae(["[&>div]:rounded-b-none"]), ex = ne(O2, "w-[280px]", "p-0"), tx = ae(["min-w-0", "w-full", "[field-sizing:content]", "max-h-(--spacing-128)", "outline-none", "bg-transparent", "resize-none", "overflow-y-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder"]), nx = ae(["flex", "min-w-0", "w-full", "flex-col", "gap-(--spacing-16)"]), ox = ae(["relative", "flex", "flex-col", "gap-(--spacing-12)"]), rx = ae(["inline-flex", "h-(--spacing-24)", "items-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-label-sm)", "leading-(--font-line-height-16)", "text-text-subtle", "uppercase"]), ix = ae(["flex", "flex-wrap", "items-center", "gap-(--spacing-8)"]), sx = ae(["flex", "items-center", "gap-(--spacing-32)"], {
  variants: {
    showUpload: {
      true: "justify-between",
      false: "justify-end"
    }
  },
  defaultVariants: {
    showUpload: !0
  }
});
function lx(t) {
  const e = B.c(72), {
    value: n,
    onChange: o,
    placeholder: r,
    "aria-label": i,
    disabled: s,
    autoFocus: l,
    onSend: a,
    clearOnSend: c,
    onUpload: u,
    showUpload: d,
    alert: f,
    attachments: p,
    suggestedUpdates: m
  } = t, h = i === void 0 ? "Message" : i, b = c === void 0 ? !0 : c, v = d === void 0 ? !0 : d;
  let C;
  e[0] !== m ? (C = m === void 0 ? [] : m, e[0] = m, e[1] = C) : C = e[1];
  const y = C, w = nt(null), [R, S] = qe(!1);
  let E;
  e[2] !== n ? (E = n.trim(), e[2] = n, e[3] = E) : E = e[3];
  const N = E.length > 0, M = s || !a || !N;
  let T;
  e[4] !== l ? (T = l ? {
    autoFocus: !0
  } : void 0, e[4] = l, e[5] = T) : T = e[5];
  const P = T;
  let k, I;
  e[6] !== l || e[7] !== s ? (k = () => {
    l && !s && w.current?.focus();
  }, I = [l, s], e[6] = l, e[7] = s, e[8] = k, e[9] = I) : (k = e[8], I = e[9]), Rt(k, I);
  let D;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = function(U) {
    const Z = w.current;
    if (!Z)
      return;
    Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set?.call(Z, U), Z.dispatchEvent(new Event("input", {
      bubbles: !0
    }));
  }, e[10] = D) : D = e[10];
  const O = D;
  let V;
  e[11] !== b || e[12] !== M || e[13] !== a ? (V = function() {
    M || (a?.(), w.current?.focus(), b && O(""));
  }, e[11] = b, e[12] = M, e[13] = a, e[14] = V) : V = e[14];
  const _ = V;
  let L;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = function(U) {
    O(U.value), w.current?.focus();
  }, e[15] = L) : L = e[15];
  const A = L;
  let $;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? ($ = function() {
    S(cx);
  }, e[16] = $) : $ = e[16];
  const Y = $;
  let z;
  e[17] !== _ || e[18] !== M || e[19] !== a ? (z = function(U) {
    if (U.key === "Escape") {
      U.currentTarget.blur();
      return;
    }
    if (U.key === "Enter" && !U.shiftKey && !U.nativeEvent.isComposing && a) {
      if (U.preventDefault(), M)
        return;
      _();
    }
  }, e[17] = _, e[18] = M, e[19] = a, e[20] = z) : z = e[20];
  const H = z, K = !!f;
  let G;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = X7(), e[21] = G) : G = e[21];
  let q;
  e[22] !== f || e[23] !== K ? (q = K ? /* @__PURE__ */ g("div", { className: J7(), children: f }) : null, e[22] = f, e[23] = K, e[24] = q) : q = e[24];
  const ee = s || void 0;
  let W;
  e[25] !== s || e[26] !== K ? (W = Q7({
    disabled: s,
    hasAlert: K
  }), e[25] = s, e[26] = K, e[27] = W) : W = e[27];
  let X;
  e[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (X = nx(), e[28] = X) : X = e[28];
  let J;
  e[29] !== s || e[30] !== y || e[31] !== R ? (J = y.length > 0 && /* @__PURE__ */ g(dx, { disabled: s, suggestedUpdates: y, suggestedUpdatesCollapsed: R, onToggleSuggestedUpdates: Y, onSelectSuggestedUpdate: A }), e[29] = s, e[30] = y, e[31] = R, e[32] = J) : J = e[32];
  let re;
  e[33] !== p ? (re = p ?? [], e[33] = p, e[34] = re) : re = e[34];
  let Q;
  e[35] !== s || e[36] !== re ? (Q = /* @__PURE__ */ g(ux, { attachments: re, disabled: s, textareaRef: w }), e[35] = s, e[36] = re, e[37] = Q) : Q = e[37];
  let ie;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = tx(), e[38] = ie) : ie = e[38];
  let ce;
  e[39] !== h || e[40] !== P || e[41] !== s || e[42] !== H || e[43] !== o || e[44] !== r || e[45] !== n ? (ce = /* @__PURE__ */ g("textarea", { ref: w, rows: 1, value: n, onChange: o, onKeyDown: H, placeholder: r, disabled: s, "aria-label": h, ...P, className: ie }), e[39] = h, e[40] = P, e[41] = s, e[42] = H, e[43] = o, e[44] = r, e[45] = n, e[46] = ce) : ce = e[46];
  let oe;
  e[47] !== J || e[48] !== Q || e[49] !== ce ? (oe = /* @__PURE__ */ F("div", { className: X, children: [
    J,
    Q,
    ce
  ] }), e[47] = J, e[48] = Q, e[49] = ce, e[50] = oe) : oe = e[50];
  let se;
  e[51] !== v ? (se = sx({
    showUpload: v
  }), e[51] = v, e[52] = se) : se = e[52];
  let fe;
  e[53] !== s || e[54] !== u || e[55] !== v ? (fe = v && /* @__PURE__ */ g(gt, { icon: "upload", variant: "ghost", size: "sm", "aria-label": "Upload file", disabled: s, onClick: u }), e[53] = s, e[54] = u, e[55] = v, e[56] = fe) : fe = e[56];
  let be;
  e[57] !== _ || e[58] !== M ? (be = /* @__PURE__ */ g(tn, { type: "button", variant: "primary", size: "sm", icon: "send", disabled: M, onMouseDown: ax, onClick: _, children: "Send" }), e[57] = _, e[58] = M, e[59] = be) : be = e[59];
  let le;
  e[60] !== se || e[61] !== fe || e[62] !== be ? (le = /* @__PURE__ */ F("div", { className: se, children: [
    fe,
    be
  ] }), e[60] = se, e[61] = fe, e[62] = be, e[63] = le) : le = e[63];
  let me;
  e[64] !== ee || e[65] !== W || e[66] !== oe || e[67] !== le ? (me = /* @__PURE__ */ F("div", { "data-disabled": ee, className: W, children: [
    oe,
    le
  ] }), e[64] = ee, e[65] = W, e[66] = oe, e[67] = le, e[68] = me) : me = e[68];
  let j;
  return e[69] !== q || e[70] !== me ? (j = /* @__PURE__ */ F("div", { className: G, children: [
    q,
    me
  ] }), e[69] = q, e[70] = me, e[71] = j) : j = e[71], j;
}
function ax(t) {
  return t.preventDefault();
}
function cx(t) {
  return !t;
}
function ux(t) {
  const e = B.c(30), {
    attachments: n,
    disabled: o,
    textareaRef: r
  } = t;
  let i;
  e[0] !== n ? (i = {
    items: n,
    minVisibleItems: 0
  }, e[0] = n, e[1] = i) : i = e[1];
  const {
    containerRef: s,
    measuringContainerRef: l,
    itemRefs: a,
    overflowRefs: c,
    visibleItems: u,
    overflowCount: d
  } = Kd(i), f = n.slice(u.length), [p, m] = qe(!1);
  let h;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ new Map(), e[2] = h) : h = e[2];
  const b = nt(h), v = nt(null), [C, y] = qe(null);
  let w, R;
  e[3] !== d ? (w = () => {
    d === 0 && m(!1);
  }, R = [d], e[3] = d, e[4] = w, e[5] = R) : (w = e[4], R = e[5]), Rt(w, R);
  let S, E;
  e[6] !== n || e[7] !== C || e[8] !== r ? (S = () => {
    if (!C || n.some((K) => {
      const {
        id: G
      } = K;
      return G === C.removedId;
    }))
      return;
    y(null), ((C.neighborId ? b.current.get(C.neighborId)?.querySelector("button") : void 0) ?? (C.neighborId ? v.current : void 0) ?? r.current)?.focus();
  }, E = [n, C, r], e[6] = n, e[7] = C, e[8] = r, e[9] = S, e[10] = E) : (S = e[9], E = e[10]), Rt(S, E);
  const N = function(K, G) {
    const q = G ? f : n, ee = q.findIndex((W) => W.id === K);
    return q[ee + 1] ?? q[ee - 1];
  }, M = function(K, G) {
    const q = G === void 0 ? !1 : G, {
      id: ee,
      onRemove: W,
      ...X
    } = K;
    return /* @__PURE__ */ g(O7, { ...X, onRemove: (J) => {
      if (J.detail === 0) {
        const re = N(ee, q), Q = re ? b.current.get(re.id)?.querySelector("button") : void 0;
        q && Q ? Q.focus() : q || y({
          removedId: ee,
          neighborId: re?.id
        });
      }
      W(J);
    } });
  }, T = n.length === 0 && "hidden";
  let P;
  e[11] !== T ? (P = ne("relative flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-10)", T), e[11] = T, e[12] = P) : P = e[12];
  const k = u.map((H) => /* @__PURE__ */ g("span", { ref: (K) => {
    K ? b.current.set(H.id, K) : b.current.delete(H.id);
  }, className: "inline-flex w-max shrink-0", children: M(H) }, H.id));
  let I;
  e[13] !== o || e[14] !== p || e[15] !== d ? (I = d > 0 && /* @__PURE__ */ g(j7, { openOnHover: !0, delay: 0, closeDelay: 200, render: /* @__PURE__ */ F(Ji, { ref: v, type: "button", disabled: o, "aria-label": `${d} more ${d === 1 ? "attachment" : "attachments"}`, "aria-expanded": p, children: [
    "+",
    d
  ] }) }), e[13] = o, e[14] = p, e[15] = d, e[16] = I) : I = e[16];
  let D;
  e[17] !== d || e[18] !== r ? (D = d === 0 ? () => r.current : void 0, e[17] = d, e[18] = r, e[19] = D) : D = e[19];
  let O;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = /* @__PURE__ */ g(wn, { size: "md", weight: "semibold", children: "Uploaded Attachments" }), e[20] = O) : O = e[20];
  const V = "true", _ = !0, L = "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", A = "inline-flex w-max items-center gap-(--spacing-10)", $ = n.map((H, K) => /* @__PURE__ */ g("span", { ref: (G) => {
    a.current[K] = G;
  }, "data-chat-textarea-measure": "attachment", "data-chat-textarea-measure-index": K, className: "inline-flex w-max shrink-0", children: M(H) }, H.id));
  let Y;
  if (e[21] !== n || e[22] !== c) {
    let H;
    e[24] !== c ? (H = (K, G) => {
      const q = G + 1;
      return /* @__PURE__ */ g("span", { ref: (ee) => {
        c.current[q] = ee;
      }, "data-chat-textarea-measure": "overflow", "data-chat-textarea-measure-count": q, className: "inline-flex w-max", children: /* @__PURE__ */ F(Ji, { disabled: !0, children: [
        "+",
        q
      ] }) }, q);
    }, e[24] = c, e[25] = H) : H = e[25], Y = n.map(H), e[21] = n, e[22] = c, e[23] = Y;
  } else
    Y = e[23];
  let z;
  return e[26] !== l || e[27] !== $ || e[28] !== Y ? (z = /* @__PURE__ */ g("div", { "aria-hidden": V, inert: _, className: L, children: /* @__PURE__ */ F("div", { ref: l, className: A, children: [
    $,
    Y
  ] }) }), e[26] = l, e[27] = $, e[28] = Y, e[29] = z) : z = e[29], /* @__PURE__ */ F("div", { ref: s, "data-chat-textarea-attachments": !0, className: P, inert: o || void 0, children: [
    k,
    /* @__PURE__ */ F(Y7, { open: p && d > 0, onOpenChange: m, children: [
      I,
      /* @__PURE__ */ g(K7, { align: "end", side: "top", sideOffset: 8, className: ex, positionerClassName: "z-[var(--z-layer-popover)]", finalFocus: D, children: /* @__PURE__ */ F("fieldset", { "aria-label": "Uploaded Attachments", inert: o || void 0, className: "flex flex-col gap-(--spacing-10) px-(--spacing-16) pt-(--spacing-10) pb-(--spacing-16)", children: [
        O,
        /* @__PURE__ */ g(Zo, { gap: 8, align: "start", children: f.map((H) => /* @__PURE__ */ g("span", { ref: (K) => {
          K ? b.current.set(H.id, K) : b.current.delete(H.id);
        }, className: "inline-flex w-max", children: M(H, !0) }, H.id)) })
      ] }) })
    ] }),
    z
  ] });
}
function dx(t) {
  const e = B.c(39), {
    disabled: n,
    suggestedUpdates: o,
    suggestedUpdatesCollapsed: r,
    onToggleSuggestedUpdates: i,
    onSelectSuggestedUpdate: s
  } = t;
  let l;
  e[0] !== o ? (l = {
    items: o,
    maxRows: 2,
    minVisibleItems: 0
  }, e[0] = o, e[1] = l) : l = e[1];
  const {
    containerRef: a,
    measuringContainerRef: c,
    reservedStartRef: u,
    reservedEndRef: d,
    itemRefs: f,
    visibleItems: p
  } = Kd(l);
  let m;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = ox(), e[2] = m) : m = e[2];
  let h;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = ix(), e[3] = h) : h = e[3];
  let b;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = rx(), e[4] = b) : b = e[4];
  let v;
  e[5] !== u ? (v = /* @__PURE__ */ g("span", { ref: u, className: b, children: "Suggested Updates" }), e[5] = u, e[6] = v) : v = e[6];
  let C;
  e[7] !== n || e[8] !== s || e[9] !== r || e[10] !== p ? (C = !r && p.map((D) => /* @__PURE__ */ g(Ji, { type: "button", disabled: n, onClick: () => s(D), children: D.label }, `${D.label}-${D.value}`)), e[7] = n, e[8] = s, e[9] = r, e[10] = p, e[11] = C) : C = e[11];
  const y = r ? "eye-watching" : "eye-slash-regular", w = r ? "Show suggested updates" : "Hide suggested updates", R = !r, S = r ? "Show" : "Hide";
  let E;
  e[12] !== n || e[13] !== i || e[14] !== S || e[15] !== y || e[16] !== w || e[17] !== R ? (E = /* @__PURE__ */ g(tn, { type: "button", variant: "ghost", size: "sm", icon: y, "aria-label": w, "aria-expanded": R, disabled: n, onClick: i, children: S }), e[12] = n, e[13] = i, e[14] = S, e[15] = y, e[16] = w, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== d || e[20] !== E ? (N = /* @__PURE__ */ g("span", { ref: d, className: "inline-flex", children: E }), e[19] = d, e[20] = E, e[21] = N) : N = e[21];
  let M;
  e[22] !== a || e[23] !== N || e[24] !== v || e[25] !== C ? (M = /* @__PURE__ */ F("div", { ref: a, className: h, children: [
    v,
    C,
    N
  ] }), e[22] = a, e[23] = N, e[24] = v, e[25] = C, e[26] = M) : M = e[26];
  let T;
  if (e[27] !== f || e[28] !== o) {
    let D;
    e[30] !== f ? (D = (O, V) => /* @__PURE__ */ g("span", { ref: (_) => {
      f.current[V] = _;
    }, className: "inline-flex w-max", children: /* @__PURE__ */ g(Ji, { type: "button", disabled: !0, children: O.label }) }, `${O.label}-${O.value}`), e[30] = f, e[31] = D) : D = e[31], T = o.map(D), e[27] = f, e[28] = o, e[29] = T;
  } else
    T = e[29];
  let P;
  e[32] !== c || e[33] !== T ? (P = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ g("div", { ref: c, className: "inline-flex w-max items-center gap-(--spacing-8)", children: T }) }), e[32] = c, e[33] = T, e[34] = P) : P = e[34];
  let k;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ g(gr, {}), e[35] = k) : k = e[35];
  let I;
  return e[36] !== M || e[37] !== P ? (I = /* @__PURE__ */ F("div", { className: m, children: [
    M,
    P,
    k
  ] }), e[36] = M, e[37] = P, e[38] = I) : I = e[38], I;
}
let Wp = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const Sa = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Fr = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, fx = {
  disabled: !1,
  ...Fr
}, to = {
  valid(t) {
    return t === null ? null : t ? {
      [Wp.valid]: ""
    } : {
      [Wp.invalid]: ""
    };
  }
}, ef = /* @__PURE__ */ x.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: Sa,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: xt,
  disabled: void 0,
  touched: Fr.touched,
  setTouched: xt,
  dirty: Fr.dirty,
  setDirty: xt,
  filled: Fr.filled,
  setFilled: xt,
  focused: Fr.focused,
  setFocused: xt,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: fx,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: xt,
  validation: {
    getValidationProps: (t = St) => t,
    getInputValidationProps: (t = St) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (ef.displayName = "FieldRootContext");
function on(t = !0) {
  const e = x.useContext(ef);
  if (e.setValidityData === xt && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : tt(28));
  return e;
}
const D2 = /* @__PURE__ */ x.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (D2.displayName = "FieldsetRootContext");
function _2(t = !1) {
  const e = x.useContext(D2);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : tt(86));
  return e;
}
const V2 = /* @__PURE__ */ x.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: xt,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (V2.displayName = "FormContext");
function Vo() {
  return x.useContext(V2);
}
const tf = /* @__PURE__ */ x.createContext({
  controlId: void 0,
  registerControlId: xt,
  labelId: void 0,
  setLabelId: xt,
  messageIds: [],
  setMessageIds: xt,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (tf.displayName = "LabelableContext");
function hn() {
  return x.useContext(tf);
}
const A2 = function(e) {
  const n = It(), o = e.controlId === void 0 ? n : e.controlId, [r, i] = x.useState(o), [s, l] = x.useState(e.labelId), [a, c] = x.useState([]), u = Tt(() => /* @__PURE__ */ new Map()), {
    messageIds: d
  } = hn(), f = Ce((h, b) => {
    const v = u.current;
    if (b === void 0) {
      v.delete(h);
      return;
    }
    v.set(h, b), i((C) => {
      if (v.size === 0)
        return;
      let y;
      for (const w of v.values()) {
        if (C !== void 0 && w === C)
          return C;
        y === void 0 && (y = w);
      }
      return y;
    });
  }), p = x.useCallback((h) => Jt({
    "aria-describedby": d.concat(a).join(" ") || void 0
  }, h), [d, a]), m = x.useMemo(() => ({
    controlId: r,
    registerControlId: f,
    labelId: s,
    setLabelId: l,
    messageIds: a,
    setMessageIds: c,
    getDescriptionProps: p
  }), [r, f, s, l, a, c, p]);
  return /* @__PURE__ */ g(tf.Provider, {
    value: m,
    children: e.children
  });
};
process.env.NODE_ENV !== "production" && (A2.displayName = "LabelableProvider");
function nf(t, e, n, o = !0, r) {
  const [i, s] = x.useState(), l = It(r ? `${r}-label` : void 0), a = t ?? e ?? i;
  return Ne(() => {
    const c = t || e || !o ? void 0 : px(n.current, l);
    i !== c && s(c);
  }), a;
}
function px(t, e) {
  const n = mx(t);
  if (n)
    return !n.id && e && (n.id = e), n.id || void 0;
}
function mx(t) {
  if (!t)
    return;
  const e = t.parentElement;
  if (e && e.tagName === "LABEL")
    return e;
  const n = t.id;
  if (n) {
    const r = t.nextElementSibling;
    if (r && r.htmlFor === n)
      return r;
  }
  const o = t.labels;
  return o && o[0];
}
function Mr(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    registerControlId: i
  } = hn(), s = It(e), l = n ? r : void 0, a = Tt(() => /* @__PURE__ */ Symbol("labelable-control")), c = x.useRef(!1), u = x.useRef(e != null), d = Ce(() => {
    !c.current || i === xt || (c.current = !1, i(a.current, void 0));
  });
  return Ne(() => {
    if (i === xt)
      return;
    let f;
    if (n) {
      const p = o?.current;
      pt(p) && p.closest("label") != null ? f = e ?? null : f = l ?? s;
    } else if (e != null)
      u.current = !0, f = e;
    else if (u.current)
      f = s;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, i(a.current, f);
  }, [e, o, l, i, n, s, a, d]), x.useEffect(() => d, [d]), r ?? s;
}
function gx(t, e) {
  const n = It(t);
  return Ne(() => (e(n), () => {
    e(void 0);
  }), [n, e]), n;
}
function hx(t = {}) {
  const {
    id: e,
    fallbackControlId: n,
    native: o = !1,
    setLabelId: r,
    focusControl: i
  } = t, {
    controlId: s,
    setLabelId: l
  } = hn(), a = Ce((p) => {
    l(p), r?.(p);
  }), c = gx(e, a), u = s ?? n;
  function d(p) {
    if (i) {
      i(p, u);
      return;
    }
    if (!u)
      return;
    const m = et(p.currentTarget).getElementById(u);
    Ct(m) && bx(m);
  }
  function f(p) {
    bt(p.nativeEvent)?.closest("button,input,select,textarea") || (!p.defaultPrevented && p.detail > 1 && p.preventDefault(), !o && d(p));
  }
  return o ? {
    id: c,
    htmlFor: u ?? void 0,
    onMouseDown: f
  } : {
    id: c,
    onClick: f,
    onPointerDown(p) {
      p.preventDefault();
    }
  };
}
function bx(t) {
  t.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: !0
  });
}
function Ul(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const Rl = Object.keys(Sa);
function vx(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let e = !1;
  for (const n of Rl)
    n !== "valid" && (n === "valueMissing" && (e = t[n]), t[n] && (e = !1));
  return e;
}
function yx(t) {
  const {
    formRef: e,
    clearErrors: n
  } = Vo(), {
    setValidityData: o,
    validate: r,
    validityData: i,
    validationDebounceTime: s,
    invalid: l,
    markedDirtyRef: a,
    state: c,
    name: u,
    shouldValidateOnChange: d
  } = t, {
    controlId: f,
    getDescriptionProps: p
  } = hn(), m = _t(), h = x.useRef(null), b = Ce(async (y, w = !1) => {
    const R = h.current;
    if (!R)
      return;
    if (w) {
      if (c.valid !== !1)
        return;
      const I = R.validity;
      if (!I.valueMissing) {
        const O = {
          value: y,
          state: {
            ...Sa,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: i.initialValue
        };
        if (R.setCustomValidity(""), f) {
          const V = e.current.fields.get(f);
          V && e.current.fields.set(f, {
            ...V,
            ...Ul(O, !1)
            // invalid = false
          });
        }
        o(O);
        return;
      }
      const D = Rl.reduce((O, V) => (O[V] = I[V], O), {});
      if (!D.valid && !vx(D))
        return;
    }
    function S(I) {
      const D = Rl.reduce((V, _) => (V[_] = I.validity[_], V), {});
      let O = !1;
      for (const V of Rl)
        if (V !== "valid") {
          if (V === "valueMissing" && D[V])
            O = !0;
          else if (D[V])
            return D;
        }
      return O && !a.current && (D.valid = !0, D.valueMissing = !1), D;
    }
    m.clear();
    let E = null, N = [];
    const M = S(R);
    let T;
    const P = d();
    if (R.validationMessage && !P)
      T = R.validationMessage, N = [R.validationMessage];
    else {
      const I = Array.from(e.current.fields.values()).reduce((O, V) => (V.name && (O[V.name] = V.getValue()), O), {}), D = r(y, I);
      typeof D == "object" && D !== null && "then" in D ? E = await D : E = D, E !== null ? (M.valid = !1, M.customError = !0, Array.isArray(E) ? (N = E, R.setCustomValidity(E.join(`
`))) : E && (N = [E], R.setCustomValidity(E))) : P && (R.setCustomValidity(""), M.customError = !1, R.validationMessage ? (T = R.validationMessage, N = [R.validationMessage]) : R.validity.valid && !M.valid && (M.valid = !0));
    }
    const k = {
      value: y,
      state: M,
      error: T ?? (Array.isArray(E) ? E[0] : E ?? ""),
      errors: N,
      initialValue: i.initialValue
    };
    if (f) {
      const I = e.current.fields.get(f);
      I && e.current.fields.set(f, {
        ...I,
        // Keep Form-level errors part of overall field validity for submit blocking/focus logic.
        ...Ul(k, l)
      });
    }
    o(k);
  }), v = x.useCallback((y = {}) => Jt(p, c.valid === !1 ? {
    "aria-invalid": !0
  } : St, y), [p, c.valid]), C = x.useCallback((y = {}) => Jt({
    onChange(w) {
      if (w.nativeEvent.defaultPrevented)
        return;
      if (n(u), !d()) {
        b(w.currentTarget.value, !0);
        return;
      }
      const R = w.currentTarget;
      if (R.value === "") {
        b(R.value);
        return;
      }
      m.clear(), s ? m.start(s, () => {
        b(R.value);
      }) : b(R.value);
    }
  }, v(y)), [v, n, u, m, b, s, d]);
  return x.useMemo(() => ({
    getValidationProps: v,
    getInputValidationProps: C,
    inputRef: h,
    commit: b
  }), [v, C, b]);
}
function xx(t) {
  const {
    commit: e,
    invalid: n,
    markedDirtyRef: o,
    name: r,
    setValidityData: i,
    validityData: s
  } = t, {
    formRef: l
  } = Vo(), a = x.useRef(null), c = x.useRef(null), u = x.useRef(null), d = Ce(() => {
    const b = c.current;
    if (b)
      return b.getValue ? b.getValue() : b.value;
  }), f = Ce((b = !0) => {
    const v = c.current;
    if (!v)
      return;
    let C = v.value;
    C === void 0 && (C = d()), o.current = !0, b ? cn.flushSync(() => e(C)) : e(C);
  });
  function p() {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: Ul(s, n),
      validate: f
    });
  }
  function m(b = c.current?.id) {
    b && l.current.fields.delete(b);
  }
  function h() {
    const b = c.current;
    if (!b)
      return;
    let v = b.value;
    v === void 0 && (v = d()), s.initialValue === null && v !== null && i((C) => ({
      ...C,
      initialValue: v
    }));
  }
  return Ne(() => {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: Ul(s, n),
      validate: f
    });
  }, [l, d, n, r, f, s]), Ne(() => {
    const b = l.current.fields;
    return () => {
      const v = c.current?.id;
      v && b.delete(v);
    };
  }, [l]), Ce((b, v) => {
    if (!v) {
      a.current === b && (a.current = null, m(), c.current = null);
      return;
    }
    const C = c.current?.id;
    a.current = b, c.current = v, C && C !== v.id && m(C), h(), p();
  });
}
const L2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    errors: o,
    validationMode: r,
    submitAttemptedRef: i
  } = Vo(), {
    render: s,
    className: l,
    validate: a,
    validationDebounceTime: c = 0,
    validationMode: u = r,
    name: d,
    disabled: f = !1,
    invalid: p,
    dirty: m,
    touched: h,
    actionsRef: b,
    style: v,
    ...C
  } = e, {
    disabled: y
  } = _2(), w = Ce(a || (() => null)), R = y || f, [S, E] = x.useState(!1), [N, M] = x.useState(!1), [T, P] = x.useState(!1), [k, I] = x.useState(!1), D = m ?? N, O = h ?? S, V = x.useRef(!1), _ = Ce((re) => {
    m === void 0 && (re && (V.current = !0), M(re));
  }), L = Ce((re) => {
    h === void 0 && E(re);
  }), A = Ce(() => u === "onChange" || u === "onSubmit" && i.current), $ = !!d && Object.hasOwn(o, d) && o[d] !== void 0, Y = p === !0 || $, [z, H] = x.useState({
    state: Sa,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), K = !Y && z.state.valid, G = x.useMemo(() => ({
    disabled: R,
    touched: O,
    dirty: D,
    valid: K,
    filled: T,
    focused: k
  }), [R, O, D, K, T, k]), q = yx({
    setValidityData: H,
    validate: w,
    validityData: z,
    validationDebounceTime: c,
    invalid: Y,
    markedDirtyRef: V,
    state: G,
    name: d,
    shouldValidateOnChange: A
  }), ee = x.useCallback(() => {
    V.current = !0, q.commit(z.value);
  }, [q, z]), W = xx({
    commit: q.commit,
    invalid: Y,
    markedDirtyRef: V,
    name: d,
    setValidityData: H,
    validityData: z
  });
  x.useImperativeHandle(b, () => ({
    validate: ee
  }), [ee]);
  const X = x.useMemo(() => ({
    invalid: Y,
    name: d,
    validityData: z,
    setValidityData: H,
    disabled: R,
    touched: O,
    setTouched: L,
    dirty: D,
    setDirty: _,
    filled: T,
    setFilled: P,
    focused: k,
    setFocused: I,
    validate: w,
    validationMode: u,
    validationDebounceTime: c,
    shouldValidateOnChange: A,
    state: G,
    markedDirtyRef: V,
    registerFieldControl: W,
    validation: q
  }), [Y, d, z, R, O, L, D, _, T, P, k, I, w, u, c, A, G, W, q]), J = Le("div", e, {
    ref: n,
    state: G,
    props: C,
    stateAttributesMapping: to
  });
  return /* @__PURE__ */ g(ef.Provider, {
    value: X,
    children: J
  });
});
process.env.NODE_ENV !== "production" && (L2.displayName = "FieldRootInner");
const Tr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(A2, {
    children: /* @__PURE__ */ g(L2, {
      ...e,
      ref: n
    })
  });
});
process.env.NODE_ENV !== "production" && (Tr.displayName = "FieldRoot");
const F2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    nativeLabel: l = !0,
    ...a
  } = e, c = on(!1), {
    labelId: u
  } = hn(), d = x.useRef(null), f = hx({
    id: u ?? s,
    native: l
  });
  return process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!d.current)
      return;
    const m = d.current.tagName === "LABEL";
    if (l) {
      if (!m) {
        const h = mr.captureOwnerStack?.() || "";
        Ko(`<Field.Label> expected a <label> element because the \`nativeLabel\` prop is true. Rendering a non-<label> disables native label association, so \`htmlFor\` will not work. Use a real <label> in the \`render\` prop, or set \`nativeLabel\` to \`false\`.${h}`);
      }
    } else if (m) {
      const h = mr.captureOwnerStack?.() || "";
      Ko(`<Field.Label> expected a non-<label> element because the \`nativeLabel\` prop is false. Rendering a <label> assumes native label behavior while Base UI treats it as non-native, which can cause unexpected pointer behavior. Use a non-<label> in the \`render\` prop, or set \`nativeLabel\` to \`true\`.${h}`);
    }
  }, [l]), Le("label", e, {
    ref: [n, d],
    state: c.state,
    props: [f, a],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (F2.displayName = "FieldLabel");
const Cx = {
  ...to,
  ...Bt
}, Or = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    match: s,
    style: l,
    ...a
  } = e, c = It(r), {
    validityData: u,
    state: d,
    name: f
  } = on(!1), {
    setMessageIds: p
  } = hn(), {
    errors: m
  } = Vo(), h = f ? m[f] : null, b = typeof s == "string";
  let v = !1;
  s === !0 ? v = !0 : b ? v = !!u.state[s] : v = !!h || u.state.valid === !1;
  const {
    mounted: C,
    transitionStatus: y,
    setMounted: w
  } = Xn(v);
  Ne(() => {
    if (!(!v || !c))
      return p((O) => O.concat(c)), () => {
        p((O) => O.filter((V) => V !== c));
      };
  }, [v, c, p]);
  const R = x.useRef(null), [S, E] = x.useState(null), [N, M] = x.useState(null), T = u.errors.length > 1 ? /* @__PURE__ */ g("ul", {
    children: u.errors.map((O) => /* @__PURE__ */ g("li", {
      children: O
    }, O))
  }) : u.error, P = b ? T : h || T;
  let k = u.error;
  h != null ? k = Array.isArray(h) ? JSON.stringify(h) : h : u.errors.length > 1 && (k = JSON.stringify(u.errors)), v && k !== N && (M(k), E(P)), jt({
    open: v,
    ref: R,
    onComplete() {
      v || w(!1);
    }
  });
  const I = {
    ...d,
    transitionStatus: y
  }, D = Le("div", e, {
    ref: [n, R],
    state: I,
    props: [{
      id: c,
      children: v ? P : S
    }, a],
    stateAttributesMapping: Cx,
    enabled: C
  });
  return C ? D : null;
});
process.env.NODE_ENV !== "production" && (Or.displayName = "FieldError");
const mi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    style: s,
    ...l
  } = e, a = It(r), c = on(!1), {
    setMessageIds: u
  } = hn();
  return Ne(() => {
    if (a)
      return u((f) => f.concat(a)), () => {
        u((f) => f.filter((p) => p !== a));
      };
  }, [a, u]), Le("p", e, {
    ref: n,
    state: c.state,
    props: [{
      id: a
    }, l],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (mi.displayName = "FieldDescription");
function gi(t, e) {
  const {
    enabled: n = !0,
    getValue: o,
    id: r,
    value: i
  } = e, {
    registerFieldControl: s
  } = on(), l = x.useRef(null);
  l.current || (l.current = /* @__PURE__ */ Symbol()), Ne(() => {
    const a = l.current;
    if (!(!a || !n))
      return s(a, {
        controlRef: t,
        getValue: o,
        id: r,
        value: i
      }), () => {
        s(a, void 0);
      };
  }, [t, n, o, r, s, i]);
}
const of = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    name: s,
    value: l,
    disabled: a = !1,
    onValueChange: c,
    defaultValue: u,
    autoFocus: d = !1,
    style: f,
    ...p
  } = e, {
    state: m,
    name: h,
    disabled: b,
    setTouched: v,
    setDirty: C,
    validityData: y,
    setFocused: w,
    setFilled: R,
    validationMode: S,
    validation: E
  } = on(), N = b || a, M = h ?? s, T = {
    ...m,
    disabled: N
  }, {
    labelId: P
  } = hn(), k = Mr({
    id: i
  });
  Ne(() => {
    const A = l != null;
    E.inputRef.current?.value || A && l !== "" ? R(!0) : A && l === "" && R(!1);
  }, [E.inputRef, R, l]);
  const I = x.useRef(null);
  Ne(() => {
    d && I.current === Gt(et(I.current)) && w(!0);
  }, [d, w]);
  const [D] = pn({
    controlled: l,
    default: u,
    name: "FieldControl",
    state: "value"
  }), O = l !== void 0, V = O ? D : void 0, _ = Ce(() => E.inputRef.current?.value);
  return gi(E.inputRef, {
    id: k,
    value: V,
    getValue: _
  }), Le("input", e, {
    ref: [n, I],
    state: T,
    props: [{
      id: k,
      disabled: N,
      name: M,
      ref: E.inputRef,
      "aria-labelledby": P,
      autoFocus: d,
      ...O ? {
        value: V
      } : {
        defaultValue: u
      },
      onChange(A) {
        const $ = A.currentTarget.value;
        c?.($, _e(Mt, A.nativeEvent)), C($ !== y.initialValue), R($ !== "");
      },
      onFocus() {
        w(!0);
      },
      onBlur(A) {
        v(!0), w(!1), S === "onBlur" && E.commit(A.currentTarget.value);
      },
      onKeyDown(A) {
        A.currentTarget.tagName === "INPUT" && A.key === "Enter" && (v(!0), E.commit(A.currentTarget.value));
      }
    }, E.getInputValidationProps(), p],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (of.displayName = "FieldControl");
const $2 = /* @__PURE__ */ x.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && ($2.displayName = "FieldItemContext");
function H2() {
  return x.useContext($2);
}
const z2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (z2.displayName = "CheckboxGroupContext");
function wx(t = !0) {
  const e = x.useContext(z2);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : tt(3));
  return e;
}
function Sx(t) {
  const e = B.c(46);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: o,
    description: n,
    icon: i,
    size: s,
    side: l,
    align: a,
    disabled: c,
    showArrow: u,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = i === void 0 ? "circle-info" : i, f = s === void 0 ? "sm" : s, p = l === void 0 ? "top" : l, m = a === void 0 ? "center" : a, h = c === void 0 ? !1 : c, b = u === void 0 ? !0 : u, v = Kt(), C = h ? -1 : 0, y = h && "opacity-40 pointer-events-none";
  let w;
  e[10] !== y ? (w = ne("inline-flex items-center justify-center", "cursor-default transition-colors duration-200", "rounded-(--radius-sm)", "text-icon-main", "hover:text-primary", "focus-visible:text-primary", "focus-visible:outline-none focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", y), e[10] = y, e[11] = w) : w = e[11];
  let R;
  e[12] !== d || e[13] !== f ? (R = /* @__PURE__ */ g(We, { name: d, size: f, tone: "inherit" }), e[12] = d, e[13] = f, e[14] = R) : R = e[14];
  let S;
  e[15] !== o || e[16] !== r || e[17] !== R || e[18] !== C || e[19] !== w ? (S = /* @__PURE__ */ g(Hd, { render: /* @__PURE__ */ g("span", { role: "img", tabIndex: C, "aria-label": o, ...r, className: w, children: R }) }), e[15] = o, e[16] = r, e[17] = R, e[18] = C, e[19] = w, e[20] = S) : S = e[20];
  const E = b ? S2 : w2;
  let N;
  e[21] !== b ? (N = b && /* @__PURE__ */ g(Yd, { "data-slot": "tooltip-arrow", className: k2 }), e[21] = b, e[22] = N) : N = e[22];
  const M = n ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let T;
  e[23] !== M ? (T = ne(E2, M), e[23] = M, e[24] = T) : T = e[24];
  let P;
  e[25] !== o || e[26] !== T ? (P = /* @__PURE__ */ g("p", { className: T, children: o }), e[25] = o, e[26] = T, e[27] = P) : P = e[27];
  let k;
  e[28] !== n ? (k = n && /* @__PURE__ */ g("p", { className: N2, children: n }), e[28] = n, e[29] = k) : k = e[29];
  let I;
  e[30] !== N || e[31] !== P || e[32] !== k ? (I = /* @__PURE__ */ F(Gd, { className: R2, children: [
    N,
    P,
    k
  ] }), e[30] = N, e[31] = P, e[32] = k, e[33] = I) : I = e[33];
  let D;
  e[34] !== m || e[35] !== p || e[36] !== E || e[37] !== I ? (D = /* @__PURE__ */ g(Ud, { side: p, align: m, sideOffset: E, className: C2, children: I }), e[34] = m, e[35] = p, e[36] = E, e[37] = I, e[38] = D) : D = e[38];
  let O;
  e[39] !== v || e[40] !== D ? (O = /* @__PURE__ */ g(Bd, { container: v, children: D }), e[39] = v, e[40] = D, e[41] = O) : O = e[41];
  let V;
  return e[42] !== h || e[43] !== S || e[44] !== O ? (V = /* @__PURE__ */ F(Fd, { disabled: h, children: [
    S,
    O
  ] }), e[42] = h, e[43] = S, e[44] = O, e[45] = V) : V = e[45], V;
}
function hi(t) {
  const e = B.c(11), {
    htmlFor: n,
    label: o,
    required: r,
    tooltip: i
  } = t;
  let s;
  e[0] !== r ? (s = r && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-required", children: "*" }), e[0] = r, e[1] = s) : s = e[1];
  let l;
  e[2] !== n || e[3] !== o || e[4] !== s ? (l = /* @__PURE__ */ F(F2, { htmlFor: n, className: "flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default", children: [
    o,
    s
  ] }), e[2] = n, e[3] = o, e[4] = s, e[5] = l) : l = e[5];
  let a;
  e[6] !== i ? (a = i && /* @__PURE__ */ g(Sx, { label: i, size: "xs" }), e[6] = i, e[7] = a) : a = e[7];
  let c;
  return e[8] !== l || e[9] !== a ? (c = /* @__PURE__ */ F("div", { className: "flex items-center justify-between mb-(--spacing-4)", children: [
    l,
    a
  ] }), e[8] = l, e[9] = a, e[10] = c) : c = e[10], c;
}
const Rx = ae(["relative", "flex", "w-full", "min-h-[132px]", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:not([data-disabled=true]):not(:focus-within):not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not([data-disabled=true]):focus-within:not(:has([readonly]))]:border-input-active-outline"], {
  variants: {
    hasError: {
      true: ["border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    hasError: !1
  }
}), Ex = ae(["flex-1", "min-w-0", "w-full", "min-h-[98px]", "border-0", "outline-none", "bg-transparent", "resize-y", "overflow-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "read-only:cursor-default", "read-only:resize-none"]);
function Up(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.join(",") : "";
}
function KO(t) {
  const e = B.c(86);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h, b, v, C, y, w;
  e[0] !== t ? ({
    id: a,
    label: c,
    error: l,
    tooltip: y,
    required: v,
    disabled: s,
    readOnly: b,
    maxLength: u,
    value: w,
    defaultValue: i,
    placeholder: m,
    tabIndex: C,
    onChange: d,
    onKeyDown: f,
    onMouseDown: p,
    "aria-describedby": n,
    "aria-label": o,
    "aria-labelledby": r,
    ...h
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18], w = e[19]);
  const R = At(), S = a ?? R;
  let E;
  e[20] !== i ? (E = () => Up(i), e[20] = i, e[21] = E) : E = e[21];
  const [N, M] = qe(E), T = w !== void 0, P = !!l, k = u !== void 0 && !P, I = !b || P || k, D = `${S}-footer`;
  let O;
  e[22] !== n || e[23] !== D || e[24] !== P || e[25] !== k ? (O = [n, P || k ? D : void 0].filter(Boolean).join(" ") || void 0, e[22] = n, e[23] = D, e[24] = P, e[25] = k, e[26] = O) : O = e[26];
  const V = O, _ = c || r ? o : o ?? "Text area";
  let L;
  e[27] !== N || e[28] !== T || e[29] !== w ? (L = T ? Up(w) : N, e[27] = N, e[28] = T, e[29] = w, e[30] = L) : L = e[30];
  const A = L;
  let $;
  e[31] !== T || e[32] !== d ? ($ = function(le) {
    T || M(le.currentTarget.value), d?.(le);
  }, e[31] = T, e[32] = d, e[33] = $) : $ = e[33];
  const Y = $;
  let z;
  e[34] !== f ? (z = function(le) {
    f?.(le), !le.defaultPrevented && le.key === "Escape" && le.currentTarget.blur();
  }, e[34] = f, e[35] = z) : z = e[35];
  const H = z;
  let K;
  e[36] !== c || e[37] !== v || e[38] !== S || e[39] !== y ? (K = c && /* @__PURE__ */ g(hi, { htmlFor: S, label: c, required: v, tooltip: y }), e[36] = c, e[37] = v, e[38] = S, e[39] = y, e[40] = K) : K = e[40];
  const G = s || void 0;
  let q;
  e[41] !== s || e[42] !== P ? (q = ne(Rx({
    hasError: P
  }), !P && "[&:has([readonly])]:border-input-readonly-outline", s && "opacity-50 cursor-not-allowed"), e[41] = s, e[42] = P, e[43] = q) : q = e[43];
  const ee = b ? void 0 : m, W = b ? -1 : C;
  let X;
  e[44] !== p || e[45] !== b ? (X = (be) => {
    p?.(be), b && !be.defaultPrevented && be.preventDefault();
  }, e[44] = p, e[45] = b, e[46] = X) : X = e[46];
  const J = v || void 0, re = P || void 0, Q = b || void 0;
  let ie;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = Ex(), e[47] = ie) : ie = e[47];
  let ce;
  e[48] !== _ || e[49] !== r || e[50] !== i || e[51] !== V || e[52] !== s || e[53] !== Y || e[54] !== H || e[55] !== u || e[56] !== h || e[57] !== b || e[58] !== v || e[59] !== W || e[60] !== X || e[61] !== J || e[62] !== re || e[63] !== Q || e[64] !== ee || e[65] !== S || e[66] !== w ? (ce = /* @__PURE__ */ g(of, { render: /* @__PURE__ */ g("textarea", { ...h, id: S, value: w, defaultValue: i, placeholder: ee, required: v, disabled: s, readOnly: b, maxLength: u, tabIndex: W, onChange: Y, onKeyDown: H, onMouseDown: X, "aria-label": _, "aria-labelledby": r, "aria-required": J, "aria-invalid": re, "aria-readonly": Q, "aria-describedby": V, className: ie }) }), e[48] = _, e[49] = r, e[50] = i, e[51] = V, e[52] = s, e[53] = Y, e[54] = H, e[55] = u, e[56] = h, e[57] = b, e[58] = v, e[59] = W, e[60] = X, e[61] = J, e[62] = re, e[63] = Q, e[64] = ee, e[65] = S, e[66] = w, e[67] = ce) : ce = e[67];
  let oe;
  e[68] !== ce || e[69] !== G || e[70] !== q ? (oe = /* @__PURE__ */ g("div", { "data-disabled": G, className: q, children: ce }), e[68] = ce, e[69] = G, e[70] = q, e[71] = oe) : oe = e[71];
  let se;
  e[72] !== l || e[73] !== D || e[74] !== P || e[75] !== u || e[76] !== k || e[77] !== I || e[78] !== A ? (se = I && /* @__PURE__ */ F("div", { "data-testid": "textarea-footer", className: "flex justify-between items-center min-h-(--spacing-20) mt-(--spacing-4) gap-(--spacing-8)", children: [
    /* @__PURE__ */ g("div", { className: "flex-1 min-w-0", children: P && /* @__PURE__ */ g(Or, { id: D, match: !0, className: "truncate text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-error-text", children: l }) }),
    k && /* @__PURE__ */ F("span", { id: D, "aria-live": "polite", className: "shrink-0 text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting whitespace-nowrap", children: [
      A.length,
      "/",
      u
    ] })
  ] }), e[72] = l, e[73] = D, e[74] = P, e[75] = u, e[76] = k, e[77] = I, e[78] = A, e[79] = se) : se = e[79];
  let fe;
  return e[80] !== s || e[81] !== P || e[82] !== oe || e[83] !== se || e[84] !== K ? (fe = /* @__PURE__ */ F(Tr, { invalid: P, disabled: s, className: "flex flex-col w-full", children: [
    K,
    oe,
    se
  ] }), e[80] = s, e[81] = P, e[82] = oe, e[83] = se, e[84] = K, e[85] = fe) : fe = e[85], fe;
}
function Nx({
  onSendMessage: t,
  value: e,
  onChange: n,
  disabled: o,
  autoFocus: r,
  alert: i,
  placeholder: s = "Ask anything...",
  initialValue: l = ""
}) {
  const [a, c] = qe(l), u = e !== void 0, d = e ?? a, f = nt(0), p = nt(d), m = nt(/* @__PURE__ */ new Map());
  p.current = d, Rt(() => () => {
    m.current.forEach(({
      controller: w
    }) => {
      w.abort();
    }), m.current.clear();
  }, []);
  function h(w) {
    u || c(w), n?.(w);
  }
  function b(w) {
    const R = w.target.value;
    f.current += 1, h(R);
  }
  function v(w, R) {
    m.current.get(w) === R && m.current.delete(w);
  }
  async function C(w, R, S) {
    try {
      await t(w, S.controller.signal), m.current.get(w) === S && f.current === R && p.current.trim() === w && h("");
    } catch {
    } finally {
      v(w, S);
    }
  }
  function y() {
    const w = d.trim();
    if (!w) {
      h("");
      return;
    }
    if (m.current.has(w)) return;
    const R = {
      controller: new AbortController()
    };
    m.current.set(w, R);
    const S = f.current;
    C(w, S, R);
  }
  return /* @__PURE__ */ g(lx, { value: d, onChange: b, onSend: y, clearOnSend: !1, disabled: o, autoFocus: r, alert: i, placeholder: s, showUpload: !1 });
}
const B2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(of, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (B2.displayName = "Input");
const kx = ae(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:has([readonly])]:cursor-default", "[&:not(:has([readonly])):not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-hover-outline", "[&:not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not(:has([readonly]))]:focus-within:border-input-active-outline", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    size: {
      xs: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Gp = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-input-text-default"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"],
      md: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"]
    },
    italic: {
      true: "italic",
      false: "not-italic"
    }
  },
  defaultVariants: {
    size: "md",
    italic: !1
  }
});
function Ix(t) {
  const e = B.c(69);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h, b, v, C, y;
  e[0] !== t ? ({
    size: f,
    italic: p,
    label: i,
    leadingIcon: s,
    trailingIcon: C,
    trailingAction: v,
    unit: y,
    description: n,
    error: r,
    tooltip: b,
    reserveSubtextSpace: m,
    required: d,
    disabled: o,
    readOnly: u,
    placeholder: a,
    tabIndex: h,
    onMouseDown: l,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18]);
  const w = f === void 0 ? "md" : f, R = p === void 0 ? !1 : p, S = m === void 0 ? !0 : m, E = !!r, N = s || v || y ? void 0 : C;
  let M;
  e[19] !== i || e[20] !== d || e[21] !== b ? (M = i && /* @__PURE__ */ g(hi, { label: i, required: d, tooltip: b }), e[19] = i, e[20] = d, e[21] = b, e[22] = M) : M = e[22];
  let T;
  e[23] !== o || e[24] !== E || e[25] !== w ? (T = ne(kx({
    size: w
  }), !E && "[&:has([readonly])]:border-input-readonly-outline", o && "opacity-50", E && ["border-input-error-outline", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-error-outline"]), e[23] = o, e[24] = E, e[25] = w, e[26] = T) : T = e[26];
  let P;
  e[27] !== s ? (P = s && /* @__PURE__ */ g(We, { name: s, size: "sm", tone: "inherit" }), e[27] = s, e[28] = P) : P = e[28];
  const k = u ? -1 : h, I = u ? void 0 : a, D = u || void 0;
  let O;
  e[29] !== l || e[30] !== u ? (O = (H) => {
    l?.(H), u && !H.defaultPrevented && H.preventDefault();
  }, e[29] = l, e[30] = u, e[31] = O) : O = e[31];
  const V = d || void 0;
  let _;
  e[32] !== E || e[33] !== R || e[34] !== w ? (_ = ne("flex-1", "min-w-0", "outline-none", Gp({
    size: w,
    italic: R
  }), "placeholder:text-text-subtle", E && "text-input-error-text"), e[32] = E, e[33] = R, e[34] = w, e[35] = _) : _ = e[35];
  let L;
  e[36] !== c || e[37] !== u || e[38] !== d || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== k || e[43] !== I || e[44] !== D ? (L = /* @__PURE__ */ g(B2, { ...c, required: d, readOnly: u, tabIndex: k, placeholder: I, "aria-readonly": D, onMouseDown: O, "aria-required": V, className: _ }), e[36] = c, e[37] = u, e[38] = d, e[39] = O, e[40] = V, e[41] = _, e[42] = k, e[43] = I, e[44] = D, e[45] = L) : L = e[45];
  let A;
  e[46] !== o || e[47] !== u || e[48] !== N || e[49] !== w || e[50] !== v || e[51] !== y ? (A = !u && v ? /* @__PURE__ */ g(gt, { ...v, disabled: o || v.disabled, size: "sm", type: "button", variant: "ghost" }) : y ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) shrink-0", children: [
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-default-outline select-none", children: "|" }),
    /* @__PURE__ */ g("span", { className: ne(Gp({
      size: w,
      italic: !1
    }), "text-input-text-supporting whitespace-nowrap"), children: y })
  ] }) : !u && N ? /* @__PURE__ */ g(We, { name: N, size: "sm", tone: "inherit" }) : null, e[46] = o, e[47] = u, e[48] = N, e[49] = w, e[50] = v, e[51] = y, e[52] = A) : A = e[52];
  let $;
  e[53] !== L || e[54] !== A || e[55] !== T || e[56] !== P ? ($ = /* @__PURE__ */ F("div", { className: T, children: [
    P,
    L,
    A
  ] }), e[53] = L, e[54] = A, e[55] = T, e[56] = P, e[57] = $) : $ = e[57];
  let Y;
  e[58] !== n || e[59] !== r || e[60] !== E || e[61] !== S ? (Y = (S || E || n) && /* @__PURE__ */ g("div", { "data-testid": "input-subtext-row", className: ne("mt-(--spacing-4)", S && "min-h-(--spacing-20)"), children: E ? /* @__PURE__ */ g(Or, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: r }) : n ? /* @__PURE__ */ g(mi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: n }) : null }), e[58] = n, e[59] = r, e[60] = E, e[61] = S, e[62] = Y) : Y = e[62];
  let z;
  return e[63] !== o || e[64] !== E || e[65] !== $ || e[66] !== Y || e[67] !== M ? (z = /* @__PURE__ */ F(Tr, { invalid: E, disabled: o, className: "flex flex-col w-full", children: [
    M,
    $,
    Y
  ] }), e[63] = o, e[64] = E, e[65] = $, e[66] = Y, e[67] = M, e[68] = z) : z = e[68], z;
}
const W2 = ae(["flex", "flex-col", "items-start", "min-w-0", "gap-(--spacing-10)", "rounded-(--radius-sm)", "px-(--spacing-8)", "py-(--spacing-10)", "w-full"]), Px = ["Wrong answer", "Slow response", "Incomplete", "Other"];
function U2(t, e) {
  const n = B.c(30), {
    rating: o,
    onSubmit: r,
    onRateResponse: i,
    defaultValue: s,
    submittedDuration: l,
    defaultSubmitted: a
  } = t, c = l === void 0 ? 4e3 : l, u = a === void 0 ? !1 : a, [d, f] = qe(o), [p, m] = qe(s), [h, b] = qe(""), [v, C] = qe(!1), [y, w] = qe(u ? "submitted" : "idle"), R = nt(c), S = nt(e);
  let E, N;
  n[0] !== u || n[1] !== s || n[2] !== o || n[3] !== e || n[4] !== c ? (E = () => {
    S.current !== e && (S.current = e, f(o), m(s), b(""), C(!1), w(u ? "submitted" : "idle"), R.current = c);
  }, N = [u, s, o, e, c], n[0] = u, n[1] = s, n[2] = o, n[3] = e, n[4] = c, n[5] = E, n[6] = N) : (E = n[5], N = n[6]), Rt(E, N);
  let M, T;
  n[7] !== y ? (M = () => {
    if (y !== "submitted")
      return;
    const L = window.setTimeout(() => {
      w("dismissed");
    }, R.current);
    return () => window.clearTimeout(L);
  }, T = [y], n[7] = y, n[8] = M, n[9] = T) : (M = n[8], T = n[9]), Rt(M, T);
  let P;
  n[10] !== i || n[11] !== r || n[12] !== y || n[13] !== c ? (P = function(A) {
    if (!(y !== "idle" || i === void 0 && r === void 0)) {
      if (f(A), i?.(A), A === -1 && r) {
        C(!0);
        return;
      }
      A === 1 && i === void 0 && r?.(A), R.current = c, w("submitted");
    }
  }, n[10] = i, n[11] = r, n[12] = y, n[13] = c, n[14] = P) : P = n[14];
  const k = P;
  let I;
  n[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = function(A) {
    A !== "Other" && b(""), m(A);
  }, n[15] = I) : I = n[15];
  const D = I;
  let O;
  n[16] !== h || n[17] !== r || n[18] !== p || n[19] !== d || n[20] !== c ? (O = function() {
    !r || p === void 0 || (R.current = c, r(d, p === "Other" && h.trim() || p), w("submitted"));
  }, n[16] = h, n[17] = r, n[18] = p, n[19] = d, n[20] = c, n[21] = O) : O = n[21];
  const V = O;
  let _;
  return n[22] !== h || n[23] !== v || n[24] !== p || n[25] !== k || n[26] !== d || n[27] !== y || n[28] !== V ? (_ = {
    selectedRating: d,
    reason: p,
    feedbackText: h,
    isReasonsOpen: v,
    status: y,
    selectRating: k,
    selectReason: D,
    setFeedbackText: b,
    submitFeedback: V
  }, n[22] = h, n[23] = v, n[24] = p, n[25] = k, n[26] = d, n[27] = y, n[28] = V, n[29] = _) : _ = n[29], _;
}
function G2(t) {
  const e = B.c(16), {
    feedbackState: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("legend", { className: "sr-only", children: "Response feedback" }), e[0] = o) : o = e[0];
  const r = n.selectedRating === 1, i = n.status !== "idle";
  let s;
  e[1] !== n ? (s = () => n.selectRating(1), e[1] = n, e[2] = s) : s = e[2];
  let l;
  e[3] !== r || e[4] !== i || e[5] !== s ? (l = /* @__PURE__ */ g(gt, { icon: "thumbs-up", variant: "ghost", size: "sm", "aria-label": "Helpful response", "aria-pressed": r, disabled: i, onClick: s }), e[3] = r, e[4] = i, e[5] = s, e[6] = l) : l = e[6];
  const a = n.selectedRating === -1, c = n.status !== "idle";
  let u;
  e[7] !== n ? (u = () => n.selectRating(-1), e[7] = n, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== c || e[11] !== u ? (d = /* @__PURE__ */ g(gt, { icon: "thumbs-down", variant: "ghost", size: "sm", "aria-label": "Unhelpful response", "aria-pressed": a, disabled: c, onClick: u }), e[9] = a, e[10] = c, e[11] = u, e[12] = d) : d = e[12];
  let f;
  return e[13] !== l || e[14] !== d ? (f = /* @__PURE__ */ F("fieldset", { className: "m-0 flex items-center gap-(--spacing-4) border-0 p-0", children: [
    o,
    l,
    d
  ] }), e[13] = l, e[14] = d, e[15] = f) : f = e[15], f;
}
function Mx(t) {
  const e = B.c(4), {
    children: n,
    selected: o,
    onClick: r
  } = t;
  let i;
  return e[0] !== n || e[1] !== r || e[2] !== o ? (i = /* @__PURE__ */ g("span", { "data-slot": "assistant-chat-feedback-reason", className: "contents [&_button[aria-pressed=true]]:bg-tag-pressed-background [&_button[aria-pressed=true]]:border-tag-pressed-outline", children: /* @__PURE__ */ g(Ji, { "aria-pressed": o, onClick: r, children: n }) }), e[0] = n, e[1] = r, e[2] = o, e[3] = i) : i = e[3], i;
}
function Y2(t) {
  const e = B.c(19), {
    feedbackState: n,
    allowWrittenFeedback: o,
    submitDisabled: r,
    className: i
  } = t, s = r === void 0 ? !1 : r;
  let l;
  e[0] !== i ? (l = ne(W2(), i), e[0] = i, e[1] = l) : l = e[1];
  let a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(fo, { size: "lg", children: "Share Feedback" }), e[2] = a) : a = e[2];
  let c;
  e[3] !== n ? (c = Px.map((m) => /* @__PURE__ */ g(Mx, { selected: n.reason === m, onClick: () => n.selectReason(m), children: m }, m)), e[3] = n, e[4] = c) : c = e[4];
  let u;
  e[5] !== c ? (u = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-start gap-(--spacing-10)", children: [
    a,
    /* @__PURE__ */ g("div", { className: "flex w-full flex-wrap gap-(--spacing-4) sm:w-max", children: c })
  ] }), e[5] = c, e[6] = u) : u = e[6];
  let d;
  e[7] !== o || e[8] !== n ? (d = o && n.reason === "Other" ? /* @__PURE__ */ g("div", { className: "min-w-0 w-full [&_input]:truncate", children: /* @__PURE__ */ g(Ix, { size: "sm", label: "Please provide details:", placeholder: "What was not helpful?", reserveSubtextSpace: !1, value: n.feedbackText, onChange: (m) => n.setFeedbackText(m.target.value) }) }) : null, e[7] = o, e[8] = n, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.reason || e[11] !== n.submitFeedback || e[12] !== s ? (f = n.reason !== void 0 ? /* @__PURE__ */ g(tn, { size: "sm", variant: "outline", disabled: s, onClick: n.submitFeedback, children: "Submit" }) : null, e[10] = n.reason, e[11] = n.submitFeedback, e[12] = s, e[13] = f) : f = e[13];
  let p;
  return e[14] !== l || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback-details", className: l, children: [
    u,
    d,
    f
  ] }), e[14] = l, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function j2(t) {
  const e = B.c(5), {
    className: n
  } = t;
  let o;
  e[0] !== n ? (o = ne(W2(), n), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(nn, { children: "Thanks! We’ve received your feedback." }), e[2] = r) : r = e[2];
  let i;
  return e[3] !== o ? (i = /* @__PURE__ */ g("output", { "data-slot": "assistant-chat-feedback", className: o, "aria-live": "polite", children: r }), e[3] = o, e[4] = i) : i = e[4], i;
}
function qO(t) {
  const e = B.c(13);
  let n, o;
  e[0] !== t ? ({
    allowWrittenFeedback: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? !0 : o, i = U2(n);
  if (i.status === "dismissed")
    return null;
  if (i.status === "submitted") {
    let c;
    return e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(j2, {}), e[3] = c) : c = e[3], c;
  }
  let s;
  e[4] !== i ? (s = /* @__PURE__ */ g(G2, { feedbackState: i }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== r || e[7] !== i || e[8] !== n ? (l = i.isReasonsOpen ? /* @__PURE__ */ g(Y2, { feedbackState: i, allowWrittenFeedback: r, submitDisabled: n.onSubmit === void 0 }) : null, e[6] = r, e[7] = i, e[8] = n, e[9] = l) : l = e[9];
  let a;
  return e[10] !== s || e[11] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback", className: "contents", children: [
    s,
    l
  ] }), e[10] = s, e[11] = l, e[12] = a) : a = e[12], a;
}
const Tx = ae(["flex", "items-center", "justify-between", "gap-(--spacing-12)", "w-full", "px-(--spacing-12)", "max-sm:gap-(--spacing-8)", "max-sm:px-(--spacing-8)"], {
  variants: {
    minimized: {
      false: ["py-(--spacing-16)", "max-sm:py-(--spacing-12)", "bg-ai-panel-header-expanded", "relative", "after:pointer-events-none", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:border-b", "after:border-solid", "after:border-outline-subtle", "after:content-['']", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"],
      true: ["py-(--spacing-8)", "bg-ai-panel-header-minimized", "[background-origin:padding-box,border-box]", "[background-clip:padding-box,border-box]", "border", "border-solid", "border-transparent", "shadow-elevation-7", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"]
    }
  },
  defaultVariants: {
    minimized: !1
  }
});
function dc(t) {
  const e = B.c(50), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    minimized: i,
    onClose: s,
    onMinimize: l,
    onExpand: a,
    onNewConversation: c,
    isNewConversationDisabled: u,
    onOpenHistory: d,
    onBack: f,
    mobileHistoryControlRef: p
  } = t, m = i === void 0 ? !1 : i, h = u === void 0 ? !1 : u;
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    defaultMatches: !1
  }, e[0] = b) : b = e[0];
  const v = Ns(ks.belowSm, b), C = m && !v;
  let y;
  e[1] !== C ? (y = ne(Tx({
    minimized: C
  })), e[1] = C, e[2] = y) : y = e[2];
  const w = C ? "" : void 0;
  let R;
  e[3] !== C || e[4] !== o ? (R = o ?? /* @__PURE__ */ g("div", { className: ne("flex shrink-0 items-center justify-center rounded-(--radius-sm)", C ? "relative size-(--icon-md) overflow-clip" : "size-(--spacing-40) p-(--spacing-4)"), children: /* @__PURE__ */ g(Pu, { size: C ? "md" : "lg" }) }), e[3] = C, e[4] = o, e[5] = R) : R = e[5];
  const S = C ? "sm" : "md";
  let E;
  e[6] !== S || e[7] !== n ? (E = /* @__PURE__ */ g("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ g(wn, { as: "h2", size: S, truncate: !0, children: n }) }), e[6] = S, e[7] = n, e[8] = E) : E = e[8];
  let N;
  e[9] !== r ? (N = r ? /* @__PURE__ */ g("span", { className: "shrink-0", children: r }) : null, e[9] = r, e[10] = N) : N = e[10];
  let M;
  e[11] !== E || e[12] !== N ? (M = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
    E,
    N
  ] }), e[11] = E, e[12] = N, e[13] = M) : M = e[13];
  let T;
  e[14] !== M || e[15] !== R ? (T = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-12)", children: [
    R,
    M
  ] }), e[14] = M, e[15] = R, e[16] = T) : T = e[16];
  let P;
  e[17] !== C || e[18] !== p || e[19] !== f ? (P = !C && f && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(gt, { ref: p, icon: "arrow-left", variant: "ghost", size: "sm", "aria-label": "Back to chat", onClick: f }) }), e[17] = C, e[18] = p, e[19] = f, e[20] = P) : P = e[20];
  let k;
  e[21] !== C || e[22] !== h || e[23] !== c ? (k = !C && c && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(gt, { icon: "edit-pen", variant: "ghost", size: "sm", "aria-label": "New chat", onClick: c, disabled: h }) }), e[21] = C, e[22] = h, e[23] = c, e[24] = k) : k = e[24];
  let I;
  e[25] !== C || e[26] !== p || e[27] !== f || e[28] !== d ? (I = !C && !f && d && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(gt, { ref: p, icon: "clock-seven", variant: "ghost", size: "sm", "aria-label": "Open chat history", onClick: d }) }), e[25] = C, e[26] = p, e[27] = f, e[28] = d, e[29] = I) : I = e[29];
  let D;
  e[30] !== C || e[31] !== l ? (D = !C && /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(gt, { icon: "minus", variant: "ghost", size: "sm", "aria-label": "Minimize", onClick: l }) }), e[30] = C, e[31] = l, e[32] = D) : D = e[32];
  let O;
  e[33] !== C || e[34] !== a ? (O = C && /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(gt, { icon: "expand-regular", variant: "ghost", size: "sm", "aria-label": "Expand", onClick: a }) }), e[33] = C, e[34] = a, e[35] = O) : O = e[35];
  let V;
  e[36] !== s ? (V = /* @__PURE__ */ g(gt, { icon: "x-close", variant: "ghost", size: "sm", "aria-label": "Close", onClick: s }), e[36] = s, e[37] = V) : V = e[37];
  let _;
  e[38] !== P || e[39] !== k || e[40] !== I || e[41] !== D || e[42] !== O || e[43] !== V ? (_ = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
    P,
    k,
    I,
    D,
    O,
    V
  ] }), e[38] = P, e[39] = k, e[40] = I, e[41] = D, e[42] = O, e[43] = V, e[44] = _) : _ = e[44];
  let L;
  return e[45] !== T || e[46] !== _ || e[47] !== y || e[48] !== w ? (L = /* @__PURE__ */ F("header", { className: y, "data-slot": "assistant-chat-header", "data-minimized": w, children: [
    T,
    _
  ] }), e[45] = T, e[46] = _, e[47] = y, e[48] = w, e[49] = L) : L = e[49], L;
}
function K2(t) {
  const e = B.c(9), {
    size: n
  } = t, [o] = qe(Ox), r = n === "fullPage" ? "size-[100px]" : "size-(--icon-xxl)";
  let i;
  e[0] !== r ? (i = ne("aw-loading-animation shrink-0", r), e[0] = r, e[1] = i) : i = e[1];
  const s = `${o}ms`;
  let l;
  e[2] !== s ? (l = {
    animationDelay: s
  }, e[2] = s, e[3] = l) : l = e[3];
  let a, c;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g("path", { className: "fill-outline-subtle opacity-40", d: "M4.8 24c0 10.605 8.595 19.2 19.2 19.2 8.085 0 15-4.995 17.835-12.068-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.128-2.123 5.31-7.313 9.06-13.38 9.06-7.95 0-14.4-6.45-14.4-14.4 0-7.95 6.45-14.4 14.4-14.4.698 0 1.388.053 2.063.143-1.313-.188-2.22-1.403-2.033-2.715.188-1.29 1.365-2.198 2.655-2.048a19.262 19.262 0 0 0-2.685-.188C13.395 4.793 4.8 13.388 4.8 23.993V24Z" }), c = /* @__PURE__ */ g("path", { className: "fill-primary-fixed", d: "M24.023 7.027c.187-1.312 1.402-2.22 2.715-2.032C36.045 6.33 43.2 14.325 43.2 24c0 2.513-.488 4.92-1.365 7.133-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.12.66-1.65 1.028-3.45 1.028-5.348 0-7.253-5.363-13.253-12.338-14.258-1.313-.188-2.22-1.403-2.033-2.715h-.015Z" }), e[4] = a, e[5] = c) : (a = e[4], c = e[5]);
  let u;
  return e[6] !== i || e[7] !== l ? (u = /* @__PURE__ */ F("svg", { "aria-hidden": "true", className: i, "data-slot": "loading-animation", fill: "none", style: l, viewBox: "0 0 48 48", children: [
    a,
    c
  ] }), e[6] = i, e[7] = l, e[8] = u) : u = e[8], u;
}
function Ox() {
  return -(Date.now() % 1e3);
}
function q2(t) {
  const e = B.c(6), {
    label: n
  } = t, o = n ?? "Loading";
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(K2, { size: "blocking" }), e[0] = r) : r = e[0];
  let i;
  e[1] !== n ? (i = n && /* @__PURE__ */ g(fo, { align: "center", size: "xs", children: n }), e[1] = n, e[2] = i) : i = e[2];
  let s;
  return e[3] !== o || e[4] !== i ? (s = /* @__PURE__ */ F("output", { "aria-label": o, className: "flex flex-col items-center gap-(--spacing-8) rounded-(--radius-sm) bg-surface-container-lowest px-(--spacing-24) py-(--spacing-16)", "data-slot": "blocking-action-status", tabIndex: -1, children: [
    r,
    i
  ] }), e[3] = o, e[4] = i, e[5] = s) : s = e[5], s;
}
function ZO(t) {
  const e = B.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    open: r,
    label: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r || void 0, l = r || void 0;
  let a;
  e[5] !== n || e[6] !== s || e[7] !== l ? (a = /* @__PURE__ */ g("div", { "aria-busy": s, inert: l, children: n }), e[5] = n, e[6] = s, e[7] = l, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== r ? (c = r && /* @__PURE__ */ g("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-surface-scrim", "data-slot": "blocking-action-overlay-scrim", children: /* @__PURE__ */ g(q2, { label: o }) }), e[9] = o, e[10] = r, e[11] = c) : c = e[11];
  let u;
  return e[12] !== i || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("div", { ...i, className: "relative", "data-slot": "blocking-action-overlay", children: [
    a,
    c
  ] }), e[12] = i, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
const Z2 = ae(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "rounded-(--radius-sm)", "focus-visible:ring-2", "focus-visible:ring-(--color-inline-link-focus-ring)", "focus-visible:ring-offset-(--spacing-4)", "active:bg-(--color-inline-link-pressed-bg)"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-title-xs)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"],
      md: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    },
    variant: {
      contextual: ["text-(--color-inline-link-contextual)", "no-underline", "hover:underline", "underline-offset-4"],
      navigational: ["text-(--color-inline-link-navigational)", "text-start", "underline", "underline-offset-4", "hover:text-(--color-inline-link-navigational-hover)"]
    },
    destructive: {
      true: ["text-(--color-text-destructive)", "hover:text-(--color-text-destructive)"]
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none"]
    }
  },
  defaultVariants: {
    size: "md",
    variant: "contextual"
  }
}), Dx = "https://www.assetwatch.com/privacy-policy";
function _x(t) {
  const e = B.c(4), {
    href: n,
    label: o
  } = t;
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Z2({
    size: "xs",
    variant: "contextual"
  }), e[0] = r) : r = e[0];
  let i;
  return e[1] !== n || e[2] !== o ? (i = /* @__PURE__ */ g("a", { className: r, href: n, target: "_blank", rel: "noopener noreferrer", children: o }), e[1] = n, e[2] = o, e[3] = i) : i = e[3], i;
}
function Vx({
  year: t = (/* @__PURE__ */ new Date()).getFullYear(),
  privacyPolicyHref: e = Dx,
  privacyPolicyLabel: n = "Privacy Policy"
}) {
  return /* @__PURE__ */ F("footer", { className: "flex h-(--spacing-32) w-full items-center justify-start gap-(--spacing-8)", children: [
    /* @__PURE__ */ F("span", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-xs) leading-(--font-line-height-16) font-(number:--font-weight-regular) text-text-default", children: [
      "© ",
      t,
      " AssetWatch"
    ] }),
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "h-(--spacing-16) border-l border-outline-subtle" }),
    /* @__PURE__ */ g(_x, { href: e, label: n })
  ] });
}
function X2() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("output", { "aria-label": "Loading", tabIndex: -1, children: /* @__PURE__ */ g(K2, { size: "fullPage" }) }), t[0] = e) : e = t[0], e;
}
function XO(t) {
  const e = B.c(5);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g(X2, {}), e[2] = o) : o = e[2];
  let r;
  return e[3] !== n ? (r = /* @__PURE__ */ g("div", { ...n, "aria-busy": "true", className: "flex min-h-dvh items-center justify-center bg-surface-low p-(--spacing-24)", "data-slot": "full-page-loading", children: o }), e[3] = n, e[4] = r) : r = e[4], r;
}
const rf = ho(null);
function sf() {
  return dn(rf);
}
function QO() {
  const t = dn(rf);
  if (!t)
    throw new Error("useAppShell must be used within AppShell.");
  return t;
}
function Ax(t) {
  const e = B.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tabs: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ? "shrink-0 flex min-h-0 max-h-[50dvh] flex-col bg-surface" : "shrink-0 max-h-[50dvh] overflow-y-auto border-b border-outline-subtle bg-surface p-(--spacing-24)";
  let s;
  e[4] !== n || e[5] !== r ? (s = r ? /* @__PURE__ */ g("div", { className: "min-h-0 overflow-y-auto px-(--spacing-24) pt-(--spacing-24) pb-(--spacing-20)", children: n }) : n, e[4] = n, e[5] = r, e[6] = s) : s = e[6];
  let l;
  e[7] !== r ? (l = r && /* @__PURE__ */ g("div", { className: "shrink-0", children: r }), e[7] = r, e[8] = l) : l = e[8];
  let a;
  return e[9] !== o || e[10] !== i || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ F("header", { "data-slot": "page-header", ...o, className: i, children: [
    s,
    l
  ] }), e[9] = o, e[10] = i, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function Q2(t) {
  const e = B.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    modifier: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "items-center", "justify-center", "gap-(--spacing-4)", "rounded-(--radius-sm)", "border-[0.5px]", "border-solid", "border-menu-hotkey-outline", "bg-menu-hotkey-background", "px-(--spacing-6)", "py-(--spacing-4)", "font-(family-name:--font-family-body)", "text-(length:--font-size-label-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-surface-on-surface-variant", "whitespace-nowrap", "not-italic", "select-none"), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = o && /* @__PURE__ */ g("span", { children: o }), e[5] = o, e[6] = s) : s = e[6];
  let l;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (l = /* @__PURE__ */ F("kbd", { "data-slot": "kbd", className: i, ...r, children: [
    s,
    n
  ] }), e[7] = n, e[8] = r, e[9] = s, e[10] = l) : l = e[10], l;
}
const Lx = ae(["inline-flex", "h-(--spacing-40)", "w-full", "min-w-0", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-left", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "max-sm:hidden"]), Fx = ae(["inline-flex", "size-(--spacing-40)", "items-center", "justify-between", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring"]), $x = {
  left: {
    collapse: "arrow-left-shrink-sidebar",
    expand: "arrow-right-expand-sidebar"
  },
  right: {
    collapse: "arrow-right-expand-sidebar",
    expand: "arrow-left-shrink-sidebar"
  }
};
function mu(t) {
  const e = B.c(34);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    collapsed: n,
    collapseDirection: l,
    onClick: o,
    onToggle: r,
    shortcut: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "left" : l, c = n ? "Expand Panel" : "Collapse Panel", u = $x[a][n ? "expand" : "collapse"];
  let d;
  e[7] !== o || e[8] !== r ? (d = function(y) {
    o?.(y), r();
  }, e[7] = o, e[8] = r, e[9] = d) : d = e[9];
  const f = d;
  if (!n) {
    let C;
    e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = Lx(), e[10] = C) : C = e[10];
    let y;
    e[11] !== u ? (y = /* @__PURE__ */ g(We, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[11] = u, e[12] = y) : y = e[12];
    let w;
    e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: "Collapse Panel" }), e[13] = w) : w = e[13];
    let R;
    e[14] !== y ? (R = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
      y,
      w
    ] }), e[14] = y, e[15] = R) : R = e[15];
    let S;
    return e[16] !== f || e[17] !== c || e[18] !== i || e[19] !== R ? (S = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !0, "aria-label": c, className: C, onClick: f, type: "button", children: R }), e[16] = f, e[17] = c, e[18] = i, e[19] = R, e[20] = S) : S = e[20], S;
  }
  let p;
  e[21] !== s ? (p = s ? /* @__PURE__ */ g(Q2, { "aria-hidden": "true", children: s }) : void 0, e[21] = s, e[22] = p) : p = e[22];
  let m;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = Fx(), e[23] = m) : m = e[23];
  let h;
  e[24] !== u ? (h = /* @__PURE__ */ g(We, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[24] = u, e[25] = h) : h = e[25];
  let b;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== h ? (b = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !1, "aria-label": c, className: m, onClick: f, type: "button", children: h }), e[26] = f, e[27] = c, e[28] = i, e[29] = h, e[30] = b) : b = e[30];
  let v;
  return e[31] !== p || e[32] !== b ? (v = /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(qo, { align: "center", endSection: p, label: "Expand", showArrow: !1, side: "right", children: b }) }), e[31] = p, e[32] = b, e[33] = v) : v = e[33], v;
}
const Hx = [
  "grid",
  "h-dvh",
  "min-h-0",
  "overflow-hidden",
  "bg-surface",
  "grid-rows-[auto_minmax(0,1fr)]",
  "transition-[grid-template-columns]",
  "duration-200",
  "ease-in-out",
  "[--app-shell-sidebar-expanded-width:260px]",
  "[--app-shell-sidebar-collapsed-width:72px]",
  "[--app-shell-sidebar-width:var(--app-shell-sidebar-expanded-width)]",
  "data-[sidebar-collapsed]:[--app-shell-sidebar-width:var(--app-shell-sidebar-collapsed-width)]",
  "grid-cols-[var(--app-shell-sidebar-width)_minmax(0,1fr)]",
  "[&>[data-slot=top-bar]]:col-span-2",
  // Keep the header brand region at the expanded width when the sidebar collapses.
  "[&_[data-slot=top-bar-leading]]:w-(--app-shell-sidebar-expanded-width)",
  "max-sm:grid-cols-1",
  "max-sm:[&>[data-slot=top-bar]]:col-span-1",
  "max-sm:[&_[data-slot=top-bar-leading]]:w-auto"
].join(" "), J2 = "[", e0 = "assetwatch:app-shell:sidebar-collapsed";
function zx() {
  if (typeof window > "u") return !1;
  try {
    return window.localStorage.getItem(e0) === "true";
  } catch {
    return !1;
  }
}
function Yp(t) {
  try {
    window.localStorage.setItem(e0, String(t));
  } catch {
  }
}
function Bx(t) {
  return t instanceof HTMLElement ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable : !1;
}
function JO({
  children: t,
  ...e
}) {
  const n = Ns(ks.belowSm, {
    defaultMatches: !1
  }), [o, r] = qe(zx), [i, s] = qe(!1), [l, a] = qe([]), c = nt(0), u = l.at(-1), d = Kt(), f = g9();
  function p(b) {
    r(b), Yp(b);
  }
  function m(b) {
    const v = c.current;
    return c.current += 1, a((C) => [...C, {
      ...b,
      id: v
    }]), () => {
      a((C) => C.filter((y) => y.id !== v));
    };
  }
  Rt(() => {
    if (n) return;
    function b(v) {
      if (v.defaultPrevented || v.isComposing || v.metaKey || v.ctrlKey || v.altKey || v.shiftKey || Bx(v.target) || v.key !== J2)
        return;
      v.preventDefault();
      const C = !o;
      r(C), Yp(C);
    }
    return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
  }, [o, n]), Rt(() => {
    if (d)
      return d.inert = !!u, () => {
        d.inert = !1;
      };
  }, [u, d]);
  const h = u ? /* @__PURE__ */ g("div", { className: "fixed inset-0 z-[var(--z-layer-blocking)] flex items-center justify-center bg-surface-scrim", "data-slot": "app-shell-blocking-overlay", children: /* @__PURE__ */ g(q2, { label: u.label }) }) : null;
  return /* @__PURE__ */ g(rf, { value: {
    desktopSidebarCollapsed: o,
    beginBlockingAction: m,
    isMobile: n,
    mobileNavigationOpen: i,
    setDesktopSidebarCollapsed: p,
    setMobileNavigationOpen: s
  }, children: /* @__PURE__ */ F("div", { className: "relative h-dvh", children: [
    /* @__PURE__ */ g("div", { ...e, "aria-busy": u ? !0 : void 0, className: Hx, "data-sidebar-collapsed": o ? "" : void 0, "data-slot": "app-shell", inert: u ? !0 : void 0, children: t }),
    h && (f ? n4(h, f) : h)
  ] }) });
}
function eD(t) {
  const e = B.c(30);
  let n, o, r, i, s, l, a, c;
  if (e[0] !== t ? ({
    banner: n,
    pageHeader: r,
    pageHeaderTabs: i,
    privacyPolicyLabel: l,
    privacyPolicyHref: s,
    children: o,
    pending: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]), c === void 0 ? !1 : c) {
    let v;
    e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ g("main", { "aria-busy": "true", className: "flex min-h-0 min-w-0 items-center justify-center overflow-y-auto bg-surface-low p-(--spacing-24)", children: /* @__PURE__ */ g(X2, {}) }), e[9] = v) : v = e[9];
    let C;
    return e[10] !== a ? (C = /* @__PURE__ */ g("div", { ...a, className: "grid min-h-0 min-w-0 grid-rows-[minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: v }), e[10] = a, e[11] = C) : C = e[11], C;
  }
  let d;
  e[12] !== n ? (d = n && /* @__PURE__ */ g(Zo, { "data-slot": "app-shell-banner", fullWidth: !0, gap: 0, children: n }), e[12] = n, e[13] = d) : d = e[13];
  let f;
  e[14] !== r || e[15] !== i ? (f = r && /* @__PURE__ */ g(Ax, { tabs: i, "data-slot": "app-shell-page-header", children: r }), e[14] = r, e[15] = i, e[16] = f) : f = e[16];
  let p;
  e[17] !== o ? (p = /* @__PURE__ */ g("div", { className: "min-w-0 grow", children: o }), e[17] = o, e[18] = p) : p = e[18];
  let m;
  e[19] !== s || e[20] !== l ? (m = /* @__PURE__ */ g("div", { className: "mt-(--spacing-32) shrink-0", children: /* @__PURE__ */ g(Vx, { privacyPolicyHref: s, privacyPolicyLabel: l }) }), e[19] = s, e[20] = l, e[21] = m) : m = e[21];
  let h;
  e[22] !== p || e[23] !== m ? (h = /* @__PURE__ */ F("main", { className: "row-start-3 flex min-h-0 min-w-0 flex-col overflow-y-auto bg-surface-low px-(--spacing-24) pt-(--spacing-24)", "data-slot": "app-shell-content-body", children: [
    p,
    m
  ] }), e[22] = p, e[23] = m, e[24] = h) : h = e[24];
  let b;
  return e[25] !== a || e[26] !== d || e[27] !== f || e[28] !== h ? (b = /* @__PURE__ */ F("div", { ...a, className: "relative z-0 grid min-h-0 min-w-0 grid-cols-[minmax(0,1fr)] grid-rows-[auto_auto_minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: [
    d,
    f,
    h
  ] }), e[25] = a, e[26] = d, e[27] = f, e[28] = h, e[29] = b) : b = e[29], b;
}
function tD(t) {
  const e = B.c(7);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const o = sf();
  if (!o)
    throw new Error("AppShellMobileNavigationTrigger must be rendered within AppShell.");
  if (!o.isMobile)
    return null;
  let r;
  e[2] !== o ? (r = () => o.setMobileNavigationOpen(!0), e[2] = o, e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== r ? (i = /* @__PURE__ */ g(gt, { ...n, "aria-label": "Open navigation", icon: "menu-hamburger", onClick: r, variant: "ghost" }), e[4] = n, e[5] = r, e[6] = i) : i = e[6], i;
}
function Wx(t) {
  const e = B.c(11);
  let n, o;
  e[0] !== t ? ({
    onClick: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = sf();
  if (!r)
    throw new Error("AppShellSidebarToggle must be rendered within AppShell.");
  if (r.isMobile)
    return null;
  const {
    desktopSidebarCollapsed: i,
    setDesktopSidebarCollapsed: s
  } = r;
  let l;
  e[3] !== i || e[4] !== s ? (l = () => s(!i), e[3] = i, e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== i || e[7] !== n || e[8] !== o || e[9] !== l ? (a = /* @__PURE__ */ g(mu, { ...o, collapsed: i, onClick: n, onToggle: l, shortcut: J2 }), e[6] = i, e[7] = n, e[8] = o, e[9] = l, e[10] = a) : a = e[10], a;
}
function Ux(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, i = e !== void 0, [s, l] = pn({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: c,
    transitionStatus: u
  } = Xn(s, !0, !0), [d, f] = x.useState(s), [{
    height: p,
    width: m
  }, h] = x.useState({
    height: void 0,
    width: void 0
  }), b = It(), [v, C] = x.useState(), y = v ?? b, [w, R] = x.useState(!1), [S, E] = x.useState(!1), N = x.useRef(null), M = x.useRef(null), T = x.useRef(null), P = x.useRef(null), k = ta(P, !1), I = Ce((D) => {
    const O = !s, V = _e(Zn, D.nativeEvent);
    if (o(O, V), V.isCanceled)
      return;
    const _ = P.current;
    M.current === "css-animation" && _ != null && _.style.removeProperty("animation-name"), !w && !S && (M.current != null && M.current !== "css-animation" && !a && O && c(!0), M.current === "css-animation" && (!d && O && f(!0), !a && O && c(!0))), l(O), M.current === "none" && a && !O && c(!1);
  });
  return Ne(() => {
    i && M.current === "none" && !s && c(!1);
  }, [i, s, e, c]), x.useMemo(() => ({
    abortControllerRef: N,
    animationTypeRef: M,
    disabled: r,
    handleTrigger: I,
    height: p,
    mounted: a,
    open: s,
    panelId: y,
    panelRef: P,
    runOnceAnimationsFinish: k,
    setDimensions: h,
    setHiddenUntilFound: R,
    setKeepMounted: E,
    setMounted: c,
    setOpen: l,
    setPanelIdState: C,
    setVisible: f,
    transitionDimensionRef: T,
    transitionStatus: u,
    visible: d,
    width: m
  }), [N, M, r, I, p, a, s, y, P, k, h, R, E, c, l, f, T, u, d, m]);
}
const lf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (lf.displayName = "CollapsibleRootContext");
function t0() {
  const t = x.useContext(lf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : tt(15));
  return t;
}
let zi = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t;
})({}), Gx = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const Yx = {
  [zi.open]: ""
}, jx = {
  [zi.closed]: ""
}, Kx = {
  open(t) {
    return t ? {
      [Gx.panelOpen]: ""
    } : null;
  }
}, qx = {
  open(t) {
    return t ? Yx : jx;
  }
}, n0 = {
  ...qx,
  ...Bt
}, af = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: i = !1,
    disabled: s = !1,
    onOpenChange: l,
    open: a,
    style: c,
    ...u
  } = e, d = Ce(l), f = Ux({
    open: a,
    defaultOpen: i,
    onOpenChange: d,
    disabled: s
  }), p = x.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), m = x.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: p
  }), [f, d, p]), h = Le("div", e, {
    state: p,
    ref: n,
    props: u,
    stateAttributesMapping: n0
  });
  return /* @__PURE__ */ g(lf.Provider, {
    value: m,
    children: h
  });
});
process.env.NODE_ENV !== "production" && (af.displayName = "CollapsibleRoot");
const Zx = {
  ...Kx,
  ...Bt
}, Gl = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: i,
    state: s,
    disabled: l
  } = t0(), {
    className: a,
    disabled: c = l,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, {
    getButtonProps: h,
    buttonRef: b
  } = Wt({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), v = x.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: i
  }), [o, r, i]);
  return Le("button", e, {
    state: s,
    ref: [n, b],
    props: [v, m, h],
    stateAttributesMapping: Zx
  });
});
process.env.NODE_ENV !== "production" && (Gl.displayName = "CollapsibleTrigger");
let Xx = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function Qx(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: i,
    keepMounted: s,
    id: l,
    mounted: a,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: p,
    setMounted: m,
    setOpen: h,
    setVisible: b,
    transitionDimensionRef: v,
    visible: C,
    width: y
  } = t, w = x.useRef(!1), R = x.useRef(null), S = x.useRef(u), E = x.useRef(u), N = ti(), M = x.useMemo(() => n.current === "css-animation" ? !C : !u && !a, [u, a, C, n]), T = Ce((k) => {
    if (!k)
      return;
    if (n.current == null || v.current == null) {
      const O = getComputedStyle(k), V = O.animationName !== "none" && O.animationName !== "", _ = O.transitionDuration !== "0s" && O.transitionDuration !== "";
      V && _ ? process.env.NODE_ENV !== "production" && ea("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : O.animationName === "none" && O.transitionDuration !== "0s" ? n.current = "css-transition" : O.animationName !== "none" && O.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", k.getAttribute(Xx.orientation) === "horizontal" || O.transitionProperty.indexOf("width") > -1 ? v.current = "width" : v.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || y === void 0) && (p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), E.current && k.style.setProperty("transition-duration", "0s"));
    let I = -1, D = -1;
    return I = Lt.request(() => {
      E.current = !1, D = Lt.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      Lt.cancel(I), Lt.cancel(D);
    };
  }), P = mn(o, d, T);
  return Ne(() => {
    if (n.current !== "css-transition")
      return;
    const k = d.current;
    if (!k)
      return;
    let I = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const D = {
        "justify-content": k.style.justifyContent,
        "align-items": k.style.alignItems,
        "align-content": k.style.alignContent,
        "justify-items": k.style.justifyItems
      };
      Object.keys(D).forEach((O) => {
        k.style.setProperty(O, "initial", "important");
      }), !E.current && !s && k.setAttribute(zi.startingStyle, ""), p({
        height: k.scrollHeight,
        width: k.scrollWidth
      }), I = Lt.request(() => {
        Object.entries(D).forEach(([O, V]) => {
          V === "" ? k.style.removeProperty(O) : k.style.setProperty(O, V);
        });
      });
    } else {
      if (k.scrollHeight === 0 && k.scrollWidth === 0)
        return;
      p({
        height: k.scrollHeight,
        width: k.scrollWidth
      });
      const D = new AbortController();
      e.current = D;
      const O = D.signal;
      let V = null;
      const _ = zi.endingStyle;
      return V = new MutationObserver((L) => {
        L.some(($) => $.type === "attributes" && $.attributeName === _) && (V?.disconnect(), V = null, f(() => {
          p({
            height: 0,
            width: 0
          }), k.style.removeProperty("content-visibility"), m(!1), e.current === D && (e.current = null);
        }, O));
      }), V.observe(k, {
        attributes: !0,
        attributeFilter: [_]
      }), () => {
        V?.disconnect(), N.cancel(), e.current === D && (D.abort(), e.current = null);
      };
    }
    return () => {
      Lt.cancel(I);
    };
  }, [e, n, N, i, s, a, u, d, f, p, m]), Ne(() => {
    if (n.current !== "css-animation")
      return;
    const k = d.current;
    k && (R.current = k.style.animationName || R.current, k.style.setProperty("animation-name", "none"), p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), !S.current && !w.current && k.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), m(!0), b(!0)) : (e.current = new AbortController(), f(() => {
      m(!1), b(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, f, p, m, b, C]), ei(() => {
    const k = Lt.request(() => {
      S.current = !1;
    });
    return () => Lt.cancel(k);
  }), Ne(() => {
    if (!i)
      return;
    const k = d.current;
    if (!k)
      return;
    let I = -1, D = -1;
    return u && w.current && (k.style.transitionDuration = "0s", p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), I = Lt.request(() => {
      w.current = !1, D = Lt.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      Lt.cancel(I), Lt.cancel(D);
    };
  }, [i, u, d, p]), Ne(() => {
    const k = d.current;
    k && i && M && (k.setAttribute("hidden", "until-found"), n.current === "css-transition" && k.setAttribute(zi.startingStyle, ""));
  }, [i, M, n, d]), x.useEffect(function() {
    const I = d.current;
    if (!I)
      return;
    function D(O) {
      w.current = !0, h(!0), c(!0, _e(Mt, O));
    }
    return dt(I, "beforematch", D);
  }, [c, d, h]), x.useMemo(() => ({
    props: {
      hidden: M,
      id: l,
      ref: P
    }
  }), [M, l, P]);
}
let jp = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const cf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: i,
    render: s,
    id: l,
    style: a,
    ...c
  } = e;
  process.env.NODE_ENV !== "production" && Ne(() => {
    r && i === !1 && ea("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, i]);
  const {
    abortControllerRef: u,
    animationTypeRef: d,
    height: f,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelId: b,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setHiddenUntilFound: w,
    setKeepMounted: R,
    setMounted: S,
    setPanelIdState: E,
    setOpen: N,
    setVisible: M,
    state: T,
    transitionDimensionRef: P,
    visible: k,
    width: I,
    transitionStatus: D
  } = t0(), O = r ?? !1, V = i ?? !1;
  Ne(() => {
    if (l)
      return E(l), () => {
        E(void 0);
      };
  }, [l, E]), Ne(() => {
    w(O);
  }, [w, O]), Ne(() => {
    R(V);
  }, [R, V]);
  const {
    props: _
  } = Qx({
    abortControllerRef: u,
    animationTypeRef: d,
    externalRef: n,
    height: f,
    hiddenUntilFound: O,
    id: b,
    keepMounted: V,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setMounted: S,
    setOpen: N,
    setVisible: M,
    transitionDimensionRef: P,
    visible: k,
    width: I
  });
  jt({
    open: h && D === "idle",
    ref: v,
    onComplete() {
      h && y({
        height: void 0,
        width: void 0
      });
    }
  });
  const L = x.useMemo(() => ({
    ...T,
    transitionStatus: D
  }), [T, D]), A = Le("div", e, {
    state: L,
    ref: [n, v],
    props: [_, {
      style: {
        [jp.collapsiblePanelHeight]: f === void 0 ? "auto" : `${f}px`,
        [jp.collapsiblePanelWidth]: I === void 0 ? "auto" : `${I}px`
      }
    }, c],
    stateAttributesMapping: n0
  });
  return V || O || p ? A : null;
});
process.env.NODE_ENV !== "production" && (cf.displayName = "CollapsiblePanel");
function Ra(t) {
  return Le(t.defaultTagName ?? "div", t, t);
}
const uf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (uf.displayName = "DialogRootContext");
function bn(t) {
  const e = x.useContext(uf);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : tt(27));
  return e;
}
let Qt = /* @__PURE__ */ (function(t) {
  return t.nestedDrawers = "--nested-drawers", t.height = "--drawer-height", t.frontmostHeight = "--drawer-frontmost-height", t.swipeMovementX = "--drawer-swipe-movement-x", t.swipeMovementY = "--drawer-swipe-movement-y", t.snapPointOffset = "--drawer-snap-point-offset", t.swipeStrength = "--drawer-swipe-strength", t;
})({}), Ro = /* @__PURE__ */ (function(t) {
  return t.swipeProgress = "--drawer-swipe-progress", t;
})({});
const Jx = {
  ...In,
  ...Bt
}, o0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = bn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: Jx,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        pointerEvents: c ? void 0 : "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        [Ro.swipeProgress]: "0",
        [Qt.swipeStrength]: "1"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (o0.displayName = "DrawerBackdrop");
const Qr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, {
    store: c
  } = bn(), u = c.useState("open");
  function d(h) {
    u && c.setOpen(!1, _e(qg, h.nativeEvent));
  }
  const {
    getButtonProps: f,
    buttonRef: p
  } = Wt({
    disabled: i,
    native: s
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, p],
    props: [{
      onClick: d
    }, a, f]
  });
});
process.env.NODE_ENV !== "production" && (Qr.displayName = "DialogClose");
const r0 = Qr, i0 = "data-drawer-content", s0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e;
  return bn(), Le("div", e, {
    ref: n,
    props: [{
      [i0]: ""
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (s0.displayName = "DrawerContent");
const es = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = bn(), c = It(s);
  return a.useSyncedValueWithCleanup("descriptionElementId", c), Le("p", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (es.displayName = "DialogDescription");
const eC = es, l0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (l0.displayName = "DrawerProviderContext");
function a0(t) {
  return x.useContext(l0);
}
let Un = (function(t) {
  return t[t.open = fn.open] = "open", t[t.closed = fn.closed] = "closed", t[t.startingStyle = fn.startingStyle] = "startingStyle", t[t.endingStyle = fn.endingStyle] = "endingStyle", t.expanded = "data-expanded", t.nestedDrawerOpen = "data-nested-drawer-open", t.nestedDrawerSwiping = "data-nested-drawer-swiping", t.swipeDismiss = "data-swipe-dismiss", t.swipeDirection = "data-swipe-direction", t.swiping = "data-swiping", t;
})({});
const df = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (df.displayName = "DialogPortalContext");
function ff() {
  const t = x.useContext(df);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : tt(26));
  return t;
}
const pf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (pf.displayName = "DrawerRootContext");
function Ea(t) {
  const e = x.useContext(pf);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DrawerRootContext is missing. Drawer parts must be placed within <Drawer.Root>." : tt(90));
  return e;
}
function Ut(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
function Kp(t, e, n) {
  if (!Number.isFinite(e) || e <= 0)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t <= 1 ? Ut(t, 0, 1) * e : t : null;
  const o = t.trim();
  if (o.endsWith("px")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r : null;
  }
  if (o.endsWith("rem")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r * n : null;
  }
  return null;
}
function tC(t, e) {
  let n = null, o = 1 / 0;
  for (const r of e) {
    const i = Math.abs(r.height - t);
    i < o && (o = i, n = r);
  }
  return n;
}
function c0() {
  const {
    store: t
  } = bn(), {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r
  } = Ea(), i = t.useState("viewportElement"), [s, l] = x.useState(0), [a, c] = x.useState(16), u = Ce(() => {
    const m = et(i).documentElement;
    i && l(i.offsetHeight), i || l(m.clientHeight);
    const h = parseFloat(getComputedStyle(m).fontSize);
    Number.isFinite(h) && c(h);
  });
  Ne(() => {
    if (u(), !i || typeof ResizeObserver != "function")
      return;
    const p = new ResizeObserver(u);
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [u, i]);
  const d = x.useMemo(() => {
    if (!e || e.length === 0 || s <= 0 || r <= 0)
      return [];
    const p = Math.min(r, s);
    if (!Number.isFinite(p) || p <= 0)
      return [];
    const m = e.map((v) => {
      const C = Kp(v, s, a);
      if (C === null || !Number.isFinite(C))
        return null;
      const y = Ut(C, 0, p);
      return {
        value: v,
        height: y,
        offset: Math.max(0, r - y)
      };
    }).filter((v) => !!v);
    if (m.length <= 1)
      return m;
    const h = [], b = [];
    for (let v = m.length - 1; v >= 0; v -= 1) {
      const C = m[v];
      b.some((w) => Math.abs(w - C.height) <= 1) || (b.push(C.height), h.push(C));
    }
    return h.reverse(), h;
  }, [r, a, e, s]), f = x.useMemo(() => {
    if (n === void 0)
      return d[0];
    if (n === null)
      return;
    const p = d.find((v) => Object.is(v.value, n));
    if (p)
      return p;
    const m = Math.min(r, s), h = Kp(n, s, a);
    if (h === null || !Number.isFinite(h))
      return;
    const b = Ut(h, 0, m);
    return tC(b, d) ?? void 0;
  }, [n, r, d, a, s]);
  return {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r,
    viewportHeight: s,
    resolvedSnapPoints: d,
    activeSnapPointOffset: f?.offset ?? null
  };
}
const mf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (mf.displayName = "DrawerViewportContext");
function nC(t) {
  return x.useContext(mf);
}
let qp = !1;
function oC() {
  qp || (typeof CSS < "u" && "registerProperty" in CSS && ([Qt.swipeMovementX, Qt.swipeMovementY, Qt.snapPointOffset].forEach((t) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<length>",
        inherits: !1,
        initialValue: "0px"
      });
    } catch {
    }
  }), [{
    name: Ro.swipeProgress,
    initialValue: "0"
  }, {
    name: Qt.swipeStrength,
    initialValue: "1"
  }].forEach(({
    name: t,
    initialValue: e
  }) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<number>",
        inherits: !1,
        initialValue: e
      });
    } catch {
    }
  })), qp = !0);
}
const rC = {
  ...In,
  ...Bt,
  expanded(t) {
    return t ? {
      [Un.expanded]: ""
    } : null;
  },
  nestedDrawerOpen(t) {
    return t ? {
      [Un.nestedDrawerOpen]: ""
    } : null;
  },
  nestedDrawerSwiping(t) {
    return t ? {
      [Un.nestedDrawerSwiping]: ""
    } : null;
  },
  swipeDirection(t) {
    return t ? {
      [Un.swipeDirection]: t
    } : null;
  },
  swiping(t) {
    return t ? {
      [Un.swiping]: ""
    } : null;
  }
}, u0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = bn(), {
    swipeDirection: u,
    frontmostHeight: d,
    hasNestedDrawer: f,
    nestedSwiping: p,
    nestedSwipeProgressStore: m,
    onPopupHeightChange: h,
    notifyParentFrontmostHeight: b,
    notifyParentHasNestedDrawer: v
  } = Ea(), C = c.useState("descriptionElementId"), y = c.useState("disablePointerDismissal"), w = c.useState("floatingRootContext"), R = c.useState("popupProps"), S = c.useState("modal"), E = c.useState("mounted"), N = c.useState("nested"), M = c.useState("nestedOpenDrawerCount"), T = c.useState("transitionStatus"), P = c.useState("open"), k = c.useState("openMethod"), I = c.useState("titleElementId"), D = c.useState("role"), O = M > 0, V = nC(), _ = V?.swiping ?? !1, L = V?.swipeStrength ?? null, {
    snapPoints: A,
    activeSnapPoint: $,
    activeSnapPointOffset: Y
  } = c0();
  ff();
  const [z, H] = x.useState(0), K = x.useRef(0);
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (V)
      return;
    const ce = mr.captureOwnerStack?.() || "";
    Ko(`<Drawer.Popup> expected to be rendered within <Drawer.Viewport>. Omitting the viewport disables drawer swipe handling and touch scroll locking. Wrap <Drawer.Popup> in <Drawer.Viewport>.${ce}`);
  }, [V]);
  const G = Ce(() => {
    const ce = c.context.popupRef.current;
    if (!ce)
      return;
    const oe = ce.offsetHeight;
    if (K.current > 0 && d > K.current && oe > K.current)
      return;
    if (K.current > 0 && f) {
      const be = K.current;
      H(be), h(be);
      return;
    }
    const fe = oe;
    fe !== K.current && (K.current = fe, H(fe), h(fe));
  });
  Ne(() => {
    if (!E) {
      K.current = 0, H(0), h(0);
      return;
    }
    const ce = c.context.popupRef.current;
    if (!ce || (oC(), G(), typeof ResizeObserver != "function"))
      return;
    const oe = new ResizeObserver(G);
    return oe.observe(ce), () => {
      oe.disconnect();
    };
  }, [G, E, O, h, c.context.popupRef]), Ne(() => {
    const ce = c.context.popupRef, oe = () => {
      const fe = ce.current;
      if (!fe)
        return;
      const be = m.getSnapshot();
      be > 0 ? fe.style.setProperty(Ro.swipeProgress, `${be}`) : fe.style.setProperty(Ro.swipeProgress, "0");
    };
    oe();
    const se = m.subscribe(oe);
    return () => {
      se();
      const fe = ce.current;
      fe && fe.style.setProperty(Ro.swipeProgress, "0");
    };
  }, [m, c.context.popupRef]), x.useEffect(() => {
    if (P)
      return b?.(d), () => {
        b?.(0);
      };
  }, [d, P, b]), x.useEffect(() => v ? (v(P || T === "ending"), () => {
    v(!1);
  }) : void 0, [v, P, T]), jt({
    open: P,
    ref: c.context.popupRef,
    onComplete() {
      P && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const q = i === void 0 ? c.context.popupRef : i, ee = {
    open: P,
    nested: N,
    transitionStatus: T,
    expanded: $ === 1,
    nestedDrawerOpen: O,
    nestedDrawerSwiping: p,
    swipeDirection: u,
    swiping: _
  };
  let W;
  z && !(!f && T !== "ending") && (W = `${z}px`);
  const J = A && A.length > 0 && (u === "down" || u === "up");
  let re = null;
  J && Y !== null && (re = u === "up" ? -Y : Y);
  let Q = V ? V.getDragStyles() : St;
  if (J && u === "down") {
    const ce = Y ?? 0, oe = Number.parseFloat(String(Q[Qt.swipeMovementY] ?? 0)), se = Number.isFinite(oe) ? ce + oe : ce, fe = se < 0;
    if (_ && fe && Number.isFinite(oe)) {
      const be = Math.abs(se), me = -Math.sqrt(be) - ce;
      Q = {
        ...Q,
        transform: void 0,
        [Qt.swipeMovementY]: `${me}px`
      };
    } else
      Q = {
        ...Q,
        transform: void 0
      };
  }
  const ie = Le("div", e, {
    state: ee,
    props: [R, {
      "aria-labelledby": I,
      "aria-describedby": C,
      role: D,
      tabIndex: -1,
      hidden: !E,
      onKeyDown(ce) {
        Cs.has(ce.key) && ce.stopPropagation();
      },
      style: {
        ...Q,
        [Ro.swipeProgress]: "0",
        [Qt.nestedDrawers]: M,
        [Qt.height]: W,
        [Qt.snapPointOffset]: typeof re == "number" ? `${re}px` : "0px",
        [Qt.frontmostHeight]: d ? `${d}px` : void 0,
        [Qt.swipeStrength]: typeof L == "number" && Number.isFinite(L) && L > 0 ? `${L}` : "1"
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: rC
  });
  return /* @__PURE__ */ g(ri, {
    context: w,
    openInteractionType: k,
    disabled: !E,
    closeOnFocusOut: !y,
    initialFocus: q,
    returnFocus: r,
    modal: S !== !1,
    restoreFocus: "popup",
    children: ie
  });
});
process.env.NODE_ENV !== "production" && (u0.displayName = "DrawerPopup");
const Dr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = bn(), s = i.useState("mounted"), l = i.useState("modal"), a = i.useState("open");
  return s || o ? /* @__PURE__ */ g(df.Provider, {
    value: o,
    children: /* @__PURE__ */ F(oi, {
      ref: n,
      ...r,
      children: [s && l === !0 && /* @__PURE__ */ g(li, {
        ref: i.context.internalBackdropRef,
        inert: kr(!a)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Dr.displayName = "DialogPortal");
const iC = Dr, sC = {
  ...In,
  ...Bt
}, Ps = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = bn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: sC,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (Ps.displayName = "DialogBackdrop");
let lC = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), aC = (function(t) {
  return t[t.open = fn.open] = "open", t[t.closed = fn.closed] = "closed", t[t.startingStyle = fn.startingStyle] = "startingStyle", t[t.endingStyle = fn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const cC = {
  ...In,
  ...Bt,
  nestedDialogOpen(t) {
    return t ? {
      [aC.nestedDialogOpen]: ""
    } : null;
  }
}, bi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = bn(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), p = c.useState("popupProps"), m = c.useState("modal"), h = c.useState("mounted"), b = c.useState("nested"), v = c.useState("nestedOpenDialogCount"), C = c.useState("open"), y = c.useState("openMethod"), w = c.useState("titleElementId"), R = c.useState("transitionStatus"), S = c.useState("role");
  ff(), jt({
    open: C,
    ref: c.context.popupRef,
    onComplete() {
      C && c.context.onOpenChangeComplete?.(!0);
    }
  });
  function E(k) {
    return k === "touch" ? c.context.popupRef.current : !0;
  }
  const N = i === void 0 ? E : i, M = v > 0, P = Le("div", e, {
    state: {
      open: C,
      nested: b,
      transitionStatus: R,
      nestedDialogOpen: M
    },
    props: [p, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": u ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !h,
      onKeyDown(k) {
        Cs.has(k.key) && k.stopPropagation();
      },
      style: {
        [lC.nestedDialogs]: v
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: cC
  });
  return /* @__PURE__ */ g(ri, {
    context: f,
    openInteractionType: y,
    disabled: !h,
    closeOnFocusOut: !d,
    initialFocus: N,
    returnFocus: r,
    modal: m !== !1,
    restoreFocus: "popup",
    children: P
  });
});
process.env.NODE_ENV !== "production" && (bi.displayName = "DialogPopup");
function uC(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o,
    isDrawer: r
  } = t, i = e.useState("open"), s = e.useState("disablePointerDismissal"), l = e.useState("modal"), a = e.useState("popupElement"), {
    openMethod: c,
    triggerProps: u
  } = Ss(i);
  fs(e);
  const {
    forceUnmount: d
  } = ps(i, e), f = x.useCallback(() => {
    e.setOpen(!1, _e(as));
  }, [e]);
  x.useImperativeHandle(o, () => ({
    unmount: d,
    close: f
  }), [d, f]);
  const p = hs({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0
  }), [m, h] = x.useState(0), [b, v] = x.useState(0), C = m === 0, y = wd(p), w = Sr(p, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: l === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(P) {
      if (!e.context.outsidePressEnabledRef.current || "button" in P && P.button !== 0 || "touches" in P && P.touches.length !== 1)
        return !1;
      const k = bt(P);
      if (C && !s) {
        const I = k;
        return l && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === I || e.context.backdropRef.current === I || He(I, a) && !I?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: C
  });
  i2(i && l === !0, a);
  const {
    getReferenceProps: R,
    getFloatingProps: S,
    getTriggerProps: E
  } = eo([y, w]);
  e.useContextCallback("onNestedDialogOpen", (P, k) => {
    h(P), v(k);
  }), e.useContextCallback("onNestedDialogClose", () => {
    h(0), v(0);
  }), x.useEffect(() => (n?.onNestedDialogOpen && i && n.onNestedDialogOpen(m + 1, b + (r ? 1 : 0)), n?.onNestedDialogClose && !i && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && i && n.onNestedDialogClose();
  }), [r, i, m, b, n]);
  const N = x.useMemo(() => R(u), [R, u]), M = x.useMemo(() => E(u), [E, u]), T = x.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: c,
    activeTriggerProps: N,
    inactiveTriggerProps: M,
    popupProps: T,
    floatingRootContext: p,
    nestedOpenDialogCount: m,
    nestedOpenDrawerCount: b
  });
}
const dC = {
  ...gs,
  modal: ge((t) => t.modal),
  nested: ge((t) => t.nested),
  nestedOpenDialogCount: ge((t) => t.nestedOpenDialogCount),
  nestedOpenDrawerCount: ge((t) => t.nestedOpenDrawerCount),
  disablePointerDismissal: ge((t) => t.disablePointerDismissal),
  openMethod: ge((t) => t.openMethod),
  descriptionElementId: ge((t) => t.descriptionElementId),
  titleElementId: ge((t) => t.titleElementId),
  viewportElement: ge((t) => t.viewportElement),
  role: ge((t) => t.role)
};
class gf extends Rr {
  constructor(e) {
    super(fC(e), {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: new Er(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, dC);
  }
  setOpen = (e, n) => {
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, !e && n.trigger == null && this.state.activeTriggerId != null && (n.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const o = {
      open: e
    }, r = n.trigger?.id ?? null;
    (r || e) && (o.activeTriggerId = r, o.activeTriggerElement = n.trigger ?? null), this.update(o);
  };
  static useStore(e, n) {
    const o = Tt(() => new gf(n)).current;
    return e ?? o;
  }
}
function fC(t = {}) {
  return {
    ...ms(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...t
  };
}
const Yl = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Yl.displayName = "IsDrawerContext");
function vi(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, f = bn(!0), p = x.useContext(Yl), m = !!f, h = gf.useStore(c?.store, {
    open: o,
    openProp: n,
    activeTriggerId: d,
    triggerIdProp: u,
    modal: l,
    disablePointerDismissal: s,
    nested: m
  });
  Ir(() => {
    n === void 0 && h.state.open === !1 && o === !0 && h.update({
      open: !0,
      activeTriggerId: d
    });
  }), h.useControlledProp("openProp", n), h.useControlledProp("triggerIdProp", u), h.useSyncedValues({
    disablePointerDismissal: s,
    nested: m,
    modal: l
  }), h.useContextCallback("onOpenChange", r), h.useContextCallback("onOpenChangeComplete", i);
  const b = h.useState("payload");
  uC({
    store: h,
    actionsRef: a,
    parentContext: f?.store.context,
    isDrawer: p
  });
  const v = x.useMemo(() => ({
    store: h
  }), [h]);
  return /* @__PURE__ */ g(Yl.Provider, {
    value: !1,
    children: /* @__PURE__ */ g(uf.Provider, {
      value: v,
      children: typeof e == "function" ? e({
        payload: b
      }) : e
    })
  });
}
let Zp = (function(t) {
  return t[t.open = fn.open] = "open", t[t.closed = fn.closed] = "closed", t[t.startingStyle = fn.startingStyle] = "startingStyle", t[t.endingStyle = fn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const pC = {
  ...In,
  ...Bt,
  nested(t) {
    return t ? {
      [Zp.nested]: ""
    } : null;
  },
  nestedDialogOpen(t) {
    return t ? {
      [Zp.nestedDialogOpen]: ""
    } : null;
  }
}, yi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    style: s,
    ...l
  } = e, a = ff(), {
    store: c
  } = bn(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), p = c.useState("nestedOpenDialogCount"), m = c.useState("mounted"), h = p > 0;
  return Le("div", e, {
    enabled: a || m,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: h
    },
    ref: [n, c.useStateSetter("viewportElement")],
    stateAttributesMapping: pC,
    props: [{
      role: "presentation",
      hidden: !m,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (yi.displayName = "DialogViewport");
const ts = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = bn(), c = It(s);
  return a.useSyncedValueWithCleanup("titleElementId", c), Le("h2", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (ts.displayName = "DialogTitle");
const d0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = bn(!0), p = c?.store ?? f?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : tt(79));
  const m = It(l), h = p.useState("floatingRootContext"), b = p.useState("isOpenedByTrigger", m), v = x.useRef(null), {
    registerTrigger: C,
    isMountedByThisTrigger: y
  } = ds(m, v, p, {
    payload: a
  }), {
    getButtonProps: w,
    buttonRef: R
  } = Wt({
    disabled: i,
    native: s
  }), S = wr(h, {
    enabled: h != null
  }), E = eo([S]), N = {
    disabled: i,
    open: b
  }, M = p.useState("triggerProps", y);
  return Le("button", e, {
    state: N,
    ref: [R, n, C, v],
    props: [E.getReferenceProps(), M, {
      [od]: "",
      id: m
    }, d, w],
    stateAttributesMapping: yr
  });
});
process.env.NODE_ENV !== "production" && (d0.displayName = "DialogTrigger");
var Xp, Qp;
function mC(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    swipeDirection: f = "down",
    snapToSequentialPoints: p = !1,
    snapPoints: m,
    snapPoint: h,
    defaultSnapPoint: b,
    onSnapPointChange: v
  } = t, C = Ce(v), y = Ea(!0), w = y?.onNestedSwipeProgressChange, R = y?.onNestedFrontmostHeightChange, S = y?.onNestedSwipingChange, E = y?.onNestedDrawerPresenceChange, [N, M] = x.useState(0), [T, P] = x.useState(0), [k, I] = x.useState(!1), [D, O] = x.useState(!1), [V] = x.useState(gC), _ = b !== void 0 ? b : m?.[0] ?? null, L = h !== void 0, [A, $] = pn({
    controlled: h,
    default: _,
    name: "Drawer",
    state: "snapPoint"
  }), Y = x.useRef(!1), z = Ce((Q, ie) => {
    const ce = ie ?? _e(Mt);
    C?.(Q, ce), !ce.isCanceled && $(Q);
  }), H = x.useMemo(() => L || !m || m.length === 0 ? A : A === null || !m.some((Q) => Object.is(Q, A)) ? _ : A, [A, L, _, m]), K = Ce((Q) => {
    M(Q), !Y.current && Q > 0 && P(Q);
  }), G = Ce((Q) => {
    if (Q > 0) {
      Y.current = !0, P(Q);
      return;
    }
    Y.current = !1, N > 0 && P(N);
  }), q = Ce((Q) => {
    I(Q);
  }), ee = Ce((Q) => {
    V.set(Q), w?.(Q);
  }), W = Ce((Q) => {
    O(Q), S?.(Q);
  }), X = Ce((Q, ie) => {
    r?.(Q, ie), !ie.isCanceled && !Q && m && m.length > 0 && z(_, _e(ie.reason, ie.event, ie.trigger));
  }), J = x.useMemo(() => ({
    swipeDirection: f,
    snapToSequentialPoints: p,
    snapPoints: m,
    activeSnapPoint: H,
    setActiveSnapPoint: z,
    frontmostHeight: T,
    popupHeight: N,
    hasNestedDrawer: k,
    nestedSwiping: D,
    nestedSwipeProgressStore: V,
    onNestedDrawerPresenceChange: q,
    onPopupHeightChange: K,
    onNestedFrontmostHeightChange: G,
    onNestedSwipingChange: W,
    onNestedSwipeProgressChange: ee,
    notifyParentFrontmostHeight: R,
    notifyParentSwipingChange: S,
    notifyParentSwipeProgressChange: w,
    notifyParentHasNestedDrawer: E
  }), [H, T, k, D, V, E, w, S, R, q, G, ee, W, K, N, z, m, p, f]), re = typeof e == "function" ? (Q) => /* @__PURE__ */ F(x.Fragment, {
    children: [Xp || (Xp = /* @__PURE__ */ g(Jp, {})), e(Q)]
  }) : /* @__PURE__ */ F(x.Fragment, {
    children: [Qp || (Qp = /* @__PURE__ */ g(Jp, {})), e]
  });
  return /* @__PURE__ */ g(pf.Provider, {
    value: J,
    children: /* @__PURE__ */ g(Yl.Provider, {
      value: !0,
      children: /* @__PURE__ */ g(vi, {
        open: n,
        defaultOpen: o,
        onOpenChange: X,
        onOpenChangeComplete: i,
        disablePointerDismissal: s,
        modal: l,
        actionsRef: a,
        handle: c,
        triggerId: u,
        defaultTriggerId: d,
        children: re
      })
    })
  });
}
function gC() {
  let t = 0;
  const e = /* @__PURE__ */ new Set();
  return {
    getSnapshot: () => t,
    set(n) {
      const o = Number.isFinite(n) ? n : 0;
      o !== t && (t = o, e.forEach((r) => {
        r();
      }));
    },
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    }
  };
}
function Jp() {
  const t = _o(), e = a0(), n = bn(!1), o = n.store.useState("open"), r = n.store.useState("nestedOpenDialogCount"), i = n.store.useState("popupElement"), s = r === 0;
  return x.useEffect(() => {
    if (!(!e || t == null))
      return () => {
        e.removeDrawer(t);
      };
  }, [t, e]), x.useEffect(() => {
    t != null && e?.setDrawerOpen(t, o);
  }, [t, o, e]), x.useEffect(() => {
    if (!o || !s || !ji)
      return;
    const a = wt(i).CloseWatcher;
    if (!a)
      return;
    function c(f) {
      n.store.select("open") && n.store.setOpen(!1, _e(c8, f));
    }
    const u = new a(), d = dt(u, "close", c);
    return () => {
      d(), u.destroy();
    };
  }, [n.store, s, o, i]), null;
}
function gu(t, e) {
  const n = gn(t);
  if (e === "vertical") {
    const r = n.overflowY;
    return (r === "auto" || r === "scroll") && t.scrollHeight > t.clientHeight;
  }
  const o = n.overflowX;
  return (o === "auto" || o === "scroll") && t.scrollWidth > t.clientWidth;
}
function hC(t, e, n) {
  let o = t;
  for (; o && o !== e; ) {
    for (const r of n)
      if (gu(o, r))
        return !0;
    o = o.parentElement;
  }
  return !1;
}
function $r(t, e, n = "vertical") {
  let o = Ct(t) ? t : null;
  for (; o && o !== e; ) {
    if (gu(o, n))
      return o;
    o = o.parentElement;
  }
  return gu(e, n) ? e : null;
}
function El(t, e, n) {
  return typeof t?.elementFromPoint == "function" ? t.elementFromPoint(e, n) : null;
}
const bC = 40, vC = 10, yC = 1, xC = 50, em = 16, CC = 80, wC = 'button,a,input,select,textarea,label,[role="button"]';
function fc(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function SC(t) {
  const n = wt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
function sl(t) {
  return Number.isFinite(t) && t > 0 ? t : null;
}
function RC(t) {
  return t % 2 === 1;
}
function pc(t, e, n) {
  const o = t[n];
  if (typeof o == "function")
    try {
      o.call(t, e);
    } catch (r) {
      if (r && typeof r == "object" && "name" in r && r.name === "NotFoundError")
        return;
      throw r;
    }
}
function EC(t) {
  const {
    enabled: e,
    directions: n,
    elementRef: o,
    movementCssVars: r,
    canStart: i,
    ignoreSelectorWhenTouch: s = !0,
    ignoreScrollableAncestors: l = !1,
    swipeThreshold: a,
    onDismiss: c,
    onProgress: u,
    onCancel: d,
    onSwipeStart: f,
    onRelease: p,
    onSwipingChange: m,
    trackDrag: h = !0
  } = t, b = wC, v = n.length === 1 ? n[0] : void 0, C = Math.max(0, typeof a == "number" ? a : bC), y = n.includes("left"), w = n.includes("right"), R = n.includes("up"), S = n.includes("down"), E = y || w, N = R || S, M = x.useMemo(() => {
    const Se = [];
    return N && Se.push("vertical"), E && Se.push("horizontal"), Se;
  }, [E, N]), [T, P] = x.useState(void 0), [k, I] = x.useState(!1), [D, O] = x.useState(!1), [V, _] = x.useState(!1), [L, A] = x.useState({
    x: 0,
    y: 0
  }), [$, Y] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [z, H] = x.useState(null), K = x.useRef({
    x: 0,
    y: 0
  }), G = x.useRef({
    x: 0,
    y: 0
  }), q = x.useRef(null), ee = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), W = x.useRef(void 0), X = x.useRef(0), J = x.useRef(!1), re = x.useRef({
    x: 0,
    y: 0
  }), Q = x.useRef(!1), ie = x.useRef(!1), ce = x.useRef(null), oe = x.useRef(!1), se = x.useRef(!1), fe = x.useRef({
    width: 0,
    height: 0
  }), be = x.useRef(0), le = x.useRef(C), me = x.useRef(null), j = x.useRef(null), te = x.useRef({
    x: 0,
    y: 0
  }), U = x.useRef(null), Z = x.useRef(!1), ue = Ce((Se) => {
    Z.current !== Se && (Z.current = Se, I(Se), m?.(Se));
  });
  function pe(Se) {
    if (!Se)
      return;
    if (typeof a != "function") {
      le.current = C;
      return;
    }
    const ke = o.current;
    if (!ke)
      return;
    const Fe = a({
      element: ke,
      direction: Se
    });
    le.current = Math.max(0, Fe);
  }
  const he = Ce((Se, ke) => {
    const Fe = Number.isFinite(Se) ? Ut(Se, 0, 1) : 0, Ue = Fe !== be.current;
    let it = !1;
    if (ke) {
      const Ke = U.current;
      it = !Ke || Ke.deltaX !== ke.deltaX || Ke.deltaY !== ke.deltaY || Ke.direction !== ke.direction;
    }
    !Ue && !it || (be.current = Fe, ke ? U.current = ke : Ue && (U.current = null), u?.(Fe, ke));
  });
  function Ie(Se, ke) {
    if (ke === null)
      return;
    const Fe = j.current;
    if (Fe && ke > Fe.time) {
      const Ue = Math.max(ke - Fe.time, em);
      te.current = {
        x: (Se.x - Fe.x) / Ue,
        y: (Se.y - Fe.y) / Ue
      };
    }
    j.current = {
      x: Se.x,
      y: Se.y,
      time: ke
    };
  }
  const ye = x.useCallback(() => {
    P(void 0), ue(!1), O(!1), _(!1), A({
      x: 0,
      y: 0
    }), Y({
      x: 0,
      y: 0,
      scale: 1
    }), H(null), he(0), le.current = C, K.current = {
      x: 0,
      y: 0
    }, G.current = {
      x: 0,
      y: 0
    }, ee.current = {
      x: 0,
      y: 0,
      scale: 1
    }, W.current = void 0, X.current = 0, J.current = !1, re.current = {
      x: 0,
      y: 0
    }, Q.current = !1, q.current = null, ie.current = !1, ce.current = null, oe.current = !1, se.current = !1, fe.current = {
      width: 0,
      height: 0
    }, me.current = null, j.current = null, te.current = {
      x: 0,
      y: 0
    }, U.current = null;
  }, [ue, C, he]);
  x.useEffect(() => {
    typeof a != "function" && (le.current = C);
  }, [C, a]);
  function xe(Se) {
    if ("touches" in Se) {
      const ke = Se.touches[0];
      return ke ? {
        x: ke.clientX,
        y: ke.clientY
      } : null;
    }
    return {
      x: Se.clientX,
      y: Se.clientY
    };
  }
  function de(Se) {
    return "touches" in Se ? !0 : Se.pointerType === "touch";
  }
  function we(Se, ke) {
    const Fe = et(o.current);
    return El(Fe, Se.x, Se.y) ?? bt(ke);
  }
  function Me(Se, ke) {
    return E && !N ? $r(Se, ke, "horizontal") : N && !E ? $r(Se, ke, "vertical") : $r(Se, ke, "vertical") ?? $r(Se, ke, "horizontal");
  }
  function Re(Se, ke, Fe) {
    oe.current = !1;
    const Ue = de(Se), it = we(ke, Se.nativeEvent), ot = et(o.current).body, Ye = Ue && ot ? Me(it, ot) : null, Xe = Fe?.ignoreScrollableTarget ?? !1;
    if (Ye && !Xe || (oe.current = !!(Ye && Xe), (it ? it.closest(b) : !1) && (!Ue || s)))
      return !1;
    const ct = o.current;
    if (l && ct && it && M.length > 0 && !(Fe?.ignoreScrollableAncestors ?? !1) && hC(it, ct, M))
      return !1;
    if (J.current = !1, W.current = void 0, X.current = 0, K.current = ke, me.current = sl(Se.timeStamp), re.current = ke, q.current = ke, ct) {
      fe.current = {
        width: ct.offsetWidth,
        height: ct.offsetHeight
      }, pe(v);
      const mt = SC(ct);
      ee.current = mt, G.current = {
        x: mt.x,
        y: mt.y
      }, Y(mt), A({
        x: mt.x,
        y: mt.y
      }), Ie({
        x: mt.x,
        y: mt.y
      }, me.current), "touches" in Se || pc(ct, Se.pointerId, "setPointerCapture");
    }
    return f?.(Se.nativeEvent), ue(!0), O(!1), H(null), Q.current = !0, he(0), !0;
  }
  function Ve() {
    je(), oe.current = !1, q.current = null;
  }
  function je() {
    ie.current = !1, ce.current = null;
  }
  function Ze(Se) {
    if (Ve(), !Z.current)
      return;
    ue(!1), O(!1), H(null);
    const ke = h ? $ : ee.current;
    G.current = {
      x: ke.x,
      y: ke.y
    }, A({
      x: ke.x,
      y: ke.y
    }), P(void 0), se.current = !1;
    const Fe = o.current;
    Fe && pc(Fe, Se.pointerId, "releasePointerCapture"), he(0, {
      deltaX: 0,
      deltaY: 0,
      direction: void 0
    }), d?.(Se.nativeEvent);
  }
  function ze(Se, ke) {
    const Fe = (ot) => ot >= 0 ? ot ** 0.5 : -(Math.abs(ot) ** 0.5), Ue = (ot, Ye, Xe) => !Ye && ot < 0 || !Xe && ot > 0 ? Fe(ot) : ot, it = E ? Ue(Se, y, w) : Fe(Se), Ke = N ? Ue(ke, R, S) : Fe(ke);
    return {
      x: it,
      y: Ke
    };
  }
  function Ee(Se, ke, Fe) {
    const Ue = Math.abs(ke), it = Math.abs(Fe);
    if (N && Fe !== 0 && (!E || it >= Ue)) {
      const Ye = Math.max(0, Se.scrollHeight - Se.clientHeight), Xe = Se.scrollTop <= 0, rt = Se.scrollTop >= Ye, ct = Fe > 0, mt = Fe < 0;
      return ct && Xe && S || mt && rt && R;
    }
    if (E && ke !== 0 && (!N || Ue > it)) {
      const Ye = Math.max(0, Se.scrollWidth - Se.clientWidth), Xe = Se.scrollLeft <= 0, rt = Se.scrollLeft >= Ye, ct = ke > 0, mt = ke < 0;
      return ct && Xe && w || mt && rt && y;
    }
    return null;
  }
  const Ae = Ce((Se) => {
    if (!e || Se.defaultPrevented || Se.nativeEvent.defaultPrevented || !("touches" in Se) && Se.button !== 0)
      return;
    const ke = xe(Se);
    !ke || (ie.current = !0, ce.current = ke, oe.current = !1, se.current = !1, !(i ? i(ke, {
      nativeEvent: Se.nativeEvent,
      direction: v
    }) : !0)) || Re(Se, ke) && je();
  });
  function Pe(Se, ke, Fe) {
    if (!e || !Z.current)
      return;
    const Ue = bt(Se.nativeEvent);
    if (de(Se) && !oe.current) {
      const Zt = Se.currentTarget;
      if (Me(Ue, Zt))
        return;
    }
    if ("touches" in Se || Se.preventDefault(), Q.current) {
      K.current = ke;
      const Zt = sl(Se.timeStamp);
      Zt !== null && (me.current = Zt), Q.current = !1;
    }
    const it = ke.x, Ke = ke.y, ot = Fe.x, Ye = Fe.y;
    (Ye < 0 && Ke > re.current.y || Ye > 0 && Ke < re.current.y) && (re.current = {
      x: re.current.x,
      y: Ke
    }), (ot < 0 && it > re.current.x || ot > 0 && it < re.current.x) && (re.current = {
      x: it,
      y: re.current.y
    });
    const Xe = it - K.current.x, rt = Ke - K.current.y, ct = Ke - re.current.y, mt = it - re.current.x;
    if (!D && Math.sqrt(Xe * Xe + rt * rt) >= yC && (O(!0), z === null && E && N)) {
      const $n = Math.abs(Xe), Si = Math.abs(rt);
      H($n > Si ? "horizontal" : "vertical");
    }
    let ht;
    if (!W.current)
      z === "vertical" ? rt > 0 ? ht = "down" : rt < 0 && (ht = "up") : z === "horizontal" ? Xe > 0 ? ht = "right" : Xe < 0 && (ht = "left") : Math.abs(Xe) >= Math.abs(rt) ? ht = Xe > 0 ? "right" : "left" : ht = rt > 0 ? "down" : "up", ht && (ht === "left" && y || ht === "right" && w || ht === "up" && R || ht === "down" && S) && (W.current = ht, X.current = fc(ht, Xe, rt), P(ht), pe(ht));
    else {
      const Zt = W.current, $n = fc(Zt, mt, ct);
      $n > le.current ? (J.current = !1, P(Zt)) : !(y && w) && !(R && S) && X.current - $n >= vC && (J.current = !0);
    }
    const Ot = ze(Xe, rt);
    let ut = ee.current.x, zt = ee.current.y;
    z === "horizontal" ? E && (ut += Ot.x) : (z === "vertical" || E && (ut += Ot.x), N && (zt += Ot.y)), G.current = {
      x: ut,
      y: zt
    }, h && A({
      x: ut,
      y: zt
    }), Ie({
      x: ut,
      y: zt
    }, sl(Se.timeStamp));
    const no = ut - ee.current.x, vn = zt - ee.current.y, Fn = W.current, Pn = v ?? W.current;
    if (!Pn) {
      he(0, {
        deltaX: no,
        deltaY: vn,
        direction: Fn
      });
      return;
    }
    const Mn = Pn === "left" || Pn === "right" ? fe.current.width : fe.current.height, rn = ee.current.scale || 1;
    if (Mn <= 0 || rn <= 0) {
      he(0, {
        deltaX: no,
        deltaY: vn,
        direction: Fn
      });
      return;
    }
    const oo = fc(Pn, ut - ee.current.x, zt - ee.current.y);
    if (oo <= 0) {
      he(0, {
        deltaX: no,
        deltaY: vn,
        direction: Fn
      });
      return;
    }
    he(oo / (Mn * rn), {
      deltaX: no,
      deltaY: vn,
      direction: Fn
    });
  }
  const Oe = Ce((Se) => {
    const ke = xe(Se);
    if (!ke)
      return;
    if (!("touches" in Se)) {
      const it = RC(Se.buttons);
      it && (se.current = !0);
      const Ke = Se.buttons === 0 && se.current;
      if (Se.buttons !== 0 && !it || Ke) {
        Ze(Se);
        return;
      }
    }
    if (!k && ie.current) {
      if (!de(Se) && (Se.defaultPrevented || Se.nativeEvent.defaultPrevented)) {
        Ve();
        return;
      }
      if (i ? i(ke, {
        nativeEvent: Se.nativeEvent,
        direction: v
      }) : !0) {
        const Ke = ce.current;
        let ot = !1;
        if (de(Se)) {
          const Xe = o.current;
          if (Ke && Xe) {
            const rt = we(ke, Se.nativeEvent), mt = et(Xe).body, ht = mt ? Me(rt, mt) : null;
            if (ht && (He(Xe, ht) || He(ht, Xe))) {
              const Ot = ke.x - Ke.x, ut = ke.y - Ke.y, zt = Ee(ht, Ot, ut);
              if (zt === !1)
                return;
              zt === !0 && (ot = !0);
            }
          }
        }
        Re(Se, ke, {
          ignoreScrollableTarget: ot,
          ignoreScrollableAncestors: ot
        }) && (Ke && ot ? (je(), K.current = Ke, re.current = Ke, q.current = Ke, Q.current = !1) : (je(), oe.current = !1));
      }
    }
    const Fe = q.current, Ue = Fe === null ? {
      x: 0,
      y: 0
    } : {
      x: ke.x - Fe.x,
      y: ke.y - Fe.y
    };
    q.current = ke, Pe(Se, ke, Ue);
  }), $e = Ce((Se) => {
    if (!e)
      return;
    const ke = G.current, Fe = ee.current, Ue = ke.x - Fe.x, it = ke.y - Fe.y, Ke = {
      deltaX: Ue,
      deltaY: it,
      direction: T ?? W.current
    };
    if (!Z.current) {
      Ve(), he(0, Ke);
      return;
    }
    ue(!1), O(!1), H(null), Ve(), se.current = !1;
    const ot = o.current;
    ot && ("touches" in Se || pc(ot, Se.pointerId, "releasePointerCapture"));
    const Ye = Ue, Xe = it, rt = me.current, ct = sl(Se.timeStamp), mt = rt !== null && ct !== null && ct > rt ? ct - rt : 0, ht = mt > 0 ? Math.max(mt, xC) : 0, Ot = ht > 0 ? Ye / ht : 0, ut = ht > 0 ? Xe / ht : 0;
    let zt = te.current.x, no = te.current.y;
    const vn = j.current;
    if (vn && ct !== null && ct >= vn.time) {
      const oo = ct - vn.time;
      if (oo <= CC) {
        const Zt = Math.max(oo, em), $n = ke.x - vn.x, Si = ke.y - vn.y, yn = $n / Zt, Hn = Si / Zt;
        yn !== 0 && (zt = yn), Hn !== 0 && (no = Hn);
      } else
        zt = 0, no = 0;
    }
    const Fn = p?.({
      event: Se.nativeEvent,
      direction: T ?? W.current,
      deltaX: Ye,
      deltaY: Xe,
      velocityX: Ot,
      velocityY: ut,
      releaseVelocityX: zt,
      releaseVelocityY: no
    }), Pn = typeof Fn == "boolean";
    if (J.current && !Pn) {
      G.current = {
        x: Fe.x,
        y: Fe.y
      }, A({
        x: Fe.x,
        y: Fe.y
      }), P(void 0), he(0, Ke);
      return;
    }
    let Mn = !1, rn;
    if (Pn)
      Mn = Fn, rn = T ?? W.current ?? v;
    else
      for (const oo of n) {
        switch (oo) {
          case "right":
            Ye > le.current && (Mn = !0, rn = "right");
            break;
          case "left":
            Ye < -le.current && (Mn = !0, rn = "left");
            break;
          case "down":
            Xe > le.current && (Mn = !0, rn = "down");
            break;
          case "up":
            Xe < -le.current && (Mn = !0, rn = "up");
            break;
        }
        if (Mn)
          break;
      }
    Mn && rn ? (P(rn), _(!0), c?.(Se.nativeEvent, {
      direction: rn
    })) : (G.current = {
      x: Fe.x,
      y: Fe.y
    }, A({
      x: Fe.x,
      y: Fe.y
    }), P(void 0), he(0, Ke));
  }), Te = x.useCallback(() => {
    const Se = h ? L : G.current, ke = h ? $ : ee.current;
    if (!k && Se.x === ke.x && Se.y === ke.y && !V)
      return {
        [r.x]: "0px",
        [r.y]: "0px"
      };
    const Fe = Se.x - ke.x, Ue = Se.y - ke.y;
    return {
      transition: k ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: k ? `translateX(${Se.x}px) translateY(${Se.y}px) scale(${ke.scale})` : void 0,
      [r.x]: `${Fe}px`,
      [r.y]: `${Ue}px`
    };
  }, [V, L, $, k, r, h]), vt = x.useCallback(() => e ? {
    onPointerDown: Ae,
    onPointerMove: Oe,
    onPointerUp: $e,
    onPointerCancel: $e
  } : {}, [e, $e, Oe, Ae]), st = x.useCallback(() => e ? {
    onTouchStart: Ae,
    onTouchMove: Oe,
    onTouchEnd: $e,
    onTouchCancel: $e
  } : {}, [e, $e, Oe, Ae]);
  return {
    swiping: k,
    swipeDirection: T,
    dragDismissed: V,
    getPointerProps: vt,
    getTouchProps: st,
    getDragStyles: Te,
    reset: ye
  };
}
const NC = ts, kC = d0, hu = 10, tm = 0.5, nm = 0.5, IC = 300, om = 4, rm = 0.2, PC = 4, mc = 80, im = 360, gc = 0.1, sm = 1, MC = `[${i0}]`, f0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    children: s,
    ...l
  } = e, {
    store: a
  } = bn(), {
    swipeDirection: c,
    notifyParentSwipingChange: u,
    notifyParentSwipeProgressChange: d,
    frontmostHeight: f,
    snapToSequentialPoints: p
  } = Ea(), h = a0()?.visualStateStore, b = a.useState("open"), v = a.useState("mounted"), C = a.useState("nested"), y = a.useState("nestedOpenDrawerCount"), w = a.useState("viewportElement"), R = a.useState("popupElement"), S = y > 0, E = c === "left" || c === "right" ? "horizontal" : "vertical", N = E === "vertical", M = N ? "horizontal" : "vertical", {
    snapPoints: T,
    resolvedSnapPoints: P,
    activeSnapPoint: k,
    activeSnapPointOffset: I,
    setActiveSnapPoint: D,
    popupHeight: O
  } = c0(), [V, _] = x.useState(null), L = x.useRef(void 0), A = x.useRef(null), $ = ti(), Y = x.useRef(!1), z = x.useRef(""), H = x.useRef(!1), K = x.useRef(!1), G = x.useRef(null), q = x.useMemo(() => {
    if (!T || T.length < 2 || c !== "down" && c !== "up" || P.length < 2)
      return null;
    const j = P.map((pe) => pe.offset).filter((pe) => Number.isFinite(pe)).sort((pe, he) => pe - he);
    if (j.length < 2)
      return null;
    const te = j[0], U = j[1], Z = j[j.length - 1];
    let ue = U - te;
    if (!Number.isFinite(ue) || ue <= 0) {
      const pe = Z - te;
      if (!Number.isFinite(pe) || pe <= 0)
        return null;
      ue = pe;
    }
    return {
      minOffset: te,
      range: ue
    };
  }, [P, T, c]), ee = x.useMemo(() => !q || I === null ? null : Ut((I - q.minOffset) / q.range, 0, 1), [I, q]), W = x.useMemo(() => T && T.length > 0 && (c === "down" || c === "up") ? c === "down" ? ["down", "up"] : ["up", "down"] : [c], [T, c]), X = Ce((j) => {
    lm(a.context.popupRef.current, a.context.backdropRef.current, j);
  }), J = Ce(() => {
    X(!1), a.context.popupRef.current?.removeAttribute(qn.endingStyle), _(null);
  }), re = Ce(() => {
    Y.current && (Y.current = !1, u?.(!1));
  }), Q = Ce(({
    resolvedProgress: j,
    shouldTrackProgress: te,
    notifyParent: U
  }) => {
    const Z = b && !C && te, ue = Z ? j : 0, pe = b && te ? j : 0;
    U && d && (d(pe), pe <= 0 && re()), h?.set({
      swipeProgress: ue,
      frontmostHeight: ue > 0 ? f : 0
    });
    const he = a.context.backdropRef.current;
    if (he) {
      if (!Z || ue <= 0) {
        he.style.setProperty(Ro.swipeProgress, "0"), he.style.removeProperty(Qt.height);
        return;
      }
      he.style.setProperty(Ro.swipeProgress, `${ue}`), f > 0 ? he.style.setProperty(Qt.height, `${f}px`) : he.style.removeProperty(Qt.height);
    }
  });
  function ie({
    direction: j,
    deltaX: te,
    deltaY: U,
    velocityX: Z,
    velocityY: ue,
    releaseVelocityX: pe,
    releaseVelocityY: he
  }) {
    if (!j)
      return null;
    const Ie = a.context.popupRef.current;
    if (!Ie)
      return null;
    const ye = j === "left" || j === "right" ? Ie.offsetWidth : Ie.offsetHeight;
    if (!Number.isFinite(ye) || ye <= 0)
      return null;
    const xe = j === "left" || j === "right" ? te : U, de = T && T.length > 0 ? I ?? 0 : 0;
    let we = 0;
    j === "down" ? we = de : j === "up" && (we = -de);
    const Me = we + xe, Re = j === "left" || j === "up" ? -Me : Me, Ve = Math.max(0, ye - Re);
    if (!Number.isFinite(Ve) || Ve <= 0)
      return null;
    const je = j === "left" || j === "right" ? pe : he, Ze = j === "left" || j === "right" ? Z : ue, ze = Math.abs(je) > 0 && Number.isFinite(je) ? je : Ze, Ee = j === "left" || j === "up" ? -ze : ze;
    if (!Number.isFinite(Ee) || Ee <= rm)
      return null;
    const Ae = Ut(Ee, rm, PC), Pe = Ut(Ve / Ae, mc, im);
    if (!Number.isFinite(Pe))
      return null;
    const Oe = (Pe - mc) / (im - mc), $e = Ut(gc + Oe * (sm - gc), gc, sm);
    return !Number.isFinite($e) || $e <= 0 ? null : $e;
  }
  function ce(j) {
    if (Y.current || !j)
      return;
    const te = j.direction ?? c, U = te === "left" || te === "right" ? j.deltaX : j.deltaY;
    !Number.isFinite(U) || Math.abs(U) < hu || (Y.current = !0, u?.(!0));
  }
  const oe = EC({
    enabled: v && !S,
    directions: W,
    elementRef: a.context.popupRef,
    ignoreSelectorWhenTouch: !1,
    ignoreScrollableAncestors: !0,
    movementCssVars: {
      x: Qt.swipeMovementX,
      y: Qt.swipeMovementY
    },
    onSwipeStart(j) {
      if ("touches" in j || "pointerType" in j && j.pointerType === "touch")
        return;
      const te = a.context.popupRef.current;
      if (!te)
        return;
      const Z = et(te).getSelection?.();
      if (!Z || Z.isCollapsed)
        return;
      const ue = pt(Z.anchorNode) ? Z.anchorNode : Z.anchorNode?.parentElement, pe = pt(Z.focusNode) ? Z.focusNode : Z.focusNode?.parentElement;
      !He(te, ue) && !He(te, pe) || Z.removeAllRanges();
    },
    onSwipingChange(j) {
      am(a.context.backdropRef.current, j), !j && !d && re();
    },
    swipeThreshold({
      element: j,
      direction: te
    }) {
      return cm(j, te);
    },
    canStart(j, te) {
      const U = a.context.popupRef.current;
      if (!U)
        return !1;
      const Z = U.ownerDocument, ue = El(Z, j.x, j.y);
      if (!ue || !He(U, ue))
        return !1;
      const pe = te.nativeEvent;
      return !(("touches" in pe || "pointerType" in pe && pe.pointerType === "touch") && dm(Z, U) || pe.type === "touchstart" && hc(ue));
    },
    onProgress(j, te) {
      ce(te);
      const U = te?.direction ?? oe.swipeDirection, Z = U === void 0 || U === c, ue = !!(T && T.length > 0), he = ue && (c === "down" || c === "up") || !ue || c === "left" || c === "right" || Z;
      let Ie = j;
      if (q && O > 0) {
        if (te && Number.isFinite(te.deltaY)) {
          const ye = I ?? q.minOffset, xe = Ut(ye + te.deltaY, 0, O);
          Ie = Ut((xe - q.minOffset) / q.range, 0, 1);
        } else if (ee !== null)
          Ie = ee;
        else if (U === "down" || U === "up") {
          const ye = j * O, xe = I ?? q.minOffset, de = U === "down" ? xe + ye : xe - ye;
          Ie = Ut((de - q.minOffset) / q.range, 0, 1);
        }
      }
      Q({
        resolvedProgress: Ie,
        shouldTrackProgress: he,
        notifyParent: !0
      });
    },
    onRelease({
      event: j,
      deltaX: te,
      deltaY: U,
      direction: Z,
      velocityX: ue,
      velocityY: pe,
      releaseVelocityX: he,
      releaseVelocityY: Ie
    }) {
      const ye = {
        deltaX: te,
        deltaY: U,
        velocityX: ue,
        velocityY: pe,
        releaseVelocityX: he,
        releaseVelocityY: Ie
      };
      function xe(st) {
        const Se = a.context.popupRef.current;
        Se && (re(), X(!0), Se.style.removeProperty("transition"), Se.setAttribute(qn.endingStyle, ""), cn.flushSync(() => {
          _(ie({
            direction: st,
            ...ye
          }));
        }));
      }
      if (!T || T.length === 0) {
        if (!Z) {
          J();
          return;
        }
        const st = a.context.popupRef.current;
        if (!st) {
          J();
          return;
        }
        const Se = cm(st, Z), ke = Z === "left" || Z === "right" ? te : U;
        if (!Number.isFinite(ke)) {
          J();
          return;
        }
        const Fe = Z === "left" || Z === "up" ? -ke : ke;
        if (Fe <= 0)
          return J(), !1;
        const Ue = Z === "left" || Z === "right" ? ue : pe;
        if ((Z === "left" || Z === "up" ? -Ue : Ue) >= tm && Fe > 0)
          return xe(Z), !0;
        const Ke = Fe > Se;
        return Ke ? xe(Z) : J(), Ke;
      }
      if (c !== "down" && c !== "up") {
        J();
        return;
      }
      if (!O || P.length === 0) {
        J();
        return;
      }
      const de = c === "down" ? U : -U;
      if (!Number.isFinite(de)) {
        J();
        return;
      }
      const we = Math.sign(de), Me = c === "down" ? Ie : -Ie, Re = c === "down" ? pe : -pe;
      let Ve = Number.isFinite(Me) ? Me : Re;
      if (we !== 0 && Math.abs(de) >= hu && Number.isFinite(Ve)) {
        const st = Math.sign(Ve);
        st !== 0 && st !== we && (Ve = Re);
      }
      const je = I ?? 0, Ze = Ut(je + de, 0, O), ze = Number.isFinite(Ve) && Math.abs(Ve) >= nm ? Ut(Ve, -om, om) * IC : 0, Ee = p ? Ze : Ut(Ze + ze, 0, O), Ae = _e(Ys, j), Pe = () => (L.current = k, D?.(null, Ae), xe(c), !0);
      if (p) {
        const st = [...P].sort((rt, ct) => rt.offset - ct.offset);
        if (st.length === 0)
          return J(), !1;
        let Se = 0, ke = Math.abs(je - st[0].offset);
        for (let rt = 1; rt < st.length; rt += 1) {
          const ct = Math.abs(je - st[rt].offset);
          ct < ke && (ke = ct, Se = rt);
        }
        let Fe = st[0];
        ke = Math.abs(Ee - Fe.offset);
        for (const rt of st) {
          const ct = Math.abs(Ee - rt.offset);
          ct < ke && (ke = ct, Fe = rt);
        }
        const Ue = Math.sign(Ve), it = we !== 0 && Ue !== 0 && Ue === we && Math.abs(Ve) >= nm;
        let Ke = Ee;
        if (it) {
          const rt = Ut(Se + we, 0, st.length - 1);
          if (rt !== Se) {
            const ct = st[rt];
            (we > 0 ? Ee < ct.offset : Ee > ct.offset) && (Fe = ct, Ke = ct.offset);
          } else if (we > 0)
            return Pe();
        }
        const Ye = Math.abs(Ke - O), Xe = Math.abs(Ke - Fe.offset);
        return Ye < Xe ? Pe() : (D?.(Fe.value, Ae), J(), !1);
      }
      if (Ve >= tm && de > 0)
        return Pe();
      let Oe = P[0], $e = Math.abs(Ee - Oe.offset);
      for (const st of P) {
        const Se = Math.abs(Ee - st.offset);
        Se < $e && ($e = Se, Oe = st);
      }
      return Math.abs(Ee - O) < $e ? Pe() : (D?.(Oe.value, Ae), J(), !1);
    },
    onDismiss(j) {
      h?.set({
        swipeProgress: 0,
        frontmostHeight: 0
      });
      const te = a.context.backdropRef.current;
      te && (te.style.setProperty(Ro.swipeProgress, "0"), te.style.removeProperty(Qt.height));
      const U = _e(Ys, j);
      if (a.setOpen(!1, U), U.isCanceled) {
        const Z = L.current;
        Z !== void 0 && D?.(Z, _e(Ys, j)), L.current = void 0, A.current?.(), J();
        return;
      }
      if (a.select("open")) {
        const Z = j;
        $.request(() => {
          if (a.select("open")) {
            const ue = L.current;
            ue !== void 0 && D?.(ue, _e(Ys, Z)), L.current = void 0, J(), A.current?.();
          } else
            L.current = void 0;
        });
        return;
      }
      L.current = void 0, X(!0);
    }
  }), se = oe.getPointerProps(), fe = oe.getTouchProps(), be = oe.reset;
  A.current = be, x.useEffect(() => {
    const j = w ?? R;
    if (!j)
      return;
    const te = j, U = et(te), Z = wt(U);
    function ue(pe) {
      if (K.current)
        return;
      const he = G.current, Ie = pe.touches[0];
      if (!Ie || !he)
        return;
      const ye = N ? Ie.clientY - he.lastY : Ie.clientX - he.lastX;
      if (p0(pe, Z)) {
        he.allowSwipe = !1, ir(he, Ie);
        return;
      }
      if (pe.touches.length === 2) {
        ir(he, Ie);
        return;
      }
      if (dm(U, te) || !b || !v || S) {
        ir(he, Ie);
        return;
      }
      if (_C(he, Ie, N)) {
        ir(he, Ie);
        return;
      }
      const de = he.scrollTarget;
      if (!de || de === U.documentElement || de === U.body) {
        pe.cancelable && pe.preventDefault(), ir(he, Ie);
        return;
      }
      if (!VC(de, E)) {
        pe.cancelable && pe.preventDefault(), ir(he, Ie);
        return;
      }
      const Me = ye;
      if (Me !== 0) {
        const Re = LC(de, E, c, Me);
        he.allowSwipe ? pe.cancelable && pe.preventDefault() : pe.cancelable && Re ? (he.allowSwipe = !0, pe.preventDefault()) : he.allowSwipe = !1;
      }
      ir(he, Ie);
    }
    return dt(U, "touchmove", ue, {
      passive: !1,
      capture: !0
    });
  }, [v, S, b, R, N, E, c, w]), x.useEffect(() => {
    if (!q || oe.swiping)
      return;
    Q({
      resolvedProgress: !b || C ? 0 : ee ?? 0,
      shouldTrackProgress: !0,
      notifyParent: !1
    });
  }, [Q, f, C, d, b, ee, q, oe.swiping, a, h]), x.useEffect(() => {
    if (d)
      return b || d(0), () => {
        d(0);
      };
  }, [d, b]), x.useEffect(() => {
    b && (be(), J());
  }, [J, b, be]), x.useEffect(() => () => {
    h?.set({
      swipeProgress: 0,
      frontmostHeight: 0
    }), am(a.context.backdropRef.current, !1), re();
  }, [re, a, h]);
  const le = x.useMemo(() => ({
    swiping: oe.swiping,
    getDragStyles: oe.getDragStyles,
    swipeStrength: V ?? null,
    setSwipeDismissed(j) {
      lm(a.context.popupRef.current, a.context.backdropRef.current, j);
    }
  }), [a, oe.getDragStyles, oe.swiping, V]);
  function me() {
    K.current = !1, G.current = null, z.current = "", H.current = !1;
  }
  return /* @__PURE__ */ g(yi, {
    ref: n,
    className: o,
    render: r,
    ...Jt(l, {
      onPointerDown(j) {
        if (z.current = j.pointerType, H.current = j.pointerType === "pen", !b || !v || S)
          return;
        const te = et(j.currentTarget), U = El(te, j.clientX, j.clientY);
        hc(U) || TC(U) || j.pointerType !== "touch" && se.onPointerDown?.(j);
      },
      onPointerMove(j) {
        j.pointerType !== "touch" && se.onPointerMove?.(j);
      },
      onPointerUp(j) {
        z.current === j.pointerType && (z.current = ""), j.pointerType !== "touch" && se.onPointerUp?.(j);
      },
      onPointerCancel(j) {
        z.current === j.pointerType && (z.current = ""), j.pointerType !== "touch" && se.onPointerCancel?.(j);
      },
      onTouchStart(j) {
        if (z.current === "pen" && H.current) {
          H.current = !1, K.current = !1, G.current = null;
          return;
        }
        if (!b || !v || S) {
          K.current = !1, G.current = null;
          return;
        }
        const U = j.touches[0];
        if (!U)
          return;
        if (fm(j)) {
          K.current = !1, G.current = null;
          return;
        }
        const Z = et(j.currentTarget), ue = El(Z, U.clientX, U.clientY);
        if (K.current = hc(ue), K.current) {
          G.current = null;
          return;
        }
        const pe = w ?? R, he = bt(j.nativeEvent), Ie = pt(he) ? he : null;
        if (pe && Ie && !He(pe, Ie)) {
          K.current = !0, G.current = null;
          return;
        }
        let ye = null, xe = !1;
        pe && Ie && (ye = $r(Ie, pe, E), xe = $r(Ie, pe, M) != null);
        let de = null;
        ye && (de = AC(ye, E, c) ? null : !1), G.current = {
          startX: U.clientX,
          startY: U.clientY,
          lastX: U.clientX,
          lastY: U.clientY,
          scrollTarget: ye,
          hasCrossAxisScrollableContent: xe,
          allowSwipe: de,
          preserveNativeCrossAxisScroll: !1
        }, fe.onTouchStart?.(j);
      },
      onTouchMove(j) {
        if (K.current || fm(j))
          return;
        const te = G.current;
        te?.preserveNativeCrossAxisScroll || te?.allowSwipe === !1 || te?.scrollTarget != null && !te.allowSwipe || fe.onTouchMove?.(j);
      },
      onTouchEnd(j) {
        me(), fe.onTouchEnd?.(j);
      },
      onTouchCancel(j) {
        me(), fe.onTouchCancel?.(j);
      },
      // Drawer popups use drawer-specific nested state attributes.
      // Suppress DialogViewport's generic nested dialog attribute.
      "data-nested-dialog-open": void 0
    }),
    children: /* @__PURE__ */ g(mf.Provider, {
      value: le,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (f0.displayName = "DrawerViewport");
function lm(t, e, n) {
  if (n) {
    t?.setAttribute(Un.swipeDismiss, ""), e?.setAttribute(Un.swipeDismiss, "");
    return;
  }
  t?.removeAttribute(Un.swipeDismiss), e?.removeAttribute(Un.swipeDismiss);
}
function am(t, e) {
  if (t) {
    if (e) {
      t.setAttribute(Un.swiping, "");
      return;
    }
    t.removeAttribute(Un.swiping);
  }
}
function hc(t) {
  return !!t?.closest(Th);
}
function TC(t) {
  return !!t?.closest(MC);
}
function cm(t, e) {
  const n = e === "left" || e === "right" ? t.offsetWidth : t.offsetHeight;
  return Math.max(n * 0.5, hu);
}
function um(t, e) {
  return t instanceof e.HTMLInputElement && t.type === "range";
}
function OC(t) {
  return pt(t) ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" : !1;
}
function DC(t, e) {
  const n = pt(t.anchorNode) ? t.anchorNode : t.anchorNode?.parentElement, o = pt(t.focusNode) ? t.focusNode : t.focusNode?.parentElement;
  return t.containsNode(e, !0) || He(e, n) || He(e, o);
}
function dm(t, e) {
  const n = Gt(t);
  if (!!(n && He(e, n)) && OC(n)) {
    const {
      selectionStart: i,
      selectionEnd: s
    } = n;
    if (i != null && s != null && i < s)
      return !0;
  }
  const r = t.getSelection?.();
  return !r || r.isCollapsed ? !1 : DC(r, e);
}
function p0(t, e) {
  const n = t.composedPath();
  return n ? n.some((o) => um(o, e)) : um(bt(t), e);
}
function fm(t) {
  return p0(t.nativeEvent, wt(t.currentTarget));
}
function ir(t, e) {
  t.lastX = e.clientX, t.lastY = e.clientY;
}
function _C(t, e, n) {
  if (t.preserveNativeCrossAxisScroll)
    return !0;
  if (t.allowSwipe === !0 || !t.hasCrossAxisScrollableContent)
    return !1;
  const o = n ? e.clientY - t.startY : e.clientX - t.startX, r = n ? e.clientX - t.startX : e.clientY - t.startY, i = Math.abs(o), s = Math.abs(r);
  return s < 6 || s <= i + 2 ? !1 : (t.preserveNativeCrossAxisScroll = !0, !0);
}
function VC(t, e) {
  return e === "vertical" ? t.scrollHeight > t.clientHeight : t.scrollWidth > t.clientWidth;
}
function m0(t, e) {
  if (e === "vertical") {
    const o = Math.max(0, t.scrollHeight - t.clientHeight);
    return {
      offset: t.scrollTop,
      max: o
    };
  }
  const n = Math.max(0, t.scrollWidth - t.clientWidth);
  return {
    offset: t.scrollLeft,
    max: n
  };
}
function AC(t, e, n) {
  const {
    offset: o,
    max: r
  } = m0(t, e), i = g0(n, e);
  return i === null ? !1 : i ? o <= 0 : o >= r;
}
function LC(t, e, n, o) {
  const {
    offset: r,
    max: i
  } = m0(t, e), s = g0(n, e);
  return s === null || !(s ? o > 0 : o < 0) ? !1 : s ? r <= 0 : r >= i;
}
function g0(t, e) {
  return e === "vertical" ? t === "down" ? !0 : t === "up" ? !1 : null : t === "right" ? !0 : t === "left" ? !1 : null;
}
const h0 = ho({
  responsive: !0,
  side: "right",
  isBottomSheet: !1
}), FC = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "transition-opacity", "duration-200", "data-ending-style:opacity-0", "data-starting-style:opacity-0"]), $C = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "flex", "pointer-events-none"], {
  variants: {
    side: {
      left: "justify-start",
      right: "justify-end"
    },
    isBottomSheet: {
      false: null,
      true: "items-end justify-center"
    },
    responsive: {
      false: null,
      true: "max-md:items-end max-md:justify-center"
    }
  }
}), HC = ae(["pointer-events-auto", "flex", "h-dvh", "max-h-dvh", "min-w-0", "flex-col", "overflow-hidden", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-4", "outline-none", "transition-transform", "duration-200", "ease-out"], {
  variants: {
    size: {
      default: ["[--drawer-size:640px]", "w-[min(100vw,var(--drawer-size))]"],
      small: ["[--drawer-size:560px]", "w-[min(100vw,var(--drawer-size))]"]
    },
    side: {
      left: ["data-ending-style:-translate-x-full", "data-starting-style:-translate-x-full"],
      right: ["data-ending-style:translate-x-full", "data-starting-style:translate-x-full"]
    },
    contentVariant: {
      default: null,
      navigation: "border-0"
    },
    isBottomSheet: {
      false: null,
      true: ["h-auto", "min-h-[230px]", "max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "w-full", "rounded-t-(--radius-sm)", "data-ending-style:translate-x-0", "data-ending-style:translate-y-full", "data-starting-style:translate-x-0", "data-starting-style:translate-y-full"]
    },
    responsive: {
      false: null,
      true: ["max-md:h-auto", "max-md:min-h-[230px]", "max-md:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-md:w-full", "max-md:rounded-t-(--radius-sm)", "max-md:data-ending-style:translate-x-0", "max-md:data-ending-style:translate-y-full", "max-md:data-starting-style:translate-x-0", "max-md:data-starting-style:translate-y-full"]
    }
  },
  defaultVariants: {
    size: "default"
  }
}), zC = ae(["flex", "min-h-0", "flex-1", "flex-col", "overflow-hidden", "bg-surface"], {
  variants: {
    variant: {
      default: ["gap-(--spacing-16)", "pt-(--spacing-10)"],
      navigation: ["gap-0", "pt-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), BC = ae(["flex", "shrink-0", "items-start", "justify-between", "gap-(--spacing-2)", "bg-surface", "mx-(--spacing-10)", "p-(--spacing-8)"]), WC = ae(["flex", "min-w-0", "flex-1", "items-start", "gap-(--spacing-8)"]), UC = ae(["flex", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-4)"]), GC = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), YC = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), jC = ae(["min-h-0", "flex-1", "overflow-y-auto", "px-(--spacing-20)", "max-md:pb-[env(safe-area-inset-bottom)]"]), KC = ae(["flex", "flex-col"], {
  variants: {
    gap: {
      none: "gap-0",
      md: "gap-(--spacing-20)"
    }
  },
  defaultVariants: {
    gap: "md"
  }
}), qC = ae(["flex", "min-h-(--spacing-80)", "shrink-0", "items-center", "justify-end", "gap-(--spacing-10)", "border-t", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)", "max-md:pb-[calc(var(--spacing-16)_+_env(safe-area-inset-bottom))]"]);
function ZC(t) {
  const e = B.c(19);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r, i, s;
  e[3] !== o ? ({
    side: i,
    responsive: s,
    ...r
  } = o, e[3] = o, e[4] = r, e[5] = i, e[6] = s) : (r = e[4], i = e[5], s = e[6]);
  const l = i === void 0 ? "right" : i, a = s === void 0 ? !0 : s;
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    defaultMatches: !1
  }, e[7] = c) : c = e[7];
  const u = Ns(ks.belowMd, c), d = a && u;
  let f;
  e[8] !== d || e[9] !== a || e[10] !== l ? (f = {
    responsive: a,
    side: l,
    isBottomSheet: d
  }, e[8] = d, e[9] = a, e[10] = l, e[11] = f) : f = e[11];
  const p = d ? "down" : l === "left" ? "left" : "right";
  let m;
  e[12] !== n || e[13] !== r || e[14] !== p ? (m = /* @__PURE__ */ g(mC, { modal: !0, swipeDirection: p, ...r, children: n }), e[12] = n, e[13] = r, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== f || e[17] !== m ? (h = /* @__PURE__ */ g(h0, { value: f, children: m }), e[16] = f, e[17] = m, e[18] = h) : h = e[18], h;
}
function nD(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(kC, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function XC(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(r0, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function QC(t) {
  const e = B.c(33);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    size: r,
    contentVariant: i,
    initialFocus: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "default" : i, a = s === void 0 ? !0 : s, c = Kt(), {
    responsive: u,
    side: d,
    isBottomSheet: f
  } = dn(h0);
  let p;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g(o0, { className: ne(FC()) }), e[6] = p) : p = e[6];
  let m;
  e[7] !== f || e[8] !== u || e[9] !== d ? (m = ne($C({
    responsive: u,
    side: d,
    isBottomSheet: f
  })), e[7] = f, e[8] = u, e[9] = d, e[10] = m) : m = e[10];
  let h;
  e[11] !== l || e[12] !== f || e[13] !== u || e[14] !== d || e[15] !== r ? (h = ne(HC({
    responsive: u,
    size: r,
    side: d,
    isBottomSheet: f,
    contentVariant: l
  })), e[11] = l, e[12] = f, e[13] = u, e[14] = d, e[15] = r, e[16] = h) : h = e[16];
  let b;
  e[17] !== l ? (b = ne(zC({
    variant: l
  })), e[17] = l, e[18] = b) : b = e[18];
  let v;
  e[19] !== n || e[20] !== b ? (v = /* @__PURE__ */ g(s0, { className: b, children: n }), e[19] = n, e[20] = b, e[21] = v) : v = e[21];
  let C;
  e[22] !== a || e[23] !== o || e[24] !== h || e[25] !== v ? (C = /* @__PURE__ */ g(u0, { "aria-modal": "true", initialFocus: a, className: h, ...o, children: v }), e[22] = a, e[23] = o, e[24] = h, e[25] = v, e[26] = C) : C = e[26];
  let y;
  e[27] !== m || e[28] !== C ? (y = /* @__PURE__ */ g(f0, { className: m, children: C }), e[27] = m, e[28] = C, e[29] = y) : y = e[29];
  let w;
  return e[30] !== c || e[31] !== y ? (w = /* @__PURE__ */ F(iC, { container: c, children: [
    p,
    y
  ] }), e[30] = c, e[31] = y, e[32] = w) : w = e[32], w;
}
function oD(t) {
  const e = B.c(36);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    title: a,
    subtitle: s,
    leadingIcon: r,
    accessory: n,
    actions: o,
    closeLabel: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "Close drawer" : l;
  let u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = ne(BC()), e[8] = u) : u = e[8];
  let d;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(WC()), e[9] = d) : d = e[9];
  let f;
  e[10] !== r ? (f = r && /* @__PURE__ */ g("span", { className: "mt-(--spacing-4) inline-flex shrink-0 text-icon-main", children: /* @__PURE__ */ g(We, { name: r, size: "sm", tone: "inherit" }) }), e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne(UC()), e[12] = p) : p = e[12];
  let m;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = ne(GC()), e[13] = m) : m = e[13];
  let h;
  e[14] !== a ? (h = /* @__PURE__ */ g(NC, { className: m, children: a }), e[14] = a, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-8)", children: [
    h,
    n
  ] }), e[16] = n, e[17] = h, e[18] = b) : b = e[18];
  let v;
  e[19] !== s ? (v = s && /* @__PURE__ */ g(eC, { className: ne(YC()), children: s }), e[19] = s, e[20] = v) : v = e[20];
  let C;
  e[21] !== b || e[22] !== v ? (C = /* @__PURE__ */ F("div", { className: p, children: [
    b,
    v
  ] }), e[21] = b, e[22] = v, e[23] = C) : C = e[23];
  let y;
  e[24] !== C || e[25] !== f ? (y = /* @__PURE__ */ F("div", { className: d, children: [
    f,
    C
  ] }), e[24] = C, e[25] = f, e[26] = y) : y = e[26];
  let w;
  e[27] !== c ? (w = /* @__PURE__ */ g(r0, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": c, variant: "ghost", size: "md" }) }), e[27] = c, e[28] = w) : w = e[28];
  let R;
  e[29] !== o || e[30] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-8)", children: [
    o,
    w
  ] }), e[29] = o, e[30] = w, e[31] = R) : R = e[31];
  let S;
  return e[32] !== i || e[33] !== y || e[34] !== R ? (S = /* @__PURE__ */ F("div", { className: u, ...i, children: [
    y,
    R
  ] }), e[32] = i, e[33] = y, e[34] = R, e[35] = S) : S = e[35], S;
}
function rD(t) {
  const e = B.c(13);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    gap: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(jC()), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = ne(KC({
    gap: o
  })), e[5] = o, e[6] = s) : s = e[6];
  let l;
  e[7] !== n || e[8] !== s ? (l = /* @__PURE__ */ g("div", { className: s, children: n }), e[7] = n, e[8] = s, e[9] = l) : l = e[9];
  let a;
  return e[10] !== r || e[11] !== l ? (a = /* @__PURE__ */ g("div", { className: i, ...r, children: l }), e[10] = r, e[11] = l, e[12] = a) : a = e[12], a;
}
function iD(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(qC()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const Ms = ho({
  collapsed: !1
});
function b0() {
  return dn(Ms);
}
const JC = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface", "border-r", "border-outline-subtle", "text-menu-text-default", "transition-[width]", "duration-200", "ease-in-out", "overflow-hidden"], {
  variants: {
    collapsed: {
      false: null,
      true: null
    },
    inAppShell: {
      false: null,
      true: ["relative", "z-10", "w-(--app-shell-sidebar-width)", "data-[hover-expanded]:w-(--app-shell-sidebar-expanded-width)"]
    }
  },
  compoundVariants: [{
    collapsed: !1,
    inAppShell: !1,
    className: "w-[260px]"
  }, {
    collapsed: !0,
    inAppShell: !1,
    className: "w-[72px]"
  }]
}), ew = ae("sticky bottom-0 z-10 mt-auto flex shrink-0 bg-surface", {
  variants: {
    collapsed: {
      false: "w-full",
      true: "w-(--spacing-40) justify-center"
    }
  }
}), hf = ae(["group/sidebar-item", "relative", "inline-flex", "items-center", "border-0", "rounded-[var(--radius-sm)]", "text-left", "no-underline", "outline-none", "select-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "font-[family-name:var(--font-family-label)]", "font-[number:var(--font-weight-medium)]", "text-[length:var(--font-size-label-large)]", "leading-[var(--font-line-height-24)]", "tracking-[var(--font-letter-spacing-default)]", "text-menu-icon-default", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "disabled:cursor-not-allowed", "disabled:opacity-50", "disabled:pointer-events-none"], {
  variants: {
    collapsed: {
      false: ["h-(--spacing-40)", "w-full", "min-w-0", "justify-between", "gap-[var(--spacing-8)]", "px-(--spacing-10)", "py-[var(--spacing-12)]"],
      true: ["size-(--spacing-40)", "justify-center", "p-(--spacing-10)"]
    },
    selected: {
      false: "bg-transparent",
      true: ["bg-menu-item-selected", "text-menu-text-default", "hover:bg-menu-item-selected"]
    },
    variant: {
      item: "",
      subItem: ""
    }
  },
  compoundVariants: [{
    selected: !0,
    variant: "item",
    className: ["before:absolute", "before:left-[-16px]", "before:top-1/2", "before:h-(--spacing-24)", "before:w-[2px]", "before:-translate-y-1/2", "before:bg-primary", "before:rounded-r-[2px]", "before:content-['']"]
  }]
}), tw = ae(["overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "opacity-100", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0", "transition-[height,opacity]", "duration-200", "ease-out", "motion-reduce:transition-none"]), nw = "flex size-(--icon-sm) shrink-0 items-center justify-center", ow = ["pointer-events-none", "absolute", "left-[-16px]", "top-1/2", "h-(--spacing-24)", "w-[2px]", "-translate-y-1/2", "rounded-r-[2px]", "bg-primary"].join(" ");
function sD(t) {
  const e = B.c(64);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    collapsed: a,
    "aria-label": c,
    children: n,
    onMouseEnter: i,
    onMouseLeave: s,
    mobileHeaderLeading: r,
    mobileHeaderActions: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = a === void 0 ? !1 : a, d = c === void 0 ? "Main navigation" : c, f = sf(), [p, m] = qe(!1), h = nt(!1), b = nt(!1), v = f?.desktopSidebarCollapsed ?? u, C = nt(v), y = f?.isMobile ?? !1, w = !y && v && !p;
  let R, S;
  e[9] !== v ? (R = () => {
    v ? !C.current && v && h.current && (b.current = !0, m(!1)) : (m(!1), b.current = !1), C.current = v;
  }, S = [v], e[9] = v, e[10] = R, e[11] = S) : (R = e[10], S = e[11]), Rt(R, S);
  let E;
  e[12] !== f || e[13] !== y ? (E = y ? () => f?.setMobileNavigationOpen(!1) : void 0, e[12] = f, e[13] = y, e[14] = E) : E = e[14];
  let N;
  e[15] !== w || e[16] !== E ? (N = {
    collapsed: w,
    closeMobileNavigation: E
  }, e[15] = w, e[16] = E, e[17] = N) : N = e[17];
  const M = w ? "" : void 0, T = p ? "" : void 0, P = !!f;
  let k;
  e[18] !== w || e[19] !== P ? (k = JC({
    collapsed: w,
    inAppShell: P
  }), e[18] = w, e[19] = P, e[20] = k) : k = e[20];
  const I = `${k}${y ? " w-full border-r-0" : ""}`;
  let D;
  e[21] !== i || e[22] !== v ? (D = (X) => {
    i?.(X), h.current = !0, v && !b.current && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget)) && m(!0);
  }, e[21] = i, e[22] = v, e[23] = D) : D = e[23];
  let O;
  e[24] !== s || e[25] !== v ? (O = (X) => {
    s?.(X), h.current = !1;
    const J = b.current;
    if (b.current = !1, v && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget))) {
      if (J) {
        m(!1);
        return;
      }
      m(!1);
    }
  }, e[24] = s, e[25] = v, e[26] = O) : O = e[26];
  let V;
  e[27] !== f || e[28] !== y ? (V = f && !y && /* @__PURE__ */ g("div", { className: "shrink-0 px-(--spacing-16) pt-(--spacing-24)", children: /* @__PURE__ */ g(Wx, {}) }), e[27] = f, e[28] = y, e[29] = V) : V = e[29];
  let _;
  e[30] !== n ? (_ = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto overscroll-contain", "data-slot": "sidebar-navigation", children: /* @__PURE__ */ g("div", { className: "flex min-h-full flex-col gap-(--spacing-8) px-(--spacing-16) py-(--spacing-16)", children: n }) }), e[30] = n, e[31] = _) : _ = e[31];
  let L;
  e[32] !== d || e[33] !== l || e[34] !== I || e[35] !== D || e[36] !== O || e[37] !== V || e[38] !== _ || e[39] !== M || e[40] !== T ? (L = /* @__PURE__ */ F("nav", { ...l, "aria-label": d, "data-collapsed": M, "data-hover-expanded": T, className: I, "data-slot": "sidebar", onMouseEnter: D, onMouseLeave: O, children: [
    V,
    _
  ] }), e[32] = d, e[33] = l, e[34] = I, e[35] = D, e[36] = O, e[37] = V, e[38] = _, e[39] = M, e[40] = T, e[41] = L) : L = e[41];
  let A;
  e[42] !== L || e[43] !== N ? (A = /* @__PURE__ */ g(Ms, { value: N, children: L }), e[42] = L, e[43] = N, e[44] = A) : A = e[44];
  const $ = A;
  if (!y || !f)
    return $;
  let Y;
  e[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = {
    width: "75vw"
  }, e[45] = Y) : Y = e[45];
  let z;
  e[46] !== r ? (z = /* @__PURE__ */ g("div", { className: "min-w-0", children: r }), e[46] = r, e[47] = z) : z = e[47];
  let H;
  e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ g(XC, { render: /* @__PURE__ */ g(gt, { "aria-label": "Close navigation", icon: "x-close", variant: "outline" }) }), e[48] = H) : H = e[48];
  let K;
  e[49] !== o ? (K = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-12)", children: [
    o,
    H
  ] }), e[49] = o, e[50] = K) : K = e[50];
  let G;
  e[51] !== z || e[52] !== K ? (G = /* @__PURE__ */ F("div", { className: "flex h-[68px] shrink-0 items-center justify-between gap-(--spacing-12) border-b border-outline-subtle bg-surface px-(--spacing-24)", children: [
    z,
    K
  ] }), e[51] = z, e[52] = K, e[53] = G) : G = e[53];
  let q;
  e[54] !== $ ? (q = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1", children: $ }), e[54] = $, e[55] = q) : q = e[55];
  let ee;
  e[56] !== d || e[57] !== G || e[58] !== q ? (ee = /* @__PURE__ */ F(QC, { "aria-label": d, contentVariant: "navigation", style: Y, children: [
    G,
    q
  ] }), e[56] = d, e[57] = G, e[58] = q, e[59] = ee) : ee = e[59];
  let W;
  return e[60] !== f.mobileNavigationOpen || e[61] !== f.setMobileNavigationOpen || e[62] !== ee ? (W = /* @__PURE__ */ g(ZC, { open: f.mobileNavigationOpen, onOpenChange: f.setMobileNavigationOpen, responsive: !1, side: "left", children: ee }), e[60] = f.mobileNavigationOpen, e[61] = f.setMobileNavigationOpen, e[62] = ee, e[63] = W) : W = e[63], W;
}
function lD(t) {
  const e = B.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    collapsed: r
  } = dn(Ms);
  let i;
  e[3] !== r ? (i = ew({
    collapsed: r
  }), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("div", { ...o, className: i, "data-slot": "sidebar-footer", children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function rw(t) {
  const e = B.c(6), {
    leading: n
  } = t;
  if (!n)
    return null;
  if (n.type === "icon") {
    let i;
    return e[0] !== n.name ? (i = /* @__PURE__ */ g(We, { name: n.name, size: "sm", tone: "inherit", "aria-hidden": !0, "data-slot": "sidebar-item-icon" }), e[0] = n.name, e[1] = i) : i = e[1], i;
  }
  const o = n.variant ?? "external";
  let r;
  return e[2] !== n.initials || e[3] !== n.src || e[4] !== o ? (r = /* @__PURE__ */ g(jr, { initials: n.initials, size: "xs", src: n.src, variant: o }), e[2] = n.initials, e[3] = n.src, e[4] = o, e[5] = r) : r = e[5], r;
}
function bf(t) {
  const e = B.c(21), {
    label: n,
    leading: o,
    badge: r,
    selected: i,
    variant: s,
    collapsed: l,
    trailing: a
  } = t, c = i === void 0 ? !1 : i, u = s === void 0 ? "item" : s;
  let d;
  e[0] !== o || e[1] !== c || e[2] !== u ? (d = u === "subItem" ? /* @__PURE__ */ g("span", { "aria-hidden": !0, className: nw, "data-slot": "sidebar-item-dot", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "relative z-[2] size-(--icon-sm)", viewBox: "0 0 20 20", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation item indicator" }),
    /* @__PURE__ */ g("circle", { className: c ? "fill-primary-on-container" : "fill-outline-subtle", cx: "10", cy: "10", "data-slot": "sidebar-item-dot-indicator", r: "2" })
  ] }) }) : /* @__PURE__ */ g(rw, { leading: o }), e[0] = o, e[1] = c, e[2] = u, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== n ? (f = !l && /* @__PURE__ */ g("span", { className: "min-w-0 truncate", "data-slot": "sidebar-item-label", title: n, children: n }), e[4] = l, e[5] = n, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-[var(--spacing-8)]", children: [
    d,
    f
  ] }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let m;
  e[10] !== r || e[11] !== l ? (m = !l && r && /* @__PURE__ */ g("span", { className: "ml-auto shrink-0", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(pu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[10] = r, e[11] = l, e[12] = m) : m = e[12];
  const h = !l && a;
  let b;
  e[13] !== r || e[14] !== l ? (b = l && r && /* @__PURE__ */ g("span", { className: "absolute right-(--spacing-2) top-(--spacing-2)", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(pu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[13] = r, e[14] = l, e[15] = b) : b = e[15];
  let v;
  return e[16] !== p || e[17] !== m || e[18] !== h || e[19] !== b ? (v = /* @__PURE__ */ F(Vt, { children: [
    p,
    m,
    h,
    b
  ] }), e[16] = p, e[17] = m, e[18] = h, e[19] = b, e[20] = v) : v = e[20], v;
}
function Nl(t) {
  const e = B.c(24), {
    collapsed: n,
    closeMobileNavigation: o
  } = dn(Ms);
  let r, i, s, l, a, c, u;
  if (e[0] !== o || e[1] !== n || e[2] !== t) {
    const {
      itemId: h,
      label: b,
      leading: v,
      selected: C,
      badge: y,
      tooltip: w,
      variant: R,
      collapsed: S,
      ...E
    } = t;
    i = b, u = w;
    const N = C === void 0 ? !1 : C, M = R === void 0 ? "item" : R;
    r = S === void 0 ? n : S;
    const T = hf({
      collapsed: r,
      selected: N,
      variant: M
    });
    let P;
    e[10] !== y || e[11] !== r || e[12] !== i || e[13] !== v || e[14] !== N || e[15] !== M ? (P = /* @__PURE__ */ g(bf, { label: i, leading: v, badge: y, selected: N, variant: M, collapsed: r }), e[10] = y, e[11] = r, e[12] = i, e[13] = v, e[14] = N, e[15] = M, e[16] = P) : P = e[16];
    const k = P, {
      render: I,
      href: D,
      target: O,
      rel: V,
      onClick: _,
      ...L
    } = E;
    if (D === void 0 && I === void 0)
      throw new Error("SidebarItem requires either an href or render prop.");
    const A = O === "_blank" && !V ? "noopener noreferrer" : V;
    c = Ra, s = "a", l = I, a = Jt(L, {
      ...D !== void 0 && {
        href: D
      },
      ...O !== void 0 && {
        target: O
      },
      ...A !== void 0 && {
        rel: A
      },
      onClick: ($) => {
        _?.($), o?.();
      },
      "data-sidebar-item": h,
      "aria-label": i,
      "aria-current": N ? "page" : void 0,
      className: T,
      children: k
    }), e[0] = o, e[1] = n, e[2] = t, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[17] !== s || e[18] !== l || e[19] !== a ? (d = {
    defaultTagName: s,
    render: l,
    props: a
  }, e[17] = s, e[18] = l, e[19] = a, e[20] = d) : d = e[20];
  const f = c(d);
  if (!r || u === !1)
    return f;
  const p = u ?? i;
  let m;
  return e[21] !== f || e[22] !== p ? (m = /* @__PURE__ */ g(qo, { label: p, side: "right", align: "center", children: f }), e[21] = f, e[22] = p, e[23] = m) : m = e[23], m;
}
function iw(t) {
  const e = B.c(34);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: i,
    leading: s,
    selected: c,
    badge: n,
    tooltip: u,
    collapsed: o,
    hasSelectedChild: r,
    open: l,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = c === void 0 ? !1 : c, f = d ? "page" : void 0;
  let p;
  e[10] !== o || e[11] !== d ? (p = hf({
    collapsed: o,
    selected: d,
    variant: "item"
  }), e[10] = o, e[11] = d, e[12] = p) : p = e[12];
  let m;
  e[13] !== r ? (m = r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: ow, "data-slot": "sidebar-group-current-indicator" }), e[13] = r, e[14] = m) : m = e[14];
  const h = l ? "chevron-up" : "chevron-down";
  let b;
  e[15] !== h ? (b = /* @__PURE__ */ g(We, { name: h, size: "xs", tone: "secondary", "aria-hidden": !0 }), e[15] = h, e[16] = b) : b = e[16];
  let v;
  e[17] !== n || e[18] !== o || e[19] !== i || e[20] !== s || e[21] !== d || e[22] !== b ? (v = /* @__PURE__ */ g(bf, { label: i, leading: s, badge: n, selected: d, collapsed: o, trailing: b }), e[17] = n, e[18] = o, e[19] = i, e[20] = s, e[21] = d, e[22] = b, e[23] = v) : v = e[23];
  let C;
  e[24] !== i || e[25] !== a || e[26] !== f || e[27] !== p || e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F("button", { ...a, "aria-label": i, "aria-current": f, className: p, type: "button", children: [
    m,
    v
  ] }), e[24] = i, e[25] = a, e[26] = f, e[27] = p, e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  const y = C;
  if (!o || u === !1)
    return y;
  const w = u ?? i;
  let R;
  return e[31] !== y || e[32] !== w ? (R = /* @__PURE__ */ g(qo, { label: w, side: "right", align: "center", children: y }), e[31] = y, e[32] = w, e[33] = R) : R = e[33], R;
}
function sw(t) {
  const e = B.c(3), {
    children: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "pointer-events-none absolute top-[24px] bottom-[20px] left-(--spacing-10) z-[1] w-(--icon-sm)", "data-slot": "sidebar-group-connector", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "size-full", preserveAspectRatio: "none", viewBox: "0 0 20 100", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation connector" }),
    /* @__PURE__ */ g("line", { className: "stroke-outline-subtle", vectorEffect: "non-scaling-stroke", x1: "10", x2: "10", y1: "0", y2: "100" })
  ] }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("div", { className: "relative flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-group-items", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function lw(t) {
  const e = B.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-static-group-items", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function aw(t) {
  const e = B.c(13), {
    label: n,
    leading: o,
    badge: r,
    tooltip: i,
    collapsed: s
  } = t;
  let l;
  e[0] !== s ? (l = hf({
    collapsed: s,
    selected: !1,
    variant: "item"
  }), e[0] = s, e[1] = l) : l = e[1];
  const a = `${l} !cursor-default hover:bg-transparent active:bg-transparent`;
  let c;
  e[2] !== r || e[3] !== s || e[4] !== n || e[5] !== o ? (c = /* @__PURE__ */ g(bf, { label: n, leading: o, badge: r, collapsed: s }), e[2] = r, e[3] = s, e[4] = n, e[5] = o, e[6] = c) : c = e[6];
  let u;
  e[7] !== a || e[8] !== c ? (u = /* @__PURE__ */ g("div", { className: a, children: c }), e[7] = a, e[8] = c, e[9] = u) : u = e[9];
  const d = u;
  if (!s || i === !1)
    return d;
  const f = i ?? n;
  let p;
  return e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ g(qo, { label: f, side: "right", align: "center", children: d }), e[10] = d, e[11] = f, e[12] = p) : p = e[12], p;
}
function pm(t) {
  const e = B.c(35), {
    itemId: n,
    label: o,
    leading: r,
    selected: i,
    hasSelectedChild: s,
    badge: l,
    tooltip: a,
    collapsed: c,
    collapsible: u,
    open: d,
    defaultOpen: f,
    onOpenChange: p,
    children: m
  } = t, h = i === void 0 ? !1 : i, b = s === void 0 ? !1 : s, v = u === void 0 ? !0 : u, C = f === void 0 ? !1 : f, {
    collapsed: y
  } = dn(Ms), w = c ?? y, [R, S] = qe(C), E = d !== void 0, N = E ? d : R;
  let M;
  e[0] !== E || e[1] !== p ? (M = function(L) {
    E || S(L), p?.(L);
  }, e[0] = E, e[1] = p, e[2] = M) : M = e[2];
  const T = M;
  let P;
  e[3] !== l || e[4] !== w || e[5] !== b || e[6] !== o || e[7] !== r || e[8] !== N || e[9] !== h || e[10] !== a ? (P = /* @__PURE__ */ g(iw, { label: o, leading: r, selected: h, hasSelectedChild: b, badge: l, tooltip: a, collapsed: w, open: N }), e[3] = l, e[4] = w, e[5] = b, e[6] = o, e[7] = r, e[8] = N, e[9] = h, e[10] = a, e[11] = P) : P = e[11];
  const k = P;
  if (!v) {
    let _;
    e[12] !== l || e[13] !== w || e[14] !== o || e[15] !== r || e[16] !== a ? (_ = /* @__PURE__ */ g(aw, { label: o, leading: r, badge: l, tooltip: a, collapsed: w }), e[12] = l, e[13] = w, e[14] = o, e[15] = r, e[16] = a, e[17] = _) : _ = e[17];
    let L;
    e[18] !== m ? (L = /* @__PURE__ */ g(lw, { children: m }), e[18] = m, e[19] = L) : L = e[19];
    let A;
    return e[20] !== n || e[21] !== _ || e[22] !== L ? (A = /* @__PURE__ */ F("div", { "data-sidebar-group": n, children: [
      _,
      L
    ] }), e[20] = n, e[21] = _, e[22] = L, e[23] = A) : A = e[23], A;
  }
  let I;
  e[24] !== k ? (I = /* @__PURE__ */ g(Gl, { render: k }), e[24] = k, e[25] = I) : I = e[25];
  let D;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = tw(), e[26] = D) : D = e[26];
  let O;
  e[27] !== m ? (O = /* @__PURE__ */ g(cf, { className: D, "data-slot": "sidebar-group-panel", children: /* @__PURE__ */ g(sw, { children: m }) }), e[27] = m, e[28] = O) : O = e[28];
  let V;
  return e[29] !== T || e[30] !== n || e[31] !== N || e[32] !== I || e[33] !== O ? (V = /* @__PURE__ */ F(af, { "data-sidebar-group": n, open: N, onOpenChange: T, children: [
    I,
    O
  ] }), e[29] = T, e[30] = n, e[31] = N, e[32] = I, e[33] = O, e[34] = V) : V = e[34], V;
}
const cw = ae(["@container/modal w-[min(calc(100vw_-_(var(--spacing-16)_*_2)),var(--modal-size))]", "max-w-(--modal-size)", "min-w-0", "max-h-[calc(100vh_-_var(--spacing-32))]", "flex flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5", "p-(--spacing-20)", "outline-none", "max-sm:min-h-[230px]", "max-sm:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-sm:w-full", "max-sm:max-w-none", "max-sm:rounded-b-none", "max-sm:pb-[calc(var(--spacing-20)_+_env(safe-area-inset-bottom))]"], {
  variants: {
    size: {
      sm: "[--modal-size:320px]",
      md: "[--modal-size:600px]",
      lg: "[--modal-size:1100px]"
    }
  }
}), uw = ae(["shrink-0 h-auto mt-(--spacing-20) flex gap-(--spacing-16)", "[&>*]:max-w-full [&>*]:h-auto [&>*]:min-h-(--spacing-40) [&>*]:min-w-0", "[&>*]:whitespace-normal [&>*]:[overflow-wrap:anywhere]", "[&>*]:flex-wrap", "[&_:is(button,a)]:max-w-full [&_:is(button,a)]:min-w-0 [&_:is(button,a)]:h-auto [&_:is(button,a)]:min-h-(--spacing-40)", "[&_:is(button,a)]:whitespace-normal [&_:is(button,a)]:[overflow-wrap:anywhere]", "@max-[480px]/modal:flex-col-reverse @max-[480px]/modal:items-stretch @max-[480px]/modal:[&>*]:w-full"], {
  variants: {
    size: {
      sm: "flex-col-reverse items-stretch [&>*]:w-full",
      md: "flex-wrap items-center justify-end",
      lg: "flex-wrap items-center justify-end"
    }
  }
}), dw = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), fw = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]);
function bu(t) {
  const e = B.c(37), {
    open: n,
    onOpenChange: o,
    title: r,
    description: i,
    dismissible: s,
    size: l,
    children: a,
    footer: c
  } = t, u = s === void 0 ? !0 : s, d = Kt(), f = l ?? "md";
  let p;
  e[0] !== u || e[1] !== o ? (p = (I, D) => {
    if (!u && !I && (D.reason === "escape-key" || D.reason === "outside-press")) {
      D.cancel();
      return;
    }
    o(I);
  }, e[0] = u, e[1] = o, e[2] = p) : p = e[2];
  const m = p, h = !u;
  let b;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(Ps, { className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }), e[3] = b) : b = e[3];
  let v;
  e[4] !== f ? (v = ne(cw({
    size: f
  })), e[4] = f, e[5] = v) : v = e[5];
  let C;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ne(dw()), e[6] = C) : C = e[6];
  let y;
  e[7] !== r ? (y = /* @__PURE__ */ g(ts, { className: C, children: r }), e[7] = r, e[8] = y) : y = e[8];
  let w;
  e[9] !== u ? (w = u && /* @__PURE__ */ g(Qr, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Close", variant: "ghost", size: "sm" }) }), e[9] = u, e[10] = w) : w = e[10];
  let R;
  e[11] !== y || e[12] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
    y,
    w
  ] }), e[11] = y, e[12] = w, e[13] = R) : R = e[13];
  let S;
  e[14] !== i ? (S = i && /* @__PURE__ */ g(es, { className: ne(fw()), children: i }), e[14] = i, e[15] = S) : S = e[15];
  let E;
  e[16] !== S || e[17] !== R ? (E = /* @__PURE__ */ F("div", { className: "shrink-0 flex flex-col gap-(--spacing-6)", children: [
    R,
    S
  ] }), e[16] = S, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== a ? (N = a && /* @__PURE__ */ g("div", { className: "min-h-0 mt-(--spacing-20) overflow-y-auto", children: a }), e[19] = a, e[20] = N) : N = e[20];
  let M;
  e[21] !== c || e[22] !== f ? (M = c && /* @__PURE__ */ g("div", { className: ne(uw({
    size: f
  })), children: c }), e[21] = c, e[22] = f, e[23] = M) : M = e[23];
  let T;
  e[24] !== E || e[25] !== N || e[26] !== M || e[27] !== v ? (T = /* @__PURE__ */ g(yi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-center justify-center max-sm:items-end", children: /* @__PURE__ */ F(bi, { "aria-modal": "true", className: v, children: [
    E,
    N,
    M
  ] }) }), e[24] = E, e[25] = N, e[26] = M, e[27] = v, e[28] = T) : T = e[28];
  let P;
  e[29] !== d || e[30] !== T ? (P = /* @__PURE__ */ F(Dr, { container: d, children: [
    b,
    T
  ] }), e[29] = d, e[30] = T, e[31] = P) : P = e[31];
  let k;
  return e[32] !== m || e[33] !== n || e[34] !== P || e[35] !== h ? (k = /* @__PURE__ */ g(vi, { open: n, onOpenChange: m, modal: !0, disablePointerDismissal: h, children: P }), e[32] = m, e[33] = n, e[34] = P, e[35] = h, e[36] = k) : k = e[36], k;
}
function pw() {
  if (typeof document > "u") return null;
  const t = document.getElementById("aw-local-development-context")?.textContent;
  if (!t) return null;
  try {
    const e = JSON.parse(t);
    return !e || typeof e != "object" || !("appName" in e) || typeof e.appName != "string" || !("branch" in e) || typeof e.branch != "string" || !("worktree" in e) || typeof e.worktree != "string" || !("worktreePath" in e) || typeof e.worktreePath != "string" || !("apiTargets" in e) || !Array.isArray(e.apiTargets) || !e.apiTargets.every((n) => typeof n == "string") ? null : e;
  } catch {
    return null;
  }
}
function mw(t) {
  return [`App: ${t.appName}`, `Branch: ${t.branch}`, `Worktree: ${t.worktreePath}`, `Frontend: ${window.location.origin}`, `API targets: ${t.apiTargets.join(", ") || "No local proxy configured"}`, "Frontend checkout and API code are independent; worktree frontends may share a backend."].join(`
`);
}
function gw() {
  const t = B.c(15), [e, n] = qe(!1), [o, r] = qe("");
  let i, s, l, a;
  if (t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    l = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      if (i = pw(), !i) {
        l = null;
        break e;
      }
      a = ["brand", "informative", "positive", "warning"], s = Array.from(i.worktreePath).reduce(bw, 0);
    }
    t[0] = i, t[1] = s, t[2] = l, t[3] = a;
  } else
    i = t[0], s = t[1], l = t[2], a = t[3];
  if (l !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return l;
  const u = a[s % a.length];
  let d;
  t[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = async function() {
    try {
      if (!i)
        return;
      await navigator.clipboard.writeText(mw(i)), r("Copied");
    } catch {
      r("Could not copy. Select the details to copy manually.");
    }
  }, t[4] = d) : d = t[4];
  const f = d;
  let p;
  t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ F(tn, { variant: "ghost", size: "sm", "aria-label": `Local development context: ${i.appName}, ${i.worktree}`, onClick: () => {
    r(""), n(!0);
  }, children: [
    /* @__PURE__ */ g(Ln, { tone: u, label: "LOCAL" }),
    /* @__PURE__ */ F("span", { className: "hidden max-w-[160px] truncate sm:inline min-[1200px]:max-w-[240px]", children: [
      i.appName,
      " · ",
      i.worktree
    ] })
  ] }), t[5] = p) : p = t[5];
  let m;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", icon: "copy-regular", disabled: !navigator.clipboard?.writeText, onClick: () => {
    f();
  }, children: "Copy context" }), t[6] = m) : m = t[6];
  let h;
  t[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ F("dl", { className: "grid min-w-0 grid-cols-[auto_minmax(0,1fr)] gap-x-(--spacing-16) gap-y-(--spacing-8) text-(length:--font-size-body-medium) text-text-default [&>dd]:break-words", children: [
    /* @__PURE__ */ g("dt", { children: "App" }),
    /* @__PURE__ */ g("dd", { children: i.appName }),
    /* @__PURE__ */ g("dt", { children: "Branch" }),
    /* @__PURE__ */ g("dd", { children: i.branch }),
    /* @__PURE__ */ g("dt", { children: "Worktree" }),
    /* @__PURE__ */ g("dd", { children: i.worktreePath }),
    /* @__PURE__ */ g("dt", { children: "Frontend" }),
    /* @__PURE__ */ g("dd", { children: window.location.origin }),
    /* @__PURE__ */ g("dt", { children: "API targets" }),
    /* @__PURE__ */ g("dd", { children: i.apiTargets.length ? i.apiTargets.map(hw) : "No local proxy configured; check the app’s API configuration." })
  ] }), t[7] = h) : h = t[7];
  let b;
  t[8] !== o ? (b = o && /* @__PURE__ */ g(nn, { size: "sm", role: "status", children: o }), t[8] = o, t[9] = b) : b = t[9];
  let v;
  t[10] !== b ? (v = /* @__PURE__ */ F(Zo, { children: [
    h,
    b
  ] }), t[10] = b, t[11] = v) : v = t[11];
  let C;
  return t[12] !== e || t[13] !== v ? (C = /* @__PURE__ */ F(Vt, { children: [
    p,
    /* @__PURE__ */ g(bu, { open: e, onOpenChange: n, title: "Local development context", description: "Frontend checkout and API code are independent. Worktree frontends may share a backend.", footer: m, children: v })
  ] }), t[12] = e, t[13] = v, t[14] = C) : C = t[14], C;
}
function hw(t) {
  return /* @__PURE__ */ g("div", { children: t }, t);
}
function bw(t, e) {
  return t + e.charCodeAt(0);
}
const vw = ["flex", "h-(--spacing-64)", "w-full", "items-center", "bg-surface", "border-b", "border-outline-subtle", "max-sm:h-[68px]"], yw = ["flex", "h-full", "min-w-0", "shrink-0", "transition-[width]", "duration-200", "ease-in-out", "items-center", "border-r", "border-outline-subtle", "px-(--spacing-16)", "max-sm:border-r-0", "max-sm:px-(--spacing-24)"], xw = ["hidden", "h-full", "min-w-0", "flex-1", "items-center", "overflow-hidden", "px-(--spacing-24)", "sm:flex"], Cw = ["ml-auto", "flex", "h-full", "shrink-0", "items-center", "gap-(--spacing-12)", "pr-(--spacing-24)", "max-sm:gap-(--spacing-20)"];
function aD(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = vw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { ...o, className: r, "data-slot": "top-bar", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function cD(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = yw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-leading", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function uD(t) {
  const e = B.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = xw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-content", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function dD(t) {
  const e = B.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Cw.join(" "), e[3] = r) : r = e[3];
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ g(gw, {}), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ F("div", { ...o, className: r, "data-slot": "top-bar-actions", children: [
    i,
    n
  ] }), e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
const ww = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface"]), Sw = ae(["flex", "w-full", "min-w-0", "flex-col", "gap-(--spacing-4)", "rounded-(--radius-sm)", "px-0", "py-(--spacing-4)", "text-left", "cursor-pointer", "hover:bg-surface-hover", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring"], {
  variants: {
    active: {
      true: "bg-surface-container",
      false: null
    }
  },
  defaultVariants: {
    active: !1
  }
});
function v0(t) {
  const e = B.c(17), {
    conversations: n,
    activeConversationId: o,
    onSelectConversation: r
  } = t;
  let i, s, l, a, c;
  if (e[0] !== o || e[1] !== n || e[2] !== r) {
    const f = n.reduce(Rw, {});
    l = "assistant-chat-sidebar-content", a = "flex h-full min-h-0 flex-1 flex-col", e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("div", { className: "px-(--spacing-12) max-sm:px-(--spacing-20)", children: /* @__PURE__ */ g(fo, { size: "lg", children: "Chat History" }) }), e[8] = c) : c = e[8], i = "min-h-0 flex-1 overflow-y-auto px-(--spacing-12) pt-(--spacing-16)", s = n.length === 0 ? /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-center gap-(--spacing-12) px-(--spacing-12) text-center", children: [
      /* @__PURE__ */ g(We, { name: "message", size: "md", tone: "secondary", "aria-hidden": !0 }),
      /* @__PURE__ */ g(nn, { tone: "subtle", children: "Your chat history will appear here" })
    ] }) : Object.entries(f).map((p) => {
      const [m, h] = p;
      return /* @__PURE__ */ F("section", { className: "mb-(--spacing-16)", children: [
        /* @__PURE__ */ g("div", { className: "px-(--spacing-8)", children: /* @__PURE__ */ g(fo, { size: "sm", tone: "subtle", children: m }) }),
        /* @__PURE__ */ g("div", { className: "mt-(--spacing-10) flex flex-col gap-(--spacing-4) px-(--spacing-8)", children: h.map((b) => /* @__PURE__ */ F("button", { type: "button", "aria-current": b.id === o ? "page" : void 0, className: Sw({
          active: b.id === o
        }), onClick: () => r(b.id), children: [
          /* @__PURE__ */ F("span", { className: "flex items-start justify-between gap-(--spacing-8)", children: [
            /* @__PURE__ */ g("span", { className: "[&>span]:block min-w-0 flex-1 [&>span]:leading-(--font-line-height-20)", children: /* @__PURE__ */ g(wn, { as: "span", size: "sm", truncate: !0, children: b.title }) }),
            b.timestamp ? /* @__PURE__ */ g("span", { className: "shrink-0 whitespace-nowrap", children: /* @__PURE__ */ g(nn, { as: "span", size: "sm", tone: "subtle", children: b.timestamp }) }) : null
          ] }),
          b.preview ? /* @__PURE__ */ g(nn, { as: "span", size: "sm", tone: "subtle", truncate: !0, children: b.preview }) : null
        ] }, b.id)) })
      ] }, m);
    }), e[0] = o, e[1] = n, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a, e[7] = c;
  } else
    i = e[3], s = e[4], l = e[5], a = e[6], c = e[7];
  let u;
  e[9] !== i || e[10] !== s ? (u = /* @__PURE__ */ g("div", { className: i, children: s }), e[9] = i, e[10] = s, e[11] = u) : u = e[11];
  let d;
  return e[12] !== l || e[13] !== a || e[14] !== c || e[15] !== u ? (d = /* @__PURE__ */ F("div", { "data-slot": l, className: a, children: [
    c,
    u
  ] }), e[12] = l, e[13] = a, e[14] = c, e[15] = u, e[16] = d) : d = e[16], d;
}
function Rw(t, e) {
  const n = e.groupLabel ?? "Conversations", o = t[n] ?? [];
  return o.push(e), t[n] = o, t;
}
function Ew(t) {
  const e = B.c(20), {
    conversations: n,
    activeConversationId: o,
    collapsed: r,
    onNewConversation: i,
    isNewConversationDisabled: s,
    onSelectConversation: l,
    onToggle: a,
    collapseDirection: c,
    badge: u,
    newConversationLabel: d
  } = t, f = r === void 0 ? !1 : r, p = s === void 0 ? !1 : s, m = d === void 0 ? "New chat" : d;
  let h;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = ww(), e[0] = h) : h = e[0];
  let b;
  e[1] !== u || e[2] !== c || e[3] !== f || e[4] !== a ? (b = f ? null : /* @__PURE__ */ g("div", { className: "h-[72px] pb-(--spacing-8) pl-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ g(Lp, { badge: u, sidebar: "expanded", children: /* @__PURE__ */ g(mu, { collapsed: !1, collapseDirection: c, onToggle: a }) }) }), e[1] = u, e[2] = c, e[3] = f, e[4] = a, e[5] = b) : b = e[5];
  let v;
  e[6] !== o || e[7] !== u || e[8] !== c || e[9] !== f || e[10] !== n || e[11] !== p || e[12] !== m || e[13] !== i || e[14] !== l || e[15] !== a ? (v = f ? /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto px-(--spacing-4) pb-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-between", children: [
    /* @__PURE__ */ g(Lp, { badge: u, sidebar: "collapsed", children: /* @__PURE__ */ g(mu, { collapsed: !0, collapseDirection: c, onToggle: a }) }),
    /* @__PURE__ */ g("div", { className: "flex size-(--spacing-48) items-center justify-center", children: /* @__PURE__ */ g(gt, { icon: "edit-pen", variant: "outline", size: "md", "aria-label": m, onClick: i, disabled: p }) })
  ] }) }) : /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ g(v0, { conversations: n, activeConversationId: o, onSelectConversation: l }),
    /* @__PURE__ */ g("div", { className: "mt-auto px-(--spacing-12) pb-(--spacing-24) pt-(--spacing-12)", children: /* @__PURE__ */ g(tn, { variant: "outline", size: "md", icon: "edit-pen", fullWidth: !0, onClick: i, disabled: p, children: m }) })
  ] }), e[6] = o, e[7] = u, e[8] = c, e[9] = f, e[10] = n, e[11] = p, e[12] = m, e[13] = i, e[14] = l, e[15] = a, e[16] = v) : v = e[16];
  let C;
  return e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-sidebar", className: h, children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19], C;
}
const mm = ne("relative", "flex", "flex-col", "items-start", "w-full", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"), bc = {
  none: "p-0",
  compact: "p-(--spacing-12)",
  comfortable: "px-(--spacing-20) py-(--spacing-16)"
}, Nw = ne("flex", "w-full", "items-stretch", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:rounded-r-none", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:rounded-none", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:last-child:not(:first-child)>[data-slot=card]]:rounded-l-none"), kw = ne("flex", "min-w-0", "flex-1", "[&>[data-slot=card]]:h-full"), Iw = ne("cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "text-left", "hover:bg-surface-hover", "active:bg-surface-container-highest", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"), Pw = ne("has-[[data-slot=card-link]]:isolate", "has-[[data-slot=card-link]]:cursor-pointer", "has-[[data-slot=card-link]]:transition-colors", "has-[[data-slot=card-link]]:hover:bg-surface-hover", "has-[[data-slot=card-link]:active]:bg-surface-container-highest", "has-[[data-slot=card-link]:focus-visible]:ring-2", "has-[[data-slot=card-link]:focus-visible]:ring-button-focus-ring", "has-[[data-slot=card-link]:focus-visible]:ring-offset-1", "has-[[data-slot=card-link]:focus-visible]:ring-offset-surface", "has-[[data-slot=card-link]]:[&_:is(button,a:not([data-slot=card-link]),input,select,textarea,summary,[role=button],[role=link])]:relative", "has-[[data-slot=card-link]]:[&_:is(button,a:not([data-slot=card-link]),input,select,textarea,summary,[role=button],[role=link])]:z-20"), Mw = ne("flex", "w-full", "flex-col", "items-start", "overflow-hidden", "rounded-(--radius-sm)"), Tw = {
  brand: "bg-primary",
  positive: "bg-positive",
  warning: "bg-accessibility-warning",
  negative: "bg-negative",
  informative: "bg-informative"
};
function Ow(t) {
  const e = B.c(4), {
    tone: n
  } = t, o = Tw[n];
  let r;
  e[0] !== o ? (r = ne("pointer-events-none absolute -top-px -left-px -right-px z-10 h-(--spacing-8) rounded-tl-(--radius-sm) rounded-tr-(--radius-sm)", o), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-border-fill", className: r }), e[2] = r, e[3] = i) : i = e[3], i;
}
function y0(t) {
  return Jl(t) && t.type === Ow;
}
function fD(t) {
  const e = B.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { "data-slot": "card-image-slot", className: "w-full shrink-0 overflow-hidden", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function pD(t) {
  const e = B.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = Ql.map(n, Dw), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-group", className: Nw, ...o, children: r }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function Dw(t) {
  return /* @__PURE__ */ g("div", { "data-slot": "card-group-item", className: kw, children: t });
}
function vr(t) {
  const e = B.c(26);
  let n, o, r, i, s, l, a;
  if (e[0] !== t) {
    a = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        children: m,
        fillHeight: h,
        padding: b,
        ...v
      } = t;
      l = v;
      const C = h === void 0 ? !1 : h;
      s = b === void 0 ? "comfortable" : b;
      let y;
      if (e[8] !== m) {
        const S = Ql.toArray(m);
        n = S.filter(y0), r = n.length > 0, y = S.filter(_w), e[8] = m, e[9] = n, e[10] = r, e[11] = y;
      } else
        n = e[9], r = e[10], y = e[11];
      const w = y;
      let R;
      if (e[12] !== m || e[13] !== w || e[14] !== r || e[15] !== s ? (R = r ? /* @__PURE__ */ g("div", { "data-slot": "card-content", className: ne(Mw, bc[s]), children: w }) : m, e[12] = m, e[13] = w, e[14] = r, e[15] = s, e[16] = R) : R = e[16], o = R, i = C ? "h-full" : null, "onClick" in l && l.onClick !== void 0) {
        const {
          onClick: S,
          disabled: E,
          ...N
        } = l;
        a = /* @__PURE__ */ F(Qn, { "data-slot": "card", className: ne(mm, r ? "overflow-visible" : "overflow-hidden", !r && bc[s], i, Iw, E && "opacity-50 pointer-events-none"), onClick: S, disabled: E, "aria-disabled": E || void 0, ...N, children: [
          n,
          o
        ] });
        break e;
      }
    }
    e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7];
  if (a !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return a;
  const c = r ? "overflow-visible" : "overflow-hidden", u = !r && bc[s];
  let d;
  e[17] !== i || e[18] !== c || e[19] !== u ? (d = ne(mm, c, u, i, Pw), e[17] = i, e[18] = c, e[19] = u, e[20] = d) : d = e[20];
  const f = l;
  let p;
  return e[21] !== n || e[22] !== o || e[23] !== d || e[24] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "card", className: d, ...f, children: [
    n,
    o
  ] }), e[21] = n, e[22] = o, e[23] = d, e[24] = f, e[25] = p) : p = e[25], p;
}
function _w(t) {
  return !y0(t);
}
function mD(t) {
  const e = B.c(9);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Ra, n = "a", o = l, r = Jt(a, {
      "data-slot": "card-link",
      className: "text-left outline-none after:absolute after:inset-0 after:z-10 after:rounded-(--radius-sm) after:content-['']"
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], i(s);
}
const Vw = ae(["grid", "w-full", "grid-cols-2", "gap-(--spacing-12)"]);
function gD(t) {
  const e = B.c(18), {
    title: n,
    description: o,
    templates: r,
    onSelectTemplate: i
  } = t;
  let s;
  e[0] !== n ? (s = /* @__PURE__ */ g("h2", { className: "text-center font-(family-name:--font-family-headline) text-(length:--font-size-title-xl) font-(number:--font-weight-semibold) leading-(--font-line-height-28) tracking-(--font-letter-spacing-default) text-text-default", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = o ? /* @__PURE__ */ g(nn, { tone: "subtle", children: o }) : null, e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== s || e[5] !== l ? (a = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-center gap-(--spacing-8) pt-(--spacing-12) text-center", children: [
    s,
    l
  ] }), e[4] = s, e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = Vw(), e[7] = c) : c = e[7];
  let u;
  if (e[8] !== i || e[9] !== r) {
    let p;
    e[11] !== i ? (p = (m) => /* @__PURE__ */ g(vr, { fillHeight: !0, padding: "none", "aria-label": m.title, onClick: () => i(m), children: /* @__PURE__ */ g("div", { className: "flex h-full w-full flex-col p-(--spacing-16)", children: m.content ?? /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-12)", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full items-start justify-between gap-(--spacing-12)", children: [
        /* @__PURE__ */ g("span", { className: "text-icon-main", children: m.icon ?? /* @__PURE__ */ g(We, { name: "sparkles", size: "md" }) }),
        m.action ? /* @__PURE__ */ g("span", { className: "shrink-0", children: m.action }) : null
      ] }),
      /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-col gap-(--spacing-4)", children: [
        /* @__PURE__ */ g(wn, { as: "h3", size: "xs", children: m.title }),
        m.description ? /* @__PURE__ */ g(nn, { size: "sm", tone: "subtle", children: m.description }) : null
      ] })
    ] }) }) }, m.id), e[11] = i, e[12] = p) : p = e[12], u = r.map(p), e[8] = i, e[9] = r, e[10] = u;
  } else
    u = e[10];
  let d;
  e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[13] = u, e[14] = d) : d = e[14];
  let f;
  return e[15] !== a || e[16] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-template-picker", className: "flex w-full max-w-[368px] flex-col items-center gap-(--spacing-20)", children: [
    a,
    d
  ] }), e[15] = a, e[16] = d, e[17] = f) : f = e[17], f;
}
function Aw(t) {
  const e = B.c(53), {
    message: n,
    renderMessageContent: o,
    feedback: r,
    feedbackProps: i,
    feedbackResetKey: s
  } = t;
  let l;
  e[0] !== n || e[1] !== o ? (l = o ? o(n) : n.content, e[0] = n, e[1] = o, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== i ? (c = i ?? {}, e[3] = i, e[4] = c) : c = e[4];
  const u = U2(c, s), d = n.role === "assistant" && r === void 0 && i !== void 0;
  let f;
  e[5] !== u || e[6] !== d ? (f = d && u.status === "idle" ? /* @__PURE__ */ g(G2, { feedbackState: u }) : null, e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  const p = f;
  let m;
  e[8] !== r || e[9] !== i || e[10] !== u || e[11] !== d ? (m = d ? u.status === "submitted" ? /* @__PURE__ */ g(j2, {}) : u.status === "idle" && u.isReasonsOpen ? /* @__PURE__ */ g(Y2, { feedbackState: u, allowWrittenFeedback: i.allowWrittenFeedback ?? !0, submitDisabled: i.onSubmit === void 0 }) : null : r, e[8] = r, e[9] = i, e[10] = u, e[11] = d, e[12] = m) : m = e[12];
  const h = m, b = n.role === "user";
  if (n.role === "system") {
    const D = typeof a == "string" || typeof a == "number";
    let O;
    e[13] !== a || e[14] !== D || e[15] !== n.statusTone ? (O = D ? /* @__PURE__ */ g(G5, { tone: n.statusTone ?? "informative", children: a }) : /* @__PURE__ */ g(nu, { tone: "system", children: a }), e[13] = a, e[14] = D, e[15] = n.statusTone, e[16] = O) : O = e[16];
    let V;
    e[17] !== n.actions ? (V = n.actions ? /* @__PURE__ */ g(z1, { children: n.actions }) : null, e[17] = n.actions, e[18] = V) : V = e[18];
    let _;
    return e[19] !== O || e[20] !== V ? (_ = /* @__PURE__ */ g(eu, { direction: "inbound", children: /* @__PURE__ */ F(tu, { children: [
      O,
      V
    ] }) }), e[19] = O, e[20] = V, e[21] = _) : _ = e[21], _;
  }
  const v = b ? "outbound" : "inbound";
  let C;
  e[22] !== b || e[23] !== n.avatar ? (C = b ? null : /* @__PURE__ */ g(Bg, { children: n.avatar ?? /* @__PURE__ */ g(jr, { variant: "ai", size: "md" }) }), e[22] = b, e[23] = n.avatar, e[24] = C) : C = e[24];
  const y = n.author ?? (b ? "You" : "Assistant");
  let w;
  e[25] !== y ? (w = /* @__PURE__ */ g(fo, { size: "lg", children: y }), e[25] = y, e[26] = w) : w = e[26];
  let R;
  e[27] !== n.timestamp ? (R = n.timestamp ? /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ g(fo, { size: "xs", tone: "subtle", children: "•" }),
    /* @__PURE__ */ g(fo, { size: "lg", tone: "subtle", children: n.timestamp })
  ] }) : null, e[27] = n.timestamp, e[28] = R) : R = e[28];
  let S;
  e[29] !== w || e[30] !== R ? (S = /* @__PURE__ */ F(Wg, { children: [
    w,
    R
  ] }), e[29] = w, e[30] = R, e[31] = S) : S = e[31];
  let E;
  e[32] !== a ? (E = /* @__PURE__ */ g(nu, { children: a }), e[32] = a, e[33] = E) : E = e[33];
  let N;
  e[34] !== p || e[35] !== n.actions ? (N = n.actions || p ? /* @__PURE__ */ g(z1, { children: /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-4)", children: [
    n.actions,
    p
  ] }) }) : null, e[34] = p, e[35] = n.actions, e[36] = N) : N = e[36];
  let M;
  e[37] !== S || e[38] !== E || e[39] !== N ? (M = /* @__PURE__ */ F(tu, { children: [
    S,
    E,
    N
  ] }), e[37] = S, e[38] = E, e[39] = N, e[40] = M) : M = e[40];
  let T;
  e[41] !== b ? (T = b ? null : /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "w-[28px] shrink-0" }), e[41] = b, e[42] = T) : T = e[42];
  let P;
  e[43] !== M || e[44] !== T || e[45] !== v || e[46] !== C ? (P = /* @__PURE__ */ F(eu, { direction: v, children: [
    C,
    M,
    T
  ] }), e[43] = M, e[44] = T, e[45] = v, e[46] = C, e[47] = P) : P = e[47];
  let k;
  e[48] !== h ? (k = h ? /* @__PURE__ */ g("div", { children: h }) : null, e[48] = h, e[49] = k) : k = e[49];
  let I;
  return e[50] !== P || e[51] !== k ? (I = /* @__PURE__ */ F("div", { className: "flex min-w-0 w-full flex-col gap-(--spacing-4)", children: [
    P,
    k
  ] }), e[50] = P, e[51] = k, e[52] = I) : I = e[52], I;
}
function gm(t) {
  const e = B.c(6), {
    messageId: n,
    scrollPosition: o
  } = t, {
    scrollToEnd: r,
    scrollToMessage: i
  } = Iu(), s = nt(n);
  let l, a;
  return e[0] !== n || e[1] !== o || e[2] !== r || e[3] !== i ? (l = () => {
    n && s.current !== n && (o === "end" ? r() : i(n, {
      align: "start"
    })), s.current = n;
  }, a = [n, o, r, i], e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = l, e[5] = a) : (l = e[4], a = e[5]), Rt(l, a), null;
}
function hD(t) {
  const e = B.c(114), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    conversations: i,
    activeConversationId: s,
    messages: l,
    isResponding: a,
    sidebar: c,
    templatePicker: u,
    feedback: d,
    feedbackRating: f,
    feedbackResetKey: p,
    conversationDate: m,
    minimized: h,
    onClose: b,
    onExpand: v,
    onMinimize: C,
    onSidebarToggle: y,
    sidebarBadge: w,
    collapseDirection: R,
    onNewConversation: S,
    onSelectConversation: E,
    onSendMessage: N,
    renderMessageContent: M,
    onSubmitFeedback: T,
    onRateResponse: P,
    composerProps: k
  } = t;
  let I;
  e[0] !== i ? (I = i === void 0 ? [] : i, e[0] = i, e[1] = I) : I = e[1];
  const D = I, O = a === void 0 ? !1 : a, V = h === void 0 ? !1 : h, _ = At();
  let L;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = {
    defaultMatches: !1
  }, e[2] = L) : L = e[2];
  const A = Ns(ks.belowSm, L), $ = V && !A, Y = l.length === 0, [z, H] = qe(!1), [K, G] = qe(0);
  let q;
  e[3] !== k?.initialValue ? (q = () => k?.initialValue ?? "", e[3] = k?.initialValue, e[4] = q) : q = e[4];
  const [ee, W] = qe(q), X = nt(s), J = nt(null), re = nt(null), Q = `${_}-conversation-date`, ie = `${_}-responding`;
  let ce;
  e[5] !== l ? (ce = [...l].reverse().find($w)?.id, e[5] = l, e[6] = ce) : ce = e[6];
  const oe = ce;
  let se;
  e[7] !== l ? (se = [...l].reverse().find(Fw)?.id, e[7] = l, e[8] = se) : se = e[8];
  const fe = se, be = p ?? `${s ?? "conversation"}:${fe ?? "response"}`;
  let le, me;
  e[9] !== A || e[10] !== c ? (me = () => {
    (!A || !c) && H(!1);
  }, le = [A, c], e[9] = A, e[10] = c, e[11] = le, e[12] = me) : (le = e[11], me = e[12]), Rt(me, le);
  let j, te;
  e[13] !== s ? (j = () => {
    X.current !== s && (W(""), X.current = s);
  }, te = [s], e[13] = s, e[14] = j, e[15] = te) : (j = e[14], te = e[15]), Rt(j, te);
  let U;
  e[16] !== A ? (U = () => {
    !A || re.current === null || (J.current?.focus(), re.current = null);
  }, e[16] = A, e[17] = U) : U = e[17], po(U);
  let Z;
  e[18] !== f || e[19] !== P || e[20] !== T ? (Z = T || P ? {
    rating: f,
    onRateResponse: P,
    onSubmit: T
  } : void 0, e[18] = f, e[19] = P, e[20] = T, e[21] = Z) : Z = e[21];
  const ue = Z;
  let pe;
  e[22] !== A || e[23] !== z || e[24] !== S ? (pe = () => {
    A && z && (re.current = "history"), H(!1), W(""), G(Lw), S?.();
  }, e[22] = A, e[23] = z, e[24] = S, e[25] = pe) : pe = e[25];
  const he = pe;
  let Ie;
  e[26] !== A || e[27] !== z || e[28] !== E ? (Ie = (Ye) => {
    A && z && (re.current = "history"), H(!1), E?.(Ye);
  }, e[26] = A, e[27] = z, e[28] = E, e[29] = Ie) : Ie = e[29];
  const ye = Ie;
  let xe;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = () => {
    re.current = "back", H(!0);
  }, e[30] = xe) : xe = e[30];
  const de = xe;
  let we;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (we = () => {
    re.current = "history", H(!1);
  }, e[31] = we) : we = e[31];
  const Me = we;
  let Re;
  e[32] !== s || e[33] !== D || e[34] !== A || e[35] !== Y || e[36] !== o || e[37] !== z || e[38] !== b || e[39] !== v || e[40] !== C || e[41] !== ye || e[42] !== c || e[43] !== he || e[44] !== n || e[45] !== r ? (Re = c && A ? /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: !z, children: /* @__PURE__ */ g(Ap, { children: /* @__PURE__ */ F(Fp, { children: [
    /* @__PURE__ */ g(dc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: he, isNewConversationDisabled: Y, onBack: Me, mobileHistoryControlRef: z ? J : void 0 }),
    /* @__PURE__ */ g($p, { children: /* @__PURE__ */ g("div", { className: "flex h-full min-h-0 flex-col pt-(--spacing-16)", children: /* @__PURE__ */ g(v0, { conversations: D, activeConversationId: s, onSelectConversation: ye }) }) })
  ] }) }) }) : null, e[32] = s, e[33] = D, e[34] = A, e[35] = Y, e[36] = o, e[37] = z, e[38] = b, e[39] = v, e[40] = C, e[41] = ye, e[42] = c, e[43] = he, e[44] = n, e[45] = r, e[46] = Re) : Re = e[46];
  const Ve = Re, je = $ || !!(c && A && z);
  let Ze;
  e[47] !== s || e[48] !== R || e[49] !== D || e[50] !== Y || e[51] !== y || e[52] !== ye || e[53] !== c || e[54] !== w || e[55] !== he ? (Ze = c ? /* @__PURE__ */ g(N7, { children: /* @__PURE__ */ g(Ew, { conversations: D, activeConversationId: s, collapsed: c === "collapsed", onNewConversation: he, isNewConversationDisabled: Y, onSelectConversation: ye, onToggle: y, collapseDirection: R, badge: w }) }) : null, e[47] = s, e[48] = R, e[49] = D, e[50] = Y, e[51] = y, e[52] = ye, e[53] = c, e[54] = w, e[55] = he, e[56] = Ze) : Ze = e[56];
  const ze = c ? he : void 0, Ee = c ? de : void 0, Ae = z ? void 0 : J;
  let Pe;
  e[57] !== Y || e[58] !== o || e[59] !== b || e[60] !== v || e[61] !== C || e[62] !== ze || e[63] !== Ee || e[64] !== Ae || e[65] !== n || e[66] !== r ? (Pe = /* @__PURE__ */ g(dc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: ze, isNewConversationDisabled: Y, onOpenHistory: Ee, mobileHistoryControlRef: Ae }), e[57] = Y, e[58] = o, e[59] = b, e[60] = v, e[61] = C, e[62] = ze, e[63] = Ee, e[64] = Ae, e[65] = n, e[66] = r, e[67] = Pe) : Pe = e[67];
  let Oe;
  e[68] !== ue || e[69] !== be || e[70] !== m || e[71] !== Q || e[72] !== d || e[73] !== O || e[74] !== fe || e[75] !== oe || e[76] !== l || e[77] !== M || e[78] !== ie || e[79] !== u ? (Oe = /* @__PURE__ */ g($p, { children: !O && l.length === 0 && u ? /* @__PURE__ */ F("div", { className: "relative h-full min-h-0", children: [
    /* @__PURE__ */ g("div", { className: "flex h-full min-h-0 flex-col items-center overflow-y-auto px-(--spacing-12) pb-[58px] pt-(--spacing-12)", children: u }),
    /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "pointer-events-none absolute inset-x-0 bottom-0 h-[58px] bg-gradient-to-b from-surface/0 to-surface" })
  ] }) : /* @__PURE__ */ F(Ug, { children: [
    /* @__PURE__ */ F(Gg, { "aria-label": "Conversation", children: [
      /* @__PURE__ */ F(Yg, { children: [
        m ? /* @__PURE__ */ g(Hi, { messageId: Q, children: /* @__PURE__ */ g("div", { className: "py-(--spacing-10)", children: /* @__PURE__ */ g(gr, { centeredText: m, emphasis: "high" }) }) }) : null,
        l.map((Ye) => /* @__PURE__ */ g(Hi, { messageId: Ye.id, children: /* @__PURE__ */ g(Aw, { message: Ye, renderMessageContent: M, feedback: Ye.id === fe ? d : void 0, feedbackProps: Ye.id === fe ? ue : void 0, feedbackResetKey: be }) }, Ye.id)),
        O ? /* @__PURE__ */ g(Hi, { messageId: ie, children: /* @__PURE__ */ g(I7, {}) }) : null
      ] }),
      /* @__PURE__ */ g(gm, { messageId: oe, scrollPosition: "end" }),
      /* @__PURE__ */ g(gm, { messageId: fe, scrollPosition: "start" })
    ] }),
    /* @__PURE__ */ g(jg, {})
  ] }) }), e[68] = ue, e[69] = be, e[70] = m, e[71] = Q, e[72] = d, e[73] = O, e[74] = fe, e[75] = oe, e[76] = l, e[77] = M, e[78] = ie, e[79] = u, e[80] = Oe) : Oe = e[80];
  const $e = `${s ?? "conversation"}:${K}`;
  let Te;
  e[81] !== k || e[82] !== ee || e[83] !== N || e[84] !== $e ? (Te = /* @__PURE__ */ g(k7, { children: /* @__PURE__ */ g("div", { className: "-mx-(--spacing-4) -mb-(--spacing-4)", children: /* @__PURE__ */ g(Nx, { ...k, autoFocus: !0, value: ee, onChange: W, onSendMessage: N }, $e) }) }), e[81] = k, e[82] = ee, e[83] = N, e[84] = $e, e[85] = Te) : Te = e[85];
  let vt;
  e[86] !== Pe || e[87] !== Oe || e[88] !== Te ? (vt = /* @__PURE__ */ F(Fp, { children: [
    Pe,
    Oe,
    Te
  ] }), e[86] = Pe, e[87] = Oe, e[88] = Te, e[89] = vt) : vt = e[89];
  let st;
  e[90] !== c || e[91] !== Ze || e[92] !== vt ? (st = /* @__PURE__ */ F(Ap, { sidebar: c, children: [
    Ze,
    vt
  ] }), e[90] = c, e[91] = Ze, e[92] = vt, e[93] = st) : st = e[93];
  let Se;
  e[94] !== je || e[95] !== st ? (Se = /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: je, children: st }), e[94] = je, e[95] = st, e[96] = Se) : Se = e[96];
  const ke = Se;
  let Fe;
  e[97] !== ke || e[98] !== Ve ? (Fe = /* @__PURE__ */ F(Vt, { children: [
    Ve,
    ke
  ] }), e[97] = ke, e[98] = Ve, e[99] = Fe) : Fe = e[99];
  const Ue = Fe;
  let it;
  e[100] !== Ue || e[101] !== $ ? (it = /* @__PURE__ */ g("div", { className: "contents", hidden: $, children: Ue }), e[100] = Ue, e[101] = $, e[102] = it) : it = e[102];
  let Ke;
  e[103] !== $ || e[104] !== o || e[105] !== b || e[106] !== v || e[107] !== C || e[108] !== n || e[109] !== r ? (Ke = $ ? /* @__PURE__ */ g(dc, { title: n, leadingAccessory: o, titleAccessory: r, minimized: !0, onClose: b, onMinimize: C, onExpand: v }) : null, e[103] = $, e[104] = o, e[105] = b, e[106] = v, e[107] = C, e[108] = n, e[109] = r, e[110] = Ke) : Ke = e[110];
  let ot;
  return e[111] !== it || e[112] !== Ke ? (ot = /* @__PURE__ */ F(Vt, { children: [
    it,
    Ke
  ] }), e[111] = it, e[112] = Ke, e[113] = ot) : ot = e[113], ot;
}
function Lw(t) {
  return t + 1;
}
function Fw(t) {
  return t.role === "assistant";
}
function $w(t) {
  return t.role === "user";
}
const Hw = ae(["fixed", "z-[var(--z-layer-assistant)]", "outline-none", "right-(--spacing-20)", "max-sm:right-(--spacing-12)", "max-sm:left-auto", "max-sm:top-[172px]", "max-sm:bottom-auto", "max-sm:m-0", "max-sm:h-[min(700px,calc(100dvh-188px))]", "max-sm:w-[min(350px,calc(100vw-var(--spacing-24)))]"], {
  variants: {
    minimized: {
      true: ["bottom-0", "w-[242px]"],
      false: ["bottom-(--spacing-12)", "h-[min(624px,calc(100dvh-var(--spacing-80)))]"]
    },
    sidebar: {
      expanded: null,
      collapsed: null
    }
  },
  compoundVariants: [{
    minimized: !1,
    sidebar: "expanded",
    class: "w-[634px]"
  }, {
    minimized: !1,
    sidebar: "collapsed",
    class: "w-[456px]"
  }],
  defaultVariants: {
    minimized: !1,
    sidebar: "collapsed"
  }
});
function bD(t) {
  const e = B.c(20), {
    open: n,
    onOpenChange: o,
    "aria-label": r,
    children: i,
    minimized: s,
    sidebar: l
  } = t, a = s === void 0 ? !1 : s, c = l === void 0 ? "collapsed" : l, u = Kt(), [d, f] = qe(n);
  let p;
  e[0] !== o ? (p = (R, S) => {
    const E = S?.reason === "outside-press" || S?.reason === "focus-out";
    if (!R && E) {
      S.cancel();
      return;
    }
    o(R);
  }, e[0] = o, e[1] = p) : p = e[1];
  const m = p;
  let h, b;
  e[2] !== n ? (h = () => {
    n && f(!0);
  }, b = [n], e[2] = n, e[3] = h, e[4] = b) : (h = e[3], b = e[4]), Rt(h, b);
  let v;
  e[5] !== a || e[6] !== c ? (v = Hw({
    minimized: a,
    sidebar: c
  }), e[5] = a, e[6] = c, e[7] = v) : v = e[7];
  let C;
  e[8] !== r || e[9] !== i || e[10] !== v ? (C = /* @__PURE__ */ g(bi, { "data-slot": "assistant-chat-dialog", "aria-label": r, className: v, children: i }), e[8] = r, e[9] = i, e[10] = v, e[11] = C) : C = e[11];
  let y;
  e[12] !== d || e[13] !== u || e[14] !== C ? (y = /* @__PURE__ */ g(Dr, { container: u, keepMounted: d, children: C }), e[12] = d, e[13] = u, e[14] = C, e[15] = y) : y = e[15];
  let w;
  return e[16] !== m || e[17] !== n || e[18] !== y ? (w = /* @__PURE__ */ g(vi, { open: n, onOpenChange: m, modal: !1, disablePointerDismissal: !0, children: y }), e[16] = m, e[17] = n, e[18] = y, e[19] = w) : w = e[19], w;
}
const zw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
};
function Bw(t) {
  const e = B.c(2), {
    count: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "flex w-[60px] items-center justify-center rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-6) font-(family-name:--font-family-title) font-(number:--font-weight-bold) text-(length:--font-size-headline-xsmall) leading-(--font-line-height-24) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function vD(t) {
  const e = B.c(40);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    count: r,
    actionItemName: n,
    priority: s,
    priorityLabel: l,
    buttonLabel: o,
    onButtonClick: i,
    style: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  let u;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    defaultMatches: !1
  }, e[9] = u) : u = e[9];
  const d = Ns(ks.belowSm, u);
  let f;
  e[10] !== c ? (f = {
    width: "100%",
    ...c
  }, e[10] = c, e[11] = f) : f = e[11];
  const p = f;
  let m;
  e[12] !== r ? (m = /* @__PURE__ */ g(Bw, { count: r }), e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== n ? (h = /* @__PURE__ */ g(wn, { size: "md", as: "h3", children: n }), e[14] = n, e[15] = h) : h = e[15];
  const b = zw[s];
  let v;
  e[16] !== l || e[17] !== b ? (v = /* @__PURE__ */ g(Ln, { tone: b, icon: "priority", label: l }), e[16] = l, e[17] = b, e[18] = v) : v = e[18];
  let C;
  e[19] !== m || e[20] !== h || e[21] !== v ? (C = /* @__PURE__ */ F(br, { gap: 12, align: "center", wrap: "nowrap", children: [
    m,
    h,
    v
  ] }), e[19] = m, e[20] = h, e[21] = v, e[22] = C) : C = e[22];
  let y;
  e[23] !== o || e[24] !== d || e[25] !== i ? (y = !d && /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", onClick: i, children: o }), e[23] = o, e[24] = d, e[25] = i, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(br, { justify: "between", align: "center", wrap: "nowrap", children: [
    C,
    y
  ] }) }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  if (d) {
    const E = `${o} ${n}`;
    let N;
    return e[30] !== p || e[31] !== R || e[32] !== i || e[33] !== a || e[34] !== E ? (N = /* @__PURE__ */ g(vr, { ...a, "aria-label": E, padding: "compact", style: p, onClick: i, children: R }), e[30] = p, e[31] = R, e[32] = i, e[33] = a, e[34] = E, e[35] = N) : N = e[35], N;
  }
  let S;
  return e[36] !== p || e[37] !== R || e[38] !== a ? (S = /* @__PURE__ */ g(vr, { ...a, padding: "compact", style: p, children: R }), e[36] = p, e[37] = R, e[38] = a, e[39] = S) : S = e[39], S;
}
const Ww = {
  positive: "text-positive",
  negative: "text-negative"
}, Uw = "text-text-subtle";
function x0(t) {
  const e = B.c(16), {
    label: n,
    showIcon: o
  } = t, r = o === void 0 ? !0 : o, {
    value: i
  } = t, s = i === void 0, l = !s && (!("tone" in t) || t.tone === void 0), a = s || l;
  let c = Uw, u = "trend-no-change", d = "sm";
  !a && t.tone && t.direction && (c = Ww[t.tone], u = t.direction === "up" ? "trend-up" : "trend-down", d = "md");
  const f = `inline-flex items-center gap-(--spacing-4) ${c}`;
  let p;
  e[0] !== u || e[1] !== d || e[2] !== s || e[3] !== r ? (p = r ? s ? /* @__PURE__ */ g("span", { className: "inline-block w-(--icon-sm) text-center font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: "--" }) : /* @__PURE__ */ g(We, { name: u, size: d, tone: "inherit" }) : null, e[0] = u, e[1] = d, e[2] = s, e[3] = r, e[4] = p) : p = e[4];
  let m;
  e[5] !== i ? (m = i ? /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: i }) : null, e[5] = i, e[6] = m) : m = e[6];
  let h;
  e[7] !== f || e[8] !== p || e[9] !== m ? (h = /* @__PURE__ */ F("span", { className: f, children: [
    p,
    m
  ] }), e[7] = f, e[8] = p, e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] !== n ? (b = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = b) : b = e[12];
  let v;
  return e[13] !== h || e[14] !== b ? (v = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-4)", children: [
    h,
    b
  ] }), e[13] = h, e[14] = b, e[15] = v) : v = e[15], v;
}
const Gw = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-title-lg)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "positive"
  }
});
function Yw(t) {
  const e = B.c(5), {
    value: n,
    tone: o
  } = t;
  let r;
  e[0] !== o ? (r = Gw({
    tone: o
  }), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r || e[3] !== n ? (i = /* @__PURE__ */ g("span", { className: r, children: n }), e[2] = r, e[3] = n, e[4] = i) : i = e[4], i;
}
function yD(t) {
  const e = B.c(26);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: o,
    value: l,
    tone: i,
    detail: n,
    trend: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== n ? (a = n ? /* @__PURE__ */ F("span", { className: "font-(number:--font-weight-semibold) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: [
    " ",
    n
  ] }) : null, e[7] = n, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== a ? (c = /* @__PURE__ */ F(wn, { size: "sm", as: "h3", children: [
    o,
    a
  ] }), e[9] = o, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== i || e[13] !== l ? (u = /* @__PURE__ */ g(Yw, { value: l, tone: i }), e[12] = i, e[13] = l, e[14] = u) : u = e[14];
  let d;
  e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(br, { justify: "between", align: "center", wrap: "nowrap", children: [
    c,
    u
  ] }), e[15] = c, e[16] = u, e[17] = d) : d = e[17];
  let f;
  e[18] !== s ? (f = s ? /* @__PURE__ */ g(x0, { ...s }) : null, e[18] = s, e[19] = f) : f = e[19];
  let p;
  e[20] !== d || e[21] !== f ? (p = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Zo, { gap: 8, children: [
    d,
    f
  ] }) }), e[20] = d, e[21] = f, e[22] = p) : p = e[22];
  let m;
  return e[23] !== r || e[24] !== p ? (m = /* @__PURE__ */ g(vr, { ...r, padding: "compact", children: p }), e[23] = r, e[24] = p, e[25] = m) : m = e[25], m;
}
const jw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
}, Kw = ae(["font-(family-name:--font-family-headline)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-headline-large)", "leading-(--font-line-height-40)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function qw(t) {
  const e = B.c(5), {
    value: n,
    tone: o
  } = t, r = o === void 0 ? "neutral" : o;
  let i;
  e[0] !== r ? (i = Kw({
    tone: r
  }), e[0] = r, e[1] = i) : i = e[1];
  let s;
  return e[2] !== i || e[3] !== n ? (s = /* @__PURE__ */ g("span", { className: i, children: n }), e[2] = i, e[3] = n, e[4] = s) : s = e[4], s;
}
function xD(t) {
  const e = B.c(43);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    label: r,
    value: f,
    tone: c,
    trend: d,
    supportingInfo: a,
    actionLabel: n,
    onActionClick: i,
    actionRender: o,
    priority: s,
    fillHeight: u,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "neutral" : c, m = u === void 0 ? !1 : u, h = m ? "flex h-full w-full flex-col justify-center" : "w-full";
  let b;
  e[12] !== r ? (b = /* @__PURE__ */ g(wn, { size: "md", as: "h3", truncate: !0, children: r }), e[12] = r, e[13] = b) : b = e[13];
  let v;
  e[14] !== n || e[15] !== o || e[16] !== i || e[17] !== s ? (v = n && (i || o) ? /* @__PURE__ */ g(gt, { render: o, variant: "outline", size: "sm", icon: "arrow-up-right", "aria-label": n, onClick: i }) : s ? /* @__PURE__ */ g(We, { name: "priority", size: "sm", tone: jw[s] }) : null, e[14] = n, e[15] = o, e[16] = i, e[17] = s, e[18] = v) : v = e[18];
  let C;
  e[19] !== b || e[20] !== v ? (C = /* @__PURE__ */ g("div", { className: "h-(--spacing-32)", children: /* @__PURE__ */ F(br, { justify: "between", align: "start", wrap: "nowrap", children: [
    b,
    v
  ] }) }), e[19] = b, e[20] = v, e[21] = C) : C = e[21];
  let y;
  e[22] !== p || e[23] !== f ? (y = /* @__PURE__ */ g(qw, { value: f, tone: p }), e[22] = p, e[23] = f, e[24] = y) : y = e[24];
  let w;
  e[25] !== d ? (w = d ? /* @__PURE__ */ g(x0, { ...d }) : null, e[25] = d, e[26] = w) : w = e[26];
  let R;
  e[27] !== a ? (R = a ? /* @__PURE__ */ g("div", { className: "w-full", children: a }) : null, e[27] = a, e[28] = R) : R = e[28];
  let S;
  e[29] !== y || e[30] !== w || e[31] !== R ? (S = /* @__PURE__ */ F(Zo, { gap: 6, children: [
    y,
    w,
    R
  ] }), e[29] = y, e[30] = w, e[31] = R, e[32] = S) : S = e[32];
  let E;
  e[33] !== S || e[34] !== C ? (E = /* @__PURE__ */ F(Zo, { gap: 12, children: [
    C,
    S
  ] }), e[33] = S, e[34] = C, e[35] = E) : E = e[35];
  let N;
  e[36] !== E || e[37] !== h ? (N = /* @__PURE__ */ g("div", { className: h, children: E }), e[36] = E, e[37] = h, e[38] = N) : N = e[38];
  let M;
  return e[39] !== m || e[40] !== l || e[41] !== N ? (M = /* @__PURE__ */ g(vr, { fillHeight: m, ...l, children: N }), e[39] = m, e[40] = l, e[41] = N, e[42] = M) : M = e[42], M;
}
function CD(t) {
  const e = B.c(41);
  let n;
  e[0] !== t.chipLabel || e[1] !== t.mpCount || e[2] !== t.mpCountLabel || e[3] !== t.variant ? (n = t.variant === "add" ? /* @__PURE__ */ g(Ln, { tone: "informative", label: t.chipLabel ?? "Recommended" }) : t.mpCount != null ? /* @__PURE__ */ g(Ln, { tone: "neutral", label: t.mpCountLabel ?? (t.mpCount === 1 ? "1 MP" : `${t.mpCount} MPs`) }) : null, e[0] = t.chipLabel, e[1] = t.mpCount, e[2] = t.mpCountLabel, e[3] = t.variant, e[4] = n) : n = e[4];
  const o = n, {
    serviceName: r,
    icon: i,
    variant: s,
    showIcon: l
  } = t, a = s === void 0 ? "default" : s, c = l === void 0 ? !0 : l;
  let u;
  e[5] !== i ? (u = /* @__PURE__ */ g(We, { name: i, size: "sm", tone: "neutral", "aria-hidden": !0 }), e[5] = i, e[6] = u) : u = e[6];
  let d;
  e[7] !== r ? (d = /* @__PURE__ */ g(wn, { size: "sm", as: "h3", children: r }), e[7] = r, e[8] = d) : d = e[8];
  let f;
  e[9] !== u || e[10] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-start gap-(--spacing-4)", children: [
    u,
    d
  ] }), e[9] = u, e[10] = d, e[11] = f) : f = e[11];
  let p;
  e[12] !== f || e[13] !== o ? (p = /* @__PURE__ */ F(br, { gap: 8, justify: "between", wrap: "wrap", align: "start", children: [
    f,
    o
  ] }), e[12] = f, e[13] = o, e[14] = p) : p = e[14];
  let m;
  e[15] !== a || e[16] !== c ? (m = a === "add" ? /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-center gap-(--spacing-10) border border-dashed border-outline-subtle bg-surface py-(--spacing-6)", children: [
    c ? /* @__PURE__ */ g(We, { name: "marketplace", size: "md", tone: "neutral", "aria-hidden": !0 }) : null,
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-24) text-text-default", children: "Add" })
  ] }) : null, e[15] = a, e[16] = c, e[17] = m) : m = e[17];
  let h;
  e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Zo, { gap: 12, children: [
    p,
    m
  ] }) }), e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  const b = h;
  if (t.onClick) {
    let R, S, E;
    if (e[21] !== t) {
      const {
        serviceName: T,
        icon: P,
        variant: k,
        chipLabel: I,
        mpCount: D,
        mpCountLabel: O,
        showIcon: V,
        onClick: _,
        style: L,
        ...A
      } = t;
      S = _, E = L, R = A, e[21] = t, e[22] = R, e[23] = S, e[24] = E;
    } else
      R = e[22], S = e[23], E = e[24];
    let N;
    e[25] !== E ? (N = {
      width: "100%",
      ...E
    }, e[25] = E, e[26] = N) : N = e[26];
    let M;
    return e[27] !== R || e[28] !== b || e[29] !== S || e[30] !== N ? (M = /* @__PURE__ */ g(vr, { ...R, onClick: S, padding: "compact", style: N, children: b }), e[27] = R, e[28] = b, e[29] = S, e[30] = N, e[31] = M) : M = e[31], M;
  }
  let v, C;
  if (e[32] !== t) {
    const {
      serviceName: R,
      icon: S,
      variant: E,
      chipLabel: N,
      mpCount: M,
      mpCountLabel: T,
      showIcon: P,
      onClick: k,
      style: I,
      ...D
    } = t;
    C = I, v = D, e[32] = t, e[33] = v, e[34] = C;
  } else
    v = e[33], C = e[34];
  let y;
  e[35] !== C ? (y = {
    width: "100%",
    ...C
  }, e[35] = C, e[36] = y) : y = e[36];
  let w;
  return e[37] !== b || e[38] !== v || e[39] !== y ? (w = /* @__PURE__ */ g(vr, { ...v, padding: "compact", style: y, children: b }), e[37] = b, e[38] = v, e[39] = y, e[40] = w) : w = e[40], w;
}
const Zw = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
function Xw() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "data-slot": "empty-state-pattern", "aria-hidden": "true", viewBox: "0 0 336 336", fill: "none", className: "pointer-events-none absolute top-1/2 left-1/2 size-[336px] max-w-none -translate-x-1/2 -translate-y-1/2 text-outline-subtle", children: /* @__PURE__ */ F("g", { stroke: "currentColor", children: [
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "167.5", strokeOpacity: "0" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "143.5", strokeOpacity: "0.04" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "119.5", strokeOpacity: "0.24" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "95.5", strokeOpacity: "0.48" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "71.5", strokeOpacity: "0.67" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "47.5", strokeOpacity: "0.88" })
  ] }) }), t[0] = e) : e = t[0], e;
}
function hm({
  icon: t,
  title: e,
  description: n,
  actions: o,
  headingLevel: r = 2,
  variant: i = "default",
  outlined: s = i === "compact",
  iconTone: l
}) {
  const a = Zw[r];
  return /* @__PURE__ */ F("section", { "data-slot": "empty-state", className: ne(i === "compact" ? "relative flex aspect-square w-full flex-col items-center justify-center gap-(--spacing-12) overflow-hidden" : "relative mx-auto flex w-full flex-col items-center overflow-hidden py-(--spacing-128)", i === "default" && !s && "max-w-[856px]", s && "rounded-(--radius-sm) border border-solid border-outline-subtle"), children: [
    i === "compact" ? /* @__PURE__ */ g("div", { className: `flex size-(--spacing-40) items-center justify-center rounded-full ${l === "negative" ? "bg-negative-container" : "bg-surface-container-low"}`, children: /* @__PURE__ */ g(We, { name: t, size: "xs", tone: l, "aria-hidden": !0 }) }) : /* @__PURE__ */ F("div", { className: "relative flex size-[48px] items-center justify-center", children: [
      /* @__PURE__ */ g(Xw, {}),
      /* @__PURE__ */ g("div", { className: "relative z-10", children: /* @__PURE__ */ g(We, { name: t, size: "md", "aria-hidden": !0 }) })
    ] }),
    /* @__PURE__ */ F("div", { className: i === "compact" ? "flex w-full flex-col items-center px-(--spacing-12) text-center" : "relative mt-(--spacing-20) flex w-full max-w-[500px] flex-col items-center px-(--spacing-32) text-center", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-6)", children: [
        /* @__PURE__ */ g(a, { className: i === "compact" ? "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default" : "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-24) text-text-default", children: e }),
        n ? /* @__PURE__ */ g("p", { className: i === "compact" ? "m-0 whitespace-pre-line font-(family-name:--font-family-title) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtle" : "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-subtle", children: n }) : null
      ] }),
      o ? /* @__PURE__ */ g("div", { className: i === "compact" ? "mt-(--spacing-20) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)" : "mt-(--spacing-32) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)", children: o }) : null
    ] })
  ] });
}
function Qw(t) {
  const e = B.c(6), {
    title: n,
    action: o,
    headingLevel: r
  } = t, s = `h${r === void 0 ? 2 : r}`;
  let l;
  e[0] !== s || e[1] !== n ? (l = /* @__PURE__ */ g(wn, { as: s, children: n }), e[0] = s, e[1] = n, e[2] = l) : l = e[2];
  let a;
  return e[3] !== o || e[4] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "section-header", className: "flex min-h-(--spacing-32) w-full items-center justify-between gap-(--spacing-12) leading-(--font-line-height-24)", children: [
    l,
    o
  ] }), e[3] = o, e[4] = l, e[5] = a) : a = e[5], a;
}
const Jw = {
  title: "Asset Gallery",
  viewAll: "View All",
  noImagesFound: "No Images Found",
  emptyDescription: "At least one image is required for every asset.",
  addImages: "Add Images",
  loadingError: "Loading Error",
  loadingErrorDescription: `We had a problem loading this media.
Try refreshing the page or checking back later.`,
  refresh: "Refresh"
};
function eS(t) {
  return JSON.stringify(t.map(({
    id: e,
    src: n
  }) => [e, n]));
}
function tS(t) {
  return Promise.all(t.map((e) => new Promise((n, o) => {
    const r = new Image();
    r.onload = () => n(), r.onerror = () => o(new Error(`Unable to load ${e}`)), r.src = e;
  }))).then(() => {
  });
}
function wD(t) {
  const e = B.c(35), {
    images: n,
    onViewAll: o,
    onAddImages: r,
    onRefresh: i,
    hasLoadingError: s,
    showThumbnails: l,
    labels: a
  } = t, c = s === void 0 ? !1 : s, u = l === void 0 ? !0 : l, [d, f] = qe(), [p, m] = qe(0), h = nt(0);
  let b;
  e[0] !== n ? (b = eS(n), e[0] = n, e[1] = b) : b = e[1];
  const v = b, C = nt(v), [y, w] = qe(v);
  let R, S;
  e[2] !== v ? (R = () => (C.current = v, h.current = h.current + 1, () => {
    h.current = h.current + 1;
  }), S = [v], e[2] = v, e[3] = R, e[4] = S) : (R = e[3], S = e[4]), po(R, S), y !== v && (w(v), f(void 0), m(iS));
  let E;
  e[5] !== a ? (E = {
    ...Jw,
    ...a
  }, e[5] = a, e[6] = E) : E = e[6];
  const N = E, M = c || d?.imageSetKey === v && d.retryId === p;
  let T;
  if (e[7] !== v || e[8] !== d || e[9] !== c || e[10] !== M || e[11] !== n || e[12] !== N.addImages || e[13] !== N.emptyDescription || e[14] !== N.loadingError || e[15] !== N.loadingErrorDescription || e[16] !== N.noImagesFound || e[17] !== N.refresh || e[18] !== N.title || e[19] !== N.viewAll || e[20] !== r || e[21] !== i || e[22] !== o || e[23] !== p || e[24] !== u) {
    const P = n.slice(0, 4);
    let k;
    e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = (_, L) => {
      f({
        imageSetKey: _,
        retryId: L
      });
    }, e[26] = k) : k = e[26];
    const I = k, D = () => {
      if (c) {
        i?.();
        return;
      }
      if (!(d?.imageSetKey === v && d.retryId === p))
        return;
      const L = h.current = h.current + 1, A = [...new Set(P.slice(0, u ? 4 : 1).map(rS))], $ = tS(A);
      i?.(), $.then(() => {
        L !== h.current || C.current !== v || (m(oS), f(void 0));
      }, nS);
    };
    let O;
    e[27] !== M || e[28] !== n.length || e[29] !== N.viewAll || e[30] !== o ? (O = n.length > 0 && !M && o ? /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", icon: "arrow-up-right", onClick: o, children: N.viewAll }) : void 0, e[27] = M, e[28] = n.length, e[29] = N.viewAll, e[30] = o, e[31] = O) : O = e[31];
    let V;
    e[32] !== N.title || e[33] !== O ? (V = /* @__PURE__ */ g(Qw, { title: N.title, action: O }), e[32] = N.title, e[33] = O, e[34] = V) : V = e[34], T = /* @__PURE__ */ F("div", { "data-slot": "contextual-asset-gallery", className: "flex w-[320px] max-w-full flex-col gap-(--spacing-10)", children: [
      V,
      M ? /* @__PURE__ */ g(hm, { variant: "compact", icon: "wifi-exclamation-sharp-solid", iconTone: "negative", title: N.loadingError, description: N.loadingErrorDescription, actions: /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", icon: "sync", onClick: D, children: N.refresh }) }) : n.length === 0 ? /* @__PURE__ */ g(hm, { variant: "compact", icon: "image-regular", title: N.noImagesFound, description: N.emptyDescription, actions: /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", icon: "add-plus", onClick: r, children: N.addImages }) }) : /* @__PURE__ */ F(Vt, { children: [
        /* @__PURE__ */ g(Wl, { size: "lg", fullWidth: !0, src: P[0].src, alt: P[0].alt, onImageError: () => I(v, p) }, `${P[0].id}-${p}`),
        u && P.length > 1 ? /* @__PURE__ */ g("div", { className: "grid grid-cols-3 gap-(--spacing-4)", children: P.slice(1).map((_) => /* @__PURE__ */ g(Wl, { size: "lg", fullWidth: !0, src: _.src, alt: _.alt, onImageError: () => I(v, p) }, `${_.id}-${p}`)) }) : null
      ] })
    ] }), e[7] = v, e[8] = d, e[9] = c, e[10] = M, e[11] = n, e[12] = N.addImages, e[13] = N.emptyDescription, e[14] = N.loadingError, e[15] = N.loadingErrorDescription, e[16] = N.noImagesFound, e[17] = N.refresh, e[18] = N.title, e[19] = N.viewAll, e[20] = r, e[21] = i, e[22] = o, e[23] = p, e[24] = u, e[25] = T;
  } else
    T = e[25];
  return T;
}
function nS() {
}
function oS(t) {
  return t + 1;
}
function rS(t) {
  return t.src;
}
function iS(t) {
  return t + 1;
}
const sS = ae(["w-full", "flex", "items-start", "justify-between", "gap-(--spacing-24)", "p-(--spacing-12)", "rounded-(--radius-sm)"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), lS = {
  neutral: "circle-info",
  informative: "circle-info",
  positive: "circle-check",
  warning: "warning",
  negative: "warning"
};
function bm(t) {
  const e = B.c(33);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: s,
    title: l,
    subtext: i,
    action: n,
    onDismiss: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "neutral" : s, c = a === "negative", u = !!(n || o), d = c ? "alert" : "note", f = c ? "assertive" : void 0;
  let p;
  e[7] !== a ? (p = ne(sS({
    tone: a
  })), e[7] = a, e[8] = p) : p = e[8];
  const m = lS[a];
  let h;
  e[9] !== m ? (h = /* @__PURE__ */ g(We, { name: m, size: "md", tone: "inherit" }), e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    color: "inherit"
  }, e[11] = b) : b = e[11];
  let v;
  e[12] !== l ? (v = /* @__PURE__ */ g(wn, { as: "span", size: "sm", style: b, children: l }), e[12] = l, e[13] = v) : v = e[13];
  let C;
  e[14] !== i ? (C = i ? /* @__PURE__ */ g(nn, { as: "span", size: "sm", style: {
    color: "inherit"
  }, children: i }) : null, e[14] = i, e[15] = C) : C = e[15];
  let y;
  e[16] !== v || e[17] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) min-w-0", children: [
    v,
    C
  ] }), e[16] = v, e[17] = C, e[18] = y) : y = e[18];
  let w;
  e[19] !== y || e[20] !== h ? (w = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    h,
    y
  ] }), e[19] = y, e[20] = h, e[21] = w) : w = e[21];
  let R;
  e[22] !== n || e[23] !== u || e[24] !== o ? (R = u ? /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    o ? /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Dismiss alert", variant: "ghost", size: "sm", onClick: o }) : null
  ] }) : null, e[22] = n, e[23] = u, e[24] = o, e[25] = R) : R = e[25];
  let S;
  return e[26] !== r || e[27] !== w || e[28] !== R || e[29] !== d || e[30] !== f || e[31] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...r, children: [
    w,
    R
  ] }), e[26] = r, e[27] = w, e[28] = R, e[29] = d, e[30] = f, e[31] = p, e[32] = S) : S = e[32], S;
}
function aS(t) {
  const e = B.c(14), {
    stableCount: n,
    watchingCount: o,
    maintenanceCount: r
  } = t, i = n + o + r;
  if (i === 0) {
    let p;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "h-(--spacing-8) w-full rounded-(--radius-none) bg-surface-inverse-surface/20" }), e[0] = p) : p = e[0], p;
  }
  const s = n / i * 100, l = o / i * 100, a = r / i * 100;
  let c;
  e[1] !== n || e[2] !== s ? (c = n > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-stable", className: "h-full rounded-(--radius-none) bg-datavis-crit-green", style: {
    width: `${s}%`
  } }), e[1] = n, e[2] = s, e[3] = c) : c = e[3];
  let u;
  e[4] !== o || e[5] !== l ? (u = o > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-watching", className: "h-full rounded-(--radius-none) bg-datavis-crit-yellow", style: {
    width: `${l}%`
  } }), e[4] = o, e[5] = l, e[6] = u) : u = e[6];
  let d;
  e[7] !== r || e[8] !== a ? (d = r > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-maintenance", className: "h-full rounded-(--radius-none) bg-datavis-crit-red", style: {
    width: `${a}%`
  } }), e[7] = r, e[8] = a, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ F("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "flex h-(--spacing-8) w-full gap-(--spacing-6)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
const kl = 6, cS = 4;
function uS(t) {
  return cS / (2 * Math.PI * t) * 360;
}
function vm(t, e, n, o) {
  const r = (o - 90) * Math.PI / 180;
  return {
    x: t + n * Math.cos(r),
    y: e + n * Math.sin(r)
  };
}
function dS(t, e, n, o, r) {
  const i = vm(t, e, n, r), s = vm(t, e, n, o), l = r - o > 180 ? 1 : 0;
  return `M ${i.x} ${i.y} A ${n} ${n} 0 ${l} 0 ${s.x} ${s.y}`;
}
const fS = ["Stable", "Watching", "Maintenance Recommended"], pS = ["stroke-datavis-crit-green", "stroke-datavis-crit-yellow", "stroke-datavis-crit-red"];
function mS(t) {
  const e = B.c(51), {
    size: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t, l = n / 2, a = n / 2, c = (n - kl) / 2, u = r + i + s, d = u === 0;
  let f;
  e[0] !== d || e[1] !== u ? (f = d ? "--" : u >= 1e4 ? `${Math.round(u / 1e3)}k` : String(u), e[0] = d, e[1] = u, e[2] = f) : f = e[2];
  const p = f, m = n >= 80 ? "var(--font-size-title-xl)" : "var(--font-size-title-sm)", h = n >= 80 ? "var(--font-size-title-sm)" : "var(--font-size-title-xs)", b = a - 4;
  let v;
  e[3] !== p || e[4] !== m || e[5] !== l || e[6] !== b ? (v = /* @__PURE__ */ g("text", { x: l, y: b, textAnchor: "middle", dominantBaseline: "auto", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: m, className: "fill-text-default", "data-testid": "asset-status-donut-count", children: p }), e[3] = p, e[4] = m, e[5] = l, e[6] = b, e[7] = v) : v = e[7];
  const C = a + 4;
  let y;
  e[8] !== l || e[9] !== C || e[10] !== o || e[11] !== h ? (y = /* @__PURE__ */ g("text", { x: l, y: C, textAnchor: "middle", dominantBaseline: "hanging", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: h, className: "fill-text-subtext", "data-testid": "asset-status-donut-unit", children: o }), e[8] = l, e[9] = C, e[10] = o, e[11] = h, e[12] = y) : y = e[12];
  let w;
  e[13] !== v || e[14] !== y ? (w = /* @__PURE__ */ F(Vt, { children: [
    v,
    y
  ] }), e[13] = v, e[14] = y, e[15] = w) : w = e[15];
  const R = w;
  if (d) {
    let V;
    e[16] !== l || e[17] !== a || e[18] !== c ? (V = /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: "stroke-surface-inverse-surface/20", strokeWidth: kl }), e[16] = l, e[17] = a, e[18] = c, e[19] = V) : V = e[19];
    let _;
    return e[20] !== R || e[21] !== n || e[22] !== V ? (_ = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": "No asset status data available", "data-testid": "asset-status-donut", children: [
      V,
      R
    ] }), e[20] = R, e[21] = n, e[22] = V, e[23] = _) : _ = e[23], _;
  }
  let S;
  e[24] !== s || e[25] !== r || e[26] !== i ? (S = [r, i, s].map(bS).filter(hS), e[24] = s, e[25] = r, e[26] = i, e[27] = S) : S = e[27];
  const E = S;
  let N;
  e[28] !== c || e[29] !== E.length ? (N = E.length > 1 ? uS(c) : 0, e[28] = c, e[29] = E.length, e[30] = N) : N = e[30];
  const M = N, P = 360 - E.length * M;
  let k;
  if (e[31] !== P || e[32] !== l || e[33] !== a || e[34] !== M || e[35] !== c || e[36] !== E || e[37] !== u) {
    k = [];
    let V = 0;
    for (const _ of E) {
      const L = _.count / u * P;
      k.push({
        path: dS(l, a, c, V, V + L),
        strokeClassName: _.strokeClassName,
        label: `${_.label}: ${_.count}`
      }), V = V + (L + M);
    }
    e[31] = P, e[32] = l, e[33] = a, e[34] = M, e[35] = c, e[36] = E, e[37] = u, e[38] = k;
  } else
    k = e[38];
  const I = `Asset status: ${r} stable, ${i} watching, ${s} maintenance`;
  let D;
  e[39] !== k || e[40] !== l || e[41] !== a || e[42] !== c || e[43] !== E[0] || e[44] !== E.length ? (D = E.length === 1 ? /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: E[0].strokeClassName, strokeWidth: kl, "aria-label": `${E[0].label}: ${E[0].count}`, "data-testid": "asset-status-donut-segment" }) : k.map(gS), e[39] = k, e[40] = l, e[41] = a, e[42] = c, e[43] = E[0], e[44] = E.length, e[45] = D) : D = e[45];
  let O;
  return e[46] !== R || e[47] !== n || e[48] !== D || e[49] !== I ? (O = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": I, "data-testid": "asset-status-donut", children: [
    D,
    R
  ] }), e[46] = R, e[47] = n, e[48] = D, e[49] = I, e[50] = O) : O = e[50], O;
}
function gS(t) {
  return /* @__PURE__ */ g("path", { d: t.path, fill: "none", className: t.strokeClassName, strokeWidth: kl, "aria-label": t.label, "data-testid": "asset-status-donut-segment" }, t.label);
}
function hS(t) {
  return t.count > 0;
}
function bS(t, e) {
  return {
    count: t,
    strokeClassName: pS[e],
    label: fS[e]
  };
}
const vS = {
  md: "var(--font-size-title-sm)",
  sm: "var(--font-size-title-xs)"
};
function vc(t) {
  const e = B.c(20), {
    size: n,
    icon: o,
    iconColor: r,
    chipTone: i,
    label: s,
    count: l
  } = t;
  let a;
  e[0] !== o ? (a = /* @__PURE__ */ g(We, { name: o, size: "xs", tone: "inherit" }), e[0] = o, e[1] = a) : a = e[1];
  let c;
  e[2] !== r || e[3] !== a ? (c = /* @__PURE__ */ g("span", { className: r, "aria-hidden": "true", children: a }), e[2] = r, e[3] = a, e[4] = c) : c = e[4];
  const u = vS[n];
  let d;
  e[5] !== u ? (d = {
    fontSize: u
  }, e[5] = u, e[6] = d) : d = e[6];
  let f;
  e[7] !== s || e[8] !== d ? (f = /* @__PURE__ */ g("span", { className: "truncate font-(family-name:--font-family-title) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default", style: d, children: s }), e[7] = s, e[8] = d, e[9] = f) : f = e[9];
  let p;
  e[10] !== c || e[11] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) min-w-0", children: [
    c,
    f
  ] }), e[10] = c, e[11] = f, e[12] = p) : p = e[12];
  const m = n === "md" ? o : void 0;
  let h;
  e[13] !== i || e[14] !== l || e[15] !== m ? (h = /* @__PURE__ */ g(Ln, { tone: i, icon: m, label: l }), e[13] = i, e[14] = l, e[15] = m, e[16] = h) : h = e[16];
  let b;
  return e[17] !== p || e[18] !== h ? (b = /* @__PURE__ */ F("div", { className: "grid w-full grid-cols-[minmax(0,1fr)_max-content] items-center gap-(--spacing-8)", "data-testid": "asset-status-key-row", children: [
    p,
    h
  ] }), e[17] = p, e[18] = h, e[19] = b) : b = e[19], b;
}
function ym(t) {
  const e = B.c(19), {
    labels: n,
    size: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t;
  let l;
  e[0] !== n ? (l = n === void 0 ? {
    stable: "Stable",
    watching: "Watching",
    maintenance: "Maintenance Recommended"
  } : n, e[0] = n, e[1] = l) : l = e[1];
  const a = l, u = `flex w-full min-w-0 flex-col ${o === "md" ? "gap-(--spacing-6)" : "gap-(--spacing-4)"}`;
  let d;
  e[2] !== a.stable || e[3] !== o || e[4] !== r ? (d = /* @__PURE__ */ g(vc, { size: o, icon: "circle-check", iconColor: "text-datavis-crit-green", chipTone: "positive", label: a.stable, count: r }), e[2] = a.stable, e[3] = o, e[4] = r, e[5] = d) : d = e[5];
  let f;
  e[6] !== a.watching || e[7] !== o || e[8] !== i ? (f = /* @__PURE__ */ g(vc, { size: o, icon: "eye-watching", iconColor: "text-datavis-crit-yellow", chipTone: "warning", label: a.watching, count: i }), e[6] = a.watching, e[7] = o, e[8] = i, e[9] = f) : f = e[9];
  let p;
  e[10] !== a.maintenance || e[11] !== s || e[12] !== o ? (p = /* @__PURE__ */ g(vc, { size: o, icon: "maintenance", iconColor: "text-datavis-crit-red", chipTone: "negative", label: a.maintenance, count: s }), e[10] = a.maintenance, e[11] = s, e[12] = o, e[13] = p) : p = e[13];
  let m;
  return e[14] !== u || e[15] !== d || e[16] !== f || e[17] !== p ? (m = /* @__PURE__ */ F("div", { className: u, "data-testid": "asset-status-key", children: [
    d,
    f,
    p
  ] }), e[14] = u, e[15] = d, e[16] = f, e[17] = p, e[18] = m) : m = e[18], m;
}
const yS = {
  md: 88,
  sm: 80
};
function xS({
  stableCount: t,
  watchingCount: e,
  maintenanceCount: n
}) {
  const o = [t < 0 ? "stableCount" : null, e < 0 ? "watchingCount" : null, n < 0 ? "maintenanceCount" : null].filter((r) => r !== null);
  if (o.length > 0)
    throw new RangeError(`AssetStatusCard counts cannot be negative: ${o.join(", ")}`);
}
function CS(t) {
  return t.borderBoxSize[0]?.inlineSize ?? t.contentRect.width;
}
function SD(t) {
  const e = B.c(24), {
    variant: n,
    stretch: o,
    unit: r,
    stableCount: i,
    watchingCount: s,
    maintenanceCount: l,
    labels: a,
    emptyStateTitle: c
  } = t, u = o === void 0 ? !0 : o, d = c === void 0 ? "No available asset status data. Check back later." : c;
  xS({
    stableCount: i,
    watchingCount: s,
    maintenanceCount: l
  });
  const f = nt(null), [p, m] = qe("md"), h = n === "donut", b = i + s + l, v = b === 0, C = h ? "p-(--spacing-12)" : "p-(--spacing-20)";
  let y, w;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = () => {
    const T = f.current;
    if (!T || typeof ResizeObserver > "u")
      return;
    const P = (I) => {
      m(I <= 380 ? "sm" : "md");
    };
    P(T.getBoundingClientRect().width);
    const k = new ResizeObserver((I) => {
      const [D] = I;
      D && P(CS(D));
    });
    return k.observe(T), () => {
      k.disconnect();
    };
  }, w = [], e[0] = y, e[1] = w) : (y = e[0], w = e[1]), Rt(y, w);
  const R = u ? "h-full" : "h-fit";
  let S;
  e[2] !== C || e[3] !== R ? (S = ne("flex w-full min-w-0 flex-col gap-(--spacing-16) rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1", R, C), e[2] = C, e[3] = R, e[4] = S) : S = e[4];
  let E;
  e[5] !== h || e[6] !== v || e[7] !== b || e[8] !== r ? (E = !h && /* @__PURE__ */ F("div", { className: "flex items-baseline gap-(--spacing-6)", "data-testid": "asset-status-card-header", children: [
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xl) leading-(--font-line-height-28) text-text-default", children: v ? "--" : b }),
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-regular) text-(length:--font-size-title-md) leading-(--font-line-height-24) text-text-subtext", children: r })
  ] }), e[5] = h, e[6] = v, e[7] = b, e[8] = r, e[9] = E) : E = e[9];
  let N;
  e[10] !== d || e[11] !== h || e[12] !== v || e[13] !== a || e[14] !== l || e[15] !== p || e[16] !== i || e[17] !== r || e[18] !== s ? (N = h ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g("div", { className: "shrink-0", children: /* @__PURE__ */ g(mS, { size: yS[p], unit: r, stableCount: i, watchingCount: s, maintenanceCount: l }) }),
    v ? /* @__PURE__ */ g(bm, { tone: "neutral", title: d }) : /* @__PURE__ */ g(ym, { labels: a, size: p, stableCount: i, watchingCount: s, maintenanceCount: l })
  ] }) : /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g(aS, { stableCount: i, watchingCount: s, maintenanceCount: l }),
    v ? /* @__PURE__ */ g(bm, { tone: "neutral", title: d }) : /* @__PURE__ */ g(ym, { labels: a, size: p, stableCount: i, watchingCount: s, maintenanceCount: l })
  ] }), e[10] = d, e[11] = h, e[12] = v, e[13] = a, e[14] = l, e[15] = p, e[16] = i, e[17] = r, e[18] = s, e[19] = N) : N = e[19];
  let M;
  return e[20] !== S || e[21] !== E || e[22] !== N ? (M = /* @__PURE__ */ F("div", { ref: f, "data-testid": "asset-status-card", className: S, children: [
    E,
    N
  ] }), e[20] = S, e[21] = E, e[22] = N, e[23] = M) : M = e[23], M;
}
const vf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (vf.displayName = "PreviewCardRootContext");
function Ts(t) {
  const e = x.useContext(vf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PreviewCardRootContext is missing. PreviewCard parts must be placed within <PreviewCard.Root>." : tt(50));
  return e;
}
const wS = 600, C0 = 300, SS = {
  ...gs,
  instantType: ge((t) => t.instantType),
  hasViewport: ge((t) => t.hasViewport)
};
class yf extends Rr {
  constructor(e) {
    super({
      ...RS(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Er(),
      closeDelayRef: {
        current: C0
      }
    }, SS);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Ft, i = e && o === fr, s = !e && (o === Zn || o === xr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Ft && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? cn.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Tt(() => new yf(n)).current, r = e ?? o, i = hs({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function RS() {
  return {
    ...ms(),
    instantType: void 0,
    hasViewport: !1
  };
}
function xm(t) {
  const {
    open: e,
    defaultOpen: n = !1,
    onOpenChange: o,
    onOpenChangeComplete: r,
    actionsRef: i,
    handle: s,
    triggerId: l,
    defaultTriggerId: a = null,
    children: c
  } = t, u = yf.useStore(s?.store, {
    open: n,
    openProp: e,
    activeTriggerId: a,
    triggerIdProp: l
  });
  Ir(() => {
    e === void 0 && u.state.open === !1 && n === !0 && u.update({
      open: !0,
      activeTriggerId: a
    });
  }), u.useControlledProp("openProp", e), u.useControlledProp("triggerIdProp", l), u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", r);
  const d = u.useState("open"), f = u.select("floatingRootContext"), p = u.useState("activeTriggerId"), m = u.useState("payload");
  fs(u);
  const {
    forceUnmount: h
  } = ps(d, u);
  Ne(() => {
    d && p == null && u.set("payload", void 0);
  }, [u, p, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, _e(as));
  }, [u]);
  x.useImperativeHandle(i, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = Sr(f), {
    getReferenceProps: C,
    getTriggerProps: y,
    getFloatingProps: w
  } = eo([v]), R = x.useMemo(() => C(), [C]), S = x.useMemo(() => y(), [y]), E = x.useMemo(() => w(), [w]);
  return u.useSyncedValues({
    activeTriggerProps: R,
    inactiveTriggerProps: S,
    popupProps: E
  }), /* @__PURE__ */ g(vf.Provider, {
    value: u,
    children: typeof c == "function" ? c({
      payload: m
    }) : c
  });
}
function ES(t) {
  return Ts(!0) ? /* @__PURE__ */ g(xm, {
    ...t
  }) : /* @__PURE__ */ g(ud, {
    children: /* @__PURE__ */ g(xm, {
      ...t
    })
  });
}
const xf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (xf.displayName = "PreviewCardPortalContext");
function NS() {
  const t = x.useContext(xf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Portal> is missing." : tt(48));
  return t;
}
const w0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Ts().useState("mounted") || o ? /* @__PURE__ */ g(xf.Provider, {
    value: o,
    children: /* @__PURE__ */ g(va, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (w0.displayName = "PreviewCardPortal");
const S0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    delay: i,
    closeDelay: s,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = Ts(!0), p = c?.store ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Trigger> must be either used within a <PreviewCard.Root> component or provided with a handle." : tt(89));
  const m = It(l), h = p.useState("isTriggerActive", m), b = p.useState("isOpenedByTrigger", m), v = p.useState("floatingRootContext"), C = x.useRef(null), y = i ?? wS, w = s ?? C0, {
    registerTrigger: R,
    isMountedByThisTrigger: S
  } = ds(m, C, p, {
    payload: a
  });
  Ne(() => {
    S && (p.context.closeDelayRef.current = w);
  }, [p, S, w]);
  const E = bs(v, {
    mouseOnly: !0,
    move: !1,
    handleClose: vs(),
    delay: () => ({
      open: y,
      close: w
    }),
    triggerElementRef: C,
    isActiveTrigger: h,
    isClosing: () => p.select("transitionStatus") === "ending"
  }), N = yd(v, {
    delay: y
  }), M = {
    open: b
  }, T = p.useState("triggerProps", S);
  return Le("a", e, {
    state: M,
    ref: [n, R, C],
    props: [E, N.reference, T, {
      id: m
    }, d],
    stateAttributesMapping: yr
  });
});
process.env.NODE_ENV !== "production" && (S0.displayName = "PreviewCardTrigger");
const Cf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cf.displayName = "PreviewCardPositionerContext");
function kS() {
  const t = x.useContext(Cf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Popup> and <PreviewCard.Arrow> must be used within the <PreviewCard.Positioner> component" : tt(49));
  return t;
}
const R0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = da,
    style: v,
    ...C
  } = e, y = Ts(), w = NS(), R = fa(), S = y.useState("open"), E = y.useState("mounted"), N = y.useState("floatingRootContext"), M = y.useState("instantType"), T = y.useState("transitionStatus"), P = y.useState("hasViewport"), k = ii({
    anchor: i,
    floatingRootContext: N,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: P ? ha : void 0
  }), I = {
    open: S,
    side: k.side,
    align: k.align,
    anchorHidden: k.anchorHidden,
    instant: M
  }, D = ai(e, I, {
    styles: k.positionerStyles,
    transitionStatus: T,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !S
  });
  return /* @__PURE__ */ g(Cf.Provider, {
    value: k,
    children: /* @__PURE__ */ g(cd, {
      id: R,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (R0.displayName = "PreviewCardPositioner");
const IS = {
  ...In,
  ...Bt
}, E0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Ts(), {
    side: a,
    align: c
  } = kS(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = Ce(() => l.context.closeDelayRef.current);
  return ma(m, {
    closeDelay: h
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Nr(f), s],
    stateAttributesMapping: IS
  });
});
process.env.NODE_ENV !== "production" && (E0.displayName = "PreviewCardPopup");
const PS = "z-[var(--z-layer-popover)]";
function MS(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(ES, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function TS(t) {
  const e = B.c(8);
  let n, o, r;
  e[0] !== t ? ({
    render: o,
    delay: r,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? 0 : r;
  let s;
  return e[4] !== i || e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ g(S0, { render: o, delay: i, ...n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
function OS(t) {
  const e = B.c(21);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: n,
    className: o,
    side: i,
    align: s,
    sideOffset: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "bottom" : i, c = s === void 0 ? "center" : s, u = l === void 0 ? 8 : l, d = Kt();
  let f;
  e[7] !== o ? (f = ne(O2, o), e[7] = o, e[8] = f) : f = e[8];
  let p;
  e[9] !== n || e[10] !== f ? (p = /* @__PURE__ */ g(E0, { className: f, children: n }), e[9] = n, e[10] = f, e[11] = p) : p = e[11];
  let m;
  e[12] !== c || e[13] !== r || e[14] !== a || e[15] !== u || e[16] !== p ? (m = /* @__PURE__ */ g(R0, { side: a, align: c, sideOffset: u, className: PS, ...r, children: p }), e[12] = c, e[13] = r, e[14] = a, e[15] = u, e[16] = p, e[17] = m) : m = e[17];
  let h;
  return e[18] !== d || e[19] !== m ? (h = /* @__PURE__ */ g(w0, { container: d, children: m }), e[18] = d, e[19] = m, e[20] = h) : h = e[20], h;
}
const DS = {
  operational: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  critical: "bg-datavis-crit-red",
  inactive: "bg-surface-container-high"
}, _S = 32, VS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], AS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function LS(t) {
  if (t < 1 || t > 12)
    throw new RangeError(`AssetTimeline requires between 1 and 12 consecutive months. Received ${t}.`);
}
function FS(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getMonth(), o = e.getFullYear();
  return Array.from({
    length: t
  }, (r, i) => {
    const s = t - i - 1, l = new Date(o, n - s, 1), a = l.getMonth(), c = l.getFullYear();
    return {
      shortLabel: VS[a],
      longLabel: `${AS[a]} ${c}`,
      key: `${c}-${a}`
    };
  });
}
function N0(t) {
  return t.markerCount ?? t.events?.length ?? 0;
}
function $S(t) {
  const e = t.reduce((o, r) => (o[r.severity] += 1, o), {
    operational: 0,
    warning: 0,
    critical: 0,
    inactive: 0
  }), n = (o, r) => `${o} ${r} ${o === 1 ? "month" : "months"}`;
  return `Asset timeline: ${n(e.operational, "operational")}, ${n(e.warning, "warning")}, ${n(e.critical, "critical")}, ${n(e.inactive, "inactive")}.`;
}
function Cm(t, e) {
  const n = N0(t), o = n === 1 ? "1 event" : `${n} events`;
  return n > 0 ? `${e.longLabel}: ${t.severity}, ${o}` : `${e.longLabel}: ${t.severity}, no events`;
}
function HS(t) {
  const e = B.c(3), {
    count: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("svg", { "aria-hidden": "true", viewBox: "0 0 8 8", className: "size-(--spacing-8) fill-informative group-focus-visible/asset-timeline-marker:fill-primary-on-primary", children: /* @__PURE__ */ g("path", { d: "M4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8ZM4 2.5C4.39782 2.5 4.77936 2.65804 5.06066 2.93934C5.34196 3.22064 5.5 3.60218 5.5 4C5.5 4.39782 5.34196 4.77936 5.06066 5.06066C4.77936 5.34196 4.39782 5.5 4 5.5C3.60218 5.5 3.22064 5.34196 2.93934 5.06066C2.65804 4.77936 2.5 4.39782 2.5 4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5Z" }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-marker", className: "inline-flex h-(--spacing-20) min-w-(--spacing-32) items-center justify-center gap-(--spacing-2) rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-6) font-(family-name:--font-family-label) font-(number:--font-weight-medium) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-default group-hover/asset-timeline-marker:bg-surface-container group-focus-visible/asset-timeline-marker:bg-primary group-focus-visible/asset-timeline-marker:text-primary-on-primary", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function zS(t) {
  const e = B.c(6), {
    count: n,
    ariaLabel: o,
    onClick: r
  } = t;
  let i;
  e[0] !== n ? (i = /* @__PURE__ */ g(HS, { count: n }), e[0] = n, e[1] = i) : i = e[1];
  let s;
  return e[2] !== o || e[3] !== r || e[4] !== i ? (s = /* @__PURE__ */ g("button", { type: "button", "aria-label": o, "data-testid": "asset-timeline-event-marker", "data-test-id": "asset-timeline-event-marker", className: "group/asset-timeline-marker cursor-pointer rounded-(--radius-xs) border-0 bg-transparent p-0 outline-none", onClick: r, children: i }), e[2] = o, e[3] = r, e[4] = i, e[5] = s) : s = e[5], s;
}
function BS(t) {
  const e = B.c(43), {
    month: n,
    meta: o,
    monthIndex: r,
    renderHoverCard: i,
    onMonthClick: s
  } = t, l = N0(n);
  let a, c;
  e[0] !== o.longLabel || e[1] !== o.shortLabel || e[2] !== n || e[3] !== r || e[4] !== i ? (a = {
    month: n,
    monthIndex: r,
    monthLabel: o.shortLabel,
    monthLongLabel: o.longLabel
  }, c = i?.(a), e[0] = o.longLabel, e[1] = o.shortLabel, e[2] = n, e[3] = r, e[4] = i, e[5] = a, e[6] = c) : (a = e[5], c = e[6]);
  const u = c;
  let d;
  e[7] !== u || e[8] !== o || e[9] !== n ? (d = u ? {} : {
    role: "img",
    "aria-label": Cm(n, o)
  }, e[7] = u, e[8] = o, e[9] = n, e[10] = d) : d = e[10];
  const f = DS[n.severity];
  let p;
  e[11] !== f ? (p = ne("flex h-(--spacing-12) w-full", f), e[11] = f, e[12] = p) : p = e[12];
  let m;
  e[13] !== u || e[14] !== o || e[15] !== n ? (m = u ? /* @__PURE__ */ F(MS, { children: [
    /* @__PURE__ */ g(TS, { delay: 0, closeDelay: 0, render: /* @__PURE__ */ g("button", { type: "button", "aria-label": Cm(n, o), className: "block h-full w-full cursor-pointer border-0 bg-transparent p-0 text-center outline-none focus-visible:ring-(--spacing-2) focus-visible:ring-button-focus-ring focus-visible:ring-offset-(--focus-ring-offset) focus-visible:ring-offset-surface" }) }),
    /* @__PURE__ */ g(OS, { className: "overflow-hidden", sideOffset: _S, children: u })
  ] }) : null, e[13] = u, e[14] = o, e[15] = n, e[16] = m) : m = e[16];
  let h;
  e[17] !== d || e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-fill", "data-test-id": "asset-timeline-fill", ...d, className: p, children: m }), e[17] = d, e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  const b = h;
  let v;
  e[21] !== o.shortLabel ? (v = o.shortLabel.slice(0, 1), e[21] = o.shortLabel, e[22] = v) : v = e[22];
  let C;
  e[23] !== v ? (C = /* @__PURE__ */ g("span", { className: "@min-[48px]/asset-timeline-month:hidden", children: v }), e[23] = v, e[24] = C) : C = e[24];
  let y;
  e[25] !== o.shortLabel ? (y = /* @__PURE__ */ g("span", { className: "hidden @min-[48px]/asset-timeline-month:inline", children: o.shortLabel }), e[25] = o.shortLabel, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "pt-(--spacing-4) font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtle", children: [
    C,
    y
  ] }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  let S;
  e[30] !== l || e[31] !== o.longLabel || e[32] !== a || e[33] !== s ? (S = l > 0 ? /* @__PURE__ */ g(zS, { count: l, ariaLabel: `${o.longLabel}: ${l} monthly events`, onClick: () => s?.(a) }) : null, e[30] = l, e[31] = o.longLabel, e[32] = a, e[33] = s, e[34] = S) : S = e[34];
  const E = S;
  let N;
  e[35] !== b || e[36] !== R ? (N = /* @__PURE__ */ F(Vt, { children: [
    b,
    R
  ] }), e[35] = b, e[36] = R, e[37] = N) : N = e[37];
  const M = N;
  let T;
  e[38] !== E ? (T = E ? /* @__PURE__ */ g("span", { className: "absolute bottom-(--spacing-40)", children: E }) : null, e[38] = E, e[39] = T) : T = e[39];
  let P;
  return e[40] !== T || e[41] !== M ? (P = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-month", "data-test-id": "asset-timeline-month", className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-month-content", className: "relative flex w-full flex-col items-center pt-(--spacing-24)", children: [
    T,
    M
  ] }) }), e[40] = T, e[41] = M, e[42] = P) : P = e[42], P;
}
function RD(t) {
  const e = B.c(28);
  let n, o, r, i;
  e[0] !== t ? ({
    months: r,
    ariaLabel: n,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]), LS(r.length);
  const s = "renderHoverCard" in i ? i.renderHoverCard : void 0, l = "onMonthClick" in i ? i.onMonthClick : void 0;
  let a;
  e[5] !== r.length ? (a = FS(r.length), e[5] = r.length, e[6] = a) : a = e[6];
  const c = a, u = `repeat(${r.length}, minmax(0, 1fr))`;
  let d;
  e[7] !== u ? (d = {
    gridTemplateColumns: u
  }, e[7] = u, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== n || e[10] !== r ? (p = n ?? $S(r), e[9] = n, e[10] = r, e[11] = p) : p = e[11];
  let m;
  e[12] !== o ? (m = ne("grid w-full min-w-0 items-end gap-x-(--spacing-1)", o), e[12] = o, e[13] = m) : m = e[13];
  let h;
  if (e[14] !== c || e[15] !== r || e[16] !== l || e[17] !== s) {
    let v;
    e[19] !== c || e[20] !== l || e[21] !== s ? (v = (C, y) => /* @__PURE__ */ g(BS, { month: C, meta: c[y], monthIndex: y, renderHoverCard: s, onMonthClick: l }, c[y].key), e[19] = c, e[20] = l, e[21] = s, e[22] = v) : v = e[22], h = r.map(v), e[14] = c, e[15] = r, e[16] = l, e[17] = s, e[18] = h;
  } else
    h = e[18];
  let b;
  return e[23] !== f || e[24] !== p || e[25] !== m || e[26] !== h ? (b = /* @__PURE__ */ g("section", { "data-testid": "asset-timeline", "data-test-id": "asset-timeline", "aria-label": p, className: m, style: f, children: h }), e[23] = f, e[24] = p, e[25] = m, e[26] = h, e[27] = b) : b = e[27], b;
}
const Hr = {
  complete: "complete",
  partial: "partial",
  failed: "failed",
  unknown: "unknown"
}, Ai = {
  complete: "Complete",
  partial: "Partial",
  failed: "Failed",
  unknown: "Unknown"
}, WS = {
  loadingReleaseInfo: "Loading release info...",
  copyRecord: "Copy record",
  openSsm: "Open SSM",
  openSsmAriaLabel: "Open SSM parameter",
  recordUnavailable: "Record unavailable",
  copyPrefix: "Copy",
  rows: {
    tag: "Tag",
    status: "Status",
    sha: "SHA",
    requestedRef: "Requested ref",
    deployedAt: "Deployed at",
    ssmParameter: "SSM parameter",
    selected: "Selected",
    deployed: "Deployed",
    failed: "Failed",
    terraform: "Terraform",
    api: "API",
    frontend: "Frontend"
  },
  links: {
    githubTag: "GitHub tag",
    githubCommit: "GitHub commit",
    workflowRun: "Workflow run"
  },
  status: Ai,
  values: {
    unknown: "unknown",
    none: "none",
    notSelected: "not selected",
    deployed: "deployed"
  }
}, ED = {
  [Hr.complete]: {
    label: Ai.complete,
    icon: "circle-check",
    iconTone: "positive"
  },
  [Hr.failed]: {
    label: Ai.failed,
    icon: "circle-exclamation",
    iconTone: "negative"
  },
  [Hr.partial]: {
    label: Ai.partial,
    icon: "warning",
    iconTone: "warning"
  },
  [Hr.unknown]: {
    label: Ai.unknown,
    icon: "circle-info",
    iconTone: "neutral"
  }
};
function wm(t, e = "unknown") {
  return t ? t.slice(0, 12) : e;
}
function US(t) {
  return t ?? Hr.unknown;
}
function GS(t, e) {
  return e[t];
}
function YS(t, e) {
  if (!e)
    return "";
  const n = encodeURIComponent(encodeURIComponent(e));
  return `https://${t}.console.aws.amazon.com/systems-manager/parameters/${n}/description?region=${t}`;
}
function jS({
  appName: t,
  environment: e,
  recordParameterName: n,
  commitId: o,
  branchName: r,
  releaseTag: i
}) {
  return {
    app: t,
    environment: e,
    parameterName: n,
    status: Hr.unknown,
    sourceSha: o,
    requestedRef: r,
    releaseTag: i,
    selectedParts: [],
    deployedParts: [],
    failedParts: [],
    parts: {
      terraform: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      api: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      frontend: {
        selected: !1,
        result: "unknown",
        deployed: !1
      }
    }
  };
}
function yc(t, e) {
  return !t || t.length === 0 ? e : t.join(", ");
}
function KS(t, e) {
  if (!t)
    return e;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? t : n.toLocaleString();
}
function xc(t, e) {
  return t ? t.selected ? t.deployed ? e.deployed : t.result ?? e.unknown : e.notSelected : e.unknown;
}
function Cc(t) {
  const e = B.c(23);
  let n, o, r, i, s, l, a, c, u;
  if (e[0] !== t) {
    const {
      size: p,
      destructive: m,
      disabled: h,
      children: b,
      ...v
    } = t;
    n = b, s = v;
    const C = p === void 0 ? "md" : p, y = m === void 0 ? !1 : m;
    r = h === void 0 ? !1 : h, i = "onClick" in t && t.onClick !== void 0 && !("href" in t && t.href !== void 0), o = Z2({
      size: C,
      variant: i ? "navigational" : "contextual",
      destructive: y,
      disabled: r
    });
    const {
      render: w,
      href: R,
      target: S,
      rel: E,
      ...N
    } = i ? {} : s, M = S === "_blank" && !E ? "noopener noreferrer" : E;
    u = Ra, l = "a", a = w, c = Jt(N, {
      ...R !== void 0 && {
        href: R
      },
      ...S !== void 0 && {
        target: S
      },
      ...M !== void 0 && {
        rel: M
      },
      ...r && {
        href: void 0,
        tabIndex: -1,
        onClick: qS
      },
      "aria-disabled": r || void 0,
      className: o,
      children: n
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[10] !== l || e[11] !== a || e[12] !== c ? (d = {
    defaultTagName: l,
    render: a,
    props: c
  }, e[10] = l, e[11] = a, e[12] = c, e[13] = d) : d = e[13];
  const f = u(d);
  if (i) {
    const p = s;
    let m, h;
    e[14] !== p ? ({
      onClick: h,
      ...m
    } = p, e[14] = p, e[15] = m, e[16] = h) : (m = e[15], h = e[16]);
    const b = m, v = r ? void 0 : h, C = r || void 0;
    let y;
    return e[17] !== n || e[18] !== o || e[19] !== b || e[20] !== v || e[21] !== C ? (y = /* @__PURE__ */ g("button", { ...b, type: "button", onClick: v, "aria-disabled": C, className: o, children: n }), e[17] = n, e[18] = o, e[19] = b, e[20] = v, e[21] = C, e[22] = y) : y = e[22], y;
  }
  return f;
}
function qS(t) {
  return t.preventDefault();
}
function ZS(t) {
  const e = B.c(13), {
    display: n,
    labels: o
  } = t;
  let r;
  e[0] !== n.githubTagUrl || e[1] !== o ? (r = n.githubTagUrl ? /* @__PURE__ */ g(Cc, { href: n.githubTagUrl, target: "_blank", rel: "noreferrer", children: o.links.githubTag }) : null, e[0] = n.githubTagUrl, e[1] = o, e[2] = r) : r = e[2];
  let i;
  e[3] !== n.githubCommitUrl || e[4] !== o ? (i = n.githubCommitUrl ? /* @__PURE__ */ g(Cc, { href: n.githubCommitUrl, target: "_blank", rel: "noreferrer", children: o.links.githubCommit }) : null, e[3] = n.githubCommitUrl, e[4] = o, e[5] = i) : i = e[5];
  let s;
  e[6] !== n.record.workflowRunUrl || e[7] !== o ? (s = n.record.workflowRunUrl ? /* @__PURE__ */ g(Cc, { href: n.record.workflowRunUrl, target: "_blank", rel: "noreferrer", children: o.links.workflowRun }) : null, e[6] = n.record.workflowRunUrl, e[7] = o, e[8] = s) : s = e[8];
  let l;
  return e[9] !== r || e[10] !== i || e[11] !== s ? (l = /* @__PURE__ */ F("div", { className: "flex flex-wrap gap-(--spacing-12)", children: [
    r,
    i,
    s
  ] }), e[9] = r, e[10] = i, e[11] = s, e[12] = l) : l = e[12], l;
}
function Dn(t) {
  const e = B.c(17), {
    label: n,
    value: o,
    copyValue: r,
    copiedLabel: i,
    copyPrefix: s,
    onCopy: l,
    unknownValue: a,
    noneValue: c
  } = t, u = r ?? o, d = typeof navigator < "u" && !!navigator.clipboard?.writeText, f = !!(u && u !== a && u !== c), p = i === n;
  let m;
  e[0] !== n ? (m = /* @__PURE__ */ g("div", { className: "max-sm:col-span-2", children: /* @__PURE__ */ g(nn, { as: "div", size: "sm", tone: "subtle", children: n }) }), e[0] = n, e[1] = m) : m = e[1];
  const h = o || a;
  let b;
  e[2] !== h ? (b = /* @__PURE__ */ g("code", { className: "min-w-0 truncate rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-4) font-mono text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: h }), e[2] = h, e[3] = b) : b = e[3];
  const v = p ? "check-mark" : "copy-regular", C = `${s} ${n}`, y = !f || !d;
  let w;
  e[4] !== n || e[5] !== l || e[6] !== u ? (w = () => {
    l(u, n);
  }, e[4] = n, e[5] = l, e[6] = u, e[7] = w) : w = e[7];
  let R;
  e[8] !== v || e[9] !== C || e[10] !== y || e[11] !== w ? (R = /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: v, "aria-label": C, disabled: y, onClick: w }), e[8] = v, e[9] = C, e[10] = y, e[11] = w, e[12] = R) : R = e[12];
  let S;
  return e[13] !== m || e[14] !== b || e[15] !== R ? (S = /* @__PURE__ */ F("div", { className: "grid grid-cols-[128px_minmax(0,1fr)_var(--spacing-32)] items-center gap-(--spacing-8) border-b border-outline-subtle py-(--spacing-8) last:border-b-0 max-sm:grid-cols-[1fr_var(--spacing-32)]", children: [
    m,
    b,
    R
  ] }), e[13] = m, e[14] = b, e[15] = R, e[16] = S) : S = e[16], S;
}
function XS(t) {
  const e = B.c(76), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t, s = r.rows.selected;
  let l;
  e[0] !== n.record.selectedParts || e[1] !== r.values.none ? (l = yc(n.record.selectedParts, r.values.none), e[0] = n.record.selectedParts, e[1] = r.values.none, e[2] = l) : l = e[2];
  let a;
  e[3] !== o || e[4] !== r.copyPrefix || e[5] !== r.rows.selected || e[6] !== r.values.none || e[7] !== r.values.unknown || e[8] !== i || e[9] !== l ? (a = /* @__PURE__ */ g(Dn, { label: s, value: l, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[3] = o, e[4] = r.copyPrefix, e[5] = r.rows.selected, e[6] = r.values.none, e[7] = r.values.unknown, e[8] = i, e[9] = l, e[10] = a) : a = e[10];
  const c = r.rows.deployed;
  let u;
  e[11] !== n.record.deployedParts || e[12] !== r.values.none ? (u = yc(n.record.deployedParts, r.values.none), e[11] = n.record.deployedParts, e[12] = r.values.none, e[13] = u) : u = e[13];
  let d;
  e[14] !== o || e[15] !== r.copyPrefix || e[16] !== r.rows.deployed || e[17] !== r.values.none || e[18] !== r.values.unknown || e[19] !== i || e[20] !== u ? (d = /* @__PURE__ */ g(Dn, { label: c, value: u, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[14] = o, e[15] = r.copyPrefix, e[16] = r.rows.deployed, e[17] = r.values.none, e[18] = r.values.unknown, e[19] = i, e[20] = u, e[21] = d) : d = e[21];
  const f = r.rows.failed;
  let p;
  e[22] !== n.record.failedParts || e[23] !== r.values.none ? (p = yc(n.record.failedParts, r.values.none), e[22] = n.record.failedParts, e[23] = r.values.none, e[24] = p) : p = e[24];
  let m;
  e[25] !== o || e[26] !== r.copyPrefix || e[27] !== r.rows.failed || e[28] !== r.values.none || e[29] !== r.values.unknown || e[30] !== i || e[31] !== p ? (m = /* @__PURE__ */ g(Dn, { label: f, value: p, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[25] = o, e[26] = r.copyPrefix, e[27] = r.rows.failed, e[28] = r.values.none, e[29] = r.values.unknown, e[30] = i, e[31] = p, e[32] = m) : m = e[32];
  const h = r.rows.terraform, b = n.record.parts?.terraform;
  let v;
  e[33] !== r.values || e[34] !== b ? (v = xc(b, r.values), e[33] = r.values, e[34] = b, e[35] = v) : v = e[35];
  const C = n.record.parts?.terraform?.sha;
  let y;
  e[36] !== o || e[37] !== r.copyPrefix || e[38] !== r.rows.terraform || e[39] !== r.values.none || e[40] !== r.values.unknown || e[41] !== i || e[42] !== v || e[43] !== C ? (y = /* @__PURE__ */ g(Dn, { label: h, value: v, copyValue: C, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[36] = o, e[37] = r.copyPrefix, e[38] = r.rows.terraform, e[39] = r.values.none, e[40] = r.values.unknown, e[41] = i, e[42] = v, e[43] = C, e[44] = y) : y = e[44];
  const w = r.rows.api, R = n.record.parts?.api;
  let S;
  e[45] !== r.values || e[46] !== R ? (S = xc(R, r.values), e[45] = r.values, e[46] = R, e[47] = S) : S = e[47];
  const E = n.record.parts?.api?.image ?? n.record.apiImage;
  let N;
  e[48] !== o || e[49] !== r.copyPrefix || e[50] !== r.rows.api || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i || e[54] !== S || e[55] !== E ? (N = /* @__PURE__ */ g(Dn, { label: w, value: S, copyValue: E, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[48] = o, e[49] = r.copyPrefix, e[50] = r.rows.api, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = S, e[55] = E, e[56] = N) : N = e[56];
  const M = r.rows.frontend, T = n.record.parts?.frontend;
  let P;
  e[57] !== r.values || e[58] !== T ? (P = xc(T, r.values), e[57] = r.values, e[58] = T, e[59] = P) : P = e[59];
  const k = n.record.parts?.frontend?.cloudfrontDistributionId ?? n.record.frontendCloudfrontDistributionId;
  let I;
  e[60] !== o || e[61] !== r.copyPrefix || e[62] !== r.rows.frontend || e[63] !== r.values.none || e[64] !== r.values.unknown || e[65] !== i || e[66] !== P || e[67] !== k ? (I = /* @__PURE__ */ g(Dn, { label: M, value: P, copyValue: k, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[60] = o, e[61] = r.copyPrefix, e[62] = r.rows.frontend, e[63] = r.values.none, e[64] = r.values.unknown, e[65] = i, e[66] = P, e[67] = k, e[68] = I) : I = e[68];
  let D;
  return e[69] !== y || e[70] !== N || e[71] !== I || e[72] !== a || e[73] !== d || e[74] !== m ? (D = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    a,
    d,
    m,
    y,
    N,
    I
  ] }), e[69] = y, e[70] = N, e[71] = I, e[72] = a, e[73] = d, e[74] = m, e[75] = D) : D = e[75], D;
}
function QS(t) {
  const e = B.c(62), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t;
  let s;
  e[0] !== o || e[1] !== n.displayTag || e[2] !== r.copyPrefix || e[3] !== r.rows.tag || e[4] !== r.values.none || e[5] !== r.values.unknown || e[6] !== i ? (s = /* @__PURE__ */ g(Dn, { label: r.rows.tag, value: n.displayTag, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[0] = o, e[1] = n.displayTag, e[2] = r.copyPrefix, e[3] = r.rows.tag, e[4] = r.values.none, e[5] = r.values.unknown, e[6] = i, e[7] = s) : s = e[7];
  const l = r.rows.status;
  let a;
  e[8] !== n.status || e[9] !== r.status ? (a = GS(n.status, r.status), e[8] = n.status, e[9] = r.status, e[10] = a) : a = e[10];
  let c;
  e[11] !== o || e[12] !== r.copyPrefix || e[13] !== r.rows.status || e[14] !== r.values.none || e[15] !== r.values.unknown || e[16] !== i || e[17] !== a ? (c = /* @__PURE__ */ g(Dn, { label: l, value: a, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[11] = o, e[12] = r.copyPrefix, e[13] = r.rows.status, e[14] = r.values.none, e[15] = r.values.unknown, e[16] = i, e[17] = a, e[18] = c) : c = e[18];
  let u;
  e[19] !== o || e[20] !== n.shortSha || e[21] !== n.sourceSha || e[22] !== r.copyPrefix || e[23] !== r.rows.sha || e[24] !== r.values.none || e[25] !== r.values.unknown || e[26] !== i ? (u = /* @__PURE__ */ g(Dn, { label: r.rows.sha, value: n.shortSha, copyValue: n.sourceSha, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[19] = o, e[20] = n.shortSha, e[21] = n.sourceSha, e[22] = r.copyPrefix, e[23] = r.rows.sha, e[24] = r.values.none, e[25] = r.values.unknown, e[26] = i, e[27] = u) : u = e[27];
  const d = n.record.requestedRef ?? r.values.unknown;
  let f;
  e[28] !== o || e[29] !== r.copyPrefix || e[30] !== r.rows.requestedRef || e[31] !== r.values.none || e[32] !== r.values.unknown || e[33] !== i || e[34] !== d ? (f = /* @__PURE__ */ g(Dn, { label: r.rows.requestedRef, value: d, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[28] = o, e[29] = r.copyPrefix, e[30] = r.rows.requestedRef, e[31] = r.values.none, e[32] = r.values.unknown, e[33] = i, e[34] = d, e[35] = f) : f = e[35];
  const p = r.rows.deployedAt;
  let m;
  e[36] !== n.record.deployedAt || e[37] !== r.values.unknown ? (m = KS(n.record.deployedAt, r.values.unknown), e[36] = n.record.deployedAt, e[37] = r.values.unknown, e[38] = m) : m = e[38];
  let h;
  e[39] !== o || e[40] !== r.copyPrefix || e[41] !== r.rows.deployedAt || e[42] !== r.values.none || e[43] !== r.values.unknown || e[44] !== i || e[45] !== m ? (h = /* @__PURE__ */ g(Dn, { label: p, value: m, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[39] = o, e[40] = r.copyPrefix, e[41] = r.rows.deployedAt, e[42] = r.values.none, e[43] = r.values.unknown, e[44] = i, e[45] = m, e[46] = h) : h = e[46];
  let b;
  e[47] !== o || e[48] !== n.parameterName || e[49] !== r.copyPrefix || e[50] !== r.rows.ssmParameter || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i ? (b = /* @__PURE__ */ g(Dn, { label: r.rows.ssmParameter, value: n.parameterName, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[47] = o, e[48] = n.parameterName, e[49] = r.copyPrefix, e[50] = r.rows.ssmParameter, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = b) : b = e[54];
  let v;
  return e[55] !== s || e[56] !== h || e[57] !== b || e[58] !== c || e[59] !== u || e[60] !== f ? (v = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    s,
    c,
    u,
    f,
    h,
    b
  ] }), e[55] = s, e[56] = h, e[57] = b, e[58] = c, e[59] = u, e[60] = f, e[61] = v) : v = e[61], v;
}
function ND({
  open: t,
  onOpenChange: e,
  appName: n,
  appLabel: o = n,
  labels: r = WS,
  environment: i = "local",
  branchName: s = "local",
  commitId: l = "local",
  releaseTag: a = "",
  recordParameterName: c = `/assetwatch/deployments/${i}/${n}`,
  record: u,
  isRecordLoading: d = !1,
  isRecordUnavailable: f = !1,
  awsRegion: p = "us-east-2",
  repoFullName: m = "AssetWatch1/fullstack.assetwatch",
  modalTitle: h = `${o} Release Info`,
  modalDescription: b = `Current ${o} release information for this environment.`
}) {
  const [v, C] = qe(null), y = typeof navigator < "u" && !!navigator.clipboard?.writeText;
  async function w(V, _) {
    !V || !y || (await navigator.clipboard.writeText(V), C(_), window.setTimeout(() => C(null), 1600));
  }
  if (d)
    return /* @__PURE__ */ g(bu, { open: t, onOpenChange: e, title: h, description: b, children: /* @__PURE__ */ F(br, { gap: 8, children: [
      /* @__PURE__ */ g($u, { size: "sm" }),
      /* @__PURE__ */ g(nn, { size: "sm", tone: "subtle", children: r.loadingReleaseInfo })
    ] }) });
  const R = u ?? jS({
    appName: n,
    environment: i,
    recordParameterName: c,
    commitId: l,
    branchName: s,
    releaseTag: a
  }), S = US(R.status), E = R.releaseTag || a || `${R.environment ?? "local"}-${wm(R.sourceSha, r.values.unknown)}`, N = R.sourceSha ?? l, M = wm(N, r.values.unknown), T = R.parameterName || c || r.values.unknown, P = YS(p, T), k = JSON.stringify(R, null, 2), I = R.releaseTag ? `https://github.com/${m}/tree/${R.releaseTag}` : "", D = N && N !== "local" ? `https://github.com/${m}/commit/${N}` : "", O = {
    appLabel: o,
    environment: R.environment ?? i,
    status: S,
    displayTag: E,
    sourceSha: N,
    shortSha: M,
    parameterName: T,
    ssmConsoleUrl: P,
    recordJson: k,
    githubTagUrl: I,
    githubCommitUrl: D,
    record: R
  };
  return /* @__PURE__ */ g(bu, { open: t, onOpenChange: e, title: h, description: b, footer: /* @__PURE__ */ F(br, { gap: 8, children: [
    /* @__PURE__ */ g(tn, { variant: "outline", size: "sm", icon: v === "record" ? "check-mark" : "copy-regular", disabled: !y, onClick: () => {
      w(O.recordJson, "record");
    }, children: r.copyRecord }),
    O.ssmConsoleUrl ? /* @__PURE__ */ g(tn, { variant: "primary", size: "sm", icon: "arrow-up-right", render: /* @__PURE__ */ g("a", { href: O.ssmConsoleUrl, target: "_blank", rel: "noreferrer", "aria-label": r.openSsmAriaLabel, children: r.openSsm }), children: r.openSsm }) : null
  ] }), children: /* @__PURE__ */ F(Zo, { gap: 16, children: [
    f ? /* @__PURE__ */ g(nn, { size: "sm", tone: "warning", children: r.recordUnavailable }) : null,
    /* @__PURE__ */ g(QS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(XS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(ZS, { display: O, labels: r }),
    /* @__PURE__ */ g("pre", { className: "max-h-[220px] overflow-auto rounded-(--radius-sm) border border-outline-subtle bg-surface-container p-(--spacing-12) text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: O.recordJson })
  ] }) });
}
function JS(t) {
  return t.split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0]).join("").toUpperCase();
}
function kD(t) {
  const e = B.c(27), {
    company: n,
    selected: o,
    onSettingsClick: r
  } = t, i = o === void 0 ? !1 : o, {
    collapsed: s,
    closeMobileNavigation: l
  } = b0(), a = n.facilityCount === void 0 ? void 0 : n.facilityCount + (n.facilityCount === 1 ? " facility" : " facilities"), c = `relative flex h-[60px] min-w-0 items-center gap-(--spacing-6) rounded-(--radius-sm) border border-outline-subtle px-(--spacing-10)${i ? " bg-menu-item-selected" : " bg-surface"}${s ? " w-[60px] shrink-0 justify-center" : " w-full"}`, u = n.name;
  let d;
  e[0] !== n.name ? (d = JS(n.name), e[0] = n.name, e[1] = d) : d = e[1];
  let f;
  e[2] !== n.logoUrl || e[3] !== n.name || e[4] !== d ? (f = /* @__PURE__ */ g(jr, { "aria-label": u, initials: d, src: n.logoUrl, variant: "external" }), e[2] = n.logoUrl, e[3] = n.name, e[4] = d, e[5] = f) : f = e[5];
  let p;
  e[6] !== s || e[7] !== n.name || e[8] !== a || e[9] !== r ? (p = !s && /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ F("span", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ g("span", { className: "block truncate text-(length:--font-size-label-large) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-menu-text-default", children: n.name }),
      a && /* @__PURE__ */ g("span", { className: "block text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: a })
    ] }),
    r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "shrink-0", children: /* @__PURE__ */ g(We, { name: "settings-cog", size: "sm", tone: "secondary" }) })
  ] }), e[6] = s, e[7] = n.name, e[8] = a, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ F(Vt, { children: [
    f,
    p
  ] }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  const h = m;
  if (r) {
    const v = `Open ${n.name} settings`, C = i ? "page" : void 0, y = `${c} cursor-pointer text-left outline-none transition-colors duration-200 ease-in-out ${i ? "hover:bg-menu-item-selected" : "hover:bg-menu-item-hover"} focus-visible:ring-2 focus-visible:ring-menu-focus-ring focus-visible:ring-inset`, w = i || void 0;
    let R;
    e[14] !== l || e[15] !== r ? (R = () => {
      r(), l?.();
    }, e[14] = l, e[15] = r, e[16] = R) : R = e[16];
    let S;
    return e[17] !== h || e[18] !== w || e[19] !== R || e[20] !== v || e[21] !== C || e[22] !== y ? (S = /* @__PURE__ */ g("button", { "aria-label": v, "aria-current": C, className: y, "data-slot": "company-navigation", "data-selected": w, onClick: R, type: "button", children: h }), e[17] = h, e[18] = w, e[19] = R, e[20] = v, e[21] = C, e[22] = y, e[23] = S) : S = e[23], S;
  }
  let b;
  return e[24] !== c || e[25] !== h ? (b = /* @__PURE__ */ g("div", { className: c, "data-slot": "company-navigation", children: h }), e[24] = c, e[25] = h, e[26] = b) : b = e[26], b;
}
const wf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (wf.displayName = "SelectRootContext");
const Sf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Sf.displayName = "SelectFloatingContext");
function Ao() {
  const t = x.useContext(wf);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : tt(60));
  return t;
}
function k0() {
  const t = x.useContext(Sf);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : tt(61));
  return t;
}
const I0 = (t, e) => Object.is(t, e);
function go(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function P0(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : go(e, o, n));
}
function Po(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : go(o, e, n));
}
function M0(t, e, n) {
  return t.filter((o) => !go(e, o, n));
}
function jl(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function Rf(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function T0(t) {
  if (!Array.isArray(t))
    return t != null && "null" in t;
  const e = t;
  if (Rf(e)) {
    for (const n of e)
      for (const o of n.items)
        if (o && o.value == null && o.label != null)
          return !0;
    return !1;
  }
  for (const n of e)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function en(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return jl(t);
}
function Gn(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? jl(t.value) : jl(t);
}
function O0(t, e, n) {
  function o() {
    return en(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = e, i = Rf(r) ? r.flatMap((s) => s.items) : r;
    if (t == null || typeof t != "object") {
      const s = i.find((l) => l.value === t);
      return s && s.label != null ? s.label : o();
    }
    if ("value" in t) {
      const s = i.find((l) => l && l.value === t.value);
      if (s && s.label != null)
        return s.label;
    }
  }
  return o();
}
function eR(t, e, n) {
  return t.reduce((o, r, i) => (i > 0 && o.push(", "), o.push(/* @__PURE__ */ g(x.Fragment, {
    children: O0(r, e, n)
  }, i)), o), []);
}
const ft = {
  id: ge((t) => t.id),
  labelId: ge((t) => t.labelId),
  modal: ge((t) => t.modal),
  multiple: ge((t) => t.multiple),
  items: ge((t) => t.items),
  itemToStringLabel: ge((t) => t.itemToStringLabel),
  itemToStringValue: ge((t) => t.itemToStringValue),
  isItemEqualToValue: ge((t) => t.isItemEqualToValue),
  value: ge((t) => t.value),
  hasSelectedValue: ge((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : Gn(e, o) !== "";
  }),
  hasNullItemLabel: ge((t, e) => e ? T0(t.items) : !1),
  open: ge((t) => t.open),
  mounted: ge((t) => t.mounted),
  forceMount: ge((t) => t.forceMount),
  transitionStatus: ge((t) => t.transitionStatus),
  openMethod: ge((t) => t.openMethod),
  activeIndex: ge((t) => t.activeIndex),
  selectedIndex: ge((t) => t.selectedIndex),
  isActive: ge((t, e) => t.activeIndex === e),
  isSelected: ge((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((i) => go(n, i, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : go(n, r, o);
  }),
  isSelectedByFocus: ge((t, e) => t.selectedIndex === e),
  popupProps: ge((t) => t.popupProps),
  triggerProps: ge((t) => t.triggerProps),
  triggerElement: ge((t) => t.triggerElement),
  positionerElement: ge((t) => t.positionerElement),
  listElement: ge((t) => t.listElement),
  scrollUpArrowVisible: ge((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: ge((t) => t.scrollDownArrowVisible),
  hasScrollArrows: ge((t) => t.hasScrollArrows)
}, Co = 1;
function D0(t, e) {
  return Math.max(0, t - e);
}
function tR(t, e) {
  if (e <= 0)
    return 0;
  const n = Ut(t, 0, e), o = n, r = e - n, i = o <= Co, s = r <= Co;
  return i && s ? o <= r ? 0 : e : i ? 0 : s ? e : n;
}
function _0(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: i,
    defaultOpen: s = !1,
    onOpenChange: l,
    name: a,
    form: c,
    autoComplete: u,
    disabled: d = !1,
    readOnly: f = !1,
    required: p = !1,
    modal: m = !0,
    actionsRef: h,
    inputRef: b,
    onOpenChangeComplete: v,
    items: C,
    multiple: y = !1,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S = I0,
    highlightItemOnHover: E = !0,
    children: N
  } = t, {
    clearErrors: M
  } = Vo(), {
    setDirty: T,
    setTouched: P,
    setFocused: k,
    shouldValidateOnChange: I,
    validityData: D,
    setFilled: O,
    name: V,
    disabled: _,
    validation: L,
    validationMode: A
  } = on(), $ = Mr({
    id: e
  }), Y = _ || d, z = V ?? a, [H, K] = pn({
    controlled: n,
    default: y ? o ?? _n : o,
    name: "Select",
    state: "value"
  }), [G, q] = pn({
    controlled: i,
    default: s,
    name: "Select",
    state: "open"
  }), ee = x.useRef([]), W = x.useRef([]), X = x.useRef(null), J = x.useRef(null), re = x.useRef(0), Q = x.useRef(null), ie = x.useRef([]), ce = x.useRef(!1), oe = x.useRef(!1), se = x.useRef(null), fe = x.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), be = x.useRef(!1), {
    mounted: le,
    setMounted: me,
    transitionStatus: j
  } = Xn(G), {
    openMethod: te,
    triggerProps: U
  } = Ss(G), Z = Tt(() => new hd({
    id: $,
    labelId: void 0,
    modal: m,
    multiple: y,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S,
    value: H,
    open: G,
    mounted: le,
    transitionStatus: j,
    items: C,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, ue = ve(Z, ft.activeIndex), pe = ve(Z, ft.selectedIndex), he = ve(Z, ft.triggerElement), Ie = ve(Z, ft.positionerElement), ye = m9(te), xe = te ?? ye, de = x.useMemo(() => y && Array.isArray(H) && H.length === 0 ? "" : Gn(H, R), [y, H, R]), we = x.useMemo(() => y && Array.isArray(H) ? H.map((Ye) => Gn(Ye, R)) : Gn(H, R), [y, H, R]), Me = Ht(Z.state.triggerElement), Re = Ce(() => we);
  gi(Me, {
    id: $,
    value: H,
    getValue: Re
  });
  const Ve = x.useRef(H);
  Ne(() => {
    H !== Ve.current && Z.set("forceMount", !0);
  }, [Z, H]), Ne(() => {
    O(y ? Array.isArray(H) && H.length > 0 : H != null);
  }, [y, H, O]), Ne(function() {
    if (G)
      return;
    const Xe = ie.current;
    if (y) {
      const ct = Array.isArray(H) ? H : [];
      if (ct.length === 0) {
        Z.set("selectedIndex", null);
        return;
      }
      const mt = ct[ct.length - 1], ht = Po(Xe, mt, S);
      Z.set("selectedIndex", ht === -1 ? null : ht);
      return;
    }
    const rt = Po(Xe, H, S);
    Z.set("selectedIndex", rt === -1 ? null : rt);
  }, [y, G, H, ie, S, Z]), So(H, () => {
    M(z), T(H !== D.initialValue), I() ? L.commit(H) : L.commit(H, !0);
  });
  const je = Ce((Ye, Xe) => {
    if (l?.(Ye, Xe), !Xe.isCanceled && (q(Ye), !Ye && (Xe.reason === Mo || Xe.reason === ls) && (P(!0), k(!1), A === "onBlur" && L.commit(H)), !Ye && Z.state.activeIndex !== null)) {
      const rt = ee.current[Z.state.activeIndex];
      queueMicrotask(() => {
        rt?.setAttribute("tabindex", "-1");
      });
    }
  }), Ze = Ce(() => {
    me(!1), Z.update({
      activeIndex: null,
      openMethod: null
    }), v?.(!1);
  });
  jt({
    enabled: !h,
    open: G,
    ref: X,
    onComplete() {
      G || Ze();
    }
  }), x.useImperativeHandle(h, () => ({
    unmount: Ze
  }), [Ze]);
  const ze = Ce((Ye, Xe) => {
    r?.(Ye, Xe), !Xe.isCanceled && K(Ye);
  }), Ee = Ce(() => {
    const Ye = Z.state.listElement || X.current;
    if (!Ye)
      return;
    const Xe = D0(Ye.scrollHeight, Ye.clientHeight), rt = tR(Ye.scrollTop, Xe), ct = rt > 0, mt = rt < Xe;
    Z.state.scrollUpArrowVisible !== ct && Z.set("scrollUpArrowVisible", ct), Z.state.scrollDownArrowVisible !== mt && Z.set("scrollDownArrowVisible", mt);
  }), Ae = vd({
    open: G,
    onOpenChange: je,
    elements: {
      reference: he,
      floating: Ie
    }
  }), Pe = wr(Ae, {
    enabled: !f && !Y,
    event: "mousedown"
  }), Oe = Sr(Ae, {
    bubbles: !1
  }), $e = Cd(Ae, {
    enabled: !f && !Y,
    listRef: ee,
    activeIndex: ue,
    selectedIndex: pe,
    disabledIndices: _n,
    onNavigate(Ye) {
      Ye === null && !G || Z.set("activeIndex", Ye);
    },
    focusItemOnHover: E
  }), Te = Sd(Ae, {
    enabled: !f && !Y && (G || !y),
    listRef: W,
    activeIndex: ue,
    selectedIndex: pe,
    onMatch(Ye) {
      G ? Z.set("activeIndex", Ye) : ze(ie.current[Ye], _e("none"));
    },
    onTypingChange(Ye) {
      ce.current = Ye;
    }
  }), {
    getReferenceProps: vt,
    getFloatingProps: st,
    getItemProps: Se
  } = eo([Pe, Oe, $e, Te]), ke = x.useMemo(() => Jt(vt(), U, $ ? {
    id: $
  } : St), [vt, U, $]);
  Ir(() => {
    Z.update({
      popupProps: st(),
      triggerProps: ke
    });
  }), Ne(() => {
    Z.update({
      id: $,
      modal: m,
      multiple: y,
      value: H,
      open: G,
      mounted: le,
      transitionStatus: j,
      popupProps: st(),
      triggerProps: ke,
      items: C,
      itemToStringLabel: w,
      itemToStringValue: R,
      isItemEqualToValue: S,
      openMethod: xe
    });
  }, [Z, $, m, y, H, G, le, j, st, ke, C, w, R, S, xe]);
  const Fe = x.useMemo(() => ({
    store: Z,
    name: z,
    required: p,
    disabled: Y,
    readOnly: f,
    multiple: y,
    highlightItemOnHover: E,
    setValue: ze,
    setOpen: je,
    listRef: ee,
    popupRef: X,
    scrollHandlerRef: J,
    handleScrollArrowVisibility: Ee,
    scrollArrowsMountedCountRef: re,
    getItemProps: Se,
    events: Ae.context.events,
    valueRef: Q,
    valuesRef: ie,
    labelsRef: W,
    typingRef: ce,
    selectionRef: fe,
    selectedItemTextRef: se,
    validation: L,
    onOpenChangeComplete: v,
    keyboardActiveRef: oe,
    alignItemWithTriggerActiveRef: be,
    initialValueRef: Ve
  }), [Z, z, p, Y, f, y, E, ze, je, Se, Ae.context.events, L, v, Ee]), Ue = mn(b, L.inputRef), it = y && Array.isArray(H) && H.length > 0, Ke = y ? void 0 : z, ot = x.useMemo(() => !y || !Array.isArray(H) || !z ? null : H.map((Ye) => {
    const Xe = Gn(Ye, R);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: c,
      name: z,
      value: Xe
    }, Xe);
  }), [y, H, c, z, R]);
  return /* @__PURE__ */ g(wf.Provider, {
    value: Fe,
    children: /* @__PURE__ */ F(Sf.Provider, {
      value: Ae,
      children: [N, /* @__PURE__ */ g("input", {
        ...L.getInputValidationProps({
          onFocus() {
            Z.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ye) {
            if (Ye.nativeEvent.defaultPrevented)
              return;
            const Xe = Ye.currentTarget.value, rt = _e(Mt, Ye.nativeEvent);
            function ct() {
              if (y)
                return;
              const mt = ie.current.find((ht) => Gn(ht, R).toLowerCase() === Xe.toLowerCase() || en(ht, w).toLowerCase() === Xe.toLowerCase());
              mt != null && (T(mt !== D.initialValue), ze(mt, rt), I() && L.commit(mt));
            }
            Z.set("forceMount", !0), queueMicrotask(ct);
          }
        }),
        id: $ && Ke == null ? `${$}-hidden-input` : void 0,
        form: c,
        name: Ke,
        autoComplete: u,
        value: de,
        disabled: Y,
        required: p && !it,
        readOnly: f,
        ref: Ue,
        style: z ? ni : er,
        tabIndex: -1,
        "aria-hidden": !0,
        suppressHydrationWarning: !0
      }), ot]
    })
  });
}
function Ef(t, e) {
  return t ?? e;
}
const ll = 2, nR = 400, Sm = 200, oR = {
  ...Yi,
  ...to,
  value: () => null
}, Nf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    disabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    setTouched: u,
    setFocused: d,
    validationMode: f,
    state: p,
    disabled: m
  } = on(), {
    labelId: h
  } = hn(), {
    store: b,
    setOpen: v,
    selectionRef: C,
    validation: y,
    readOnly: w,
    required: R,
    alignItemWithTriggerActiveRef: S,
    disabled: E,
    keyboardActiveRef: N
  } = Ao(), M = m || E || s, T = ve(b, ft.open), P = ve(b, ft.value), k = ve(b, ft.triggerProps), I = ve(b, ft.positionerElement), D = ve(b, ft.listElement), O = ve(b, ft.id), V = ve(b, ft.labelId), _ = ve(b, ft.hasSelectedValue), L = !_ && T, A = ve(b, ft.hasNullItemLabel, L), $ = i ?? O, Y = Ef(h, V);
  Mr({
    id: $
  });
  const z = Ht(I), H = x.useRef(null), {
    getButtonProps: K,
    buttonRef: G
  } = Wt({
    disabled: M,
    native: l
  }), q = Ce((oe) => {
    b.set("triggerElement", oe);
  }), ee = mn(n, H, G, q), W = _t(), X = _t(), J = _t(), re = _t();
  x.useEffect(() => {
    if (T)
      return !(_ || A) ? J.start(nR, () => {
        C.current.allowUnselectedMouseUp = !0, C.current.allowSelectedMouseUp = !0;
      }) : re.start(Sm, () => {
        C.current.allowUnselectedMouseUp = !0, J.start(Sm, () => {
          C.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        J.clear(), re.clear();
      };
    C.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, X.clear();
  }, [T, _, A, C, X, J, re]);
  const Q = x.useMemo(() => D?.id ?? Ki(I)?.id, [D, I]), ie = Jt(k, {
    id: $,
    role: "combobox",
    "aria-expanded": T ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": T ? Q : void 0,
    "aria-labelledby": Y,
    "aria-readonly": w || void 0,
    "aria-required": R || void 0,
    tabIndex: M ? -1 : 0,
    ref: ee,
    onFocus(oe) {
      d(!0), T && S.current && v(!1, _e(Mt, oe.nativeEvent)), W.start(0, () => {
        b.set("forceMount", !0);
      });
    },
    onBlur(oe) {
      He(I, oe.relatedTarget) || (u(!0), d(!1), f === "onBlur" && y.commit(P));
    },
    onPointerMove() {
      N.current = !1;
    },
    onKeyDown() {
      N.current = !0;
    },
    onMouseDown(oe) {
      if (T)
        return;
      const se = et(oe.currentTarget);
      function fe(be) {
        if (!H.current)
          return;
        const le = be.target;
        if (He(H.current, le) || He(z.current, le) || le === H.current)
          return;
        const me = Md(H.current);
        be.clientX >= me.left - ll && be.clientX <= me.right + ll && be.clientY >= me.top - ll && be.clientY <= me.bottom + ll || v(!1, _e(Xg, be));
      }
      X.start(0, () => {
        se.addEventListener("mouseup", fe, {
          once: !0
        });
      });
    }
  }, y.getValidationProps, c, K);
  ie.role = "combobox";
  const ce = {
    ...p,
    open: T,
    disabled: M,
    value: P,
    readOnly: w,
    placeholder: !_
  };
  return Le("button", e, {
    ref: [n, H],
    state: ce,
    stateAttributesMapping: oR,
    props: ie
  });
});
process.env.NODE_ENV !== "production" && (Nf.displayName = "SelectTrigger");
const rR = {
  value: () => null
}, V0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    placeholder: s,
    style: l,
    ...a
  } = e, {
    store: c,
    valueRef: u
  } = Ao(), d = ve(c, ft.value), f = ve(c, ft.items), p = ve(c, ft.itemToStringLabel), m = ve(c, ft.hasSelectedValue), h = !m && s != null && i == null, b = ve(c, ft.hasNullItemLabel, h), v = {
    value: d,
    placeholder: !m
  };
  let C = null;
  return typeof i == "function" ? C = i(d) : i != null ? C = i : !m && s != null && !b ? C = s : Array.isArray(d) ? C = eR(d, f, p) : C = O0(d, f, p), Le("span", e, {
    state: v,
    ref: [n, u],
    props: [{
      children: C
    }, a],
    stateAttributesMapping: rR
  });
});
process.env.NODE_ENV !== "production" && (V0.displayName = "SelectValue");
const A0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l
  } = Ao(), c = {
    open: ve(l, ft.open)
  };
  return Le("span", e, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, s],
    stateAttributesMapping: yr
  });
});
process.env.NODE_ENV !== "production" && (A0.displayName = "SelectIcon");
const L0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (L0.displayName = "SelectPortalContext");
const kf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    store: o
  } = Ao(), r = ve(o, ft.mounted), i = ve(o, ft.forceMount);
  return r || i ? /* @__PURE__ */ g(L0.Provider, {
    value: !0,
    children: /* @__PURE__ */ g(oi, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (kf.displayName = "SelectPortal");
const If = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (If.displayName = "SelectPositionerContext");
function F0() {
  const t = x.useContext(If);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : tt(59));
  return t;
}
function Kl(t, e) {
  t && Object.assign(t.style, e);
}
const $0 = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, iR = {
  position: "fixed"
}, Pf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h,
    alignItemWithTrigger: b = !0,
    collisionAvoidance: v = rd,
    style: C,
    ...y
  } = e, {
    store: w,
    listRef: R,
    labelsRef: S,
    alignItemWithTriggerActiveRef: E,
    selectedItemTextRef: N,
    valuesRef: M,
    initialValueRef: T,
    popupRef: P,
    setValue: k
  } = Ao(), I = k0(), D = ve(w, ft.open), O = ve(w, ft.mounted), V = ve(w, ft.modal), _ = ve(w, ft.value), L = ve(w, ft.openMethod), A = ve(w, ft.positionerElement), $ = ve(w, ft.triggerElement), Y = ve(w, ft.isItemEqualToValue), z = ve(w, ft.transitionStatus), H = x.useRef(null), K = x.useRef(null), [G, q] = x.useState(b), ee = O && G && L !== "touch";
  !O && G !== b && q(b), Ne(() => {
    O || (ft.scrollUpArrowVisible(w.state) && w.set("scrollUpArrowVisible", !1), ft.scrollDownArrowVisible(w.state) && w.set("scrollDownArrowVisible", !1));
  }, [w, O]), x.useImperativeHandle(E, () => ee), ba((ee || V) && D, L === "touch", A, $);
  const W = ii({
    anchor: o,
    floatingRootContext: I,
    positionMethod: r,
    mounted: O,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h ?? ee,
    collisionAvoidance: v,
    keepMounted: !0
  }), X = ee ? "none" : W.side, J = ee ? iR : W.positionerStyles, re = {
    open: D,
    side: X,
    align: W.align,
    anchorHidden: W.anchorHidden
  }, Q = Ce((fe) => {
    w.set("positionerElement", fe);
  }), ie = ai(e, re, {
    styles: J,
    transitionStatus: z,
    props: y,
    refs: [n, Q],
    hidden: !O,
    inert: !D
  }), ce = x.useRef(0), oe = Ce((fe) => {
    if (fe.size === 0 && ce.current === 0 || M.current.length === 0)
      return;
    const be = ce.current;
    if (ce.current = fe.size, fe.size === be)
      return;
    const le = _e(Mt);
    if (be !== 0 && !w.state.multiple && _ !== null && Po(M.current, _, Y) === -1) {
      const j = T.current, U = j != null && Po(M.current, j, Y) !== -1 ? j : null;
      k(U, le), U === null && (w.set("selectedIndex", null), N.current = null);
    }
    if (be !== 0 && w.state.multiple && Array.isArray(_)) {
      const me = (te) => Po(M.current, te, Y) !== -1, j = _.filter((te) => me(te));
      (j.length !== _.length || j.some((te) => !P0(_, te, Y))) && (k(j, le), j.length === 0 && (w.set("selectedIndex", null), N.current = null));
    }
    if (D && ee) {
      w.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const me = {
        height: ""
      };
      Kl(A, me), Kl(P.current, me);
    }
  }), se = x.useMemo(() => ({
    ...W,
    side: X,
    alignItemWithTriggerActive: ee,
    setControlledAlignItemWithTrigger: q,
    scrollUpArrowRef: H,
    scrollDownArrowRef: K
  }), [W, X, ee, q]);
  return /* @__PURE__ */ g(si, {
    elementsRef: R,
    labelsRef: S,
    onMapChange: oe,
    children: /* @__PURE__ */ F(If.Provider, {
      value: se,
      children: [O && V && /* @__PURE__ */ g(li, {
        inert: kr(!D),
        cutout: $
      }), ie]
    })
  });
});
process.env.NODE_ENV !== "production" && (Pf.displayName = "SelectPositioner");
const al = "base-ui-disable-scrollbar", ql = {
  className: al,
  getElement(t) {
    return /* @__PURE__ */ g("style", {
      nonce: t,
      href: al,
      precedence: "base-ui:low",
      children: `.${al}{scrollbar-width:none}.${al}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (ql.getElement.displayName = "styleDisableScrollbar.getElement");
const H0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (H0.displayName = "CSPContext");
const sR = {
  disableStyleElements: !1
};
function lR() {
  return x.useContext(H0) ?? sR;
}
const aR = {
  ...In,
  ...Bt
}, Mf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a,
    popupRef: c,
    onOpenChangeComplete: u,
    setOpen: d,
    valueRef: f,
    selectedItemTextRef: p,
    keyboardActiveRef: m,
    multiple: h,
    handleScrollArrowVisibility: b,
    scrollHandlerRef: v,
    listRef: C,
    highlightItemOnHover: y
  } = Ao(), {
    side: w,
    align: R,
    alignItemWithTriggerActive: S,
    isPositioned: E,
    setControlledAlignItemWithTrigger: N,
    scrollDownArrowRef: M,
    scrollUpArrowRef: T
  } = F0(), P = Rd() != null, k = k0(), I = ws(), {
    nonce: D,
    disableStyleElements: O
  } = lR(), V = ve(a, ft.id), _ = ve(a, ft.open), L = ve(a, ft.mounted), A = ve(a, ft.popupProps), $ = ve(a, ft.transitionStatus), Y = ve(a, ft.triggerElement), z = ve(a, ft.positionerElement), H = ve(a, ft.listElement), K = x.useRef(!1), G = x.useRef(!1), q = x.useRef({}), ee = ti(), W = Ce((Q) => {
    if (!z || !c.current || !G.current)
      return;
    if (K.current || !S) {
      b();
      return;
    }
    const ie = z.style.top === "0px", ce = z.style.bottom === "0px";
    if (!ie && !ce) {
      b();
      return;
    }
    const oe = Em(z), se = Li(z.getBoundingClientRect().height, "y", oe), fe = et(z), be = getComputedStyle(z), le = parseFloat(be.marginTop), me = parseFloat(be.marginBottom), j = Rm(getComputedStyle(c.current)), te = Math.min(fe.documentElement.clientHeight - le - me, j), U = Q.scrollTop, Z = cl(Q);
    let ue = 0, pe = null, he = !1, Ie = !1;
    const ye = (Me) => {
      z.style.height = `${Me}px`;
    }, xe = (Me, Re) => {
      const Ve = Ut(Me, 0, te - se);
      Ve > 0 && ye(se + Ve), Q.scrollTop = Re, te - (se + Ve) <= Co && (K.current = !0), b();
    }, de = ie ? Z - U : U, we = Math.min(se + de, te);
    if (ue = we, de <= Co) {
      xe(de, ie ? Z : 0);
      return;
    }
    if (te - we > Co)
      ie ? Ie = !0 : pe = 0;
    else if (he = !0, ce && U < Z) {
      const Me = se + de - te;
      pe = U - (de - Me);
    }
    if (ue = Math.ceil(ue), ue !== 0 && ye(ue), Ie || pe != null) {
      const Me = cl(Q), Re = Ie ? Me : Ut(pe, 0, Me);
      Math.abs(Q.scrollTop - Re) > Co && (Q.scrollTop = Re);
    }
    (he || ue >= te - Co) && (K.current = !0), b();
  });
  x.useImperativeHandle(v, () => W, [W]), jt({
    open: _,
    ref: c,
    onComplete() {
      _ && u?.(!0);
    }
  });
  const X = {
    open: _,
    transitionStatus: $,
    side: w,
    align: R
  };
  Ne(() => {
    !z || !c.current || Object.keys(q.current).length || (q.current = {
      top: z.style.top || "0",
      left: z.style.left || "0",
      right: z.style.right,
      height: z.style.height,
      bottom: z.style.bottom,
      minHeight: z.style.minHeight,
      maxHeight: z.style.maxHeight,
      marginTop: z.style.marginTop,
      marginBottom: z.style.marginBottom
    });
  }, [c, z]), Ne(() => {
    _ || S || (G.current = !1, K.current = !1, Kl(z, q.current));
  }, [_, S, z, c]), Ne(() => {
    const Q = c.current;
    if (!_ || !Y || !z || !Q || S && !E || a.state.transitionStatus === "ending")
      return;
    if (!S) {
      G.current = !0, ee.request(b), Q.style.removeProperty("--transform-origin");
      return;
    }
    const ie = cR(Q);
    Q.style.removeProperty("--transform-origin");
    try {
      const ce = p.current, oe = f.current, se = getComputedStyle(z), fe = getComputedStyle(Q), be = et(Y), le = wt(z), me = Em(Y), j = ul(Y.getBoundingClientRect(), me), te = ul(z.getBoundingClientRect(), me), U = j.height, Z = H || Q, ue = Z.scrollHeight, pe = parseFloat(fe.borderBottomWidth), he = parseFloat(se.marginTop) || 10, Ie = parseFloat(se.marginBottom) || 10, ye = parseFloat(se.minHeight) || 100, xe = Rm(fe), de = 5, we = 5, Me = 20, Re = be.documentElement.clientHeight - he - Ie, Ve = be.documentElement.clientWidth, je = Re - j.bottom + U;
      let Ze, ze = I === "rtl" ? j.right - te.width : j.left, Ee = 0;
      if (ce && oe) {
        const Ue = ul(oe.getBoundingClientRect(), me);
        Ze = ul(ce.getBoundingClientRect(), me), ze = te.left + (I === "rtl" ? Ue.right - Ze.right : Ue.left - Ze.left);
        const it = Ue.top - j.top + Ue.height / 2;
        Ee = Ze.top - te.top + Ze.height / 2 - it;
      }
      const Ae = je + Ee + Ie + pe;
      let Pe = Math.min(Re, Ae);
      const Oe = Re - he - Ie, $e = Ae - Pe, Te = Ve - we;
      z.style.left = `${Ut(ze, de, Te - te.width)}px`, z.style.height = `${Pe}px`, z.style.maxHeight = "auto", z.style.marginTop = `${he}px`, z.style.marginBottom = `${Ie}px`, Q.style.height = "100%";
      const vt = cl(Z), st = $e >= vt - Co;
      st && (Pe = Math.min(Re, te.height) - ($e - vt));
      const Se = j.top < Me || j.bottom > Re - Me || Math.ceil(Pe) + Co < Math.min(ue, ye), ke = (le.visualViewport?.scale ?? 1) !== 1 && Uu;
      if (Se || ke) {
        G.current = !0, Kl(z, q.current), N(!1);
        return;
      }
      const Fe = Math.max(ye, Pe);
      if (st) {
        const Ue = Math.max(0, Re - Ae);
        z.style.top = te.height >= Oe ? "0" : `${Ue}px`, z.style.height = `${Pe}px`, Z.scrollTop = cl(Z);
      } else
        z.style.bottom = "0", Z.scrollTop = $e;
      if (Ze) {
        const Ue = te.top, it = te.height, Ke = Ze.top + Ze.height / 2, ot = it > 0 ? (Ke - Ue) / it * 100 : 50, Ye = Ut(ot, 0, 100);
        Q.style.setProperty("--transform-origin", `50% ${Ye}%`);
      }
      (Fe === Re || Pe >= xe) && (K.current = !0), b(), y && a.state.selectedIndex === null && a.state.activeIndex === null && C.current[0] != null && a.set("activeIndex", 0), G.current = !0;
    } finally {
      ie();
    }
  }, [a, _, z, Y, f, p, c, b, S, N, ee, M, T, H, C, y, I, E]), x.useEffect(() => {
    if (!S || !z || !_)
      return;
    const Q = wt(z);
    function ie(ce) {
      d(!1, _e(f8, ce));
    }
    return dt(Q, "resize", ie);
  }, [d, S, z, _]);
  const J = {
    ...H ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": h || void 0,
      id: `${V}-list`
    },
    onKeyDown(Q) {
      m.current = !0, P && Cs.has(Q.key) && Q.stopPropagation();
    },
    onMouseMove() {
      m.current = !1;
    },
    onScroll(Q) {
      H || W(Q.currentTarget);
    },
    ...S && {
      style: H ? {
        height: "100%"
      } : $0
    }
  }, re = Le("div", e, {
    ref: [n, c],
    state: X,
    stateAttributesMapping: aR,
    props: [A, J, Nr($), {
      className: !H && S ? ql.className : void 0
    }, l]
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!O && ql.getElement(D), /* @__PURE__ */ g(ri, {
      context: k,
      modal: !1,
      disabled: !L,
      returnFocus: s,
      restoreFocus: !0,
      children: re
    })]
  });
});
process.env.NODE_ENV !== "production" && (Mf.displayName = "SelectPopup");
function Rm(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
function cl(t) {
  return D0(t.scrollHeight, t.clientHeight);
}
function Em(t) {
  return zh.getScale(t);
}
function Li(t, e, n) {
  return t / n[e];
}
function ul(t, e) {
  return qi({
    x: Li(t.x, "x", e),
    y: Li(t.y, "y", e),
    width: Li(t.width, "x", e),
    height: Li(t.height, "y", e)
  });
}
const Nm = [["transform", "none"], ["scale", "1"], ["translate", "0 0"]];
function cR(t) {
  const {
    style: e
  } = t, n = {};
  for (const [o, r] of Nm)
    n[o] = e.getPropertyValue(o), e.setProperty(o, r, "important");
  return () => {
    for (const [o] of Nm) {
      const r = n[o];
      r ? e.setProperty(o, r) : e.removeProperty(o);
    }
  };
}
const Tf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l,
    scrollHandlerRef: a
  } = Ao(), {
    alignItemWithTriggerActive: c
  } = F0(), u = ve(l, ft.hasScrollArrows), d = ve(l, ft.openMethod), f = ve(l, ft.multiple), m = {
    id: `${ve(l, ft.id)}-list`,
    role: "listbox",
    "aria-multiselectable": f || void 0,
    onScroll(b) {
      a.current?.(b.currentTarget);
    },
    ...c && {
      style: $0
    },
    className: u && d !== "touch" ? ql.className : void 0
  }, h = Ce((b) => {
    l.set("listElement", b);
  });
  return Le("div", e, {
    ref: [n, h],
    props: [m, s]
  });
});
process.env.NODE_ENV !== "production" && (Tf.displayName = "SelectList");
const Of = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Of.displayName = "SelectItemContext");
function Df() {
  const t = x.useContext(Of);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : tt(57));
  return t;
}
const _f = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    label: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(null), f = Do({
    label: s,
    textRef: d,
    indexGuessBehavior: Ku.GuessFromOrder
  }), {
    store: p,
    getItemProps: m,
    setOpen: h,
    setValue: b,
    selectionRef: v,
    typingRef: C,
    valuesRef: y,
    multiple: w,
    selectedItemTextRef: R
  } = Ao(), S = ve(p, ft.isActive, f.index), E = ve(p, ft.isSelected, f.index, i), N = ve(p, ft.isSelectedByFocus, f.index), M = ve(p, ft.isItemEqualToValue), T = f.index, P = T !== -1, k = x.useRef(null), I = Ht(T);
  Ne(() => {
    if (!P)
      return;
    const G = y.current;
    return G[T] = i, () => {
      delete G[T];
    };
  }, [P, T, i, y]), Ne(() => {
    if (!P)
      return;
    const G = p.state.value;
    let q = G;
    w && Array.isArray(G) && G.length > 0 && (q = G[G.length - 1]), q !== void 0 && go(i, q, M) && (p.set("selectedIndex", T), d.current && (R.current = d.current));
  }, [P, T, w, M, p, i, R]);
  const D = {
    disabled: l,
    selected: E,
    highlighted: S
  }, O = m({
    active: S,
    selected: E
  });
  O.id = void 0;
  const V = x.useRef(null), _ = x.useRef("mouse"), L = x.useRef(!1), {
    getButtonProps: A,
    buttonRef: $
  } = Wt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function Y(G) {
    const q = p.state.value;
    if (w) {
      const ee = Array.isArray(q) ? q : [], W = E ? M0(ee, i, M) : [...ee, i];
      b(W, _e(Uo, G));
    } else
      b(i, _e(Uo, G)), h(!1, _e(Uo, G));
  }
  const z = {
    role: "option",
    "aria-selected": E,
    tabIndex: S ? 0 : -1,
    onTouchStart() {
      v.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(G) {
      V.current = G.key, p.set("activeIndex", T), G.key === " " && C.current && G.preventDefault();
    },
    onClick(G) {
      L.current = !1, !(G.type === "keydown" && V.current === null) && (l || G.type === "keydown" && V.current === " " && C.current || _.current !== "touch" && !S || (V.current = null, Y(G.nativeEvent)));
    },
    onPointerEnter(G) {
      _.current = G.pointerType;
    },
    onPointerDown(G) {
      _.current = G.pointerType, L.current = !0;
    },
    onMouseUp() {
      if (l)
        return;
      if (L.current) {
        L.current = !1;
        return;
      }
      const G = !v.current.allowSelectedMouseUp && E, q = !v.current.allowUnselectedMouseUp && !E;
      G || q || _.current !== "touch" && !S || k.current?.click();
    }
  }, H = Le("div", e, {
    ref: [$, n, f.ref, k],
    state: D,
    props: [O, z, u, A]
  }), K = x.useMemo(() => ({
    selected: E,
    indexRef: I,
    textRef: d,
    selectedByFocus: N,
    hasRegistered: P
  }), [E, I, d, N, P]);
  return /* @__PURE__ */ g(Of.Provider, {
    value: K,
    children: H
  });
}));
process.env.NODE_ENV !== "production" && (_f.displayName = "SelectItem");
const z0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Df();
  return o || r ? /* @__PURE__ */ g(B0, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (z0.displayName = "SelectItemIndicator");
const B0 = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    style: r,
    keepMounted: i,
    ...s
  } = t, {
    selected: l
  } = Df(), a = x.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Xn(l), f = Le("span", t, {
    ref: [e, a],
    state: {
      selected: l,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, s],
    stateAttributesMapping: Bt
  });
  return jt({
    open: l,
    ref: a,
    onComplete() {
      l || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (B0.displayName = "Inner");
const Vf = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: i,
    hasRegistered: s
  } = Df(), {
    selectedItemTextRef: l
  } = Ao(), {
    className: a,
    render: c,
    style: u,
    ...d
  } = e, f = x.useCallback((m) => {
    if (!m || !s)
      return;
    const h = l.current === null || !l.current.isConnected;
    (i || h && o.current === 0) && (l.current = m);
  }, [l, o, i, s]);
  return Le("div", e, {
    ref: [f, n, r],
    props: d
  });
}));
process.env.NODE_ENV !== "production" && (Vf.displayName = "SelectItemText");
function uR(t) {
  const e = B.c(54), {
    id: n,
    options: o,
    value: r,
    selectedOption: i,
    onValueChange: s,
    open: l,
    onOpenChange: a,
    disabled: c,
    readOnly: u,
    required: d,
    name: f,
    placeholder: p,
    label: m,
    "data-testid": h,
    renderValue: b,
    renderOption: v,
    popupWidth: C,
    triggerClassName: y
  } = t, w = Kt(), R = m || n ? void 0 : u ? "Select option" : p ?? "Select option", S = d || void 0, E = u || void 0, N = u ? -1 : void 0, M = !i && !b && "text-input-text-placeholder";
  let T;
  e[0] !== M ? (T = ne("min-w-0 flex-1 truncate text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", M), e[0] = M, e[1] = T) : T = e[1];
  let P;
  e[2] !== p || e[3] !== u || e[4] !== b || e[5] !== i ? (P = b ? b(i) : i?.label ?? (u ? null : p), e[2] = p, e[3] = u, e[4] = b, e[5] = i, e[6] = P) : P = e[6];
  let k;
  e[7] !== T || e[8] !== P ? (k = /* @__PURE__ */ g("span", { className: T, children: P }), e[7] = T, e[8] = P, e[9] = k) : k = e[9];
  let I;
  e[10] !== h || e[11] !== u ? (I = !u && /* @__PURE__ */ g("span", { "data-testid": h ? `${h}-trigger` : void 0, className: "inline-flex shrink-0", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[10] = h, e[11] = u, e[12] = I) : I = e[12];
  let D;
  e[13] !== h || e[14] !== n || e[15] !== R || e[16] !== S || e[17] !== E || e[18] !== N || e[19] !== k || e[20] !== I || e[21] !== y ? (D = /* @__PURE__ */ F(Nf, { id: n, "data-testid": h, className: y, "aria-label": R, "aria-required": S, "aria-readonly": E, tabIndex: N, children: [
    k,
    I
  ] }), e[13] = h, e[14] = n, e[15] = R, e[16] = S, e[17] = E, e[18] = N, e[19] = k, e[20] = I, e[21] = y, e[22] = D) : D = e[22];
  const O = C === "content" ? "w-auto min-w-(--anchor-width)" : "w-(--anchor-width) min-w-[180px]";
  let V;
  e[23] !== O ? (V = ne("z-[var(--z-layer-popover)] max-w-[calc(100vw-var(--spacing-16))]", O), e[23] = O, e[24] = V) : V = e[24];
  let _;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = ui({
    size: "auto"
  }), e[25] = _) : _ = e[25];
  const L = h ? `${h}-options` : void 0;
  let A;
  if (e[26] !== o || e[27] !== v || e[28] !== r) {
    let K;
    e[30] !== v || e[31] !== r ? (K = (G) => /* @__PURE__ */ F(_f, { value: G.value, disabled: G.disabled, className: Oo({}), children: [
      G.icon && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(We, { name: G.icon, size: "xs", tone: "inherit" }) }),
      /* @__PURE__ */ g(Xr, { checked: G.value === r, children: /* @__PURE__ */ g(Vf, { children: v ? v(G) : G.label }) })
    ] }, G.value), e[30] = v, e[31] = r, e[32] = K) : K = e[32], A = o.map(K), e[26] = o, e[27] = v, e[28] = r, e[29] = A;
  } else
    A = e[29];
  let $;
  e[33] !== L || e[34] !== A ? ($ = /* @__PURE__ */ g(Mf, { className: _, children: /* @__PURE__ */ g(Tf, { "data-testid": L, className: "flex flex-col outline-none", children: A }) }), e[33] = L, e[34] = A, e[35] = $) : $ = e[35];
  let Y;
  e[36] !== V || e[37] !== $ ? (Y = /* @__PURE__ */ g(Pf, { alignItemWithTrigger: !1, sideOffset: 4, className: V, children: $ }), e[36] = V, e[37] = $, e[38] = Y) : Y = e[38];
  let z;
  e[39] !== w || e[40] !== Y ? (z = /* @__PURE__ */ g(kf, { container: w, children: Y }), e[39] = w, e[40] = Y, e[41] = z) : z = e[41];
  let H;
  return e[42] !== c || e[43] !== f || e[44] !== a || e[45] !== s || e[46] !== l || e[47] !== o || e[48] !== u || e[49] !== d || e[50] !== D || e[51] !== z || e[52] !== r ? (H = /* @__PURE__ */ F(_0, { value: r, onValueChange: s, open: l, onOpenChange: a, disabled: c, readOnly: u, required: d, name: f, items: o, modal: !1, children: [
    D,
    z
  ] }), e[42] = c, e[43] = f, e[44] = a, e[45] = s, e[46] = l, e[47] = o, e[48] = u, e[49] = d, e[50] = D, e[51] = z, e[52] = r, e[53] = H) : H = e[53], H;
}
const Af = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Af.displayName = "ComboboxRootContext");
const Lf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lf.displayName = "ComboboxFloatingContext");
const Ff = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ff.displayName = "ComboboxDerivedItemsContext");
const $f = /* @__PURE__ */ x.createContext("");
process.env.NODE_ENV !== "production" && ($f.displayName = "ComboboxInputValueContext");
function Sn() {
  const t = x.useContext(Af);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(22));
  return t;
}
function Na() {
  const t = x.useContext(Lf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(23));
  return t;
}
function Lo() {
  const t = x.useContext(Ff);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(24));
  return t;
}
function Hf() {
  return x.useContext($f);
}
const De = {
  id: ge((t) => t.id),
  labelId: ge((t) => t.labelId),
  items: ge((t) => t.items),
  selectedValue: ge((t) => t.selectedValue),
  hasSelectionChips: ge((t) => {
    const e = t.selectedValue;
    return Array.isArray(e) && e.length > 0;
  }),
  hasSelectedValue: ge((t) => {
    const {
      selectedValue: e,
      selectionMode: n
    } = t;
    return e == null ? !1 : n === "multiple" && Array.isArray(e) ? e.length > 0 : !0;
  }),
  hasNullItemLabel: ge((t, e) => e ? T0(t.items) : !1),
  open: ge((t) => t.open),
  mounted: ge((t) => t.mounted),
  forceMounted: ge((t) => t.forceMounted),
  inline: ge((t) => t.inline),
  activeIndex: ge((t) => t.activeIndex),
  selectedIndex: ge((t) => t.selectedIndex),
  isActive: ge((t, e) => t.activeIndex === e),
  isSelected: ge((t, e) => {
    const n = t.isItemEqualToValue, o = t.selectedValue;
    return Array.isArray(o) ? o.some((r) => go(e, r, n)) : go(e, o, n);
  }),
  transitionStatus: ge((t) => t.transitionStatus),
  popupProps: ge((t) => t.popupProps),
  inputProps: ge((t) => t.inputProps),
  triggerProps: ge((t) => t.triggerProps),
  getItemProps: ge((t) => t.getItemProps),
  positionerElement: ge((t) => t.positionerElement),
  listElement: ge((t) => t.listElement),
  triggerElement: ge((t) => t.triggerElement),
  inputElement: ge((t) => t.inputElement),
  inputGroupElement: ge((t) => t.inputGroupElement),
  popupSide: ge((t) => t.popupSide),
  openMethod: ge((t) => t.openMethod),
  inputInsidePopup: ge((t) => t.inputInsidePopup),
  selectionMode: ge((t) => t.selectionMode),
  name: ge((t) => t.name),
  form: ge((t) => t.form),
  disabled: ge((t) => t.disabled),
  readOnly: ge((t) => t.readOnly),
  required: ge((t) => t.required),
  grid: ge((t) => t.grid),
  virtualized: ge((t) => t.virtualized),
  itemToStringLabel: ge((t) => t.itemToStringLabel),
  isItemEqualToValue: ge((t) => t.isItemEqualToValue),
  modal: ge((t) => t.modal),
  autoHighlight: ge((t) => t.autoHighlight),
  submitOnItemClick: ge((t) => t.submitOnItemClick)
};
function dR(t, e) {
  return (n, o) => {
    if (n == null)
      return !1;
    const r = en(n, e);
    return t.contains(r, o);
  };
}
function fR(t, e, n) {
  return (o, r) => {
    if (o == null)
      return !1;
    if (!r)
      return !0;
    const i = en(o, e), s = n != null ? en(n, e) : "";
    return s && t.contains(s, r) && s.length === r.length ? !0 : t.contains(i, r);
  };
}
const km = /* @__PURE__ */ new Map();
function pR(t = {}) {
  const e = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...t
  }, n = `${W0(t.locale)}|${JSON.stringify(e)}`, o = km.get(n);
  if (o)
    return o;
  const r = new Intl.Collator(t.locale, e), i = {
    contains(s, l, a) {
      if (!l)
        return !0;
      const c = en(s, a);
      for (let u = 0; u <= c.length - l.length; u += 1)
        if (r.compare(c.slice(u, u + l.length), l) === 0)
          return !0;
      return !1;
    },
    startsWith(s, l, a) {
      if (!l)
        return !0;
      const c = en(s, a);
      return r.compare(c.slice(0, l.length), l) === 0;
    },
    endsWith(s, l, a) {
      if (!l)
        return !0;
      const c = en(s, a), u = l.length;
      return c.length >= u && r.compare(c.slice(c.length - u), l) === 0;
    }
  };
  return km.set(n, i), i;
}
function W0(t) {
  return Array.isArray(t) ? t.map((e) => W0(e)).join(",") : t == null ? "" : String(t);
}
const U0 = pR, G0 = /* @__PURE__ */ Symbol("none"), sr = {
  value: G0,
  index: -1
};
function Y0(t) {
  const {
    id: e,
    onOpenChangeComplete: n,
    defaultSelectedValue: o = null,
    selectedValue: r,
    onSelectedValueChange: i,
    defaultInputValue: s,
    inputValue: l,
    open: a,
    defaultOpen: c = !1,
    selectionMode: u = "none",
    onItemHighlighted: d,
    name: f,
    form: p,
    disabled: m = !1,
    readOnly: h = !1,
    required: b = !1,
    inputRef: v,
    grid: C = !1,
    items: y,
    filteredItems: w,
    filter: R,
    openOnInputClick: S = !0,
    autoHighlight: E = !1,
    keepHighlight: N = !1,
    highlightItemOnHover: M = !0,
    loopFocus: T = !0,
    itemToStringLabel: P,
    itemToStringValue: k,
    isItemEqualToValue: I = I0,
    virtualized: D = !1,
    inline: O = !1,
    fillInputOnItemPress: V = !0,
    modal: _ = !1,
    limit: L = -1,
    autoComplete: A = "list",
    formAutoComplete: $,
    locale: Y,
    submitOnItemClick: z = !1
  } = t, {
    clearErrors: H
  } = Vo(), {
    setDirty: K,
    validityData: G,
    shouldValidateOnChange: q,
    setFilled: ee,
    name: W,
    disabled: X,
    setTouched: J,
    setFocused: re,
    validationMode: Q,
    validation: ie
  } = on(), ce = Mr({
    id: e
  }), oe = U0({
    locale: Y
  }), [se, fe] = x.useState(!1), [be, le] = x.useState(null), me = x.useRef([]), j = x.useRef([]), te = x.useRef(null), U = x.useRef(null), Z = x.useRef(null), ue = x.useRef(null), pe = x.useRef(null), he = x.useRef(!0), Ie = x.useRef(!1), ye = x.useRef(null), xe = x.useRef(null), de = x.useRef(null), we = x.useRef(sr), Me = x.useRef(null), Re = x.useRef([]), Ve = x.useRef([]), je = X || m, Ze = W ?? f, ze = u === "multiple", Ee = u === "single", Ae = l !== void 0 || s !== void 0, Pe = y !== void 0, Oe = w !== void 0;
  let $e;
  E === "always" ? $e = "always" : $e = E ? "input-change" : !1;
  const [Te, vt] = pn({
    controlled: r,
    default: ze ? o ?? _n : o,
    name: "Combobox",
    state: "selectedValue"
  }), st = x.useMemo(() => R === null ? () => !0 : R !== void 0 ? R : Ee && !se ? fR(oe, P, Te) : dR(oe, P), [R, Ee, Te, se, oe, P]), Se = Tt(() => Ae ? s ?? "" : Ee ? en(Te, P) : "").current, [ke, Fe] = pn({
    controlled: l,
    default: Se,
    name: "Combobox",
    state: "inputValue"
  }), [Ue, it] = pn({
    controlled: a,
    default: c,
    name: "Combobox",
    state: "open"
  }), Ke = Rf(y), ot = be ?? (ke === "" ? "" : String(ke).trim()), Ye = Ee ? en(Te, P) : "", Xe = Ee && !se && ot !== "" && Ye !== "" && Ye.length === ot.length && oe.contains(Ye, ot), rt = Xe ? "" : ot, ct = Pe && Oe && Xe, mt = x.useMemo(() => y ? Ke ? y.flatMap((Ge) => Ge.items) : y : _n, [y, Ke]), ht = x.useMemo(() => {
    if (w && !ct)
      return w;
    if (!y)
      return _n;
    if (Ke) {
      const Qe = y, yt = [];
      let Nt = 0;
      for (const Xt of Qe) {
        if (L > -1 && Nt >= L)
          break;
        const qt = rt === "" ? Xt.items : Xt.items.filter((zs) => st(zs, rt, P));
        if (qt.length === 0)
          continue;
        const or = L > -1 ? L - Nt : 1 / 0, Fo = qt.slice(0, or);
        if (Fo.length > 0) {
          const zs = {
            ...Xt,
            items: Fo
          };
          yt.push(zs), Nt += Fo.length;
        }
      }
      return yt;
    }
    if (rt === "")
      return L > -1 ? mt.slice(0, L) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        mt
      );
    const Ge = [];
    for (const Qe of mt) {
      if (L > -1 && Ge.length >= L)
        break;
      st(Qe, rt, P) && Ge.push(Qe);
    }
    return Ge;
  }, [w, ct, y, Ke, rt, L, st, P, mt]), Ot = x.useMemo(() => Ke ? ht.flatMap((Qe) => Qe.items) : ht, [ht, Ke]), ut = Tt(() => new hd({
    id: ce,
    labelId: void 0,
    selectedValue: Te,
    open: Ue,
    filter: st,
    query: ot,
    items: y,
    selectionMode: u,
    listRef: me,
    labelsRef: j,
    popupRef: te,
    emptyRef: pe,
    inputRef: U,
    startDismissRef: Z,
    endDismissRef: ue,
    keyboardActiveRef: he,
    chipsContainerRef: ye,
    clearRef: xe,
    valuesRef: Re,
    allValuesRef: Ve,
    selectionEventRef: de,
    name: Ze,
    form: p,
    disabled: je,
    readOnly: h,
    required: b,
    grid: C,
    isGrouped: Ke,
    virtualized: D,
    openOnInputClick: S,
    itemToStringLabel: P,
    isItemEqualToValue: I,
    modal: _,
    autoHighlight: $e,
    submitOnItemClick: z,
    hasInputValue: Ae,
    mounted: !1,
    forceMounted: !1,
    transitionStatus: "idle",
    inline: O,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    inputProps: {},
    triggerProps: {},
    positionerElement: null,
    listElement: null,
    triggerElement: null,
    inputElement: null,
    inputGroupElement: null,
    popupSide: null,
    openMethod: null,
    inputInsidePopup: !0,
    onOpenChangeComplete: n || xt,
    // Placeholder callbacks replaced on first render
    setOpen: xt,
    setInputValue: xt,
    setSelectedValue: xt,
    setIndices: xt,
    onItemHighlighted: xt,
    handleSelection: xt,
    getItemProps: () => St,
    forceMount: xt,
    requestSubmit: xt
  })).current, zt = u === "none" ? ke : Te, no = x.useMemo(() => u === "none" ? zt : Array.isArray(Te) ? Te.map((Ge) => Gn(Ge, k)) : Gn(Te, k), [zt, k, u, Te]), vn = Ce(d), Fn = Ce(n), Pn = ve(ut, De.activeIndex), Mn = ve(ut, De.selectedIndex), rn = ve(ut, De.positionerElement), oo = ve(ut, De.listElement), Zt = ve(ut, De.triggerElement), $n = ve(ut, De.inputElement), Si = ve(ut, De.inputGroupElement), yn = ve(ut, De.inline), Hn = ve(ut, De.inputInsidePopup), F3 = Ht(Zt), {
    mounted: M1,
    setMounted: $3,
    transitionStatus: Fa
  } = Xn(Ue), {
    openMethod: T1,
    triggerProps: $a
  } = Ss(Ue), H3 = Ce(() => no);
  gi(Hn ? F3 : U, {
    id: ce,
    value: zt,
    getValue: H3
  });
  const Fs = Ce(() => {
    y ? j.current = Ot.map((Ge) => en(Ge, P)) : ut.set("forceMounted", !0);
  }), z3 = x.useRef(Te);
  Ne(() => {
    Te !== z3.current && Fs();
  }, [Fs, Te]);
  const zn = Ce((Ge) => {
    ut.update(Ge);
    const Qe = Ge.type || "none";
    if (Ge.activeIndex !== void 0)
      if (Ge.activeIndex === null)
        we.current !== sr && (we.current = sr, vn(void 0, Ni(Qe, void 0, {
          index: -1
        })));
      else {
        const yt = Re.current[Ge.activeIndex];
        we.current = {
          value: yt,
          index: Ge.activeIndex
        }, vn(yt, Ni(Qe, void 0, {
          index: Ge.activeIndex
        }));
      }
  }), ro = Ce((Ge, Qe) => {
    if (Ie.current = Qe.reason === zo, t.onInputValueChange?.(Ge, Qe), !Qe.isCanceled) {
      if (Qe.reason === Lr) {
        const yt = Qe.event, Nt = yt.inputType;
        if (yt.type === "compositionend" || Nt != null && Nt !== "" && Nt !== "insertReplacementText") {
          const qt = Ge.trim() !== "";
          qt && fe(!0), Me.current = {
            hasQuery: qt
          }, qt && $e && ut.state.activeIndex == null && ut.set("activeIndex", 0);
        }
      }
      Fe(Ge);
    }
  }), Ri = Ce((Ge, Qe) => {
    if (Ue !== Ge && (Qe.reason === "escape-key" && Pe && Ot.length === 0 && !ut.state.emptyRef.current && Qe.allowPropagation(), t.onOpenChange?.(Ge, Qe), !Qe.isCanceled && (!Ge && se && (Ee ? (yn || le(ot), ot === "" && fe(!1)) : ze && (yn || Hn ? zn({
      activeIndex: null
    }) : le(ot), ro("", _e(zo, Qe.event)))), it(Ge), !Ge && Hn && (Qe.reason === Mo || Qe.reason === ls) && (J(!0), re(!1), Q === "onBlur")))) {
      const yt = u === "none" ? ke : Te;
      ie.commit(yt);
    }
  }), $s = Ce((Ge, Qe) => {
    if (i?.(Ge, Qe), Qe.isCanceled)
      return;
    vt(Ge), (u === "none" && te.current && V || Ee && !ut.state.inputInsidePopup) && ro(en(Ge, P), _e(Qe.reason, Qe.event)), Ee && Ge != null && Qe.reason !== Lr && se && !yn && le(ot);
  }), B3 = Ce((Ge, Qe) => {
    let yt = Qe;
    if (yt === void 0) {
      if (Pn === null)
        return;
      yt = Re.current[Pn];
    }
    const Nt = bt(Ge), Xt = de.current ?? Ge;
    de.current = null;
    const qt = _e(Uo, Xt), or = Nt?.closest("a")?.getAttribute("href");
    if (or) {
      or.startsWith("#") && Ri(!1, qt);
      return;
    }
    if (ze) {
      const Fo = Array.isArray(Te) ? Te : [], e4 = P0(Fo, yt, ut.state.isItemEqualToValue) ? M0(Fo, yt, ut.state.isItemEqualToValue) : [...Fo, yt];
      if ($s(e4, qt), !(U.current ? U.current.value.trim() !== "" : !1))
        return;
      ut.state.inputInsidePopup ? ro("", _e(zo, qt.event)) : Ri(!1, qt);
    } else
      $s(yt, qt), Ri(!1, qt);
  }), Ha = Ce(() => {
    if (!ut.state.submitOnItemClick)
      return;
    const Ge = ie.inputRef.current?.form ?? ut.state.inputElement?.form;
    Ge && typeof Ge.requestSubmit == "function" && Ge.requestSubmit();
  }), za = Ce(() => {
    if ($3(!1), Fn?.(!1), fe(!1), le(null), zn(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), ze && U.current && U.current.value !== "" && !Ie.current && ro("", _e(zo)), Ee)
      if (ut.state.inputInsidePopup)
        U.current && U.current.value !== "" && ro("", _e(zo));
      else {
        const Ge = en(Te, P);
        U.current && U.current.value !== Ge && ro(Ge, _e(Ge === "" ? zo : Mt));
      }
  }), W3 = x.useMemo(() => yn && rn ? {
    current: rn.closest('[role="dialog"]')
  } : te, [yn, rn]);
  jt({
    enabled: !t.actionsRef,
    open: Ue,
    ref: W3,
    onComplete() {
      Ue || za();
    }
  }), x.useImperativeHandle(t.actionsRef, () => ({
    unmount: za
  }), [za]), Ne(function() {
    if (Ue || u === "none")
      return;
    const Qe = y ? mt : Ve.current;
    if (ze) {
      const yt = Array.isArray(Te) ? Te : [], Nt = yt[yt.length - 1], Xt = Po(Qe, Nt, I);
      zn({
        selectedIndex: Xt === -1 ? null : Xt
      });
    } else {
      const yt = Po(Qe, Te, I);
      zn({
        selectedIndex: yt === -1 ? null : yt
      });
    }
  }, [Ue, Te, y, u, mt, ze, I, zn]), Ne(() => {
    y && (Re.current = Ot, me.current.length = Ot.length);
  }, [y, Ot]), Ne(() => {
    const Ge = Me.current;
    if (Ge && (Ge.hasQuery ? $e && ut.set("activeIndex", 0) : $e === "always" && ut.set("activeIndex", 0), Me.current = null), !Ue && !yn)
      return;
    const yt = Pe || Oe ? Ot : Re.current, Nt = ut.state.activeIndex;
    if (Nt == null) {
      if ($e === "always" && yt.length > 0) {
        ut.set("activeIndex", 0);
        return;
      }
      we.current !== sr && (we.current = sr, ut.state.onItemHighlighted(void 0, Ni(Mt, void 0, {
        index: -1
      })));
      return;
    }
    if (Nt >= yt.length) {
      we.current !== sr && (we.current = sr, ut.state.onItemHighlighted(void 0, Ni(Mt, void 0, {
        index: -1
      }))), ut.set("activeIndex", null);
      return;
    }
    const Xt = yt[Nt], qt = we.current.value, or = qt !== G0 && go(Xt, qt, ut.state.isItemEqualToValue);
    (we.current.index !== Nt || !or) && (we.current = {
      value: Xt,
      index: Nt
    }, ut.state.onItemHighlighted(Xt, Ni(Mt, void 0, {
      index: Nt
    })));
  }, [Pn, $e, Oe, Pe, Ot, yn, Ue, ut]), Ne(() => {
    if (u === "none") {
      ee(String(ke) !== "");
      return;
    }
    ee(ze ? Array.isArray(Te) && Te.length > 0 : Te != null);
  }, [ee, u, ke, Te, ze]), x.useEffect(() => {
    Pe && $e && Ot.length === 0 && zn({
      activeIndex: null
    });
  }, [Pe, $e, Ot.length, zn]), So(ot, () => {
    !Ue || ot === "" || ot === String(Se) || fe(!0);
  }), So(Te, () => {
    if (u !== "none" && (H(Ze), K(Te !== G.initialValue), q() ? ie.commit(Te) : ie.commit(Te, !0), Ee && !Ae && !Hn)) {
      const Ge = en(Te, P);
      ke !== Ge && ro(Ge, _e(Mt));
    }
  }), So(ke, () => {
    u === "none" && (H(Ze), K(ke !== G.initialValue), q() ? ie.commit(ke) : ie.commit(ke, !0));
  }), So(y, () => {
    if (!Ee || Ae || Hn || se)
      return;
    const Ge = en(Te, P);
    ke !== Ge && ro(Ge, _e(Mt));
  });
  const Hs = vd({
    open: yn ? !0 : Ue,
    onOpenChange: Ri,
    elements: {
      reference: Hn ? Zt : $n,
      floating: rn
    }
  });
  let Ba, Wa;
  yn || (Ba = C ? "grid" : "listbox", Wa = Ue ? "true" : "false");
  const U3 = x.useMemo(() => {
    const Ge = $n?.tagName === "INPUT", Qe = $n == null || Ge, yt = Qe || Ue, Nt = Qe ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return yt && (Nt.role = "combobox", Nt["aria-expanded"] = Wa, Nt["aria-haspopup"] = Ba, Nt["aria-controls"] = Ue ? oo?.id : void 0, Nt["aria-autocomplete"] = A), {
      reference: Nt,
      floating: {
        role: "presentation"
      }
    };
  }, [$n, Ue, Wa, Ba, oo?.id, A]), G3 = wr(Hs, {
    enabled: !h && !je && S,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: Hn ? 0 : 100,
    reason: Zg
  }), Y3 = Sr(Hs, {
    enabled: !h && !je && !yn,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: yn ? !0 : void 0,
    outsidePress(Ge) {
      const Qe = bt(Ge);
      return !He(Zt, Qe) && !He(xe.current, Qe) && !He(ye.current, Qe) && !He(Si, Qe);
    }
  }), j3 = Cd(Hs, {
    enabled: !h && !je,
    id: ce,
    listRef: me,
    activeIndex: Pn,
    selectedIndex: Mn,
    virtual: !0,
    loopFocus: T,
    allowEscape: T && !$e,
    focusItemOnOpen: se || u === "none" && !$e ? !1 : "auto",
    focusItemOnHover: M,
    resetOnPointerLeave: !N,
    // `cols` > 1 enables grid navigation.
    // Since <Combobox.Row> infers column sizes (and is required when building a grid),
    // it works correctly even with a value of `2`.
    // Floating UI tests don't require `role="row"` wrappers, so retains the number API.
    cols: C ? 2 : 1,
    orientation: C ? "horizontal" : void 0,
    disabledIndices: _n,
    onNavigate(Ge, Qe) {
      !Qe && !Ue || Fa === "ending" || zn(Qe ? {
        activeIndex: Ge,
        type: he.current ? "keyboard" : "pointer"
      } : {
        activeIndex: Ge
      });
    }
  }), {
    getReferenceProps: Ua,
    getFloatingProps: Ga,
    getItemProps: Ya
  } = eo([U3, G3, Y3, j3]);
  Ir(() => {
    ut.update({
      inline: O,
      popupProps: Ga(),
      inputProps: Ua(),
      triggerProps: $a,
      getItemProps: Ya,
      setOpen: Ri,
      setInputValue: ro,
      setSelectedValue: $s,
      setIndices: zn,
      onItemHighlighted: vn,
      handleSelection: B3,
      forceMount: Fs,
      requestSubmit: Ha
    });
  }), Ne(() => {
    ut.update({
      id: ce,
      selectedValue: Te,
      open: Ue,
      mounted: M1,
      transitionStatus: Fa,
      items: y,
      inline: O,
      popupProps: Ga(),
      inputProps: Ua(),
      triggerProps: $a,
      openMethod: T1,
      getItemProps: Ya,
      selectionMode: u,
      name: Ze,
      form: p,
      disabled: je,
      readOnly: h,
      required: b,
      grid: C,
      isGrouped: Ke,
      virtualized: D,
      onOpenChangeComplete: Fn,
      openOnInputClick: S,
      itemToStringLabel: P,
      modal: _,
      autoHighlight: $e,
      isItemEqualToValue: I,
      submitOnItemClick: z,
      hasInputValue: Ae,
      requestSubmit: Ha
    });
  }, [ut, ce, Te, Ue, M1, Fa, y, Ga, Ua, Ya, T1, $a, u, Ze, je, h, b, ie, C, Ke, D, Fn, S, P, _, I, z, Ae, O, Ha, $e, p]);
  const K3 = mn(v, ie.inputRef), q3 = x.useMemo(() => ({
    query: ot,
    hasItems: Pe,
    filteredItems: ht,
    flatFilteredItems: Ot
  }), [ot, Pe, ht, Ot]), Z3 = x.useMemo(() => Array.isArray(zt) ? "" : Gn(zt, k), [zt, k]), X3 = ze && Array.isArray(Te) && Te.length > 0, ja = ze || u === "none" ? void 0 : Ze, Q3 = x.useMemo(() => !ze || !Array.isArray(Te) || !Ze ? null : Te.map((Ge) => {
    const Qe = Gn(Ge, k);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: p,
      name: Ze,
      value: Qe
    }, Qe);
  }), [ze, Te, p, Ze, k]), J3 = /* @__PURE__ */ F(x.Fragment, {
    children: [t.children, /* @__PURE__ */ g("input", {
      ...ie.getInputValidationProps({
        // Move focus when the hidden input is focused.
        onFocus() {
          if (Hn) {
            Zt?.focus();
            return;
          }
          (U.current || Zt)?.focus();
        },
        // Handle browser autofill.
        onChange(Ge) {
          if (Ge.nativeEvent.defaultPrevented)
            return;
          const Qe = Ge.currentTarget.value, yt = _e(Mt, Ge.nativeEvent);
          function Nt() {
            if (ze)
              return;
            if (u === "none") {
              K(Qe !== G.initialValue), ro(Qe, yt), q() && ie.commit(Qe);
              return;
            }
            const Xt = Re.current.find((qt) => Gn(qt, k).toLowerCase() === Qe.toLowerCase() || en(qt, P).toLowerCase() === Qe.toLowerCase());
            Xt != null && (K(Xt !== G.initialValue), $s?.(Xt, yt), q() && ie.commit(Xt));
          }
          y ? Nt() : (Fs(), queueMicrotask(Nt));
        }
      }),
      id: ce && ja == null ? `${ce}-hidden-input` : void 0,
      form: p,
      name: ja,
      autoComplete: $,
      disabled: je,
      required: b && !X3,
      readOnly: h,
      value: Z3,
      ref: K3,
      style: ja ? ni : er,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), Q3]
  });
  return /* @__PURE__ */ g(Af.Provider, {
    value: ut,
    children: /* @__PURE__ */ g(Lf.Provider, {
      value: Hs,
      children: /* @__PURE__ */ g(Ff.Provider, {
        value: q3,
        children: /* @__PURE__ */ g($f.Provider, {
          value: ke,
          children: J3
        })
      })
    })
  });
}
function zf(t) {
  const {
    multiple: e = !1,
    defaultValue: n,
    value: o,
    onValueChange: r,
    autoComplete: i,
    ...s
  } = t;
  return /* @__PURE__ */ g(Y0, {
    ...s,
    selectionMode: e ? "multiple" : "single",
    selectedValue: o,
    defaultSelectedValue: n,
    onSelectedValueChange: r,
    formAutoComplete: i
  });
}
const Bf = {
  ...Yi,
  ...to,
  popupSide: (t) => t ? {
    "data-popup-side": t
  } : null,
  listEmpty: (t) => t ? {
    "data-list-empty": ""
  } : null
}, Wf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Wf.displayName = "ComboboxChipsContext");
function j0() {
  return x.useContext(Wf);
}
const Uf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Uf.displayName = "ComboboxPositionerContext");
function Gf(t) {
  const e = x.useContext(Uf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : tt(21));
  return e;
}
const Yf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = Sn(), {
    buttonRef: r,
    getButtonProps: i
  } = Wt({
    native: !1
  }), s = mn(n, r), l = Ce((c) => {
    o.state.setOpen(!1, _e(qg, c.nativeEvent, c.currentTarget));
  }), a = i({
    onClick: l
  });
  return /* @__PURE__ */ g("span", {
    ref: s,
    ...a,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: ni
  });
});
process.env.NODE_ENV !== "production" && (Yf.displayName = "ComboboxInternalDismissButton");
const Os = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    id: s,
    style: l,
    ...a
  } = e, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: p,
    validation: m
  } = on(), {
    labelId: h
  } = hn(), b = j0(), C = !!Gf(!0), y = Sn(), {
    filteredItems: w
  } = Lo(), R = Hf(), S = ws(), E = ve(y, De.required), N = ve(y, De.disabled), M = ve(y, De.readOnly), T = ve(y, De.name), P = ve(y, De.form), k = ve(y, De.selectionMode), I = ve(y, De.autoHighlight), D = ve(y, De.inputProps), O = ve(y, De.triggerProps), V = ve(y, De.open), _ = ve(y, De.mounted), L = ve(y, De.selectedValue), A = ve(y, De.popupSide), $ = ve(y, De.positionerElement), Y = ve(y, De.id), z = ve(y, De.inline), H = ve(y, De.modal), K = !!I, G = _ && $ ? A : null, q = u || N || i, ee = w.length === 0, W = C || z, X = !W || H, J = It(s ?? (W ? void 0 : Y)), re = Ef(h, void 0), Q = C ? Fr : c, [ie, ce] = x.useState(null), oe = x.useRef(!1), se = x.useRef(null), fe = x.useRef(!1), be = Ce((U) => {
    const Z = C || y.state.inline;
    Z && !y.state.hasInputValue && y.state.setInputValue("", _e(Mt)), y.update({
      inputElement: U,
      inputInsidePopup: Z
    });
  }), le = C || !m ? a : m.getValidationProps(a), me = {
    ...Q,
    open: V,
    disabled: q,
    readOnly: M,
    popupSide: G,
    listEmpty: ee
  };
  function j(U) {
    if (!b)
      return;
    let Z;
    const {
      highlightedChipIndex: ue
    } = b, pe = b.chipsRef.current.length;
    if (ue !== void 0) {
      if (U.key === "ArrowLeft")
        U.preventDefault(), ue > 0 ? Z = ue - 1 : Z = void 0;
      else if (U.key === "ArrowRight")
        U.preventDefault(), ue < pe - 1 ? Z = ue + 1 : Z = void 0;
      else if (U.key === "Backspace" || U.key === "Delete") {
        U.preventDefault();
        const he = ue >= L.length - 1 ? L.length - 2 : ue;
        Z = he >= 0 ? he : void 0, y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: "keyboard"
        });
      }
      return Z;
    }
    return U.key === "ArrowLeft" && (U.currentTarget.selectionStart ?? 0) === 0 && L.length > 0 ? (U.preventDefault(), Z = pe > 0 ? pe - 1 : void 0) : U.key === "Backspace" && U.currentTarget.value === "" && L.length > 0 && (y.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: "keyboard"
    }), U.preventDefault()), Z;
  }
  const te = Le("input", e, {
    state: me,
    ref: [n, y.state.inputRef, be],
    props: [D, O, {
      type: "text",
      value: e.value ?? ie ?? R,
      "aria-readonly": M || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": re,
      disabled: q,
      readOnly: M,
      required: k === "none" ? E : void 0,
      form: P,
      ...k === "none" && T && {
        name: T
      },
      id: J,
      onFocus() {
        if (f(!0), !z || !fe.current)
          return;
        fe.current = !1;
        const U = se.current;
        U == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(y.state.valuesRef.current, U) || y.state.setIndices({
          activeIndex: U
        });
      },
      onBlur() {
        d(!0), f(!1);
        const U = y.state.activeIndex;
        if (z && U !== null && I !== "always" && (se.current = U, fe.current = !0, y.state.setIndices({
          activeIndex: null
        })), p === "onBlur") {
          const Z = k === "none" ? R : L;
          m.commit(Z);
        }
      },
      onCompositionStart(U) {
        ji || (oe.current = !0, ce(U.currentTarget.value));
      },
      onCompositionEnd(U) {
        oe.current = !1;
        const Z = U.currentTarget.value;
        ce(null), y.state.setInputValue(Z, _e(Lr, U.nativeEvent));
      },
      onChange(U) {
        const Z = U.nativeEvent.inputType, ue = !Z || Z === "insertReplacementText", pe = oe.current || !ue;
        if (oe.current) {
          const xe = U.currentTarget.value;
          ce(xe), xe === "" && !y.state.openOnInputClick && !y.state.inputInsidePopup && y.state.setOpen(!1, _e(zo, U.nativeEvent));
          const de = xe.trim(), we = K && de !== "";
          !M && !q && de && pe && (y.state.setOpen(!0, _e(Lr, U.nativeEvent)), K || y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          })), V && y.state.activeIndex !== null && !we && y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          });
          return;
        }
        y.state.setInputValue(U.currentTarget.value, _e(Lr, U.nativeEvent));
        const he = U.currentTarget.value === "", Ie = _e(zo, U.nativeEvent);
        he && !y.state.inputInsidePopup && (k === "single" && y.state.setSelectedValue(null, Ie), y.state.openOnInputClick || y.state.setOpen(!1, Ie));
        const ye = U.currentTarget.value.trim();
        !M && !q && ye && pe && (y.state.setOpen(!0, _e(Lr, U.nativeEvent)), K || y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        })), V && y.state.activeIndex !== null && !K && y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        });
      },
      onKeyDown(U) {
        if (q || M || U.ctrlKey || U.shiftKey || U.altKey || U.metaKey)
          return;
        y.state.keyboardActiveRef.current = !0;
        const Z = U.currentTarget, ue = Z.scrollWidth - Z.clientWidth, pe = S === "rtl";
        if (U.key === "Home") {
          $t(U);
          const ye = Y1 && pe ? Z.value.length : 0;
          Z.setSelectionRange(ye, ye), Z.scrollLeft = 0;
          return;
        }
        if (U.key === "End") {
          $t(U);
          const ye = Y1 && pe ? 0 : Z.value.length;
          Z.setSelectionRange(ye, ye), Z.scrollLeft = pe ? -ue : ue;
          return;
        }
        if (!_ && U.key === "Escape") {
          const ye = k === "multiple" && Array.isArray(L) ? L.length === 0 : L === null, xe = _e(xr, U.nativeEvent), de = k === "multiple" ? [] : null;
          y.state.setInputValue("", xe), y.state.setSelectedValue(de, xe), !ye && !y.state.inline && !xe.isPropagationAllowed && U.stopPropagation();
          return;
        }
        if (b && U.key === "Backspace" && Z.value === "" && b.highlightedChipIndex === void 0 && Array.isArray(L) && L.length > 0) {
          const ye = b.chipsRef.current.length, xe = ye > 0 ? ye - 1 : L.length - 1, de = L.filter((we, Me) => Me !== xe);
          y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          }), y.state.setSelectedValue(de, _e(Mt, U.nativeEvent));
          return;
        }
        const he = b?.highlightedChipIndex !== void 0, Ie = j(U);
        if (b?.setHighlightedChipIndex(Ie), Ie !== void 0 ? b?.chipsRef.current[Ie]?.focus() : he && y.state.inputRef.current?.focus(), U.which !== 229 && U.key === "Enter" && V) {
          const ye = y.state.activeIndex, xe = U.nativeEvent;
          if (ye === null) {
            if (z)
              return;
            y.state.setOpen(!1, _e(Mt, xe));
            return;
          }
          $t(U);
          const de = y.state.listRef.current[ye];
          de && (y.state.selectionEventRef.current = xe, de.click(), y.state.selectionEventRef.current = null);
        }
      },
      onPointerMove() {
        y.state.keyboardActiveRef.current = !1;
      },
      onPointerDown() {
        y.state.keyboardActiveRef.current = !1;
      }
    }, le],
    stateAttributesMapping: Bf
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [V && X && /* @__PURE__ */ g(Yf, {
      ref: y.state.startDismissRef
    }), te]
  });
});
process.env.NODE_ENV !== "production" && (Os.displayName = "ComboboxInput");
function K0(t, e, n, o, r) {
  if (t.baseUIHandlerPrevented || o)
    return;
  const i = bt(t.nativeEvent), s = pt(i) ? i : null;
  s !== t.currentTarget && (r?.(s) || ph(s)) || (t.preventDefault(), !n && (e.state.inputRef.current?.focus(), e.state.openOnInputClick && e.state.setOpen(!0, _e(Zg, t.nativeEvent))));
}
const ka = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = on(), a = Sn(), {
    filteredItems: c
  } = Lo(), u = ve(a, De.open), d = ve(a, De.mounted), f = ve(a, De.popupSide), p = ve(a, De.positionerElement), m = ve(a, De.disabled), h = ve(a, De.readOnly), b = ve(a, De.hasSelectedValue), v = ve(a, De.selectionMode), C = d && p ? f : null, y = m, w = c.length === 0, S = {
    ...l,
    open: u,
    disabled: y,
    readOnly: h,
    popupSide: C,
    listEmpty: w,
    placeholder: v === "none" ? !1 : !b
  }, E = Ce((N) => {
    a.set("inputGroupElement", N);
  });
  return Le("div", e, {
    ref: [n, E],
    props: [{
      role: "group",
      onMouseDown(N) {
        K0(N, a, y, h, (M) => He(a.state.chipsContainerRef.current, M));
      }
    }, s],
    state: S,
    stateAttributesMapping: Bf
  });
});
process.env.NODE_ENV !== "production" && (ka.displayName = "ComboboxInputGroup");
const dl = 2, Ia = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    nativeButton: i = !0,
    disabled: s = !1,
    id: l,
    style: a,
    ...c
  } = e, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: p,
    validationMode: m,
    validation: h
  } = on(), {
    labelId: b
  } = hn(), v = Sn(), {
    filteredItems: C
  } = Lo(), y = ve(v, De.selectionMode), w = ve(v, De.disabled), R = ve(v, De.readOnly), S = ve(v, De.required), E = ve(v, De.mounted), N = ve(v, De.popupSide), M = ve(v, De.positionerElement), T = ve(v, De.listElement), P = ve(v, De.triggerProps), k = ve(v, De.triggerElement), I = ve(v, De.inputInsidePopup), D = ve(v, De.id), O = ve(v, De.labelId), V = ve(v, De.open), _ = ve(v, De.selectedValue), L = ve(v, De.activeIndex), A = ve(v, De.selectedIndex), $ = ve(v, De.hasSelectedValue), Y = Na(), z = Hf(), H = _t(), K = d || w || s, G = C.length === 0, q = E && M ? N : null;
  Mr({
    id: I ? l : void 0
  });
  const ee = I ? l ?? D : l, W = Ef(b, O), X = x.useRef("");
  function J(le) {
    X.current = le.pointerType;
  }
  const re = Y.useState("domReferenceElement");
  x.useEffect(() => {
    I && k && k !== re && Y.set("domReferenceElement", k);
  }, [k, re, Y, I]);
  const {
    reference: Q
  } = Sd(Y, {
    enabled: !V && !R && !w && y === "single",
    listRef: v.state.labelsRef,
    activeIndex: L,
    selectedIndex: A,
    onMatch(le) {
      const me = v.state.valuesRef.current[le];
      me !== void 0 && v.state.setSelectedValue(me, _e("none"));
    }
  }), {
    reference: ie
  } = wr(Y, {
    enabled: !R && !w,
    event: "mousedown"
  }), {
    buttonRef: ce,
    getButtonProps: oe
  } = Wt({
    native: i,
    disabled: K
  }), se = {
    ...u,
    open: V,
    disabled: K,
    popupSide: q,
    listEmpty: G,
    placeholder: y === "none" ? !1 : !$
  }, fe = Ce((le) => {
    v.set("triggerElement", le);
  });
  return Le("button", e, {
    ref: [n, ce, fe],
    state: se,
    props: [P, ie, Q, {
      id: ee,
      tabIndex: I ? 0 : -1,
      role: I ? "combobox" : void 0,
      "aria-expanded": V ? "true" : "false",
      "aria-haspopup": I ? "dialog" : "listbox",
      "aria-controls": V ? T?.id : void 0,
      "aria-required": I && S || void 0,
      "aria-labelledby": W,
      onPointerDown: J,
      onPointerEnter: J,
      onFocus() {
        p(!0), !(K || R) && H.start(0, v.state.forceMount);
      },
      onBlur(le) {
        if (!He(M, le.relatedTarget) && (f(!0), p(!1), m === "onBlur")) {
          const me = y === "none" ? z : _;
          h.commit(me);
        }
      },
      onMouseDown(le) {
        if (K || R || (I || Y.set("domReferenceElement", le.currentTarget), v.state.forceMount(), X.current !== "touch" && (v.state.inputRef.current?.focus(), I || le.preventDefault()), V))
          return;
        const me = et(le.currentTarget);
        function j(te) {
          if (!k)
            return;
          const U = bt(te), Z = v.state.positionerElement, ue = v.state.listElement;
          if (He(k, U) || He(Z, U) || He(ue, U) || U === k)
            return;
          const pe = Md(k), he = te.clientX >= pe.left - dl && te.clientX <= pe.right + dl, Ie = te.clientY >= pe.top - dl && te.clientY <= pe.bottom + dl;
          he && Ie || v.state.setOpen(!1, _e("cancel-open", te));
        }
        I && me.addEventListener("mouseup", j, {
          once: !0
        });
      },
      onKeyDown(le) {
        K || R || (le.key === "ArrowDown" || le.key === "ArrowUp") && ($t(le), v.state.setOpen(!0, _e(zr, le.nativeEvent)), v.state.inputRef.current?.focus());
      }
    }, h ? h.getValidationProps(c) : c, oe],
    stateAttributesMapping: Bf
  });
});
process.env.NODE_ENV !== "production" && (Ia.displayName = "ComboboxTrigger");
const jf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (jf.displayName = "GroupCollectionContext");
function mR() {
  return x.useContext(jf);
}
function gR(t) {
  const {
    children: e,
    items: n
  } = t, o = x.useMemo(() => ({
    items: n
  }), [n]);
  return /* @__PURE__ */ g(jf.Provider, {
    value: o,
    children: e
  });
}
function q0(t) {
  const {
    children: e
  } = t, {
    filteredItems: n
  } = Lo(), o = mR(), r = o ? o.items : n;
  return r ? /* @__PURE__ */ g(x.Fragment, {
    children: r.map(e)
  }) : null;
}
const Ds = /* @__PURE__ */ x.forwardRef(function(e, n) {
  var o;
  const {
    render: r,
    className: i,
    style: s,
    children: l,
    ...a
  } = e, c = Sn(), u = Na(), d = !!Gf(!0), {
    filteredItems: f,
    hasItems: p
  } = Lo(), m = ve(c, De.selectionMode), h = ve(c, De.grid), b = ve(c, De.popupProps), v = ve(c, De.virtualized), C = m === "multiple", y = f.length === 0, w = Ce((T) => {
    c.set("positionerElement", T);
  }), R = Ce((T) => {
    c.set("listElement", T);
  }), S = x.useMemo(() => typeof l == "function" ? o || (o = /* @__PURE__ */ g(q0, {
    children: l
  })) : l, [l]), E = {
    empty: y
  }, N = u.useState("floatingId"), M = Le("div", e, {
    state: E,
    ref: [n, R, d ? null : w],
    props: [b, {
      children: S,
      tabIndex: -1,
      id: N,
      role: h ? "grid" : "listbox",
      "aria-multiselectable": C ? "true" : void 0,
      onKeyDown(T) {
        if (!(c.state.disabled || c.state.readOnly) && T.key === "Enter") {
          const P = c.state.activeIndex;
          if (P == null)
            return;
          $t(T);
          const k = T.nativeEvent, I = c.state.listRef.current[P];
          I && (c.state.selectionEventRef.current = k, I.click(), c.state.selectionEventRef.current = null);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, a]
  });
  return v ? M : /* @__PURE__ */ g(si, {
    elementsRef: c.state.listRef,
    labelsRef: p ? void 0 : c.state.labelsRef,
    children: M
  });
});
process.env.NODE_ENV !== "production" && (Ds.displayName = "ComboboxList");
const hR = "⁠", bR = 200;
function vR(t) {
  const e = t.ownerDocument.createTreeWalker(t, NodeFilter.SHOW_TEXT);
  let n = null;
  for (; e.nextNode(); ) {
    const o = e.currentNode;
    o.nodeValue !== "" && (n = o);
  }
  return n;
}
function yR() {
  const t = _t(), e = x.useRef(null);
  return x.useEffect(() => {
    if (Gu)
      return;
    const n = e.current;
    if (n == null)
      return;
    const o = vR(n);
    if (o == null)
      return;
    const r = o.nodeValue ?? "", i = `${r}${hR}`;
    return o.nodeValue = i, t.start(bR, () => {
      o.nodeValue === i && (o.nodeValue = r);
    }), () => {
      t.clear(), o.nodeValue === i && (o.nodeValue = r);
    };
  }, [e, t]), e;
}
const Kf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Kf.displayName = "ComboboxPortalContext");
function xR() {
  const t = x.useContext(Kf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : tt(20));
  return t;
}
const Pa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, i = Sn(), s = ve(i, De.mounted), l = ve(i, De.forceMounted);
  return s || o || l ? /* @__PURE__ */ g(Kf.Provider, {
    value: o,
    children: /* @__PURE__ */ g(oi, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Pa.displayName = "ComboboxPortal");
const Ma = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = rd,
    style: v,
    ...C
  } = e, y = Sn(), {
    filteredItems: w
  } = Lo(), R = Na(), S = xR(), E = ve(y, De.modal), N = ve(y, De.open), M = ve(y, De.mounted), T = ve(y, De.openMethod), P = ve(y, De.positionerElement), k = ve(y, De.triggerElement), I = ve(y, De.inputElement), D = ve(y, De.inputGroupElement), O = ve(y, De.inputInsidePopup), V = ve(y, De.transitionStatus), _ = w.length === 0, A = ii({
    anchor: i ?? (O ? k : D ?? I),
    floatingRootContext: R,
    positionMethod: s,
    mounted: M,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: S,
    collisionAvoidance: b,
    lazyFlip: !0
  });
  ba(N && E, T === "touch", P, k);
  const $ = {
    open: N,
    side: A.side,
    align: A.align,
    anchorHidden: A.anchorHidden,
    empty: _
  };
  Ne(() => {
    y.set("popupSide", A.side);
  }, [y, A.side]);
  const Y = Ce((H) => {
    y.set("positionerElement", H);
  }), z = ai(e, $, {
    styles: A.positionerStyles,
    transitionStatus: V,
    props: C,
    refs: [n, Y],
    hidden: !M,
    inert: !N
  });
  return /* @__PURE__ */ F(Uf.Provider, {
    value: A,
    children: [M && E && /* @__PURE__ */ g(li, {
      inert: kr(!N),
      cutout: D ?? I ?? k
    }), z]
  });
});
process.env.NODE_ENV !== "production" && (Ma.displayName = "ComboboxPositioner");
const CR = {
  ...In,
  ...Bt
}, Ta = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    initialFocus: s,
    finalFocus: l,
    ...a
  } = e, c = Sn(), u = Gf(), d = Na(), {
    filteredItems: f
  } = Lo(), p = ve(c, De.mounted), m = ve(c, De.open), h = ve(c, De.openMethod), b = ve(c, De.transitionStatus), v = ve(c, De.inputInsidePopup), C = ve(c, De.inputElement), y = ve(c, De.modal), w = f.length === 0;
  jt({
    open: m,
    ref: c.state.popupRef,
    onComplete() {
      m && c.state.onOpenChangeComplete(!0);
    }
  });
  const R = {
    open: m,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: b,
    empty: w
  }, S = Le("div", e, {
    state: R,
    ref: [n, c.state.popupRef],
    props: [{
      role: v ? "dialog" : "presentation",
      tabIndex: -1,
      onFocus(P) {
        const k = bt(P.nativeEvent);
        h !== "touch" && (He(c.state.listElement, k) || k === P.currentTarget) && c.state.inputRef.current?.focus();
      }
    }, Nr(b), a],
    stateAttributesMapping: CR
  }), N = s === void 0 ? v ? (P) => P === "touch" ? c.state.popupRef.current : C : !1 : s;
  let M;
  l != null ? M = l : M = v ? void 0 : !1;
  const T = !v || y;
  return /* @__PURE__ */ g(ri, {
    context: d,
    disabled: !p,
    modal: T,
    openInteractionType: h,
    initialFocus: N,
    returnFocus: M,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [S, T && /* @__PURE__ */ g(Yf, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Ta.displayName = "ComboboxPopup");
const qf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (qf.displayName = "ComboboxGroupContext");
function wR() {
  const t = x.useContext(qf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : tt(18));
  return t;
}
const Z0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    items: s,
    ...l
  } = e, [a, c] = x.useState(), u = x.useMemo(() => ({
    labelId: a,
    setLabelId: c,
    items: s
  }), [a, c, s]), d = Le("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": a
    }, l]
  }), f = /* @__PURE__ */ g(qf.Provider, {
    value: u,
    children: d
  });
  return s ? /* @__PURE__ */ g(gR, {
    items: s,
    children: f
  }) : f;
});
process.env.NODE_ENV !== "production" && (Z0.displayName = "ComboboxGroup");
const X0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    setLabelId: a
  } = wR(), c = It(s);
  return Ne(() => (a(c), () => {
    a(void 0);
  }), [c, a]), Le("div", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (X0.displayName = "ComboboxGroupLabel");
const Q0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Q0.displayName = "ComboboxItemContext");
const Zf = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Zf.displayName = "ComboboxRowContext");
function SR() {
  return x.useContext(Zf);
}
const _s = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    index: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(!1), f = x.useRef(null), p = Do({
    index: s,
    textRef: f,
    indexGuessBehavior: Ku.GuessFromOrder
  }), m = Sn(), h = SR(), {
    flatFilteredItems: b,
    hasItems: v
  } = Lo(), C = ve(m, De.open), y = ve(m, De.selectionMode), w = ve(m, De.readOnly), R = ve(m, De.virtualized), S = ve(m, De.isItemEqualToValue), E = y !== "none", N = s ?? (R ? Po(b, i, S) : p.index), M = p.index !== -1, T = ve(m, De.id), P = ve(m, De.isActive, N), k = ve(m, De.isSelected, i), I = ve(m, De.getItemProps), D = x.useRef(null), O = T != null && M ? `${T}-${N}` : void 0, V = k && E;
  Ne(() => {
    if (!(M && (R || s != null)))
      return;
    const q = m.state.listRef.current;
    return q[N] = D.current, () => {
      delete q[N];
    };
  }, [M, R, N, s, m]), Ne(() => {
    if (!M || v)
      return;
    const G = m.state.valuesRef.current;
    return G[N] = i, y !== "none" && m.state.allValuesRef.current.push(i), () => {
      delete G[N];
    };
  }, [M, v, N, i, m, y]), Ne(() => {
    if (!C) {
      d.current = !1;
      return;
    }
    if (!M || v)
      return;
    const G = m.state.selectedValue, q = Array.isArray(G) ? G[G.length - 1] : G;
    go(i, q, S) && m.set("selectedIndex", N);
  }, [M, v, C, m, N, i, S]);
  const _ = {
    disabled: l,
    selected: V,
    highlighted: P
  }, L = I({
    active: P,
    selected: V
  });
  L.id = void 0, L.onFocus = void 0;
  const {
    getButtonProps: A,
    buttonRef: $
  } = Wt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function Y(G) {
    function q() {
      m.state.handleSelection(G, i);
    }
    m.state.submitOnItemClick ? (cn.flushSync(q), m.state.requestSubmit()) : q();
  }
  const z = {
    id: O,
    role: h ? "gridcell" : "option",
    "aria-selected": E ? V : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(G) {
      d.current = !0, G.preventDefault();
    },
    onMouseDown(G) {
      G.preventDefault();
    },
    onClick(G) {
      l || w || Y(G.nativeEvent);
    },
    onMouseUp(G) {
      const q = d.current;
      d.current = !1, !(l || w || G.button !== 0 || q || !P) && Y(G.nativeEvent);
    }
  }, H = Le("div", e, {
    ref: [$, n, p.ref, D],
    state: _,
    props: [L, z, u, A]
  }), K = x.useMemo(() => ({
    selected: V,
    textRef: f
  }), [V, f]);
  return /* @__PURE__ */ g(Q0.Provider, {
    value: K,
    children: H
  });
}));
process.env.NODE_ENV !== "production" && (_s.displayName = "ComboboxItem");
const J0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Sn(), a = ve(l, De.open), c = ve(l, De.hasSelectionChips), [u, d] = x.useState(void 0);
  a && u !== void 0 && d(void 0);
  const f = x.useRef([]), p = Le("div", e, {
    ref: [n, l.state.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [c ? {
      role: "toolbar"
    } : St, {
      onMouseDown(h) {
        K0(h, l, l.state.disabled, l.state.readOnly);
      }
    }, s]
  }), m = x.useMemo(() => ({
    highlightedChipIndex: u,
    setHighlightedChipIndex: d,
    chipsRef: f
  }), [u, d, f]);
  return /* @__PURE__ */ g(Wf.Provider, {
    value: m,
    children: /* @__PURE__ */ g(si, {
      elementsRef: f,
      children: p
    })
  });
});
process.env.NODE_ENV !== "production" && (J0.displayName = "ComboboxChips");
const Xf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xf.displayName = "ComboboxChipContext");
function RR() {
  const t = x.useContext(Xf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "useComboboxChipContext must be used within a ComboboxChip" : tt(17));
  return t;
}
const eb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Sn(), {
    setHighlightedChipIndex: a,
    chipsRef: c
  } = j0(), u = ve(l, De.disabled), d = ve(l, De.readOnly), f = ve(l, De.selectedValue), {
    ref: p,
    index: m
  } = Do();
  function h(y) {
    let w = m;
    if (y.key === "ArrowLeft")
      y.preventDefault(), m > 0 ? w = m - 1 : w = void 0;
    else if (y.key === "ArrowRight")
      y.preventDefault(), m < c.current.length - 1 ? w = m + 1 : w = void 0;
    else if (y.key === "Backspace" || y.key === "Delete") {
      const R = m >= f.length - 1 ? f.length - 2 : m;
      w = R >= 0 ? R : void 0, $t(y), l.state.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: "keyboard"
      }), l.state.setSelectedValue(f.filter((S, E) => E !== m), _e(Mt, y.nativeEvent));
    } else y.key === "Enter" || y.key === " " ? ($t(y), w = void 0) : y.key === "ArrowDown" || y.key === "ArrowUp" ? ($t(y), l.state.setOpen(!0, _e(zr, y.nativeEvent)), w = void 0) : (
      // Check for printable characters (letters, numbers, symbols)
      y.key.length === 1 && !y.ctrlKey && !y.metaKey && !y.altKey && (w = void 0)
    );
    return w;
  }
  const v = Le("div", e, {
    ref: [n, p],
    state: {
      disabled: u
    },
    props: [{
      tabIndex: -1,
      "aria-disabled": u || void 0,
      "aria-readonly": d || void 0,
      onKeyDown(y) {
        if (u || d)
          return;
        const w = h(y);
        cn.flushSync(() => {
          a(w);
        }), w === void 0 ? l.state.inputRef.current?.focus() : c.current[w]?.focus();
      }
    }, s]
  }), C = x.useMemo(() => ({
    index: m
  }), [m]);
  return /* @__PURE__ */ g(Xf.Provider, {
    value: C,
    children: v
  });
});
process.env.NODE_ENV !== "production" && (eb.displayName = "ComboboxChip");
const tb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, c = Sn(), {
    index: u
  } = RR(), d = ve(c, De.disabled), f = ve(c, De.readOnly), p = ve(c, De.selectedValue), m = ve(c, De.isItemEqualToValue), h = d || i, {
    buttonRef: b,
    getButtonProps: v
  } = Wt({
    native: s,
    disabled: h || f,
    focusableWhenDisabled: !0
  }), C = {
    disabled: h
  };
  function y(S) {
    const E = c.state.activeIndex;
    if (E == null)
      return;
    const N = Po(c.state.valuesRef.current, S, m);
    N !== -1 && E === N && c.state.setIndices({
      activeIndex: null,
      type: c.state.keyboardActiveRef.current ? "keyboard" : "pointer"
    });
  }
  function w(S) {
    const E = _e(a8, S.nativeEvent), N = p[u];
    return y(N), c.state.setSelectedValue(p.filter((M, T) => T !== u), E), c.state.inputRef.current?.focus(), E;
  }
  return Le("button", e, {
    ref: [n, b],
    state: C,
    props: [{
      tabIndex: -1,
      onMouseDown(S) {
        S.preventDefault();
      },
      onClick(S) {
        if (h || f)
          return;
        w(S).isPropagationAllowed || S.stopPropagation();
      },
      onKeyDown(S) {
        h || f || (S.key === "Enter" || S.key === " ") && (w(S).isPropagationAllowed || $t(S));
      }
    }, a, v]
  });
});
process.env.NODE_ENV !== "production" && (tb.displayName = "ComboboxChipRemove");
const nb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Le("div", e, {
    ref: n,
    props: [{
      role: "row"
    }, s]
  });
  return /* @__PURE__ */ g(Zf.Provider, {
    value: !0,
    children: l
  });
});
process.env.NODE_ENV !== "production" && (nb.displayName = "ComboboxRow");
const Qf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, {
    filteredItems: a
  } = Lo(), c = Sn(), u = yR(), d = a.length === 0 ? s : null;
  return Le("div", e, {
    ref: [n, c.state.emptyRef, u],
    props: [{
      children: d,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Qf.displayName = "ComboboxEmpty");
const ER = {
  ...Bt,
  ...yr
}, Jf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    keepMounted: l = !1,
    style: a,
    ...c
  } = e, {
    disabled: u
  } = on(), d = Sn(), f = ve(d, De.selectionMode), p = ve(d, De.disabled), m = ve(d, De.readOnly), h = ve(d, De.open), b = ve(d, De.selectedValue), v = ve(d, De.hasSelectionChips), C = Hf();
  let y = !1;
  f === "none" ? y = C !== "" : f === "single" ? y = b != null : y = v;
  const w = u || p || i, {
    buttonRef: R,
    getButtonProps: S
  } = Wt({
    native: s,
    disabled: w
  }), {
    mounted: E,
    transitionStatus: N,
    setMounted: M
  } = Xn(y), T = {
    disabled: w,
    open: h,
    transitionStatus: N
  };
  jt({
    open: y,
    ref: d.state.clearRef,
    onComplete() {
      y || M(!1);
    }
  });
  const P = Le("button", e, {
    state: T,
    ref: [n, R, d.state.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(I) {
        I.preventDefault();
      },
      onClick(I) {
        if (w || m)
          return;
        const D = d.state.keyboardActiveRef;
        d.state.setInputValue("", _e(U1, I.nativeEvent)), f !== "none" ? (d.state.setSelectedValue(Array.isArray(b) ? [] : null, _e(U1, I.nativeEvent)), d.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: D.current ? "keyboard" : "pointer"
        })) : d.state.setIndices({
          activeIndex: null,
          type: D.current ? "keyboard" : "pointer"
        }), d.state.inputRef.current?.focus();
      }
    }, c, S],
    stateAttributesMapping: ER
  });
  return l || E ? P : null;
});
process.env.NODE_ENV !== "production" && (Jf.displayName = "ComboboxClear");
function NR(t) {
  const e = B.c(65), {
    id: n,
    options: o,
    selectedOption: r,
    onValueChange: i,
    open: s,
    onOpenChange: l,
    disabled: a,
    readOnly: c,
    required: u,
    name: d,
    placeholder: f,
    label: p,
    "data-testid": m,
    renderValue: h,
    renderOption: b,
    popupWidth: v,
    triggerClassName: C
  } = t, y = Kt(), [w, R] = qe(""), S = r ?? null;
  let E;
  e[0] !== i ? (E = (ce, oe) => i(ce?.value ?? null, oe), e[0] = i, e[1] = E) : E = e[1];
  const N = s ? w : r?.label ?? "";
  let M;
  e[2] !== l ? (M = (ce) => {
    l(ce), ce && R("");
  }, e[2] = l, e[3] = M) : M = e[3];
  const T = a && "cursor-not-allowed";
  let P;
  e[4] !== T || e[5] !== C ? (P = ne(C, "relative", "[&:not([data-readonly])]:focus-within:border-input-active-outline", T), e[4] = T, e[5] = C, e[6] = P) : P = e[6];
  let k;
  e[7] !== s || e[8] !== f || e[9] !== c || e[10] !== h || e[11] !== r ? (k = !s && /* @__PURE__ */ g("span", { className: ne("pointer-events-none absolute inset-y-0 left-(--spacing-10) flex min-w-0 items-center text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", c ? "right-(--spacing-10)" : "right-(--spacing-32)"), children: h ? h(r) : r ? /* @__PURE__ */ g("span", { className: "truncate", children: r.label }) : c ? null : /* @__PURE__ */ g("span", { className: "truncate text-input-text-placeholder", children: f }) }), e[7] = s, e[8] = f, e[9] = c, e[10] = h, e[11] = r, e[12] = k) : k = e[12];
  const I = p || n ? void 0 : c ? "Select option" : f ?? "Select option", D = u || void 0, O = c ? -1 : void 0, V = !s && "text-transparent caret-transparent";
  let _;
  e[13] !== V ? (_ = ne("min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", V), e[13] = V, e[14] = _) : _ = e[14];
  const L = s ? "Search" : void 0;
  let A;
  e[15] !== c ? (A = (ce) => {
    c && ce.preventDefault();
  }, e[15] = c, e[16] = A) : A = e[16];
  let $;
  e[17] !== m || e[18] !== n || e[19] !== O || e[20] !== _ || e[21] !== L || e[22] !== A || e[23] !== I || e[24] !== D ? ($ = /* @__PURE__ */ g(Os, { id: n, "data-testid": m, "aria-label": I, "aria-required": D, tabIndex: O, className: _, placeholder: L, onFocus: kR, onMouseDown: A }), e[17] = m, e[18] = n, e[19] = O, e[20] = _, e[21] = L, e[22] = A, e[23] = I, e[24] = D, e[25] = $) : $ = e[25];
  let Y;
  e[26] !== m || e[27] !== c ? (Y = !c && /* @__PURE__ */ g(Ia, { "data-testid": m ? `${m}-trigger` : void 0, "aria-label": "Open options", className: "inline-flex shrink-0 text-input-text-default outline-none", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[26] = m, e[27] = c, e[28] = Y) : Y = e[28];
  let z;
  e[29] !== $ || e[30] !== Y || e[31] !== P || e[32] !== k ? (z = /* @__PURE__ */ F(ka, { className: P, children: [
    k,
    $,
    Y
  ] }), e[29] = $, e[30] = Y, e[31] = P, e[32] = k, e[33] = z) : z = e[33];
  const H = v === "content" ? "w-auto min-w-(--anchor-width) max-w-[calc(100vw-var(--spacing-16))]" : "w-(--anchor-width) min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]";
  let K;
  e[34] !== H ? (K = ne("z-[var(--z-layer-popover)]", H), e[34] = H, e[35] = K) : K = e[35];
  let G;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = ui({
    size: "auto"
  }), e[36] = G) : G = e[36];
  const q = m ? `${m}-options` : void 0;
  let ee;
  e[37] !== b || e[38] !== r?.value ? (ee = (ce) => /* @__PURE__ */ F(_s, { value: ce, disabled: ce.disabled, className: Oo({}), children: [
    ce.icon && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(We, { name: ce.icon, size: "xs", tone: "inherit" }) }),
    /* @__PURE__ */ g(Xr, { checked: ce.value === r?.value, children: b ? b(ce) : ce.label })
  ] }, ce.value), e[37] = b, e[38] = r?.value, e[39] = ee) : ee = e[39];
  let W;
  e[40] !== q || e[41] !== ee ? (W = /* @__PURE__ */ g(Ds, { "data-testid": q, className: "flex flex-col outline-none", children: ee }), e[40] = q, e[41] = ee, e[42] = W) : W = e[42];
  let X;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (X = /* @__PURE__ */ g(Qf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[43] = X) : X = e[43];
  let J;
  e[44] !== W ? (J = /* @__PURE__ */ F(Ta, { className: G, children: [
    W,
    X
  ] }), e[44] = W, e[45] = J) : J = e[45];
  let re;
  e[46] !== K || e[47] !== J ? (re = /* @__PURE__ */ g(Ma, { sideOffset: 4, className: K, children: J }), e[46] = K, e[47] = J, e[48] = re) : re = e[48];
  let Q;
  e[49] !== y || e[50] !== re ? (Q = /* @__PURE__ */ g(Pa, { container: y, children: re }), e[49] = y, e[50] = re, e[51] = Q) : Q = e[51];
  let ie;
  return e[52] !== a || e[53] !== d || e[54] !== s || e[55] !== o || e[56] !== c || e[57] !== u || e[58] !== S || e[59] !== z || e[60] !== E || e[61] !== Q || e[62] !== N || e[63] !== M ? (ie = /* @__PURE__ */ F(zf, { value: S, onValueChange: E, disabled: a, readOnly: c, required: u, name: d, modal: !1, items: o, isItemEqualToValue: MR, itemToStringLabel: PR, itemToStringValue: IR, open: s, inputValue: N, onInputValueChange: R, onOpenChange: M, children: [
    z,
    Q
  ] }), e[52] = a, e[53] = d, e[54] = s, e[55] = o, e[56] = c, e[57] = u, e[58] = S, e[59] = z, e[60] = E, e[61] = Q, e[62] = N, e[63] = M, e[64] = ie) : ie = e[64], ie;
}
function kR(t) {
  return t.currentTarget.select();
}
function IR(t) {
  return t.value;
}
function PR(t) {
  return t.label;
}
function MR(t, e) {
  return t.value === e.value;
}
const TR = ae(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "data-[disabled]:cursor-not-allowed", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function ob(t) {
  const e = B.c(52), {
    id: n,
    options: o,
    value: r,
    onChange: i,
    defaultValue: s,
    placeholder: l,
    size: a,
    label: c,
    tooltip: u,
    required: d,
    description: f,
    error: p,
    disabled: m,
    readOnly: h,
    reserveSubtextSpace: b,
    name: v,
    "data-testid": C,
    renderValue: y,
    renderOption: w,
    popupWidth: R,
    searchable: S
  } = t, E = a === void 0 ? "md" : a, N = h === void 0 ? !1 : h, M = b === void 0 ? !0 : b, T = R === void 0 ? "anchor" : R, P = S === void 0 ? !1 : S, k = !!p, D = M || k || !!f, O = r !== void 0, [V, _] = qe(s ?? null), [L, A] = qe(!1), $ = L && !N;
  let Y, z;
  e[0] !== N ? (Y = () => {
    N && A(!1);
  }, z = [N], e[0] = N, e[1] = Y, e[2] = z) : (Y = e[1], z = e[2]), Rt(Y, z);
  const H = O ? r : V;
  let K;
  if (e[3] !== H || e[4] !== o) {
    let ce;
    e[6] !== H ? (ce = (oe) => oe.value === H, e[6] = H, e[7] = ce) : ce = e[7], K = o.find(ce), e[3] = H, e[4] = o, e[5] = K;
  } else
    K = e[5];
  const G = K;
  let q;
  e[8] !== H || e[9] !== O || e[10] !== i || e[11] !== d ? (q = function(oe, se) {
    const be = se.reason === "item-press" && !d && H !== null && oe === H ? null : oe;
    i?.(be, se), !O && !se.isCanceled && _(be);
  }, e[8] = H, e[9] = O, e[10] = i, e[11] = d, e[12] = q) : q = e[12];
  const ee = q;
  let W;
  e[13] !== m || e[14] !== k || e[15] !== E ? (W = ne(TR({
    size: E
  }), !k && "data-[readonly]:border-input-readonly-outline", m && "opacity-50", k && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[13] = m, e[14] = k, e[15] = E, e[16] = W) : W = e[16];
  const X = W;
  let J;
  e[17] !== c || e[18] !== d || e[19] !== u ? (J = c && /* @__PURE__ */ g(hi, { label: c, required: d, tooltip: u }), e[17] = c, e[18] = d, e[19] = u, e[20] = J) : J = e[20];
  let re;
  e[21] !== H || e[22] !== C || e[23] !== m || e[24] !== ee || e[25] !== n || e[26] !== $ || e[27] !== c || e[28] !== v || e[29] !== o || e[30] !== l || e[31] !== T || e[32] !== N || e[33] !== w || e[34] !== y || e[35] !== d || e[36] !== P || e[37] !== G || e[38] !== X ? (re = P ? /* @__PURE__ */ g(NR, { id: n, options: o, selectedOption: G, onValueChange: ee, open: $, onOpenChange: A, disabled: m, readOnly: N, required: d, name: v, placeholder: l, label: c, "data-testid": C, renderValue: y, renderOption: w, popupWidth: T, triggerClassName: X }) : /* @__PURE__ */ g(uR, { id: n, options: o, value: H, selectedOption: G, onValueChange: ee, open: $, onOpenChange: A, disabled: m, readOnly: N, required: d, name: v, placeholder: l, label: c, "data-testid": C, renderValue: y, renderOption: w, popupWidth: T, triggerClassName: X }), e[21] = H, e[22] = C, e[23] = m, e[24] = ee, e[25] = n, e[26] = $, e[27] = c, e[28] = v, e[29] = o, e[30] = l, e[31] = T, e[32] = N, e[33] = w, e[34] = y, e[35] = d, e[36] = P, e[37] = G, e[38] = X, e[39] = re) : re = e[39];
  let Q;
  e[40] !== f || e[41] !== p || e[42] !== k || e[43] !== M || e[44] !== D ? (Q = D && /* @__PURE__ */ g("div", { "data-testid": "select-subtext-row", className: ne("mt-(--spacing-4)", M && "min-h-(--spacing-20)"), children: k ? /* @__PURE__ */ g(Or, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: p }) : f ? /* @__PURE__ */ g(mi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: f }) : null }), e[40] = f, e[41] = p, e[42] = k, e[43] = M, e[44] = D, e[45] = Q) : Q = e[45];
  let ie;
  return e[46] !== m || e[47] !== k || e[48] !== J || e[49] !== re || e[50] !== Q ? (ie = /* @__PURE__ */ F(Tr, { invalid: k, disabled: m, className: "flex flex-col w-full", children: [
    J,
    re,
    Q
  ] }), e[46] = m, e[47] = k, e[48] = J, e[49] = re, e[50] = Q, e[51] = ie) : ie = e[51], ie;
}
function Im(t) {
  if (t)
    return {
      ...t,
      tone: t.tone === "neutral" ? "activity" : t.tone
    };
}
function Bi(t) {
  return t.replace(/^\s*(?:\([^)]*\)\s*[-–—]?\s*)+/, "").split(/\s+/).filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
function OR(t) {
  const e = B.c(36), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    collapsed: a
  } = t;
  let c;
  e[0] !== n ? (c = function(p) {
    return n.find((m) => m.id === p);
  }, e[0] = n, e[1] = c) : c = e[1];
  const u = c;
  let d;
  if (e[2] !== s || e[3] !== a || e[4] !== n || e[5] !== l || e[6] !== u || e[7] !== i || e[8] !== r || e[9] !== o) {
    const f = u(o), p = f ? l?.(f) ?? [] : [];
    let m;
    e[11] !== a || e[12] !== n.length ? (m = a ? /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }) : /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
      "FACILITIES (",
      n.length,
      ")"
    ] }), e[11] = a, e[12] = n.length, e[13] = m) : m = e[13];
    const h = a ? "flex w-full justify-center" : void 0, b = a ? "w-[60px] shrink-0" : void 0;
    let v;
    e[14] !== n ? (v = n.map(DR), e[14] = n, e[15] = v) : v = e[15];
    let C;
    e[16] !== a || e[17] !== u ? (C = (N) => N ? /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(jr, { initials: Bi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      !a && /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }) : null, e[16] = a, e[17] = u, e[18] = C) : C = e[18];
    let y;
    e[19] !== u ? (y = (N) => /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(jr, { initials: Bi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }), e[19] = u, e[20] = y) : y = e[20];
    let w;
    e[21] !== i || e[22] !== r ? (w = (N) => {
      N && (r ?? i)(N);
    }, e[21] = i, e[22] = r, e[23] = w) : w = e[23];
    let R;
    e[24] !== o || e[25] !== v || e[26] !== C || e[27] !== y || e[28] !== w ? (R = /* @__PURE__ */ g(ob, { searchable: !0, options: v, required: !0, popupWidth: "content", reserveSubtextSpace: !1, size: "md", value: o, renderValue: C, renderOption: y, onChange: w }), e[24] = o, e[25] = v, e[26] = C, e[27] = y, e[28] = w, e[29] = R) : R = e[29];
    let S;
    e[30] !== R || e[31] !== b ? (S = /* @__PURE__ */ g("div", { className: b, children: R }), e[30] = R, e[31] = b, e[32] = S) : S = e[32];
    let E;
    e[33] !== S || e[34] !== h ? (E = /* @__PURE__ */ g("div", { className: h, children: S }), e[33] = S, e[34] = h, e[35] = E) : E = e[35], d = /* @__PURE__ */ F("section", { "aria-label": `Facilities (${n.length})`, children: [
      m,
      E,
      f && p.length > 0 && /* @__PURE__ */ g("div", { className: "mt-(--spacing-4) flex flex-col gap-(--spacing-4)", children: p.map((N) => /* @__PURE__ */ g(Nl, { itemId: N.id, label: N.label, badge: N.badge, leading: N.icon ? {
        type: "icon",
        name: N.icon
      } : void 0, href: N.render ? void 0 : N.href ?? "#", render: N.render, onClick: (M) => {
        i(f.id), N.onClick?.(M);
      }, selected: f.id === o && N.id === s, variant: "item" }, N.id)) })
    ] }), e[2] = s, e[3] = a, e[4] = n, e[5] = l, e[6] = u, e[7] = i, e[8] = r, e[9] = o, e[10] = d;
  } else
    d = e[10];
  return d;
}
function DR(t) {
  return {
    value: t.id,
    label: t.name
  };
}
function ID(t) {
  const e = B.c(85), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    expandedFacilityId: a,
    initialExpandedFacilityId: c,
    onExpandedFacilityChange: u
  } = t, {
    collapsed: d
  } = b0(), [f, p] = qe(c), m = "expandedFacilityId" in t, h = m ? a : f, b = nt(!1), v = nt(o);
  let C;
  e[0] !== m || e[1] !== u ? (C = function(I) {
    m || p(I), u?.(I);
  }, e[0] = m, e[1] = u, e[2] = C) : C = e[2];
  const y = C;
  let w, R;
  if (e[3] !== h || e[4] !== n || e[5] !== m || e[6] !== u || e[7] !== o ? (w = () => {
    if (m || n.length < 2 || n.length > 5)
      return;
    const k = !b.current;
    b.current = !0;
    const I = v.current !== o;
    v.current = o, (k && h === void 0 || I || h !== void 0 && !n.some((D) => D.id === h)) && (m || p(o), u?.(o));
  }, R = [h, n, m, u, o], e[3] = h, e[4] = n, e[5] = m, e[6] = u, e[7] = o, e[8] = w, e[9] = R) : (w = e[8], R = e[9]), Rt(w, R), n.length === 0)
    return null;
  if (n.length === 1) {
    const k = n[0];
    let I, D, O, V, _, L, A, $, Y;
    if (e[10] !== s || e[11] !== l || e[12] !== k || e[13] !== i || e[14] !== o) {
      const K = l?.(k) ?? [];
      let G;
      e[24] !== k.alertBadge ? (G = Im(k.alertBadge), e[24] = k.alertBadge, e[25] = G) : G = e[25];
      const q = G;
      D = k.name, I = pm, O = !1, V = k.id, _ = k.name, L = q;
      let ee;
      e[26] !== s ? (ee = (J) => J.id === s, e[26] = s, e[27] = ee) : ee = e[27], A = K.some(ee);
      let W;
      e[28] !== k.name ? (W = Bi(k.name), e[28] = k.name, e[29] = W) : W = e[29], e[30] !== k.avatarUrl || e[31] !== W ? ($ = {
        type: "avatar",
        initials: W,
        src: k.avatarUrl
      }, e[30] = k.avatarUrl, e[31] = W, e[32] = $) : $ = e[32];
      let X;
      e[33] !== s || e[34] !== k.id || e[35] !== i || e[36] !== o ? (X = (J) => /* @__PURE__ */ g(Nl, { itemId: J.id, label: J.label, badge: J.badge, leading: J.icon ? {
        type: "icon",
        name: J.icon
      } : void 0, href: J.render ? void 0 : J.href ?? "#", render: J.render, onClick: (re) => {
        i(k.id), J.onClick?.(re);
      }, selected: k.id === o && J.id === s, variant: "item" }, J.id), e[33] = s, e[34] = k.id, e[35] = i, e[36] = o, e[37] = X) : X = e[37], Y = K.map(X), e[10] = s, e[11] = l, e[12] = k, e[13] = i, e[14] = o, e[15] = I, e[16] = D, e[17] = O, e[18] = V, e[19] = _, e[20] = L, e[21] = A, e[22] = $, e[23] = Y;
    } else
      I = e[15], D = e[16], O = e[17], V = e[18], _ = e[19], L = e[20], A = e[21], $ = e[22], Y = e[23];
    let z;
    e[38] !== I || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== L || e[43] !== A || e[44] !== $ || e[45] !== Y ? (z = /* @__PURE__ */ g(I, { collapsible: O, itemId: V, label: _, badge: L, hasSelectedChild: A, leading: $, children: Y }), e[38] = I, e[39] = O, e[40] = V, e[41] = _, e[42] = L, e[43] = A, e[44] = $, e[45] = Y, e[46] = z) : z = e[46];
    let H;
    return e[47] !== D || e[48] !== z ? (H = /* @__PURE__ */ g("section", { "aria-label": D, children: z }), e[47] = D, e[48] = z, e[49] = H) : H = e[49], H;
  }
  if (n.length > 5) {
    let k;
    return e[50] !== s || e[51] !== d || e[52] !== n || e[53] !== l || e[54] !== i || e[55] !== r || e[56] !== o ? (k = /* @__PURE__ */ g(OR, { facilities: n, selectedFacilityId: o, onFacilitySelect: r, onFacilityChange: i, activeItemId: s, facilitySubNavItems: l, collapsed: d }), e[50] = s, e[51] = d, e[52] = n, e[53] = l, e[54] = i, e[55] = r, e[56] = o, e[57] = k) : k = e[57], k;
  }
  const S = `Facilities (${n.length})`;
  let E;
  e[58] !== d || e[59] !== n.length ? (E = !d && /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
    "FACILITIES (",
    n.length,
    ")"
  ] }), e[58] = d, e[59] = n.length, e[60] = E) : E = e[60];
  let N;
  e[61] !== d ? (N = d && /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }), e[61] = d, e[62] = N) : N = e[62];
  let M;
  if (e[63] !== s || e[64] !== h || e[65] !== n || e[66] !== l || e[67] !== i || e[68] !== o || e[69] !== y) {
    let k;
    e[71] !== s || e[72] !== h || e[73] !== l || e[74] !== i || e[75] !== o || e[76] !== y ? (k = (I) => {
      const D = l?.(I) ?? [], O = Im(I.alertBadge), V = I.id === o && D.some((L) => L.id === s), _ = I.id === h;
      return D.length ? /* @__PURE__ */ g(pm, { itemId: I.id, label: I.name, badge: O, leading: {
        type: "avatar",
        initials: Bi(I.name),
        src: I.avatarUrl
      }, hasSelectedChild: V, open: _, onOpenChange: (L) => {
        const A = L ? I.id : void 0;
        y(A);
      }, children: D.map((L) => /* @__PURE__ */ g(Nl, { itemId: L.id, label: L.label, badge: L.badge, leading: L.icon ? {
        type: "icon",
        name: L.icon
      } : void 0, href: L.render ? void 0 : L.href ?? "#", render: L.render, onClick: (A) => {
        i(I.id), L.onClick?.(A);
      }, selected: I.id === o && L.id === s, variant: "subItem" }, L.id)) }, I.id) : /* @__PURE__ */ g(Nl, { itemId: I.id, label: I.name, leading: {
        type: "avatar",
        initials: Bi(I.name),
        src: I.avatarUrl
      }, href: "#", badge: O, selected: I.id === o, onClick: (L) => {
        L.preventDefault(), i(I.id);
      } }, I.id);
    }, e[71] = s, e[72] = h, e[73] = l, e[74] = i, e[75] = o, e[76] = y, e[77] = k) : k = e[77], M = n.map(k), e[63] = s, e[64] = h, e[65] = n, e[66] = l, e[67] = i, e[68] = o, e[69] = y, e[70] = M;
  } else
    M = e[70];
  let T;
  e[78] !== M ? (T = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-4)", children: M }), e[78] = M, e[79] = T) : T = e[79];
  let P;
  return e[80] !== S || e[81] !== E || e[82] !== N || e[83] !== T ? (P = /* @__PURE__ */ F("section", { "aria-label": S, className: "flex flex-col gap-(--spacing-4)", children: [
    E,
    N,
    T
  ] }), e[80] = S, e[81] = E, e[82] = N, e[83] = T, e[84] = P) : P = e[84], P;
}
const rb = ho(void 0);
function _R(t) {
  return t === "light" || t === "dark" || t === "system";
}
function Pm() {
  return typeof window > "u" || !window.matchMedia ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function VR(t, e) {
  if (typeof window > "u")
    return e;
  try {
    const n = localStorage.getItem(t);
    return _R(n) ? n : e;
  } catch {
    return e;
  }
}
function AR(t) {
  const e = B.c(21), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, i = o === void 0 ? "light" : o, s = r === void 0 ? "assetwatch-ui-theme" : r;
  let l;
  e[0] !== i || e[1] !== s ? (l = () => VR(s, i), e[0] = i, e[1] = s, e[2] = l) : l = e[2];
  const [a, c] = qe(l), [u, d] = qe(Pm), f = a === "system" ? u : a;
  let p, m;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = () => {
    if (!window.matchMedia)
      return;
    const E = window.matchMedia("(prefers-color-scheme: dark)"), N = () => d(Pm());
    return E.addEventListener("change", N), () => E.removeEventListener("change", N);
  }, m = [], e[3] = p, e[4] = m) : (p = e[3], m = e[4]), Rt(p, m);
  let h, b;
  e[5] !== f ? (h = () => {
    const E = window.document.documentElement;
    E.classList.remove("light", "dark"), E.classList.add(f);
  }, b = [f], e[5] = f, e[6] = h, e[7] = b) : (h = e[6], b = e[7]), Rt(h, b);
  let v;
  e[8] !== s ? (v = (E) => {
    localStorage.setItem(s, E), c(E);
  }, e[8] = s, e[9] = v) : v = e[9];
  const C = v;
  let y;
  e[10] !== f || e[11] !== C ? (y = () => {
    C(f === "light" ? "dark" : "light");
  }, e[10] = f, e[11] = C, e[12] = y) : y = e[12];
  const w = y;
  let R;
  e[13] !== f || e[14] !== C || e[15] !== a || e[16] !== w ? (R = {
    theme: a,
    resolvedTheme: f,
    setTheme: C,
    toggleTheme: w
  }, e[13] = f, e[14] = C, e[15] = a, e[16] = w, e[17] = R) : R = e[17];
  let S;
  return e[18] !== n || e[19] !== R ? (S = /* @__PURE__ */ g(rb.Provider, { value: R, children: n }), e[18] = n, e[19] = R, e[20] = S) : S = e[20], S;
}
function LR() {
  const t = xg(rb);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
const PD = {
  openMenuAriaLabel: "Open account menu",
  engineeringOnly: "Engineering Only",
  appearance: "Theme",
  matchBrowser: "Match Browser",
  light: "Light",
  dark: "Dark",
  currentArtifact: "Current artifact",
  signOut: "Sign out"
}, FR = [{
  value: "system",
  label: "matchBrowser"
}, {
  value: "light",
  label: "light"
}, {
  value: "dark",
  label: "dark"
}];
function MD(t) {
  const e = B.c(19), {
    additionalContent: n,
    labels: o,
    engineeringOnly: r,
    engineeringContent: i,
    onOpenArtifact: s,
    onSignOut: l
  } = t, a = r === void 0 ? !1 : r, {
    theme: c,
    setTheme: u
  } = LR();
  let d;
  e[0] !== o.openMenuAriaLabel ? (d = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(gt, { "aria-label": o.openMenuAriaLabel, icon: "user", size: "md", variant: "outline" }) }), e[0] = o.openMenuAriaLabel, e[1] = d) : d = e[1];
  let f;
  e[2] !== o.signOut || e[3] !== l ? (f = /* @__PURE__ */ g(pr, { "data-testid": "nav-sign-out", leadingIcon: "logout-exit", onClick: l, tone: "destructive", children: o.signOut }), e[2] = o.signOut, e[3] = l, e[4] = f) : f = e[4];
  let p;
  e[5] !== i || e[6] !== a || e[7] !== o || e[8] !== s || e[9] !== u || e[10] !== c ? (p = a ? /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ g(fu, { children: o.engineeringOnly }),
    /* @__PURE__ */ g(pr, { leadingIcon: "settings-cog", submenu: /* @__PURE__ */ F(_d, { value: c, onValueChange: (b) => u(b), children: [
      /* @__PURE__ */ g(fu, { children: o.appearance }),
      FR.map((b) => {
        const {
          value: v,
          label: C
        } = b;
        return /* @__PURE__ */ g(Vd, { value: v, children: o[C] }, v);
      })
    ] }), children: o.appearance }),
    s ? /* @__PURE__ */ g(pr, { leadingIcon: "document", onClick: s, children: o.currentArtifact }) : null,
    i
  ] }) : null, e[5] = i, e[6] = a, e[7] = o, e[8] = s, e[9] = u, e[10] = c, e[11] = p) : p = e[11];
  let m;
  e[12] !== n || e[13] !== f || e[14] !== p ? (m = /* @__PURE__ */ F(Pr, { align: "end", size: "sm", children: [
    n,
    f,
    p
  ] }), e[12] = n, e[13] = f, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== d || e[17] !== m ? (h = /* @__PURE__ */ F(Dd, { children: [
    d,
    m
  ] }), e[16] = d, e[17] = m, e[18] = h) : h = e[18], h;
}
const $R = ae(["rounded-(--radius-sm)", "border border-outline-subtle", "bg-surface-container-lowest", "flex flex-col"], {
  variants: {
    padding: {
      compact: "py-(--spacing-12) px-(--spacing-6)",
      standard: "p-(--spacing-12)"
    },
    elevated: {
      true: "shadow-elevation-1",
      false: null
    }
  },
  defaultVariants: {
    padding: "standard",
    elevated: !1
  }
}), HR = ae(["w-full", "flex flex-col", "[overflow:clip]", "rounded-(--radius-sm)", "border-[0.5px] border-outline-subtle", "bg-surface-container-low", "text-text-default"], {
  variants: {
    padding: {
      none: "p-0",
      compact: "p-(--spacing-8) gap-(--spacing-8)"
    }
  },
  defaultVariants: {
    padding: "compact"
  }
}), zR = ae(["min-w-0 truncate", "font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "font-medium", "leading-(--line-height-24)", "text-text-default"]), BR = ae(["w-full min-w-0", "flex gap-(--spacing-24) items-start overflow-hidden"]);
function ib(t) {
  const e = B.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: i,
    elevated: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o || e[7] !== r || e[8] !== i ? (l = ne($R({
    padding: i,
    elevated: r
  }), o), e[6] = o, e[7] = r, e[8] = i, e[9] = l) : l = e[9];
  let a;
  return e[10] !== n || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ g("div", { className: l, ...s, "data-slot": "content-container-root", children: n }), e[10] = n, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function sb(t) {
  const e = B.c(12);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] !== o || e[6] !== r ? (s = ne(HR({
    padding: r
  }), o), e[5] = o, e[6] = r, e[7] = s) : s = e[7];
  let l;
  return e[8] !== n || e[9] !== i || e[10] !== s ? (l = /* @__PURE__ */ g("div", { className: s, ...i, "data-slot": "content-container-body", children: n }), e[8] = n, e[9] = i, e[10] = s, e[11] = l) : l = e[11], l;
}
function lb(t) {
  const e = B.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne("w-full", o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...r, "data-slot": "content-container-footer", children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
function WR(t) {
  const e = B.c(20), {
    main: n,
    start: o,
    titleAccessory: r,
    actions: i,
    summary: s
  } = t;
  let l;
  e[0] !== o ? (l = o && /* @__PURE__ */ g("div", { "data-slot": "content-container-start-accessory", className: "flex shrink-0 items-center", children: o }), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = r && /* @__PURE__ */ g("div", { "data-slot": "content-container-title-accessory", className: "flex shrink-0 items-center", children: r }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== n || e[5] !== a ? (c = /* @__PURE__ */ F("div", { "data-slot": "content-container-main", className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    a
  ] }), e[4] = n, e[5] = a, e[6] = c) : c = e[6];
  let u;
  e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-left", className: "flex flex-1 gap-(--spacing-8) items-center min-w-0", children: [
    l,
    c
  ] }), e[7] = l, e[8] = c, e[9] = u) : u = e[9];
  let d;
  e[10] !== i ? (d = i && /* @__PURE__ */ g("div", { "data-slot": "content-container-actions", className: "flex shrink-0 gap-(--spacing-8) items-center justify-end", children: i }), e[10] = i, e[11] = d) : d = e[11];
  let f;
  e[12] !== u || e[13] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "content-container-header", className: "flex items-center gap-(--spacing-8) w-full", children: [
    u,
    d
  ] }), e[12] = u, e[13] = d, e[14] = f) : f = e[14];
  let p;
  e[15] !== s ? (p = s && /* @__PURE__ */ g("div", { "data-slot": "content-container-summary", className: BR(), children: s }), e[15] = s, e[16] = p) : p = e[16];
  let m;
  return e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-wrapper", className: "flex flex-col gap-(--spacing-8) w-full", children: [
    f,
    p
  ] }), e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
function ab(t) {
  const e = B.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne(zR(), o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("span", { className: i, ...r, children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const UR = ae(["hover:bg-surface-container-low", "cursor-pointer", "transition-colors duration-200 ease-in-out", "has-[:focus-visible]:[outline-width:var(--spacing-2)]", "has-[:focus-visible]:outline-solid", "has-[:focus-visible]:outline-tertiary-tertiary", "has-[:focus-visible]:[outline-offset:3px]", "data-[disabled]:opacity-50", "data-[disabled]:cursor-default"]), GR = ae(["w-full", "flex items-center gap-(--spacing-8)", "cursor-pointer", "min-h-(--spacing-24)", "text-left", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), YR = ae(["group", "flex size-(--spacing-32) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "cursor-pointer", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), jR = ae(["w-full", "min-w-0", "overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "mt-(--spacing-12)", "[&[data-starting-style]]:mt-0", "[&[data-ending-style]]:mt-0", "transition-[height,margin-top] duration-150 ease-in-out", "motion-reduce:transition-none"]), KR = ["[data-accordion-panel-content]", "[data-accordion-ignore-shell-click]", "button", "a", "input", "label", "select", "textarea", "[role='button']", "[role='link']", "[role='menuitem']", "[role='option']", "[role='switch']", "[role='checkbox']", "[role='radio']"].join(",");
function qR(t) {
  return t instanceof Element ? t.closest(KR) === null : !1;
}
function TD(t) {
  const e = B.c(66);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    open: a,
    defaultOpen: r,
    onOpenChange: l,
    title: f,
    startAccessory: u,
    titleAccessory: p,
    actions: n,
    summary: d,
    children: o,
    footer: s,
    disabled: i,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  let m;
  e[13] !== r ? (m = () => r ?? !1, e[13] = r, e[14] = m) : m = e[14];
  const [h, b] = qe(m), v = a !== void 0, C = v ? a : h;
  let y;
  e[15] !== v || e[16] !== l ? (y = function(W) {
    v || b(W), l?.(W);
  }, e[15] = v, e[16] = l, e[17] = y) : y = e[17];
  const w = y;
  let R;
  e[18] !== i || e[19] !== C || e[20] !== w ? (R = function(W) {
    i || !qR(W.target) || w(!C);
  }, e[18] = i, e[19] = C, e[20] = w, e[21] = R) : R = e[21];
  const S = R, E = i ? "" : void 0;
  let N;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = UR(), e[22] = N) : N = e[22];
  let M;
  e[23] !== u ? (M = u && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: u }), e[23] = u, e[24] = M) : M = e[24];
  let T;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = GR(), e[25] = T) : T = e[25];
  let P;
  e[26] !== f ? (P = /* @__PURE__ */ g("h3", { className: "flex min-w-0 flex-1 m-0", children: /* @__PURE__ */ g(Gl, { className: T, onClick: XR, children: /* @__PURE__ */ g(ab, { className: "flex-1", children: f }) }) }), e[26] = f, e[27] = P) : P = e[27];
  let k;
  e[28] !== p ? (k = p && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: p }), e[28] = p, e[29] = k) : k = e[29];
  let I;
  e[30] !== P || e[31] !== k ? (I = /* @__PURE__ */ F("div", { className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    P,
    k
  ] }), e[30] = P, e[31] = k, e[32] = I) : I = e[32];
  let D;
  e[33] !== n ? (D = n && /* @__PURE__ */ g("div", { "data-accordion-ignore-shell-click": "", className: "flex shrink-0 items-center", children: n }), e[33] = n, e[34] = D) : D = e[34];
  let O;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = YR(), e[35] = O) : O = e[35];
  let V;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ g("span", { className: "flex group-data-[panel-open]:hidden", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: "md", tone: "secondary" }) }), e[36] = V) : V = e[36];
  let _;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ F(Gl, { "aria-label": "Toggle accordion", "data-slot": "accordion-chevron-trigger", className: O, onClick: ZR, children: [
    V,
    /* @__PURE__ */ g("span", { className: "hidden group-data-[panel-open]:flex", children: /* @__PURE__ */ g(We, { name: "chevron-up", size: "md", tone: "secondary" }) })
  ] }), e[37] = _) : _ = e[37];
  let L;
  e[38] !== I || e[39] !== D || e[40] !== M ? (L = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8) w-full", children: [
    M,
    I,
    D,
    _
  ] }), e[38] = I, e[39] = D, e[40] = M, e[41] = L) : L = e[41];
  let A;
  e[42] !== d ? (A = d && /* @__PURE__ */ g("div", { className: "w-full min-w-0", children: d }), e[42] = d, e[43] = A) : A = e[43];
  let $;
  e[44] !== L || e[45] !== A ? ($ = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) w-full", children: [
    L,
    A
  ] }), e[44] = L, e[45] = A, e[46] = $) : $ = e[46];
  let Y;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = jR(), e[47] = Y) : Y = e[47];
  let z;
  e[48] !== o ? (z = /* @__PURE__ */ g(sb, { children: o }), e[48] = o, e[49] = z) : z = e[49];
  let H;
  e[50] !== s ? (H = s && /* @__PURE__ */ g(lb, { children: s }), e[50] = s, e[51] = H) : H = e[51];
  let K;
  e[52] !== z || e[53] !== H ? (K = /* @__PURE__ */ g(cf, { className: Y, children: /* @__PURE__ */ F("div", { "data-accordion-panel-content": "", className: "flex flex-col gap-(--spacing-4) cursor-default", children: [
    z,
    H
  ] }) }), e[52] = z, e[53] = H, e[54] = K) : K = e[54];
  let G;
  e[55] !== S || e[56] !== $ || e[57] !== K || e[58] !== E ? (G = /* @__PURE__ */ F(ib, { padding: "standard", "data-disabled": E, className: N, onClick: S, children: [
    $,
    K
  ] }), e[55] = S, e[56] = $, e[57] = K, e[58] = E, e[59] = G) : G = e[59];
  let q;
  return e[60] !== i || e[61] !== C || e[62] !== c || e[63] !== w || e[64] !== G ? (q = /* @__PURE__ */ g(af, { ...c, open: C, onOpenChange: w, disabled: i, className: "group", children: G }), e[60] = i, e[61] = C, e[62] = c, e[63] = w, e[64] = G, e[65] = q) : q = e[65], q;
}
function ZR(t) {
  return t.stopPropagation();
}
function XR(t) {
  return t.stopPropagation();
}
const QR = ae(["flex", "w-full", "items-center", "justify-between", "px-(--spacing-24)", "py-(--spacing-16)", "rounded-(--radius-sm)", "relative", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-px", "after:bg-outline-subtle"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function OD(t) {
  const e = B.c(35);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: r,
    tone: l,
    title: a,
    description: o,
    action: n,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "neutral" : l, u = c === "negative", d = u ? "alert" : "status", f = u ? "assertive" : "polite";
  let p;
  e[8] !== c ? (p = ne(QR({
    tone: c
  })), e[8] = c, e[9] = p) : p = e[9];
  let m;
  e[10] !== r ? (m = /* @__PURE__ */ g(We, { name: r, size: "md", tone: "inherit" }), e[10] = r, e[11] = m) : m = e[11];
  let h;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    color: "inherit"
  }, e[12] = h) : h = e[12];
  let b;
  e[13] !== a ? (b = /* @__PURE__ */ g(wn, { as: "span", size: "md", style: h, children: a }), e[13] = a, e[14] = b) : b = e[14];
  let v;
  e[15] !== o ? (v = o ? /* @__PURE__ */ g(nn, { as: "span", size: "md", style: {
    color: "inherit"
  }, children: o }) : null, e[15] = o, e[16] = v) : v = e[16];
  let C;
  e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { className: "min-w-0 flex flex-col gap-(--spacing-8)", children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  e[20] !== m || e[21] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    m,
    C
  ] }), e[20] = m, e[21] = C, e[22] = y) : y = e[22];
  let w;
  e[23] !== i ? (w = i ? /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Dismiss banner", variant: "ghost", size: "sm", onClick: i }) : null, e[23] = i, e[24] = w) : w = e[24];
  let R;
  e[25] !== n || e[26] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    w
  ] }), e[25] = n, e[26] = w, e[27] = R) : R = e[27];
  let S;
  return e[28] !== s || e[29] !== y || e[30] !== R || e[31] !== d || e[32] !== f || e[33] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...s, children: [
    y,
    R
  ] }), e[28] = s, e[29] = y, e[30] = R, e[31] = d, e[32] = f, e[33] = p, e[34] = S) : S = e[34], S;
}
function DD(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("nav", { "aria-label": "Breadcrumb", "data-slot": "breadcrumb", className: "w-full min-w-0", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function _D({
  children: t,
  ref: e,
  ...n
}) {
  const o = nt(null), r = nt(null), i = nt(() => {
  }), [s, l] = qe(!1), a = Ql.toArray(t), c = a.filter(cb), u = a.filter(tE), d = nE(t), f = c.length > 2 && a.length === c.length + u.length;
  i.current = function() {
    const b = o.current, v = r.current;
    if (!f || !b || !v) {
      l(!1);
      return;
    }
    const C = b.getBoundingClientRect().width, y = v.getBoundingClientRect().width;
    l(C > 0 && y > C);
  };
  function p(h) {
    o.current = h, typeof e == "function" ? e(h) : e && (e.current = h);
  }
  po(() => {
    i.current();
  }), po(() => {
    const h = o.current;
    if (!h || typeof ResizeObserver > "u")
      return;
    const b = new ResizeObserver(() => {
      i.current();
    });
    return b.observe(h), () => {
      b.disconnect();
    };
  }, []);
  const m = s && f ? [c[0], Mm(u[0], "breadcrumb-overflow-leading-separator"), /* @__PURE__ */ g(oE, { items: c.slice(1, -1) }, "breadcrumb-overflow"), Mm(u[0], "breadcrumb-overflow-trailing-separator"), c.at(-1)] : t;
  return /* @__PURE__ */ F(Vt, { children: [
    /* @__PURE__ */ g("ol", { ...n, ref: p, "data-slot": "breadcrumb-list", "data-collapsed": s && f ? "" : void 0, className: "flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-8) overflow-hidden p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: m }),
    f && /* @__PURE__ */ g("ol", { ref: r, "aria-hidden": "true", inert: !0, "data-slot": "breadcrumb-list-measurement", className: "pointer-events-none invisible absolute flex w-max flex-nowrap items-center gap-(--spacing-8) p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: d })
  ] });
}
function JR(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-item", className: "inline-flex min-w-0 items-center", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function eE(t) {
  const e = B.c(10);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Ra, n = "a", o = l;
    let c;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ["text-breadcrumb-text-inactive", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "no-underline", "block", "min-w-0", "max-w-full", "truncate", "whitespace-nowrap", "cursor-pointer", "transition-[color,text-decoration-color]", "hover:underline", "hover:[text-decoration-skip-ink:none]", "active:text-breadcrumb-text-inactive-pressed", "active:underline", "active:[text-decoration-skip-ink:none]", "active:[text-decoration-style:solid]", "outline-none", "focus-visible:[outline:var(--spacing-2)_solid_var(--color-breadcrumb-focus-ring)]", "focus-visible:outline-offset-[3px]", "rounded-(--radius-sm)"], e[5] = c) : c = e[5], r = Jt(a, {
      className: c.join(" ")
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = s) : s = e[9], i(s);
}
function VD(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("span", { "data-slot": "breadcrumb-page", "aria-current": "page", className: "block min-w-0 max-w-full truncate text-breadcrumb-text-active font-family-body font-semibold", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function cb(t) {
  return Jl(t) && t.type === JR;
}
function tE(t) {
  return Jl(t) && t.type === db;
}
function ub(t) {
  return Jl(t) && t.type === eE;
}
function Mm(t, e) {
  return t ? Yc(t, {
    key: e
  }) : /* @__PURE__ */ g(db, {}, e);
}
function nE(t) {
  return Ql.map(t, (e) => !cb(e) || !ub(e.props.children) ? e : Yc(e, {
    children: Yc(e.props.children, {
      tabIndex: -1
    })
  }));
}
function oE(t) {
  const e = B.c(10), {
    items: n
  } = t, [o, r] = qe(!1), i = n.length, s = `Show ${i} hidden breadcrumb ${i === 1 ? "level" : "levels"}`;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(gt, { "aria-label": s, icon: "ellipsis-dots-horiz", size: "sm", variant: "ghost" }) }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  e[2] !== n ? (a = n.map(rE), e[2] = n, e[3] = a) : a = e[3];
  let c;
  e[4] !== a ? (c = /* @__PURE__ */ g(Pr, { align: "start", size: "sm", children: a }), e[4] = a, e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-overflow", className: "inline-flex shrink-0", children: /* @__PURE__ */ F(Dd, { modal: !1, open: o, onOpenChange: r, children: [
    l,
    c
  ] }) }), e[6] = o, e[7] = l, e[8] = c, e[9] = u) : u = e[9], u;
}
function rE(t, e) {
  return /* @__PURE__ */ g(iE, { item: t }, t.key ?? e);
}
function iE(t) {
  const e = B.c(4), {
    item: n
  } = t, o = n.props.children;
  if (ub(o)) {
    let i;
    return e[0] !== o ? (i = /* @__PURE__ */ g(pr, { render: o, children: o.props.children }), e[0] = o, e[1] = i) : i = e[1], i;
  }
  let r;
  return e[2] !== o ? (r = /* @__PURE__ */ g(pr, { disabled: !0, children: o }), e[2] = o, e[3] = r) : r = e[3], r;
}
function db(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-separator", "aria-hidden": "true", className: "text-breadcrumb-separator font-family-label font-medium shrink-0 select-none", ...t, children: "/" }), e[0] = t, e[1] = n) : n = e[1], n;
}
function AD(t) {
  const e = B.c(16), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    actions: i,
    summary: s,
    children: l,
    footer: a
  } = t;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ g("h3", { className: "flex min-w-0 m-0", children: /* @__PURE__ */ g(ab, { children: n }) }), e[0] = n, e[1] = c) : c = e[1];
  let u;
  e[2] !== i || e[3] !== o || e[4] !== s || e[5] !== c || e[6] !== r ? (u = /* @__PURE__ */ g(WR, { main: c, start: o, titleAccessory: r, actions: i, summary: s }), e[2] = i, e[3] = o, e[4] = s, e[5] = c, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== l ? (d = /* @__PURE__ */ g(sb, { padding: "none", className: "min-h-(--spacing-80)", children: l }), e[8] = l, e[9] = d) : d = e[9];
  let f;
  e[10] !== a ? (f = a && /* @__PURE__ */ g(lb, { "data-card-container-slot": "footer", children: a }), e[10] = a, e[11] = f) : f = e[11];
  let p;
  return e[12] !== u || e[13] !== d || e[14] !== f ? (p = /* @__PURE__ */ g(ib, { elevated: !0, padding: "standard", children: /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-12) w-full", children: [
    u,
    d,
    f
  ] }) }), e[12] = u, e[13] = d, e[14] = f, e[15] = p) : p = e[15], p;
}
const sE = 2, lE = 32, aE = 3;
function cE(t) {
  return !x.isValidElement(t) || t.type !== Wl ? t : x.cloneElement(t, {
    selected: t.props.selected ?? !1
  });
}
function fb(t) {
  return t.clientWidth || t.getBoundingClientRect().width;
}
function uE(t) {
  return Math.max(t.scrollWidth, t.getBoundingClientRect().width);
}
function dE(t) {
  const e = lE * sE;
  return Math.max(0, t - e);
}
function fE(t, e) {
  const n = fb(t), o = Array.from(e.children).filter((i) => i instanceof HTMLElement);
  if (n <= 0 || o.length === 0) return o.length;
  let r = 0;
  for (const i of o) {
    const s = i.offsetWidth || i.getBoundingClientRect().width;
    if (s <= 0) return o.length;
    if (i.offsetLeft + s > n) break;
    r += 1;
  }
  return Math.max(1, r);
}
function LD({
  children: t,
  ...e
}) {
  const n = x.useRef(null), o = x.useRef(null), r = x.useRef(null), i = x.useRef(() => {
  }), [s, l] = x.useState(!1), [a, c] = x.useState(0), [u, d] = x.useState(Number.POSITIVE_INFINITY), f = x.Children.toArray(t), p = f.length, m = p > 0 ? a % p : 0, h = f.map((y, w) => ({
    child: cE(y),
    key: w
  })), b = s ? [...h.slice(m), ...h.slice(0, m)] : h;
  i.current = () => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R) return;
    const S = fb(y), E = uE(R), N = dE(S), M = E > S, T = p >= aE && E > N, P = p > 1 && S > 0 && (M || T);
    l(P), d(P ? fE(w, R) : p), P || c(0);
  }, x.useLayoutEffect(() => {
    i.current();
  }), x.useLayoutEffect(() => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R || typeof ResizeObserver > "u")
      return;
    const S = new ResizeObserver(() => {
      i.current();
    });
    return S.observe(y), S.observe(w), S.observe(R), () => S.disconnect();
  }, []);
  const v = () => {
    p !== 0 && c((y) => (y + 1) % p);
  };
  return /* @__PURE__ */ F("div", { ...e, ref: n, "data-slot": "carousel", className: s ? "flex w-full items-center" : "flex w-full items-center gap-(--spacing-10)", children: [
    s && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "chevron-left", "aria-label": "Previous Images", onClick: () => {
      p !== 0 && c((y) => (y - 1 + p) % p);
    } }),
    /* @__PURE__ */ g("div", { ref: o, "data-slot": "carousel-viewport", className: s ? "min-w-0 flex-1 overflow-hidden" : "min-w-0 max-w-full overflow-hidden", children: /* @__PURE__ */ g("div", { ref: r, "data-slot": "carousel-track", className: "relative flex w-max items-center gap-(--spacing-10) p-(--spacing-4)", children: b.map(({
      child: y,
      key: w
    }, R) => {
      const S = s && R >= u;
      return /* @__PURE__ */ g("div", { "data-slot": "carousel-item", className: "shrink-0", inert: S ? !0 : void 0, "aria-hidden": S || void 0, children: y }, w);
    }) }) }),
    s && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "chevron-right", "aria-label": "Next Images", onClick: v })
  ] });
}
function FD(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(A5, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
async function pE(t, e) {
  if (navigator.clipboard?.write && typeof ClipboardItem < "u")
    try {
      await navigator.clipboard.write([new ClipboardItem({
        "text/html": new Blob([e], {
          type: "text/html"
        }),
        "text/plain": new Blob([t], {
          type: "text/plain"
        })
      })]);
      return;
    } catch {
    }
  if (!navigator.clipboard?.writeText)
    throw new Error("Clipboard API is unavailable.");
  await navigator.clipboard.writeText(t);
}
function $D({
  content: t,
  onCopy: e,
  onCopyError: n,
  copyLabel: o = "Copy message",
  copiedLabel: r = "Copied message",
  ...i
}) {
  const [s, l] = qe("default"), a = nt(null);
  Rt(() => () => {
    a.current !== null && clearTimeout(a.current);
  }, []);
  async function c() {
    try {
      if (t.html)
        await pE(t.text, t.html);
      else {
        if (!navigator.clipboard?.writeText)
          throw new Error("Clipboard API is unavailable.");
        await navigator.clipboard.writeText(t.text);
      }
    } catch (d) {
      l("error"), n?.(d);
      return;
    }
    l("copied"), a.current !== null && clearTimeout(a.current), a.current = setTimeout(() => l("default"), 3e3), e?.();
  }
  const u = s === "copied";
  return /* @__PURE__ */ g(gt, { "data-slot": "chat-copy-button", "data-copy-state": s, icon: u ? "check-mark" : "copy-regular", "aria-label": u ? r : o, variant: "ghost", size: "sm", onClick: c, ...i });
}
let Tm = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
function mE(t) {
  return x.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [Tm.checked]: ""
      } : {
        [Tm.unchecked]: ""
      };
    },
    ...to
  }), [t.indeterminate]);
}
const pb = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (pb.displayName = "CheckboxRootContext");
const gE = "data-parent", mb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i = !1,
    "aria-labelledby": s,
    disabled: l = !1,
    form: a,
    id: c,
    indeterminate: u = !1,
    inputRef: d,
    name: f,
    onCheckedChange: p,
    parent: m = !1,
    readOnly: h = !1,
    render: b,
    required: v = !1,
    uncheckedValue: C,
    value: y,
    nativeButton: w = !1,
    style: R,
    ...S
  } = e, {
    clearErrors: E
  } = Vo(), {
    disabled: N,
    name: M,
    setDirty: T,
    setFilled: P,
    setFocused: k,
    setTouched: I,
    state: D,
    validationMode: O,
    validityData: V,
    shouldValidateOnChange: _,
    validation: L
  } = on(), A = H2(), {
    labelId: $,
    controlId: Y,
    registerControlId: z,
    getDescriptionProps: H
  } = hn(), K = wx(), G = K?.parent, q = G && K.allValues, ee = N || A.disabled || K?.disabled || l, W = M ?? f, X = y ?? W, J = It(), re = It();
  let Q = Y;
  q ? Q = m ? re : `${G.id}-${X}` : c && (Q = c);
  let ie = {};
  q && (m ? ie = K.parent.getParentProps() : X && (ie = K.parent.getChildProps(X)));
  const ce = Ce(p), {
    checked: oe = o,
    indeterminate: se = u,
    onCheckedChange: fe,
    ...be
  } = ie, le = K?.value, me = K?.setValue, j = K?.defaultValue, te = x.useRef(null), U = Tt(() => /* @__PURE__ */ Symbol("checkbox-control")), Z = x.useRef(!1), {
    getButtonProps: ue,
    buttonRef: pe
  } = Wt({
    disabled: ee,
    native: w
  }), he = K?.validation ?? L, [Ie, ye] = pn({
    controlled: X && le && !m ? le.includes(X) : oe,
    default: X && j && !m ? j.includes(X) : i,
    name: "Checkbox",
    state: "checked"
  });
  Ne(() => {
    z !== xt && (Z.current = !0, z(U.current, Q));
  }, [Q, K, z, m, U]), x.useEffect(() => {
    const Ee = U.current;
    return () => {
      !Z.current || z === xt || (Z.current = !1, z(Ee, void 0));
    };
  }, [z, U]), gi(te, {
    enabled: !K,
    id: J,
    value: Ie
  });
  const xe = x.useRef(null), de = mn(d, xe, he.inputRef), we = nf(s, $, xe, !w, Q ?? void 0);
  Ne(() => {
    xe.current && (xe.current.indeterminate = se, Ie && P(!0));
  }, [Ie, se, P]), So(Ie, () => {
    K && !m || (E(W), P(Ie), T(Ie !== V.initialValue), _() ? he.commit(Ie) : he.commit(Ie, !0));
  });
  const Me = Jt(
    {
      checked: Ie,
      disabled: ee,
      form: a,
      // parent checkboxes unset `name` to be excluded from form submission
      name: m ? void 0 : W,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: w ? void 0 : Q ?? void 0,
      required: v,
      ref: de,
      style: W ? ni : er,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(Ee) {
        if (Ee.nativeEvent.defaultPrevented)
          return;
        if (h) {
          Ee.preventDefault();
          return;
        }
        const Ae = Ee.currentTarget.checked, Pe = _e(Mt, Ee.nativeEvent);
        if (fe?.(Ae, Pe), ce(Ae, Pe), !Pe.isCanceled && (ye(Ae), X && le && me && !m && !q)) {
          const Oe = Ae ? [...le, X] : le.filter(($e) => $e !== X);
          me(Oe, Pe);
        }
      },
      onFocus() {
        te.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: (K ? Ie && y : y) || ""
    } : St,
    H,
    K ? he.getValidationProps : he.getInputValidationProps
  ), Re = q ? !!oe : Ie, Ve = q && se || u;
  x.useEffect(() => {
    if (!G || !X)
      return;
    const Ee = G.disabledStatesRef.current;
    return Ee.set(X, ee), () => {
      Ee.delete(X);
    };
  }, [G, ee, X]);
  const je = x.useMemo(() => ({
    ...D,
    checked: Re,
    disabled: ee,
    readOnly: h,
    required: v,
    indeterminate: Ve
  }), [D, Re, ee, h, v, Ve]), Ze = mE(je), ze = Le("span", e, {
    state: je,
    ref: [pe, te, n, K?.registerControlRef],
    props: [{
      id: w ? Q ?? void 0 : J,
      role: "checkbox",
      "aria-checked": se ? "mixed" : Ie,
      "aria-readonly": h || void 0,
      "aria-required": v || void 0,
      "aria-labelledby": we,
      [gE]: m ? "" : void 0,
      onFocus() {
        k(!0);
      },
      onBlur() {
        const Ee = xe.current;
        Ee && (I(!0), k(!1), O === "onBlur" && he.commit(K ? le : Ee.checked));
      },
      onClick(Ee) {
        h || ee || (Ee.preventDefault(), xe.current?.dispatchEvent(new PointerEvent("click", {
          bubbles: !0,
          shiftKey: Ee.shiftKey,
          ctrlKey: Ee.ctrlKey,
          altKey: Ee.altKey,
          metaKey: Ee.metaKey
        })));
      }
    }, H, he.getValidationProps, S, be, ue],
    stateAttributesMapping: Ze
  });
  return /* @__PURE__ */ F(pb.Provider, {
    value: je,
    children: [ze, !Ie && !K && W && !m && C !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: a,
      name: W,
      value: C
    }), /* @__PURE__ */ g("input", {
      ...Me,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (mb.displayName = "CheckboxRoot");
const Zl = {
  sm: "rounded-[2px]",
  md: "rounded-(--radius-sm)"
}, Om = {
  sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
  // Snap md to whole pixels to avoid SVG crossfade shimmer from 19.2px subpixel rasterization.
  md: ["w-[20px]", "h-[20px]"]
}, hE = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "group/checkbox",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1px]",
  "focus-visible:ring-checkbox-focus-ring",
  "cursor-[inherit]",
  // touch target — before:inset per size to maintain WCAG 44×44px minimum
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", Zl.sm, "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", Zl.md, "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), bE = ae(["absolute", "left-1/2", "top-1/2", "z-10", "inline-flex", "-translate-x-1/2", "-translate-y-1/2", "items-center", "justify-center", "overflow-hidden", "transition-[background-color]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "group-data-[checked]/checkbox:bg-checkbox-filled-default-background", "group-data-[indeterminate]/checkbox:bg-checkbox-filled-default-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-data-[error]/checkbox:bg-error", "group-data-[disabled]/checkbox:bg-checkbox-filled-disabled-background"], {
  variants: {
    size: {
      sm: [Zl.sm, ...Om.sm],
      md: [Zl.md, ...Om.md]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), vE = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-outline-hover-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), yE = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-outline-pressed-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), xE = ae(["absolute", "inset-0", "h-full", "w-full", "text-checkbox-outline-default-border", "group-[:not([data-error]):not([data-disabled]):hover]/checkbox:text-checkbox-outline-hover-border", "group-[:not([data-error]):not([data-disabled]):active]/checkbox:text-checkbox-outline-pressed-border", "group-data-[error]/checkbox:text-error", "group-data-[disabled]/checkbox:text-checkbox-filled-disabled-background", "group-data-[checked]/checkbox:opacity-0", "group-data-[indeterminate]/checkbox:opacity-0", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), CE = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[checked]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), wE = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[indeterminate]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]);
function SE(t) {
  const e = B.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M13.7143 1.14286C14.3464 1.14286 14.8571 1.65357 14.8571 2.28571V13.7143C14.8571 14.3464 14.3464 14.8571 13.7143 14.8571H2.28571C1.65357 14.8571 1.14286 14.3464 1.14286 13.7143V2.28571C1.14286 1.65357 1.65357 1.14286 2.28571 1.14286H13.7143ZM2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function RE(t) {
  const e = B.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function EE(t) {
  const e = B.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M3 7V9H13V7H3Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
const Dm = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), NE = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), kE = ae([], {
  variants: {
    size: {
      sm: [],
      md: []
    },
    labelLeft: {
      true: [],
      false: []
    }
  },
  compoundVariants: [{
    labelLeft: !1,
    size: "sm",
    className: "pl-[calc(var(--icon-sm)+var(--spacing-8))]"
  }, {
    labelLeft: !1,
    size: "md",
    className: "pl-[calc(var(--icon-md)+var(--spacing-8))]"
  }],
  defaultVariants: {
    size: "sm",
    labelLeft: !1
  }
});
function IE(t) {
  const e = B.c(69);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    error: r,
    label: s,
    description: n,
    labelLeft: l,
    size: c,
    indeterminate: i,
    disabled: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = At();
  let d;
  e[9] !== n || e[10] !== u || e[11] !== a ? (d = [a["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[9] = n, e[10] = u, e[11] = a, e[12] = d) : d = e[12];
  const f = d, p = o ? "cursor-not-allowed" : "cursor-pointer";
  let m;
  e[13] !== p ? (m = ne("inline-flex flex-col gap-(--spacing-4)", p), e[13] = p, e[14] = m) : m = e[14];
  let h;
  e[15] !== o || e[16] !== u || e[17] !== s || e[18] !== l ? (h = l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(Dm(), o && "opacity-50"), children: s }), e[15] = o, e[16] = u, e[17] = s, e[18] = l, e[19] = h) : h = e[19];
  const b = s ? void 0 : a["aria-label"], v = s ? `${u}-label` : void 0, C = r || void 0, y = r ? "" : void 0;
  let w;
  e[20] !== c ? (w = ne(hE({
    size: c
  })), e[20] = c, e[21] = w) : w = e[21];
  let R;
  e[22] !== c ? (R = ne(vE({
    size: c
  })), e[22] = c, e[23] = R) : R = e[23];
  let S;
  e[24] !== R ? (S = /* @__PURE__ */ g("span", { className: R }), e[24] = R, e[25] = S) : S = e[25];
  let E;
  e[26] !== c ? (E = ne(yE({
    size: c
  })), e[26] = c, e[27] = E) : E = e[27];
  let N;
  e[28] !== E ? (N = /* @__PURE__ */ g("span", { className: E }), e[28] = E, e[29] = N) : N = e[29];
  let M;
  e[30] !== c ? (M = ne(bE({
    size: c
  })), e[30] = c, e[31] = M) : M = e[31];
  let T;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ g(SE, { className: ne(xE()) }), e[32] = T) : T = e[32];
  let P;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ g(RE, { className: ne(CE()) }), e[33] = P) : P = e[33];
  let k;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ g(EE, { className: ne(wE()) }), e[34] = k) : k = e[34];
  let I;
  e[35] !== M ? (I = /* @__PURE__ */ F("span", { className: M, children: [
    T,
    P,
    k
  ] }), e[35] = M, e[36] = I) : I = e[36];
  let D;
  e[37] !== f || e[38] !== o || e[39] !== i || e[40] !== a || e[41] !== S || e[42] !== N || e[43] !== I || e[44] !== b || e[45] !== v || e[46] !== C || e[47] !== y || e[48] !== w ? (D = /* @__PURE__ */ F(mb, { ...a, indeterminate: i, disabled: o, "aria-label": b, "aria-labelledby": v, "aria-describedby": f, "aria-invalid": C, "data-error": y, className: w, children: [
    S,
    N,
    I
  ] }), e[37] = f, e[38] = o, e[39] = i, e[40] = a, e[41] = S, e[42] = N, e[43] = I, e[44] = b, e[45] = v, e[46] = C, e[47] = y, e[48] = w, e[49] = D) : D = e[49];
  let O;
  e[50] !== o || e[51] !== u || e[52] !== s || e[53] !== l ? (O = !l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(Dm(), o && "opacity-50"), children: s }), e[50] = o, e[51] = u, e[52] = s, e[53] = l, e[54] = O) : O = e[54];
  let V;
  e[55] !== D || e[56] !== O || e[57] !== h ? (V = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    h,
    D,
    O
  ] }), e[55] = D, e[56] = O, e[57] = h, e[58] = V) : V = e[58];
  let _;
  e[59] !== n || e[60] !== o || e[61] !== u || e[62] !== l || e[63] !== c ? (_ = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: ne(NE(), o && "opacity-50", kE({
    size: c,
    labelLeft: l
  })), children: n }), e[59] = n, e[60] = o, e[61] = u, e[62] = l, e[63] = c, e[64] = _) : _ = e[64];
  let L;
  return e[65] !== V || e[66] !== _ || e[67] !== m ? (L = /* @__PURE__ */ F("label", { className: m, children: [
    V,
    _
  ] }), e[65] = V, e[66] = _, e[67] = m, e[68] = L) : L = e[68], L;
}
function PE(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const ME = {}, Fi = {};
function dr(t, e) {
  try {
    const o = (ME[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return o in Fi ? Fi[o] : _m(o, o.split(":"));
  } catch {
    if (t in Fi) return Fi[t];
    const n = t?.match(TE);
    return n ? _m(t, n.slice(1)) : NaN;
  }
}
const TE = /([+-]\d\d):?(\d\d)?/;
function _m(t, e) {
  const n = +(e[0] || 0), o = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return Fi[t] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class lo extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(dr(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), gb(this), vu(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new lo(...n, e) : new lo(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new lo(+this, e);
  }
  getTimezoneOffset() {
    const e = -dr(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), vu(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new lo(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Vm = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Vm.test(t)) return;
  const e = t.replace(Vm, "$1UTC");
  lo.prototype[e] && (t.startsWith("get") ? lo.prototype[t] = function() {
    return this.internal[e]();
  } : (lo.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), OE(this), +this;
  }, lo.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), vu(this), +this;
  }));
});
function vu(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-dr(t.timeZone, t) * 60));
}
function OE(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), gb(t);
}
function gb(t) {
  const e = dr(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), o = /* @__PURE__ */ new Date(+t);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), s = r - i, l = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  s && l && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + s);
  const a = r - n;
  a && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + a);
  const c = /* @__PURE__ */ new Date(+t);
  c.setUTCSeconds(0);
  const u = r > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(dr(t.timeZone, t) * 60)) % 60;
  (d || u) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + d + u));
  const f = dr(t.timeZone, t), p = f > 0 ? Math.floor(f) : Math.ceil(f), h = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - p, b = p !== n, v = h - a;
  if (b && v) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v);
    const C = dr(t.timeZone, t), y = C > 0 ? Math.floor(C) : Math.ceil(C), w = p - y;
    w && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + w), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + w));
  }
}
class an extends lo {
  //#region static
  static tz(e, ...n) {
    return n.length ? new an(...n, e) : new an(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${PE(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new an(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new an(+new Date(e), this.timeZone);
  }
  //#endregion
}
const hb = 6048e5, DE = 864e5, Am = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Yt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Am in t ? t[Am](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Pt(t, e) {
  return Yt(e || t, t);
}
function bb(t, e, n) {
  const o = Pt(t, n?.in);
  return isNaN(e) ? Yt(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function vb(t, e, n) {
  const o = Pt(t, n?.in);
  if (isNaN(e)) return Yt(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), i = Yt(t, o.getTime());
  i.setMonth(o.getMonth() + e + 1, 0);
  const s = i.getDate();
  return r >= s ? i : (o.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), o);
}
let _E = {};
function Vs() {
  return _E;
}
function Jr(t, e) {
  const n = Vs(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Pt(t, e?.in), i = r.getDay(), s = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function ns(t, e) {
  return Jr(t, { ...e, weekStartsOn: 1 });
}
function yb(t, e) {
  const n = Pt(t, e?.in), o = n.getFullYear(), r = Yt(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = ns(r), s = Yt(n, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const l = ns(s);
  return n.getTime() >= i.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function Lm(t) {
  const e = Pt(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function xi(t, ...e) {
  const n = Yt.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function os(t, e) {
  const n = Pt(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function e1(t, e, n) {
  const [o, r] = xi(
    n?.in,
    t,
    e
  ), i = os(o), s = os(r), l = +i - Lm(i), a = +s - Lm(s);
  return Math.round((l - a) / DE);
}
function VE(t, e) {
  const n = yb(t, e), o = Yt(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), ns(o);
}
function AE(t, e, n) {
  return bb(t, e * 7, n);
}
function LE(t, e, n) {
  return vb(t, e * 12, n);
}
function FE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Yt.bind(null, r));
    const i = Pt(r, o);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Yt(o, n || NaN);
}
function $E(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Yt.bind(null, r));
    const i = Pt(r, o);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Yt(o, n || NaN);
}
function HE(t, e, n) {
  const [o, r] = xi(
    n?.in,
    t,
    e
  );
  return +os(o) == +os(r);
}
function xb(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function zE(t) {
  return !(!xb(t) && typeof t != "number" || isNaN(+Pt(t)));
}
function Cb(t, e, n) {
  const [o, r] = xi(
    n?.in,
    t,
    e
  ), i = o.getFullYear() - r.getFullYear(), s = o.getMonth() - r.getMonth();
  return i * 12 + s;
}
function BE(t, e) {
  const n = Pt(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function wb(t, e) {
  const [n, o] = xi(t, e.start, e.end);
  return { start: n, end: o };
}
function WE(t, e) {
  const { start: n, end: o } = wb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Yt(n, s)), s.setMonth(s.getMonth() + l);
  return r ? a.reverse() : a;
}
function UE(t, e) {
  const n = Pt(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function GE(t, e) {
  const n = Pt(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Sb(t, e) {
  const n = Pt(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function YE(t, e) {
  const { start: n, end: o } = wb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Yt(n, s)), s.setFullYear(s.getFullYear() + l);
  return r ? a.reverse() : a;
}
function Rb(t, e) {
  const n = Vs(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Pt(t, e?.in), i = r.getDay(), s = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function jE(t, e) {
  return Rb(t, { ...e, weekStartsOn: 1 });
}
const KE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qE = (t, e, n) => {
  let o;
  const r = KE[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function wc(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const ZE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, XE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, QE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JE = {
  date: wc({
    formats: ZE,
    defaultWidth: "full"
  }),
  time: wc({
    formats: XE,
    defaultWidth: "full"
  }),
  dateTime: wc({
    formats: QE,
    defaultWidth: "full"
  })
}, eN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tN = (t, e, n, o) => eN[t];
function Pi(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, l = n?.width ? String(n.width) : s;
      r = t.formattingValues[l] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, l = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[l] || t.values[s];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const nN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, oN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, rN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, iN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, sN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, aN = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, cN = {
  ordinalNumber: aN,
  era: Pi({
    values: nN,
    defaultWidth: "wide"
  }),
  quarter: Pi({
    values: oN,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Pi({
    values: rN,
    defaultWidth: "wide"
  }),
  day: Pi({
    values: iN,
    defaultWidth: "wide"
  }),
  dayPeriod: Pi({
    values: sN,
    defaultWidth: "wide",
    formattingValues: lN,
    defaultFormattingWidth: "wide"
  })
};
function Mi(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const s = i[0], l = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], a = Array.isArray(l) ? dN(l, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      uN(l, (d) => d.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(a) : a, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function uN(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function dN(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function fN(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const l = e.slice(r.length);
    return { value: s, rest: l };
  };
}
const pN = /^(\d+)(th|st|nd|rd)?/i, mN = /\d+/i, gN = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, hN = {
  any: [/^b/i, /^(a|c)/i]
}, bN = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vN = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yN = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xN = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, CN = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, wN = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, SN = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, RN = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, EN = {
  ordinalNumber: fN({
    matchPattern: pN,
    parsePattern: mN,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Mi({
    matchPatterns: gN,
    defaultMatchWidth: "wide",
    parsePatterns: hN,
    defaultParseWidth: "any"
  }),
  quarter: Mi({
    matchPatterns: bN,
    defaultMatchWidth: "wide",
    parsePatterns: vN,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Mi({
    matchPatterns: yN,
    defaultMatchWidth: "wide",
    parsePatterns: xN,
    defaultParseWidth: "any"
  }),
  day: Mi({
    matchPatterns: CN,
    defaultMatchWidth: "wide",
    parsePatterns: wN,
    defaultParseWidth: "any"
  }),
  dayPeriod: Mi({
    matchPatterns: SN,
    defaultMatchWidth: "any",
    parsePatterns: RN,
    defaultParseWidth: "any"
  })
}, Ar = {
  code: "en-US",
  formatDistance: qE,
  formatLong: JE,
  formatRelative: tN,
  localize: cN,
  match: EN,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function NN(t, e) {
  const n = Pt(t, e?.in);
  return e1(n, Sb(n)) + 1;
}
function t1(t, e) {
  const n = Pt(t, e?.in), o = +ns(n) - +VE(n);
  return Math.round(o / hb) + 1;
}
function Eb(t, e) {
  const n = Pt(t, e?.in), o = n.getFullYear(), r = Vs(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = Yt(e?.in || t, 0);
  s.setFullYear(o + 1, 0, i), s.setHours(0, 0, 0, 0);
  const l = Jr(s, e), a = Yt(e?.in || t, 0);
  a.setFullYear(o, 0, i), a.setHours(0, 0, 0, 0);
  const c = Jr(a, e);
  return +n >= +l ? o + 1 : +n >= +c ? o : o - 1;
}
function kN(t, e) {
  const n = Vs(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = Eb(t, e), i = Yt(e?.in || t, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), Jr(i, e);
}
function n1(t, e) {
  const n = Pt(t, e?.in), o = +Jr(n, e) - +kN(n, e);
  return Math.round(o / hb) + 1;
}
function Et(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const $o = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return Et(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Et(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Et(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Et(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Et(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Et(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Et(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return Et(r, e.length);
  }
}, _r = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Fm = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return $o.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = Eb(t, o), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const s = i % 100;
      return Et(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Et(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = yb(t);
    return Et(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Et(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return Et(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return Et(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return $o.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return Et(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = n1(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : Et(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = t1(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : Et(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : $o.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = NN(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : Et(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Et(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Et(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return Et(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = _r.noon : o === 0 ? r = _r.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = _r.evening : o >= 12 ? r = _r.afternoon : o >= 4 ? r = _r.morning : r = _r.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return $o.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : $o.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : Et(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : Et(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : $o.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : $o.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return $o.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Hm(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ar(o);
      // Hours and minutes with `:` delimiter
      default:
        return ar(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Hm(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ar(o);
      // Hours and minutes with `:` delimiter
      default:
        return ar(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + $m(o, ":");
      default:
        return "GMT" + ar(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + $m(o, ":");
      default:
        return "GMT" + ar(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return Et(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Et(+t, e.length);
  }
};
function $m(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + Et(i, 2);
}
function Hm(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Et(Math.abs(t) / 60, 2) : ar(t, e);
}
function ar(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Et(Math.trunc(o / 60), 2), i = Et(o % 60, 2);
  return n + r + e + i;
}
const zm = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, Nb = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, IN = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return zm(t, e);
  let i;
  switch (o) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", zm(o, e)).replace("{{time}}", Nb(r, e));
}, PN = {
  p: Nb,
  P: IN
}, MN = /^D+$/, TN = /^Y+$/, ON = ["D", "DD", "YY", "YYYY"];
function DN(t) {
  return MN.test(t);
}
function _N(t) {
  return TN.test(t);
}
function VN(t, e, n) {
  const o = AN(t, e, n);
  if (console.warn(o), ON.includes(t)) throw new RangeError(o);
}
function AN(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const LN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, FN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $N = /^'([^]*?)'?$/, HN = /''/g, zN = /[a-zA-Z]/;
function $i(t, e, n) {
  const o = Vs(), r = n?.locale ?? o.locale ?? Ar, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, l = Pt(t, n?.in);
  if (!zE(l))
    throw new RangeError("Invalid time value");
  let a = e.match(FN).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = PN[d];
      return f(u, r.formatLong);
    }
    return u;
  }).join("").match(LN).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: BN(u) };
    if (Fm[d])
      return { isToken: !0, value: u };
    if (d.match(zN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (a = r.localize.preprocessor(l, a));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: r
  };
  return a.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && _N(d) || !n?.useAdditionalDayOfYearTokens && DN(d)) && VN(d, e, String(t));
    const f = Fm[d[0]];
    return f(l, d, r.localize, c);
  }).join("");
}
function BN(t) {
  const e = t.match($N);
  return e ? e[1].replace(HN, "'") : t;
}
function WN(t, e) {
  const n = Pt(t, e?.in), o = n.getFullYear(), r = n.getMonth(), i = Yt(n, 0);
  return i.setFullYear(o, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function UN(t, e) {
  return Pt(t, e?.in).getMonth();
}
function GN(t, e) {
  return Pt(t, e?.in).getFullYear();
}
function YN(t, e) {
  return +Pt(t) > +Pt(e);
}
function jN(t, e) {
  return +Pt(t) < +Pt(e);
}
function KN(t, e, n) {
  const [o, r] = xi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function qN(t, e, n) {
  const [o, r] = xi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function ZN(t, e, n) {
  const o = Pt(t, n?.in), r = o.getFullYear(), i = o.getDate(), s = Yt(t, 0);
  s.setFullYear(r, e, 15), s.setHours(0, 0, 0, 0);
  const l = WN(s);
  return o.setMonth(e, Math.min(i, l)), o;
}
function XN(t, e, n) {
  const o = Pt(t, n?.in);
  return isNaN(+o) ? Yt(t, NaN) : (o.setFullYear(e), o);
}
const Bm = 5, QN = 4;
function JN(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), i = e.addDays(r, Bm * 7 - 1);
  return e.getMonth(t) === e.getMonth(i) ? Bm : QN;
}
function kb(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -6) : e.addDays(n, -1 * (o - 1));
}
function ek(t, e) {
  const n = kb(t, e), o = JN(t, e);
  return e.addDays(n, o * 7 - 1);
}
const Ib = {
  ...Ar,
  labels: {
    labelDayButton: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => $i(s, l, { locale: Ar, ...n });
      let i = r(t, "PPPP");
      return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (t) => `Week ${t}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => $i(r, i, { locale: Ar, ...e }), o(t, "LLLL yyyy");
    },
    labelGridcell: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => $i(s, l, { locale: Ar, ...n });
      let i = r(t, "PPPP");
      return e?.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => $i(r, i, { locale: Ar, ...e }), o(t, "cccc");
    }
  }
};
class Nn {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? an.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, i) => this.overrides?.newDate ? this.overrides.newDate(o, r, i) : this.options.timeZone ? new an(o, r, i, this.options.timeZone) : new Date(o, r, i), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : bb(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : vb(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : AE(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : LE(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : e1(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : Cb(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : WE(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : YE(o), i = new Set(r.map((l) => this.getYear(l)));
      if (i.size === r.length)
        return r;
      const s = [];
      return i.forEach((l) => {
        s.push(new Date(l, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : ek(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : jE(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : BE(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Rb(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : GE(o), this.format = (o, r, i) => {
      const s = this.overrides?.format ? this.overrides.format(o, r, this.options) : $i(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : t1(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : UN(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : GN(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : n1(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : YN(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : jN(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : xb(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : HE(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : KN(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : qN(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : FE(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : $E(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : ZN(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : XN(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : kb(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : os(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : ns(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : UE(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : Jr(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : Sb(o), this.options = { locale: Ib, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && Nn.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: n, timeZone: o, numerals: r } = this.options, i = n?.code;
    if (i && Nn.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(e);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, s);
  }
}
Nn.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const yo = new Nn();
class Pb {
  constructor(e, n, o = yo) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o, this.isoDate = o.format(e, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class tk {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class nk {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function ok(t) {
  return Be.createElement("button", { ...t });
}
function rk(t) {
  return Be.createElement("span", { ...t });
}
function ik(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    Be.createElement(
      "svg",
      { className: o, width: e, height: e, viewBox: "0 0 24 24" },
      n === "up" && Be.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && Be.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && Be.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && Be.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function sk(t) {
  const { day: e, modifiers: n, ...o } = t;
  return Be.createElement("td", { ...o });
}
function lk(t) {
  const { day: e, modifiers: n, ...o } = t, r = Be.useRef(null);
  return Be.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), Be.createElement("button", { ref: r, ...o });
}
var Je;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(Je || (Je = {}));
var Dt;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(Dt || (Dt = {}));
var Yn;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Yn || (Yn = {}));
var Rn;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(Rn || (Rn = {}));
function ak(t) {
  const { options: e, className: n, components: o, classNames: r, ...i } = t, s = [r[Je.Dropdown], n].join(" "), l = e?.find(({ value: a }) => a === i.value);
  return Be.createElement(
    "span",
    { "data-disabled": i.disabled, className: r[Je.DropdownRoot] },
    Be.createElement(o.Select, { className: s, ...i }, e?.map(({ value: a, label: c, disabled: u }) => Be.createElement(o.Option, { key: a, value: a, disabled: u }, c))),
    Be.createElement(
      "span",
      { className: r[Je.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      Be.createElement(o.Chevron, { orientation: "down", size: 18, className: r[Je.Chevron] })
    )
  );
}
function ck(t) {
  return Be.createElement("div", { ...t });
}
function uk(t) {
  return Be.createElement("div", { ...t });
}
function dk(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Be.createElement("div", { ...o }, t.children);
}
function fk(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Be.createElement("div", { ...o });
}
function pk(t) {
  return Be.createElement("table", { ...t });
}
function mk(t) {
  return Be.createElement("div", { ...t });
}
const Mb = ho(void 0);
function Ci() {
  const t = xg(Mb);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function gk(t) {
  const { components: e } = Ci();
  return Be.createElement(e.Dropdown, { ...t });
}
function hk(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...i } = t, { components: s, classNames: l, labels: { labelPrevious: a, labelNext: c } } = Ci(), u = Tn((f) => {
    r && n?.(f);
  }, [r, n]), d = Tn((f) => {
    o && e?.(f);
  }, [o, e]);
  return Be.createElement(
    "nav",
    { ...i },
    Be.createElement(
      s.PreviousMonthButton,
      { type: "button", className: l[Je.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": a(o), onClick: d },
      Be.createElement(s.Chevron, { disabled: o ? void 0 : !0, className: l[Je.Chevron], orientation: "left" })
    ),
    Be.createElement(
      s.NextMonthButton,
      { type: "button", className: l[Je.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      Be.createElement(s.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: l[Je.Chevron] })
    )
  );
}
function bk(t) {
  const { components: e } = Ci();
  return Be.createElement(e.Button, { ...t });
}
function vk(t) {
  return Be.createElement("option", { ...t });
}
function yk(t) {
  const { components: e } = Ci();
  return Be.createElement(e.Button, { ...t });
}
function xk(t) {
  const { rootRef: e, ...n } = t;
  return Be.createElement("div", { ...n, ref: e });
}
function Ck(t) {
  return Be.createElement("select", { ...t });
}
function wk(t) {
  const { week: e, ...n } = t;
  return Be.createElement("tr", { ...n });
}
function Sk(t) {
  return Be.createElement("th", { ...t });
}
function Rk(t) {
  return Be.createElement(
    "thead",
    { "aria-hidden": !0 },
    Be.createElement("tr", { ...t })
  );
}
function Ek(t) {
  const { week: e, ...n } = t;
  return Be.createElement("th", { ...n });
}
function Nk(t) {
  return Be.createElement("th", { ...t });
}
function kk(t) {
  return Be.createElement("tbody", { ...t });
}
function Ik(t) {
  const { components: e } = Ci();
  return Be.createElement(e.Dropdown, { ...t });
}
const Pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: ok,
  CaptionLabel: rk,
  Chevron: ik,
  Day: sk,
  DayButton: lk,
  Dropdown: ak,
  DropdownNav: ck,
  Footer: uk,
  Month: dk,
  MonthCaption: fk,
  MonthGrid: pk,
  Months: mk,
  MonthsDropdown: gk,
  Nav: hk,
  NextMonthButton: bk,
  Option: vk,
  PreviousMonthButton: yk,
  Root: xk,
  Select: Ck,
  Week: wk,
  WeekNumber: Ek,
  WeekNumberHeader: Nk,
  Weekday: Sk,
  Weekdays: Rk,
  Weeks: kk,
  YearsDropdown: Ik
}, Symbol.toStringTag, { value: "Module" }));
function Eo(t, e, n = !1, o = yo) {
  let { from: r, to: i } = t;
  const { differenceInCalendarDays: s, isSameDay: l } = o;
  return r && i ? (s(i, r) < 0 && ([r, i] = [i, r]), s(e, r) >= (n ? 1 : 0) && s(i, e) >= (n ? 1 : 0)) : !n && i ? l(i, e) : !n && r ? l(r, e) : !1;
}
function o1(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function Oa(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function r1(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function i1(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Tb(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Ob(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function No(t, e, n = yo) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: i, isAfter: s } = n;
  return o.some((l) => {
    if (typeof l == "boolean")
      return l;
    if (n.isDate(l))
      return r(t, l);
    if (Ob(l, n))
      return l.some((a) => r(t, a));
    if (Oa(l))
      return Eo(l, t, !1, n);
    if (Tb(l))
      return Array.isArray(l.dayOfWeek) ? l.dayOfWeek.includes(t.getDay()) : l.dayOfWeek === t.getDay();
    if (o1(l)) {
      const a = i(l.before, t), c = i(l.after, t), u = a > 0, d = c < 0;
      return s(l.before, l.after) ? d && u : u || d;
    }
    return r1(l) ? i(t, l.after) > 0 : i1(l) ? i(l.before, t) > 0 : typeof l == "function" ? l(t) : !1;
  });
}
function Mk(t, e, n, o, r) {
  const { disabled: i, hidden: s, modifiers: l, showOutsideDays: a, broadcastCalendar: c, today: u = r.today() } = e, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: m, endOfMonth: h, isAfter: b } = r, v = n && p(n), C = o && h(o), y = {
    [Dt.focused]: [],
    [Dt.outside]: [],
    [Dt.disabled]: [],
    [Dt.hidden]: [],
    [Dt.today]: []
  }, w = {};
  for (const R of t) {
    const { date: S, displayMonth: E } = R, N = !!(E && !f(S, E)), M = !!(v && m(S, v)), T = !!(C && b(S, C)), P = !!(i && No(S, i, r)), k = !!(s && No(S, s, r)) || M || T || // Broadcast calendar will show outside days as default
    !c && !a && N || c && a === !1 && N, I = d(S, u);
    N && y.outside.push(R), P && y.disabled.push(R), k && y.hidden.push(R), I && y.today.push(R), l && Object.keys(l).forEach((D) => {
      const O = l?.[D];
      O && No(S, O, r) && (w[D] ? w[D].push(R) : w[D] = [R]);
    });
  }
  return (R) => {
    const S = {
      [Dt.focused]: !1,
      [Dt.disabled]: !1,
      [Dt.hidden]: !1,
      [Dt.outside]: !1,
      [Dt.today]: !1
    }, E = {};
    for (const N in y) {
      const M = y[N];
      S[N] = M.some((T) => T === R);
    }
    for (const N in w)
      E[N] = w[N].some((M) => M === R);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function Tk(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [i]) => (n[i] ? r.push(n[i]) : e[Dt[i]] ? r.push(e[Dt[i]]) : e[Yn[i]] && r.push(e[Yn[i]]), r), [e[Je.Day]]);
}
function Ok(t) {
  return {
    ...Pk,
    ...t
  };
}
function Dk(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function _k() {
  const t = {};
  for (const e in Je)
    t[Je[e]] = `rdp-${Je[e]}`;
  for (const e in Dt)
    t[Dt[e]] = `rdp-${Dt[e]}`;
  for (const e in Yn)
    t[Yn[e]] = `rdp-${Yn[e]}`;
  for (const e in Rn)
    t[Rn[e]] = `rdp-${Rn[e]}`;
  return t;
}
function Db(t, e, n) {
  return (n ?? new Nn(e)).formatMonthYear(t);
}
const Vk = Db;
function Ak(t, e, n) {
  return (n ?? new Nn(e)).format(t, "d");
}
function Lk(t, e = yo) {
  return e.format(t, "LLLL");
}
function Fk(t, e, n) {
  return (n ?? new Nn(e)).format(t, "cccccc");
}
function $k(t, e = yo) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function Hk() {
  return "";
}
function _b(t, e = yo) {
  return e.format(t, "yyyy");
}
const zk = _b, Bk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Db,
  formatDay: Ak,
  formatMonthCaption: Vk,
  formatMonthDropdown: Lk,
  formatWeekNumber: $k,
  formatWeekNumberHeader: Hk,
  formatWeekdayName: Fk,
  formatYearCaption: zk,
  formatYearDropdown: _b
}, Symbol.toStringTag, { value: "Module" }));
function Wk(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...Bk,
    ...t
  };
}
function s1(t, e, n, o) {
  let r = (o ?? new Nn(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const Uk = s1;
function l1(t, e, n) {
  return (n ?? new Nn(e)).formatMonthYear(t);
}
const Gk = l1;
function Vb(t, e, n, o) {
  let r = (o ?? new Nn(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function Ab(t) {
  return "Choose the Month";
}
function Lb() {
  return "";
}
const Yk = "Go to the Next Month";
function Fb(t, e) {
  return Yk;
}
function $b(t) {
  return "Go to the Previous Month";
}
function Hb(t, e, n) {
  return (n ?? new Nn(e)).format(t, "cccc");
}
function zb(t, e) {
  return `Week ${t}`;
}
function Bb(t) {
  return "Week Number";
}
function Wb(t) {
  return "Choose the Year";
}
const jk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Gk,
  labelDay: Uk,
  labelDayButton: s1,
  labelGrid: l1,
  labelGridcell: Vb,
  labelMonthDropdown: Ab,
  labelNav: Lb,
  labelNext: Fb,
  labelPrevious: $b,
  labelWeekNumber: zb,
  labelWeekNumberHeader: Bb,
  labelWeekday: Hb,
  labelYearDropdown: Wb
}, Symbol.toStringTag, { value: "Module" })), Wn = (t, e, n) => e || (n ? typeof n == "function" ? n : (...o) => n : t);
function Kk(t, e) {
  const n = e.locale?.labels ?? {};
  return {
    ...jk,
    ...t ?? {},
    labelDayButton: Wn(s1, t?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Wn(Ab, t?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Wn(Fb, t?.labelNext, n.labelNext),
    labelPrevious: Wn($b, t?.labelPrevious, n.labelPrevious),
    labelWeekNumber: Wn(zb, t?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Wn(Wb, t?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Wn(l1, t?.labelGrid, n.labelGrid),
    labelGridcell: Wn(Vb, t?.labelGridcell, n.labelGridcell),
    labelNav: Wn(Lb, t?.labelNav, n.labelNav),
    labelWeekNumberHeader: Wn(Bb, t?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Wn(Hb, t?.labelWeekday, n.labelWeekday)
  };
}
function qk(t, e, n, o, r) {
  const { startOfMonth: i, startOfYear: s, endOfYear: l, eachMonthOfInterval: a, getMonth: c } = r;
  return a({
    start: s(t),
    end: l(t)
  }).map((f) => {
    const p = o.formatMonthDropdown(f, r), m = c(f), h = e && f < i(e) || n && f > i(n) || !1;
    return { value: m, label: p, disabled: h };
  });
}
function Zk(t, e = {}, n = {}) {
  let o = { ...e?.[Je.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function Xk(t, e, n, o) {
  const r = o ?? t.today(), i = n ? t.startOfBroadcastWeek(r, t) : e ? t.startOfISOWeek(r) : t.startOfWeek(r), s = [];
  for (let l = 0; l < 7; l++) {
    const a = t.addDays(i, l);
    s.push(a);
  }
  return s;
}
function Qk(t, e, n, o, r = !1) {
  if (!t || !e)
    return;
  const { startOfYear: i, endOfYear: s, eachYearOfInterval: l, getYear: a } = o, c = i(t), u = s(e), d = l({ start: c, end: u });
  return r && d.reverse(), d.map((f) => {
    const p = n.formatYearDropdown(f, o);
    return {
      value: a(f),
      label: p,
      disabled: !1
    };
  });
}
function Jk(t, e = {}) {
  const { weekStartsOn: n, locale: o } = e, r = n ?? o?.options?.weekStartsOn ?? 0, i = (l) => {
    const a = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new an(a.getFullYear(), a.getMonth(), a.getDate(), 12, 0, 0, t);
  }, s = (l) => {
    const a = i(l);
    return new Date(a.getFullYear(), a.getMonth(), a.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(an.tz(t)),
    newDate: (l, a, c) => new an(l, a, c, 12, 0, 0, t),
    startOfDay: (l) => i(l),
    startOfWeek: (l, a) => {
      const c = i(l), u = a?.weekStartsOn ?? r, d = (c.getDay() - u + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfISOWeek: (l) => {
      const a = i(l), c = (a.getDay() - 1 + 7) % 7;
      return a.setDate(a.getDate() - c), a;
    },
    startOfMonth: (l) => {
      const a = i(l);
      return a.setDate(1), a;
    },
    startOfYear: (l) => {
      const a = i(l);
      return a.setMonth(0, 1), a;
    },
    endOfWeek: (l, a) => {
      const c = i(l), f = (((a?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + f), c;
    },
    endOfISOWeek: (l) => {
      const a = i(l), c = (7 - a.getDay()) % 7;
      return a.setDate(a.getDate() + c), a;
    },
    endOfMonth: (l) => {
      const a = i(l);
      return a.setMonth(a.getMonth() + 1, 0), a;
    },
    endOfYear: (l) => {
      const a = i(l);
      return a.setMonth(11, 31), a;
    },
    eachMonthOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new an(a.getFullYear(), a.getMonth(), 1, 12, 0, 0, t), f = c.getFullYear() * 12 + c.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= f; )
        u.push(new an(d, t)), d.setMonth(d.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a), c;
    },
    addWeeks: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a * 7), c;
    },
    addMonths: (l, a) => {
      const c = i(l);
      return c.setMonth(c.getMonth() + a), c;
    },
    addYears: (l, a) => {
      const c = i(l);
      return c.setFullYear(c.getFullYear() + a), c;
    },
    eachYearOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new an(a.getFullYear(), 0, 1, 12, 0, 0, t);
      for (; d.getFullYear() <= c.getFullYear(); )
        u.push(new an(d, t)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (l, a) => {
      const c = s(l);
      return n1(c, {
        weekStartsOn: a?.weekStartsOn ?? r,
        firstWeekContainsDate: a?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (l) => {
      const a = s(l);
      return t1(a);
    },
    differenceInCalendarDays: (l, a) => {
      const c = s(l), u = s(a);
      return e1(c, u);
    },
    differenceInCalendarMonths: (l, a) => {
      const c = s(l), u = s(a);
      return Cb(c, u);
    }
  };
}
const As = (t) => t instanceof HTMLElement ? t : null, Sc = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], eI = (t) => As(t.querySelector("[data-animated-month]")), Rc = (t) => As(t.querySelector("[data-animated-caption]")), Ec = (t) => As(t.querySelector("[data-animated-weeks]")), tI = (t) => As(t.querySelector("[data-animated-nav]")), nI = (t) => As(t.querySelector("[data-animated-weekdays]"));
function oI(t, e, { classNames: n, months: o, focused: r, dateLib: i }) {
  const s = nt(null), l = nt(o), a = nt(!1);
  po(() => {
    const c = l.current;
    if (l.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const u = i.isSameMonth(o[0].date, c[0].date), d = i.isAfter(o[0].date, c[0].date), f = d ? n[Rn.caption_after_enter] : n[Rn.caption_before_enter], p = d ? n[Rn.weeks_after_enter] : n[Rn.weeks_before_enter], m = s.current, h = t.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (Sc(h).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const w = eI(y);
      w && y.contains(w) && y.removeChild(w);
      const R = Rc(y);
      R && R.classList.remove(f);
      const S = Ec(y);
      S && S.classList.remove(p);
    }), s.current = h) : s.current = null, a.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const b = m instanceof HTMLElement ? Sc(m) : [], v = Sc(t.current);
    if (v?.every((C) => C instanceof HTMLElement) && b && b.every((C) => C instanceof HTMLElement)) {
      a.current = !0, t.current.style.isolation = "isolate";
      const C = tI(t.current);
      C && (C.style.zIndex = "1"), v.forEach((y, w) => {
        const R = b[w];
        if (!R)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const S = Rc(y);
        S && S.classList.add(f);
        const E = Ec(y);
        E && E.classList.add(p);
        const N = () => {
          a.current = !1, t.current && (t.current.style.isolation = ""), C && (C.style.zIndex = ""), S && S.classList.remove(f), E && E.classList.remove(p), y.style.position = "", y.style.overflow = "", y.contains(R) && y.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const M = nI(R);
        M && (M.style.opacity = "0");
        const T = Rc(R);
        T && (T.classList.add(d ? n[Rn.caption_before_exit] : n[Rn.caption_after_exit]), T.addEventListener("animationend", N));
        const P = Ec(R);
        P && P.classList.add(d ? n[Rn.weeks_before_exit] : n[Rn.weeks_after_exit]), y.insertBefore(R, y.firstChild);
      });
    }
  });
}
function rI(t, e, n, o) {
  const r = t[0], i = t[t.length - 1], { ISOWeek: s, fixedWeeks: l, broadcastCalendar: a } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: m, endOfWeek: h, isAfter: b, startOfBroadcastWeek: v, startOfISOWeek: C, startOfWeek: y } = o, w = a ? v(r, o) : s ? C(r) : y(r), R = a ? f(i) : s ? p(m(i)) : h(m(i)), S = e && (a ? f(e) : s ? p(e) : h(e)), E = S && b(R, S) ? S : R, N = u(E, w), M = d(i, r) + 1, T = [];
  for (let I = 0; I <= N; I++) {
    const D = c(w, I);
    T.push(D);
  }
  const k = (a ? 35 : 42) * M;
  if (l && T.length < k) {
    const I = k - T.length;
    for (let D = 0; D < I; D++) {
      const O = c(T[T.length - 1], 1);
      T.push(O);
    }
  }
  return T;
}
function iI(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((i, s) => i.concat(s.days.slice()), e.slice());
    return n.concat(r.slice());
  }, e.slice());
}
function sI(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, i = [];
  for (let s = 0; s < r; s++) {
    const l = o.addMonths(t, s);
    if (e && l > e)
      break;
    i.push(l);
  }
  return i;
}
function Wm(t, e, n, o) {
  const { month: r, defaultMonth: i, today: s = o.today(), numberOfMonths: l = 1 } = t;
  let a = r || i || s;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = o;
  if (n && c(n, a) < l - 1) {
    const f = -1 * (l - 1);
    a = u(n, f);
  }
  return e && c(a, e) < 0 && (a = e), d(a);
}
function lI(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: i, endOfISOWeek: s, endOfMonth: l, endOfWeek: a, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = o, m = t.reduce((h, b) => {
    const v = n.broadcastCalendar ? d(b, o) : n.ISOWeek ? f(b) : p(b), C = n.broadcastCalendar ? i(b) : n.ISOWeek ? s(l(b)) : a(l(b)), y = e.filter((E) => E >= v && E <= C), w = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < w) {
      const E = e.filter((N) => {
        const M = w - y.length;
        return N > C && N <= r(C, M);
      });
      y.push(...E);
    }
    const R = y.reduce((E, N) => {
      const M = n.ISOWeek ? c(N) : u(N), T = E.find((k) => k.weekNumber === M), P = new Pb(N, b, o);
      return T ? T.days.push(P) : E.push(new nk(M, [P])), E;
    }, []), S = new tk(b, R);
    return h.push(S), h;
  }, []);
  return n.reverseMonths ? m.reverse() : m;
}
function aI(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: i, startOfMonth: s, endOfMonth: l, addYears: a, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: p, fromMonth: m, toMonth: h } = t;
  !n && m && (n = m), !n && f && (n = e.newDate(f, 0, 1)), !o && h && (o = h), !o && p && (o = u(p, 11, 31));
  const b = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = s(n) : f ? n = u(f, 0, 1) : !n && b && (n = r(a(t.today ?? d(), -100))), o ? o = l(o) : p ? o = u(p, 11, 31) : !o && b && (o = c(t.today ?? d())), [
    n && i(n),
    o && i(o)
  ];
}
function cI(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i = 1 } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i : 1, u = s(t);
  if (!e)
    return l(u, c);
  if (!(a(e, t) < i))
    return l(u, c);
}
function uI(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i ?? 1 : 1, u = s(t);
  if (!e)
    return l(u, -c);
  if (!(a(u, e) <= 0))
    return l(u, -c);
}
function dI(t) {
  const e = [];
  return t.reduce((n, o) => n.concat(o.weeks.slice()), e.slice());
}
function Da(t, e) {
  const [n, o] = qe(t);
  return [e === void 0 ? n : e, o];
}
function fI(t, e) {
  const [n, o] = aI(t, e), { startOfMonth: r, endOfMonth: i } = e, s = Wm(t, n, o, e), [l, a] = Da(
    s,
    // initialMonth is always computed from props.month if provided
    t.month ? s : void 0
  );
  Rt(() => {
    const w = Wm(t, n, o, e);
    a(w);
  }, [t.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: p } = vl(() => {
    const w = sI(l, o, { numberOfMonths: t.numberOfMonths }, e), R = rI(w, t.endMonth ? i(t.endMonth) : void 0, {
      ISOWeek: t.ISOWeek,
      fixedWeeks: t.fixedWeeks,
      broadcastCalendar: t.broadcastCalendar
    }, e), S = lI(w, R, {
      broadcastCalendar: t.broadcastCalendar,
      fixedWeeks: t.fixedWeeks,
      ISOWeek: t.ISOWeek,
      reverseMonths: t.reverseMonths
    }, e), E = dI(S), N = iI(S), M = uI(l, n, t, e), T = cI(l, o, t, e);
    return {
      months: S,
      weeks: E,
      days: N,
      previousMonth: M,
      nextMonth: T
    };
  }, [
    e,
    l.getTime(),
    o?.getTime(),
    n?.getTime(),
    t.disableNavigation,
    t.broadcastCalendar,
    t.endMonth?.getTime(),
    t.fixedWeeks,
    t.ISOWeek,
    t.numberOfMonths,
    t.pagedNavigation,
    t.reverseMonths
  ]), { disableNavigation: m, onMonthChange: h } = t, b = (w) => u.some((R) => R.days.some((S) => S.isEqualTo(w))), v = (w) => {
    if (m)
      return;
    let R = r(w);
    n && R < r(n) && (R = r(n)), o && R > r(o) && (R = r(o)), a(R), h?.(R);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: o,
    previousMonth: f,
    nextMonth: p,
    goToMonth: v,
    goToDay: (w) => {
      b(w) || v(w.date);
    }
  };
}
var so;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(so || (so = {}));
function Um(t) {
  return !t[Dt.disabled] && !t[Dt.hidden] && !t[Dt.outside];
}
function pI(t, e, n, o) {
  let r, i = -1;
  for (const s of t) {
    const l = e(s);
    Um(l) && (l[Dt.focused] && i < so.FocusedModifier ? (r = s, i = so.FocusedModifier) : o?.isEqualTo(s) && i < so.LastFocused ? (r = s, i = so.LastFocused) : n(s.date) && i < so.Selected ? (r = s, i = so.Selected) : l[Dt.today] && i < so.Today && (r = s, i = so.Today));
  }
  return r || (r = t.find((s) => Um(e(s)))), r;
}
function mI(t, e, n, o, r, i, s) {
  const { ISOWeek: l, broadcastCalendar: a } = i, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: m, endOfWeek: h, max: b, min: v, startOfBroadcastWeek: C, startOfISOWeek: y, startOfWeek: w } = s;
  let S = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (E) => a ? C(E, s) : l ? y(E) : w(E),
    endOfWeek: (E) => a ? p(E) : l ? m(E) : h(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? S = b([o, S]) : e === "after" && r && (S = v([r, S])), S;
}
function Ub(t, e, n, o, r, i, s, l = 0) {
  if (l > 365)
    return;
  const a = mI(t, e, n.date, o, r, i, s), c = !!(i.disabled && No(a, i.disabled, s)), u = !!(i.hidden && No(a, i.hidden, s)), d = a, f = new Pb(a, d, s);
  return !c && !u ? f : Ub(t, e, f, o, r, i, s, l + 1);
}
function gI(t, e, n, o, r) {
  const { autoFocus: i } = t, [s, l] = qe(), a = pI(e.days, n, o || (() => !1), s), [c, u] = qe(i ? a : void 0);
  return {
    isFocusTarget: (h) => !!a?.isEqualTo(h),
    setFocused: u,
    focused: c,
    blur: () => {
      l(c), u(void 0);
    },
    moveFocus: (h, b) => {
      if (!c)
        return;
      const v = Ub(h, b, c, e.navStart, e.navEnd, t, r);
      v && (t.disableNavigation && !e.days.some((y) => y.isEqualTo(v)) || (e.goToDay(v), u(v)));
    }
  };
}
function hI(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Da(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e, c = (p) => l?.some((m) => a(m, p)) ?? !1, { min: u, max: d } = t;
  return {
    selected: l,
    select: (p, m, h) => {
      let b = [...l ?? []];
      if (c(p)) {
        if (l?.length === u || o && l?.length === 1)
          return;
        b = l?.filter((v) => !a(v, p));
      } else
        l?.length === d ? b = [p] : b = [...b, p];
      return r || s(b), r?.(b, p, m, h), b;
    },
    isSelected: c
  };
}
function bI(t, e, n = 0, o = 0, r = !1, i = yo) {
  const { from: s, to: l } = e || {}, { isSameDay: a, isAfter: c, isBefore: u } = i;
  let d;
  if (!s && !l)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (s && !l)
    a(s, t) ? n === 0 ? d = { from: s, to: t } : r ? d = { from: s, to: void 0 } : d = void 0 : u(t, s) ? d = { from: t, to: s } : d = { from: s, to: t };
  else if (s && l)
    if (a(s, t) && a(l, t))
      r ? d = { from: s, to: l } : d = void 0;
    else if (a(s, t))
      d = { from: s, to: n > 0 ? void 0 : t };
    else if (a(l, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, s))
      d = { from: t, to: l };
    else if (c(t, s))
      d = { from: s, to: t };
    else if (c(t, l))
      d = { from: s, to: t };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = i.differenceInCalendarDays(d.to, d.from);
    o > 0 && f > o ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function vI(t, e, n = yo) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const i = n.differenceInCalendarDays(t.to, t.from), s = Math.min(i, 6);
  for (let l = 0; l <= s; l++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Gm(t, e, n = yo) {
  return Eo(t, e.from, !1, n) || Eo(t, e.to, !1, n) || Eo(e, t.from, !1, n) || Eo(e, t.to, !1, n);
}
function yI(t, e, n = yo) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((l) => typeof l != "function").some((l) => typeof l == "boolean" ? l : n.isDate(l) ? Eo(t, l, !1, n) : Ob(l, n) ? l.some((a) => Eo(t, a, !1, n)) : Oa(l) ? l.from && l.to ? Gm(t, { from: l.from, to: l.to }, n) : !1 : Tb(l) ? vI(t, l.dayOfWeek, n) : o1(l) ? n.isAfter(l.before, l.after) ? Gm(t, {
    from: n.addDays(l.after, 1),
    to: n.addDays(l.before, -1)
  }, n) : No(t.from, l, n) || No(t.to, l, n) : r1(l) || i1(l) ? No(t.from, l, n) || No(t.to, l, n) : !1))
    return !0;
  const s = o.filter((l) => typeof l == "function");
  if (s.length) {
    let l = t.from;
    const a = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= a; c++) {
      if (s.some((u) => u(l)))
        return !0;
      l = n.addDays(l, 1);
    }
  }
  return !1;
}
function xI(t, e) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: i, required: s, onSelect: l } = t, [a, c] = Da(i, l ? i : void 0), u = l ? i : a;
  return {
    selected: u,
    select: (p, m, h) => {
      const { min: b, max: v } = t;
      let C;
      if (p) {
        const y = u?.from, w = u?.to, R = !!y && !!w, S = !!y && !!w && e.isSameDay(y, w) && e.isSameDay(p, y);
        r && (R || !u?.from) ? !s && S ? C = void 0 : C = { from: p, to: void 0 } : C = bI(p, u, b, v, s, e);
      }
      return o && n && C?.from && C.to && yI({ from: C.from, to: C.to }, n, e) && (C.from = p, C.to = void 0), l || c(C), l?.(C, p, m, h), C;
    },
    isSelected: (p) => u && Eo(u, p, !1, e)
  };
}
function CI(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Da(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e;
  return {
    selected: l,
    select: (d, f, p) => {
      let m = d;
      return !o && l && l && a(d, l) && (m = void 0), r || s(m), r?.(m, d, f, p), m;
    },
    isSelected: (d) => l ? a(l, d) : !1
  };
}
function wI(t, e) {
  const n = CI(t, e), o = hI(t, e), r = xI(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function On(t, e) {
  return t instanceof an && t.timeZone === e ? t : new an(t, e);
}
function Vr(t, e, n) {
  return On(t, e);
}
function Ym(t, e, n) {
  return typeof t == "boolean" || typeof t == "function" ? t : t instanceof Date ? Vr(t, e) : Array.isArray(t) ? t.map((o) => o instanceof Date ? Vr(o, e) : o) : Oa(t) ? {
    ...t,
    from: t.from ? On(t.from, e) : t.from,
    to: t.to ? On(t.to, e) : t.to
  } : o1(t) ? {
    before: Vr(t.before, e),
    after: Vr(t.after, e)
  } : r1(t) ? {
    after: Vr(t.after, e)
  } : i1(t) ? {
    before: Vr(t.before, e)
  } : t;
}
function Nc(t, e, n) {
  return t && (Array.isArray(t) ? t.map((o) => Ym(o, e)) : Ym(t, e));
}
function SI(t) {
  let e = t;
  const n = e.timeZone;
  if (n && (e = {
    ...t,
    timeZone: n
  }, e.today && (e.today = On(e.today, n)), e.month && (e.month = On(e.month, n)), e.defaultMonth && (e.defaultMonth = On(e.defaultMonth, n)), e.startMonth && (e.startMonth = On(e.startMonth, n)), e.endMonth && (e.endMonth = On(e.endMonth, n)), e.mode === "single" && e.selected ? e.selected = On(e.selected, n) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((Ee) => On(Ee, n)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? On(e.selected.from, n) : e.selected.from,
    to: e.selected.to ? On(e.selected.to, n) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Nc(e.disabled, n)), e.hidden !== void 0 && (e.hidden = Nc(e.hidden, n)), e.modifiers)) {
    const Ee = {};
    Object.keys(e.modifiers).forEach((Ae) => {
      Ee[Ae] = Nc(e.modifiers?.[Ae], n);
    }), e.modifiers = Ee;
  }
  const { components: o, formatters: r, labels: i, dateLib: s, locale: l, classNames: a } = vl(() => {
    const Ee = { ...Ib, ...e.locale }, Ae = e.broadcastCalendar ? 1 : e.weekStartsOn, Pe = e.noonSafe && e.timeZone ? Jk(e.timeZone, {
      weekStartsOn: Ae,
      locale: Ee
    }) : void 0, Oe = e.dateLib && Pe ? { ...Pe, ...e.dateLib } : e.dateLib ?? Pe, $e = new Nn({
      locale: Ee,
      weekStartsOn: Ae,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, Oe);
    return {
      dateLib: $e,
      components: Ok(e.components),
      formatters: Wk(e.formatters),
      labels: Kk(e.labels, $e.options),
      locale: Ee,
      classNames: { ..._k(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: s.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: p, onDayClick: m, onDayFocus: h, onDayKeyDown: b, onDayMouseEnter: v, onDayMouseLeave: C, onNextClick: y, onPrevClick: w, showWeekNumber: R, styles: S } = e, { formatCaption: E, formatDay: N, formatMonthDropdown: M, formatWeekNumber: T, formatWeekNumberHeader: P, formatWeekdayName: k, formatYearDropdown: I } = r, D = fI(e, s), { days: O, months: V, navStart: _, navEnd: L, previousMonth: A, nextMonth: $, goToMonth: Y } = D, z = Mk(O, e, _, L, s), { isSelected: H, select: K, selected: G } = wI(e, s) ?? {}, { blur: q, focused: ee, isFocusTarget: W, moveFocus: X, setFocused: J } = gI(e, D, z, H ?? (() => !1), s), { labelDayButton: re, labelGridcell: Q, labelGrid: ie, labelMonthDropdown: ce, labelNav: oe, labelPrevious: se, labelNext: fe, labelWeekday: be, labelWeekNumber: le, labelWeekNumberHeader: me, labelYearDropdown: j } = i, te = vl(() => Xk(s, e.ISOWeek, e.broadcastCalendar, e.today), [s, e.ISOWeek, e.broadcastCalendar, e.today]), U = u !== void 0 || m !== void 0, Z = Tn(() => {
    A && (Y(A), w?.(A));
  }, [A, Y, w]), ue = Tn(() => {
    $ && (Y($), y?.($));
  }, [Y, $, y]), pe = Tn((Ee, Ae) => (Pe) => {
    Pe.preventDefault(), Pe.stopPropagation(), J(Ee), !Ae.disabled && (K?.(Ee.date, Ae, Pe), m?.(Ee.date, Ae, Pe));
  }, [K, m, J]), he = Tn((Ee, Ae) => (Pe) => {
    J(Ee), h?.(Ee.date, Ae, Pe);
  }, [h, J]), Ie = Tn((Ee, Ae) => (Pe) => {
    q(), p?.(Ee.date, Ae, Pe);
  }, [q, p]), ye = Tn((Ee, Ae) => (Pe) => {
    const Oe = {
      ArrowLeft: [
        Pe.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Pe.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Pe.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Pe.shiftKey ? "year" : "week", "before"],
      PageUp: [Pe.shiftKey ? "year" : "month", "before"],
      PageDown: [Pe.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Oe[Pe.key]) {
      Pe.preventDefault(), Pe.stopPropagation();
      const [$e, Te] = Oe[Pe.key];
      X($e, Te);
    }
    b?.(Ee.date, Ae, Pe);
  }, [X, b, e.dir]), xe = Tn((Ee, Ae) => (Pe) => {
    v?.(Ee.date, Ae, Pe);
  }, [v]), de = Tn((Ee, Ae) => (Pe) => {
    C?.(Ee.date, Ae, Pe);
  }, [C]), we = Tn((Ee) => (Ae) => {
    const Pe = Number(Ae.target.value), Oe = s.setMonth(s.startOfMonth(Ee), Pe);
    Y(Oe);
  }, [s, Y]), Me = Tn((Ee) => (Ae) => {
    const Pe = Number(Ae.target.value), Oe = s.setYear(s.startOfMonth(Ee), Pe);
    Y(Oe);
  }, [s, Y]), { className: Re, style: Ve } = vl(() => ({
    className: [a[Je.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[Je.Root], ...e.style }
  }), [a, e.className, e.style, S]), je = Dk(e), Ze = nt(null);
  oI(Ze, !!e.animate, {
    classNames: a,
    months: V,
    focused: ee,
    dateLib: s
  });
  const ze = {
    dayPickerProps: e,
    selected: G,
    select: K,
    isSelected: H,
    months: V,
    nextMonth: $,
    previousMonth: A,
    goToMonth: Y,
    getModifiers: z,
    components: o,
    classNames: a,
    styles: S,
    labels: i,
    formatters: r
  };
  return Be.createElement(
    Mb.Provider,
    { value: ze },
    Be.createElement(
      o.Root,
      { rootRef: e.animate ? Ze : void 0, className: Re, style: Ve, dir: e.dir, id: e.id, lang: e.lang ?? l.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...je },
      Be.createElement(
        o.Months,
        { className: a[Je.Months], style: S?.[Je.Months] },
        !e.hideNavigation && !d && Be.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Je.Nav], style: S?.[Je.Nav], "aria-label": oe(), onPreviousClick: Z, onNextClick: ue, previousMonth: A, nextMonth: $ }),
        V.map((Ee, Ae) => Be.createElement(
          o.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: a[Je.Month],
            style: S?.[Je.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Ae,
            displayIndex: Ae,
            calendarMonth: Ee
          },
          d === "around" && !e.hideNavigation && Ae === 0 && Be.createElement(
            o.PreviousMonthButton,
            { type: "button", className: a[Je.PreviousMonthButton], tabIndex: A ? void 0 : -1, "aria-disabled": A ? void 0 : !0, "aria-label": se(A), onClick: Z, "data-animated-button": e.animate ? "true" : void 0 },
            Be.createElement(o.Chevron, { disabled: A ? void 0 : !0, className: a[Je.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          Be.createElement(o.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: a[Je.MonthCaption], style: S?.[Je.MonthCaption], calendarMonth: Ee, displayIndex: Ae }, c?.startsWith("dropdown") ? Be.createElement(
            o.DropdownNav,
            { className: a[Je.Dropdowns], style: S?.[Je.Dropdowns] },
            (() => {
              const Pe = c === "dropdown" || c === "dropdown-months" ? Be.createElement(o.MonthsDropdown, { key: "month", className: a[Je.MonthsDropdown], "aria-label": ce(), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: we(Ee.date), options: qk(Ee.date, _, L, r, s), style: S?.[Je.Dropdown], value: s.getMonth(Ee.date) }) : Be.createElement("span", { key: "month" }, M(Ee.date, s)), Oe = c === "dropdown" || c === "dropdown-years" ? Be.createElement(o.YearsDropdown, { key: "year", className: a[Je.YearsDropdown], "aria-label": j(s.options), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Me(Ee.date), options: Qk(_, L, r, s, !!e.reverseYears), style: S?.[Je.Dropdown], value: s.getYear(Ee.date) }) : Be.createElement("span", { key: "year" }, I(Ee.date, s));
              return s.getMonthYearOrder() === "year-first" ? [Oe, Pe] : [Pe, Oe];
            })(),
            Be.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, E(Ee.date, s.options, s))
          ) : Be.createElement(o.CaptionLabel, { className: a[Je.CaptionLabel], role: "status", "aria-live": "polite" }, E(Ee.date, s.options, s))),
          d === "around" && !e.hideNavigation && Ae === f - 1 && Be.createElement(
            o.NextMonthButton,
            { type: "button", className: a[Je.NextMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": fe($), onClick: ue, "data-animated-button": e.animate ? "true" : void 0 },
            Be.createElement(o.Chevron, { disabled: $ ? void 0 : !0, className: a[Je.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          Ae === f - 1 && d === "after" && !e.hideNavigation && Be.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Je.Nav], style: S?.[Je.Nav], "aria-label": oe(), onPreviousClick: Z, onNextClick: ue, previousMonth: A, nextMonth: $ }),
          Be.createElement(
            o.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": ie(Ee.date, s.options, s) || void 0, className: a[Je.MonthGrid], style: S?.[Je.MonthGrid] },
            !e.hideWeekdays && Be.createElement(
              o.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: a[Je.Weekdays], style: S?.[Je.Weekdays] },
              R && Be.createElement(o.WeekNumberHeader, { "aria-label": me(s.options), className: a[Je.WeekNumberHeader], style: S?.[Je.WeekNumberHeader], scope: "col" }, P()),
              te.map((Pe) => Be.createElement(o.Weekday, { "aria-label": be(Pe, s.options, s), className: a[Je.Weekday], key: String(Pe), style: S?.[Je.Weekday], scope: "col" }, k(Pe, s.options, s)))
            ),
            Be.createElement(o.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: a[Je.Weeks], style: S?.[Je.Weeks] }, Ee.weeks.map((Pe) => Be.createElement(
              o.Week,
              { className: a[Je.Week], key: Pe.weekNumber, style: S?.[Je.Week], week: Pe },
              R && Be.createElement(o.WeekNumber, { week: Pe, style: S?.[Je.WeekNumber], "aria-label": le(Pe.weekNumber, {
                locale: l
              }), className: a[Je.WeekNumber], scope: "row", role: "rowheader" }, T(Pe.weekNumber, s)),
              Pe.days.map((Oe) => {
                const { date: $e } = Oe, Te = z(Oe);
                if (Te[Dt.focused] = !Te.hidden && !!ee?.isEqualTo(Oe), Te[Yn.selected] = H?.($e) || Te.selected, Oa(G)) {
                  const { from: ke, to: Fe } = G;
                  Te[Yn.range_start] = !!(ke && Fe && s.isSameDay($e, ke)), Te[Yn.range_end] = !!(ke && Fe && s.isSameDay($e, Fe)), Te[Yn.range_middle] = Eo(G, $e, !0, s);
                }
                const vt = Zk(Te, S, e.modifiersStyles), st = Tk(Te, a, e.modifiersClassNames), Se = !U && !Te.hidden ? Q($e, Te, s.options, s) : void 0;
                return Be.createElement(o.Day, { key: `${Oe.isoDate}_${Oe.displayMonthId}`, day: Oe, modifiers: Te, className: st.join(" "), style: vt, role: "gridcell", "aria-selected": Te.selected || void 0, "aria-label": Se, "data-day": Oe.isoDate, "data-month": Oe.outside ? Oe.dateMonthId : void 0, "data-selected": Te.selected || void 0, "data-disabled": Te.disabled || void 0, "data-hidden": Te.hidden || void 0, "data-outside": Oe.outside || void 0, "data-focused": Te.focused || void 0, "data-today": Te.today || void 0 }, !Te.hidden && U ? Be.createElement(o.DayButton, { className: a[Je.DayButton], style: S?.[Je.DayButton], type: "button", day: Oe, modifiers: Te, disabled: !Te.focused && Te.disabled || void 0, "aria-disabled": Te.focused && Te.disabled || void 0, tabIndex: W(Oe) ? 0 : -1, "aria-label": re($e, Te, s.options, s), onClick: pe(Oe, Te), onBlur: Ie(Oe, Te), onFocus: he(Oe, Te), onKeyDown: ye(Oe, Te), onMouseEnter: xe(Oe, Te), onMouseLeave: de(Oe, Te) }, N($e, s.options, s)) : !Te.hidden && N(Oe.date, s.options, s));
              })
            )))
          )
        ))
      ),
      e.footer && Be.createElement(o.Footer, { className: a[Je.Footer], style: S?.[Je.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function RI(t) {
  const e = B.c(18), {
    children: n,
    positionerClassName: o,
    popupClassName: r,
    listClassName: i
  } = t, s = Kt();
  let l;
  e[0] !== o ? (l = ne("z-[var(--z-layer-popover)]", o), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = ui({
    size: "auto",
    className: r
  }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== i ? (c = ne("flex flex-col", i), e[4] = i, e[5] = c) : c = e[5];
  let u;
  e[6] !== n || e[7] !== c ? (u = /* @__PURE__ */ g(Tf, { className: c, children: n }), e[6] = n, e[7] = c, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== u ? (d = /* @__PURE__ */ g(Mf, { className: a, children: u }), e[9] = a, e[10] = u, e[11] = d) : d = e[11];
  let f;
  e[12] !== l || e[13] !== d ? (f = /* @__PURE__ */ g(Pf, { sideOffset: 4, alignItemWithTrigger: !1, className: l, children: d }), e[12] = l, e[13] = d, e[14] = f) : f = e[14];
  let p;
  return e[15] !== s || e[16] !== f ? (p = /* @__PURE__ */ g(kf, { container: s, children: f }), e[15] = s, e[16] = f, e[17] = p) : p = e[17], p;
}
function EI(t) {
  const e = B.c(11), {
    value: n,
    disabled: o,
    icon: r,
    children: i
  } = t;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = Oo({}), e[0] = s) : s = e[0];
  let l;
  e[1] !== r ? (l = r && /* @__PURE__ */ g("span", { className: "shrink-0 text-menu-icon-default inline-flex", children: /* @__PURE__ */ g(We, { name: r, size: "xs", tone: "inherit" }) }), e[1] = r, e[2] = l) : l = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ g(Vf, { className: "flex-1 min-w-0", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let c;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(z0, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(We, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== a || e[9] !== n ? (u = /* @__PURE__ */ F(_f, { value: n, disabled: o, className: s, children: [
    l,
    a,
    c
  ] }), e[6] = o, e[7] = l, e[8] = a, e[9] = n, e[10] = u) : u = e[10], u;
}
function NI(t) {
  const e = B.c(2), {
    size: n
  } = t, o = n === void 0 ? "xs" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "transition-transform duration-200 [[data-popup-open]_&]:rotate-180 inline-flex", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
function kI(t) {
  const e = B.c(26), {
    value: n,
    onChange: o,
    options: r,
    disabled: i,
    "aria-label": s
  } = t;
  let l;
  e[0] !== r || e[1] !== n ? (l = r?.find((R) => R.value === Number(n)), e[0] = r, e[1] = n, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== o ? (c = function(S) {
    S !== null && o?.({
      target: {
        value: String(S)
      },
      currentTarget: {
        value: String(S)
      }
    });
  }, e[3] = o, e[4] = c) : c = e[4];
  const u = c, d = a?.value ?? null;
  let f;
  e[5] !== r ? (f = r ?? [], e[5] = r, e[6] = f) : f = e[6];
  let p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne("flex items-center gap-(--spacing-2)", "cursor-pointer rounded-(--radius-xs) outline-none", "focus-visible:ring-2 focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"), e[7] = p) : p = e[7];
  const m = a?.label ?? "";
  let h;
  e[8] !== m ? (h = /* @__PURE__ */ g(V0, { className: "text-(length:--font-size-title-md) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default select-none", children: m }), e[8] = m, e[9] = h) : h = e[9];
  let b;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(A0, { className: "text-icon-main", children: /* @__PURE__ */ g(NI, { size: "sm" }) }), e[10] = b) : b = e[10];
  let v;
  e[11] !== s || e[12] !== i || e[13] !== h ? (v = /* @__PURE__ */ F(Nf, { disabled: i, "aria-label": s, className: p, children: [
    h,
    b
  ] }), e[11] = s, e[12] = i, e[13] = h, e[14] = v) : v = e[14];
  let C;
  e[15] !== r ? (C = r?.map(II), e[15] = r, e[16] = C) : C = e[16];
  let y;
  e[17] !== C ? (y = /* @__PURE__ */ g(RI, { listClassName: "max-h-[368px] overflow-y-auto", children: C }), e[17] = C, e[18] = y) : y = e[18];
  let w;
  return e[19] !== i || e[20] !== u || e[21] !== y || e[22] !== d || e[23] !== f || e[24] !== v ? (w = /* @__PURE__ */ F(_0, { value: d, onValueChange: u, disabled: i, items: f, children: [
    v,
    y
  ] }), e[19] = i, e[20] = u, e[21] = y, e[22] = d, e[23] = f, e[24] = v, e[25] = w) : w = e[25], w;
}
function II(t) {
  return /* @__PURE__ */ g(EI, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function PI(t) {
  const e = B.c(18), {
    children: n
  } = t, {
    goToMonth: o,
    nextMonth: r,
    previousMonth: i,
    dayPickerProps: s
  } = Ci(), l = s.disabled === !0, a = l || !i;
  let c;
  e[0] !== o || e[1] !== i ? (c = () => i && o(i), e[0] = o, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== a || e[4] !== c ? (u = /* @__PURE__ */ g(gt, { icon: "chevron-left", variant: "ghost", size: "md", "aria-label": "Previous month", disabled: a, onClick: c }), e[3] = a, e[4] = c, e[5] = u) : u = e[5];
  let d;
  e[6] !== n ? (d = /* @__PURE__ */ g("div", { className: "flex items-center gap-[26px]", children: n }), e[6] = n, e[7] = d) : d = e[7];
  const f = l || !r;
  let p;
  e[8] !== o || e[9] !== r ? (p = () => r && o(r), e[8] = o, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ g(gt, { icon: "chevron-right", variant: "ghost", size: "md", "aria-label": "Next month", disabled: f, onClick: p }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  let h;
  return e[14] !== u || e[15] !== d || e[16] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex items-center justify-between pt-(--spacing-8) px-(--spacing-12)", children: [
    u,
    d,
    m
  ] }), e[14] = u, e[15] = d, e[16] = m, e[17] = h) : h = e[17], h;
}
function MI(t) {
  const e = B.c(12), {
    value: n,
    onValueChange: o,
    disabled: r
  } = t, i = r === void 0 ? !1 : r, s = n ?? void 0, l = n ?? void 0;
  let a;
  e[0] !== o ? (a = (h) => o(h ?? null), e[0] = o, e[1] = a) : a = e[1];
  let c, u;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = new Date(2e3, 0), u = new Date(2099, 11), e[2] = c, e[3] = u) : (c = e[2], u = e[3]);
  let d, f, p;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    formatMonthDropdown: TI
  }, f = {
    root: "w-[328px] bg-surface rounded-(--radius-sm) shadow-elevation-3 flex flex-col gap-(--spacing-4)",
    months: "flex flex-col",
    month: "flex flex-col gap-(--spacing-4)",
    month_caption: "",
    nav: "hidden",
    dropdowns: "flex items-center gap-[26px]",
    dropdown_root: "",
    dropdown: "",
    caption_label: "",
    month_grid: "w-full border-collapse",
    weeks: "flex flex-col gap-(--spacing-8) px-(--spacing-2) pb-(--spacing-16)",
    week: "flex gap-[11px] items-center justify-center",
    weekdays: "flex gap-[11px] items-center justify-center px-(--spacing-2) pt-(--spacing-8) pb-(--spacing-12) border-t border-outline-subtle",
    weekday: "size-(--font-line-height-36) flex items-center justify-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) text-text-subtle",
    day: "size-(--font-line-height-36) flex items-center justify-center rounded-full text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default cursor-pointer transition-colors duration-200 ease-in-out [&:not([data-selected])]:hover:bg-surface-hover [&:not([data-selected])]:active:bg-surface-pressed",
    day_button: "size-full flex items-center justify-center outline-none rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring",
    selected: "bg-primary [&>button]:text-primary-on-primary",
    today: "font-(number:--font-weight-semibold)",
    outside: "text-text-subtle",
    disabled: "text-text-disabled pointer-events-none opacity-50",
    hidden: "invisible"
  }, p = {
    MonthCaption: PI,
    Dropdown: kI
  }, e[4] = d, e[5] = f, e[6] = p) : (d = e[4], f = e[5], p = e[6]);
  let m;
  return e[7] !== i || e[8] !== s || e[9] !== l || e[10] !== a ? (m = /* @__PURE__ */ g(SI, { mode: "single", selected: s, defaultMonth: l, onSelect: a, disabled: i, captionLayout: "dropdown", startMonth: c, endMonth: u, showOutsideDays: !0, formatters: d, classNames: f, components: p }), e[7] = i, e[8] = s, e[9] = l, e[10] = a, e[11] = m) : m = e[11], m;
}
function TI(t) {
  return t.toLocaleString("en-US", {
    month: "short"
  });
}
const OI = /^(\d{2})\/(\d{2})\/(\d{4})$/;
function jm(t) {
  const e = t.match(OI);
  if (!e) return null;
  const [, n, o, r] = e, i = new Date(Number(r), Number(n) - 1, Number(o));
  return i.getFullYear() !== Number(r) || i.getMonth() !== Number(n) - 1 || i.getDate() !== Number(o) ? null : i;
}
function kc(t) {
  const e = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0"), o = t.getFullYear();
  return `${e}/${n}/${o}`;
}
const DI = ae(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-[176px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function HD(t) {
  const e = B.c(73), {
    value: n,
    onValueChange: o,
    label: r,
    size: i,
    required: s,
    description: l,
    tooltip: a,
    error: c,
    disabled: u
  } = t, d = i === void 0 ? "md" : i, f = u === void 0 ? !1 : u, p = Kt(), [m, h] = qe(!1);
  let b;
  e[0] !== n ? (b = n ? kc(n) : "", e[0] = n, e[1] = b) : b = e[1];
  const [v, C] = qe(b), y = nt(null), w = nt(null), R = At(), S = At(), E = !!c;
  let N, M;
  e[2] !== n ? (N = () => {
    C((be) => {
      const le = jm(be);
      return (n === null ? be === "" : le !== null && le.getFullYear() === n.getFullYear() && le.getMonth() === n.getMonth() && le.getDate() === n.getDate()) ? be : n ? kc(n) : "";
    });
  }, M = [n], e[2] = n, e[3] = N, e[4] = M) : (N = e[3], M = e[4]), Rt(N, M);
  let T;
  e[5] !== o ? (T = function(le) {
    const me = le.target.value;
    C(me);
    const j = jm(me);
    j ? o(j) : me === "" && o(null);
  }, e[5] = o, e[6] = T) : T = e[6];
  const P = T;
  let k;
  e[7] !== o ? (k = function(le) {
    o(le), C(le ? kc(le) : ""), h(!1);
  }, e[7] = o, e[8] = k) : k = e[8];
  const I = k;
  let D;
  e[9] !== o ? (D = function() {
    o(null), C(""), h(!1), w.current?.focus();
  }, e[9] = o, e[10] = D) : D = e[10];
  const O = D, V = v, _ = f && "pointer-events-none";
  let L;
  e[11] !== _ ? (L = ne("flex flex-col w-fit", _), e[11] = _, e[12] = L) : L = e[12];
  let A;
  e[13] !== R || e[14] !== r || e[15] !== s || e[16] !== a ? (A = r && /* @__PURE__ */ g(hi, { htmlFor: R, label: r, required: s, tooltip: a }), e[13] = R, e[14] = r, e[15] = s, e[16] = a, e[17] = A) : A = e[17];
  let $;
  e[18] !== f || e[19] !== E || e[20] !== d ? ($ = ne(DI({
    size: d,
    hasError: E
  }), f && "opacity-50"), e[18] = f, e[19] = E, e[20] = d, e[21] = $) : $ = e[21];
  const Y = s || void 0, z = E || void 0, H = l || c ? S : void 0, K = E && "text-input-error-text";
  let G;
  e[22] !== K ? (G = ne("flex-1 min-w-0 outline-none bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-text-subtle", K), e[22] = K, e[23] = G) : G = e[23];
  let q;
  e[24] !== f || e[25] !== V || e[26] !== P || e[27] !== R || e[28] !== s || e[29] !== Y || e[30] !== z || e[31] !== H || e[32] !== G ? (q = /* @__PURE__ */ g("input", { id: R, ref: w, type: "text", value: V, onChange: P, placeholder: "MM/DD/YYYY", disabled: f, required: s, "aria-required": Y, "aria-invalid": z, "aria-describedby": H, className: G }), e[24] = f, e[25] = V, e[26] = P, e[27] = R, e[28] = s, e[29] = Y, e[30] = z, e[31] = H, e[32] = G, e[33] = q) : q = e[33];
  let ee;
  e[34] !== f || e[35] !== O || e[36] !== n ? (ee = n !== null && !f && /* @__PURE__ */ g("button", { type: "button", "aria-label": "Clear date", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", onMouseDown: _I, onClick: O, children: /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = f, e[35] = O, e[36] = n, e[37] = ee) : ee = e[37];
  let W;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (W = /* @__PURE__ */ g(We, { name: "calendar", size: "xs", tone: "inherit" }), e[38] = W) : W = e[38];
  let X;
  e[39] !== f ? (X = /* @__PURE__ */ g(ya, { render: /* @__PURE__ */ g("button", { type: "button", "aria-label": "Open calendar", disabled: f, className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-main hover:text-icon-main disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: W }) }), e[39] = f, e[40] = X) : X = e[40];
  let J;
  e[41] !== ee || e[42] !== X ? (J = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    ee,
    X
  ] }), e[41] = ee, e[42] = X, e[43] = J) : J = e[43];
  let re;
  e[44] !== $ || e[45] !== q || e[46] !== J ? (re = /* @__PURE__ */ F("div", { ref: y, className: $, children: [
    q,
    J
  ] }), e[44] = $, e[45] = q, e[46] = J, e[47] = re) : re = e[47];
  let Q;
  e[48] !== f || e[49] !== I || e[50] !== n ? (Q = /* @__PURE__ */ g(Ca, { anchor: y, side: "bottom", align: "start", sideOffset: 4, children: /* @__PURE__ */ g(wa, { children: /* @__PURE__ */ g(MI, { value: n, onValueChange: I, disabled: f }) }) }), e[48] = f, e[49] = I, e[50] = n, e[51] = Q) : Q = e[51];
  let ie;
  e[52] !== p || e[53] !== Q ? (ie = /* @__PURE__ */ g(xa, { container: p, children: Q }), e[52] = p, e[53] = Q, e[54] = ie) : ie = e[54];
  let ce;
  e[55] !== m || e[56] !== re || e[57] !== ie ? (ce = /* @__PURE__ */ F(Xd, { open: m, onOpenChange: h, modal: !1, children: [
    re,
    ie
  ] }), e[55] = m, e[56] = re, e[57] = ie, e[58] = ce) : ce = e[58];
  let oe;
  e[59] !== l || e[60] !== S || e[61] !== c || e[62] !== E ? (oe = E ? /* @__PURE__ */ g(Or, { match: !0, id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: c }) : l ? /* @__PURE__ */ g(mi, { id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: l }) : null, e[59] = l, e[60] = S, e[61] = c, e[62] = E, e[63] = oe) : oe = e[63];
  let se;
  e[64] !== oe ? (se = /* @__PURE__ */ g("div", { "data-testid": "date-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: oe }), e[64] = oe, e[65] = se) : se = e[65];
  let fe;
  return e[66] !== f || e[67] !== E || e[68] !== L || e[69] !== A || e[70] !== ce || e[71] !== se ? (fe = /* @__PURE__ */ F(Tr, { invalid: E, disabled: f, className: L, children: [
    A,
    ce,
    se
  ] }), e[66] = f, e[67] = E, e[68] = L, e[69] = A, e[70] = ce, e[71] = se, e[72] = fe) : fe = e[72], fe;
}
function _I(t) {
  return t.preventDefault();
}
const fl = 8, Km = 20, VI = 16, AI = 20;
function Gb(t) {
  return {
    offsetX: t ? t.offsetLeft : VI,
    offsetY: t ? t.offsetTop : AI,
    width: t?.offsetWidth || Km,
    height: t?.offsetHeight || Km
  };
}
function LI(t, e) {
  const n = -e.offsetX, o = -e.offsetY, r = window.innerWidth - e.offsetX - e.width, i = window.innerHeight - e.offsetY - e.height;
  return {
    x: Math.max(n, Math.min(t.x, r)),
    y: Math.max(o, Math.min(t.y, i))
  };
}
function FI(t) {
  const e = B.c(24), {
    dragHandleRef: n,
    position: o,
    onPositionChange: r,
    disabled: i
  } = t, s = i === void 0 ? !1 : i, l = x.useRef(!1), [a, c] = x.useState(!1);
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    pointerX: 0,
    pointerY: 0,
    elementX: 0,
    elementY: 0
  }, e[0] = u) : u = e[0];
  const d = x.useRef(u);
  let f;
  e[1] !== n ? (f = (P) => LI(P, Gb(n.current)), e[1] = n, e[2] = f) : f = e[2];
  const p = f;
  let m;
  e[3] !== s || e[4] !== o ? (m = (P) => {
    s || P.pointerType === "mouse" && P.button !== 0 || (P.currentTarget.setPointerCapture?.(P.pointerId), l.current = !0, c(!0), d.current = {
      pointerX: P.clientX,
      pointerY: P.clientY,
      elementX: o.x,
      elementY: o.y
    });
  }, e[3] = s, e[4] = o, e[5] = m) : m = e[5];
  const h = m;
  let b;
  e[6] !== p || e[7] !== r ? (b = (P) => {
    if (!l.current)
      return;
    const k = P.clientX - d.current.pointerX, I = P.clientY - d.current.pointerY;
    r(p({
      x: d.current.elementX + k,
      y: d.current.elementY + I
    }));
  }, e[6] = p, e[7] = r, e[8] = b) : b = e[8];
  const v = b;
  let C;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = () => l.current ? (l.current = !1, c(!1), !0) : !1, e[9] = C) : C = e[9];
  const y = C;
  let w;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = (P) => {
    y() && P.currentTarget.releasePointerCapture?.(P.pointerId);
  }, e[10] = w) : w = e[10];
  const R = w;
  let S;
  e[11] !== p || e[12] !== s || e[13] !== r || e[14] !== o ? (S = (P) => {
    if (s || P.target !== P.currentTarget)
      return;
    let k = 0, I = 0;
    if (P.key === "ArrowLeft")
      k = -fl;
    else if (P.key === "ArrowRight")
      k = fl;
    else if (P.key === "ArrowUp")
      I = -fl;
    else if (P.key === "ArrowDown")
      I = fl;
    else
      return;
    P.preventDefault(), r(p({
      x: o.x + k,
      y: o.y + I
    }));
  }, e[11] = p, e[12] = s, e[13] = r, e[14] = o, e[15] = S) : S = e[15];
  const E = S;
  let N;
  e[16] !== E || e[17] !== h || e[18] !== v ? (N = {
    onPointerDown: h,
    onPointerMove: v,
    onPointerUp: R,
    onPointerCancel: y,
    onLostPointerCapture: y,
    onKeyDown: E,
    tabIndex: 0,
    "aria-label": "Drag to reposition",
    "data-slot": "dialog-drag-handle"
  }, e[16] = E, e[17] = h, e[18] = v, e[19] = N) : N = e[19];
  const M = N;
  let T;
  return e[20] !== n || e[21] !== a || e[22] !== M ? (T = {
    dragHandleRef: n,
    isDragging: a,
    dragHandleProps: M
  }, e[20] = n, e[21] = a, e[22] = M, e[23] = T) : T = e[23], T;
}
const qm = 550, Zm = 400, $I = 16, HI = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]"], {
  variants: {
    expanded: {
      true: ["pointer-events-none", "flex", "items-center", "justify-center", "p-(--spacing-16)"],
      false: "pointer-events-none"
    }
  }
}), zI = ae(["flex", "flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5"], {
  variants: {
    expanded: {
      true: ["pointer-events-auto", "w-[min(1263px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(1136px,calc(100vh_-_var(--spacing-32)))]", "outline-none"],
      false: ["pointer-events-auto", "fixed", "z-[var(--z-layer-dialog)]", "h-[min(400px,100vh)]", "w-[min(550px,100vw)]"]
    }
  }
}), BI = ae(["shrink-0", "bg-surface-container-lowest", "px-(--spacing-24)", "py-(--spacing-16)", "shadow-elevation-1"]), WI = ae(["flex", "shrink-0", "flex-col", "gap-(--spacing-6)", "p-(--spacing-16)"]), Xm = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-bold)", "leading-(--font-line-height-28)", "text-text-default"]), Qm = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), UI = ae(["mt-(--spacing-4)", "flex", "size-(--spacing-20)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "select-none", "outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"]), GI = ae(["min-h-0", "flex-1"], {
  variants: {
    expanded: {
      true: "flex",
      false: ["overflow-y-auto", "p-(--spacing-16)"]
    }
  }
}), YI = ae([], {
  variants: {
    expanded: {
      true: ["min-w-0", "flex-1", "overflow-y-auto", "p-(--spacing-16)"],
      false: "contents"
    }
  }
}), Jm = ae(["flex", "min-h-(--spacing-40)", "shrink-0", "items-center", "gap-(--spacing-16)", "px-(--spacing-16)", "pb-(--spacing-16)"]);
function Yb() {
  return typeof window > "u" ? {
    width: qm,
    height: Zm
  } : {
    width: Math.min(qm, window.innerWidth),
    height: Math.min(Zm, window.innerHeight)
  };
}
function pl(t, e = Yb()) {
  return typeof window > "u" ? t : {
    x: Math.max(0, Math.min(t.x, window.innerWidth - e.width)),
    y: Math.max(0, Math.min(t.y, window.innerHeight - e.height))
  };
}
function eg(t, e) {
  if (typeof window > "u") return t;
  const n = Gb(e);
  return {
    x: Math.max(-n.offsetX, Math.min(t.x, window.innerWidth - n.offsetX - n.width)),
    y: Math.max(-n.offsetY, Math.min(t.y, window.innerHeight - n.offsetY - n.height))
  };
}
function jI(t) {
  if (typeof window > "u") return {
    x: 0,
    y: 0
  };
  const {
    innerWidth: e,
    innerHeight: n
  } = window, o = Yb(), r = Math.min($I, e, n), i = e - o.width - r, s = n - o.height - r;
  switch (t) {
    case "top-start":
      return pl({
        x: r,
        y: r
      }, o);
    case "top-end":
      return pl({
        x: i,
        y: r
      }, o);
    case "bottom-start":
      return pl({
        x: r,
        y: s
      }, o);
    case "bottom-end":
      return pl({
        x: i,
        y: s
      }, o);
  }
}
function zD({
  open: t,
  onOpenChange: e,
  expanded: n = !1,
  onExpandedChange: o,
  initialPlacement: r = "bottom-end",
  position: i,
  onPositionChange: s,
  heading: l,
  description: a,
  headerAccessory: c,
  expandedAside: u,
  children: d,
  floatingFooter: f,
  expandedFooter: p
}) {
  const m = Kt(), h = !!n, b = i !== void 0, [v, C] = x.useState(() => jI(r)), y = i ?? v, w = x.useRef(null), R = (T) => {
    b || C(T), s?.(T);
  }, S = t && !h ? eg(y, w.current) : y, {
    isDragging: E,
    dragHandleProps: N
  } = FI({
    dragHandleRef: w,
    position: S,
    onPositionChange: R,
    disabled: h
  });
  return x.useEffect(() => {
    if (!t || h || typeof window > "u") return;
    const T = () => {
      const P = eg({
        x: y.x,
        y: y.y
      }, w.current);
      (P.x !== y.x || P.y !== y.y) && (b || C(P), s?.(P));
    };
    return T(), window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, [y.x, y.y, b, h, s, t]), /* @__PURE__ */ g(vi, { open: t, onOpenChange: (T, P) => {
    const k = P?.reason === "outside-press" || P?.reason === "focus-out";
    if (!h && !T && k) {
      P.cancel();
      return;
    }
    e(T);
  }, modal: h, disablePointerDismissal: !h, children: /* @__PURE__ */ F(Dr, { container: m, children: [
    h && /* @__PURE__ */ g(Ps, { "data-slot": "dialog-scrim", className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }),
    /* @__PURE__ */ g(yi, { className: ne(HI({
      expanded: h
    })), children: /* @__PURE__ */ F(bi, { "aria-modal": h ? "true" : void 0, "data-slot": h ? "dialog-expanded" : "dialog", initialFocus: h ? void 0 : () => w.current, className: ne(zI({
      expanded: h
    })), style: h ? void 0 : {
      left: S.x,
      top: S.y
    }, children: [
      h ? /* @__PURE__ */ F("div", { "data-slot": "dialog-expanded-header", className: ne(BI()), children: [
        /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-16)", children: [
            /* @__PURE__ */ g(ts, { className: ne(Xm(), "whitespace-nowrap"), children: l }),
            c && /* @__PURE__ */ g("div", { className: "flex min-w-0 items-center gap-(--spacing-16)", children: c })
          ] }),
          /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-16)", children: [
            o && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Collapse", onClick: () => o(!1) }),
            /* @__PURE__ */ g(Qr, { render: /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
          ] })
        ] }),
        a && /* @__PURE__ */ g(es, { className: ne(Qm(), "mt-(--spacing-6)"), children: a })
      ] }) : /* @__PURE__ */ g("div", { className: ne(WI()), children: /* @__PURE__ */ F("div", { className: "flex items-start justify-between gap-(--spacing-6)", children: [
        /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 gap-(--spacing-8)", children: [
          /* @__PURE__ */ g("button", { type: "button", ref: w, ...N, className: ne(UI(), E ? "cursor-grabbing" : "cursor-grab"), children: /* @__PURE__ */ g(We, { name: "drag", size: "sm", tone: "secondary" }) }),
          /* @__PURE__ */ F("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8)", children: [
              /* @__PURE__ */ g(ts, { className: ne(Xm(), "min-w-0"), children: l }),
              c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
            ] }),
            a && /* @__PURE__ */ g(es, { className: ne(Qm(), "mt-(--spacing-4)"), children: a })
          ] })
        ] }),
        /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
          o && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Expand", onClick: () => o(!0) }),
          /* @__PURE__ */ g(Qr, { render: /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
        ] })
      ] }) }),
      /* @__PURE__ */ F("div", { className: ne(GI({
        expanded: h
      })), children: [
        h && u && /* @__PURE__ */ F(Vt, { children: [
          /* @__PURE__ */ g("div", { className: "min-w-0 basis-1/2 overflow-y-auto p-(--spacing-16)", children: u }),
          /* @__PURE__ */ g(gr, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ g("div", { className: ne(YI({
          expanded: h
        })), children: d }, "body")
      ] }),
      h ? p && /* @__PURE__ */ g("div", { className: ne(Jm()), children: p }) : f && /* @__PURE__ */ g("div", { className: ne(Jm()), children: f })
    ] }) })
  ] }) });
}
const a1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (a1.displayName = "TabsRootContext");
function c1() {
  const t = x.useContext(a1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : tt(64));
  return t;
}
let KI = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const u1 = {
  tabActivationDirection: (t) => ({
    [KI.activationDirection]: t
  })
}, d1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: i,
    orientation: s = "horizontal",
    render: l,
    value: a,
    style: c,
    ...u
  } = e, d = Object.hasOwn(e, "defaultValue"), f = x.useRef([]), [p, m] = x.useState(() => /* @__PURE__ */ new Map()), [h, b] = pn({
    controlled: a,
    default: r,
    name: "Tabs",
    state: "value"
  }), v = a !== void 0, [C, y] = x.useState(() => /* @__PURE__ */ new Map()), w = x.useCallback((H) => {
    if (H === void 0)
      return null;
    for (const [K, G] of C.entries())
      if (G != null && H === (G.value ?? G.index))
        return K;
    return null;
  }, [C]), [R, S] = x.useState(() => ({
    previousValue: h,
    tabActivationDirection: "none"
  })), {
    previousValue: E,
    tabActivationDirection: N
  } = R;
  let M = N, T = !1;
  E !== h && (M = tg(E, h, s, C), T = E != null && h != null && w(h) == null);
  const P = T ? E : h, k = E !== P || N !== M;
  Ne(() => {
    k && S({
      previousValue: P,
      tabActivationDirection: M
    });
  }, [P, k, M]);
  const I = Ce((H, K) => {
    const G = tg(h, H, s, C);
    K.activationDirection = G, i?.(H, K), !K.isCanceled && b(H);
  }), D = Ce((H, K) => {
    m((G) => {
      if (G.get(H) === K)
        return G;
      const q = new Map(G);
      return q.set(H, K), q;
    });
  }), O = Ce((H, K) => {
    m((G) => {
      if (!G.has(H) || G.get(H) !== K)
        return G;
      const q = new Map(G);
      return q.delete(H), q;
    });
  }), V = x.useCallback((H) => p.get(H), [p]), _ = x.useCallback((H) => {
    for (const K of C.values())
      if (H === K?.value)
        return K?.id;
  }, [C]), L = x.useMemo(() => ({
    getTabElementBySelectedValue: w,
    getTabIdByPanelValue: _,
    getTabPanelIdByValue: V,
    onValueChange: I,
    orientation: s,
    registerMountedTabPanel: D,
    setTabMap: y,
    unregisterMountedTabPanel: O,
    tabActivationDirection: M,
    value: h
  }), [w, _, V, I, s, D, y, O, M, h]), A = x.useMemo(() => {
    for (const H of C.values())
      if (H != null && H.value === h)
        return H;
  }, [C, h]), $ = x.useMemo(() => {
    for (const H of C.values())
      if (H != null && !H.disabled)
        return H.value;
  }, [C]);
  Ne(() => {
    if (v || C.size === 0)
      return;
    const H = A?.disabled, K = A == null && h !== null;
    if (d && H && h === r || !H && !K)
      return;
    const q = $ ?? null;
    h !== q && (b(q), S((ee) => ee.tabActivationDirection === "none" ? ee : {
      ...ee,
      tabActivationDirection: "none"
    }));
  }, [r, $, d, v, A, b, C, h]);
  const z = Le("div", e, {
    state: {
      orientation: s,
      tabActivationDirection: M
    },
    ref: n,
    props: u,
    stateAttributesMapping: u1
  });
  return /* @__PURE__ */ g(a1.Provider, {
    value: L,
    children: /* @__PURE__ */ g(si, {
      elementsRef: f,
      children: z
    })
  });
});
process.env.NODE_ENV !== "production" && (d1.displayName = "TabsRoot");
function tg(t, e, n, o) {
  if (t == null || e == null)
    return "none";
  let r = null, i = null;
  for (const [a, c] of o.entries()) {
    if (c == null)
      continue;
    const u = c.value ?? c.index;
    if (t === u && (r = a), e === u && (i = a), r != null && i != null)
      break;
  }
  if (r == null || i == null)
    return r !== i && (typeof t == "number" || typeof t == "string") && typeof t == typeof e ? n === "horizontal" ? e > t ? "right" : "left" : e > t ? "down" : "up" : "none";
  const s = r.getBoundingClientRect(), l = i.getBoundingClientRect();
  if (n === "horizontal") {
    if (l.left < s.left)
      return "left";
    if (l.left > s.left)
      return "right";
  } else {
    if (l.top < s.top)
      return "up";
    if (l.top > s.top)
      return "down";
  }
  return "none";
}
const f1 = "data-composite-item-active", p1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (p1.displayName = "TabsListContext");
function qI() {
  const t = x.useContext(p1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : tt(65));
  return t;
}
const m1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: i,
    value: s,
    id: l,
    nativeButton: a = !0,
    style: c,
    ...u
  } = e, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: p
  } = c1(), {
    activateOnFocus: m,
    highlightedTabIndex: h,
    onTabActivation: b,
    registerTabResizeObserverElement: v,
    setHighlightedTabIndex: C,
    tabsListElement: y
  } = qI(), w = It(l), R = x.useMemo(() => ({
    disabled: r,
    id: w,
    value: s
  }), [r, w, s]), {
    compositeProps: S,
    compositeRef: E,
    index: N
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = p2({
    metadata: R
  }), M = s === d, T = x.useRef(!1), P = x.useRef(null);
  x.useEffect(() => {
    const z = P.current;
    if (z)
      return v(z);
  }, [v]), Ne(() => {
    if (T.current) {
      T.current = !1;
      return;
    }
    if (!(M && N > -1 && h !== N))
      return;
    const z = y;
    if (z != null) {
      const H = Gt(et(z));
      if (H && He(z, H))
        return;
    }
    r || C(N);
  }, [M, N, h, C, r, y]);
  const {
    getButtonProps: k,
    buttonRef: I
  } = Wt({
    disabled: r,
    native: a,
    focusableWhenDisabled: !0
  }), D = f(s), O = x.useRef(!1), V = x.useRef(!1);
  function _(z) {
    M || r || b(s, _e(Mt, z.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function L(z) {
    M || (N > -1 && !r && C(N), !r && m && (!O.current || // keyboard or touch focus
    O.current && V.current) && b(s, _e(Mt, z.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function A(z) {
    if (M || r)
      return;
    O.current = !0;
    function H() {
      O.current = !1, V.current = !1;
    }
    (!z.button || z.button === 0) && (V.current = !0, et(z.currentTarget).addEventListener("pointerup", H, {
      once: !0
    }));
  }
  return Le("button", e, {
    state: {
      disabled: r,
      active: M,
      orientation: p
    },
    ref: [n, I, E, P],
    props: [S, {
      role: "tab",
      "aria-controls": D,
      "aria-selected": M,
      id: w,
      onClick: _,
      onFocus: L,
      onPointerDown: A,
      [f1]: M ? "" : void 0,
      onKeyDownCapture() {
        T.current = !0;
      }
    }, u, k]
  });
});
process.env.NODE_ENV !== "production" && (m1.displayName = "TabsTab");
let ZI = (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t;
})({});
const XI = {
  ...u1,
  ...Bt
}, jb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: i,
    keepMounted: s = !1,
    style: l,
    ...a
  } = e, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: m
  } = c1(), h = It(), b = x.useMemo(() => ({
    id: h,
    value: r
  }), [h, r]), {
    ref: v,
    index: C
  } = Do({
    metadata: b
  }), y = r === c, {
    mounted: w,
    transitionStatus: R,
    setMounted: S
  } = Xn(y), E = !w, N = u(r), M = {
    hidden: E,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: R
  }, T = x.useRef(null), P = Le("div", e, {
    state: M,
    ref: [n, v, T],
    props: [{
      "aria-labelledby": N,
      hidden: E,
      id: h,
      role: "tabpanel",
      tabIndex: y ? 0 : -1,
      inert: kr(!y),
      [ZI.index]: C
    }, a],
    stateAttributesMapping: XI
  });
  return jt({
    open: y,
    ref: T,
    onComplete() {
      y || S(!1);
    }
  }), Ne(() => {
    if (!(E && !s) && h != null)
      return p(r, h), () => {
        m(r, h);
      };
  }, [E, s, r, h, p, m]), s || w ? P : null;
});
process.env.NODE_ENV !== "production" && (jb.displayName = "TabsPanel");
const QI = [];
function JI(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    onLoop: r,
    dense: i = !1,
    orientation: s = "both",
    direction: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: p,
    modifierKeys: m = QI
  } = t, [h, b] = x.useState(0), v = n > 1, C = x.useRef(null), y = mn(C, u), w = x.useRef([]), R = x.useRef(!1), S = a ?? h, E = Ce((P, k = !1) => {
    if ((c ?? b)(P), k) {
      const I = w.current[P];
      Ip(C.current, I, l, s);
    }
  }), N = Ce((P) => {
    if (P.size === 0 || R.current)
      return;
    R.current = !0;
    const k = Array.from(P.keys()), I = k.find((O) => O?.hasAttribute(f1)) ?? null, D = I ? k.indexOf(I) : -1;
    D !== -1 && E(D), Ip(C.current, I, l, s);
  }), M = Ce((P, k, I) => r ? r?.(P, k, I, w) : I), T = x.useMemo(() => ({
    "aria-orientation": s === "both" ? void 0 : s,
    ref: y,
    onFocus(P) {
      const k = C.current, I = bt(P.nativeEvent);
      !k || I == null || !kp(I) || I.setSelectionRange(0, I.value.length ?? 0);
    },
    onKeyDown(P) {
      const k = d ? Fy : Jh;
      if (!k.has(P.key) || eP(P, m) || !C.current)
        return;
      const D = l === "rtl", O = D ? Qi : Gr, V = {
        horizontal: O,
        vertical: ur,
        both: O
      }[s], _ = D ? Gr : Qi, L = {
        horizontal: _,
        vertical: Ur,
        both: _
      }[s], A = bt(P.nativeEvent);
      if (A != null && kp(A) && !b2(A)) {
        const q = A.selectionStart, ee = A.selectionEnd, W = A.value ?? "";
        if (q == null || P.shiftKey || q !== ee || P.key !== L && q < W.length || P.key !== V && q > 0)
          return;
      }
      let $ = S;
      const Y = xl(w, p), z = lu(w, p);
      if (v) {
        const q = e || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), ee = hh(q, n, i), W = ee.findIndex((J) => J != null && !ko(w.current, J, p)), X = ee.reduce((J, re, Q) => re != null && !ko(w.current, re, p) ? Q : J, -1);
        $ = ee[gh(ee.map((J) => J != null ? w.current[J] : null), {
          event: P,
          orientation: s,
          loopFocus: o,
          onLoop: M,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: vh([...p || w.current.map((J, re) => ko(w.current, re) ? re : void 0), void 0], ee),
          minIndex: W,
          maxIndex: X,
          prevIndex: bh(
            S > z ? Y : S,
            q,
            ee,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            P.key === ur ? "bl" : P.key === Gr ? "tr" : "tl"
          ),
          rtl: D
        })];
      }
      const H = {
        horizontal: [O],
        vertical: [ur],
        both: [O, ur]
      }[s], K = {
        horizontal: [_],
        vertical: [Ur],
        both: [_, Ur]
      }[s], G = v ? k : {
        horizontal: d ? Ay : Xh,
        vertical: d ? Ly : Qh,
        both: k
      }[s];
      d && (P.key === ys ? $ = Y : P.key === xs && ($ = z)), $ === S && (H.includes(P.key) || K.includes(P.key)) && (o && $ === z && H.includes(P.key) ? ($ = Y, r && ($ = r(P, S, $, w))) : o && $ === Y && K.includes(P.key) ? ($ = z, r && ($ = r(P, S, $, w))) : $ = ln(w.current, {
        startingIndex: $,
        decrement: K.includes(P.key),
        disabledIndices: p
      })), $ !== S && !Zi(w.current, $) && (f && P.stopPropagation(), G.has(P.key) && P.preventDefault(), E($, !0), queueMicrotask(() => {
        w.current[$]?.focus();
      }));
    }
  }), [n, i, l, p, w, d, S, v, e, o, r, M, y, m, E, s, f]);
  return x.useMemo(() => ({
    props: T,
    highlightedIndex: S,
    onHighlightedIndexChange: E,
    elementsRef: w,
    disabledIndices: p,
    onMapChange: N,
    relayKeyboardEvent: T.onKeyDown
  }), [T, S, E, w, p, N]);
}
function eP(t, e) {
  for (const n of By.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function Kb(t) {
  const {
    render: e,
    className: n,
    style: o,
    refs: r = _n,
    props: i = _n,
    state: s = St,
    stateAttributesMapping: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: p,
    onLoop: m,
    cols: h,
    enableHomeAndEndKeys: b,
    onMapChange: v,
    stopEventPropagation: C = !0,
    rootRef: y,
    disabledIndices: w,
    modifierKeys: R,
    highlightItemOnHover: S = !1,
    tag: E = "div",
    ...N
  } = t, M = ws(), {
    props: T,
    highlightedIndex: P,
    onHighlightedIndexChange: k,
    elementsRef: I,
    onMapChange: D,
    relayKeyboardEvent: O
  } = JI({
    itemSizes: f,
    cols: h,
    loopFocus: p,
    onLoop: m,
    dense: d,
    orientation: u,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: y,
    stopEventPropagation: C,
    enableHomeAndEndKeys: b,
    direction: M,
    disabledIndices: w,
    modifierKeys: R
  }), V = Le(E, t, {
    state: s,
    ref: r,
    props: [T, ...i, N],
    stateAttributesMapping: l
  }), _ = x.useMemo(() => ({
    highlightedIndex: P,
    onHighlightedIndexChange: k,
    highlightItemOnHover: S,
    relayKeyboardEvent: O
  }), [P, k, S, O]);
  return /* @__PURE__ */ g(Lu.Provider, {
    value: _,
    children: /* @__PURE__ */ g(si, {
      elementsRef: I,
      onMapChange: (L) => {
        v?.(L), D(L);
      },
      children: V
    })
  });
}
const g1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: i = !0,
    render: s,
    style: l,
    ...a
  } = e, {
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: p
  } = c1(), [m, h] = x.useState(0), [b, v] = x.useState(null), C = x.useRef(/* @__PURE__ */ new Set()), y = x.useRef(/* @__PURE__ */ new Set()), w = x.useRef(null), R = Ce(() => {
    C.current.forEach((k) => {
      k();
    });
  });
  x.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const k = new ResizeObserver(() => {
      C.current.size && R();
    });
    return w.current = k, b && k.observe(b), y.current.forEach((I) => {
      k.observe(I);
    }), () => {
      k.disconnect(), w.current = null;
    };
  }, [b, R]);
  const S = Ce((k) => (C.current.add(k), () => {
    C.current.delete(k);
  })), E = Ce((k) => (y.current.add(k), w.current?.observe(k), () => {
    y.current.delete(k), w.current?.unobserve(k);
  })), N = Ce((k, I) => {
    k !== d && c(k, I);
  }), M = {
    orientation: u,
    tabActivationDirection: p
  }, T = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, P = x.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: m,
    registerIndicatorUpdateListener: S,
    registerTabResizeObserverElement: E,
    onTabActivation: N,
    setHighlightedTabIndex: h,
    tabsListElement: b
  }), [o, m, S, E, N, h, b]);
  return /* @__PURE__ */ g(p1.Provider, {
    value: P,
    children: /* @__PURE__ */ g(Kb, {
      render: s,
      className: r,
      style: l,
      state: M,
      refs: [n, v],
      props: [T, a],
      stateAttributesMapping: u1,
      highlightedIndex: m,
      enableHomeAndEndKeys: !0,
      loopFocus: i,
      orientation: u,
      onHighlightedIndexChange: h,
      onMapChange: f,
      disabledIndices: _n
    })
  });
});
process.env.NODE_ENV !== "production" && (g1.displayName = "TabsList");
function tP(t) {
  const e = B.c(8), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t;
  let i;
  e[0] !== o ? (i = o ?? [], e[0] = o, e[1] = i) : i = e[1];
  const [s, l] = qe(i), a = n !== void 0, c = a ? n : s;
  let u;
  e[2] !== a || e[3] !== r ? (u = function(m) {
    a || l(m), r?.(m);
  }, e[2] = a, e[3] = r, e[4] = u) : u = e[4];
  const d = u;
  let f;
  return e[5] !== c || e[6] !== d ? (f = [c, d], e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
}
function qb(t) {
  const e = B.c(6), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t, [i, s] = qe(o ?? null), l = n !== void 0, a = l ? n : i;
  let c;
  e[0] !== l || e[1] !== r ? (c = function(p) {
    l || s(p), r?.(p);
  }, e[0] = l, e[1] = r, e[2] = c) : c = e[2];
  const u = c;
  let d;
  return e[3] !== a || e[4] !== u ? (d = [a, u], e[3] = a, e[4] = u, e[5] = d) : d = e[5], d;
}
const nP = ae(["inline-flex", "h-(--spacing-32)", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-button-outline-default-text", "outline-none", "transition-colors", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "hover:border-button-outline-hover-border", "hover:bg-button-outline-hover-background", "active:border-button-outline-pressed-border", "active:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-[3px]", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:cursor-not-allowed", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    fullWidth: {
      true: "w-full",
      false: ""
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
});
function _a(t) {
  const e = B.c(31);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    leadingIcon: r,
    trailingIcon: u,
    showChevron: s,
    open: l,
    mouseDown: a,
    fullWidth: c,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? !1 : s, f = l === void 0 ? !1 : l, p = a === void 0 ? !1 : a, m = c === void 0 ? !1 : c;
  let h;
  e[10] !== o || e[11] !== m ? (h = ne(nP({
    fullWidth: m
  }), o), e[10] = o, e[11] = m, e[12] = h) : h = e[12];
  const b = p ? "" : void 0, v = d ? f : i["aria-expanded"];
  let C;
  e[13] !== r ? (C = r && /* @__PURE__ */ g(We, { name: r, size: "xs", tone: "inherit" }), e[13] = r, e[14] = C) : C = e[14];
  let y;
  e[15] !== n ? (y = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: n }), e[15] = n, e[16] = y) : y = e[16];
  let w;
  e[17] !== u ? (w = u && /* @__PURE__ */ g(We, { name: u, size: "xs", tone: "inherit" }), e[17] = u, e[18] = w) : w = e[18];
  let R;
  e[19] !== f || e[20] !== d ? (R = d && /* @__PURE__ */ g("span", { "data-open": f ? "" : void 0, className: "inline-flex transition-transform duration-200 data-[open]:rotate-180", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[19] = f, e[20] = d, e[21] = R) : R = e[21];
  let S;
  return e[22] !== i || e[23] !== w || e[24] !== R || e[25] !== h || e[26] !== b || e[27] !== v || e[28] !== C || e[29] !== y ? (S = /* @__PURE__ */ F(Qn, { className: h, ...i, "data-mouse-down": b, "aria-expanded": v, children: [
    C,
    y,
    w,
    R
  ] }), e[22] = i, e[23] = w, e[24] = R, e[25] = h, e[26] = b, e[27] = v, e[28] = C, e[29] = y, e[30] = S) : S = e[30], S;
}
function BD(t) {
  const e = B.c(47), {
    children: n,
    title: o,
    triggerLabel: r,
    align: i,
    open: s,
    defaultOpen: l,
    onOpenChange: a,
    onApply: c,
    applyLabel: u,
    onClearAll: d,
    clearAllLabel: f,
    disabled: p
  } = t, m = o === void 0 ? "Filters" : o, h = i === void 0 ? "start" : i, b = u === void 0 ? "Apply filters" : u, v = f === void 0 ? "Clear All" : f, C = Kt(), [y, w] = qe(l ?? !1), {
    mouseDown: R,
    triggerMouseDownProps: S
  } = Es(), E = s !== void 0, N = E ? s : y;
  let M;
  e[0] !== E || e[1] !== a ? (M = function(ee) {
    E || w(ee), a?.(ee);
  }, e[0] = E, e[1] = a, e[2] = M) : M = e[2];
  const T = M;
  let P;
  e[3] !== T ? (P = function() {
    T(!1);
  }, e[3] = T, e[4] = P) : P = e[4];
  const k = P;
  let I;
  e[5] !== p || e[6] !== R || e[7] !== m || e[8] !== r || e[9] !== S ? (I = /* @__PURE__ */ g(ya, { render: r !== void 0 ? /* @__PURE__ */ g(_a, { trailingIcon: "filter", disabled: p, mouseDown: R, ...S, children: r }) : /* @__PURE__ */ g(gt, { variant: "outline", size: "sm", icon: "filter", "aria-label": m, disabled: p, ...S }) }), e[5] = p, e[6] = R, e[7] = m, e[8] = r, e[9] = S, e[10] = I) : I = e[10];
  let D;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne("flex", "w-[500px]", "max-w-[calc(100vw-var(--spacing-32))]", "max-h-[544px]", "flex-col", "gap-(--spacing-20)", "overflow-y-auto", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface", "p-(--spacing-20)", "shadow-elevation-3", "outline-none"), e[11] = D) : D = e[11];
  let O;
  e[12] !== m ? (O = /* @__PURE__ */ g("h2", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-28) text-text-default", children: m }), e[12] = m, e[13] = O) : O = e[13];
  let V;
  e[14] !== v || e[15] !== d ? (V = d && /* @__PURE__ */ g(tn, { variant: "ghost", size: "sm", onClick: d, children: v }), e[14] = v, e[15] = d, e[16] = V) : V = e[16];
  let _;
  e[17] !== V || e[18] !== O ? (_ = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    O,
    V
  ] }), e[17] = V, e[18] = O, e[19] = _) : _ = e[19];
  let L;
  e[20] !== n || e[21] !== k ? (L = typeof n == "function" ? n({
    close: k
  }) : n, e[20] = n, e[21] = k, e[22] = L) : L = e[22];
  let A;
  e[23] !== L ? (A = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-16)", children: L }), e[23] = L, e[24] = A) : A = e[24];
  let $;
  e[25] !== k || e[26] !== c ? ($ = () => {
    c?.(), k();
  }, e[25] = k, e[26] = c, e[27] = $) : $ = e[27];
  let Y;
  e[28] !== b || e[29] !== $ ? (Y = /* @__PURE__ */ g("div", { className: "flex justify-end", children: /* @__PURE__ */ g(tn, { size: "sm", onClick: $, children: b }) }), e[28] = b, e[29] = $, e[30] = Y) : Y = e[30];
  let z;
  e[31] !== _ || e[32] !== A || e[33] !== Y || e[34] !== m ? (z = /* @__PURE__ */ F(wa, { role: "dialog", "aria-label": m, className: D, children: [
    _,
    A,
    Y
  ] }), e[31] = _, e[32] = A, e[33] = Y, e[34] = m, e[35] = z) : z = e[35];
  let H;
  e[36] !== h || e[37] !== z ? (H = /* @__PURE__ */ g(Ca, { side: "bottom", align: h, sideOffset: 4, children: z }), e[36] = h, e[37] = z, e[38] = H) : H = e[38];
  let K;
  e[39] !== C || e[40] !== H ? (K = /* @__PURE__ */ g(xa, { container: C, children: H }), e[39] = C, e[40] = H, e[41] = K) : K = e[41];
  let G;
  return e[42] !== N || e[43] !== T || e[44] !== K || e[45] !== I ? (G = /* @__PURE__ */ F(Xd, { open: N, onOpenChange: T, modal: !1, children: [
    I,
    K
  ] }), e[42] = N, e[43] = T, e[44] = K, e[45] = I, e[46] = G) : G = e[46], G;
}
function WD(t) {
  const e = B.c(27), {
    label: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = tP(u), [p, m] = qe(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Es();
  let v;
  e[4] !== d || e[5] !== f ? (v = function(N, M) {
    f(M ? [...d, N] : d.filter((T) => T !== N));
  }, e[4] = d, e[5] = f, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== a || e[8] !== n || e[9] !== h || e[10] !== p || e[11] !== b ? (y = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(_a, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: n }) }), e[7] = a, e[8] = n, e[9] = h, e[10] = p, e[11] = b, e[12] = y) : y = e[12];
  let w;
  if (e[13] !== C || e[14] !== o || e[15] !== d) {
    let E;
    e[17] !== C || e[18] !== d ? (E = (N) => /* @__PURE__ */ g(w9, { checked: d.includes(N.value), disabled: N.disabled, closeOnClick: !1, onCheckedChange: (M) => {
      C(N.value, M);
    }, children: N.label }, N.value), e[17] = C, e[18] = d, e[19] = E) : E = e[19], w = o.map(E), e[13] = C, e[14] = o, e[15] = d, e[16] = w;
  } else
    w = e[16];
  let R;
  e[20] !== c || e[21] !== w ? (R = /* @__PURE__ */ g(Pr, { size: "auto", align: c, children: w }), e[20] = c, e[21] = w, e[22] = R) : R = e[22];
  let S;
  return e[23] !== p || e[24] !== y || e[25] !== R ? (S = /* @__PURE__ */ F(ci, { open: p, onOpenChange: m, children: [
    y,
    R
  ] }), e[23] = p, e[24] = y, e[25] = R, e[26] = S) : S = e[26], S;
}
function UD(t) {
  const e = B.c(29), {
    options: n,
    value: o,
    defaultValue: r,
    onChange: i,
    placeholder: s,
    align: l,
    disabled: a
  } = t, c = s === void 0 ? "Date Range" : s, u = l === void 0 ? "start" : l;
  let d;
  e[0] !== r || e[1] !== i || e[2] !== o ? (d = {
    value: o,
    defaultValue: r,
    onChange: i
  }, e[0] = r, e[1] = i, e[2] = o, e[3] = d) : d = e[3];
  const [f, p] = qb(d), [m, h] = qe(!1), {
    mouseDown: b,
    triggerMouseDownProps: v
  } = Es();
  let C;
  e[4] !== n || e[5] !== c || e[6] !== f ? (C = n.find((P) => P.value === f)?.label ?? c, e[4] = n, e[5] = c, e[6] = f, e[7] = C) : C = e[7];
  const y = C;
  let w;
  e[8] !== a || e[9] !== b || e[10] !== m || e[11] !== y || e[12] !== v ? (w = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ g(_a, { leadingIcon: "calendar", showChevron: !0, open: m, mouseDown: b, disabled: a, ...v, children: y }) }), e[8] = a, e[9] = b, e[10] = m, e[11] = y, e[12] = v, e[13] = w) : w = e[13];
  const R = f ?? "";
  let S;
  e[14] !== p ? (S = (P) => {
    p(P), h(!1);
  }, e[14] = p, e[15] = S) : S = e[15];
  let E;
  e[16] !== n ? (E = n.map(oP), e[16] = n, e[17] = E) : E = e[17];
  let N;
  e[18] !== R || e[19] !== S || e[20] !== E ? (N = /* @__PURE__ */ g(_d, { value: R, onValueChange: S, children: E }), e[18] = R, e[19] = S, e[20] = E, e[21] = N) : N = e[21];
  let M;
  e[22] !== u || e[23] !== N ? (M = /* @__PURE__ */ g(Pr, { size: "trigger", align: u, children: N }), e[22] = u, e[23] = N, e[24] = M) : M = e[24];
  let T;
  return e[25] !== m || e[26] !== M || e[27] !== w ? (T = /* @__PURE__ */ F(ci, { open: m, onOpenChange: h, children: [
    w,
    M
  ] }), e[25] = m, e[26] = M, e[27] = w, e[28] = T) : T = e[28], T;
}
function oP(t) {
  return /* @__PURE__ */ g(Vd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function GD(t) {
  const e = B.c(33), {
    prefix: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = qb(u), [p, m] = qe(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Es();
  let v;
  e[4] !== o || e[5] !== d ? (v = o.find((k) => k.value === d)?.label ?? "", e[4] = o, e[5] = d, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== n ? (y = /* @__PURE__ */ g("span", { className: "text-text-subtle", children: n }), e[7] = n, e[8] = y) : y = e[8];
  let w;
  e[9] !== C ? (w = C && /* @__PURE__ */ F(Vt, { children: [
    " ",
    /* @__PURE__ */ g("span", { children: C })
  ] }), e[9] = C, e[10] = w) : w = e[10];
  let R;
  e[11] !== a || e[12] !== h || e[13] !== p || e[14] !== y || e[15] !== w || e[16] !== b ? (R = /* @__PURE__ */ g(jo, { render: /* @__PURE__ */ F(_a, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: [
    y,
    w
  ] }) }), e[11] = a, e[12] = h, e[13] = p, e[14] = y, e[15] = w, e[16] = b, e[17] = R) : R = e[17];
  const S = d ?? "";
  let E;
  e[18] !== f ? (E = (k) => {
    f(k), m(!1);
  }, e[18] = f, e[19] = E) : E = e[19];
  let N;
  e[20] !== o ? (N = o.map(rP), e[20] = o, e[21] = N) : N = e[21];
  let M;
  e[22] !== S || e[23] !== E || e[24] !== N ? (M = /* @__PURE__ */ g(_d, { value: S, onValueChange: E, children: N }), e[22] = S, e[23] = E, e[24] = N, e[25] = M) : M = e[25];
  let T;
  e[26] !== c || e[27] !== M ? (T = /* @__PURE__ */ g(Pr, { size: "trigger", align: c, children: M }), e[26] = c, e[27] = M, e[28] = T) : T = e[28];
  let P;
  return e[29] !== p || e[30] !== T || e[31] !== R ? (P = /* @__PURE__ */ F(ci, { open: p, onOpenChange: m, children: [
    R,
    T
  ] }), e[29] = p, e[30] = T, e[31] = R, e[32] = P) : P = e[32], P;
}
function rP(t) {
  return /* @__PURE__ */ g(Vd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function YD(t) {
  const e = B.c(13), {
    filters: n,
    onRemove: o,
    onClearAll: r,
    label: i
  } = t, s = i === void 0 ? "Filters:" : i;
  if (n.length === 0)
    return null;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtle", children: s }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  if (e[2] !== n || e[3] !== o) {
    let d;
    e[5] !== o ? (d = (f) => /* @__PURE__ */ g(Yv, { label: f.label, removeAriaLabel: f.removeAriaLabel, onClose: () => o(f.id) }, f.id), e[5] = o, e[6] = d) : d = e[6], a = n.map(d), e[2] = n, e[3] = o, e[4] = a;
  } else
    a = e[4];
  let c;
  e[7] !== r ? (c = /* @__PURE__ */ g(tn, { variant: "ghost", size: "sm", onClick: r, children: "Clear All" }), e[7] = r, e[8] = c) : c = e[8];
  let u;
  return e[9] !== l || e[10] !== a || e[11] !== c ? (u = /* @__PURE__ */ F("div", { "aria-live": "polite", className: "flex flex-wrap items-center gap-(--spacing-8)", children: [
    l,
    a,
    c
  ] }), e[9] = l, e[10] = a, e[11] = c, e[12] = u) : u = e[12], u;
}
function jD(t) {
  const e = B.c(13), {
    items: n,
    value: o,
    defaultValue: r,
    onValueChange: i,
    "aria-label": s
  } = t, l = s === void 0 ? "Filter views" : s;
  let a;
  e[0] !== i ? (a = (p) => i?.(p), e[0] = i, e[1] = a) : a = e[1];
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ne("inline-flex", "flex-wrap", "max-w-full", "items-center", "gap-[2px]", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface-container-high", "p-[2px]", "max-sm:gap-(--spacing-4)", "max-sm:p-(--spacing-4)"), e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = n.map(iP), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== l || e[6] !== u ? (d = /* @__PURE__ */ g(g1, { "aria-label": l, className: c, children: u }), e[5] = l, e[6] = u, e[7] = d) : d = e[7];
  let f;
  return e[8] !== r || e[9] !== a || e[10] !== d || e[11] !== o ? (f = /* @__PURE__ */ g(d1, { value: o, defaultValue: r, onValueChange: a, children: d }), e[8] = r, e[9] = a, e[10] = d, e[11] = o, e[12] = f) : f = e[12], f;
}
function iP(t) {
  return /* @__PURE__ */ F(m1, { value: t.value, disabled: t.disabled, "aria-label": t.count === void 0 ? t.label : `${t.label} ${t.count}`, className: ne("relative", "group", "inline-flex", "h-[28px]", "min-w-0", "items-center", "justify-center", "gap-(--spacing-6)", "rounded-(--radius-xs)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-text-subtle", "outline-none", "transition-[background-color,box-shadow]", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "focus-visible:[outline:2px_solid_hsl(var(--button-focus-ring))]", "focus-visible:[outline-offset:2px]", "data-[active]:bg-surface-container-lowest", "data-[active]:text-text-default", "data-[active]:shadow-elevation-1", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "max-sm:before:absolute", "max-sm:before:left-0", "max-sm:before:top-1/2", "max-sm:before:h-[44px]", "max-sm:before:min-w-[44px]", "max-sm:before:w-full", "max-sm:before:-translate-y-1/2", "max-sm:before:content-['']"), children: [
    /* @__PURE__ */ g("span", { className: "truncate", children: t.label }),
    t.count !== void 0 && /* @__PURE__ */ g("span", { className: "text-text-disabled group-data-[active]:text-text-subtle", children: t.count })
  ] }, t.value);
}
const ng = ne("border", "border-outline-subtle", "rounded-(--radius-sm)", "flex", "flex-col");
function KD(t) {
  const e = B.c(24);
  let n, o, r;
  e[0] !== t ? ({
    as: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "form" : r;
  let s, l, a, c;
  if (e[4] !== n) {
    const b = x.Children.toArray(n);
    s = b.find(Zb);
    const v = b.filter(sP);
    c = "overflow-hidden p-(--spacing-20)", l = "flex flex-col gap-(--spacing-20) w-full", a = x.Children.map(v, (C, y) => /* @__PURE__ */ F(Vt, { children: [
      C,
      y < v.length - 1 && /* @__PURE__ */ g(gr, { variant: "middle-inset" })
    ] })), e[4] = n, e[5] = s, e[6] = l, e[7] = a, e[8] = c;
  } else
    s = e[5], l = e[6], a = e[7], c = e[8];
  let u;
  e[9] !== l || e[10] !== a ? (u = /* @__PURE__ */ g("div", { className: l, children: a }), e[9] = l, e[10] = a, e[11] = u) : u = e[11];
  let d;
  e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[12] = c, e[13] = u, e[14] = d) : d = e[14];
  let f;
  e[15] !== s || e[16] !== d ? (f = /* @__PURE__ */ F(Vt, { children: [
    d,
    s
  ] }), e[15] = s, e[16] = d, e[17] = f) : f = e[17];
  const p = f;
  if (i === "div") {
    const b = o;
    let v;
    return e[18] !== p || e[19] !== b ? (v = /* @__PURE__ */ g("div", { className: ng, ...b, children: p }), e[18] = p, e[19] = b, e[20] = v) : v = e[20], v;
  }
  const m = o;
  let h;
  return e[21] !== p || e[22] !== m ? (h = /* @__PURE__ */ g("form", { className: ng, ...m, children: p }), e[21] = p, e[22] = m, e[23] = h) : h = e[23], h;
}
function sP(t) {
  return !Zb(t);
}
function Zb(t) {
  return x.isValidElement(t) && t.type === uP;
}
const lP = ae(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-text-default", "tracking-(--font-letter-spacing-default)", "shrink-0"], {
  variants: {
    variant: {
      main: ["text-(length:--font-size-title-xl)", "leading-(--font-line-height-28)"],
      subsection: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    }
  }
}), aP = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-text-subtext", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]);
function qD(t) {
  const e = B.c(30), {
    variant: n,
    title: o,
    description: r,
    titleAccessory: i,
    actions: s,
    children: l
  } = t, a = n === "main" ? "h2" : "h3", c = x.useId(), u = r != null, d = u ? `${c}-description` : void 0;
  let f;
  e[0] !== o ? (f = /* @__PURE__ */ g("legend", { className: "sr-only", children: o }), e[0] = o, e[1] = f) : f = e[1];
  let p;
  e[2] !== n ? (p = lP({
    variant: n
  }), e[2] = n, e[3] = p) : p = e[3];
  let m;
  e[4] !== a || e[5] !== p || e[6] !== o ? (m = /* @__PURE__ */ g(a, { className: p, children: o }), e[4] = a, e[5] = p, e[6] = o, e[7] = m) : m = e[7];
  const h = i != null && i;
  let b;
  e[8] !== m || e[9] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6)", children: [
    m,
    h
  ] }), e[8] = m, e[9] = h, e[10] = b) : b = e[10];
  let v;
  e[11] !== r || e[12] !== u || e[13] !== c ? (v = u && /* @__PURE__ */ g("p", { id: `${c}-description`, className: ne(aP(), "mt-(--spacing-6)"), children: r }), e[11] = r, e[12] = u, e[13] = c, e[14] = v) : v = e[14];
  let C;
  e[15] !== b || e[16] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex-1 min-w-0", children: [
    b,
    v
  ] }), e[15] = b, e[16] = v, e[17] = C) : C = e[17];
  let y;
  e[18] !== s ? (y = s != null && /* @__PURE__ */ g("div", { className: "shrink-0", children: s }), e[18] = s, e[19] = y) : y = e[19];
  let w;
  e[20] !== C || e[21] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-12)", children: [
    C,
    y
  ] }), e[20] = C, e[21] = y, e[22] = w) : w = e[22];
  let R;
  e[23] !== l ? (R = l != null && /* @__PURE__ */ g("div", { className: "mt-(--spacing-16) flex flex-col", children: l }), e[23] = l, e[24] = R) : R = e[24];
  let S;
  return e[25] !== d || e[26] !== w || e[27] !== R || e[28] !== f ? (S = /* @__PURE__ */ F("fieldset", { "aria-describedby": d, className: "border-0 p-0 m-0 min-w-0", children: [
    f,
    w,
    R
  ] }), e[25] = d, e[26] = w, e[27] = R, e[28] = f, e[29] = S) : S = e[29], S;
}
const cP = ne("font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-20)", "text-text-default", "text-(length:--font-size-label-lg)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap", "shrink-0");
function ZD(t) {
  const e = B.c(10), {
    columns: n
  } = t, [o, r] = n, i = n.length === 2 ? "justify-between" : "justify-center";
  let s;
  e[0] !== i ? (s = ne("flex w-[212px] items-start p-0", i), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(og, { column: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r != null && /* @__PURE__ */ g(og, { column: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  return e[6] !== s || e[7] !== l || e[8] !== a ? (c = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    a
  ] }), e[6] = s, e[7] = l, e[8] = a, e[9] = c) : c = e[9], c;
}
function og(t) {
  const e = B.c(7), {
    column: n
  } = t;
  let o;
  e[0] !== n.icon ? (o = n.icon != null && /* @__PURE__ */ g(We, { name: n.icon, size: "sm", "aria-hidden": !0 }), e[0] = n.icon, e[1] = o) : o = e[1];
  let r;
  e[2] !== n.label ? (r = /* @__PURE__ */ g("span", { className: cP, children: n.label }), e[2] = n.label, e[3] = r) : r = e[3];
  let i;
  return e[4] !== o || e[5] !== r ? (i = /* @__PURE__ */ F("div", { className: "flex flex-1 items-center justify-end gap-(--spacing-8) min-w-0 overflow-hidden", children: [
    o,
    r
  ] }), e[4] = o, e[5] = r, e[6] = i) : i = e[6], i;
}
function uP(t) {
  const e = B.c(18);
  let n, o, r;
  e[0] !== t ? ({
    leading: o,
    actions: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none h-[58px] w-full shrink-0 bg-gradient-to-b from-surface-0 to-surface mb-[-12px]" }), e[4] = i) : i = e[4];
  const s = o != null && n != null ? "sm:justify-between" : n != null ? "sm:justify-end" : "sm:justify-start";
  let l;
  e[5] !== s ? (l = ne("flex flex-col items-stretch gap-(--spacing-16) overflow-hidden border-t border-outline-subtle bg-surface p-(--spacing-16) shrink-0 rounded-b-(--radius-sm) sm:flex-row sm:items-center", s), e[5] = s, e[6] = l) : l = e[6];
  let a;
  e[7] !== o ? (a = o != null && /* @__PURE__ */ g("div", { className: "min-w-0 w-full sm:flex-1", children: o }), e[7] = o, e[8] = a) : a = e[8];
  let c;
  e[9] !== n ? (c = n != null && /* @__PURE__ */ g("div", { className: "flex flex-wrap items-center justify-end gap-(--spacing-16) self-end sm:flex-nowrap sm:self-auto sm:shrink-0", children: n }), e[9] = n, e[10] = c) : c = e[10];
  let u;
  e[11] !== l || e[12] !== a || e[13] !== c ? (u = /* @__PURE__ */ F("div", { className: l, children: [
    a,
    c
  ] }), e[11] = l, e[12] = a, e[13] = c, e[14] = u) : u = e[14];
  let d;
  return e[15] !== r || e[16] !== u ? (d = /* @__PURE__ */ F("footer", { role: "none", className: "sticky bottom-0 flex flex-col", ...r, children: [
    i,
    u
  ] }), e[15] = r, e[16] = u, e[17] = d) : d = e[17], d;
}
function XD(t) {
  const e = B.c(10);
  let n, o, r;
  e[0] !== t ? ({
    header: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== n ? (i = /* @__PURE__ */ g("main", { className: "flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-(--spacing-24)", children: n }), e[4] = n, e[5] = i) : i = e[5];
  let s;
  return e[6] !== o || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ F("div", { ...r, "data-slot": "full-page-layout", className: "flex h-dvh min-h-0 w-full flex-col overflow-hidden bg-surface", children: [
    o,
    i
  ] }), e[6] = o, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const dP = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), fP = ae(["pointer-events-none", "fixed", "inset-0", "flex", "flex-col", "gap-(--spacing-10)", "px-(--spacing-24)", "pt-(--spacing-20)", "pb-(--spacing-32)", "outline-none"]), pP = ae(["pointer-events-auto", "max-h-full", "max-w-full", "rounded-(--radius-sm)", "object-contain", "opacity-100", "transition-opacity", "duration-200", "ease-in-out", "starting:opacity-0", "motion-reduce:transition-none"]);
function QD(t) {
  const e = B.c(42), {
    open: n,
    onOpenChange: o,
    images: r,
    index: i,
    onIndexChange: s,
    "aria-label": l
  } = t, a = l === void 0 ? "Image viewer" : l, c = Kt(), u = r[i], d = r.length > 0;
  let f;
  e[0] !== d || e[1] !== r.length || e[2] !== i || e[3] !== s ? (f = () => {
    d && s((i - 1 + r.length) % r.length);
  }, e[0] = d, e[1] = r.length, e[2] = i, e[3] = s, e[4] = f) : f = e[4];
  const p = f;
  let m;
  e[5] !== d || e[6] !== r.length || e[7] !== i || e[8] !== s ? (m = () => {
    d && s((i + 1) % r.length);
  }, e[5] = d, e[6] = r.length, e[7] = i, e[8] = s, e[9] = m) : m = e[9];
  const h = m;
  let b;
  e[10] !== h || e[11] !== p ? (b = (O) => {
    O.altKey || O.ctrlKey || O.metaKey || (O.key === "ArrowLeft" && (O.preventDefault(), p()), O.key === "ArrowRight" && (O.preventDefault(), h()));
  }, e[10] = h, e[11] = p, e[12] = b) : b = e[12];
  const v = b;
  let C;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g(Ps, { "data-slot": "lightbox-scrim", className: ne(dP()) }), e[13] = C) : C = e[13];
  let y;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = ne(fP()), e[14] = y) : y = e[14];
  let w;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ g("div", { className: "pointer-events-auto self-end", children: /* @__PURE__ */ g(Qr, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Close", variant: "outline", size: "md" }) }) }), e[15] = w) : w = e[15];
  const R = !d;
  let S;
  e[16] !== p || e[17] !== R ? (S = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(gt, { icon: "arrow-left", "aria-label": "Previous image", variant: "outline", size: "md", disabled: R, onClick: p }) }), e[16] = p, e[17] = R, e[18] = S) : S = e[18];
  let E;
  e[19] !== u || e[20] !== i ? (E = u && /* @__PURE__ */ g("img", { src: u.src, alt: u.alt, className: ne(pP()) }, `${i}-${u.src}`), e[19] = u, e[20] = i, e[21] = E) : E = e[21];
  let N;
  e[22] !== E ? (N = /* @__PURE__ */ g("div", { "data-slot": "lightbox-image-container", className: "flex min-w-0 flex-1 self-stretch items-center justify-center", children: E }), e[22] = E, e[23] = N) : N = e[23];
  const M = !d;
  let T;
  e[24] !== h || e[25] !== M ? (T = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(gt, { icon: "arrow-right-regular", "aria-label": "Next image", variant: "outline", size: "md", disabled: M, onClick: h }) }), e[24] = h, e[25] = M, e[26] = T) : T = e[26];
  let P;
  e[27] !== N || e[28] !== T || e[29] !== S ? (P = /* @__PURE__ */ F("div", { className: "flex min-h-0 flex-1 items-center gap-(--spacing-24)", children: [
    S,
    N,
    T
  ] }), e[27] = N, e[28] = T, e[29] = S, e[30] = P) : P = e[30];
  let k;
  e[31] !== a || e[32] !== v || e[33] !== P ? (k = /* @__PURE__ */ g(yi, { className: "pointer-events-none fixed inset-0 z-[var(--z-layer-dialog)]", children: /* @__PURE__ */ F(bi, { "aria-label": a, "aria-modal": "true", "data-slot": "lightbox", className: y, onKeyDown: v, children: [
    w,
    P
  ] }) }), e[31] = a, e[32] = v, e[33] = P, e[34] = k) : k = e[34];
  let I;
  e[35] !== c || e[36] !== k ? (I = /* @__PURE__ */ F(Dr, { container: c, children: [
    C,
    k
  ] }), e[35] = c, e[36] = k, e[37] = I) : I = e[37];
  let D;
  return e[38] !== o || e[39] !== n || e[40] !== I ? (D = /* @__PURE__ */ g(vi, { open: n, onOpenChange: o, modal: !0, children: I }), e[38] = o, e[39] = n, e[40] = I, e[41] = D) : D = e[41], D;
}
const mP = ne("group relative flex  w-full flex-col items-stretch justify-center overflow-hidden", "min-w-0 flex-1", "border-0 border-b border-solid border-b-outline-subtle", "bg-surface", "p-(--spacing-16)", "text-left", "transition-colors duration-200 ease-in-out", "after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-(--spacing-4)", "after:bg-primary after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-['']", "data-[state=active]:bg-primary/8 data-[state=active]:after:opacity-100", "cursor-pointer", "hover:bg-surface-hover", "active:bg-surface-pressed", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring", "disabled:pointer-events-none disabled:opacity-50");
function JD(t) {
  const e = B.c(9);
  let n, o, r;
  e[0] !== t ? ({
    active: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? !1 : r, s = i ? "active" : "default";
  let l;
  return e[4] !== i || e[5] !== n || e[6] !== o || e[7] !== s ? (l = /* @__PURE__ */ g(Qn, { type: "button", "data-slot": "list-card", "data-state": s, "aria-pressed": i, className: mP, ...o, children: n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s, e[8] = l) : l = e[8], l;
}
const gP = ae(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), rg = ["inline-flex", "items-center", "gap-(--spacing-4)", "h-(--spacing-24)", "bg-chip-neutral-container", "text-chip-neutral-label", "rounded-(--radius-sm)", "px-(--spacing-6)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(number:--font-weight-medium)", "whitespace-nowrap", "overflow-hidden", "max-w-full", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"];
function Ic(t, e) {
  return t.find((n) => n.value === e)?.label ?? e;
}
function hP(t, e) {
  return e.flatMap((n) => {
    const o = t.find((r) => r.value === n);
    return o ? [o] : [];
  });
}
function e_(t) {
  const e = B.c(116), {
    options: n,
    value: o,
    onChange: r,
    defaultValue: i,
    placeholder: s,
    size: l,
    label: a,
    tooltip: c,
    required: u,
    description: d,
    error: f,
    disabled: p,
    readOnly: m,
    name: h,
    "data-testid": b,
    reserveSubtextSpace: v
  } = t, C = l === void 0 ? "md" : l, y = m === void 0 ? !1 : m, w = v === void 0 ? !0 : v, R = Kt(), S = nt(null), E = !!f, M = w || E || !!d, T = o !== void 0;
  let P;
  e[0] !== i ? (P = i ?? [], e[0] = i, e[1] = P) : P = e[1];
  const [k, I] = qe(P), [D, O] = qe(!1), V = D && !y;
  let _, L;
  e[2] !== y ? (_ = () => {
    y && O(!1);
  }, L = [y], e[2] = y, e[3] = _, e[4] = L) : (_ = e[3], L = e[4]), Rt(_, L);
  const A = T ? o : k;
  let $;
  e[5] !== A || e[6] !== n ? ($ = hP(n, A), e[5] = A, e[6] = n, e[7] = $) : $ = e[7];
  const Y = $;
  let z;
  e[8] !== A ? (z = {
    items: A
  }, e[8] = A, e[9] = z) : z = e[9];
  const {
    containerRef: H,
    measuringContainerRef: K,
    itemRefs: G,
    overflowRefs: q,
    visibleItems: ee,
    overflowCount: W
  } = Kd(z);
  let X;
  e[10] !== T || e[11] !== r ? (X = function($e) {
    const Te = $e.map(wP);
    T || I(Te), r?.(Te);
  }, e[10] = T, e[11] = r, e[12] = X) : X = e[12];
  const J = X;
  let re;
  e[13] !== a || e[14] !== u || e[15] !== c ? (re = a && /* @__PURE__ */ g(hi, { label: a, required: u, tooltip: c }), e[13] = a, e[14] = u, e[15] = c, e[16] = re) : re = e[16];
  let Q;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Q = (Oe, $e) => {
    if (!Oe && $e.reason === "item-press") {
      $e.cancel();
      return;
    }
    O(Oe);
  }, e[17] = Q) : Q = e[17];
  let ie;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = /* @__PURE__ */ g("div", {}), e[18] = ie) : ie = e[18];
  let ce;
  e[19] !== p || e[20] !== E || e[21] !== C ? (ce = ne(gP({
    size: C
  }), p ? "opacity-50 cursor-not-allowed" : "cursor-pointer", !E && "data-[readonly]:border-input-readonly-outline", E && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[19] = p, e[20] = E, e[21] = C, e[22] = ce) : ce = e[22];
  const oe = u || void 0, se = y ? -1 : void 0;
  let fe;
  e[23] !== y ? (fe = (Oe) => {
    y && Oe.preventDefault();
  }, e[23] = y, e[24] = fe) : fe = e[24];
  let be;
  e[25] !== A.length || e[26] !== p || e[27] !== n || e[28] !== W || e[29] !== y || e[30] !== ee ? (be = A.length > 0 && /* @__PURE__ */ F(Vt, { children: [
    ee.map((Oe) => y ? /* @__PURE__ */ g(Ln, { label: Ic(n, Oe), tone: "neutral" }, Oe) : /* @__PURE__ */ F(eb, { className: ne(rg), children: [
      /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: Ic(n, Oe) }),
      !p && /* @__PURE__ */ g(tb, { className: "inline-flex shrink-0 cursor-pointer items-center text-icon-secondary rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", "aria-label": "Remove", onMouseDown: vP, children: /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }) })
    ] }, Oe)),
    W > 0 && /* @__PURE__ */ g(Ln, { label: `+${W}`, tone: "neutral" })
  ] }), e[25] = A.length, e[26] = p, e[27] = n, e[28] = W, e[29] = y, e[30] = ee, e[31] = be) : be = e[31];
  const le = y ? a ?? "Select option" : a ? `Search ${a}` : "Search options", me = y ? -1 : void 0;
  let j;
  e[32] !== y ? (j = (Oe) => {
    y && Oe.preventDefault();
  }, e[32] = y, e[33] = j) : j = e[33];
  const te = !y && A.length === 0 ? s : void 0;
  let U;
  e[34] !== p || e[35] !== le || e[36] !== me || e[37] !== j || e[38] !== te ? (U = /* @__PURE__ */ g(Os, { "aria-label": le, className: "min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", disabled: p, tabIndex: me, onMouseDown: j, placeholder: te }), e[34] = p, e[35] = le, e[36] = me, e[37] = j, e[38] = te, e[39] = U) : U = e[39];
  let Z;
  e[40] !== H || e[41] !== be || e[42] !== U ? (Z = /* @__PURE__ */ F(J0, { ref: H, "data-multi-select-chips": "", className: "flex flex-1 min-w-0 items-center gap-(--spacing-4) cursor-[inherit]", children: [
    be,
    U
  ] }), e[40] = H, e[41] = be, e[42] = U, e[43] = Z) : Z = e[43];
  let ue;
  e[44] !== p || e[45] !== y ? (ue = !p && !y && /* @__PURE__ */ g(Jf, { className: "shrink-0 inline-flex items-center text-icon-secondary", "aria-label": "Clear all", onMouseDown: bP, children: /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }) }), e[44] = p, e[45] = y, e[46] = ue) : ue = e[46];
  let pe;
  e[47] !== b || e[48] !== y ? (pe = !y && /* @__PURE__ */ g("span", { "data-testid": b ? `${b}-trigger` : void 0, className: "shrink-0 text-input-text-default inline-flex transition-transform duration-200 [[data-popup-open]_&]:rotate-180", children: /* @__PURE__ */ g(We, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[47] = b, e[48] = y, e[49] = pe) : pe = e[49];
  let he;
  e[50] !== b || e[51] !== ce || e[52] !== oe || e[53] !== se || e[54] !== fe || e[55] !== Z || e[56] !== ue || e[57] !== pe ? (he = /* @__PURE__ */ F(Ia, { "data-testid": b, ref: S, render: ie, nativeButton: !1, className: ce, "aria-required": oe, tabIndex: se, onMouseDown: fe, children: [
    Z,
    ue,
    pe
  ] }), e[50] = b, e[51] = ce, e[52] = oe, e[53] = se, e[54] = fe, e[55] = Z, e[56] = ue, e[57] = pe, e[58] = he) : he = e[58];
  let Ie;
  e[59] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ie = ui({
    size: "auto"
  }), e[59] = Ie) : Ie = e[59];
  const ye = b ? `${b}-options` : void 0;
  let xe;
  e[60] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = (Oe) => {
    Oe.key === "Escape" && O(!1);
  }, e[60] = xe) : xe = e[60];
  let de;
  e[61] !== A ? (de = (Oe) => {
    const $e = A.includes(Oe.value);
    return /* @__PURE__ */ g(_s, { value: Oe, disabled: Oe.disabled, className: Oo({}), children: /* @__PURE__ */ g(Xr, { checked: $e, checkbox: !0, children: Oe.label }) }, Oe.value);
  }, e[61] = A, e[62] = de) : de = e[62];
  let we;
  e[63] !== ye || e[64] !== de ? (we = /* @__PURE__ */ g(Ds, { "data-testid": ye, className: "flex flex-col outline-none", onKeyDownCapture: xe, children: de }), e[63] = ye, e[64] = de, e[65] = we) : we = e[65];
  let Me;
  e[66] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Me = /* @__PURE__ */ g(Qf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[66] = Me) : Me = e[66];
  let Re;
  e[67] !== we ? (Re = /* @__PURE__ */ g(Ma, { anchor: S, align: "start", sideOffset: 4, className: "z-[var(--z-layer-popover)] w-(--anchor-width)", children: /* @__PURE__ */ F(Ta, { className: Ie, children: [
    we,
    Me
  ] }) }), e[67] = we, e[68] = Re) : Re = e[68];
  let Ve;
  e[69] !== R || e[70] !== Re ? (Ve = /* @__PURE__ */ g(Pa, { container: R, children: Re }), e[69] = R, e[70] = Re, e[71] = Ve) : Ve = e[71];
  let je;
  if (e[72] !== G || e[73] !== A || e[74] !== p || e[75] !== n || e[76] !== y) {
    let Oe;
    e[78] !== G || e[79] !== p || e[80] !== n || e[81] !== y ? (Oe = ($e, Te) => /* @__PURE__ */ g("span", { ref: (vt) => {
      G.current[Te] = vt;
    }, "data-label": Ic(n, $e), "data-multi-select-measure": "chip", "data-multi-select-measure-index": Te, className: ne(rg, "max-w-none before:content-[attr(data-label)]"), children: !p && !y && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center text-icon-secondary", children: /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }) }) }, `chip-measure-${$e}`), e[78] = G, e[79] = p, e[80] = n, e[81] = y, e[82] = Oe) : Oe = e[82], je = A.map(Oe), e[72] = G, e[73] = A, e[74] = p, e[75] = n, e[76] = y, e[77] = je;
  } else
    je = e[77];
  let Ze;
  if (e[83] !== A || e[84] !== q) {
    let Oe;
    e[86] !== q ? (Oe = ($e, Te) => {
      const vt = Te + 1;
      return /* @__PURE__ */ g("span", { ref: (st) => {
        q.current[vt] = st;
      }, "data-label": `+${vt}`, "data-multi-select-measure": "overflow", "data-multi-select-measure-count": vt, className: "inline-flex items-center justify-center max-w-none gap-(--spacing-4) h-(--spacing-24) rounded-(--radius-sm) overflow-hidden font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-20) font-(--font-weight-medium) whitespace-nowrap bg-chip-neutral-container text-chip-neutral-label px-(--spacing-6) py-(--spacing-4) before:content-[attr(data-label)]" }, `overflow-measure-${vt}`);
    }, e[86] = q, e[87] = Oe) : Oe = e[87], Ze = A.slice(1).map(Oe), e[83] = A, e[84] = q, e[85] = Ze;
  } else
    Ze = e[85];
  let ze;
  e[88] !== K || e[89] !== je || e[90] !== Ze ? (ze = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ F("div", { ref: K, className: "inline-flex w-max items-center gap-(--spacing-4)", children: [
    je,
    Ze
  ] }) }), e[88] = K, e[89] = je, e[90] = Ze, e[91] = ze) : ze = e[91];
  let Ee;
  e[92] !== p || e[93] !== J || e[94] !== V || e[95] !== h || e[96] !== n || e[97] !== y || e[98] !== u || e[99] !== Y || e[100] !== he || e[101] !== Ve || e[102] !== ze ? (Ee = /* @__PURE__ */ F(zf, { multiple: !0, value: Y, onValueChange: J, disabled: p, readOnly: y, required: u, name: h, modal: !1, open: V, onOpenChange: Q, items: n, isItemEqualToValue: CP, itemToStringLabel: xP, itemToStringValue: yP, children: [
    he,
    Ve,
    ze
  ] }), e[92] = p, e[93] = J, e[94] = V, e[95] = h, e[96] = n, e[97] = y, e[98] = u, e[99] = Y, e[100] = he, e[101] = Ve, e[102] = ze, e[103] = Ee) : Ee = e[103];
  let Ae;
  e[104] !== d || e[105] !== f || e[106] !== E || e[107] !== w || e[108] !== M ? (Ae = M && /* @__PURE__ */ g("div", { "data-testid": "multi-select-subtext-row", className: ne("mt-(--spacing-4)", w && "min-h-(--spacing-20)"), children: E ? /* @__PURE__ */ g(Or, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: f }) : d ? /* @__PURE__ */ g(mi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: d }) : null }), e[104] = d, e[105] = f, e[106] = E, e[107] = w, e[108] = M, e[109] = Ae) : Ae = e[109];
  let Pe;
  return e[110] !== p || e[111] !== E || e[112] !== re || e[113] !== Ee || e[114] !== Ae ? (Pe = /* @__PURE__ */ F(Tr, { invalid: E, disabled: p, className: "relative flex flex-col w-full", children: [
    re,
    Ee,
    Ae
  ] }), e[110] = p, e[111] = E, e[112] = re, e[113] = Ee, e[114] = Ae, e[115] = Pe) : Pe = e[115], Pe;
}
function bP(t) {
  return t.stopPropagation();
}
function vP(t) {
  return t.stopPropagation();
}
function yP(t) {
  return t.value;
}
function xP(t) {
  return t.label;
}
function CP(t, e) {
  return t.value === e.value;
}
function wP(t) {
  return t.value;
}
const SP = [10, 25, 50, 100], Xb = {
  rowsPerPage: "Rows per page",
  ariaLabel: "Table pagination",
  previousPage: "Previous page",
  nextPage: "Next page",
  formatCurrentPageLabel: (t) => `Page ${t}, current page`,
  formatGoToPageLabel: (t) => `Go to page ${t}`,
  formatRange: (t, e, n) => `${t} - ${e} of ${n}`
};
function RP(t) {
  return t ?? Xb;
}
function Xo(t, e) {
  return Number.isFinite(t) && t > 0 ? Math.floor(t) : e;
}
function wi(t, e) {
  const n = Xo(e, 1), o = Xo(t, 1);
  return Math.min(Math.max(o, 1), n);
}
function Qb(t, e) {
  const n = Xo(e, 1), o = wi(t, n);
  return n === 1 ? "none" : o === 1 ? "right" : o === n ? "left" : "both";
}
function EP(t, e) {
  const n = Xo(e, 1), o = wi(t, n);
  return n <= 4 ? Array.from({
    length: n
  }, (r, i) => ({
    type: "page",
    page: i + 1
  })) : o <= 3 ? [{
    type: "page",
    page: 1
  }, {
    type: "page",
    page: 2
  }, {
    type: "page",
    page: 3
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }] : o >= n - 2 ? [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: n - 2
  }, {
    type: "page",
    page: n - 1
  }, {
    type: "page",
    page: n
  }] : [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: o - 1
  }, {
    type: "page",
    page: o
  }, {
    type: "page",
    page: o + 1
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }];
}
function NP({
  currentPage: t,
  rowsPerPage: e,
  totalItems: n,
  totalPages: o,
  formatRange: r
}) {
  const i = Math.max(0, Math.floor(n)), s = r ?? Xb.formatRange;
  if (i === 0)
    return s(0, 0, 0);
  const l = Xo(e, i), a = wi(t, o), c = (a - 1) * l + 1, u = Math.min(a * l, i);
  return s(c, u, i);
}
function Xl(t) {
  const e = B.c(11), {
    direction: n,
    disabled: o,
    mobile: r,
    labels: i,
    onClick: s
  } = t, l = r === void 0 ? !1 : r, a = n === "previous", c = a ? i.previousPage : i.nextPage, u = l ? "size-[44px]" : "size-(--spacing-32)", d = o ? "cursor-default text-icon-disabled" : "cursor-pointer text-surface-on-surface hover:bg-surface-hover active:bg-surface-pressed";
  let f;
  e[0] !== u || e[1] !== d ? (f = ne("inline-flex shrink-0 items-center justify-center rounded-(--radius-sm) border-0 bg-transparent p-0 outline-none transition-colors duration-200 ease-in-out", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", u, d), e[0] = u, e[1] = d, e[2] = f) : f = e[2];
  const p = a ? "chevron-left" : "chevron-right";
  let m;
  e[3] !== p ? (m = /* @__PURE__ */ g(We, { name: p, size: "xs", tone: "inherit" }), e[3] = p, e[4] = m) : m = e[4];
  let h;
  return e[5] !== o || e[6] !== s || e[7] !== c || e[8] !== f || e[9] !== m ? (h = /* @__PURE__ */ g("button", { type: "button", "aria-label": c, disabled: o, onClick: s, className: f, children: m }), e[5] = o, e[6] = s, e[7] = c, e[8] = f, e[9] = m, e[10] = h) : h = e[10], h;
}
function ig(t) {
  const e = B.c(29), {
    currentPage: n,
    totalPages: o,
    labels: r,
    onPageChange: i,
    showPageIndicator: s
  } = t, l = s === void 0 ? !1 : s;
  let a, c, u;
  e[0] !== n || e[1] !== o ? (c = Xo(o, 1), a = wi(n, c), u = Qb(a, c), e[0] = n, e[1] = o, e[2] = a, e[3] = c, e[4] = u) : (a = e[2], c = e[3], u = e[4]);
  const d = u, f = d === "both" || d === "left", p = d === "both" || d === "right", m = !f;
  let h;
  e[5] !== i || e[6] !== a ? (h = () => i(a - 1), e[5] = i, e[6] = a, e[7] = h) : h = e[7];
  let b;
  e[8] !== r || e[9] !== m || e[10] !== h ? (b = /* @__PURE__ */ g(Xl, { direction: "previous", disabled: m, labels: r, onClick: h }), e[8] = r, e[9] = m, e[10] = h, e[11] = b) : b = e[11];
  let v;
  e[12] !== r || e[13] !== i || e[14] !== a || e[15] !== c || e[16] !== l ? (v = l && /* @__PURE__ */ g(kP, { currentPage: a, totalPages: c, labels: r, onPageChange: i }), e[12] = r, e[13] = i, e[14] = a, e[15] = c, e[16] = l, e[17] = v) : v = e[17];
  const C = !p;
  let y;
  e[18] !== i || e[19] !== a ? (y = () => i(a + 1), e[18] = i, e[19] = a, e[20] = y) : y = e[20];
  let w;
  e[21] !== r || e[22] !== C || e[23] !== y ? (w = /* @__PURE__ */ g(Xl, { direction: "next", disabled: C, labels: r, onClick: y }), e[21] = r, e[22] = C, e[23] = y, e[24] = w) : w = e[24];
  let R;
  return e[25] !== b || e[26] !== v || e[27] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-center gap-(--spacing-12)", children: [
    b,
    v,
    w
  ] }), e[25] = b, e[26] = v, e[27] = w, e[28] = R) : R = e[28], R;
}
function kP(t) {
  const e = B.c(11), {
    currentPage: n,
    totalPages: o,
    labels: r,
    onPageChange: i
  } = t;
  let s;
  if (e[0] !== n || e[1] !== r || e[2] !== i || e[3] !== o) {
    let a;
    e[5] !== n || e[6] !== r || e[7] !== i ? (a = (c) => {
      if (c.type === "ellipsis")
        return /* @__PURE__ */ g(IP, {}, c.key);
      const u = c.page === n;
      return /* @__PURE__ */ g("button", { type: "button", "aria-label": u ? r.formatCurrentPageLabel(c.page) : r.formatGoToPageLabel(c.page), "aria-current": u ? "page" : void 0, onClick: () => i(c.page), className: ne("inline-flex min-w-(--spacing-20) items-center justify-center rounded-(--radius-sm) px-(--spacing-6) py-(--spacing-2)", "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20)", "outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", u ? "bg-primary text-primary-on-primary" : "cursor-pointer text-text-subtle hover:bg-surface-hover active:bg-surface-pressed"), children: c.page }, c.page);
    }, e[5] = n, e[6] = r, e[7] = i, e[8] = a) : a = e[8], s = EP(n, o).map(a), e[0] = n, e[1] = r, e[2] = i, e[3] = o, e[4] = s;
  } else
    s = e[4];
  let l;
  return e[9] !== s ? (l = /* @__PURE__ */ g("div", { className: "flex items-center justify-center gap-(--spacing-10)", children: s }), e[9] = s, e[10] = l) : l = e[10], l;
}
function IP() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("span", { className: "select-none whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-default", children: "..." }), t[0] = e) : e = t[0], e;
}
function PP(t) {
  const e = B.c(17), {
    selectId: n,
    rowsPerPage: o,
    rowsPerPageOptions: r,
    rowsPerPageLabel: i,
    disabled: s,
    onRowsPerPageChange: l,
    onPageChange: a
  } = t, c = s === void 0 ? !1 : s;
  let u;
  e[0] !== i || e[1] !== n ? (u = /* @__PURE__ */ g("label", { htmlFor: n, className: "whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: i }), e[0] = i, e[1] = n, e[2] = u) : u = e[2];
  const d = String(o);
  let f;
  e[3] !== r ? (f = r.map(MP), e[3] = r, e[4] = f) : f = e[4];
  let p;
  e[5] !== a || e[6] !== l ? (p = (b) => {
    b != null && (l(Number(b)), a(1));
  }, e[5] = a, e[6] = l, e[7] = p) : p = e[7];
  let m;
  e[8] !== c || e[9] !== n || e[10] !== d || e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ g("div", { className: "h-(--spacing-32) w-(--spacing-80) shrink-0", children: /* @__PURE__ */ g(ob, { id: n, size: "sm", value: d, disabled: c, reserveSubtextSpace: !1, options: f, onChange: p }) }), e[8] = c, e[9] = n, e[10] = d, e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  let h;
  return e[14] !== u || e[15] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex h-(--spacing-40) w-[188px] shrink-0 items-center justify-between gap-(--spacing-12)", children: [
    u,
    m
  ] }), e[14] = u, e[15] = m, e[16] = h) : h = e[16], h;
}
function MP(t) {
  return {
    value: String(t),
    label: String(t)
  };
}
function TP(t) {
  const e = B.c(24), {
    rangeLabel: n,
    currentPage: o,
    totalPages: r,
    labels: i,
    onPageChange: s
  } = t;
  let l, a;
  if (e[0] !== o || e[1] !== r) {
    const w = Xo(r, 1);
    l = wi(o, w), a = Qb(l, w), e[0] = o, e[1] = r, e[2] = l, e[3] = a;
  } else
    l = e[2], a = e[3];
  const c = a, u = c === "both" || c === "left", d = c === "both" || c === "right", f = !u;
  let p;
  e[4] !== s || e[5] !== l ? (p = () => s(l - 1), e[4] = s, e[5] = l, e[6] = p) : p = e[6];
  let m;
  e[7] !== i || e[8] !== f || e[9] !== p ? (m = /* @__PURE__ */ g(Xl, { direction: "previous", mobile: !0, disabled: f, labels: i, onClick: p }), e[7] = i, e[8] = f, e[9] = p, e[10] = m) : m = e[10];
  let h;
  e[11] !== n ? (h = /* @__PURE__ */ g("span", { className: "min-w-0 truncate px-(--spacing-12) text-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = h) : h = e[12];
  const b = !d;
  let v;
  e[13] !== s || e[14] !== l ? (v = () => s(l + 1), e[13] = s, e[14] = l, e[15] = v) : v = e[15];
  let C;
  e[16] !== i || e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ g(Xl, { direction: "next", mobile: !0, disabled: b, labels: i, onClick: v }), e[16] = i, e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  return e[20] !== m || e[21] !== h || e[22] !== C ? (y = /* @__PURE__ */ F("div", { className: "hidden h-[44px] w-full items-center justify-between px-(--spacing-16) @max-[600px]/pagination:flex", children: [
    m,
    h,
    C
  ] }), e[20] = m, e[21] = h, e[22] = C, e[23] = y) : y = e[23], y;
}
function OP(t) {
  const e = B.c(33), {
    currentPage: n,
    totalPages: o,
    totalItems: r,
    rowsPerPage: i,
    onPageChange: s,
    labels: l
  } = t, a = At();
  let c, u, d, f, p;
  e[0] !== n || e[1] !== l || e[2] !== i || e[3] !== r || e[4] !== o ? (c = RP(l), f = Xo(o, 1), d = wi(n, f), u = r <= 0, p = NP({
    currentPage: d,
    rowsPerPage: i,
    totalItems: r,
    totalPages: f,
    formatRange: c.formatRange
  }), e[0] = n, e[1] = l, e[2] = i, e[3] = r, e[4] = o, e[5] = c, e[6] = u, e[7] = d, e[8] = f, e[9] = p) : (c = e[5], u = e[6], d = e[7], f = e[8], p = e[9]);
  const m = p;
  let h;
  e[10] !== s || e[11] !== m || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ g(TP, { rangeLabel: m, currentPage: d, totalPages: f, labels: c, onPageChange: s }), e[10] = s, e[11] = m, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== s || e[17] !== t.contextLabel || e[18] !== t.onRowsPerPageChange || e[19] !== t.rowsPerPageOptions || e[20] !== t.variant || e[21] !== m || e[22] !== c || e[23] !== i || e[24] !== u || e[25] !== a || e[26] !== d || e[27] !== f ? (b = t.variant === "simplified" ? /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) @min-[600px]/pagination:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: t.contextLabel }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(ig, { currentPage: d, totalPages: f, labels: c, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "h-(--spacing-40) flex-1" })
  ] }) : /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) @min-[600px]/pagination:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: m }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(ig, { currentPage: d, totalPages: f, labels: c, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ g(PP, { selectId: a, rowsPerPage: i, rowsPerPageOptions: t.rowsPerPageOptions ?? SP, rowsPerPageLabel: c.rowsPerPage, disabled: u, onRowsPerPageChange: t.onRowsPerPageChange, onPageChange: s }) })
  ] }), e[16] = s, e[17] = t.contextLabel, e[18] = t.onRowsPerPageChange, e[19] = t.rowsPerPageOptions, e[20] = t.variant, e[21] = m, e[22] = c, e[23] = i, e[24] = u, e[25] = a, e[26] = d, e[27] = f, e[28] = b) : b = e[28];
  let v;
  return e[29] !== c.ariaLabel || e[30] !== h || e[31] !== b ? (v = /* @__PURE__ */ F("nav", { "aria-label": c.ariaLabel, className: "@container/pagination w-full", children: [
    h,
    b
  ] }), e[29] = c.ariaLabel, e[30] = h, e[31] = b, e[32] = v) : v = e[32], v;
}
const sg = /* @__PURE__ */ new Map();
function DP(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = sg.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return sg.set(n, r), r;
}
function lg(t, e, n) {
  return t == null ? "" : DP(e, n).format(t);
}
function _P(t, e, n) {
  return t == null ? "" : n ? lg(t, e, n) : lg(t / 100, e, {
    style: "percent"
  });
}
const h1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (h1.displayName = "ProgressRootContext");
function Jb() {
  const t = x.useContext(h1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : tt(51));
  return t;
}
let Pc = /* @__PURE__ */ (function(t) {
  return t.complete = "data-complete", t.indeterminate = "data-indeterminate", t.progressing = "data-progressing", t;
})({});
const b1 = {
  status(t) {
    return t === "progressing" ? {
      [Pc.progressing]: ""
    } : t === "complete" ? {
      [Pc.complete]: ""
    } : t === "indeterminate" ? {
      [Pc.indeterminate]: ""
    } : null;
  }
};
function VP(t, e) {
  return e == null ? "indeterminate progress" : t || `${e}%`;
}
const v1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    format: o,
    getAriaValueText: r = VP,
    locale: i,
    max: s = 100,
    min: l = 0,
    value: a,
    render: c,
    className: u,
    children: d,
    style: f,
    ...p
  } = e, [m, h] = x.useState(), b = Ht(o);
  let v = "indeterminate";
  Number.isFinite(a) && (v = a === s ? "complete" : "progressing");
  const C = _P(a, i, b.current), y = x.useMemo(() => ({
    status: v
  }), [v]), w = {
    "aria-labelledby": m,
    "aria-valuemax": s,
    "aria-valuemin": l,
    "aria-valuenow": a ?? void 0,
    "aria-valuetext": r(C, a),
    role: "progressbar",
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [d, /* @__PURE__ */ g("span", {
        role: "presentation",
        style: er,
        children: "x"
      })]
    })
  }, R = x.useMemo(() => ({
    formattedValue: C,
    max: s,
    min: l,
    setLabelId: h,
    state: y,
    status: v,
    value: a
  }), [C, s, l, h, y, v, a]), S = Le("div", e, {
    state: y,
    ref: n,
    props: [w, p],
    stateAttributesMapping: b1
  });
  return /* @__PURE__ */ g(h1.Provider, {
    value: R,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (v1.displayName = "ProgressRoot");
const e3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = Jb();
  return Le("div", e, {
    state: l,
    ref: n,
    props: s,
    stateAttributesMapping: b1
  });
});
process.env.NODE_ENV !== "production" && (e3.displayName = "ProgressTrack");
function AP(t, e, n) {
  return (t - e) * 100 / (n - e);
}
const t3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    max: l,
    min: a,
    value: c,
    state: u
  } = Jb(), d = Number.isFinite(c) && c !== null ? AP(c, a, l) : null, f = x.useCallback(() => d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  }, [d]);
  return Le("div", e, {
    state: u,
    ref: n,
    props: [{
      style: f()
    }, s],
    stateAttributesMapping: b1
  });
});
process.env.NODE_ENV !== "production" && (t3.displayName = "ProgressIndicator");
const LP = {
  sm: "2px",
  md: "4px",
  lg: "8px"
}, FP = {
  brand: "bg-primary",
  positive: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  negative: "bg-datavis-crit-red"
};
function t_(t) {
  const e = B.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    value: l,
    size: i,
    tone: s,
    "aria-label": n,
    "aria-labelledby": o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "md" : i, c = s === void 0 ? "brand" : s;
  let u;
  e[7] !== l ? (u = Number.isFinite(l) ? Math.min(100, Math.max(0, l)) : 0, e[7] = l, e[8] = u) : u = e[8];
  const d = u, f = LP[a];
  let p;
  e[9] !== f ? (p = {
    height: f
  }, e[9] = f, e[10] = p) : p = e[10];
  const m = `absolute ${FP[c]}`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g(t3, { className: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  e[13] !== p || e[14] !== h ? (b = /* @__PURE__ */ g(e3, { className: "relative w-full overflow-hidden bg-[hsl(var(--surface-inverse-surface)/0.2)]", style: p, children: h }), e[13] = p, e[14] = h, e[15] = b) : b = e[15];
  let v;
  return e[16] !== n || e[17] !== o || e[18] !== d || e[19] !== r || e[20] !== b ? (v = /* @__PURE__ */ g(v1, { ...r, value: d, "aria-label": n, "aria-labelledby": o, children: b }), e[16] = n, e[17] = o, e[18] = d, e[19] = r, e[20] = b, e[21] = v) : v = e[21], v;
}
const $P = {
  sm: {
    diameter: 16,
    stroke: 3
  },
  md: {
    diameter: 36,
    stroke: 5
  },
  lg: {
    diameter: 56,
    stroke: 7
  }
}, HP = {
  brand: "stroke-primary",
  positive: "stroke-datavis-crit-green",
  warning: "stroke-datavis-crit-yellow",
  negative: "stroke-datavis-crit-red"
};
function n_(t) {
  const e = B.c(40);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    value: a,
    size: s,
    tone: l,
    "aria-label": n,
    "aria-labelledby": o,
    style: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "md" : s, u = l === void 0 ? "brand" : l;
  let d;
  e[8] !== a ? (d = Number.isFinite(a) ? Math.min(100, Math.max(0, a)) : 0, e[8] = a, e[9] = d) : d = e[9];
  const f = d, {
    diameter: p,
    stroke: m
  } = $P[c], h = (p - m) / 2, b = 2 * Math.PI * h, v = b * (1 - f / 100), C = p / 2;
  let y;
  e[10] !== p ? (y = {
    display: "inline-flex",
    width: p,
    height: p
  }, e[10] = p, e[11] = y) : y = e[11];
  const w = y;
  let R;
  e[12] !== w || e[13] !== i ? (R = typeof i == "function" ? (V) => ({
    ...i(V),
    ...w
  }) : {
    ...i,
    ...w
  }, e[12] = w, e[13] = i, e[14] = R) : R = e[14];
  const S = R, E = `0 0 ${p} ${p}`;
  let N;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = {
    stroke: "hsl(var(--surface-inverse-surface) / 0.2)"
  }, e[15] = N) : N = e[15];
  let M;
  e[16] !== C || e[17] !== h || e[18] !== m ? (M = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", style: N }), e[16] = C, e[17] = h, e[18] = m, e[19] = M) : M = e[19];
  const T = `${b} ${b}`, P = HP[u];
  let k;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = {
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%"
  }, e[20] = k) : k = e[20];
  let I;
  e[21] !== C || e[22] !== v || e[23] !== h || e[24] !== m || e[25] !== P || e[26] !== T ? (I = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", strokeDasharray: T, strokeDashoffset: v, className: P, style: k }), e[21] = C, e[22] = v, e[23] = h, e[24] = m, e[25] = P, e[26] = T, e[27] = I) : I = e[27];
  let D;
  e[28] !== p || e[29] !== I || e[30] !== E || e[31] !== M ? (D = /* @__PURE__ */ F("svg", { width: p, height: p, viewBox: E, fill: "none", "aria-hidden": "true", children: [
    M,
    I
  ] }), e[28] = p, e[29] = I, e[30] = E, e[31] = M, e[32] = D) : D = e[32];
  let O;
  return e[33] !== n || e[34] !== o || e[35] !== f || e[36] !== r || e[37] !== S || e[38] !== D ? (O = /* @__PURE__ */ g(v1, { ...r, value: f, "aria-label": n, "aria-labelledby": o, style: S, children: D }), e[33] = n, e[34] = o, e[35] = f, e[36] = r, e[37] = S, e[38] = D, e[39] = O) : O = e[39], O;
}
let ag = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const yu = {
  checked(t) {
    return t ? {
      [ag.checked]: ""
    } : {
      [ag.unchecked]: ""
    };
  },
  ...Bt,
  ...to
}, y1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (y1.displayName = "RadioGroupContext");
function zP() {
  return x.useContext(y1);
}
const x1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (x1.displayName = "RadioRootContext");
function BP() {
  const t = x.useContext(x1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : tt(52));
  return t;
}
const n3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    readOnly: s = !1,
    required: l = !1,
    "aria-labelledby": a,
    value: c,
    inputRef: u,
    nativeButton: d = !1,
    id: f,
    style: p,
    ...m
  } = e, h = zP(), {
    disabled: b,
    readOnly: v,
    required: C,
    form: y,
    checkedValue: w,
    touched: R = !1,
    validation: S,
    name: E
  } = h ?? {}, N = h?.setCheckedValue ?? xt, M = h?.setTouched ?? xt, T = h?.registerControlRef ?? xt, P = h?.registerInputRef ?? xt, {
    setDirty: k,
    validityData: I,
    setTouched: D,
    setFilled: O,
    state: V,
    disabled: _
  } = on(), L = H2(), {
    labelId: A,
    getDescriptionProps: $
  } = hn(), Y = _ || L.disabled || b || i, z = v || s, H = C || l, K = y, G = h ? w === c : c === "", q = x.useMemo(() => jl(c), [c]), ee = x.useRef(null), W = x.useRef(null), X = Ce((ue) => {
    ue && T(ue, Y);
  }), J = mn(u, W, P);
  Ne(() => {
    W.current?.checked && O(!0);
  }, [O]), Ne(() => {
    if (W.current) {
      if (Y && G) {
        P(null);
        return;
      }
      ee.current && T(ee.current, Y), P(W.current);
    }
  }, [G, Y, T, P]);
  const re = It(), Q = Mr({
    id: f,
    implicit: !1,
    controlRef: ee
  }), ie = d ? void 0 : Q, ce = nf(a, A, W, !d, ie), oe = {
    role: "radio",
    "aria-checked": G,
    "aria-required": H || void 0,
    "aria-readonly": z || void 0,
    "aria-labelledby": ce,
    [f1]: G ? "" : void 0,
    id: d ? Q : re,
    onKeyDown(ue) {
      ue.key === "Enter" && ue.preventDefault();
    },
    onClick(ue) {
      ue.defaultPrevented || Y || z || (ue.preventDefault(), W.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ue.shiftKey,
        ctrlKey: ue.ctrlKey,
        altKey: ue.altKey,
        metaKey: ue.metaKey
      })));
    },
    onFocus(ue) {
      ue.defaultPrevented || Y || z || !R || (W.current?.click(), M(!1));
    }
  }, {
    getButtonProps: se,
    buttonRef: fe
  } = Wt({
    disabled: Y,
    native: d
  }), be = {
    type: "radio",
    ref: J,
    form: K,
    id: ie,
    name: E,
    tabIndex: -1,
    style: E ? ni : er,
    "aria-hidden": !0,
    ...c !== void 0 ? {
      value: q
    } : St,
    disabled: Y,
    checked: G,
    required: H,
    readOnly: z,
    onChange(ue) {
      if (ue.nativeEvent.defaultPrevented || Y || z || c === void 0)
        return;
      const pe = _e(Mt, ue.nativeEvent);
      pe.isCanceled || (D(!0), k(c !== I.initialValue), O(!0), N(c, pe));
    },
    onFocus() {
      ee.current?.focus();
    }
  }, le = x.useMemo(() => ({
    ...V,
    required: H,
    disabled: Y,
    readOnly: z,
    checked: G
  }), [V, Y, z, G, H]), me = le, j = h !== void 0, te = [n, ee, fe, X], U = [oe, $, S?.getValidationProps ?? St, m, se], Z = Le("span", e, {
    enabled: !j,
    state: le,
    ref: te,
    props: U,
    stateAttributesMapping: yu
  });
  return /* @__PURE__ */ F(x1.Provider, {
    value: me,
    children: [j ? /* @__PURE__ */ g(Td, {
      tag: "span",
      render: o,
      className: r,
      style: p,
      state: le,
      refs: te,
      props: U,
      stateAttributesMapping: yu
    }) : Z, /* @__PURE__ */ g("input", {
      ...be,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (n3.displayName = "RadioRoot");
const o3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = BP(), c = a.checked, {
    mounted: u,
    transitionStatus: d,
    setMounted: f
  } = Xn(c), p = {
    ...a,
    transitionStatus: d
  }, m = x.useRef(null), h = s || u, b = Le("span", e, {
    ref: [n, m],
    state: p,
    props: l,
    stateAttributesMapping: yu
  });
  return jt({
    open: c,
    ref: m,
    onComplete() {
      c || f(!1);
    }
  }), h ? b : null;
});
process.env.NODE_ENV !== "production" && (o3.displayName = "RadioIndicator");
const WP = [e2], r3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i,
    readOnly: s,
    required: l,
    onValueChange: a,
    value: c,
    defaultValue: u,
    form: d,
    name: f,
    inputRef: p,
    id: m,
    style: h,
    ...b
  } = e, {
    setTouched: v,
    setFocused: C,
    shouldValidateOnChange: y,
    validationMode: w,
    name: R,
    disabled: S,
    state: E,
    validation: N,
    setDirty: M,
    setFilled: T,
    validityData: P
  } = on(), {
    labelId: k
  } = hn(), {
    clearErrors: I
  } = Vo(), D = _2(!0), O = S || i, V = R ?? f, _ = It(m), [L, A] = pn({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), $ = Ce(a), Y = Ce((oe, se) => {
    $(oe, se), !se.isCanceled && A(oe);
  }), z = x.useRef(null), H = x.useRef(null), K = x.useRef(null);
  function G(oe) {
    let se;
    return p && (typeof p == "function" ? se = p(oe) : p.current = oe), H.current = oe, N.inputRef.current = oe, se;
  }
  const q = Ce((oe, se = !1) => {
    if (oe) {
      if (se) {
        z.current === oe && (z.current = null);
        return;
      }
      z.current == null && (z.current = oe);
    }
  }), ee = Ce((oe) => {
    if (!oe || oe.disabled)
      return;
    K.current || (K.current = oe);
    const se = H.current;
    if (oe.checked || se == null || se.disabled)
      return G(oe);
  }), W = Ce(() => L ?? null);
  gi(z, {
    id: _,
    value: L,
    getValue: W
  }), So(L, () => {
    I(V), M(L !== P.initialValue), T(L != null), y() ? N.commit(L) : N.commit(L, !0);
    const oe = K.current;
    L == null && oe && !oe.disabled && G(oe);
  });
  const [X, J] = x.useState(!1), re = b["aria-labelledby"] ?? k ?? D?.legendId, Q = {
    ...E,
    disabled: O ?? !1,
    required: l ?? !1,
    readOnly: s ?? !1
  }, ie = x.useMemo(() => ({
    ...E,
    checkedValue: L,
    disabled: O,
    form: d,
    validation: N,
    name: V,
    onValueChange: $,
    readOnly: s,
    registerControlRef: q,
    registerInputRef: ee,
    required: l,
    setCheckedValue: Y,
    setTouched: J,
    touched: X
  }), [L, O, d, N, E, V, $, s, q, ee, l, Y, J, X]), ce = {
    role: "radiogroup",
    "aria-required": l || void 0,
    "aria-disabled": O || void 0,
    "aria-readonly": s || void 0,
    "aria-labelledby": re,
    onFocus() {
      C(!0);
    },
    onBlur(oe) {
      He(oe.currentTarget, oe.relatedTarget) || (v(!0), C(!1), w === "onBlur" && N.commit(L));
    },
    onKeyDownCapture(oe) {
      oe.key.startsWith("Arrow") && (v(!0), J(!0), C(!0));
    }
  };
  return /* @__PURE__ */ g(y1.Provider, {
    value: ie,
    children: /* @__PURE__ */ g(Kb, {
      render: o,
      className: r,
      style: h,
      state: Q,
      props: [ce, N.getValidationProps, b],
      refs: [n],
      stateAttributesMapping: to,
      enableHomeAndEndKeys: !1,
      modifierKeys: WP
    })
  });
});
process.env.NODE_ENV !== "production" && (r3.displayName = "RadioGroup");
function UP() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M15 8C15 4.13438 11.8656 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
function GP() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16ZM8 1.5C4.40937 1.5 1.5 4.40937 1.5 8C1.5 11.5906 4.40937 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40937 11.5906 1.5 8 1.5ZM8 11C6.34375 11 5 9.65625 5 8C5 6.34375 6.34375 5 8 5C9.65625 5 11 6.34375 11 8C11 9.65625 9.65625 11 8 11Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const i3 = ho({}), YP = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "group",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1.5px]",
  "focus-visible:ring-radio-focus-ring",
  "cursor-[inherit]",
  // coarse touch target
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), jP = ae(["absolute", "inset-0", "rounded-full", "flex", "items-center", "justify-center", "[[data-checked]_&]:hidden", "group-hover:bg-radio-outline-hover-background", "group-active:bg-radio-outline-pressed-background"]), KP = ae(["flex", "items-center", "justify-center", "text-radio-outline-default-border", "group-hover:text-radio-outline-hover-border", "group-active:text-radio-outline-pressed-border", "[[data-disabled]_&]:text-radio-outline-disabled-border", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), qP = ae(["flex", "items-center", "justify-center", "text-radio-filled-default-background", "group-hover:text-radio-filled-hover-background", "group-active:text-radio-filled-pressed-background", "[[data-disabled]_&]:text-radio-filled-disabled-background", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), s3 = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), ZP = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), XP = ae(["flex", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), QP = ae([], {
  variants: {
    size: {
      sm: ["pl-[calc(var(--icon-sm)+var(--spacing-8))]"],
      md: ["pl-[calc(var(--icon-md)+var(--spacing-8))]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function o_(t) {
  const e = B.c(28);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: i,
    error: r,
    disabled: o,
    size: l,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "sm" : l, c = At();
  let u;
  e[7] !== o || e[8] !== r || e[9] !== a ? (u = {
    error: r,
    disabled: o,
    size: a
  }, e[7] = o, e[8] = r, e[9] = a, e[10] = u) : u = e[10];
  let d;
  e[11] !== c || e[12] !== i ? (d = i && /* @__PURE__ */ g("span", { id: `${c}-label`, className: s3(), children: i }), e[11] = c, e[12] = i, e[13] = d) : d = e[13];
  const f = i ? `${c}-label` : s["aria-labelledby"], p = s["aria-label"], m = r || void 0, h = o || void 0;
  let b;
  e[14] !== n || e[15] !== o || e[16] !== s || e[17] !== f || e[18] !== p || e[19] !== m || e[20] !== h ? (b = /* @__PURE__ */ g(r3, { ...s, disabled: o, "aria-labelledby": f, "aria-label": p, "aria-invalid": m, "aria-disabled": h, className: "flex flex-col gap-(--spacing-8)", children: n }), e[14] = n, e[15] = o, e[16] = s, e[17] = f, e[18] = p, e[19] = m, e[20] = h, e[21] = b) : b = e[21];
  let v;
  e[22] !== d || e[23] !== b ? (v = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    d,
    b
  ] }), e[22] = d, e[23] = b, e[24] = v) : v = e[24];
  let C;
  return e[25] !== u || e[26] !== v ? (C = /* @__PURE__ */ g(i3, { value: u, children: v }), e[25] = u, e[26] = v, e[27] = C) : C = e[27], C;
}
function r_(t) {
  const e = B.c(53);
  let n, o, r, i;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const {
    error: s,
    disabled: l,
    size: a
  } = dn(i3), c = l || o, u = At();
  let d;
  e[5] !== n || e[6] !== u || e[7] !== i ? (d = [i["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[5] = n, e[6] = u, e[7] = i, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== c ? (p = XP({
    disabled: c
  }), e[9] = c, e[10] = p) : p = e[10];
  const m = r ? void 0 : i["aria-label"], h = r ? `${u}-label` : void 0, b = s ? "" : void 0;
  let v;
  e[11] !== i ? (v = (O) => {
    i.onKeyDown?.(O), !O.defaultPrevented && O.key === " " && (O.preventDefault(), O.currentTarget.click());
  }, e[11] = i, e[12] = v) : v = e[12];
  let C;
  e[13] !== a ? (C = ne(YP({
    size: a
  })), e[13] = a, e[14] = C) : C = e[14];
  let y;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = jP(), e[15] = y) : y = e[15];
  let w;
  e[16] !== a ? (w = KP({
    size: a
  }), e[16] = a, e[17] = w) : w = e[17];
  let R;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ g(UP, {}), e[18] = R) : R = e[18];
  let S;
  e[19] !== w ? (S = /* @__PURE__ */ g("span", { className: y, children: /* @__PURE__ */ g("span", { className: w, children: R }) }), e[19] = w, e[20] = S) : S = e[20];
  let E;
  e[21] !== a ? (E = qP({
    size: a
  }), e[21] = a, e[22] = E) : E = e[22];
  let N;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g(GP, {}), e[23] = N) : N = e[23];
  let M;
  e[24] !== E ? (M = /* @__PURE__ */ g(o3, { className: E, children: N }), e[24] = E, e[25] = M) : M = e[25];
  let T;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== S || e[30] !== M || e[31] !== m || e[32] !== h || e[33] !== b || e[34] !== v || e[35] !== C ? (T = /* @__PURE__ */ F(n3, { ...i, disabled: c, "aria-label": m, "aria-labelledby": h, "aria-describedby": f, "data-error": b, onKeyDown: v, className: C, children: [
    S,
    M
  ] }), e[26] = f, e[27] = c, e[28] = i, e[29] = S, e[30] = M, e[31] = m, e[32] = h, e[33] = b, e[34] = v, e[35] = C, e[36] = T) : T = e[36];
  let P;
  e[37] !== u || e[38] !== c || e[39] !== r ? (P = r && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(s3(), c && "opacity-[0.54]"), children: r }), e[37] = u, e[38] = c, e[39] = r, e[40] = P) : P = e[40];
  let k;
  e[41] !== T || e[42] !== P ? (k = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    T,
    P
  ] }), e[41] = T, e[42] = P, e[43] = k) : k = e[43];
  let I;
  e[44] !== n || e[45] !== u || e[46] !== c || e[47] !== a ? (I = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: ne(ZP(), c && "opacity-[0.54]", QP({
    size: a
  })), children: n }), e[44] = n, e[45] = u, e[46] = c, e[47] = a, e[48] = I) : I = e[48];
  let D;
  return e[49] !== k || e[50] !== I || e[51] !== p ? (D = /* @__PURE__ */ F("label", { className: p, children: [
    k,
    I
  ] }), e[49] = k, e[50] = I, e[51] = p, e[52] = D) : D = e[52], D;
}
const JP = ae(["flex", "w-full", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "shadow-elevation-1", "transition-colors", "duration-200", "ease-in-out", "[&:has(input:focus)]:border-input-active-outline", "hover:bg-input-hover-background", "hover:border-input-hover-outline", "active:border-input-pressed-outline", "[&:has(input:disabled)]:cursor-not-allowed", "[&:has(input:disabled)]:opacity-50"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), l3 = ae(["min-w-0", "flex-1", "border-0", "bg-transparent", "p-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-input-text-default", "outline-none", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "[&::-webkit-search-cancel-button]:appearance-none"]);
function a3(t) {
  const e = B.c(7), {
    children: n,
    size: o,
    trailing: r
  } = t, i = o === void 0 ? "md" : o;
  let s;
  e[0] !== i ? (s = ne(JP({
    size: i
  })), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-input-text-placeholder", children: /* @__PURE__ */ g(We, { name: "search", size: "sm", tone: "inherit" }) }), e[2] = l) : l = e[2];
  let a;
  return e[3] !== n || e[4] !== s || e[5] !== r ? (a = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    n,
    r
  ] }), e[3] = n, e[4] = s, e[5] = r, e[6] = a) : a = e[6], a;
}
function c3(t, e) {
  const n = B.c(10), o = nt(void 0), r = nt(t);
  let i, s;
  n[0] !== t ? (i = () => {
    r.current = t;
  }, s = [t], n[0] = t, n[1] = i, n[2] = s) : (i = n[1], s = n[2]), Rt(i, s);
  let l;
  n[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = function() {
    o.current !== void 0 && (window.clearTimeout(o.current), o.current = void 0);
  }, n[3] = l) : l = n[3];
  const a = l;
  let c;
  n[4] !== e ? (c = function(h, b) {
    const v = b === void 0 ? !1 : b;
    if (a(), !!r.current) {
      if (v || e === 0) {
        r.current(h);
        return;
      }
      o.current = window.setTimeout(() => {
        o.current = void 0, r.current?.(h);
      }, e);
    }
  }, n[4] = e, n[5] = c) : c = n[5];
  const u = c;
  let d, f;
  n[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = () => () => {
    o.current !== void 0 && window.clearTimeout(o.current);
  }, f = [], n[6] = d, n[7] = f) : (d = n[6], f = n[7]), Rt(d, f);
  let p;
  return n[8] !== u ? (p = {
    cancelSearch: a,
    emitSearch: u
  }, n[8] = u, n[9] = p) : p = n[9], p;
}
function i_(t) {
  const e = B.c(33), {
    "aria-label": n,
    value: o,
    defaultValue: r,
    onChange: i,
    onSearch: s,
    placeholder: l,
    clearable: a,
    debounceMs: c,
    size: u,
    disabled: d,
    autoFocus: f
  } = t, p = r === void 0 ? "" : r, m = l === void 0 ? "Search" : l, h = a === void 0 ? !0 : a, b = c === void 0 ? 300 : c, v = u === void 0 ? "md" : u, [C, y] = qe(p), {
    emitSearch: w
  } = c3(s, b), R = o !== void 0, S = R ? o : C;
  let E;
  e[0] !== f ? (E = f ? {
    autoFocus: !0
  } : void 0, e[0] = f, e[1] = E) : E = e[1];
  const N = E;
  let M;
  e[2] !== w || e[3] !== R || e[4] !== i ? (M = function($) {
    R || y($), i?.($), w($);
  }, e[2] = w, e[3] = R, e[4] = i, e[5] = M) : M = e[5];
  const T = M;
  let P;
  e[6] !== w || e[7] !== R || e[8] !== i ? (P = function() {
    R || y(""), i?.(""), w("", !0);
  }, e[6] = w, e[7] = R, e[8] = i, e[9] = P) : P = e[9];
  const k = P;
  let I;
  e[10] !== k || e[11] !== h || e[12] !== d || e[13] !== S ? (I = h && S.length > 0 ? /* @__PURE__ */ g(gt, { "aria-label": "Clear search", disabled: d, icon: "x-close", onClick: k, size: "sm", type: "button", variant: "ghost" }) : void 0, e[10] = k, e[11] = h, e[12] = d, e[13] = S, e[14] = I) : I = e[14];
  let D;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne(l3()), e[15] = D) : D = e[15];
  let O;
  e[16] !== T ? (O = (A) => T(A.target.value), e[16] = T, e[17] = O) : O = e[17];
  let V;
  e[18] !== k || e[19] !== S ? (V = (A) => {
    A.key === "Escape" && S.length > 0 && (A.preventDefault(), k());
  }, e[18] = k, e[19] = S, e[20] = V) : V = e[20];
  let _;
  e[21] !== n || e[22] !== N || e[23] !== d || e[24] !== S || e[25] !== m || e[26] !== O || e[27] !== V ? (_ = /* @__PURE__ */ g("input", { "aria-label": n, className: D, disabled: d, onChange: O, onKeyDown: V, placeholder: m, type: "search", value: S, ...N }), e[21] = n, e[22] = N, e[23] = d, e[24] = S, e[25] = m, e[26] = O, e[27] = V, e[28] = _) : _ = e[28];
  let L;
  return e[29] !== v || e[30] !== _ || e[31] !== I ? (L = /* @__PURE__ */ g(a3, { size: v, trailing: I, children: _ }), e[29] = v, e[30] = _, e[31] = I, e[32] = L) : L = e[32], L;
}
function eM(t) {
  const {
    openOnInputClick: e = !1,
    value: n,
    defaultValue: o,
    onValueChange: r,
    mode: i = "list",
    itemToStringValue: s,
    ...l
  } = t, a = i === "inline" || i === "both", c = i === "inline" || i === "none", u = n !== void 0, [d, f] = x.useState(o ?? ""), [p, m] = x.useState("");
  x.useEffect(() => {
    u && m("");
  }, [n, u]);
  let h;
  a && p !== "" ? h = p : u ? h = n ?? "" : h = d;
  const b = Ce((S, E) => {
    m(""), u || f(S), r?.(S, E);
  }), v = U0(), C = x.useMemo(() => l.filter !== void 0 ? l.filter : v.contains, [l.filter, v]), y = String(u ? n : d).trim(), w = x.useMemo(() => i !== "both" ? c ? null : C : C === null ? null : (S, E, N) => C(S, y, N), [C, i, y, c]), R = Ce((S, E) => {
    t.onItemHighlighted?.(S, E), E.reason !== u8 && (a ? S == null ? m("") : m(en(S, s)) : m(""));
  });
  return /* @__PURE__ */ g(Y0, {
    ...l,
    itemToStringLabel: s,
    openOnInputClick: e,
    selectionMode: "none",
    fillInputOnItemPress: !0,
    filter: w,
    autoComplete: i,
    inputValue: h,
    defaultInputValue: o,
    onInputValueChange: b,
    onItemHighlighted: R
  });
}
const tM = ka, nM = _s, oM = ae(["w-[min(540px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(640px,calc(100vh_-_var(--spacing-40)))]", "flex", "flex-col", "gap-(--spacing-10)", "outline-none", "[outline:none]", "focus:outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out", "max-sm:h-dvh", "max-sm:w-screen", "max-sm:max-h-none", "max-sm:gap-0", "max-sm:bg-surface"]), rM = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface/40", "backdrop-blur-search-overlay", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-100", "ease-in-out"]), iM = ae(["min-h-0", "max-h-[min(520px,calc(100vh_-_160px))]", "overflow-y-auto", "overscroll-contain", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none", "rounded-(--radius-sm)", "bg-surface-container-lowest", "py-(--spacing-20)", "px-(--spacing-10)", "shadow-elevation-3", "max-sm:max-h-none", "max-sm:flex-1", "max-sm:rounded-none", "max-sm:shadow-none"]), sM = ae(["contents", "max-sm:flex", "max-sm:h-[68px]", "max-sm:shrink-0", "max-sm:items-center", "max-sm:gap-(--spacing-8)", "max-sm:border-b", "max-sm:border-outline-subtle", "max-sm:px-(--spacing-16)"]), lM = ae(["hidden", "max-sm:flex", "max-sm:min-h-[44px]", "max-sm:items-center"]), aM = ae(["contents", "max-sm:flex", "max-sm:min-h-[44px]", "max-sm:min-w-0", "max-sm:flex-1", "max-sm:items-center"]), cM = ae(["flex", "flex-col", "gap-(--spacing-16)", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none"]), uM = ae(["flex", "flex-col", "gap-(--spacing-4)"]), dM = ae(["relative", "z-10", "flex", "h-(--spacing-24)", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle"]), fM = ae(["flex", "h-[45px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "bg-transparent", "py-(--spacing-4)", "pl-(--spacing-10)", "pr-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50"]), pM = ae(["inline-flex", "h-(--spacing-32)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-button-outline-default-text", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), mM = ae(["inline-flex", "size-(--spacing-32)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border", "border-solid", "border-transparent", "bg-transparent", "text-button-ghost-default-text", "outline-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background"]);
function gM(t) {
  return t.map((e) => ({
    value: e.label,
    items: e.items.map((n) => ({
      ...n,
      groupLabel: e.label
    }))
  }));
}
function hM(t) {
  return t.every((e) => e.items.length === 0);
}
function Mc(t, e) {
  return t.find((n) => n.label === e);
}
function Tc(t) {
  return `${t.groupLabel}:${t.id}`;
}
const bM = {
  meta: "⌘",
  ctrl: "Ctrl",
  alt: "Alt",
  shift: "Shift"
};
function s_(t) {
  const e = B.c(76), {
    open: n,
    onOpenChange: o,
    query: r,
    onQueryChange: i,
    onSearch: s,
    debounceMs: l,
    groups: a,
    placeholder: c,
    hotkey: u,
    showDividers: d,
    emptyLabel: f,
    disabled: p,
    "aria-label": m,
    onItemSelect: h,
    onItemRemove: b
  } = t, v = l === void 0 ? 300 : l, C = c === void 0 ? "Search" : c, y = d === void 0 ? !0 : d, w = f === void 0 ? "No results found." : f, R = m === void 0 ? "Search" : m, S = Kt(), E = At(), {
    cancelSearch: N,
    emitSearch: M
  } = c3(s, v), T = a.filter(xM), P = gM(T), k = hM(T), I = !!u && r.length === 0, D = P.at(-1)?.value, [O, V] = qe();
  let _;
  e[0] !== O ? (_ = (Me) => Tc(Me) === O, e[0] = O, e[1] = _) : _ = e[1];
  const L = P.flatMap(yM).find(_);
  let A;
  e[2] !== N || e[3] !== a || e[4] !== h ? (A = function(Re, Ve) {
    if (Re.target instanceof Element && Re.target.closest("[data-search-remove]"))
      return;
    const je = Mc(a, Ve.groupLabel);
    !je || Ve.disabled || (N(), h(Ve, je));
  }, e[2] = N, e[3] = a, e[4] = h, e[5] = A) : A = e[5];
  const $ = A;
  let Y;
  e[6] !== M || e[7] !== i ? (Y = function(Re) {
    i(Re), M(Re);
  }, e[6] = M, e[7] = i, e[8] = Y) : Y = e[8];
  const z = Y;
  let H;
  e[9] !== N || e[10] !== o ? (H = function(Re) {
    Re || N(), o(Re);
  }, e[9] = N, e[10] = o, e[11] = H) : H = e[11];
  const K = H;
  let G;
  e[12] !== a || e[13] !== b ? (G = function(Re) {
    const Ve = Mc(a, Re.groupLabel);
    !Ve || Re.disabled || b?.(Re, Ve);
  }, e[12] = a, e[13] = b, e[14] = G) : G = e[14];
  const q = G;
  let ee;
  e[15] !== V ? (ee = function(Re) {
    const Ve = Re ? Tc(Re) : void 0;
    V((je) => je === Ve ? je : Ve);
  }, e[15] = V, e[16] = ee) : ee = e[16];
  const W = ee;
  let X;
  e[17] !== q ? (X = function(Re, Ve) {
    Re.preventDefault(), Re.stopPropagation(), q(Ve);
  }, e[17] = q, e[18] = X) : X = e[18];
  const J = X;
  let re;
  e[19] !== q || e[20] !== L || e[21] !== r ? (re = function(Re) {
    !L?.removable || L.disabled || !(Re.key === "Delete" || Re.key === "Backspace" && r.length === 0) || (Re.preventDefault(), Re.stopPropagation(), q(L));
  }, e[19] = q, e[20] = L, e[21] = r, e[22] = re) : re = e[22];
  const Q = re;
  let ie;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = function(Re) {
    if (!Re.removable)
      return;
    const Ve = Re.chip ? `, ${Re.chip}` : "", je = Re.removeAriaLabel ? `${Re.removeAriaLabel}. Press Delete.` : "Press Delete to remove.";
    return `${Re.label}${Ve}. ${je}`;
  }, e[23] = ie) : ie = e[23];
  const ce = ie;
  let oe;
  e[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (oe = /* @__PURE__ */ g(Ps, { className: ne(rM()) }), e[24] = oe) : oe = e[24];
  let se;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = ne(oM()), e[25] = se) : se = e[25];
  let fe, be;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (fe = ne(sM()), be = ne(lM()), e[26] = fe, e[27] = be) : (fe = e[26], be = e[27]);
  let le;
  e[28] !== K ? (le = /* @__PURE__ */ g("div", { className: be, children: /* @__PURE__ */ g(gt, { "aria-label": "Back", icon: "chevron-left", variant: "ghost", onClick: () => K(!1) }) }), e[28] = K, e[29] = le) : le = e[29];
  let me;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (me = ne(aM()), e[30] = me) : me = e[30];
  let j;
  e[31] !== u || e[32] !== I ? (j = I && u ? /* @__PURE__ */ g(Q2, { "aria-hidden": "true", modifier: u.modifier ? bM[u.modifier] : void 0, children: u.key }) : void 0, e[31] = u, e[32] = I, e[33] = j) : j = e[33];
  let te;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = ne(l3()), e[34] = te) : te = e[34];
  let U;
  e[35] !== p || e[36] !== Q || e[37] !== E || e[38] !== C ? (U = /* @__PURE__ */ g(Os, { id: E, placeholder: C, disabled: p, className: te, onKeyDown: Q }), e[35] = p, e[36] = Q, e[37] = E, e[38] = C, e[39] = U) : U = e[39];
  let Z;
  e[40] !== j || e[41] !== U ? (Z = /* @__PURE__ */ g(tM, { children: /* @__PURE__ */ g(a3, { trailing: j, children: U }) }), e[40] = j, e[41] = U, e[42] = Z) : Z = e[42];
  let ue;
  e[43] !== E || e[44] !== Z ? (ue = /* @__PURE__ */ g("label", { className: me, htmlFor: E, children: Z }), e[43] = E, e[44] = Z, e[45] = ue) : ue = e[45];
  let pe;
  e[46] !== le || e[47] !== ue ? (pe = /* @__PURE__ */ F("div", { className: fe, children: [
    le,
    ue
  ] }), e[46] = le, e[47] = ue, e[48] = pe) : pe = e[48];
  let he;
  e[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (he = ne(iM()), e[49] = he) : he = e[49];
  let Ie;
  e[50] !== w || e[51] !== a || e[52] !== $ || e[53] !== J || e[54] !== k || e[55] !== D || e[56] !== y ? (Ie = /* @__PURE__ */ g("div", { className: he, children: k ? /* @__PURE__ */ g("div", { className: "flex h-(--spacing-40) items-center px-(--spacing-10) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: w }) : /* @__PURE__ */ g(Ds, { className: ne(cM()), children: (Me) => {
    const Re = Mc(a, Me.value);
    return /* @__PURE__ */ F(t4, { children: [
      /* @__PURE__ */ F(Z0, { items: Me.items, className: ne(uM()), children: [
        /* @__PURE__ */ F(X0, { className: ne(dM(), Re?.action && "pr-(--spacing-4)"), children: [
          /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: Me.value }),
          Re?.action && /* @__PURE__ */ F(Qn, { className: ne(pM()), "aria-label": Re.action["aria-label"], onClick: Re.action.onClick, children: [
            Re.action.label,
            /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" })
          ] })
        ] }),
        /* @__PURE__ */ g(q0, { children: (Ve) => /* @__PURE__ */ F(nM, { value: Ve, disabled: Ve.disabled, className: ne(fM()), "aria-label": ce(Ve), onClick: (je) => $(je, Ve), children: [
          /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
            /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: Ve.label }),
              Ve.subLabel && /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-xsmall) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-menu-text-subtle uppercase", children: Ve.subLabel })
            ] }),
            Ve.chip && /* @__PURE__ */ g(Ln, { label: Ve.chip, tone: "neutral" })
          ] }),
          Ve.removable && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: ne(mM()), "data-search-remove": "", "data-testid": `search-remove-${Ve.id}`, onPointerDown: (je) => J(je, Ve), children: /* @__PURE__ */ g(We, { name: "x-close", size: "sm", tone: "inherit" }) })
        ] }, Tc(Ve)) })
      ] }),
      y && Me.value !== D && /* @__PURE__ */ g(gr, { variant: "middle-inset" })
    ] }, Me.value);
  } }) }), e[50] = w, e[51] = a, e[52] = $, e[53] = J, e[54] = k, e[55] = D, e[56] = y, e[57] = Ie) : Ie = e[57];
  let ye;
  e[58] !== P || e[59] !== p || e[60] !== W || e[61] !== z || e[62] !== r || e[63] !== pe || e[64] !== Ie ? (ye = /* @__PURE__ */ F(eM, { open: !0, inline: !0, mode: "none", items: P, itemToStringValue: vM, value: r, onValueChange: z, onItemHighlighted: W, disabled: p, children: [
    pe,
    Ie
  ] }), e[58] = P, e[59] = p, e[60] = W, e[61] = z, e[62] = r, e[63] = pe, e[64] = Ie, e[65] = ye) : ye = e[65];
  let xe;
  e[66] !== R || e[67] !== ye ? (xe = /* @__PURE__ */ g(yi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-start justify-center px-(--spacing-16) pt-[12vh] max-sm:items-stretch max-sm:p-0", children: /* @__PURE__ */ g(bi, { "aria-label": R, className: se, children: ye }) }), e[66] = R, e[67] = ye, e[68] = xe) : xe = e[68];
  let de;
  e[69] !== S || e[70] !== xe ? (de = /* @__PURE__ */ F(Dr, { container: S, children: [
    oe,
    xe
  ] }), e[69] = S, e[70] = xe, e[71] = de) : de = e[71];
  let we;
  return e[72] !== K || e[73] !== n || e[74] !== de ? (we = /* @__PURE__ */ g(vi, { open: n, onOpenChange: K, modal: !0, children: de }), e[72] = K, e[73] = n, e[74] = de, e[75] = we) : we = e[75], we;
}
function vM(t) {
  return t.label;
}
function yM(t) {
  return t.items;
}
function xM(t) {
  return t.items.length > 0;
}
function CM(t) {
  if (!(t instanceof HTMLElement)) return !1;
  const e = t.tagName.toLowerCase();
  return e === "input" || e === "textarea" || e === "select" || t.isContentEditable;
}
function wM(t, e) {
  if (!e.includes("+"))
    return !t.metaKey && !t.ctrlKey && !t.altKey && !t.shiftKey && t.key.toLowerCase() === e.toLowerCase();
  const [n, o] = e.toLowerCase().split("+");
  return !n || !o ? !1 : !!(n === "mod" ? t.metaKey || t.ctrlKey : n === "meta" ? t.metaKey : n === "ctrl" ? t.ctrlKey : n === "alt" ? t.altKey : n === "shift" && t.shiftKey) && t.key.toLowerCase() === o;
}
function l_(t) {
  const e = B.c(5), {
    key: n,
    enabled: o,
    onOpen: r
  } = t, i = o === void 0 ? !0 : o;
  let s, l;
  e[0] !== i || e[1] !== n || e[2] !== r ? (s = () => {
    if (!i)
      return;
    const a = function(u) {
      CM(u.target) || wM(u, n) && (u.preventDefault(), r());
    };
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, l = [i, n, r], e[0] = i, e[1] = n, e[2] = r, e[3] = s, e[4] = l) : (s = e[3], l = e[4]), Rt(s, l);
}
const SM = ae(["aw-skeleton", "relative", "block", "overflow-hidden", "bg-surface-container"], {
  variants: {
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
function a_(t) {
  const e = B.c(25);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    radius: s,
    width: a,
    height: o,
    className: n,
    style: i,
    "aria-hidden": l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "sm" : s, u = l === void 0 ? !0 : l;
  let d;
  e[8] !== a ? (d = a !== void 0 ? {
    width: a
  } : void 0, e[8] = a, e[9] = d) : d = e[9];
  let f;
  e[10] !== o ? (f = o !== void 0 ? {
    height: o
  } : void 0, e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== i || e[13] !== d || e[14] !== f ? (p = {
    ...i,
    ...d,
    ...f
  }, e[12] = i, e[13] = d, e[14] = f, e[15] = p) : p = e[15];
  const m = p;
  let h;
  e[16] !== n || e[17] !== c ? (h = ne(SM({
    radius: c
  }), n), e[16] = n, e[17] = c, e[18] = h) : h = e[18];
  let b;
  return e[19] !== u || e[20] !== r || e[21] !== c || e[22] !== m || e[23] !== h ? (b = /* @__PURE__ */ g("div", { ...r, "data-slot": "skeleton", "data-radius": c, "aria-hidden": u, className: h, style: m }), e[19] = u, e[20] = r, e[21] = c, e[22] = m, e[23] = h, e[24] = b) : b = e[24], b;
}
const RM = 5, EM = 200;
function NM(t, e, n) {
  const o = [...t], [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}
function Ti(t, e, n) {
  return `${t}, position ${e + 1} of ${n}`;
}
function Oc(t, e, n) {
  const o = [...t.tops], r = t.ids.map((l, a) => a), [i] = r.splice(e, 1);
  r.splice(n, 0, i);
  let s = t.tops[0] ?? 0;
  return r.forEach((l, a) => {
    o[l] = s, s += t.heights[l] + (t.gaps[a] ?? 0);
  }), o;
}
function Dc(t, e, n) {
  const r = {
    ArrowUp: (i) => i - 1,
    ArrowDown: (i) => i + 1,
    Home: () => 0,
    End: (i, s) => s
  }[t];
  return r ? Math.max(0, Math.min(n, r(e, n))) : void 0;
}
function kM({
  items: t,
  getItemId: e,
  getItemLabel: n,
  onReorder: o,
  onDragEnd: r
}) {
  const [i, s] = x.useState(null), [l, a] = x.useState(!1), [c, u] = x.useState(""), d = x.useId(), f = x.useRef(/* @__PURE__ */ new Map()), p = x.useRef(null), m = x.useRef(null), h = x.useRef(/* @__PURE__ */ new Map()), b = x.useRef(null), v = x.useRef(null), C = x.useRef(null), y = x.useRef(null), w = x.useRef([]), R = x.useRef({
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  });
  R.current = {
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  };
  function S(W, X) {
    X ? f.current.set(W, X) : f.current.delete(W);
  }
  function E(W) {
    const X = h.current.get(W);
    if (X) return X;
    const J = (re) => S(W, re);
    return h.current.set(W, J), J;
  }
  function N(W) {
    const {
      items: X,
      getItemId: J,
      getItemLabel: re
    } = R.current, Q = X.find((ie) => J(ie) === W);
    return Q ? re(Q) : "";
  }
  function M(W) {
    v.current = W, s(W);
  }
  function T(W) {
    typeof document > "u" || (document.body.style.cursor = "grabbing", document.body.style.userSelect = "none");
  }
  function P() {
    if (typeof document > "u") return;
    const W = C.current;
    W && (document.body.style.cursor = W.previousBodyCursor, document.body.style.userSelect = W.previousBodyUserSelect);
  }
  function k() {
    p.current?.abort(), p.current = null, m.current?.abort(), m.current = null, y.current && (clearTimeout(y.current), y.current = null), b.current = null, P(), C.current = null, M(null);
  }
  function I() {
    for (const W of w.current)
      cancelAnimationFrame(W);
    w.current = [];
  }
  function D() {
    I();
    const W = requestAnimationFrame(() => {
      const X = requestAnimationFrame(() => {
        w.current = [], a(!1);
      });
      w.current = [X];
    });
    w.current = [W];
  }
  function O(W, X) {
    y.current && (clearTimeout(y.current), y.current = null), p.current?.abort(), p.current = null, b.current = null;
    const J = v.current;
    if (!J) {
      k();
      return;
    }
    M({
      ...J,
      delta: W,
      settling: !0
    }), y.current = setTimeout(() => {
      a(!0), X?.(), k(), D();
    }, EM);
  }
  function V() {
    const W = v.current;
    if (!W) {
      k();
      return;
    }
    if (W.settling) return;
    const X = C.current;
    if (!X) {
      k();
      return;
    }
    m.current?.abort(), m.current = null;
    const re = Oc(X, W.fromIndex, W.overIndex)[W.fromIndex] - X.tops[W.fromIndex];
    O(re, () => {
      const {
        items: Q,
        getItemId: ie,
        onReorder: ce,
        onDragEnd: oe
      } = R.current;
      if (u(`Dropped ${Ti(N(W.id), W.overIndex, Q.length)}`), W.overIndex === W.fromIndex) return;
      const se = Q.findIndex((me) => ie(me) === W.id), fe = X.ids[W.overIndex], be = Q.findIndex((me) => ie(me) === fe);
      if (se < 0 || be < 0 || se === be) return;
      const le = NM(Q, se, be);
      ce(le), oe?.(le);
    });
  }
  function _() {
    const W = v.current;
    if (!W) {
      k();
      return;
    }
    W.settling || (u(`Reordering cancelled. ${Ti(N(W.id), W.fromIndex, R.current.items.length)}`), M({
      ...W,
      delta: 0,
      overIndex: W.fromIndex
    }), O(0));
  }
  function L(W, X, J = !0) {
    const {
      items: re,
      getItemId: Q
    } = R.current, ie = re.findIndex((me) => Q(me) === W);
    if (ie < 0) return;
    const ce = re.map((me) => Q(me)), oe = ce.map((me) => f.current.get(me)?.getBoundingClientRect()), se = oe.map((me) => me ? me.top + me.height / 2 : 0), fe = oe.map((me, j) => {
      const te = oe[j + 1];
      return me && te ? te.top - (me.top + me.height) : 0;
    }), be = oe.map((me) => me?.height ?? 0), le = oe.map((me) => me?.top ?? 0);
    C.current = {
      centers: se,
      gaps: fe,
      heights: be,
      ids: ce,
      previousBodyCursor: typeof document > "u" ? "" : document.body.style.cursor,
      previousBodyUserSelect: typeof document > "u" ? "" : document.body.style.userSelect,
      startY: X,
      tops: le
    }, J && T(), M({
      id: W,
      fromIndex: ie,
      overIndex: ie,
      delta: 0,
      settling: !1
    }), u(`Picked up ${Ti(N(W), ie, re.length)}`);
  }
  function A(W) {
    const J = f.current.get(W)?.getBoundingClientRect();
    L(W, J ? J.top + J.height / 2 : 0, !1), K(W);
  }
  function $(W) {
    const X = v.current, J = C.current;
    if (!X || X.settling || !J) return;
    const re = W - J.startY, Q = J.centers[X.fromIndex] + re;
    let ie = 0, ce = Number.POSITIVE_INFINITY;
    for (let oe = 0; oe < J.centers.length; oe++) {
      const se = Math.abs(Q - J.centers[oe]);
      se < ce && (ce = se, ie = oe);
    }
    ie !== X.overIndex && u(Ti(N(X.id), ie, R.current.items.length)), M({
      ...X,
      delta: re,
      overIndex: ie
    });
  }
  function Y(W) {
    const X = v.current, J = C.current;
    if (!X || X.settling || !J) return;
    W !== X.overIndex && u(Ti(N(X.id), W, R.current.items.length));
    const re = Oc(J, X.fromIndex, W);
    M({
      ...X,
      delta: re[X.fromIndex] - J.tops[X.fromIndex],
      overIndex: W
    });
  }
  function z(W, X) {
    if (W.pointerType === "mouse" && W.button !== 0 || v.current || b.current) return;
    W.currentTarget.setPointerCapture?.(W.pointerId), b.current = {
      id: X,
      x: W.clientX,
      y: W.clientY
    };
    const J = new AbortController();
    p.current = J;
    const {
      signal: re
    } = J;
    window.addEventListener("pointermove", (Q) => {
      const ie = b.current;
      if (ie && !v.current) {
        if (Math.hypot(Q.clientX - ie.x, Q.clientY - ie.y) < RM)
          return;
        L(ie.id, ie.y);
      }
      v.current && (Q.preventDefault(), $(Q.clientY));
    }, {
      signal: re
    }), window.addEventListener("pointerup", V, {
      signal: re
    }), window.addEventListener("pointercancel", _, {
      signal: re
    }), window.addEventListener("blur", _, {
      signal: re
    }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && _();
    }, {
      signal: re
    }), window.addEventListener("keydown", (Q) => {
      Q.key === "Escape" && (Q.preventDefault(), _());
    }, {
      signal: re
    });
  }
  function H(W, X) {
    const J = v.current;
    if (J?.id !== X) return;
    if (W.key === "Tab") {
      _();
      return;
    }
    if (W.key === " " || W.key === "Enter") {
      W.preventDefault(), V();
      return;
    }
    if (W.key === "Escape") {
      W.preventDefault(), _();
      return;
    }
    const re = Dc(W.key, J.overIndex, R.current.items.length - 1);
    re !== void 0 && (W.preventDefault(), Y(re));
  }
  function K(W) {
    if (m.current?.abort(), typeof document > "u") return;
    const X = new AbortController();
    m.current = X;
    const {
      signal: J
    } = X;
    document.addEventListener("keydown", (re) => H(re, W), {
      signal: J
    }), document.addEventListener("focusin", (re) => {
      if (v.current?.id !== W) return;
      const ie = re.target, ce = f.current.get(W)?.querySelector('[data-slot="sortable-handle"]');
      ie instanceof Node && ce?.contains(ie) || _();
    }, {
      signal: J
    });
  }
  function G(W, X) {
    const J = v.current;
    if (W.key === " " || W.key === "Enter") {
      if (W.preventDefault(), W.stopPropagation(), J?.id === X) {
        V();
        return;
      }
      J || A(X);
      return;
    }
    if (W.key === "Escape" && J?.id === X) {
      W.preventDefault(), W.stopPropagation(), _();
      return;
    }
    const {
      items: re
    } = R.current, Q = re.length - 1;
    if (J?.id === X) {
      const ie = Dc(W.key, J.overIndex, Q);
      if (ie === void 0) return;
      W.preventDefault(), W.stopPropagation(), Y(ie);
      return;
    }
    Dc(W.key, 0, Q) !== void 0 && (W.preventDefault(), W.stopPropagation());
  }
  function q(W, X) {
    return {
      "aria-label": `Reorder ${X}`,
      "aria-describedby": d,
      "aria-pressed": i?.id === W,
      "data-slot": "sortable-handle",
      role: "button",
      tabIndex: 0,
      onPointerDown: (J) => z(J, W),
      onKeyDown: (J) => G(J, W),
      onClick: (J) => J.stopPropagation()
    };
  }
  function ee(W, X) {
    if (!i) return;
    if (W === i.id) return `translateY(${i.delta}px)`;
    const J = C.current;
    if (!J) return;
    const {
      fromIndex: re,
      overIndex: Q
    } = i, ce = Oc(J, re, Q)[X] - J.tops[X];
    return ce === 0 ? void 0 : `translateY(${ce}px)`;
  }
  return x.useEffect(() => () => {
    p.current?.abort(), p.current = null, y.current && (clearTimeout(y.current), y.current = null), m.current?.abort(), m.current = null;
    for (const X of w.current)
      cancelAnimationFrame(X);
    w.current = [], b.current = null;
    const W = C.current;
    typeof document < "u" && W && (document.body.style.cursor = W.previousBodyCursor, document.body.style.userSelect = W.previousBodyUserSelect), C.current = null;
  }, []), {
    draggingId: i?.id ?? null,
    settling: i?.settling ?? !1,
    committing: l,
    getRowRef: E,
    getHandleProps: q,
    getItemTransform: ee,
    announcement: c,
    instructionsId: d
  };
}
const IM = ae(["relative", "transition-transform duration-200 ease-out", "motion-reduce:transition-none"]), PM = ae(["flex size-(--spacing-20) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "text-text-subtext", "cursor-grab touch-none", "active:cursor-grabbing", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), MM = ae(["flex w-full items-stretch", "data-[dragging]:shadow-elevation-1"]);
function c_(t) {
  const e = B.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ne(MM(), n), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "sortable-list-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function TM(t) {
  const e = B.c(7);
  let n, o;
  if (e[0] !== t ? ({
    visible: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]), !(o === void 0 ? !0 : o))
    return null;
  let i, s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = PM(), s = /* @__PURE__ */ g(We, { name: "grip-drag", size: "md", tone: "secondary", "aria-hidden": !0 }), e[3] = i, e[4] = s) : (i = e[3], s = e[4]);
  let l;
  return e[5] !== n ? (l = /* @__PURE__ */ g("div", { className: "flex w-(--spacing-40) shrink-0 items-center justify-center", children: /* @__PURE__ */ g("button", { ...n, type: "button", className: i, children: s }) }), e[5] = n, e[6] = l) : l = e[6], l;
}
function OM(t) {
  const e = B.c(36), {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s,
    className: l,
    children: a
  } = t;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== n || e[3] !== s || e[4] !== i ? (c = {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s
  }, e[0] = o, e[1] = r, e[2] = n, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const {
    draggingId: u,
    settling: d,
    committing: f,
    getRowRef: p,
    getHandleProps: m,
    getItemTransform: h,
    announcement: b,
    instructionsId: v
  } = kM(c);
  let C;
  if (e[6] !== a || e[7] !== f || e[8] !== u || e[9] !== m || e[10] !== o || e[11] !== r || e[12] !== h || e[13] !== p || e[14] !== n || e[15] !== d) {
    let S;
    e[17] !== a || e[18] !== f || e[19] !== u || e[20] !== m || e[21] !== o || e[22] !== r || e[23] !== h || e[24] !== p || e[25] !== d ? (S = (E, N) => {
      const M = o(E), T = r(E), P = u === M, k = m(M, T), I = /* @__PURE__ */ g(TM, { ...k });
      return /* @__PURE__ */ g("div", { ref: p(M), "data-slot": "sortable-item", "data-dragging": P ? "" : void 0, style: {
        transform: h(M, N)
      }, className: ne(IM(), f && "transition-none", P && "z-10", P && !d && "transition-none"), children: a(E, {
        handle: I,
        handleProps: k,
        isDragging: P
      }) }, M);
    }, e[17] = a, e[18] = f, e[19] = u, e[20] = m, e[21] = o, e[22] = r, e[23] = h, e[24] = p, e[25] = d, e[26] = S) : S = e[26], C = n.map(S), e[6] = a, e[7] = f, e[8] = u, e[9] = m, e[10] = o, e[11] = r, e[12] = h, e[13] = p, e[14] = n, e[15] = d, e[16] = C;
  } else
    C = e[16];
  let y;
  e[27] !== v ? (y = /* @__PURE__ */ g("span", { id: v, className: "sr-only", children: "Press Space or Enter to pick up, arrow keys to move, Space or Enter to drop, or Escape to cancel." }), e[27] = v, e[28] = y) : y = e[28];
  let w;
  e[29] !== b ? (w = /* @__PURE__ */ g("span", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: b }), e[29] = b, e[30] = w) : w = e[30];
  let R;
  return e[31] !== l || e[32] !== C || e[33] !== y || e[34] !== w ? (R = /* @__PURE__ */ F("div", { "data-slot": "sortable-list", className: l, children: [
    C,
    y,
    w
  ] }), e[31] = l, e[32] = C, e[33] = y, e[34] = w, e[35] = R) : R = e[35], R;
}
const u_ = OM, C1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (C1.displayName = "SwitchRootContext");
function DM() {
  const t = x.useContext(C1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : tt(63));
  return t;
}
let cg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const u3 = {
  ...to,
  checked(t) {
    return t ? {
      [cg.checked]: ""
    } : {
      [cg.unchecked]: ""
    };
  }
}, d3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i,
    "aria-labelledby": s,
    form: l,
    id: a,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: p = !1,
    required: m = !1,
    disabled: h = !1,
    render: b,
    uncheckedValue: v,
    value: C,
    style: y,
    ...w
  } = e, {
    clearErrors: R
  } = Vo(), {
    state: S,
    setTouched: E,
    setDirty: N,
    validityData: M,
    setFilled: T,
    setFocused: P,
    shouldValidateOnChange: k,
    validationMode: I,
    disabled: D,
    name: O,
    validation: V
  } = on(), {
    labelId: _
  } = hn(), L = D || h, A = O ?? u, $ = Ce(f), Y = x.useRef(null), z = mn(Y, c, V.inputRef), H = x.useRef(null), K = It(), G = Mr({
    id: a,
    implicit: !1,
    controlRef: H
  }), q = d ? void 0 : G, [ee, W] = pn({
    controlled: o,
    default: !!i,
    name: "Switch",
    state: "checked"
  });
  gi(H, {
    id: K,
    value: ee
  }), Ne(() => {
    Y.current && T(Y.current.checked);
  }, [Y, T]), So(ee, () => {
    R(A), N(ee !== M.initialValue), T(ee), k() ? V.commit(ee) : V.commit(ee, !0);
  });
  const {
    getButtonProps: X,
    buttonRef: J
  } = Wt({
    disabled: L,
    native: d
  }), re = nf(s, _, Y, !d, q), Q = {
    id: d ? G : K,
    role: "switch",
    "aria-checked": ee,
    "aria-readonly": p || void 0,
    "aria-required": m || void 0,
    "aria-labelledby": re,
    onFocus() {
      L || P(!0);
    },
    onBlur() {
      const se = Y.current;
      !se || L || (E(!0), P(!1), I === "onBlur" && V.commit(se.checked));
    },
    onClick(se) {
      p || L || (se.preventDefault(), Y.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: se.shiftKey,
        ctrlKey: se.ctrlKey,
        altKey: se.altKey,
        metaKey: se.metaKey
      })));
    }
  }, ie = x.useMemo(() => Jt(
    {
      checked: ee,
      disabled: L,
      form: l,
      id: q,
      name: A,
      required: m,
      style: A ? ni : er,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: z,
      onChange(se) {
        if (se.nativeEvent.defaultPrevented)
          return;
        if (p) {
          se.preventDefault();
          return;
        }
        const fe = se.currentTarget.checked, be = _e(Mt, se.nativeEvent);
        $?.(fe, be), !be.isCanceled && W(fe);
      },
      onFocus() {
        H.current?.focus();
      }
    },
    V.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    C !== void 0 ? {
      value: C
    } : St
  ), [ee, L, l, z, q, A, $, p, m, W, V, C]), ce = x.useMemo(() => ({
    ...S,
    checked: ee,
    disabled: L,
    readOnly: p,
    required: m
  }), [S, ee, L, p, m]), oe = Le("span", e, {
    state: ce,
    ref: [n, H, J],
    props: [Q, V.getValidationProps, w, X],
    stateAttributesMapping: u3
  });
  return /* @__PURE__ */ F(C1.Provider, {
    value: ce,
    children: [oe, !ee && A && v !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: l,
      name: A,
      value: v
    }), /* @__PURE__ */ g("input", {
      ...ie,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (d3.displayName = "SwitchRoot");
const f3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = on(), a = DM(), c = {
    ...l,
    ...a
  };
  return Le("span", e, {
    state: c,
    ref: n,
    stateAttributesMapping: u3,
    props: s
  });
});
process.env.NODE_ENV !== "production" && (f3.displayName = "SwitchThumb");
const _M = ae(["inline-flex", "items-start", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["opacity-[0.54]", "cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), VM = ae(["relative", "shrink-0", "w-[44px]", "h-(--spacing-24)", "rounded-full", "bg-surface-container-highest", "data-[checked]:bg-primary", "transition-colors", "duration-200", "ease-in-out", "motion-reduce:transition-none", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2", "focus-visible:ring-tertiary-tertiary", "cursor-[inherit]", "[@media(pointer:coarse)]:before:content-['']", "[@media(pointer:coarse)]:before:absolute", "[@media(pointer:coarse)]:before:inset-x-0", "[@media(pointer:coarse)]:before:inset-y-[-12px]"]), AM = ae(["absolute", "top-(--spacing-2)", "w-(--spacing-20)", "h-(--spacing-20)", "rounded-full", "bg-surface-container-lowest", "shadow-elevation-1", "translate-x-(--spacing-2)", "data-[checked]:translate-x-[22px]", "transition-transform", "duration-150", "ease-in-out", "motion-reduce:transition-none"]), LM = ae(["text-text-default", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), FM = ae(["text-text-subtle", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"]);
function d_(t) {
  const e = B.c(25);
  let n, o, r, i, s;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: s,
    id: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s, a = At(), c = o ?? a;
  let u;
  e[6] !== l ? (u = ne(_M({
    disabled: l
  })), e[6] = l, e[7] = u) : u = e[7];
  const d = r ? `${c}-label` : void 0, f = n ? `${c}-description` : void 0;
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = VM(), e[8] = p) : p = e[8];
  let m;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ g(f3, { className: AM() }), e[9] = m) : m = e[9];
  let h;
  e[10] !== l || e[11] !== i || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ g(d3, { ...i, id: c, disabled: l, "aria-labelledby": d, "aria-describedby": f, className: p, children: m }), e[10] = l, e[11] = i, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== r || e[18] !== c ? (b = (r || n) && /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-4)", children: [
    r && /* @__PURE__ */ g("span", { id: `${c}-label`, className: LM(), children: r }),
    n && /* @__PURE__ */ g("span", { id: `${c}-description`, className: FM(), children: n })
  ] }), e[16] = n, e[17] = r, e[18] = c, e[19] = b) : b = e[19];
  let v;
  return e[20] !== c || e[21] !== u || e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F("label", { htmlFor: c, className: u, children: [
    h,
    b
  ] }), e[20] = c, e[21] = u, e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Wo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function kn(t, e) {
  return (n) => {
    e.setState((o) => ({
      ...o,
      [t]: Wo(n, o[t])
    }));
  };
}
function Va(t) {
  return t instanceof Function;
}
function $M(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function HM(t, e) {
  const n = [], o = (r) => {
    r.forEach((i) => {
      n.push(i);
      const s = e(i);
      s != null && s.length && o(s);
    });
  };
  return o(t), n;
}
function lt(t, e, n) {
  let o = [], r;
  return (i) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const l = t(i);
    if (!(l.length !== o.length || l.some((u, d) => o[d] !== u)))
      return r;
    o = l;
    let c;
    if (n.key && n.debug && (c = Date.now()), r = e(...l), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (m, h) => {
        for (m = String(m); m.length < h; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n?.key);
    }
    return r;
  };
}
function at(t, e, n, o) {
  return {
    debug: () => {
      var r;
      return (r = t?.debugAll) != null ? r : t[e];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function zM(t, e, n, o) {
  const r = () => {
    var s;
    return (s = i.getValue()) != null ? s : t.options.renderFallbackValue;
  }, i = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(o),
    renderValue: r,
    getContext: lt(() => [t, n, e, i], (s, l, a, c) => ({
      table: s,
      column: l,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), at(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, e, t);
  }, {}), i;
}
function BM(t, e, n, o) {
  var r, i;
  const l = {
    ...t._getDefaultColumnDef(),
    ...e
  }, a = l.accessorKey;
  let c = (r = (i = l.id) != null ? i : a ? typeof String.prototype.replaceAll == "function" ? a.replaceAll(".", "_") : a.replace(/\./g, "_") : void 0) != null ? r : typeof l.header == "string" ? l.header : void 0, u;
  if (l.accessorFn ? u = l.accessorFn : a && (a.includes(".") ? u = (f) => {
    let p = f;
    for (const h of a.split(".")) {
      var m;
      p = (m = p) == null ? void 0 : m[h], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${h}" in deeply nested key "${a}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: lt(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, at(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: lt(() => [t._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let m = d.columns.flatMap((h) => h.getLeafColumns());
        return f(m);
      }
      return [d];
    }, at(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const sn = "debugHeaders";
function ug(t, e, n) {
  var o;
  let i = {
    id: (o = n.id) != null ? o : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(l), s.push(a);
      };
      return l(i), s;
    },
    getContext: () => ({
      table: t,
      header: i,
      column: e
    })
  };
  return t._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, t);
  }), i;
}
const WM = {
  createTable: (t) => {
    t.getHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => {
      var i, s;
      const l = (i = o?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], a = (s = r?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? s : [], c = n.filter((d) => !(o != null && o.includes(d.id)) && !(r != null && r.includes(d.id)));
      return ml(e, [...l, ...c, ...a], t);
    }, at(t.options, sn, "getHeaderGroups")), t.getCenterHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => (n = n.filter((i) => !(o != null && o.includes(i.id)) && !(r != null && r.includes(i.id))), ml(e, n, t, "center")), at(t.options, sn, "getCenterHeaderGroups")), t.getLeftHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return ml(e, i, t, "left");
    }, at(t.options, sn, "getLeftHeaderGroups")), t.getRightHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return ml(e, i, t, "right");
    }, at(t.options, sn, "getRightHeaderGroups")), t.getFooterGroups = lt(() => [t.getHeaderGroups()], (e) => [...e].reverse(), at(t.options, sn, "getFooterGroups")), t.getLeftFooterGroups = lt(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), at(t.options, sn, "getLeftFooterGroups")), t.getCenterFooterGroups = lt(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), at(t.options, sn, "getCenterFooterGroups")), t.getRightFooterGroups = lt(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), at(t.options, sn, "getRightFooterGroups")), t.getFlatHeaders = lt(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, sn, "getFlatHeaders")), t.getLeftFlatHeaders = lt(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, sn, "getLeftFlatHeaders")), t.getCenterFlatHeaders = lt(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, sn, "getCenterFlatHeaders")), t.getRightFlatHeaders = lt(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, sn, "getRightFlatHeaders")), t.getCenterLeafHeaders = lt(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, sn, "getCenterLeafHeaders")), t.getLeftLeafHeaders = lt(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, sn, "getLeftLeafHeaders")), t.getRightLeafHeaders = lt(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, sn, "getRightLeafHeaders")), t.getLeafHeaders = lt(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, o) => {
      var r, i, s, l, a, c;
      return [...(r = (i = e[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(a = (c = o[0]) == null ? void 0 : c.headers) != null ? a : []].map((u) => u.getLeafHeaders()).flat();
    }, at(t.options, sn, "getLeafHeaders"));
  }
};
function ml(t, e, n, o) {
  var r, i;
  let s = 0;
  const l = function(f, p) {
    p === void 0 && (p = 1), s = Math.max(s, p), f.filter((m) => m.getIsVisible()).forEach((m) => {
      var h;
      (h = m.columns) != null && h.length && l(m.columns, p + 1);
    }, 0);
  };
  l(t);
  let a = [];
  const c = (f, p) => {
    const m = {
      depth: p,
      id: [o, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    f.forEach((b) => {
      const v = [...h].reverse()[0], C = b.column.depth === m.depth;
      let y, w = !1;
      if (C && b.column.parent ? y = b.column.parent : (y = b.column, w = !0), v && v?.column === y)
        v.subHeaders.push(b);
      else {
        const R = ug(n, y, {
          id: [o, p, y.id, b?.id].filter(Boolean).join("_"),
          isPlaceholder: w,
          placeholderId: w ? `${h.filter((S) => S.column === y).length}` : void 0,
          depth: p,
          index: h.length
        });
        R.subHeaders.push(b), h.push(R);
      }
      m.headers.push(b), b.headerGroup = m;
    }), a.push(m), p > 0 && c(h, p - 1);
  }, u = e.map((f, p) => ug(n, f, {
    depth: s,
    index: p
  }));
  c(u, s - 1), a.reverse();
  const d = (f) => f.filter((m) => m.column.getIsVisible()).map((m) => {
    let h = 0, b = 0, v = [0];
    m.subHeaders && m.subHeaders.length ? (v = [], d(m.subHeaders).forEach((y) => {
      let {
        colSpan: w,
        rowSpan: R
      } = y;
      h += w, v.push(R);
    })) : h = 1;
    const C = Math.min(...v);
    return b = b + C, m.colSpan = h, m.rowSpan = b, {
      colSpan: h,
      rowSpan: b
    };
  });
  return d((r = (i = a[0]) == null ? void 0 : i.headers) != null ? r : []), a;
}
const UM = (t, e, n, o, r, i, s) => {
  let l = {
    id: e,
    index: o,
    original: n,
    depth: r,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (l._valuesCache.hasOwnProperty(a))
        return l._valuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return l._valuesCache[a] = c.accessorFn(l.original, o), l._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (l._uniqueValuesCache.hasOwnProperty(a))
        return l._uniqueValuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[a] = c.columnDef.getUniqueValues(l.original, o), l._uniqueValuesCache[a]) : (l._uniqueValuesCache[a] = [l.getValue(a)], l._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = l.getValue(a)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => HM(l.subRows, (a) => a.subRows),
    getParentRow: () => l.parentId ? t.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = l;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        a.push(u), c = u;
      }
      return a.reverse();
    },
    getAllCells: lt(() => [t.getAllLeafColumns()], (a) => a.map((c) => zM(t, l, c, c.id)), at(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: lt(() => [l.getAllCells()], (a) => a.reduce((c, u) => (c[u.column.id] = u, c), {}), at(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let a = 0; a < t._features.length; a++) {
    const c = t._features[a];
    c == null || c.createRow == null || c.createRow(l, t);
  }
  return l;
}, GM = {
  createColumn: (t, e) => {
    t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, p3 = (t, e, n) => {
  var o, r;
  const i = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
p3.autoRemove = (t) => Kn(t);
const m3 = (t, e, n) => {
  var o;
  return !!(!((o = t.getValue(e)) == null || (o = o.toString()) == null) && o.includes(n));
};
m3.autoRemove = (t) => Kn(t);
const g3 = (t, e, n) => {
  var o;
  return ((o = t.getValue(e)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === n?.toLowerCase();
};
g3.autoRemove = (t) => Kn(t);
const h3 = (t, e, n) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(n);
};
h3.autoRemove = (t) => Kn(t);
const b3 = (t, e, n) => !n.some((o) => {
  var r;
  return !((r = t.getValue(e)) != null && r.includes(o));
});
b3.autoRemove = (t) => Kn(t) || !(t != null && t.length);
const v3 = (t, e, n) => n.some((o) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(o);
});
v3.autoRemove = (t) => Kn(t) || !(t != null && t.length);
const y3 = (t, e, n) => t.getValue(e) === n;
y3.autoRemove = (t) => Kn(t);
const x3 = (t, e, n) => t.getValue(e) == n;
x3.autoRemove = (t) => Kn(t);
const w1 = (t, e, n) => {
  let [o, r] = n;
  const i = t.getValue(e);
  return i >= o && i <= r;
};
w1.resolveFilterValue = (t) => {
  let [e, n] = t, o = typeof e != "number" ? parseFloat(e) : e, r = typeof n != "number" ? parseFloat(n) : n, i = e === null || Number.isNaN(o) ? -1 / 0 : o, s = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > s) {
    const l = i;
    i = s, s = l;
  }
  return [i, s];
};
w1.autoRemove = (t) => Kn(t) || Kn(t[0]) && Kn(t[1]);
const wo = {
  includesString: p3,
  includesStringSensitive: m3,
  equalsString: g3,
  arrIncludes: h3,
  arrIncludesAll: b3,
  arrIncludesSome: v3,
  equals: y3,
  weakEquals: x3,
  inNumberRange: w1
};
function Kn(t) {
  return t == null || t === "";
}
const YM = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: kn("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      return typeof o == "string" ? wo.includesString : typeof o == "number" ? wo.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? wo.equals : Array.isArray(o) ? wo.arrIncludes : wo.weakEquals;
    }, t.getFilterFn = () => {
      var n, o;
      return Va(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = e.options.filterFns) == null ? void 0 : o[t.columnDef.filterFn]) != null ? n : wo[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, o, r;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((o = e.options.enableColumnFilters) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((o) => o.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, o;
      return (n = (o = e.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((o) => {
        const r = t.getFilterFn(), i = o?.find((u) => u.id === t.id), s = Wo(n, i ? i.value : void 0);
        if (dg(r, s, t)) {
          var l;
          return (l = o?.filter((u) => u.id !== t.id)) != null ? l : [];
        }
        const a = {
          id: t.id,
          value: s
        };
        if (i) {
          var c;
          return (c = o?.map((u) => u.id === t.id ? a : u)) != null ? c : [];
        }
        return o != null && o.length ? [...o, a] : [a];
      });
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), o = (r) => {
        var i;
        return (i = Wo(e, r)) == null ? void 0 : i.filter((s) => {
          const l = n.find((a) => a.id === s.id);
          if (l) {
            const a = l.getFilterFn();
            if (dg(a, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(o);
    }, t.resetColumnFilters = (e) => {
      var n, o;
      t.setColumnFilters(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function dg(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const jM = (t, e, n) => n.reduce((o, r) => {
  const i = r.getValue(t);
  return o + (typeof i == "number" ? i : 0);
}, 0), KM = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o > i || o === void 0 && i >= i) && (o = i);
  }), o;
}, qM = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o < i || o === void 0 && i >= i) && (o = i);
  }), o;
}, ZM = (t, e, n) => {
  let o, r;
  return n.forEach((i) => {
    const s = i.getValue(t);
    s != null && (o === void 0 ? s >= s && (o = r = s) : (o > s && (o = s), r < s && (r = s)));
  }), [o, r];
}, XM = (t, e) => {
  let n = 0, o = 0;
  if (e.forEach((r) => {
    let i = r.getValue(t);
    i != null && (i = +i) >= i && (++n, o += i);
  }), n) return o / n;
}, QM = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((i) => i.getValue(t));
  if (!$M(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, JM = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), eT = (t, e) => new Set(e.map((n) => n.getValue(t))).size, tT = (t, e) => e.length, _c = {
  sum: jM,
  min: KM,
  max: qM,
  extent: ZM,
  mean: XM,
  median: QM,
  unique: JM,
  uniqueCount: eT,
  count: tT
}, nT = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: kn("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((o) => o !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, o;
      return ((n = t.columnDef.enableGrouping) != null ? n : !0) && ((o = e.options.enableGrouping) != null ? o : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      if (typeof o == "number")
        return _c.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return _c.extent;
    }, t.getAggregationFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Va(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (o = e.options.aggregationFns) == null ? void 0 : o[t.columnDef.aggregationFn]) != null ? n : _c[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, o;
      t.setGrouping(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const o = e.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = o.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, o) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var r;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function oT(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const o = t.filter((i) => !e.includes(i.id));
  return n === "remove" ? o : [...e.map((i) => t.find((s) => s.id === i)).filter(Boolean), ...o];
}
const rT = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: kn("columnOrder", t)
  }),
  createColumn: (t, e) => {
    t.getIndex = lt((n) => [Wi(e, n)], (n) => n.findIndex((o) => o.id === t.id), at(e.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (n) => {
      var o;
      return ((o = Wi(e, n)[0]) == null ? void 0 : o.id) === t.id;
    }, t.getIsLastColumn = (n) => {
      var o;
      const r = Wi(e, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = lt(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, o) => (r) => {
      let i = [];
      if (!(e != null && e.length))
        i = r;
      else {
        const s = [...e], l = [...r];
        for (; l.length && s.length; ) {
          const a = s.shift(), c = l.findIndex((u) => u.id === a);
          c > -1 && i.push(l.splice(c, 1)[0]);
        }
        i = [...i, ...l];
      }
      return oT(i, n, o);
    }, at(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Vc = () => ({
  left: [],
  right: []
}), iT = {
  getInitialState: (t) => ({
    columnPinning: Vc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: kn("columnPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const o = t.getLeafColumns().map((r) => r.id).filter(Boolean);
      e.setColumnPinning((r) => {
        var i, s;
        if (n === "right") {
          var l, a;
          return {
            left: ((l = r?.left) != null ? l : []).filter((d) => !(o != null && o.includes(d))),
            right: [...((a = r?.right) != null ? a : []).filter((d) => !(o != null && o.includes(d))), ...o]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = r?.left) != null ? c : []).filter((d) => !(o != null && o.includes(d))), ...o],
            right: ((u = r?.right) != null ? u : []).filter((d) => !(o != null && o.includes(d)))
          };
        }
        return {
          left: ((i = r?.left) != null ? i : []).filter((d) => !(o != null && o.includes(d))),
          right: ((s = r?.right) != null ? s : []).filter((d) => !(o != null && o.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((o) => {
      var r, i, s;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((i = (s = e.options.enableColumnPinning) != null ? s : e.options.enablePinning) != null ? i : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((l) => l.id), {
        left: o,
        right: r
      } = e.getState().columnPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "left" : s ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      return r ? (n = (o = e.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.getCenterVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, o, r) => {
      const i = [...o ?? [], ...r ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, at(e.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.left], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), at(e.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), at(e.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, o;
      return t.setColumnPinning(e ? Vc() : (n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : Vc());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const o = t.getState().columnPinning;
      if (!e) {
        var r, i;
        return !!((r = o.left) != null && r.length || (i = o.right) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t.getLeftLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), at(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), at(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return e.filter((i) => !r.includes(i.id));
    }, at(t.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function sT(t) {
  return t || (typeof document < "u" ? document : null);
}
const gl = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ac = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), lT = {
  getDefaultColumnDef: () => gl,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: Ac(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: kn("columnSizing", t),
    onColumnSizingInfoChange: kn("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, o, r;
      const i = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : gl.minSize, (o = i ?? t.columnDef.size) != null ? o : gl.size), (r = t.columnDef.maxSize) != null ? r : gl.maxSize);
    }, t.getStart = lt((n) => [n, Wi(e, n), e.getState().columnSizing], (n, o) => o.slice(0, t.getIndex(n)).reduce((r, i) => r + i.getSize(), 0), at(e.options, "debugColumns", "getStart")), t.getAfter = lt((n) => [n, Wi(e, n), e.getState().columnSizing], (n, o) => o.slice(t.getIndex(n) + 1).reduce((r, i) => r + i.getSize(), 0), at(e.options, "debugColumns", "getAfter")), t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: o,
          ...r
        } = n;
        return r;
      });
    }, t.getCanResize = () => {
      var n, o;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((o = e.options.enableColumnResizing) != null ? o : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var i;
          n += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return o(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = (n) => {
      const o = e.getColumn(t.column.id), r = o?.getCanResize();
      return (i) => {
        if (!o || !r || (i.persist == null || i.persist(), Lc(i) && i.touches && i.touches.length > 1))
          return;
        const s = t.getSize(), l = t ? t.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[o.id, o.getSize()]], a = Lc(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (v, C) => {
          typeof C == "number" && (e.setColumnSizingInfo((y) => {
            var w, R;
            const S = e.options.columnResizeDirection === "rtl" ? -1 : 1, E = (C - ((w = y?.startOffset) != null ? w : 0)) * S, N = Math.max(E / ((R = y?.startSize) != null ? R : 0), -0.999999);
            return y.columnSizingStart.forEach((M) => {
              let [T, P] = M;
              c[T] = Math.round(Math.max(P + P * N, 0) * 100) / 100;
            }), {
              ...y,
              deltaOffset: E,
              deltaPercentage: N
            };
          }), (e.options.columnResizeMode === "onChange" || v === "end") && e.setColumnSizing((y) => ({
            ...y,
            ...c
          })));
        }, d = (v) => u("move", v), f = (v) => {
          u("end", v), e.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = sT(n), m = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            p?.removeEventListener("mousemove", m.moveHandler), p?.removeEventListener("mouseup", m.upHandler), f(v.clientX);
          }
        }, h = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var C;
            p?.removeEventListener("touchmove", h.moveHandler), p?.removeEventListener("touchend", h.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), f((C = v.touches[0]) == null ? void 0 : C.clientX);
          }
        }, b = aT() ? {
          passive: !1
        } : !1;
        Lc(i) ? (p?.addEventListener("touchmove", h.moveHandler, b), p?.addEventListener("touchend", h.upHandler, b)) : (p?.addEventListener("mousemove", m.moveHandler, b), p?.addEventListener("mouseup", m.upHandler, b)), e.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: a,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? Ac() : (n = t.initialState.columnSizingInfo) != null ? n : Ac());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    };
  }
};
let hl = null;
function aT() {
  if (typeof hl == "boolean") return hl;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return hl = t, hl;
}
function Lc(t) {
  return t.type === "touchstart";
}
const cT = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: kn("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((o) => ({
        ...o,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, o;
      const r = t.columns;
      return (n = r.length ? r.some((i) => i.getIsVisible()) : (o = e.getState().columnVisibility) == null ? void 0 : o[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, o;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((o = e.options.enableHiding) != null ? o : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = lt(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), at(e.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = lt(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], at(e.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const e = (n, o) => lt(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), at(t.options, "debugColumns", n));
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var o;
      t.setColumnVisibility(n ? {} : (o = t.initialState.columnVisibility) != null ? o : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      t.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function Wi(t, e) {
  return e ? e === "center" ? t.getCenterVisibleLeafColumns() : e === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const uT = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, dT = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: kn("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const o = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getCanGlobalFilter = () => {
      var n, o, r, i;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = e.options.enableGlobalFilter) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && ((i = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? i : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => wo.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: o
      } = t.options;
      return Va(o) ? o : o === "auto" ? t.getGlobalAutoFilterFn() : (e = (n = t.options.filterFns) == null ? void 0 : n[o]) != null ? e : wo[o];
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    };
  }
}, fT = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: kn("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetExpanded) != null ? o : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (o) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o), t.toggleAllRowsExpanded = (o) => {
      o ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (o) => {
      var r, i;
      t.setExpanded(o ? {} : (r = (i = t.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const o = t.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const o = t.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || t.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let o = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        o = Math.max(o, s.length);
      }), o;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((o) => {
        var r;
        const i = o === !0 ? !0 : !!(o != null && o[t.id]);
        let s = {};
        if (o === !0 ? Object.keys(e.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = o, n = (r = n) != null ? r : !i, !i && n)
          return {
            ...s,
            [t.id]: !0
          };
        if (i && !n) {
          const {
            [t.id]: l,
            ...a
          } = s;
          return a;
        }
        return o;
      });
    }, t.getIsExpanded = () => {
      var n;
      const o = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : o === !0 || o?.[t.id]);
    }, t.getCanExpand = () => {
      var n, o, r;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((o = e.options.enableExpanding) != null ? o : !0) && !!((r = t.subRows) != null && r.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, o = t;
      for (; n && o.parentId; )
        o = e.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, xu = 0, Cu = 10, Fc = () => ({
  pageIndex: xu,
  pageSize: Cu
}), pT = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Fc(),
      ...t?.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: kn("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetPageIndex) != null ? o : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (o) => {
      const r = (i) => Wo(o, i);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(r);
    }, t.resetPagination = (o) => {
      var r;
      t.setPagination(o ? Fc() : (r = t.initialState.pagination) != null ? r : Fc());
    }, t.setPageIndex = (o) => {
      t.setPagination((r) => {
        let i = Wo(o, r.pageIndex);
        const s = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...r,
          pageIndex: i
        };
      });
    }, t.resetPageIndex = (o) => {
      var r, i;
      t.setPageIndex(o ? xu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : xu);
    }, t.resetPageSize = (o) => {
      var r, i;
      t.setPageSize(o ? Cu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : Cu);
    }, t.setPageSize = (o) => {
      t.setPagination((r) => {
        const i = Math.max(1, Wo(o, r.pageSize)), s = r.pageSize * r.pageIndex, l = Math.floor(s / i);
        return {
          ...r,
          pageIndex: l,
          pageSize: i
        };
      });
    }, t.setPageCount = (o) => t.setPagination((r) => {
      var i;
      let s = Wo(o, (i = t.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...r,
        pageCount: s
      };
    }), t.getPageOptions = lt(() => [t.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((i, s) => s)), r;
    }, at(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: o
      } = t.getState().pagination, r = t.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, t.previousPage = () => t.setPageIndex((o) => o - 1), t.nextPage = () => t.setPageIndex((o) => o + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var o;
      return (o = t.options.pageCount) != null ? o : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var o;
      return (o = t.options.rowCount) != null ? o : t.getPrePaginationRowModel().rows.length;
    };
  }
}, $c = () => ({
  top: [],
  bottom: []
}), mT = {
  getInitialState: (t) => ({
    rowPinning: $c(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: kn("rowPinning", t)
  }),
  createRow: (t, e) => {
    t.pin = (n, o, r) => {
      const i = o ? t.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], s = r ? t.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...s, t.id, ...i]);
      e.setRowPinning((a) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = a?.top) != null ? d : []).filter((h) => !(l != null && l.has(h))),
            bottom: [...((f = a?.bottom) != null ? f : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var p, m;
          return {
            top: [...((p = a?.top) != null ? p : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)],
            bottom: ((m = a?.bottom) != null ? m : []).filter((h) => !(l != null && l.has(h)))
          };
        }
        return {
          top: ((c = a?.top) != null ? c : []).filter((h) => !(l != null && l.has(h))),
          bottom: ((u = a?.bottom) != null ? u : []).filter((h) => !(l != null && l.has(h)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = e.options;
      return typeof o == "function" ? o(t) : (n = o ?? r) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: o,
        bottom: r
      } = e.getState().rowPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "top" : s ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      if (!r) return -1;
      const i = (n = r === "top" ? e.getTopRows() : e.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (o = i?.indexOf(t.id)) != null ? o : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, o;
      return t.setRowPinning(e ? $c() : (n = (o = t.initialState) == null ? void 0 : o.rowPinning) != null ? n : $c());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const o = t.getState().rowPinning;
      if (!e) {
        var r, i;
        return !!((r = o.top) != null && r.length || (i = o.bottom) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t._getPinnedRows = (e, n, o) => {
      var r;
      return ((r = t.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const l = t.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => e.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: o
      }));
    }, t.getTopRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.top], (e, n) => t._getPinnedRows(e, n, "top"), at(t.options, "debugRows", "getTopRows")), t.getBottomRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (e, n) => t._getPinnedRows(e, n, "bottom"), at(t.options, "debugRows", "getBottomRows")), t.getCenterRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return e.filter((i) => !r.has(i.id));
    }, at(t.options, "debugRows", "getCenterRows"));
  }
}, gT = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: kn("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = t.getPreGroupedRowModel().flatRows;
        return e ? r.forEach((i) => {
          i.getCanSelect() && (o[i.id] = !0);
        }) : r.forEach((i) => {
          delete o[i.id];
        }), o;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const o = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return t.getRowModel().rows.forEach((i) => {
        wu(r, i.id, o, !0, t);
      }), r;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = lt(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? Hc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = lt(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? Hc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = lt(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? Hc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let o = !!(e.length && Object.keys(n).length);
      return o && e.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let o = !!e.length;
      return o && e.some((r) => !n[r.id]) && (o = !1), o;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, o) => {
      const r = t.getIsSelected();
      e.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !r, t.getCanSelect() && r === n)
          return i;
        const l = {
          ...i
        };
        return wu(l, t.id, n, (s = o?.selectChildren) != null ? s : !0, e), l;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return S1(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Su(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Su(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (o) => {
        var r;
        n && t.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, wu = (t, e, n, o, r) => {
  var i;
  const s = r.getRow(e, !0);
  n ? (s.getCanMultiSelect() || Object.keys(t).forEach((l) => delete t[l]), s.getCanSelect() && (t[e] = !0)) : delete t[e], o && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => wu(t, l.id, n, o, r));
};
function Hc(t, e) {
  const n = t.getState().rowSelection, o = [], r = {}, i = function(s, l) {
    return s.map((a) => {
      var c;
      const u = S1(a, n);
      if (u && (o.push(a), r[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: i(a.subRows)
      }), u)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: i(e.rows),
    flatRows: o,
    rowsById: r
  };
}
function S1(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function Su(t, e, n) {
  var o;
  if (!((o = t.subRows) != null && o.length)) return !1;
  let r = !0, i = !1;
  return t.subRows.forEach((s) => {
    if (!(i && !r) && (s.getCanSelect() && (S1(s, e) ? i = !0 : r = !1), s.subRows && s.subRows.length)) {
      const l = Su(s, e);
      l === "all" ? i = !0 : (l === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const Ru = /([0-9]+)/gm, hT = (t, e, n) => C3(Qo(t.getValue(n)).toLowerCase(), Qo(e.getValue(n)).toLowerCase()), bT = (t, e, n) => C3(Qo(t.getValue(n)), Qo(e.getValue(n))), vT = (t, e, n) => R1(Qo(t.getValue(n)).toLowerCase(), Qo(e.getValue(n)).toLowerCase()), yT = (t, e, n) => R1(Qo(t.getValue(n)), Qo(e.getValue(n))), xT = (t, e, n) => {
  const o = t.getValue(n), r = e.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, CT = (t, e, n) => R1(t.getValue(n), e.getValue(n));
function R1(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function Qo(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function C3(t, e) {
  const n = t.split(Ru).filter(Boolean), o = e.split(Ru).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), i = o.shift(), s = parseInt(r, 10), l = parseInt(i, 10), a = [s, l].sort();
    if (isNaN(a[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - o.length;
}
const Oi = {
  alphanumeric: hT,
  alphanumericCaseSensitive: bT,
  text: vT,
  textCaseSensitive: yT,
  datetime: xT,
  basic: CT
}, wT = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: kn("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const i = r?.getValue(t.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Oi.datetime;
        if (typeof i == "string" && (o = !0, i.split(Ru).length > 1))
          return Oi.alphanumeric;
      }
      return o ? Oi.text : Oi.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(t.id) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Va(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (o = e.options.sortingFns) == null ? void 0 : o[t.columnDef.sortingFn]) != null ? n : Oi[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, o) => {
      const r = t.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      e.setSorting((s) => {
        const l = s?.find((p) => p.id === t.id), a = s?.findIndex((p) => p.id === t.id);
        let c = [], u, d = i ? n : r === "desc";
        if (s != null && s.length && t.getCanMultiSort() && o ? l ? u = "toggle" : u = "add" : s != null && s.length && a !== s.length - 1 ? u = "replace" : l ? u = "toggle" : u = "replace", u === "toggle" && (i || r || (u = "remove")), u === "add") {
          var f;
          c = [...s, {
            id: t.id,
            desc: d
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = s.map((p) => p.id === t.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = s.filter((p) => p.id !== t.id) : c = [{
          id: t.id,
          desc: d
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = t.columnDef.sortDescFirst) != null ? o : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var o, r;
      const i = t.getFirstSortDir(), s = t.getIsSorted();
      return s ? s !== i && ((o = e.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = e.options.enableMultiRemove) != null) || r) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, t.getCanSort = () => {
      var n, o;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((o = e.options.enableSorting) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, o;
      return (n = (o = t.columnDef.enableMultiSort) != null ? o : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const o = (n = e.getState().sorting) == null ? void 0 : n.find((r) => r.id === t.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, o;
      return (n = (o = e.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, o;
      t.setSorting(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, ST = [
  WM,
  cT,
  rT,
  iT,
  GM,
  YM,
  uT,
  //depends on ColumnFaceting
  dT,
  //depends on ColumnFiltering
  wT,
  nT,
  //depends on RowSorting
  fT,
  pT,
  mT,
  gT,
  lT
];
function RT(t) {
  var e, n;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const o = [...ST, ...(e = t._features) != null ? e : []];
  let r = {
    _features: o
  };
  const i = r._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(r)), {}), s = (f) => r.options.mergeOptions ? r.options.mergeOptions(i, f) : {
    ...i,
    ...f
  };
  let a = {
    ...{},
    ...(n = t.initialState) != null ? n : {}
  };
  r._features.forEach((f) => {
    var p;
    a = (p = f.getInitialState == null ? void 0 : f.getInitialState(a)) != null ? p : a;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: o,
    options: {
      ...i,
      ...t
    },
    initialState: a,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (f) => {
      const p = Wo(f, r.options);
      r.options = s(p);
    },
    getState: () => r.options.state,
    setState: (f) => {
      r.options.onStateChange == null || r.options.onStateChange(f);
    },
    _getRowId: (f, p, m) => {
      var h;
      return (h = r.options.getRowId == null ? void 0 : r.options.getRowId(f, p, m)) != null ? h : `${m ? [m.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let m = (p ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[f];
      if (!m && (m = r.getCoreRowModel().rowsById[f], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: lt(() => [r.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (m) => {
          const h = m.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var h, b;
          return (h = (b = m.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? h : null;
        },
        ...r._features.reduce((m, h) => Object.assign(m, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...f
      };
    }, at(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: lt(() => [r._getColumnDefs()], (f) => {
      const p = function(m, h, b) {
        return b === void 0 && (b = 0), m.map((v) => {
          const C = BM(r, v, b, h), y = v;
          return C.columns = y.columns ? p(y.columns, C, b + 1) : [], C;
        });
      };
      return p(f);
    }, at(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: lt(() => [r.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), at(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: lt(() => [r.getAllFlatColumns()], (f) => f.reduce((p, m) => (p[m.id] = m, p), {}), at(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: lt(() => [r.getAllColumns(), r._getOrderColumnsFn()], (f, p) => {
      let m = f.flatMap((h) => h.getLeafColumns());
      return p(m);
    }, at(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = r._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(r, d);
  for (let f = 0; f < r._features.length; f++) {
    const p = r._features[f];
    p == null || p.createTable == null || p.createTable(r);
  }
  return r;
}
function ET() {
  return (t) => lt(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, i, s) {
      i === void 0 && (i = 0);
      const l = [];
      for (let c = 0; c < r.length; c++) {
        const u = UM(t, t._getRowId(r[c], c, s), r[c], c, i, void 0, s?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, l.push(u), t.options.getSubRows) {
          var a;
          u.originalSubRows = t.options.getSubRows(r[c], c), (a = u.originalSubRows) != null && a.length && (u.subRows = o(u.originalSubRows, i + 1, u));
        }
      }
      return l;
    };
    return n.rows = o(e), n;
  }, at(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function NT(t) {
  const e = [], n = (o) => {
    var r;
    e.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function kT(t) {
  return (e) => lt(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: a
    } = o;
    const c = r * i, u = c + r;
    s = s.slice(c, u);
    let d;
    e.options.paginateExpandedRows ? d = {
      rows: s,
      flatRows: l,
      rowsById: a
    } : d = NT({
      rows: s,
      flatRows: l,
      rowsById: a
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, at(e.options, "debugTable", "getPaginationRowModel"));
}
function IT() {
  return (t) => lt(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const o = t.getState().sorting, r = [], i = o.filter((a) => {
      var c;
      return (c = t.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), s = {};
    i.forEach((a) => {
      const c = t.getColumn(a.id);
      c && (s[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (a) => {
      const c = a.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < i.length; p += 1) {
          var f;
          const m = i[p], h = s[m.id], b = h.sortUndefined, v = (f = m?.desc) != null ? f : !1;
          let C = 0;
          if (b) {
            const y = u.getValue(m.id), w = d.getValue(m.id), R = y === void 0, S = w === void 0;
            if (R || S) {
              if (b === "first") return R ? -1 : 1;
              if (b === "last") return R ? 1 : -1;
              C = R && S ? 0 : R ? b : -b;
            }
          }
          if (C === 0 && (C = h.sortingFn(u, d, m.id)), C !== 0)
            return v && (C *= -1), h.invertSorting && (C *= -1), C;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        r.push(u), (d = u.subRows) != null && d.length && (u.subRows = l(u.subRows));
      }), c;
    };
    return {
      rows: l(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, at(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function fg(t, e) {
  return t ? PT(t) ? /* @__PURE__ */ x.createElement(t, e) : t : null;
}
function PT(t) {
  return MT(t) || typeof t == "function" || TT(t);
}
function MT(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function TT(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function OT(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = x.useState(() => ({
    current: RT(e)
  })), [o, r] = x.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...t,
    state: {
      ...o,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      r(s), t.onStateChange == null || t.onStateChange(s);
    }
  })), n.current;
}
const DT = {
  starting: "169px",
  text: "170px",
  doubleLine: "250px",
  chip: "90px",
  chipText: "250px",
  currency: "130px",
  icon: "52px",
  button: "191px",
  toggle: "207px",
  dropdown: "182px",
  input: "var(--table-input-cell-width)",
  calendar: "208px",
  expand: "80px",
  endingSpacer: "8px"
}, _T = ae(["w-full", "caption-bottom", "border-collapse", "bg-table-row-light-surface", "text-text-default", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "@max-[480px]/data-table:[--table-input-cell-width:167px]", "@max-[480px]/data-table:[--table-row-height:56px]"], {
  variants: {
    size: {
      sm: ["[--table-input-cell-width:167px]", "[--table-row-height:56px]"],
      md: ["[--table-input-cell-width:167px]", "[--table-row-height:68px]"],
      lg: ["[--table-input-cell-width:208px]", "[--table-row-height:84px]"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), VT = ae(["relative", "border-b", "border-table-outline", "transition-[box-shadow]", "duration-200", "ease-in-out", "data-[interactive]:cursor-pointer", "data-[selected]:bg-table-row-select"], {
  variants: {
    section: {
      header: ["h-(--spacing-40)"],
      body: ["h-(--table-row-height)", "hover:z-[1]", "hover:shadow-elevation-2"]
    }
  },
  defaultVariants: {
    section: "body"
  }
}), AT = ae(["[&>td:first-child]:relative", "[&>td:first-child]:before:pointer-events-none", "[&>td:first-child]:before:absolute", "[&>td:first-child]:before:inset-y-0", "[&>td:first-child]:before:left-0", "[&>td:first-child]:before:w-(--spacing-4)", "[&>td:first-child]:before:content-['']"], {
  variants: {
    tone: {
      brand: "[&>td:first-child]:before:bg-primary",
      positive: "[&>td:first-child]:before:bg-positive",
      warning: "[&>td:first-child]:before:bg-accessibility-warning",
      negative: "[&>td:first-child]:before:bg-negative",
      informative: "[&>td:first-child]:before:bg-informative"
    }
  }
}), w3 = ae([], {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), LT = ae(["h-(--spacing-40)", "whitespace-nowrap", "border-b", "border-table-outline", "bg-table-row-alt-surface", "py-0", "align-middle", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-16)", "text-table-header-text"], {
  variants: {
    variant: {
      default: ["px-(--spacing-16)"],
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      spacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), FT = ae(["h-(--table-row-height)", "min-w-0", "px-(--spacing-16)", "py-0", "align-middle", "text-text-default"], {
  variants: {
    variant: {
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      text: null,
      doubleLine: null,
      chip: null,
      chipText: null,
      currency: ["font-(family-name:--font-family-label)"],
      icon: ["px-(--spacing-16)", "text-center"],
      button: null,
      toggle: null,
      dropdown: null,
      input: null,
      calendar: null,
      expand: ["px-(--spacing-16)", "text-center"],
      endingSpacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "text"
  }
});
function S3(t, e) {
  return t !== void 0 ? typeof t == "number" ? `${t}px` : t : e ? DT[e] : void 0;
}
function R3(t, e) {
  return e ? {
    ...t,
    width: e,
    minWidth: e
  } : t;
}
function E3(t) {
  if (t === "compact") return "@max-[480px]/data-table:hidden";
  if (t === "comfortable") return "@max-[768px]/data-table:hidden";
  if (t === "expanded") return "@max-[1024px]/data-table:hidden";
  if (t === "wide") return "@max-[1280px]/data-table:hidden";
}
function $T(t) {
  const e = B.c(11);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    style: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "md" : r;
  let s;
  e[4] !== i ? (s = _T({
    size: i
  }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== i || e[8] !== o || e[9] !== s ? (l = /* @__PURE__ */ g("table", { "data-slot": "table", "data-size": i, className: s, style: o, ...n }), e[6] = n, e[7] = i, e[8] = o, e[9] = s, e[10] = l) : l = e[10], l;
}
function HT(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("thead", { "data-slot": "table-header", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function zT(t) {
  const e = B.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("tbody", { "data-slot": "table-body", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function zc(t) {
  const e = B.c(17);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    accentTone: n,
    selected: s,
    interactive: l,
    section: i,
    children: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !1 : s, c = l === void 0 ? !1 : l, u = a ? "" : void 0, d = c ? "" : void 0, f = a || void 0;
  let p;
  e[7] !== n || e[8] !== i ? (p = ne(VT({
    section: i
  }), i !== "header" && n && AT({
    tone: n
  })), e[7] = n, e[8] = i, e[9] = p) : p = e[9];
  let m;
  return e[10] !== o || e[11] !== r || e[12] !== u || e[13] !== d || e[14] !== f || e[15] !== p ? (m = /* @__PURE__ */ g("tr", { "data-slot": "table-row", "data-selected": u, "data-interactive": d, "aria-selected": f, className: p, ...r, children: o }), e[10] = o, e[11] = r, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m) : m = e[16], m;
}
function BT(t) {
  return t || "none";
}
function pg(t, e) {
  return t ? t === e ? "text-primary" : "text-icon-disabled" : "text-icon-main";
}
function WT(t) {
  const e = B.c(13), {
    direction: n
  } = t;
  let o;
  e[0] !== n ? (o = ne("absolute left-(--spacing-2) top-[3px] inline-flex", pg(n, "ascending")), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(We, { name: "chevron-up", size: "xs", tone: "inherit" }), e[2] = r) : r = e[2];
  let i;
  e[3] !== o ? (i = /* @__PURE__ */ g("span", { className: o, children: r }), e[3] = o, e[4] = i) : i = e[4];
  let s;
  e[5] !== n ? (s = ne("absolute left-(--spacing-2) top-[9px] inline-flex", pg(n, "descending")), e[5] = n, e[6] = s) : s = e[6];
  let l;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g(We, { name: "chevron-down", size: "xs", tone: "inherit" }), e[7] = l) : l = e[7];
  let a;
  e[8] !== s ? (a = /* @__PURE__ */ g("span", { className: s, children: l }), e[8] = s, e[9] = a) : a = e[9];
  let c;
  return e[10] !== i || e[11] !== a ? (c = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "relative block h-[28px] w-(--spacing-20) shrink-0", children: [
    i,
    a
  ] }), e[10] = i, e[11] = a, e[12] = c) : c = e[12], c;
}
function UT(t) {
  const e = B.c(72);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    align: n,
    children: o,
    leadingCheckbox: i,
    sortable: c,
    sortDirection: u,
    tooltip: d,
    hideBelow: r,
    variant: f,
    width: p,
    style: a,
    onSort: s,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const m = c === void 0 ? !1 : c, h = u === void 0 ? !1 : u;
  let b, v, C, y, w;
  if (e[13] !== n || e[14] !== o || e[15] !== r || e[16] !== i || e[17] !== s || e[18] !== h || e[19] !== m || e[20] !== a || e[21] !== d || e[22] !== f || e[23] !== p) {
    const S = S3(p);
    let E;
    e[29] !== d ? (E = d ? /* @__PURE__ */ g(qo, { label: d, showArrow: !1, children: /* @__PURE__ */ g("button", { type: "button", className: "inline-flex shrink-0 items-center border-0 bg-transparent p-0 text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "aria-label": d, children: /* @__PURE__ */ g(We, { name: "circle-info", size: "xs", tone: "inherit" }) }) }) : null, e[29] = d, e[30] = E) : E = e[30];
    const N = E, M = n === "right" && "justify-end", T = n === "center" && "justify-center";
    let P;
    e[31] !== M || e[32] !== T ? (P = ne("flex min-w-0 items-center gap-(--spacing-8)", M, T), e[31] = M, e[32] = T, e[33] = P) : P = e[33];
    let k;
    e[34] !== o ? (k = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: o }), e[34] = o, e[35] = k) : k = e[35];
    let I;
    e[36] !== h || e[37] !== m ? (I = m && /* @__PURE__ */ g(WT, { direction: h }), e[36] = h, e[37] = m, e[38] = I) : I = e[38];
    let D;
    e[39] !== P || e[40] !== k || e[41] !== I ? (D = /* @__PURE__ */ F("span", { className: P, children: [
      k,
      I
    ] }), e[39] = P, e[40] = k, e[41] = I, e[42] = D) : D = e[42];
    const O = D, V = n === "right" && "justify-end", _ = n === "center" && "justify-center";
    let L;
    e[43] !== V || e[44] !== _ ? (L = ne("flex min-w-0 items-center gap-(--spacing-12)", V, _), e[43] = V, e[44] = _, e[45] = L) : L = e[45];
    let A;
    e[46] !== i ? (A = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0", children: i }), e[46] = i, e[47] = A) : A = e[47];
    let $;
    e[48] !== n || e[49] !== O || e[50] !== s || e[51] !== m ? ($ = m ? /* @__PURE__ */ g("button", { type: "button", onClick: s, className: ne("flex h-full min-w-0 items-center bg-transparent p-0 text-inherit", "border-0 outline-none cursor-pointer", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", n === "right" && "justify-end", n === "center" && "justify-center"), children: O }) : O, e[48] = n, e[49] = O, e[50] = s, e[51] = m, e[52] = $) : $ = e[52];
    let Y;
    e[53] !== L || e[54] !== A || e[55] !== $ || e[56] !== N ? (Y = /* @__PURE__ */ F("span", { className: L, children: [
      A,
      $,
      N
    ] }), e[53] = L, e[54] = A, e[55] = $, e[56] = N, e[57] = Y) : Y = e[57], b = Y, v = "table-head", e[58] !== h || e[59] !== m ? (C = m ? BT(h) : void 0, e[58] = h, e[59] = m, e[60] = C) : C = e[60], e[61] !== n || e[62] !== r || e[63] !== f ? (y = ne(LT({
      variant: f
    }), w3({
      align: n
    }), E3(r)), e[61] = n, e[62] = r, e[63] = f, e[64] = y) : y = e[64], w = R3(a, S), e[13] = n, e[14] = o, e[15] = r, e[16] = i, e[17] = s, e[18] = h, e[19] = m, e[20] = a, e[21] = d, e[22] = f, e[23] = p, e[24] = b, e[25] = v, e[26] = C, e[27] = y, e[28] = w;
  } else
    b = e[24], v = e[25], C = e[26], y = e[27], w = e[28];
  let R;
  return e[65] !== b || e[66] !== l || e[67] !== v || e[68] !== C || e[69] !== y || e[70] !== w ? (R = /* @__PURE__ */ g("th", { "data-slot": v, "aria-sort": C, className: y, style: w, ...l, children: b }), e[65] = b, e[66] = l, e[67] = v, e[68] = C, e[69] = y, e[70] = w, e[71] = R) : R = e[71], R;
}
function GT(t) {
  const e = B.c(31);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    align: n,
    variant: a,
    hideBelow: r,
    width: c,
    style: s,
    children: o,
    emptyFallback: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = l === void 0 ? "--" : l, d = a ?? "text";
  let f, p, m, h, b;
  if (e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== d || e[13] !== s || e[14] !== c) {
    const y = S3(c, d);
    f = o == null || typeof o == "string" && o.trim() === "", p = "table-cell", m = d, e[20] !== n || e[21] !== r || e[22] !== d ? (h = ne(FT({
      variant: d
    }), w3({
      align: n
    }), E3(r)), e[20] = n, e[21] = r, e[22] = d, e[23] = h) : h = e[23], b = R3(s, y), e[9] = n, e[10] = o, e[11] = r, e[12] = d, e[13] = s, e[14] = c, e[15] = f, e[16] = p, e[17] = m, e[18] = h, e[19] = b;
  } else
    f = e[15], p = e[16], m = e[17], h = e[18], b = e[19];
  const v = d === "endingSpacer" ? null : f ? u : o;
  let C;
  return e[24] !== i || e[25] !== p || e[26] !== m || e[27] !== h || e[28] !== b || e[29] !== v ? (C = /* @__PURE__ */ g("td", { "data-slot": p, "data-variant": m, className: h, style: b, ...i, children: v }), e[24] = i, e[25] = p, e[26] = m, e[27] = h, e[28] = b, e[29] = v, e[30] = C) : C = e[30], C;
}
function N3(t) {
  const e = B.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex min-w-0 flex-col gap-(--spacing-2)", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function E1(t) {
  const e = B.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function N1(t) {
  const e = B.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtext", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function YT(t) {
  const e = B.c(15), {
    status: n,
    checkbox: o,
    thumbnail: r,
    avatar: i,
    icon: s,
    primary: l,
    secondary: a,
    chip: c
  } = t;
  let u;
  e[0] !== l ? (u = /* @__PURE__ */ g(E1, { children: l }), e[0] = l, e[1] = u) : u = e[1];
  let d;
  e[2] !== c || e[3] !== a ? (d = (a || c) && /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-4) pt-(--spacing-4)", children: [
    a && /* @__PURE__ */ g(N1, { children: a }),
    c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
  ] }), e[2] = c, e[3] = a, e[4] = d) : d = e[4];
  let f;
  e[5] !== u || e[6] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-col justify-center", children: [
    u,
    d
  ] }), e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  let p;
  return e[8] !== i || e[9] !== o || e[10] !== s || e[11] !== n || e[12] !== f || e[13] !== r ? (p = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    o,
    r,
    i,
    s,
    f
  ] }), e[8] = i, e[9] = o, e[10] = s, e[11] = n, e[12] = f, e[13] = r, e[14] = p) : p = e[14], p;
}
function jT(t) {
  const e = B.c(15), {
    leadingIcon: n,
    main: o,
    supporting: r,
    trailingIcon: i
  } = t;
  let s;
  e[0] !== n ? (s = n && /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(E1, { children: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r && /* @__PURE__ */ g(N1, { children: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  e[6] !== l || e[7] !== a ? (c = /* @__PURE__ */ F(N3, { children: [
    l,
    a
  ] }), e[6] = l, e[7] = a, e[8] = c) : c = e[8];
  let u;
  e[9] !== i ? (u = i && /* @__PURE__ */ g("span", { className: "shrink-0", children: i }), e[9] = i, e[10] = u) : u = e[10];
  let d;
  return e[11] !== s || e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    s,
    c,
    u
  ] }), e[11] = s, e[12] = c, e[13] = u, e[14] = d) : d = e[14], d;
}
function KT(t) {
  const e = B.c(7), {
    chip: n,
    secondary: o
  } = t;
  let r;
  e[0] !== n ? (r = /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = r) : r = e[1];
  let i;
  e[2] !== o ? (i = o && /* @__PURE__ */ g("span", { className: "min-w-0 truncate text-text-subtext", children: o }), e[2] = o, e[3] = i) : i = e[3];
  let s;
  return e[4] !== r || e[5] !== i ? (s = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    r,
    i
  ] }), e[4] = r, e[5] = i, e[6] = s) : s = e[6], s;
}
const mg = Object.assign(GT, {
  ChipText: KT,
  Primary: E1,
  Secondary: N1,
  Stack: N3,
  Starting: YT,
  Text: jT
});
function qT(t) {
  return t === "asc" ? "ascending" : t === "desc" ? "descending" : !1;
}
function ZT() {
  return import.meta.env?.DEV ?? !1;
}
function f_({
  ariaLabel: t,
  columns: e,
  data: n,
  size: o = "md",
  getRowId: r,
  sorting: i,
  onSortingChange: s,
  manualSorting: l = !1,
  rowSelection: a,
  onRowSelectionChange: c,
  enableRowSelection: u,
  getRowAccentTone: d,
  pagination: f,
  manualPagination: p = !1,
  emptyMessage: m = "No results.",
  variant: h = "fullWidth"
}) {
  const b = u ?? !!(a || c), v = {
    ...i !== void 0 ? {
      sorting: i
    } : {},
    ...a !== void 0 ? {
      rowSelection: a
    } : {},
    ...f !== void 0 ? {
      pagination: {
        pageIndex: Math.max(0, f.currentPage - 1),
        pageSize: f.rowsPerPage
      }
    } : {}
  }, C = OT({
    data: n,
    columns: e,
    defaultColumn: {
      enableSorting: !1
    },
    getRowId: r,
    state: v,
    enableRowSelection: b,
    onSortingChange: s,
    onRowSelectionChange: c,
    manualSorting: l,
    manualPagination: p,
    getCoreRowModel: ET(),
    ...l ? {} : {
      getSortedRowModel: IT()
    },
    ...f !== void 0 && !p ? {
      getPaginationRowModel: kT()
    } : {},
    ...f !== void 0 ? {
      pageCount: f.totalPages
    } : {}
  }), y = C.getVisibleLeafColumns(), w = y[0], R = w?.columnDef.meta;
  return ZT() && w && R?.cellVariant !== "starting" && console.warn("DataTable expects the first visible column to use meta.cellVariant = 'starting' to match the table design-system contract."), /* @__PURE__ */ F("div", { "data-slot": "data-table", "data-variant": h, className: ne("@container/data-table w-full", h === "card" && ["overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"]), children: [
    /* @__PURE__ */ g("div", { "data-slot": "data-table-scroll", className: "w-full overflow-x-auto bg-table-row-light-surface pb-(--spacing-8)", children: /* @__PURE__ */ F($T, { size: o, "aria-label": t, children: [
      /* @__PURE__ */ g(HT, { children: C.getHeaderGroups().map((S) => /* @__PURE__ */ g(zc, { section: "header", children: S.headers.map((E) => {
        const N = E.column.columnDef.meta, M = E.column.getCanSort(), T = E.column.getToggleSortingHandler(), P = N?.cellVariant === "starting", k = E.column.id === w?.id, I = b && P && k && !E.isPlaceholder, D = C.getIsAllPageRowsSelected(), O = C.getIsSomePageRowsSelected();
        return /* @__PURE__ */ g(UT, { colSpan: E.colSpan, scope: "col", align: N?.headerAlign ?? N?.align, variant: P ? "starting" : void 0, width: N?.width, tooltip: N?.tooltip, hideBelow: N?.hideBelow, leadingCheckbox: I ? /* @__PURE__ */ g(IE, { "aria-label": "Select all visible rows", checked: D, indeterminate: O && !D, onCheckedChange: (V) => C.toggleAllPageRowsSelected(!!V) }) : void 0, sortable: M, sortDirection: qT(E.column.getIsSorted()), onSort: M && T ? (V) => T(V) : void 0, children: E.isPlaceholder ? null : fg(E.column.columnDef.header, E.getContext()) }, E.id);
      }) }, S.id)) }),
      /* @__PURE__ */ g(zT, { children: C.getRowModel().rows.length > 0 ? C.getRowModel().rows.map((S) => /* @__PURE__ */ g(zc, { accentTone: d?.(S.original), selected: S.getIsSelected(), children: S.getVisibleCells().map((E) => {
        const N = E.column.columnDef.meta;
        return /* @__PURE__ */ g(mg, { variant: N?.cellVariant, align: N?.align, width: N?.width, hideBelow: N?.hideBelow, "data-hide-below": N?.hideBelow, children: fg(E.column.columnDef.cell, E.getContext()) }, E.id);
      }) }, S.id)) : /* @__PURE__ */ g(zc, { children: /* @__PURE__ */ g(mg, { colSpan: y.length, emptyFallback: null, children: /* @__PURE__ */ g("div", { className: "flex h-(--table-row-height) items-center justify-center text-text-subtext", children: m }) }) }) })
    ] }) }),
    f && /* @__PURE__ */ g("div", { "data-slot": "data-table-pagination", className: ne(h === "card" && "bg-table-row-light-surface"), children: /* @__PURE__ */ g(OP, { ...f }) })
  ] });
}
const XT = ["flex", "flex-row", "items-center", "border-b", "border-outline-variant"].join(" ");
function p_({
  children: t,
  inset: e = !1,
  ...n
}) {
  const {
    onScroll: o,
    ref: r,
    ...i
  } = n, s = nt(null), l = nt(() => {
  }), [a, c] = qe(!1), [u, d] = qe(!1);
  l.current = function() {
    const h = s.current;
    if (!h) {
      c(!1), d(!1);
      return;
    }
    const b = h.scrollWidth > h.clientWidth;
    c(b && h.scrollLeft > 0), d(b && h.scrollLeft + h.clientWidth < h.scrollWidth - 1);
  };
  function f(m) {
    s.current = m, typeof r == "function" ? r(m) : r && (r.current = m);
  }
  po(() => {
    l.current();
  }), po(() => {
    const m = s.current;
    if (!m || typeof ResizeObserver > "u")
      return;
    const h = new ResizeObserver(() => {
      l.current();
    });
    h.observe(m);
    for (const v of m.children)
      h.observe(v);
    const b = new MutationObserver(() => {
      for (const v of m.children)
        h.observe(v);
      l.current();
    });
    return b.observe(m, {
      childList: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, []);
  function p(m) {
    l.current(), o?.(m);
  }
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    /* @__PURE__ */ g(g1, { ...i, ref: f, onScroll: p, className: ne(XT, "overflow-x-auto", "overflow-y-hidden", e && "px-(--spacing-24)"), children: t }),
    a && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-left", className: "pointer-events-none absolute inset-y-0 left-0 z-10 w-[24px] bg-linear-to-r from-surface to-transparent" }),
    u && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-right", className: "pointer-events-none absolute inset-y-0 right-0 z-10 w-[24px] bg-linear-to-l from-surface to-transparent" })
  ] });
}
const QT = [
  // Layout
  "inline-flex",
  "flex-row",
  "items-center",
  "gap-(--spacing-8)",
  "px-(--spacing-12)",
  "py-(--spacing-6)",
  "rounded-tl-(--radius-sm)",
  "rounded-tr-(--radius-sm)",
  // Typography base
  "font-(family-name:--font-family-body)",
  "text-(length:--font-size-body-large)",
  "leading-(--font-line-height-24)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "outline-none",
  "cursor-pointer",
  "select-none",
  "relative",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Hover state (pointer devices only, not on disabled)
  "not-data-[disabled]:hover:bg-surface-hover",
  // Pressed state
  "not-data-[disabled]:active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-inset",
  "focus-visible:ring-button-focus-ring",
  // Disabled state
  "data-[disabled]:opacity-50",
  "data-[disabled]:pointer-events-none",
  "data-[disabled]:cursor-default"
].join(" "), JT = ["text-text-subtext", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-(--spacing-2)", "after:translate-y-px", "after:bg-transparent", "after:transition-colors", "after:duration-200", "after:ease-in-out", "group", "data-[active]:text-text-default", "data-[active]:after:bg-primary"].join(" ");
function m_(t) {
  const e = B.c(18);
  let n, o, r, i;
  e[0] !== t ? ({
    icon: r,
    chipLabel: o,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = ne(QT, JT), e[5] = s) : s = e[5];
  let l;
  e[6] !== r ? (l = r && /* @__PURE__ */ g(We, { name: r, size: "sm", tone: "inherit" }), e[6] = r, e[7] = l) : l = e[7];
  const a = typeof n == "string" ? n : void 0;
  let c;
  e[8] !== n || e[9] !== a ? (c = /* @__PURE__ */ g("span", { "data-text": a, className: "relative flex flex-col items-center group-data-[active]:font-semibold before:content-[attr(data-text)] before:font-semibold before:invisible before:h-0 before:overflow-hidden before:pointer-events-none", children: n }), e[8] = n, e[9] = a, e[10] = c) : c = e[10];
  let u;
  e[11] !== o ? (u = o != null && /* @__PURE__ */ g(Ln, { tone: "neutral", label: o, "aria-hidden": !0 }), e[11] = o, e[12] = u) : u = e[12];
  let d;
  return e[13] !== i || e[14] !== l || e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(m1, { className: s, ...i, children: [
    l,
    c,
    u
  ] }), e[13] = i, e[14] = l, e[15] = c, e[16] = u, e[17] = d) : d = e[17], d;
}
function g_(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(jb, { className: "outline-none", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function h_(t) {
  const e = B.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(d1, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const eO = ae("text-surface-on-surface", {
  variants: {
    tone: {
      base: ["bg-surface-container-lowest"],
      muted: ["bg-surface-container-low"],
      neutral: ["bg-surface-container"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    },
    padding: {
      none: "p-0",
      dense: "px-(--spacing-8) py-(--spacing-10)",
      compact: "p-(--spacing-12)",
      comfortable: "px-(--spacing-20) py-(--spacing-16)"
    },
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    },
    aspect: {
      auto: null,
      square: "aspect-square"
    },
    centered: {
      true: "grid place-items-center",
      false: null
    },
    width: {
      auto: null,
      content: "w-fit",
      full: "w-full"
    }
  },
  defaultVariants: {
    tone: "base",
    padding: "comfortable",
    radius: "sm",
    aspect: "auto",
    centered: !1,
    width: "auto"
  }
});
function b_(t) {
  const e = B.c(28);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    tone: r,
    padding: i,
    radius: s,
    aspect: l,
    centered: a,
    width: c,
    hasBorder: u,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = r === void 0 ? "base" : r, f = i === void 0 ? "comfortable" : i, p = s === void 0 ? "sm" : s, m = l === void 0 ? "auto" : l, h = a === void 0 ? !1 : a, b = c === void 0 ? "auto" : c, v = u === void 0 ? !1 : u, C = h || void 0;
  let y;
  e[10] !== m || e[11] !== h || e[12] !== v || e[13] !== f || e[14] !== p || e[15] !== d || e[16] !== b ? (y = ne(eO({
    tone: d,
    padding: f,
    radius: p,
    aspect: m,
    centered: h,
    width: b
  }), v && "border border-outline-subtle", "shadow-elevation-1"), e[10] = m, e[11] = h, e[12] = v, e[13] = f, e[14] = p, e[15] = d, e[16] = b, e[17] = y) : y = e[17];
  let w;
  return e[18] !== m || e[19] !== n || e[20] !== f || e[21] !== o || e[22] !== p || e[23] !== C || e[24] !== y || e[25] !== d || e[26] !== b ? (w = /* @__PURE__ */ g("div", { "data-slot": "tile", "data-tone": d, "data-padding": f, "data-radius": p, "data-aspect": m, "data-centered": C, "data-width": b, className: y, ...o, children: n }), e[18] = m, e[19] = n, e[20] = f, e[21] = o, e[22] = p, e[23] = C, e[24] = y, e[25] = d, e[26] = b, e[27] = w) : w = e[27], w;
}
function k3(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM";
  return `${e === 0 ? 12 : e > 12 ? e - 12 : e}:${String(n).padStart(2, "0")} ${o}`;
}
function Ls(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM", r = e === 0 ? 12 : e > 12 ? e - 12 : e;
  return {
    hour: String(r).padStart(2, "0"),
    minute: String(n).padStart(2, "0"),
    period: o
  };
}
function tO(t) {
  const e = Number(t.hour);
  let n = t.period === "PM" ? e + 12 : e;
  return t.period === "AM" && e === 12 && (n = 0), t.period === "PM" && e === 12 && (n = 12), `${String(n).padStart(2, "0")}:${t.minute}`;
}
function gg(t) {
  const e = t.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!e) return null;
  let n = parseInt(e[1], 10);
  const o = parseInt(e[2], 10), r = e[3].toUpperCase();
  return n < 1 || n > 12 || o < 0 || o > 59 ? null : (r === "AM" ? n === 12 && (n = 0) : n !== 12 && (n += 12), `${String(n).padStart(2, "0")}:${String(o).padStart(2, "0")}`);
}
function nO(t, e, n) {
  const o = [];
  for (let r = 0; r < 1440; r += t) {
    const i = Math.floor(r / 60), s = r % 60, l = `${String(i).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    e && l < e || n && l > n || o.push({
      value: l,
      label: k3(l)
    });
  }
  return o;
}
function oO(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((o) => {
    const r = Ls(o.value);
    n.add(r[e]);
  }), [...n];
}
function rO(t, e) {
  const n = Ls(t.value);
  return n.hour === e.hour && n.minute === e.minute && n.period === e.period;
}
function iO({
  options: t,
  currentParts: e,
  column: n,
  partValue: o
}) {
  const r = {
    ...e,
    [n]: o
  }, i = t.find((s) => rO(s, r));
  return i ? i.value : t.find((s) => Ls(s.value)[n] === o)?.value ?? t[0]?.value ?? tO(r);
}
function sO(t, e) {
  return Ls(t?.value ?? e[0]?.value ?? "00:00");
}
function Bc({
  options: t,
  currentParts: e,
  column: n
}) {
  return oO(t, n).map((o) => ({
    kind: n,
    value: `${n}-${o}`,
    label: o,
    partValue: o,
    nextValue: iO({
      options: t,
      currentParts: e,
      column: n,
      partValue: o
    })
  }));
}
const lO = ae(["flex", "items-center", "gap-(--spacing-4)", "w-[228px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function I3(t, e) {
  return e[t.kind] === t.partValue;
}
function aO(t, e) {
  return t.kind === "time" && e.kind === "time" ? t.value === e.value : t.kind !== "time" && e.kind === "time" ? I3(t, Ls(e.value)) : t.value === e.value;
}
function Wc(t) {
  const e = B.c(19), {
    option: n,
    selectedParts: o
  } = t;
  let r, i, s, l, a;
  e[0] !== n || e[1] !== o ? (i = I3(n, o), r = _s, s = n, l = `${n.kind} ${n.label}`, a = ne(Oo({}), "justify-center px-(--spacing-8)", i && "bg-menu-item-selected"), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a) : (r = e[2], i = e[3], s = e[4], l = e[5], a = e[6]);
  let c;
  e[7] !== n.label ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 text-center", children: n.label }), e[7] = n.label, e[8] = c) : c = e[8];
  let u;
  e[9] !== n.kind || e[10] !== i ? (u = i && n.kind === "period" && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(We, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[9] = n.kind, e[10] = i, e[11] = u) : u = e[11];
  let d;
  return e[12] !== r || e[13] !== s || e[14] !== l || e[15] !== a || e[16] !== c || e[17] !== u ? (d = /* @__PURE__ */ F(r, { value: s, "aria-label": l, className: a, children: [
    c,
    u
  ] }), e[12] = r, e[13] = s, e[14] = l, e[15] = a, e[16] = c, e[17] = u, e[18] = d) : d = e[18], d;
}
function Uc() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "h-[36px]" }), t[0] = e) : e = t[0], e;
}
function v_(t) {
  const e = B.c(89), {
    value: n,
    onValueChange: o,
    id: r,
    label: i,
    placeholder: s,
    size: l,
    required: a,
    description: c,
    tooltip: u,
    error: d,
    disabled: f,
    minuteStep: p,
    minTime: m,
    maxTime: h,
    name: b,
    "data-testid": v
  } = t, C = s === void 0 ? "--:--" : s, y = l === void 0 ? "md" : l, w = f === void 0 ? !1 : f, R = p === void 0 ? 15 : p, S = Kt(), [E, N] = qe(!1), M = At(), T = r ?? M, P = At(), k = !!d;
  let I, D, O, V;
  if (e[0] !== h || e[1] !== m || e[2] !== R || e[3] !== n) {
    I = nO(R, m, h), D = n ? {
      ...I.find((Me) => Me.value === n) ?? {
        value: n,
        label: k3(n)
      },
      kind: "time"
    } : null, O = sO(D, I);
    const de = {
      hour: Bc({
        options: I,
        currentParts: O,
        column: "hour"
      }),
      minute: Bc({
        options: I,
        currentParts: O,
        column: "minute"
      }),
      period: Bc({
        options: I,
        currentParts: O,
        column: "period"
      })
    }, we = Math.max(de.hour.length, de.minute.length, de.period.length);
    V = Array.from({
      length: we
    }, (Me, Re) => ({
      hour: de.hour[Re],
      minute: de.minute[Re],
      period: de.period[Re]
    })), e[0] = h, e[1] = m, e[2] = R, e[3] = n, e[4] = I, e[5] = D, e[6] = O, e[7] = V;
  } else
    I = e[4], D = e[5], O = e[6], V = e[7];
  const _ = V;
  let L;
  e[8] !== I || e[9] !== o || e[10] !== n ? (L = function(we) {
    const Me = gg(we.currentTarget.value);
    Me !== null && Me !== n && I.some((Re) => Re.value === Me) && o(Me);
  }, e[8] = I, e[9] = o, e[10] = n, e[11] = L) : L = e[11];
  const A = L;
  let $;
  e[12] !== I || e[13] !== o || e[14] !== n ? ($ = function(we) {
    const Me = we.currentTarget.value.trim();
    if (Me === "") {
      n !== null && o(null);
      return;
    }
    const Re = gg(Me);
    Re !== null && Re !== n && I.some((Ve) => Ve.value === Re) && o(Re);
  }, e[12] = I, e[13] = o, e[14] = n, e[15] = $) : $ = e[15];
  const Y = $;
  let z;
  e[16] !== o ? (z = function(we) {
    if (we === null) {
      o(null);
      return;
    }
    o(we.kind === "time" ? we.value : we.nextValue);
  }, e[16] = o, e[17] = z) : z = e[17];
  const H = z, K = w && "pointer-events-none";
  let G;
  e[18] !== K ? (G = ne("flex flex-col w-fit", K), e[18] = K, e[19] = G) : G = e[19];
  let q;
  e[20] !== T || e[21] !== i || e[22] !== a || e[23] !== u ? (q = i && /* @__PURE__ */ g(hi, { htmlFor: T, label: i, required: a, tooltip: u }), e[20] = T, e[21] = i, e[22] = a, e[23] = u, e[24] = q) : q = e[24];
  let ee;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = (de, we) => {
    N(!de && we.reason === "item-press" ? !0 : de);
  }, e[25] = ee) : ee = e[25];
  let W;
  e[26] !== w || e[27] !== k || e[28] !== y ? (W = ne(lO({
    size: y,
    hasError: k
  }), w && "opacity-50"), e[26] = w, e[27] = k, e[28] = y, e[29] = W) : W = e[29];
  const X = i ? void 0 : "Choose time", J = a || void 0, re = k || void 0, Q = c || d ? P : void 0, ie = k && "text-input-error-text";
  let ce;
  e[30] !== ie ? (ce = ne("flex-1", "min-w-0", "outline-none", "bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-input-text-placeholder", ie), e[30] = ie, e[31] = ce) : ce = e[31];
  let oe;
  e[32] !== v || e[33] !== Y || e[34] !== A || e[35] !== T || e[36] !== C || e[37] !== X || e[38] !== J || e[39] !== re || e[40] !== Q || e[41] !== ce ? (oe = /* @__PURE__ */ g(Os, { id: T, "data-testid": v, placeholder: C, "aria-autocomplete": "list", "aria-label": X, "aria-required": J, "aria-invalid": re, "aria-describedby": Q, onChange: A, onBlur: Y, className: ce }), e[32] = v, e[33] = Y, e[34] = A, e[35] = T, e[36] = C, e[37] = X, e[38] = J, e[39] = re, e[40] = Q, e[41] = ce, e[42] = oe) : oe = e[42];
  let se;
  e[43] !== w || e[44] !== D ? (se = D !== null && !w && /* @__PURE__ */ g(Jf, { "aria-label": "Clear time", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ g(We, { name: "x-close", size: "xs", tone: "inherit" }) }), e[43] = w, e[44] = D, e[45] = se) : se = e[45];
  const fe = v ? `${v}-trigger` : void 0;
  let be;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (be = /* @__PURE__ */ g(We, { name: "clock-seven", size: "xs", tone: "secondary" }), e[46] = be) : be = e[46];
  let le;
  e[47] !== fe ? (le = /* @__PURE__ */ g(Ia, { "data-testid": fe, "aria-label": "Open time picker", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: be }), e[47] = fe, e[48] = le) : le = e[48];
  let me;
  e[49] !== se || e[50] !== le ? (me = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    se,
    le
  ] }), e[49] = se, e[50] = le, e[51] = me) : me = e[51];
  let j;
  e[52] !== W || e[53] !== oe || e[54] !== me ? (j = /* @__PURE__ */ F(ka, { className: W, children: [
    oe,
    me
  ] }), e[52] = W, e[53] = oe, e[54] = me, e[55] = j) : j = e[55];
  let te;
  e[56] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = ui({
    size: "auto",
    className: "w-[228px]"
  }), e[56] = te) : te = e[56];
  const U = v ? `${v}-options` : void 0;
  let Z;
  e[57] !== _ || e[58] !== O ? (Z = _.map((de) => /* @__PURE__ */ F(nb, { className: "grid grid-cols-3 gap-(--spacing-2)", children: [
    de.hour ? /* @__PURE__ */ g(Wc, { option: de.hour, selectedParts: O }) : /* @__PURE__ */ g(Uc, {}),
    de.minute ? /* @__PURE__ */ g(Wc, { option: de.minute, selectedParts: O }) : /* @__PURE__ */ g(Uc, {}),
    de.period ? /* @__PURE__ */ g(Wc, { option: de.period, selectedParts: O }) : /* @__PURE__ */ g(Uc, {})
  ] }, [de.hour?.value ?? "empty-hour", de.minute?.value ?? "empty-minute", de.period?.value ?? "empty-period"].join("-"))), e[57] = _, e[58] = O, e[59] = Z) : Z = e[59];
  let ue;
  e[60] !== U || e[61] !== Z ? (ue = /* @__PURE__ */ g(Ma, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ g(Ta, { className: te, children: /* @__PURE__ */ g(Ds, { "data-testid": U, "aria-label": "Select a time", className: "flex flex-col gap-(--spacing-2) outline-none", children: Z }) }) }), e[60] = U, e[61] = Z, e[62] = ue) : ue = e[62];
  let pe;
  e[63] !== S || e[64] !== ue ? (pe = /* @__PURE__ */ g(Pa, { container: S, children: ue }), e[63] = S, e[64] = ue, e[65] = pe) : pe = e[65];
  let he;
  e[66] !== w || e[67] !== H || e[68] !== b || e[69] !== E || e[70] !== a || e[71] !== D || e[72] !== j || e[73] !== pe ? (he = /* @__PURE__ */ F(zf, { open: E, onOpenChange: ee, value: D, onValueChange: H, isItemEqualToValue: aO, itemToStringLabel: uO, itemToStringValue: cO, disabled: w, required: a, name: b, grid: !0, filter: null, autoComplete: "none", children: [
    j,
    pe
  ] }), e[66] = w, e[67] = H, e[68] = b, e[69] = E, e[70] = a, e[71] = D, e[72] = j, e[73] = pe, e[74] = he) : he = e[74];
  let Ie;
  e[75] !== c || e[76] !== P || e[77] !== d || e[78] !== k ? (Ie = k ? /* @__PURE__ */ g(Or, { match: !0, id: P, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-error-text", children: d }) : c ? /* @__PURE__ */ g(mi, { id: P, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting", children: c }) : null, e[75] = c, e[76] = P, e[77] = d, e[78] = k, e[79] = Ie) : Ie = e[79];
  let ye;
  e[80] !== Ie ? (ye = /* @__PURE__ */ g("div", { "data-testid": "time-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: Ie }), e[80] = Ie, e[81] = ye) : ye = e[81];
  let xe;
  return e[82] !== w || e[83] !== k || e[84] !== G || e[85] !== q || e[86] !== he || e[87] !== ye ? (xe = /* @__PURE__ */ F(Tr, { invalid: k, disabled: w, className: G, children: [
    q,
    he,
    ye
  ] }), e[82] = w, e[83] = k, e[84] = G, e[85] = q, e[86] = he, e[87] = ye, e[88] = xe) : xe = e[88], xe;
}
function cO(t) {
  return t.kind === "time" ? t.value : t.nextValue;
}
function uO(t) {
  return t.label;
}
const Aa = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Aa.displayName = "ToastContext");
function k1() {
  const t = x.useContext(Aa);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : tt(73));
  return t;
}
let hg = 0;
function P3(t) {
  return hg += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${hg}`;
}
function Gc(t, e) {
  if (typeof t == "string")
    return {
      description: t
    };
  if (typeof t == "function") {
    const n = t(e);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return t;
}
const bl = dy((t) => t.toasts, (t) => {
  const e = /* @__PURE__ */ new Map();
  let n = 0, o = 0;
  return t.forEach((r, i) => {
    const s = r.transitionStatus === "ending";
    e.set(r.id, {
      value: r,
      domIndex: i,
      visibleIndex: s ? -1 : n,
      offsetY: o
    }), o += r.height || 0, s || (n += 1);
  }), e;
}), io = {
  toasts: ge((t) => t.toasts),
  isEmpty: ge((t) => t.toasts.length === 0),
  toast: ge(bl, (t, e) => t.get(e)?.value),
  toastIndex: ge(bl, (t, e) => t.get(e)?.domIndex ?? -1),
  toastOffsetY: ge(bl, (t, e) => t.get(e)?.offsetY ?? 0),
  toastVisibleIndex: ge(bl, (t, e) => t.get(e)?.visibleIndex ?? -1),
  hovering: ge((t) => t.hovering),
  focused: ge((t) => t.focused),
  expanded: ge((t) => t.hovering || t.focused),
  expandedOrOutOfFocus: ge((t) => t.hovering || t.focused || !t.isWindowFocused),
  prevFocusElement: ge((t) => t.prevFocusElement)
};
class dO extends Rr {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(e) {
    super(e, {}, io);
  }
  setFocused(e) {
    this.set("focused", e);
  }
  setHovering(e) {
    this.set("hovering", e);
  }
  setIsWindowFocused(e) {
    this.set("isWindowFocused", e);
  }
  setPrevFocusElement(e) {
    this.set("prevFocusElement", e);
  }
  setViewport = (e) => {
    this.set("viewport", e);
  };
  disposeEffect = () => () => {
    this.timers.forEach((e) => {
      e.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(e, n = {}) {
    const o = io.toastIndex(this.state, e);
    if (o === -1)
      return;
    const r = this.state.toasts[o];
    n.skipOnRemove || r?.onRemove?.();
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  addToast = (e) => {
    const {
      timeout: n,
      limit: o
    } = this.state, r = e.id || P3("toast");
    if (e.id) {
      const c = io.toast(this.state, e.id);
      if (c)
        if (c.transitionStatus === "ending")
          this.removeToast(e.id, {
            skipOnRemove: !0
          });
        else {
          const {
            id: u,
            transitionStatus: d,
            ...f
          } = e;
          return this.updateToastInternal(e.id, f, {
            resetTimer: !0,
            markUpdated: !0
          }), e.id;
        }
    }
    const i = {
      ...e,
      id: r,
      updateKey: 0,
      transitionStatus: "starting"
    }, s = [i, ...this.state.toasts], l = s.filter((c) => c.transitionStatus !== "ending");
    if (l.length > o) {
      const c = l.length - o, u = l.slice(-c), d = new Set(u.map((f) => f.id));
      this.setToasts(s.map((f) => {
        const p = d.has(f.id);
        return f.limited !== p ? {
          ...f,
          limited: p
        } : f;
      }));
    } else
      this.setToasts(s.map((c) => c.limited ? {
        ...c,
        limited: !1
      } : c));
    const a = i.timeout ?? n;
    return i.type !== "loading" && a > 0 && this.scheduleTimer(r, a, () => this.closeToast(r)), io.expandedOrOutOfFocus(this.state) && this.pauseTimers(), r;
  };
  updateToast = (e, n) => {
    this.updateToastInternal(e, n, {
      markUpdated: !0
    });
  };
  updateToastInternal = (e, n, o = {}) => {
    const {
      timeout: r,
      toasts: i
    } = this.state, s = io.toast(this.state, e) ?? null;
    if (!s || s.transitionStatus === "ending")
      return;
    const l = {
      ...s,
      ...n,
      ...o.markUpdated && {
        updateKey: (s.updateKey ?? 0) + 1
      }
    };
    this.setToasts(i.map((h) => h.id === e ? l : h));
    const a = l.timeout ?? r, c = s?.timeout ?? r, u = Object.hasOwn(n, "timeout"), d = l.transitionStatus !== "ending" && l.type !== "loading" && a > 0, f = this.timers.has(e), p = c !== a, m = s?.type === "loading";
    if (!d && f) {
      this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
      return;
    }
    if (d && (!f || p || u || m || o.resetTimer)) {
      const h = this.timers.get(e);
      h && (h.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, a, () => this.closeToast(e)), io.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (e) => {
    const n = e === void 0, {
      limit: o,
      toasts: r
    } = this.state;
    let i;
    if (n)
      i = r, this.timers.forEach((c) => {
        c.timeout?.clear();
      }), this.timers.clear();
    else {
      const c = io.toast(this.state, e);
      if (!c)
        return;
      i = [c];
      const u = this.timers.get(e);
      u?.timeout && (u.timeout.clear(), this.timers.delete(e));
    }
    let s = 0;
    const a = {
      toasts: r.map((c) => {
        if (n || c.id === e)
          return {
            ...c,
            transitionStatus: "ending",
            height: 0
          };
        if (c.transitionStatus === "ending")
          return c;
        const u = s >= o;
        return s += 1, c.limited !== u ? {
          ...c,
          limited: u
        } : c;
      })
    };
    (n || r.length === 1) && (a.hovering = !1, a.focused = !1), this.update(a), i.forEach((c) => {
      c.transitionStatus !== "ending" && c.onClose?.();
    }), this.handleFocusManagement(e);
  };
  promiseToast = (e, n) => {
    const o = Gc(n.loading), r = this.addToast({
      ...o,
      type: "loading"
    }), i = e.then((s) => {
      const l = Gc(n.success, s);
      return this.updateToast(r, {
        ...l,
        type: "success",
        timeout: l.timeout
      }), s;
    }).catch((s) => {
      const l = Gc(n.error, s);
      return this.updateToast(r, {
        ...l,
        type: "error",
        timeout: l.timeout
      }), Promise.reject(s);
    });
    return {}.hasOwnProperty.call(n, "setPromise") && n.setPromise(i), i;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
      if (e.timeout) {
        e.timeout.clear();
        const n = Date.now() - e.start, o = e.delay - n;
        e.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, n) => {
      e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= Cn.create(), e.timeout.start(e.remaining, () => {
        this.timers.delete(n), e.callback();
      }), e.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (e) => {
    if (e.pointerType !== "touch")
      return;
    const n = bt(e);
    He(this.state.viewport, n) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(e, n, o) {
    const r = Date.now(), i = !io.expandedOrOutOfFocus(this.state), s = i ? Cn.create() : void 0;
    s?.start(n, () => {
      this.timers.delete(e), o();
    }), this.timers.set(e, {
      timeout: s,
      start: i ? r : 0,
      delay: n,
      remaining: n,
      callback: o
    });
  }
  setToasts(e) {
    const n = {
      toasts: e
    };
    e.length === 0 && (n.hovering = !1, n.focused = !1), this.update(n);
  }
  handleFocusManagement(e) {
    const n = Gt(et(this.state.viewport));
    if (!this.state.viewport || !He(this.state.viewport, n) || !Al(n))
      return;
    if (e === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = io.toasts(this.state), r = io.toastIndex(this.state, e);
    let i = null, s = r + 1;
    for (; s < o.length; ) {
      if (o[s].transitionStatus !== "ending") {
        i = o[s];
        break;
      }
      s += 1;
    }
    if (!i)
      for (s = r - 1; s >= 0; ) {
        if (o[s].transitionStatus !== "ending") {
          i = o[s];
          break;
        }
        s -= 1;
      }
    i ? i.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const I1 = function(e) {
  const {
    children: n,
    timeout: o = 5e3,
    limit: r = 3,
    toastManager: i
  } = e, s = Tt(() => new dO({
    timeout: o,
    limit: r,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return ei(s.disposeEffect), x.useEffect(function() {
    return i ? i[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? s.promiseToast(u.promise, u) : c === "update" && d ? s.updateToast(d, u) : c === "close" ? s.closeToast(d) : s.addToast(u);
    }) : void 0;
  }, [s, o, i]), s.useSyncedValues({
    timeout: o,
    limit: r
  }), /* @__PURE__ */ g(Aa.Provider, {
    value: s,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (I1.displayName = "ToastProvider");
let fO = /* @__PURE__ */ (function(t) {
  return t.frontmostHeight = "--toast-frontmost-height", t;
})({});
const M3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, a = k1(), c = _t(), u = x.useRef(!1), d = x.useRef(!1), f = x.useRef(!1), p = a.useState("isEmpty"), m = a.useState("toasts"), h = a.useState("focused"), b = a.useState("expanded"), v = a.useState("prevFocusElement"), C = m[0]?.height ?? 0, y = x.useMemo(() => m.some((_) => _.transitionStatus === "ending"), [m]);
  x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_)
      return;
    function L($) {
      p || $.key === "F6" && bt($) !== _ && ($.preventDefault(), a.setPrevFocusElement(Gt(et(_))), _?.focus({
        preventScroll: !0
      }), a.pauseTimers(), a.setFocused(!0));
    }
    const A = wt(_);
    return dt(A, "keydown", L);
  }, [a, p]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const L = wt(_);
    function A(Y) {
      bt(Y) === L && (a.setIsWindowFocused(!1), a.pauseTimers());
    }
    function $(Y) {
      if (Y.relatedTarget)
        return;
      const z = bt(Y), H = Gt(et(_));
      (z === L || !He(_, z) || !Al(H)) && a.resumeTimers(), c.start(0, () => a.setIsWindowFocused(!0));
    }
    return jn(dt(L, "blur", A, !0), dt(L, "focus", $, !0));
  }, [
    a,
    c,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    p
  ]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const L = et(_);
    return dt(L, "pointerdown", a.handleDocumentPointerDown, !0);
  }, [p, a]);
  function w(_) {
    const L = a.state.viewport;
    L && (u.current = !0, _.relatedTarget === L ? m[0]?.ref?.current?.focus() : a.restoreFocusToPrevElement());
  }
  function R(_) {
    _.key === "Tab" && _.shiftKey && bt(_.nativeEvent) === a.state.viewport && (_.preventDefault(), a.restoreFocusToPrevElement(), a.resumeTimers());
  }
  function S() {
    const _ = a.state.toasts.some((L) => L.transitionStatus === "ending");
    !a.state.isWindowFocused || _ || f.current || !d.current || (a.resumeTimers(), a.setHovering(!1), d.current = !1);
  }
  x.useEffect(S, [y, a]);
  function E() {
    a.pauseTimers(), a.setHovering(!0), d.current = !1;
  }
  function N() {
    y || f.current ? d.current = !0 : (a.resumeTimers(), a.setHovering(!1));
  }
  function M(_) {
    _.pointerType === "touch" && (f.current = !0);
  }
  function T(_) {
    _.pointerType === "touch" && (f.current = !1, S());
  }
  function P() {
    if (u.current) {
      u.current = !1;
      return;
    }
    h || Al(Gt(et(a.state.viewport))) && (a.setFocused(!0), a.pauseTimers());
  }
  function k(_) {
    !h || He(a.state.viewport, _.relatedTarget) || (a.setFocused(!1), a.resumeTimers());
  }
  const I = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: E,
    onMouseMove: E,
    onMouseLeave: N,
    onFocus: P,
    onBlur: k,
    onKeyDown: R,
    onClick: P,
    onPointerDown: M,
    onPointerUp: T,
    onPointerCancel: T
  }, D = {
    expanded: b
  }, O = Le("div", e, {
    ref: [n, a.setViewport],
    state: D,
    props: [I, {
      style: {
        [fO.frontmostHeight]: C ? `${C}px` : void 0
      }
    }, l, {
      children: /* @__PURE__ */ F(x.Fragment, {
        children: [!p && v && /* @__PURE__ */ g(An, {
          onFocus: w
        }), s, !p && v && /* @__PURE__ */ g(An, {
          onFocus: w
        })]
      })
    }]
  }), V = x.useMemo(() => m.filter((_) => _.priority === "high"), [m]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!p && v && /* @__PURE__ */ g(An, {
      onFocus: w
    }), O, !h && V.length > 0 && /* @__PURE__ */ g("div", {
      style: er,
      children: V.map((_) => /* @__PURE__ */ F("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ g("div", {
          children: _.title
        }), /* @__PURE__ */ g("div", {
          children: _.description
        })]
      }, _.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (M3.displayName = "ToastViewport");
const P1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (P1.displayName = "ToastRootContext");
function La() {
  const t = x.useContext(P1);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : tt(66));
  return t;
}
let lr = /* @__PURE__ */ (function(t) {
  return t.index = "--toast-index", t.offsetY = "--toast-offset-y", t.height = "--toast-height", t.swipeMovementX = "--toast-swipe-movement-x", t.swipeMovementY = "--toast-swipe-movement-y", t;
})({});
const pO = {
  ...Bt,
  swipeDirection(t) {
    return t ? {
      "data-swipe-direction": t
    } : null;
  }
}, Di = 40, mO = 10, Ho = 0.5, gO = 1, hO = `${Th},${q8}`;
function bg(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function bO(t) {
  const n = wt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
const T3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    toast: o,
    render: r,
    className: i,
    swipeDirection: s = ["down", "right"],
    style: l,
    ...a
  } = e, c = o.positionerProps?.anchor !== void 0;
  let u = [];
  c || (u = Array.isArray(s) ? s : [s]);
  const d = u.length > 0, f = k1(), [p, m] = x.useState(void 0), [h, b] = x.useState(!1), [v, C] = x.useState(!1), [y, w] = x.useState(!1), [R, S] = x.useState({
    x: 0,
    y: 0
  }), [E, N] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [M, T] = x.useState(), [P, k] = x.useState(), [I, D] = x.useState(null), O = x.useRef(null), V = x.useRef({
    x: 0,
    y: 0
  }), _ = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), L = x.useRef(void 0), A = x.useRef(0), $ = x.useRef(!1), Y = x.useRef({
    x: 0,
    y: 0
  }), z = x.useRef(!1), H = f.useState("toastIndex", o.id), K = f.useState("toastVisibleIndex", o.id), G = f.useState("toastOffsetY", o.id), q = f.useState("focused"), ee = f.useState("expanded");
  jt({
    open: o.transitionStatus !== "ending",
    ref: O,
    onComplete() {
      o.transitionStatus === "ending" && f.removeToast(o.id);
    }
  });
  const W = Ce((j = !1) => {
    const te = O.current;
    if (!te)
      return;
    const U = te.style.height;
    te.style.height = "auto";
    const Z = te.offsetHeight;
    te.style.height = U;
    function ue() {
      f.updateToastInternal(o.id, {
        ref: O,
        height: Z,
        ...o.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    j ? cn.flushSync(ue) : ue();
  });
  Ne(W, [W]);
  function X(j, te) {
    let U = j, Z = te;
    return !u.includes("left") && !u.includes("right") ? U = j > 0 ? j ** Ho : -(Math.abs(j) ** Ho) : (!u.includes("right") && j > 0 && (U = j ** Ho), !u.includes("left") && j < 0 && (U = -(Math.abs(j) ** Ho))), !u.includes("up") && !u.includes("down") ? Z = te > 0 ? te ** Ho : -(Math.abs(te) ** Ho) : (!u.includes("down") && te > 0 && (Z = te ** Ho), !u.includes("up") && te < 0 && (Z = -(Math.abs(te) ** Ho))), {
      x: U,
      y: Z
    };
  }
  function J(j) {
    if (j.button !== 0)
      return;
    j.pointerType === "touch" && f.pauseTimers();
    const te = bt(j.nativeEvent);
    if (!(te && te.closest(`button,a,input,textarea,[role="button"],${hO}`))) {
      if ($.current = !1, L.current = void 0, A.current = 0, V.current = {
        x: j.clientX,
        y: j.clientY
      }, Y.current = V.current, O.current) {
        const Z = bO(O.current);
        _.current = Z, N(Z), S({
          x: Z.x,
          y: Z.y
        });
      }
      f.setHovering(!0), b(!0), C(!1), D(null), z.current = !0, O.current?.setPointerCapture(j.pointerId);
    }
  }
  function re(j) {
    if (!h)
      return;
    j.preventDefault(), z.current && (V.current = {
      x: j.clientX,
      y: j.clientY
    }, z.current = !1);
    const {
      clientY: te,
      clientX: U,
      movementX: Z,
      movementY: ue
    } = j;
    (ue < 0 && te > Y.current.y || ue > 0 && te < Y.current.y) && (Y.current = {
      x: Y.current.x,
      y: te
    }), (Z < 0 && U > Y.current.x || Z > 0 && U < Y.current.x) && (Y.current = {
      x: U,
      y: Y.current.y
    });
    const pe = U - V.current.x, he = te - V.current.y, Ie = te - Y.current.y, ye = U - Y.current.x;
    if (!v && Math.sqrt(pe * pe + he * he) >= gO && (C(!0), I === null)) {
      const Ve = u.includes("left") || u.includes("right"), je = u.includes("up") || u.includes("down");
      if (Ve && je) {
        const Ze = Math.abs(pe), ze = Math.abs(he);
        D(Ze > ze ? "horizontal" : "vertical");
      }
    }
    let xe;
    if (!L.current)
      I === "vertical" ? he > 0 ? xe = "down" : he < 0 && (xe = "up") : I === "horizontal" ? pe > 0 ? xe = "right" : pe < 0 && (xe = "left") : Math.abs(pe) >= Math.abs(he) ? xe = pe > 0 ? "right" : "left" : xe = he > 0 ? "down" : "up", xe && u.includes(xe) && (L.current = xe, A.current = bg(xe, pe, he), m(xe));
    else {
      const Re = L.current, Ve = bg(Re, ye, Ie);
      Ve > Di ? ($.current = !1, m(Re)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && A.current - Ve >= mO && ($.current = !0);
    }
    const de = X(pe, he);
    let we = _.current.x, Me = _.current.y;
    I === "horizontal" ? (u.includes("left") || u.includes("right")) && (we += de.x) : (I === "vertical" || (u.includes("left") || u.includes("right")) && (we += de.x), (u.includes("up") || u.includes("down")) && (Me += de.y)), S({
      x: we,
      y: Me
    });
  }
  function Q(j) {
    if (!h)
      return;
    if (b(!1), C(!1), D(null), O.current?.releasePointerCapture(j.pointerId), $.current) {
      S({
        x: E.x,
        y: E.y
      }), m(void 0);
      return;
    }
    let te = !1;
    const U = R.x - E.x, Z = R.y - E.y;
    let ue;
    for (const pe of u) {
      switch (pe) {
        case "right":
          U > Di && (te = !0, ue = "right");
          break;
        case "left":
          U < -Di && (te = !0, ue = "left");
          break;
        case "down":
          Z > Di && (te = !0, ue = "down");
          break;
        case "up":
          Z < -Di && (te = !0, ue = "up");
          break;
      }
      if (te)
        break;
    }
    te ? (m(ue), w(!0), f.closeToast(o.id)) : (S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function ie() {
    h && (b(!1), C(!1), D(null), S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function ce(j) {
    if (j.key === "Escape") {
      if (!O.current || !He(O.current, Gt(et(O.current))))
        return;
      f.closeToast(o.id);
    }
  }
  x.useEffect(() => {
    if (!d)
      return;
    const j = O.current;
    if (!j)
      return;
    function te(U) {
      He(j, bt(U)) && U.preventDefault();
    }
    return dt(j, "touchmove", te, {
      passive: !1
    });
  }, [d]);
  function oe() {
    if (!h && R.x === E.x && R.y === E.y && !y)
      return {
        [lr.swipeMovementX]: "0px",
        [lr.swipeMovementY]: "0px"
      };
    const j = R.x - E.x, te = R.y - E.y;
    return {
      transition: h ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: h ? `translateX(${R.x}px) translateY(${R.y}px) scale(${E.scale})` : void 0,
      [lr.swipeMovementX]: `${j}px`,
      [lr.swipeMovementY]: `${te}px`
    };
  }
  const se = o.priority === "high", fe = {
    role: se ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": M,
    "aria-describedby": P,
    "aria-hidden": se && !q ? !0 : void 0,
    onPointerDown: d ? J : void 0,
    onPointerMove: d ? re : void 0,
    onPointerUp: d ? Q : void 0,
    onPointerCancel: d ? ie : void 0,
    onKeyDown: ce,
    inert: kr(o.limited),
    style: {
      ...oe(),
      [lr.index]: o.transitionStatus === "ending" ? H : K,
      [lr.offsetY]: `${G}px`,
      [lr.height]: o.height ? `${o.height}px` : void 0
    }
  }, be = x.useMemo(() => ({
    rootRef: O,
    toast: o,
    titleId: M,
    setTitleId: T,
    descriptionId: P,
    setDescriptionId: k,
    swiping: h,
    swipeDirection: p,
    recalculateHeight: W,
    index: H,
    visibleIndex: K,
    expanded: ee
  }), [o, M, P, h, p, W, H, K, ee]), le = {
    transitionStatus: o.transitionStatus,
    expanded: ee,
    limited: o.limited || !1,
    type: o.type,
    swiping: be.swiping,
    swipeDirection: be.swipeDirection
  }, me = Le("div", e, {
    ref: [n, be.rootRef],
    state: le,
    stateAttributesMapping: pO,
    props: [fe, a]
  });
  return /* @__PURE__ */ g(P1.Provider, {
    value: be,
    children: me
  });
});
process.env.NODE_ENV !== "production" && (T3.displayName = "ToastRoot");
const O3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    visibleIndex: l,
    expanded: a,
    recalculateHeight: c
  } = La(), u = x.useRef(null);
  Ne(() => {
    const m = u.current;
    if (!m || (c(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const h = new ResizeObserver(() => c(!0)), b = new MutationObserver(() => c(!0));
    return h.observe(m), b.observe(m, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, [c]);
  const d = l > 0;
  return Le("div", e, {
    ref: [n, u],
    state: {
      expanded: a,
      behind: d
    },
    props: s
  });
});
process.env.NODE_ENV !== "production" && (O3.displayName = "ToastContent");
const D3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    children: l,
    ...a
  } = e, {
    toast: c,
    setDescriptionId: u
  } = La(), d = l ?? c.description, f = !!d, p = _o(s);
  Ne(() => {
    if (f)
      return u(p), () => {
        u(void 0);
      };
  }, [f, p, u]);
  const m = {
    type: c.type
  }, h = Le("p", e, {
    ref: n,
    state: m,
    props: {
      ...a,
      id: p,
      children: d
    }
  });
  return f ? h : null;
});
process.env.NODE_ENV !== "production" && (D3.displayName = "ToastDescription");
const Eu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, c = k1(), {
    toast: u
  } = La(), d = c.useState("expanded"), [f, p] = x.useState(!1), {
    getButtonProps: m,
    buttonRef: h
  } = Wt({
    disabled: s,
    native: l
  }), b = {
    type: u.type
  };
  return Le("button", e, {
    ref: [n, h],
    state: b,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        p(!0);
      },
      onBlur() {
        p(!1);
      }
    }, a, m]
  });
});
process.env.NODE_ENV !== "production" && (Eu.displayName = "ToastClose");
const Nu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, {
    toast: c
  } = La(), u = c.actionProps?.children ?? a.children, d = !!u, {
    getButtonProps: f,
    buttonRef: p
  } = Wt({
    disabled: s,
    native: l
  }), m = {
    type: c.type
  }, h = Le("button", e, {
    ref: [n, p],
    state: m,
    props: [a, c.actionProps, f, {
      children: u
    }]
  });
  return d ? h : null;
});
process.env.NODE_ENV !== "production" && (Nu.displayName = "ToastAction");
const vO = va;
function yO() {
  const t = x.useContext(Aa);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : tt(73));
  const e = t.useState("toasts");
  return x.useMemo(() => ({
    toasts: e,
    add: t.addToast,
    close: t.closeToast,
    update: t.updateToast,
    promise: t.promiseToast
  }), [e, t]);
}
function xO() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    t.forEach((o) => o(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(o) {
      return t.add(o), () => {
        t.delete(o);
      };
    },
    add(n) {
      const o = n.id || P3("toast"), r = {
        ...n,
        id: o,
        transitionStatus: "starting"
      };
      return e({
        action: "add",
        options: r
      }), o;
    },
    close(n) {
      e({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, o) {
      e({
        action: "update",
        options: {
          ...o,
          id: n
        }
      });
    },
    promise(n, o) {
      let r = n;
      return e({
        action: "promise",
        options: {
          ...o,
          promise: n,
          setPromise(i) {
            r = i;
          }
        }
      }), r;
    }
  };
}
const CO = ae(["rounded-(--radius-sm)", "outline-none", "transition-[opacity,transform,height]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "shadow-elevation-3", "[&[data-starting-style]]:translate-y-2", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:translate-y-2", "[&[data-ending-style]]:opacity-0", "[&[data-limited]]:pointer-events-none", "[&[data-limited]]:opacity-0"], {
  variants: {
    variant: {
      default: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      error: ["bg-error", "text-error-on-error"]
    },
    placement: {
      static: ["relative", "w-full", "max-w-[344px]"],
      viewport: ["w-full"]
    }
  },
  defaultVariants: {
    variant: "default",
    placement: "static"
  }
}), wO = ae(["flex", "min-h-[48px]", "w-full", "items-center", "pl-(--spacing-10)"], {
  variants: {
    hasClose: {
      true: "pr-(--spacing-4)",
      false: "pr-(--spacing-8)"
    },
    layout: {
      inline: "gap-(--spacing-10)",
      "inline-action": "gap-(--spacing-4)",
      stacked: "items-start gap-(--spacing-10)"
    }
  },
  defaultVariants: {
    hasClose: !1,
    layout: "inline"
  }
}), SO = ae(["m-0", "min-w-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-current", "overflow-hidden", "[display:-webkit-box]", "[-webkit-box-orient:vertical]", "[-webkit-line-clamp:2]"]), RO = ae("min-w-0 flex-1 py-(--spacing-10)", {
  variants: {
    layout: {
      inline: "block",
      "inline-action": "block",
      stacked: "flex flex-col items-stretch gap-(--spacing-4)"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
}), EO = ae("shrink-0 py-(--spacing-10)", {
  variants: {
    variant: {
      default: "text-primary-inverse-primary",
      error: "text-error-on-error"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), NO = ae(["inline-flex", "h-(--spacing-40)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "whitespace-nowrap", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-12)", "py-0", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-large)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-primary-inverse-primary", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), kO = ae(["inline-flex", "size-[48px]", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-surface-inverse-on-surface", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), IO = ne("fixed", "[left:0]", "[right:0]", "mx-auto", "bottom-(--spacing-24)", "z-[var(--z-layer-notification)]", "h-(--toast-frontmost-height)", "w-[min(344px,calc(100vw_-_var(--spacing-32)))]"), PO = 10;
function vg({
  children: t,
  variant: e,
  disabled: n = !1,
  ...o
}) {
  return /* @__PURE__ */ g(Qn, { className: ne(NO({
    variant: e
  })), disabled: n, "aria-disabled": n || void 0, tabIndex: n ? -1 : void 0, ...o, children: t });
}
function yg({
  variant: t,
  disabled: e = !1,
  "aria-label": n = "Dismiss notification",
  ...o
}) {
  return /* @__PURE__ */ g(Qn, { className: ne(kO({
    variant: t
  })), disabled: e, "aria-disabled": e || void 0, "aria-label": n, tabIndex: e ? -1 : void 0, ...o, children: /* @__PURE__ */ g(We, { name: "x-close", size: "sm", tone: "inherit" }) });
}
const _3 = xO();
function MO(t) {
  return t === "error" ? "error" : "default";
}
const TO = {
  add(t, e = {}) {
    const {
      variant: n = "default",
      action: o,
      icon: r = !1,
      onDismiss: i,
      timeout: s
    } = e;
    return _3.add({
      description: t,
      type: n,
      priority: n === "error" ? "high" : "low",
      ...s !== void 0 && {
        timeout: s
      },
      data: {
        action: o,
        icon: r,
        onDismiss: i
      }
    });
  },
  error(t, e = {}) {
    return TO.add(t, {
      ...e,
      variant: "error"
    });
  }
};
function V3(t) {
  const e = B.c(73);
  let n, o, r, i;
  e[0] !== t ? ({
    toast: i,
    onActionComplete: n,
    placement: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "static" : r;
  let l, a, c, u, d, f, p, m, h, b, v, C, y, w, R, S, E;
  if (e[5] !== n || e[6] !== s || e[7] !== o || e[8] !== i) {
    E = MO(i.type), c = i.data?.action;
    const V = i.data?.icon ?? !1, _ = !!i.data?.onDismiss;
    f = c && c.label.length >= PO ? "stacked" : c ? "inline-action" : "inline", p = f === "stacked" && _, m = _ && !p;
    let L;
    e[26] !== c || e[27] !== n ? (L = function() {
      c?.onClick(), n?.();
    }, e[26] = c, e[27] = n, e[28] = L) : L = e[28], u = L;
    let A;
    e[29] !== i.data ? (A = function() {
      i.data?.onDismiss?.();
    }, e[29] = i.data, e[30] = A) : A = e[30], d = A, a = T3, v = i, e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ["down", "right"], e[31] = C) : C = e[31], y = E === "error" ? "alert" : "status", w = E === "error" ? "assertive" : "polite", R = ne(CO({
      variant: E,
      placement: s
    })), S = o, l = O3, e[32] !== f || e[33] !== _ ? (h = ne(wO({
      hasClose: _,
      layout: f
    })), e[32] = f, e[33] = _, e[34] = h) : h = e[34], b = V && /* @__PURE__ */ g("span", { "data-slot": "toast-leading-icon", className: ne(EO({
      variant: E
    })), children: /* @__PURE__ */ g(We, { name: E === "error" ? "circle-exclamation" : "circle-check-regular", size: "md", tone: "inherit" }) }), e[5] = n, e[6] = s, e[7] = o, e[8] = i, e[9] = l, e[10] = a, e[11] = c, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m, e[17] = h, e[18] = b, e[19] = v, e[20] = C, e[21] = y, e[22] = w, e[23] = R, e[24] = S, e[25] = E;
  } else
    l = e[9], a = e[10], c = e[11], u = e[12], d = e[13], f = e[14], p = e[15], m = e[16], h = e[17], b = e[18], v = e[19], C = e[20], y = e[21], w = e[22], R = e[23], S = e[24], E = e[25];
  let N;
  e[35] !== f ? (N = ne(RO({
    layout: f
  })), e[35] = f, e[36] = N) : N = e[36];
  let M;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = /* @__PURE__ */ g(D3, { className: ne(SO()) }), e[37] = M) : M = e[37];
  let T;
  e[38] !== c || e[39] !== u || e[40] !== d || e[41] !== f || e[42] !== p || e[43] !== E ? (T = c && f === "stacked" && /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-end", children: [
    /* @__PURE__ */ g(Nu, { render: /* @__PURE__ */ g(vg, { variant: E, onClick: u }), children: c.label }),
    p && /* @__PURE__ */ g(Eu, { render: /* @__PURE__ */ g(yg, { variant: E, "aria-hidden": void 0, onClick: d }) })
  ] }), e[38] = c, e[39] = u, e[40] = d, e[41] = f, e[42] = p, e[43] = E, e[44] = T) : T = e[44];
  let P;
  e[45] !== N || e[46] !== T ? (P = /* @__PURE__ */ F("div", { className: N, children: [
    M,
    T
  ] }), e[45] = N, e[46] = T, e[47] = P) : P = e[47];
  let k;
  e[48] !== c || e[49] !== u || e[50] !== f || e[51] !== E ? (k = c && f === "inline-action" && /* @__PURE__ */ g(Nu, { render: /* @__PURE__ */ g(vg, { variant: E, onClick: u }), children: c.label }), e[48] = c, e[49] = u, e[50] = f, e[51] = E, e[52] = k) : k = e[52];
  let I;
  e[53] !== d || e[54] !== m || e[55] !== E ? (I = m && /* @__PURE__ */ g(Eu, { render: /* @__PURE__ */ g(yg, { variant: E, "aria-hidden": void 0, onClick: d }) }), e[53] = d, e[54] = m, e[55] = E, e[56] = I) : I = e[56];
  let D;
  e[57] !== l || e[58] !== P || e[59] !== k || e[60] !== I || e[61] !== h || e[62] !== b ? (D = /* @__PURE__ */ F(l, { className: h, children: [
    b,
    P,
    k,
    I
  ] }), e[57] = l, e[58] = P, e[59] = k, e[60] = I, e[61] = h, e[62] = b, e[63] = D) : D = e[63];
  let O;
  return e[64] !== a || e[65] !== D || e[66] !== v || e[67] !== C || e[68] !== y || e[69] !== w || e[70] !== R || e[71] !== S ? (O = /* @__PURE__ */ g(a, { toast: v, swipeDirection: C, role: y, "aria-live": w, className: R, ...S, children: D }), e[64] = a, e[65] = D, e[66] = v, e[67] = C, e[68] = y, e[69] = w, e[70] = R, e[71] = S, e[72] = O) : O = e[72], O;
}
function y_(t) {
  const e = B.c(20);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    variant: l,
    description: o,
    action: n,
    icon: r,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = At(), c = l ?? "default", u = l === "error" ? "high" : "low";
  let d;
  e[7] !== n || e[8] !== r || e[9] !== i ? (d = {
    action: n,
    icon: r,
    onDismiss: i
  }, e[7] = n, e[8] = r, e[9] = i, e[10] = d) : d = e[10];
  let f;
  e[11] !== o || e[12] !== a || e[13] !== c || e[14] !== u || e[15] !== d ? (f = {
    id: a,
    description: o,
    type: c,
    priority: u,
    data: d
  }, e[11] = o, e[12] = a, e[13] = c, e[14] = u, e[15] = d, e[16] = f) : f = e[16];
  let p;
  return e[17] !== s || e[18] !== f ? (p = /* @__PURE__ */ g(I1, { timeout: 0, limit: 1, children: /* @__PURE__ */ g(V3, { toast: f, ...s }) }), e[17] = s, e[18] = f, e[19] = p) : p = e[19], p;
}
function OO() {
  const t = B.c(7), e = yO(), n = Kt();
  let o;
  t[0] !== e ? (o = e.toasts.map((s) => /* @__PURE__ */ g(V3, { onActionComplete: () => e.close(s.id), toast: s, placement: "viewport" }, s.id)), t[0] = e, t[1] = o) : o = t[1];
  let r;
  t[2] !== o ? (r = /* @__PURE__ */ g(M3, { className: IO, children: o }), t[2] = o, t[3] = r) : r = t[3];
  let i;
  return t[4] !== n || t[5] !== r ? (i = /* @__PURE__ */ g(vO, { container: n, children: r }), t[4] = n, t[5] = r, t[6] = i) : i = t[6], i;
}
const A3 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (A3.displayName = "ToggleGroupContext");
function DO(t = !0) {
  const e = x.useContext(A3);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>." : tt(7));
  return e;
}
const L3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultPressed: r = !1,
    disabled: i = !1,
    form: s,
    // never participates in form validation
    onPressedChange: l,
    pressed: a,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, h = It(d || void 0), b = DO(), v = b?.value ?? [], C = b ? void 0 : r, y = (i || b?.disabled) ?? !1;
  process.env.NODE_ENV !== "production" && Ne(() => {
    b && d === void 0 && b.isValueInitialized && Ko("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [b, d, b?.isValueInitialized]);
  const [w, R] = pn({
    controlled: b ? h !== void 0 && v.indexOf(h) > -1 : a,
    default: C,
    name: "Toggle",
    state: "pressed"
  }), S = Ce((I, D) => {
    h && b?.setGroupValue?.(h, I, D), l?.(I, D);
  }), {
    getButtonProps: E,
    buttonRef: N
  } = Wt({
    disabled: y,
    native: f
  }), M = {
    disabled: y,
    pressed: w
  }, T = [N, n], P = [{
    "aria-pressed": w,
    onClick(I) {
      const D = !w, O = _e(Mt, I.nativeEvent);
      S(D, O), !O.isCanceled && R(D);
    }
  }, m, E], k = Le("button", e, {
    enabled: !b,
    state: M,
    ref: T,
    props: P
  });
  return b ? /* @__PURE__ */ g(Td, {
    tag: "button",
    render: c,
    className: o,
    style: p,
    state: M,
    refs: T,
    props: P
  }) : k;
});
process.env.NODE_ENV !== "production" && (L3.displayName = "Toggle");
const _O = ae(["inline-flex", "items-center", "justify-center", "overflow-hidden", "whitespace-nowrap", "shrink-0", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"], {
  variants: {
    variant: {
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[pressed]:border-2", "data-[pressed]:border-primary", "data-[pressed]:text-primary"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "data-[pressed]:text-primary"]
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
function x_(t) {
  const e = B.c(23);
  let n, o, r, i, s;
  e[0] !== t ? ({
    icon: n,
    label: o,
    variant: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "outline" : i, a = s === void 0 ? !1 : s;
  let c;
  e[6] !== a || e[7] !== o || e[8] !== l ? (c = ne(_O({
    variant: l
  }), o ? "h-(--spacing-32) px-(--spacing-12)" : "size-(--spacing-32)", a && "opacity-40 pointer-events-none cursor-not-allowed"), e[6] = a, e[7] = o, e[8] = l, e[9] = c) : c = e[9];
  const u = a || void 0, d = a ? -1 : void 0;
  let f;
  e[10] !== o ? (f = o && /* @__PURE__ */ g("span", { className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap", children: o }), e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== n ? (p = /* @__PURE__ */ g(We, { name: n, size: "xs", tone: "inherit" }), e[12] = n, e[13] = p) : p = e[13];
  let m;
  return e[14] !== a || e[15] !== r || e[16] !== c || e[17] !== u || e[18] !== d || e[19] !== f || e[20] !== p || e[21] !== l ? (m = /* @__PURE__ */ F(L3, { "data-slot": "toggle", "data-variant": l, className: c, disabled: a, "aria-disabled": u, tabIndex: d, ...r, children: [
    f,
    p
  ] }), e[14] = a, e[15] = r, e[16] = c, e[17] = u, e[18] = d, e[19] = f, e[20] = p, e[21] = l, e[22] = m) : m = e[22], m;
}
const VO = {
  photo: {
    icon: "image-regular",
    accept: "image/png,image/jpeg",
    acceptedFormatsLabel: "PNG, JPG",
    buttonLabel: "Select Image"
  },
  file: {
    icon: "upload",
    accept: "application/pdf,text/plain",
    acceptedFormatsLabel: "PDF, TXT",
    buttonLabel: "Select File"
  }
};
function C_(t) {
  const e = B.c(45);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    variant: c,
    accept: n,
    acceptedFormatsLabel: o,
    maxSizeLabel: u,
    multiple: d,
    disabled: f,
    buttonLabel: r,
    guidanceLabel: s,
    onFilesSelected: l,
    className: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "photo" : c, m = u === void 0 ? "5 MB" : u, h = d === void 0 ? !1 : d, b = f === void 0 ? !1 : f, v = At(), C = At(), y = nt(null), w = VO[p], R = o ?? w.acceptedFormatsLabel, S = r ?? w.buttonLabel, E = n ?? w.accept, N = s ?? `Upload ${R} up to ${m}`;
  let M;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = function() {
    y.current?.click();
  }, e[12] = M) : M = e[12];
  const T = M;
  let P;
  e[13] !== l ? (P = function(K) {
    const G = Array.from(K.currentTarget.files ?? []);
    G.length > 0 && l?.(G), K.currentTarget.value = "";
  }, e[13] = l, e[14] = P) : P = e[14];
  const k = P, I = b || void 0, D = b && "opacity-50";
  let O;
  e[15] !== i || e[16] !== D ? (O = ne("flex", "w-[480px]", "max-w-full", "relative", "flex-col", "items-center", "justify-center", "gap-(--spacing-24)", "rounded-(--radius-sm)", "bg-surface-container-lowest", "px-(--spacing-16)", "py-(--spacing-24)", D, i), e[15] = i, e[16] = D, e[17] = O) : O = e[17];
  let V;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ g(AO, {}), e[18] = V) : V = e[18];
  let _;
  e[19] !== w.icon ? (_ = /* @__PURE__ */ g("span", { "data-slot": "upload-icon", className: "text-text-subtext", children: /* @__PURE__ */ g(We, { name: w.icon, size: "lg", tone: "inherit", "aria-hidden": !0 }) }), e[19] = w.icon, e[20] = _) : _ = e[20];
  let L;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = ne("m-0", "text-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"), e[21] = L) : L = e[21];
  let A;
  e[22] !== C || e[23] !== N ? (A = /* @__PURE__ */ g("p", { id: C, className: L, children: N }), e[22] = C, e[23] = N, e[24] = A) : A = e[24];
  let $;
  e[25] !== b || e[26] !== C || e[27] !== S ? ($ = /* @__PURE__ */ g(tn, { variant: "outline", size: "md", disabled: b, onClick: T, type: "button", "aria-describedby": C, children: S }), e[25] = b, e[26] = C, e[27] = S, e[28] = $) : $ = e[28];
  let Y;
  e[29] !== b || e[30] !== k || e[31] !== v || e[32] !== h || e[33] !== E || e[34] !== S ? (Y = /* @__PURE__ */ g("input", { ref: y, id: v, className: "sr-only", type: "file", accept: E, multiple: h, disabled: b, tabIndex: -1, "aria-label": S, onChange: k }), e[29] = b, e[30] = k, e[31] = v, e[32] = h, e[33] = E, e[34] = S, e[35] = Y) : Y = e[35];
  let z;
  return e[36] !== a || e[37] !== _ || e[38] !== A || e[39] !== $ || e[40] !== Y || e[41] !== I || e[42] !== O || e[43] !== p ? (z = /* @__PURE__ */ F("div", { "data-slot": "upload", "data-variant": p, "data-disabled": I, className: O, ...a, children: [
    V,
    _,
    A,
    $,
    Y
  ] }), e[36] = a, e[37] = _, e[38] = A, e[39] = $, e[40] = Y, e[41] = I, e[42] = O, e[43] = p, e[44] = z) : z = e[44], z;
}
function AO() {
  const t = B.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", preserveAspectRatio: "none", viewBox: "0 0 480 188", children: /* @__PURE__ */ g("rect", { className: "stroke-outline-subtle", x: "0.5", y: "0.5", width: "479", height: "187", rx: "4", strokeDasharray: "8 6", strokeLinecap: "butt", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }) }), t[0] = e) : e = t[0], e;
}
function w_(t) {
  const e = B.c(13), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, [i, s] = qe(null), [l, a] = qe(null);
  let c;
  e[0] !== l || e[1] !== i ? (c = {
    blockingLayerHost: l,
    portalHost: i
  }, e[0] = l, e[1] = i, e[2] = c) : c = e[2];
  let u, d, f;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-portal-host", ref: s }), d = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-blocking-layer-host", ref: a }), f = /* @__PURE__ */ g(OO, {}), e[3] = u, e[4] = d, e[5] = f) : (u = e[3], d = e[4], f = e[5]);
  let p;
  e[6] !== n || e[7] !== o || e[8] !== r ? (p = /* @__PURE__ */ g(x2, { delay: 300, timeout: 400, children: /* @__PURE__ */ g(I1, { toastManager: _3, timeout: 5e3, limit: 1, children: /* @__PURE__ */ F(AR, { defaultTheme: o, storageKey: r, children: [
    n,
    u,
    d,
    f
  ] }) }) }), e[6] = n, e[7] = o, e[8] = r, e[9] = p) : p = e[9];
  let m;
  return e[10] !== c || e[11] !== p ? (m = /* @__PURE__ */ g(Od, { value: c, children: p }), e[10] = c, e[11] = p, e[12] = m) : m = e[12], m;
}
export {
  TD as Accordion,
  vD as ActionItemCard,
  Pu as AiSparkles,
  bm as Alert,
  Kv as AnchorLink,
  qv as AnchorNav,
  JO as AppShell,
  eD as AppShellContent,
  tD as AppShellMobileNavigationTrigger,
  GO as AssetAlertChat,
  SD as AssetStatusCard,
  RD as AssetTimeline,
  n8 as AssetWatchLogo,
  w_ as AssetWatchUiProvider,
  Nx as AssistantChatComposer,
  bD as AssistantChatDialog,
  qO as AssistantChatFeedback,
  dc as AssistantChatHeader,
  hD as AssistantChatPanel,
  Ew as AssistantChatSidebar,
  gD as AssistantChatTemplatePicker,
  jr as Avatar,
  pu as Badge,
  OD as Banner,
  ZO as BlockingActionOverlay,
  DD as Breadcrumb,
  JR as BreadcrumbItem,
  eE as BreadcrumbLink,
  _D as BreadcrumbList,
  VD as BreadcrumbPage,
  db as BreadcrumbSeparator,
  tn as Button,
  BO as Caption,
  vr as Card,
  Ow as CardBorderFill,
  AD as CardContainer,
  pD as CardGroup,
  fD as CardImageSlot,
  mD as CardLink,
  LD as Carousel,
  FD as ChatActionButton,
  O7 as ChatAttachment,
  nu as ChatBubble,
  $D as ChatCopyButton,
  eu as ChatMessage,
  Bg as ChatMessageAvatar,
  tu as ChatMessageContent,
  z1 as ChatMessageFooter,
  U5 as ChatMessageGroup,
  Wg as ChatMessageHeader,
  Ap as ChatPanel,
  $p as ChatPanelBody,
  k7 as ChatPanelFooter,
  YO as ChatPanelHeader,
  Fp as ChatPanelMain,
  N7 as ChatPanelSidebar,
  Lp as ChatPanelSidebarHeader,
  Ug as ChatScroller,
  Yg as ChatScrollerContent,
  Hi as ChatScrollerItem,
  jg as ChatScrollerJumpToLatest,
  Gg as ChatScrollerViewport,
  G5 as ChatStatus,
  lx as ChatTextarea,
  IE as Checkbox,
  Ln as Chip,
  n_ as CircularProgress,
  kD as CompanyNavigation,
  jO as Container,
  wD as ContextualAssetGallery,
  PD as DEFAULT_PROFILE_MENU_LABELS,
  f_ as DataTable,
  HD as DatePicker,
  UD as DateRangeFilter,
  zD as Dialog,
  WO as Display,
  gr as Divider,
  ZC as Drawer,
  rD as DrawerBody,
  XC as DrawerClose,
  QC as DrawerContent,
  iD as DrawerFooter,
  oD as DrawerHeader,
  nD as DrawerTrigger,
  hm as EmptyState,
  ID as FacilityNavigation,
  BD as FilterPanel,
  KD as Form,
  ZD as FormActionColumnHeader,
  uP as FormFooter,
  qD as FormSection,
  XD as FullPageLayout,
  XO as FullPageLoading,
  br as Group,
  UO as Headline,
  MS as HoverCard,
  OS as HoverCardContent,
  TS as HoverCardTrigger,
  We as Icon,
  gt as IconButton,
  Cc as InlineLink,
  Ix as Input,
  yD as InsightCard,
  Q2 as Kbd,
  fo as Label,
  QD as Lightbox,
  JD as ListCard,
  Dd as Menu,
  M9 as MenuButton,
  w9 as MenuCheckboxItem,
  pr as MenuItem,
  Pr as MenuPopup,
  _d as MenuRadioGroup,
  Vd as MenuRadioItem,
  fu as MenuSubHeader,
  jo as MenuTrigger,
  xD as MetricCard,
  bu as Modal,
  e_ as MultiSelect,
  Ax as PageHeader,
  OP as Pagination,
  Y7 as Popover,
  K7 as PopoverContent,
  j7 as PopoverTrigger,
  MD as ProfileMenu,
  t_ as Progress,
  Hr as RELEASE_STATUS,
  Ai as RELEASE_STATUS_LABEL,
  r_ as Radio,
  o_ as RadioGroup,
  ND as ReleaseInfoModal,
  ED as STATUS_DISPLAY,
  i_ as SearchInput,
  s_ as SearchSpotlight,
  Qw as SectionHeader,
  jD as SegmentedFilter,
  ob as Select,
  YD as SelectedFilters,
  CD as ServiceCard,
  sD as Sidebar,
  lD as SidebarFooter,
  pm as SidebarGroup,
  Nl as SidebarItem,
  mu as SidebarToggle,
  WD as SingleFilter,
  a_ as Skeleton,
  GD as SortGroupFilter,
  u_ as SortableList,
  TM as SortableListHandle,
  c_ as SortableListItem,
  Zo as Stack,
  d_ as Switch,
  $T as Table,
  zT as TableBody,
  mg as TableCell,
  E1 as TableCellPrimary,
  N1 as TableCellSecondary,
  N3 as TableCellStack,
  KT as TableChipTextCellContent,
  UT as TableHead,
  HT as TableHeader,
  zc as TableRow,
  YT as TableStartingCellContent,
  jT as TableTextCellContent,
  h_ as Tabs,
  g_ as TabsContent,
  p_ as TabsList,
  m_ as TabsTrigger,
  Ji as Tag,
  nn as Text,
  KO as Textarea,
  Wl as Thumbnail,
  b_ as Tile,
  v_ as TimePicker,
  wn as Title,
  y_ as Toast,
  x_ as Toggle,
  qo as Tooltip,
  Sx as TooltipIcon,
  aD as TopBar,
  dD as TopBarActions,
  uD as TopBarContent,
  cD as TopBarLeading,
  x0 as Trend,
  I7 as TypingIndicator,
  C_ as Upload,
  TO as toast,
  Xv as useAnchorNav,
  QO as useAppShell,
  Kd as useOverflowItems,
  l_ as useSearchHotkey,
  b0 as useSidebar,
  LR as useTheme,
  ks as viewportQueries
};
//# sourceMappingURL=index.js.map
